(function () {
  'use strict';

  angular
    .module('gfApp',
      [
        //'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngResource',
        'ui.router',
        'ui.bootstrap',
        'ngStorage',
        'angularMoment',
        'angular-hal',
        'angular-cache',
        'toastr',
        'angular-vibrator',
        'infinite-scroll',
        'ui.select',
        'angular-ladda',
        'duScroll',
        'monospaced.elastic',
        'dcbImgFallback',
        "xeditable",
        // app
        'gfSignalrModule',
        'gfAppCore',
        'gfAppInsights',
        'gfTranslationModule',
        'tazkModule',
        'fileUploadModule',
        'datePicker',
        'nk.touchspin',
        'ui-select-infinity',
        'ui.sortable',
        'chart.js',
        'daterangepicker',
        'ngMap',
        'angular-bind-html-compile'
      ]);
})();

(function () {
  angular.module('gfApp')
    .directive('widgetPiechartProjectoverview', function ($translate, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          project: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this

          activate()

          ///

          function activate() {
              vm.projectPieChart = {
                labels: [$translate.instant('enum.status.completed'), $translate.instant('enum.projectstatus.inprogress')],
                data: [vm.project.completedProjectInstances, vm.project.pendingProjectInstances],
                options: {
                  legend: {
                    display: true,
                    position: 'bottom'
                  },
                  animation: {
                    onProgress: function(){
                      vm.isChartRendering = false;
                    }
                  },
                  maintainAspectRatio: false
                },
                colors: [colors.completed, colors.inProgress]
              }
          }
        },
        templateUrl: 'app/modules/siskin/project/widgets/widgetPiechartProjectoverview.directive.html'
      }
    })
})();

/*eslint angular/no-services: [2,["q"]]*/

(function () {
  angular.module('gfApp')
    .directive('widgetPiechartProjectmilestones', function ($translate, projectTemplateService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          header: "@?",
          project: "="
        },
        controller: function(){
          var vm = this

          activate()

          ///

          function activate(){
            projectTemplateService.getMilestones(vm.project.resource).then(function(res){
              vm.data = res.data
              var values = []
              var labels = []
              var total = 0

              angular.forEach(vm.data, function(m,k){
                labels[k] = m.milestoneName
                values[k] = m.lastCompleted
                total += m.lastCompleted
              })

              //projects which have not started any milestones
              labels.unshift($translate.instant("projects.milestones.started"))
              values.unshift(vm.project.totalProjectInstances - total)

              vm.milestoneOverviewChart={
                labels : labels,
                data :  values,
                colors: getMilestoneChartColors(vm.data),
                options: { legend: { display: true,position: 'bottom'}}
              }
            })
          }

          function getMilestoneChartColors(milestones){
            var chartColors = []
            chartColors[0] = colors.milestones[0]
            angular.forEach(milestones, function (m,key) {
              chartColors[key+1] = colors.milestones[(key+1)%colors.milestones.length]
            })
            return chartColors;
          }
        },
        templateUrl: 'app/modules/siskin/project/widgets/widgetPiechartProjectmilestones.directive.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetMatrixProjectinstancemilestones', function ($stateParams, projectDashboardService) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          header: "@?",
          filters: "=?"
        },
        controller: function($scope){
          var vm = this

          if(!vm.filters){
            vm.filters = {
              projectTemplateId : $stateParams.projectId,
              started : false,
              completed : false,
              from: null,
              to: null
            }
          }

          vm.projectPager = null
          vm.changePage = changePage
          vm.projectInstancesPageNumber = 1
          vm.projectInstancesLoading = true

          activate()

          vm.isMilestoneCompleted = isMilestoneCompleted

          ///

          function activate(){
            initializeProject()
            initializeProjectInstancePager()
          }

          function initializeProject(){
            projectDashboardService.getProjectDashboard(vm.filters)
              .then(function(data){
                vm.data = data

                if(vm.data.summary.milestoneSummary && vm.data.summary.milestoneSummary.length > 0){
                  angular.forEach(vm.data.summary.milestoneSummary, function(milestone){
                    var totalCount = milestone.completed + milestone.incomplete

                    milestone.completedPercentage = 100 * milestone.completed / totalCount
                    milestone.incompletePercentage = 100 * milestone.incomplete / totalCount
                  });
                }
              })
          }

          function initializeProjectInstancePager(){
            projectDashboardService.initializeProjectInstancePager({projectTemplateId : $stateParams.projectId})

            projectDashboardService.projectPager.reset(
              vm.filters
            )
              .then(function(){
                vm.projectInstancesLoading = false
                vm.projectInstances = projectDashboardService.projectPager.items
              });

            vm.projectPager = projectDashboardService.projectPager
          }

          function changePage(){
            vm.projectInstancesLoading = true
            vm.projectPager.items = []
            vm.projectPager.goPage(vm.projectPager.pageNumber).then(function(){
              vm.projectInstancesLoading = false
              vm.projectInstances = vm.projectPager.items
            })
          }

          function isMilestoneCompleted(completedMilestones, milestoneName) {

            var isMilestoneCompleted = false

            angular.forEach(completedMilestones, function(completedMilestone) {
              if (completedMilestone.name === milestoneName) {
                isMilestoneCompleted = true
              }
            })

            return isMilestoneCompleted
          }

          $scope.$watch('vm.filters',activate)
        },
        templateUrl: 'app/modules/siskin/project/widgets/widgetMatrixProjectinstancemilestones.directive.html'
      }
    })
})();

/*eslint angular/no-services: [2,["q"]]*/

(function () {
  angular.module('gfApp')
    .directive('widgetMapProject', function (colors, projectTemplateService) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          header: "@?",
          data: "=",
          project: "="
        },
        controller: function(){
          var vm = this

          vm.header = vm.header

          activate()

          ///

          function activate(){
            projectTemplateService.getProjects(vm.project.resource)
              .then(getMapData)
          }

          function getMapData(data) {
           
            var stores = groupProjectsByStore(data.data)
            if (stores.length) {
              vm.maps = {
                center: getCenter(stores.map(function(s){return s.key})),
                markers: stores.filter(function (store) {
                  return angular.isDefined(store.key.latitude) && angular.isDefined(store.key.longitude)
                }).map(function (g) {
                  var markerColor = colors.milestonesMap[0]
                  var instances = ""
                  var lowestMilestone

                  angular.forEach(g.value, function (p) {
                    var projectColor = colors.milestonesMap[0]
                    if (angular.isUndefined(lowestMilestone) || projectColor.listOrder < lowestMilestone) {
                      lowestMilestone = projectColor.listOrder
                      markerColor = colors.milestonesMap[0]
                    }
                    var style = "style =\"background:#" + projectColor.background + "; color:" + projectColor.text + "\"";
                    instances += "<div class='m-t-xs m-b-sm'><label class='label' " + style + " ui-sref='siskin.projectinstancedetail({projectInstanceId:" + p.projectId + "})'>" + p.projectInstanceName + "</label></div>"
                  })

                  return {
                    lat: g.key.latitude,
                    lng: g.key.longitude,
                    title: g.key.id,
                    message: "<strong>" + g.key.id + "</strong><p>" + instances + "</p>",
                    markerColor: markerColor
                  }
                })
              }
            }
          }


          function getCenter(data) {
            var minZoom = 6
            var latitudes = data.filter(function(s){return s.latitude && s.longitude}).map(function (s) {
              return s.latitude
            })
            var longitudes = data.filter(function(s){return s.latitude && s.longitude}).map(function (s) {
              return s.longitude
            })

            if(!latitudes.length || !longitudes.length) return { lat:0, lng:0}

            var distanceLatitude = max(latitudes) - min(latitudes)
            var distanceLongitude = max(longitudes) - min(longitudes)
            var zoomByLatitude = Math.round(minZoom - (distanceLatitude / 180 * minZoom)) - 2
            var zoomByLongitude = Math.round(minZoom - (distanceLongitude / 360 * minZoom)) - 2
            var zoom = Math.max(Math.max(zoomByLatitude, zoomByLongitude), 1)

            var lat = (zoom === 1 ? 0 : (max(latitudes) + min(latitudes)) / 2)
            var lng = (zoom === 1 ? 0 : (max(longitudes) + min(longitudes)) / 2)

            return {
              lat:  isNaN(lat) ? 0 : lat,
              lng:  isNaN(lng) ? 0 : lng,
              zoom: zoom-1
            }
          }

          function max(array) {
            return array.reduce(function (a, b) {
              return Math.max(a, b);
            })
          }

          function min(array) {
            return array.reduce(function (a, b) {
              return Math.min(a, b);
            })
          }

          function groupProjectsByStore(data) {
            var groupBy = function (xs, key) {
              var array = []
              var reduced = xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
              }, {})

              angular.forEach(reduced, function (value, key) {
                array.push({
                  key: {id: key, latitude: value[0].storeLatitude, longitude: value[0].storeLongitude},
                  value: value
                })
              })

              return array
            }

            return groupBy(data, 'storeName')
          }

        },
        templateUrl: 'app/modules/siskin/project/widgets/widgetMap.directive.html'
      }
    })
})();

/*eslint angular/no-services: [2,["q"]]*/

(function () {
  angular.module('gfApp')
    .directive('widgetListTaskoverview', function ($stateParams, $q, projectTemplateService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          header: "@?",
          project: "="
        },
        controller: function(){
          var vm = this

          vm.colors = {inProgress: colors.overdue, completed: colors.completed}
          vm.projects ={}

          activate()

          ///

          function activate(){
            projectTemplateService.getTasks(vm.project.resource).then(function(data){
              vm.data = data;
            })
          }

        },
        templateUrl: 'app/modules/siskin/project/widgets/widgetListTaskoverview.directive.html'
      }
    })
})();

/*eslint angular/no-services: [2,["q"]]*/

(function () {
  angular.module('gfApp')
    .directive('widgetListProjectmilestones', function ($stateParams, $q, projectTemplateService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          header: "@?",
          data: "="
        },
        controller: function(){
          var vm = this

          vm.colors = {inProgress: colors.overdue, completed: colors.completed}
          vm.filter = {}
          
          activate()

          ///

          function activate(){
            $q.when(vm.data || projectTemplateService.getDetail($stateParams.projectId))
              .then(function (data) {
                vm.data = data
              })

          }

        },
        templateUrl: 'app/modules/siskin/project/widgets/widgetListProjectmilestones.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetListMilestonehit', function ($stateParams, projectDashboardService) {
      return {
        scope: {},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          header: "@?",
          project: "="
        },
        controller: function () {
          var vm = this

          activate()

          ///

          function activate() {
            
            if(vm.filters==null){
              vm.filters = {
                projectTemplateId : $stateParams.projectId,
                started : false,
                completed : false,
                from: null,
                to: null
              }
            }

            projectDashboardService.getProjectDashboard(vm.filters)
              .then(function (data) {

                vm.data = data

                if (vm.data.summary.milestoneSummary && vm.data.summary.milestoneSummary.length > 0) {
                  angular.forEach(vm.data.summary.milestoneSummary, function (milestone) {
                    var totalCount = milestone.completed + milestone.incomplete

                    milestone.completedPercentage = 100 * milestone.completed / totalCount
                    milestone.incompletePercentage = 100 * milestone.incomplete / totalCount
                  });
                }
              })
          }
        },
        templateUrl: 'app/modules/siskin/project/widgets/widgetListMilestonehit.directive.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .factory('emailSettingsControllerFactory', factory)

  function factory($state, emailDigestSettingsService, gfSiskinDropdownValues) {
    return function (data) {
      return {
        templateUrl: 'app/modules/siskin/project/emailsettings/list.html',
        controllerInit: function (vm) {
          vm.updateUserSetting = updateUserSetting
          vm.updateGeneralSetting = updateGeneralSetting

          vm.data = data
          vm.digestEmailTypes = []
          vm.userSettings = []
          vm.settings = []
          vm.emailDigestRequirementValues = gfSiskinDropdownValues.emailDigestRequirement
          vm.isSwitchEnabled = isSwitchEnabled

          init()

          //////

          function init() {
            emailDigestSettingsService.get(data.id).then(function (settings) {
              vm.digestEmailTypes = settings.generalSettings
              vm.userSettings = settings.userSettings
              vm.hasDisabledSettings = false;

              angular.forEach(settings.generalSettings, function(generalSetting){
                var setting = {
                  general: generalSetting,
                  user: getUserSetting(generalSetting.emailTemplateType)
                }
                vm.settings.push(setting)
                vm.hasDisabledSettings = vm.hasDisabledSettings || setting.general.requirement!=='Optional'
              })

            })
          }

          function getUserSetting(key){
            return vm.userSettings.find(function(x){
              return x.emailTemplateType === key
            })
          }

          function isSwitchEnabled(setting) {
            return setting.general.requirement === gfSiskinDropdownValues.emailDigestRequirement.optional ? 'disabled' : ''
          }

          function updateUserSetting(setting) {
            setting.user.enabled = !setting.user.enabled
            emailDigestSettingsService.updateUserSetting(setting.user).then(function(data){
                setting.user = data
            })
          }

          function updateGeneralSetting(setting){
            emailDigestSettingsService.updateGeneralSetting(setting.general).then(function(data){
              setting.general = data
            })
          }
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .directive('widgetProjectinstancesStatus', function ($rootScope, dashboardV2Service) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        templateUrl: 'app/modules/siskin/monitoring/widgets/widget-projectinstances-status.directive.html',
        bindToController: {
          filter: "="
        },
        link: function ($scope){
          var d = $rootScope.$on('$dashboardSearch', $scope.vm.search)
          $scope.$on('destroy', d)
        },
        controller: function(){
          var vm = this

          vm.search = search
          
          activate()

          ///

          function activate(){
            search();
          }

          function search() {
            vm.data = undefined;
            dashboardV2Service.getProjectInstancesStatus(vm.filter).then(function(data){
              vm.data = data
            });
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetProjectinstancesProcesstime', function ($rootScope, dateTimeService, $translate, dashboardV2Service, colors, moment) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        templateUrl: 'app/modules/siskin/monitoring/widgets/widget-projectinstances-processtime.directive.html',
        bindToController: {
          filter:'='
        },
        link: function ($scope){
          var d = $rootScope.$on('$dashboardSearch', $scope.vm.search)
          $scope.$on('destroy', d)
        },
        controller: function(){
          var vm = this

          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}
          var current = moment();
          if(current.minutes()){
            current.set('minute',0);
            current.add(1,'hour');
          }
          vm.dateRangeOptions = [
            {key:$translate.instant('monitoring.filter.last12hours'), value: { dateTo: current,  dateFrom: moment(current).subtract(12,'hours')}},
            {key:$translate.instant('monitoring.filter.last24hours'), value: {dateTo: current,  dateFrom: moment(current).subtract(1,'days')}},
            {key:$translate.instant('monitoring.filter.last3days'), value: {dateTo: current,  dateFrom: moment(current).subtract(3,'days')}},
            {key:$translate.instant('monitoring.filter.last7days'), value: {dateTo: current,  dateFrom: moment(current).subtract(7,'days')}}
          ]

          vm.metrics = [
            {key:$translate.instant('monitoring.filter.max'), value: 'max'},
            {key:$translate.instant('monitoring.filter.average'), value: 'average'}
          ]

          vm.metricSelected = vm.metrics[0].value
          vm.dateRangeSelected = vm.dateRangeOptions[1].value
          vm.widgetFilter = {}

          vm.activate = activate
          vm.search = search
          vm.refresh = refresh

          activate()

          ///

          function activate(){
            vm.search();
          }

          function search(){
            vm.widgetFilter.dateFrom = vm.dateRangeSelected.dateFrom
            vm.widgetFilter.dateTo = vm.dateRangeSelected.dateTo

            vm.loading = true;

            dashboardV2Service.getProjectInstancesProcessTime(angular.extend({},vm.filter,vm.widgetFilter)).then(function(data){
              vm.data = data
              vm.refresh();
            }).finally(function(){vm.loading = false;})
          }

          function refresh() {
            if(!vm.data.length) return;
            var values = vm.data.map(function(m) { return m[vm.metricSelected]})

            vm.chart = {
              data: [values],
              labels: vm.data.map(function(m) { return dateTimeService.formatFromUtc(m.dateFrom, true) }),
              series: [$translate.instant('monitoring.workflowprocesstime.minutes')],
              options: {
                legend: {
                  display: true,
                  position: 'left'
                },
                scales: {
                  yAxes: [{
                    ticks: { beginAtZero: true, precision:0 }
                  }]
                },
                maintainAspectRatio: false
              },
              colors: [vm.colors.completed]
            };
          }
        }
      }
    })
})();

(function () {
    angular.module('gfApp')
      .directive('widgetKonnektRequests', function ($rootScope, $translate, dashboardV2Service, colors, moment) {
        return {
          scope:{},
          restrict: 'E',
          controllerAs: 'vm',
          bindToController: {
            filter:'='
          },
          link: function ($scope){
            var d = $rootScope.$on('$dashboardSearch', $scope.vm.search)
            $scope.$on('destroy', d)
          },
          templateUrl: 'app/modules/siskin/monitoring/widgets/widget-konnekt-requests.directive.html',
          controller: function(){
            var vm = this

            vm.dateRangeOptions = [
              {key:$translate.instant('monitoring.filter.last12hours'), value: { dateTo: moment(),  dateFrom: moment().subtract(0.5,'days')}},
              {key:$translate.instant('monitoring.filter.last24hours'), value: {dateTo: moment(),  dateFrom: moment().subtract(1,'days')}},
              {key:$translate.instant('monitoring.filter.last3days'), value: {dateTo: moment(),  dateFrom: moment().subtract(3,'days')}},
              {key:$translate.instant('monitoring.filter.last7days'), value: {dateTo: moment(),  dateFrom: moment().subtract(7,'days')}}
            ]
            vm.dateRangeSelected = vm.dateRangeOptions[1].value
            vm.widgetFilter = {}
            
            vm.activate = activate;
            vm.search = search;

            activate()
  
            ///

            function activate(){
              vm.search();
            }

            function search(){
              vm.widgetFilter.dateFrom = vm.dateRangeSelected.dateFrom
              vm.widgetFilter.dateTo = vm.dateRangeSelected.dateTo
              vm.loading = true;

              dashboardV2Service.getKonnektProcesses(angular.extend({},vm.filter,vm.widgetFilter)).then(function(data){
                vm.data = data;
                

                angular.forEach(data, function(m) {m.categoryName = m.categoryName == null ? $translate.instant('monitoring.fullfilmentserviceintegrations.other') : m.categoryName})
                
                vm.chart = {
                  labels: data.map(function(m){return m.categoryName;}),
                  series: [$translate.instant('enum.status.completed'),$translate.instant('enum.status.failed'),$translate.instant('enum.status.pending')],
                  data: [data.map(function(m){return m.successCount}), data.map(function(m){return m.failedCount}), data.map(function(m){return m.pendingCount})],
                  colors: [ {backgroundColor: colors.completed},{backgroundColor: colors.overdue},{backgroundColor: colors.inProgress}],
                  options: {
                    legend: { display: true, position: 'bottom'},
                    scales: {
                      yAxes: [{
                        ticks: { beginAtZero: true, precision:0 }
                      }]
                    },
                    animation: { 
                      onProgress: function () {
                        vm.isChartRendering = false;
                      }
                    }
                  }
                };
              })
              .finally(function(){
                vm.loading = false;
              });
            }
          }
        }
      })
  })();
  
(function () {
  angular.module('gfApp')
    .directive('widgetV2ProjectInstances', function (dashboardV2Service) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        templateUrl: 'app/modules/siskin/clientdashboard/widgets-v2/widgetV2ProjectInstances.directive.html',
        bindToController: {
          header: "@?",
          project: "="
        },
        controller: function(){
          var vm = this

          vm.search = search
          vm.projectStatuses = [
            {key:undefined, name:'All'}, 
            {key:'Active', name: 'Active'},
            {key:'Inactive', name: 'Inactive'},
            {key:'Completed', name: 'Completed'},
            {key:'NotStarted', name: 'Not Started'}
          ]

          vm.filters = {
            projectTemplateId: vm.project.id,
            projectStatus: vm.projectStatuses[0]
          }

          search()

          ///

          function search(refresh){
            if(refresh){
              vm.pager.page = vm.filters.pageNumber = 1
            }

            vm.isBusy = true;
            dashboardV2Service.getProjectInstances(vm.filters).then(function(data){
              vm.pager = data;
              vm.pager.goPage = function(page){
                vm.filters.pageNumber = page
                search();
              }
            })
            .finally(function() {vm.isBusy = false;});
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetV2PiechartProjectinstancesOverview', function ($translate, dashboardV2Service, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        templateUrl: 'app/modules/siskin/clientdashboard/widgets-v2/widgetV2PiechartProjectinstanceOverview.directive.html',
        bindToController: {
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this
          vm.charts = {}
          vm.charts.overview = {}
          vm.charts.projectOverview = {}
          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}

          vm.hasOverviewData = hasOverviewData

          activate()

          ///

          function activate(){
            dashboardV2Service.getProjectInstancesByStatus(vm.filters).then(setData);
          }

          function setData(data) {
            vm.data = data
            if(!data) return;

            vm.charts.overview = {
              labels: [
                $translate.instant('enum.projectstatus.inprogress'),
                $translate.instant('enum.status.completed')
              ],
              data: [data.inProgressCount, data.completedCount],
              options: {
                legend: {
                  display: true,
                  position: 'bottom'
                },
                animation: {
                  onProgress: function () {
                    vm.isChartRendering = false;
                  }
                }
              },
              colors: [vm.colors.inProgress, vm.colors.completed]
            };
          }

          function hasOverviewData() {
            return vm.data && (vm.data.inProgressCount || vm.data.completedCount)
          }

        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetV2MapProjectinstances', function (gfHelper, colors, dashboardV2Service) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this

          vm.header = vm.header

          activate()

          ///

          function activate(){
            dashboardV2Service.getProjectInstancesMap(vm.filters).then(setData)
          }

          function setData(data) {
            if(!data) return;
            vm.data = data;

            var stores = gfHelper.groupBy(data, 'storeName').map(function(storeGroup) {
              var store = storeGroup.value[0];
              store.projectInstances = storeGroup.value;
              return store
            })

            vm.maps = {
              markers: stores.filter(function (s) {
                return angular.isDefined(s.latitude) && angular.isDefined(s.longitude)
              }).map(function (s) {
                var markerColor = colors.map.completed
                var instances = ""

                angular.forEach(s.projectInstances, function (p) {

                  if (!p.isCompleted) {
                    markerColor = colors.map.inProgress
                  }

                  var labelColor = 'label-status-inactive';
                  if(p.isCompleted){
                    labelColor  ='label-status-completed';
                  } else if(p.isActive){
                    labelColor = 'label-status-inprogress';
                  }
                   
                  instances += "<div class='m-t-xs m-b-sm'><label class='label " + labelColor + "' ui-sref='siskin.projectinstancedetail({projectInstanceId:" + p.projectInstanceId + "})'>" + p.projectInstanceName + "</label></div>"
                })

                return {
                  lat: s.latitude || 0,
                  lng: s.longitude || 0,
                  title: s.storeName,
                  message: "<h4>" + s.storeName + "</h4><p>" + instances + "</p>",
                  markerColor: markerColor
                }
              })
            }

            var center = getCenter(stores)
            if (center) {
              vm.maps.center = center
            }
          }

        function getCenter(stores) {
            var minZoom = 6
            var latitudes = stores.filter(function(s){return s.latitude && s.longitude}).map(function (s) {
              return s.latitude
            })
            var longitudes = stores.filter(function(s){return s.latitude && s.longitude}).map(function (s) {
              return s.longitude
            })

            if(!latitudes.length || !longitudes.length) return { lat:0, lng:0}

            var distanceLatitude = max(latitudes) - min(latitudes)
            var distanceLongitude = max(longitudes) - min(longitudes)
            var zoomByLatitude = Math.round(minZoom - (distanceLatitude / 180 * minZoom)) - 2
            var zoomByLongitude = Math.round(minZoom - (distanceLongitude / 360 * minZoom)) - 2
            var zoom = Math.max(Math.max(zoomByLatitude, zoomByLongitude), 1)

            var lat = (zoom === 1 ? 0 : (max(latitudes) + min(latitudes)) / 2)
            var lng = (zoom === 1 ? 0 : (max(longitudes) + min(longitudes)) / 2)

            return {
              lat:  isNaN(lat) ? 0 : lat,
              lng:  isNaN(lng) ? 0 : lng,
              zoom: zoom-1
            }
          }

          function max(array) {
            if(isValidArrayHasData(array)){
              return array.reduce(function (a, b) {
                return Math.max(a, b);
              })
            }
          }

          function min(array) {
            if(isValidArrayHasData(array)){
              return array.reduce(function (a, b) {
                return Math.min(a, b);
              })
            }
          }

          function isValidArrayHasData(array){
            return angular.isArray(array) && array.length > 0;
          }

        },
        templateUrl: 'app/modules/siskin/clientdashboard/widgets-v2/widgetV2Map.directive.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetV2ListProjecttemplatoverview', function ($state, dashboardV2Service, configService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        templateUrl: 'app/modules/siskin/clientdashboard/widgets-v2/widgetV2ListProjecttemplatoverview.directive.html',
        bindToController: {
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this

          vm.features = configService.appSettings.features
          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}
          vm.projects ={}

          activate()

          ///

          function activate(){
            dashboardV2Service.getProjectTemplatesOverview(vm.filters).then(setData);
          }

          function setData(data){
            if(!data){return}
            vm.data = data;
            angular.forEach(vm.data, function (project) {
              project.percentageInProgress = project.inProgressCount/(project.inProgressCount + project.completedCount)*100
              project.percentageCompleted = project.completedCount/(project.inProgressCount + project.completedCount)*100
              project.href = $state.href('siskin.project', {projectId: project.id})
            })
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetV2ListProjectinstancemilestones', function (projectTemplateService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        templateUrl: 'app/modules/siskin/clientdashboard/widgets-v2/widgetV2ListProjectinstancemilestones.directive.html',
        bindToController: {
          filters: "=",
          header: "@?"
        },
        controller: function($stateParams){
          var vm = this

          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}

          activate()

          ///

          function activate(){
            if($stateParams.projectTemplateId){
              projectTemplateService.get($stateParams.projectTemplateId).then(function(pt) {
                vm.projectTemplate = pt
            })
            }else{
              vm.jobspager = projectTemplateService.getPager();

              var params = {};
              vm.filters.projectTemplateId = $stateParams.projectTemplateId  
              if(vm.filters.selectedClient !== null && vm.filters.selectedClient.id && vm.filters.selectedClient.id!==0){
                params = {clientId: vm.filters.selectedClient.id};
              }
              vm.jobspager.reset(params)
            }
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetV2LinechartProjectinstances', function (dateTimeService, $translate, dashboardV2Service, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        templateUrl: 'app/modules/siskin/clientdashboard/widgets-v2/widgetV2Linechart.directive.html',
        bindToController: {
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this

          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}

          activate()

          ///

          function activate(){
            dashboardV2Service.getProjectInstancesOverview(vm.filters).then(setData)
          }

          function setData(data){
            if(!data) return

            vm.data = data

            var startedCount = data.map(function(m) { return m.startedCount })
            var completedCount = data.map(function(m) { return m.completedCount })
            var labels = data.map(function(m) { return dateTimeService.formatMonthFromUtc(m.date) })

            vm.chart = {
              data: [startedCount, completedCount],
              labels: labels,
              series: [
                $translate.instant('enum.status.started'),
                $translate.instant('enum.status.completed')
                /*'Started', 'Completed'*/],
              options: {
                legend: {
                  display: true,
                  position: 'bottom'
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                      precision:0
                    }
                  }]
                },
                maintainAspectRatio: false

              },
              colors: [vm.colors.inProgress, vm.colors.completed]
            };
          }
        }
      }
    })
})();

(function () {
    angular.module('gfApp')
      .directive('widgetV2BarchartProjectinstancesCountry', function ($translate, dashboardV2Service, colors) {
        return {
          scope:{},
          restrict: 'E',
          controllerAs: 'vm',
          bindToController: {
            filters: "=",
            header: "@?"
          },
          templateUrl: 'app/modules/siskin/clientdashboard/widgets-v2/widgetV2BarchartProjectinstanceByCountry.directive.html',
          controller: function(){
            var vm = this
            vm.charts = {}
            vm.colors = { inProgress: colors.inProgress, completed: colors.completed }
  
     
            vm.hasData = hasData
  
            activate()
  
            ///
  
            function activate(){
              dashboardV2Service.getProjectInstancesByCountry(vm.filters).then(setData);
            }
  
            function setData(data){
              if(!data) return;
              vm.data = data;
              var labels = data.map(function(a){return a.country;});
              var completedList = data.map(function(a){return a.completedCount});
              var inProgressList = data.map(function(a){return a.inProgressCount;});
              
              var series = [
                $translate.instant('enum.projectstatus.inprogress'),
                $translate.instant('enum.status.completed')
              ];

              vm.charts.projectByCountry = {
                labels: labels,
                series: series,
                data: [
                  inProgressList,
                  completedList
                ],
                options: {
                  scales: {
                    xAxes: [{
                      stacked: true
                    }],
                    yAxes: [{
                      stacked: true
                    }]
                  },
                  legend: {
                    display: true,
                    position: 'bottom'
                  },
                  animation: {
                    onProgress: function () {
                      vm.isChartRendering = false;
                    }
                  }
                },
                colors: [
                  {
                    backgroundColor: vm.colors.inProgress
                  }, 
                  {
                    backgroundColor: vm.colors.completed
                  }
                ]
              };
            }
  
            function hasData() {
              return vm.data && vm.data.length;
            }
  
          }
        }
      })
  })();
  
(function () {
  angular.module('gfApp')
    .directive('widgetPiechartProjectinstancesOverview', function ($translate, dashboardService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          data:'=',
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this
          vm.charts = {}
          vm.charts.overview = {}
          vm.charts.projectOverview = {}
          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}

          vm.active = false
          vm.hasOverviewData = hasOverviewData

          activate()

          ///

          function activate(){
            getChartData(vm.filters)
          }

          function getChartData(filters) {
            dashboardService.getAllWidgets(filters).then(
              function (data) {
                vm.chartData = data
                if (data.projectOverview) {
                  getOverviewChartData(data)
                }
                vm.active = true
              }
            );
          }

          function getOverviewChartData(data) {
            vm.charts.overview = {
              labels: [
                $translate.instant('enum.projectstatus.inprogress'),
                $translate.instant('enum.status.completed')
              ],

              data: [data.projectOverview.inProgress, data.projectOverview.completed],
              options: {
                legend: {
                  display: true,
                  position: 'bottom'
                },
                animation: {
                  onProgress: function () {
                    vm.isChartRendering = false;
                  }
                }
              },
              colors: [vm.colors.inProgress, vm.colors.completed]
            };
          }

          function hasOverviewData() {
            return vm.chartData
              && vm.chartData.projectOverview
              && (vm.chartData.projectOverview.completed !== 0
                || vm.chartData.projectOverview.inProgress !== 0)
          }

        },
        templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetPiechartProjectinstanceOverview.directive.html'
      }
    })
})();

(function () {
    angular.module('gfApp')
      .directive('widgetPiechartProjectinstancesProjecttype', function ($translate, dashboardService, colors) {
        return {
          scope:{},
          restrict: 'E',
          controllerAs: 'vm',
          bindToController: {
            data:'=',
            filters: "=",
            header: "@?"
          },
          controller: function(){
            var vm = this
            vm.charts = {}
            vm.colors = colors.picChart
  
            vm.active = false
            vm.hasData = hasData
  
            activate()
  
            ///
  
            function activate(){
              getChartData(vm.filters)
            }
  
            function getChartData(filters) {
              dashboardService.getAllWidgets(filters).then(
                function (data) {
                  vm.chartData = data
                  if(data.projectByProjectType){
                    getProjectsByProjectTypeChartData(data)
                  }
  
                  vm.active = true
                }
              );
            }
  
            function getProjectsByProjectTypeChartData(data){
              var labels = data.projectByProjectType.map(function(a){
                return a.name;
              });
              var dataList = data.projectByProjectType.map(function(a){
                return a.count;
              });
              vm.charts.projectByProjectType = {
                labels: labels,
  
                data: dataList,
                options: {
                  legend: {
                    display: true,
                    position: 'bottom'
                  },
                  animation: {
                    onProgress: function () {
                      vm.isChartRendering = false;
                    }
                  }
                },
                colors: vm.colors
              };
            }
  
            function hasData() {
              return vm.chartData
                && vm.chartData.projectByProjectType
                && vm.chartData.projectByProjectType.length > 0;
            }
  
          },
          templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetPiechartProjectinstanceByProjectType.directive.html'
        }
      })
  })();
  
(function () {
    angular.module('gfApp')
      .directive('widgetPiechartProjectinstancesClient', function ($translate, dashboardService, colors) {
        return {
          scope:{},
          restrict: 'E',
          controllerAs: 'vm',
          bindToController: {
            data:'=',
            filters: "=",
            header: "@?"
          },
          controller: function(){
            var vm = this
            vm.charts = {}
            vm.colors = colors.picChart
  
            vm.active = false
            vm.hasData = hasData
  
            activate()
  
            ///
  
            function activate(){
              getChartData(vm.filters)
            }
  
            function getChartData(filters) {
              dashboardService.getAllWidgets(filters).then(
                function (data) {
                  vm.chartData = data
                  if(data.projectByClient){
                    getProjectsByClientChartData(data)
                  }
  
                  vm.active = true
                }
              );
            }
  
            function getProjectsByClientChartData(data){
              var labels = data.projectByClient.map(function(a){
                return a.name;
              });
              var dataList = data.projectByClient.map(function(a){
                return a.count;
              });
              vm.charts.projectByClient = {
                labels: labels,
  
                data: dataList,
                options: {
                  legend: {
                    display: true,
                    position: 'bottom'
                  },
                  animation: {
                    onProgress: function () {
                      vm.isChartRendering = false;
                    }
                  }
                },
                colors: vm.colors
              };
            }
  
            function hasData() {
              return vm.chartData
                && vm.chartData.projectByClient
                && vm.chartData.projectByClient.length > 0;
            }
  
          },
          templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetPiechartProjectinstanceByClient.directive.html'
        }
      })
  })();
  
(function () {
  angular.module('gfApp')
    .directive('widgetMapProjectinstances', function ($window, $interval, colors, dashboardService) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          data:'=',
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this

          vm.header = vm.header

          vm.getChartData = getChartData

          activate()

          ///

          function activate(){
            getChartData(vm.filters)
            resizeMapWidget()
          }

          function getChartData(filters) {
            dashboardService.getAllWidgets(filters).then(
              function (data) {
                vm.chartData = data
                if (data.projectOverview) {
                  getStoresChartData(data.stores)
                }
              }
            );
          }

          function resizeMapWidget(){
            $interval(function() {

            }, 1000);
          }

          function getStoresChartData(stores) {

            vm.maps = {

              markers: stores.filter(function (store) {
                return angular.isDefined(store.latitude) && angular.isDefined(store.longitude)
              }).map(function (store) {
                var markerColor = colors.map.completed
                var instances = ""

                angular.forEach(store.projectInstances, function (projectInstance) {

                  if (!projectInstance.completed) {
                    markerColor = colors.map.inProgress
                  }

                  var labelColor = projectInstance.completed ? 'label-status-completed' : 'label-status-inprogress'
                  instances += "<div class='m-t-xs m-b-sm'><label class='label " + labelColor + "' ui-sref='siskin.projectinstancedetail({projectInstanceId:" + projectInstance.id + "})'>" + projectInstance.name + "</label></div>"
                })

                return {
                  lat: store.latitude || 0,
                  lng: store.longitude || 0,
                  title: store.name,
                  message: "<h4>" + store.name + "</h4><p>" + instances + "</p>",
                  markerColor: markerColor
                }
              })
            }

            var center = getCenter(stores)
            if (center) {
              vm.maps.center = center
            }
          }

        function getCenter(stores) {
            var minZoom = 6
            var latitudes = stores.filter(function(s){return s.latitude && s.longitude}).map(function (s) {
              return s.latitude
            })
            var longitudes = stores.filter(function(s){return s.latitude && s.longitude}).map(function (s) {
              return s.longitude
            })

            if(!latitudes.length || !longitudes.length) return { lat:0, lng:0}

            var distanceLatitude = max(latitudes) - min(latitudes)
            var distanceLongitude = max(longitudes) - min(longitudes)
            var zoomByLatitude = Math.round(minZoom - (distanceLatitude / 180 * minZoom)) - 2
            var zoomByLongitude = Math.round(minZoom - (distanceLongitude / 360 * minZoom)) - 2
            var zoom = Math.max(Math.max(zoomByLatitude, zoomByLongitude), 1)

            var lat = (zoom === 1 ? 0 : (max(latitudes) + min(latitudes)) / 2)
            var lng = (zoom === 1 ? 0 : (max(longitudes) + min(longitudes)) / 2)

            return {
              lat:  isNaN(lat) ? 0 : lat,
              lng:  isNaN(lng) ? 0 : lng,
              zoom: zoom-1
            }
          }

          function max(array) {
            if(isValidArrayHasData(array)){
              return array.reduce(function (a, b) {
                return Math.max(a, b);
              })
            }
          }

          function min(array) {
            if(isValidArrayHasData(array)){
              return array.reduce(function (a, b) {
                return Math.min(a, b);
              })
            }
          }

          function isValidArrayHasData(array){
            return angular.isArray(array) && array.length > 0;
          }

        },
        templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetMap.directive.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetListProjecttemplatoverview', function ($state, $translate, dashboardService, projectTemplateService, configService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          data:'=',
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this

          vm.features = configService.appSettings.features
          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}
          vm.projects ={}

          activate()

          ///

          function activate(){
            vm.jobspager = projectTemplateService.getPager({pageSize:10})

            getProjectData(vm.filters)
          }

          function getProjectData(filters) {
            dashboardService.getAllWidgets(filters).then(
              function (data) {
                if (data.projectOverview) {
                  vm.projects = data.projects
                  angular.forEach(vm.projects, function (project) {
                    project.percentageInProgress = project.inProgress/(project.inProgress + project.completed)*100
                    project.percentageCompleted = project.completed/(project.inProgress + project.completed)*100
                    project.href = $state.href('siskin.project', {projectId: project.id})
                  })
                }
                vm.active = true;
              }
            );
          }
          

        },
        templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetListProjecttemplatoverview.directive.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetListProjectinstancemilestones', function ($translate, dashboardService, projectTemplateService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          data:'=',
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this

          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}

          activate()

          ///

          function activate(){
            vm.jobspager = projectTemplateService.getPager();

            getChartData(vm.filters)
            loadProjectTemplates()
          }

          function getChartData(filters) {
            dashboardService.getAllWidgets(filters).then(
              function (data) {
                vm.chartData = data
                vm.active = true;
              }
            );
          }

          function loadProjectTemplates() {
            var params = {};

            if(vm.filters.selectedClient !== null && vm.filters.selectedClient.id && vm.filters.selectedClient.id!==0){
              params = {clientId: vm.filters.selectedClient.id};
            }

            vm.jobspager.reset(params)
          }


        },
        templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetListProjectinstancemilestones.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('widgetLinechartProjectinstances', function ($state, $translate, dashboardService, colors) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          data:'=',
          filters: "=",
          header: "@?"
        },
        controller: function(){
          var vm = this

          vm.colors = {inProgress: colors.inProgress, completed: colors.completed}

          activate()

          ///

          function activate(){
            getDashboardData(vm.filters)
          }


          function getDashboardData(filters) {
            dashboardService.getLineChartWidget(filters).then(function (data) {
              getOverviewChartData(data.monthlyOverview)
              vm.active = true;
            })
          }
          function getOverviewChartData(monthlyOverview){
            var startedCount = monthlyOverview.map(function(data) {
              return data.startedCount
            })

            var completedCount = monthlyOverview.map(function(data) {
              return data.completedCount
            })

            var labels = monthlyOverview.map(function(data) {
              return data.name
            })

            vm.chart = {
              data: [startedCount, completedCount],
              labels: labels,
              series: [
                $translate.instant('enum.status.started'),
                $translate.instant('enum.status.completed')
                /*'Started', 'Completed'*/],
              options: {
                legend: {
                  display: true,
                  position: 'bottom'
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                      precision:0
                    }
                  }]
                },
                maintainAspectRatio: false

              },
              colors: [vm.colors.inProgress, vm.colors.completed]
            };
          }
          

        },
        templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetLinechart.directive.html'
      }
    })
})();

(function () {
    angular.module('gfApp')
      .directive('widgetBarchartProjectinstancesCountry', function ($translate, dashboardService, colors) {
        return {
          scope:{},
          restrict: 'E',
          controllerAs: 'vm',
          bindToController: {
            data:'=',
            filters: "=",
            header: "@?"
          },
          controller: function(){
            var vm = this
            vm.charts = {}
            vm.colors = { inProgress: colors.inProgress, completed: colors.completed }
  
            vm.active = false
            vm.hasData = hasData
  
            activate()
  
            ///
  
            function activate(){
              getChartData(vm.filters)
            }
  
            function getChartData(filters) {
              dashboardService.getAllWidgets(filters).then(
                function (data) {
                  vm.chartData = data
                  if(data.projectByCountry){
                    getProjectsByCountryChartData(data)
                  }
  
                  vm.active = true
                }
              );
            }
  
            function getProjectsByCountryChartData(data){
              var labels = data.projectByCountry.map(function(a){return a.name;});
              var completedList = data.projectByCountry.map(function(a){return a.completed;});
              var inProgressList = data.projectByCountry.map(function(a){return a.inProgress;});
              
              var series = [
                $translate.instant('enum.projectstatus.inprogress'),
                $translate.instant('enum.status.completed')
              ];

              vm.charts.projectByCountry = {
                labels: labels,
                series: series,
                data: [
                  inProgressList,
                  completedList
                ],
                options: {
                  scales: {
                    xAxes: [{
                      stacked: true
                    }],
                    yAxes: [{
                      stacked: true
                    }]
                  },
                  legend: {
                    display: true,
                    position: 'bottom'
                  },
                  animation: {
                    onProgress: function () {
                      vm.isChartRendering = false;
                    }
                  }
                },
                colors: [
                  {
                    backgroundColor: vm.colors.inProgress
                  }, 
                  {
                    backgroundColor: vm.colors.completed
                  }
                ]
              };
            }
  
            function hasData() {
              return vm.chartData
                && vm.chartData.projectByCountry
                && vm.chartData.projectByCountry.length > 0;
            }
  
          },
          templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetBarchartProjectinstanceByCountry.directive.html'
        }
      })
  })();
  
(function () {
    angular.module('gfApp')
      .directive('widgetBarchartProjectinstancesBrand', function ($translate, dashboardService, colors) {
        return {
          scope:{},
          restrict: 'E',
          controllerAs: 'vm',
          bindToController: {
            data:'=',
            filters: "=",
            header: "@?"
          },
          controller: function(){
            var vm = this
            vm.charts = {}
            vm.colors = { inProgress: colors.inProgress, completed: colors.completed }
  
            vm.active = false
            vm.hasData = hasData
  
            activate()
  
            ///
  
            function activate(){
              getChartData(vm.filters)
            }
  
            function getChartData(filters) {
              dashboardService.getAllWidgets(filters).then(
                function (data) {
                  vm.chartData = data
                  if(data.projectByBrand){
                    getProjectsByBrandChartData(data)
                  }
  
                  vm.active = true
                }
              );
            }
  
            function getProjectsByBrandChartData(data){
              var labels = data.projectByBrand.map(function(a){return a.name;});
              var completedList = data.projectByBrand.map(function(a){return a.completed;});
              var inProgressList = data.projectByBrand.map(function(a){return a.inProgress;});
              
              var series = [
                $translate.instant('enum.projectstatus.inprogress'),
                $translate.instant('enum.status.completed')
              ]

              vm.charts.projectByBrand = {
                labels: labels,
                series: series,
                data: [
                  inProgressList,
                  completedList
                ],
                options: {
                  scales: {
                    xAxes: [{
                      stacked: true
                    }],
                    yAxes: [{
                      stacked: true
                    }]
                  },
                  legend: {
                    display: true,
                    position: 'bottom'
                  },
                  animation: {
                    onProgress: function () {
                      vm.isChartRendering = false;
                    }
                  }
                },
                colors: [
                  {
                    backgroundColor: vm.colors.inProgress
                  }, 
                  {
                    backgroundColor: vm.colors.completed
                  }
                ]
              };
            }
  
            function hasData() {
              return vm.chartData
                && vm.chartData.projectByBrand
                && vm.chartData.projectByBrand.length > 0;
            }
  
          },
          templateUrl: 'app/modules/siskin/clientdashboard/widgets/widgetBarchartProjectinstanceByBrand.directive.html'
        }
      })
  })();
  
(function () {
  angular.module('gfApp')
    .factory('projectAttributesControllerFactory', factory)

  function factory(projectTemplateService, fileEndpointService, dataValueService) {
    return function (data) {
      return {
        size: 'lg',
        templateUrl: 'app/modules/siskin/attribute/exportimport/list.modal.html',
        controllerAs: 'vm',
        controllerInit: function (vm) {
          vm.data = data
          vm.file = {}
          vm.search = {}

          vm.download = download
          vm.upload = upload
          vm.select = select
          vm.toggle = toggle

          activate()

          ////

          function activate() {
            projectTemplateService.getDetailAttributes(vm.data.resource)
              .then(function (data) {
                vm.attributes = data
                vm.attributeGroups = dataValueService.groupByCategory(data.attributes)
              })
          }

          function upload() {
            if (vm.file.data.length > 0) {
              vm.uploadingValidation = null
              vm.uploading = true

              fileEndpointService.upload('projecttemplate-attributes-excel', vm.data, vm.file.data[0])
                .then(function(data){
                  vm.uploadingValidation = data.data
                })
                .finally(function(){
                  vm.uploading = false
                  vm.file = {}
                })
            }
          }

          function select(m, value) {
            var val = angular.isDefined(value) ? value : !m.pvalue

            m.pvalue = val

            if (angular.isDefined(m.data)) {
              angular.forEach(m.data, function (a) {
                select(a, val)
              })
            }

            if (angular.isUndefined(m.data)) {
              angular.forEach(vm.attributeGroups.groups, function (c) {
                if (c.data.indexOf(m) >= 0) {
                  c.pvalue = c.data.length === c.data.filter(function (m) {
                      return m.pvalue
                    }).length
                }
              })
            }
            if(vm.toggleVal) {
              vm.toggleVal=false
            }
          }

          function download(exportTemplate) {
            var attributeIds = vm.attributes.attributes.filter(function (m) {
              return m.pvalue
            }).map(function (m) {
              return m.id
            })
            if (attributeIds.length) {
              fileEndpointService.download('projecttemplate-attributes-excel', vm.data, {
                attributeIds: attributeIds,
                exportTemplate: exportTemplate
              })
            }
          }

          function toggle() {
            angular.forEach(vm.attributes.attributes, function (m) {
              m.pvalue = vm.toggleVal
            })

            angular.forEach(vm.attributeGroups.groups, function (m) {
              m.pvalue = vm.toggleVal
            })
          }

        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('projectAttributesBatchUpdateControllerFactory', factory)

  function factory(projectTemplateService, dataValueService, fileCollectionService, projectInstanceService, userService) {
    return function (data) {
      return {
        size: 'lg',
        templateUrl: 'app/modules/siskin/attribute/batchupdate/list.modal.html',
        controllerAs: 'vm',
        controllerInit: function (vm) {
          vm.data = data
          vm.projectselected = []
          
          vm.apply = apply
          vm.cancel = cancel
          vm.edit = edit

          vm.userPager

          activate()

          ////

          function activate() {
            projectTemplateService.getAttributesUpdate(vm.data.resource)
              .then(function (data) {
                vm.attributes = data
                vm.attributeGroups = dataValueService.groupByCategory(data.attributes)

                if(vm.attributeGroups.groups.length <= 3){
                  angular.forEach(vm.attributeGroups.groups, function(a){a.expanded = true})
                }
              })

            vm.userPager = userService.Pager()
            projectInstanceService.Pager(vm.data.resource).nextPage().then(function(data){
              vm.projects = data
            })
          }

          function apply(a){
            a.saving = true
            a.projectIds = vm.projectselected.map(function(p){return p.id})

            projectTemplateService.updateAttribute(a)
              .then(function(){
                a.success = true
                a.edit = false
              })
              .finally(function(){
                a.saving = false
              })
          }

          function cancel(a){
            a.edit = false

            if(a.type === 'multiplefile'){
              fileCollectionService.remove(a.fileCollection)
            }
            
          }

          function edit(a){
            a.edit = true
            a.success = undefined

            if(a.type === 'multiplefile'){
              fileCollectionService.getFileCollection(a)
                .then(function(data){
                  a.fileCollection = data
                  a.fileCollectionId = data.id
                })
            }
          }
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('projectAttributesAclsControllerFactory', factory)

  function factory($filter, aclService) {
    return function (data) {
      return {
        size:'lg',
        templateUrl: 'app/modules/siskin/attribute/acls/list.modal.html',
        controllerAs:'vm',
        controllerInit: function (vm) {
          vm.update = update
          vm.updateAll = updateAll
          vm.swap = swap
          vm.toggle = toggle
          vm.select = select

          vm.data = data
          vm.accesslevels = [
            {value: 'NoAccess', translationKey: 'enum.accesslevel.noaccess'},
            {value: 'Read', translationKey: 'enum.accesslevel.read'},
            {value: 'Write', translationKey: 'enum.accesslevel.write'}
          ]

          var groups = {}


          activate()

          ////

          function activate() {
            aclService.get(vm.data.resource)
              .then(function(data){
                vm.acls = data

                groups['projectRoles'] = {title: 'project.acls.projectroles', titleright: 'project.acls.attributes', type: 'attribute', data: groupBy(vm.acls.all, 'projectRoleName')}
                groups['attributes'] = {title: 'project.acls.attributes', titleright: 'project.acls.projectroles', type: 'projectRole', data: groupBy(vm.acls.all, 'attributeName')}

                vm.acls.groups = groups['projectRoles']
                select(vm.acls.groups.data[0])
              })
          }

          function select(container){
            vm.selected = container

            vm.fileApprove = false
            vm.fileOnlyApproved = false
          }

          function update(acl){
            var func = acl.id ? aclService.update : aclService.create

            func(acl)
              .then(function(data){
                if(func == aclService.create){
                  angular.forEach(groups, function(m){
                    angular.forEach(m.data, function(a){
                      a.data[a.data.indexOf(acl)] = data
                    })
                  })
                }
              })
          }

          function updateAll(access){
            if(angular.isUndefined(vm.selected)){
              return
            }

            angular.forEach($filter('filter')(vm.selected.data,vm.filterright), function(m){
              m.accessLevel = access.value
              update(m)
            })
          }

          function toggle(property, value){
            if(angular.isUndefined(vm.selected)){
              return
            }

            angular.forEach($filter('filter')(vm.selected.data,vm.filterright).filter(function(m){return m.isFileOrMultiFile}), function(m){
              if(m[property] !== value){
                m[property] = value
                update(m)
              }
            })
          }

          function swap(){
            if(vm.acls.groups.title === 'project.acls.attributes'){
              vm.acls.groups = groups['projectRoles']
            }else{
              vm.acls.groups = groups['attributes']
            }

            select(vm.acls.groups.data[0])
          }

          ///////////

          function groupBy(xs, key) {
            var listOrder = {}
            var m =  xs.reduce(function(rv, x) {
              x.name = key === 'attributeName' ? x.projectRoleName : x.attributeName;
              (rv[x[key]] = rv[x[key]] || []).push(x);
              listOrder[x[key]] = (key === 'attributeName' ? x.attributeListOrder : x.projectRoleListOrder)
              return rv;
            }, {})

            var array = []
            for(var o in m){
              if(m.hasOwnProperty(o)){
                array.push({name:o === 'undefined' ? 'project.acls.storelevel': o, listOrder: listOrder[o],data: m[o]})
              }
            }

            return array
          }
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('workflowUpdateControllerFactory', factory)

  function factory($translate, $timeout, projectTemplateService) {
    return function () {
      return {
        templateUrl: 'app/modules/siskin/workflow/list.update.html',
        controllerInit: function (vm) {

          vm.active = false
          vm.data = null

          vm.isLoading = isLoading
          vm.getNextVersion = getNextVersion
          vm.getChildWorkflowNextVersion = getChildWorkflowNextVersion
          vm.update = update
          vm.init = init
          vm.onClosed = onClosed

          var timeout = null

          init()

          /////

          function init() {
            clear()

            projectTemplateService.getVersionUpdates().then(function(data){
              vm.data = data
              vm.active = true

              vm.updatesInProgress = vm.data.updatesInProgress

              if(vm.updatesInProgress !== 0 && !vm.closed){
                timeout = $timeout(vm.init,2000);
              }

              vm.data.templates = vm.data.upgradeableWorkflows.map(function(x){
                return{
                  id:x.projectTemplateId,
                  name: x.projectTemplateName + " ("+ x.fromDisplayText +")"
                }
              })
            })
          }

          function onClosed(){
            vm.closed = true
            if(timeout){
              $timeout.cancel(timeout);
            }
          }

          function getNextVersion() {
            var projectTemplate = vm.projectTemplate
            vm.data.workflows = null
            vm.updateInfo = null
            vm.childWorkflow = null

            var updateInfo = vm.data.upgradeableWorkflows.find(function (x) {
              return x.projectTemplateId === projectTemplate.id
            })

            if (angular.isUndefined(updateInfo.workflowUpgrades)) {
              vm.updateInfo = updateInfo
            } else {
              vm.data.workflows = updateInfo.workflowUpgrades.map(function (x) {

                return {
                  id: x.fromId,
                  name: x.fromDisplayText,
                  workflow:x
                }
              })
            }
          }

          function getChildWorkflowNextVersion() {
            if (vm.childWorkflow) {
              vm.updateInfo = vm.childWorkflow.workflow
            } else {
              vm.updateInfo = null
            }
          }

          function isLoading() {
            return vm.active === false;
          }

          function update() {
            if (vm.updateInfo.projectTemplateId) {
              projectTemplateService.domainModelVersionUpdate(vm.projectTemplate.id, vm.updateInfo.toId)
                .then(function(){
                  $timeout(init)
                }).catch(showError)
            } else {
              projectTemplateService.workflowVersionUpdate(vm.projectTemplate.id, vm.updateInfo.fromId, vm.updateInfo.toId)
                .then(function(){
                  $timeout(init)
                }).catch(showError)
            }
          }

          function showError(){
            vm.error = $translate('workflows.update.error');
          }

          function clear(){
            vm.data = null
            vm.projectTemplate = null
            vm.childWorkflow = null
            vm.updateInfo = null

            vm.active = false
          }
        }
      }
    }
  }
})();

(function () {
    angular.module('gfApp')
        .factory('workflowPreviewControllerFactory', factory)
    function factory($timeout, workflowInstanceGoJsService, workflowService) {
        return function (resource) {
            return {
                size: 'lg',
                templateUrl: 'app/modules/siskin/workflow/preview.modal.html',
                controllerAs: 'vm',
                controllerInit: function (vm) {
                    vm.select = select
                    workflowInstanceGoJsService.init()
                    vm.flowchart = workflowInstanceGoJsService.flowchart
                    vm.isLoaded = false

                    activate()

                    function activate() {
                        return workflowService.get(resource)
                            .then(function (data) {
                                vm.data = data
                                select(vm.data)
                            })
                    }

                    function updateCanvas(){
                        $timeout(function () {
                            vm.flowchart.update(vm.selected.flowData)
                        })
                    }
                    
                    function select(workflow) {
                        if (vm.selected == workflow) {
                            return
                        }

                        vm.selected = null

                        $timeout(function(){
                            vm.selected = workflow

                            if(angular.isUndefined(vm.selected.flowData)){
                                workflowService.getFlowData(vm.selected.resource)
                                .then(function (data) {
                                    vm.selected.flowData = data.flowData
                                    vm.isLoaded = true
                                    updateCanvas()
                                })
                            }else{
                                updateCanvas()
                            }
                        })
                        
                    }
                }
            }
        }
    }
})();


(function () {
  angular.module('gfApp')
    .controller('WorkflowListController', controller)

  function controller($state, $log, permissionService, workflowEntityService, modalService, workflowUpdateControllerFactory, notificationService) {
    var vm = this;

    vm.updateInformation = null

    vm.view = view
    vm.clone = clone
    vm.disable = disable
    vm.download = download
    vm.restore = restore
    vm.delete = deleteEntity
    vm.downloadWfDesigner = downloadWfDesigner
    vm.checkWfUpdates = checkWfUpdates

    permissionService.actionRedirect(activate);

    ////

    function activate(){
      workflowEntityService.initializeWorkflows()

      vm.pager = workflowEntityService.pager
      vm.pager.nextPage()
    }


    function view(w){
      $state.go('workflow', {workflowId: w.id})
    }

    function clone(w){
      w.cloning = true

      workflowEntityService.clone(w)
        .then(function(data){
          $state.go('siskin.workflowset', {workflowEntityId: data})
        })
    }

    function download(w) {
      w.downloading = true
      workflowEntityService.download(w).finally(function(){w.downloading = false})
    }

    function disable(w) {
      modalService.open({
        templateUrl: 'app/modules/siskin/workflow/deactivate.workflow.modal.html',
        controllerInit: disableWorkflowController(w)
      })
    }

    function deleteEntity(w) {
      modalService.open({
        templateUrl: 'app/modules/siskin/workflow/delete.workflow.modal.html',
        controllerInit: deleteWorkflowController(w,vm.pager)
      })
    }

    function restore(workflow) {
      workflowEntityService.restore(workflow)
        .then(function(){
          workflow.isDeleted =false
        })
        .catch(function (m) {
          workflow.error = m
        })
    }

    function downloadWfDesigner() {
      vm.downloadingWorkflowDesigner = true
      workflowEntityService.downloadWfDesigner().finally(function(){vm.downloadingWorkflowDesigner = false})
    }

    function checkWfUpdates(){
      modalService.open(workflowUpdateControllerFactory(vm.updateInformation))
    }

    function disableWorkflowController(workflow){
      return function (vm) {
        vm.original = workflow
        vm.data = angular.copy(workflow)
        vm.data.resource = workflow.resource

        vm.delete = function(){
          workflowEntityService.remove(workflow)
            .then(function(){
              vm.original.isDeleted = true
              vm.close()
            })
            .catch(function (m) {
              vm.error = m
              $log(vm.error)
            })
        }
      }
    }

    function deleteWorkflowController(workflow, pager){
      return function (vm) {
        vm.original = workflow
        vm.data = angular.copy(workflow)
        vm.data.resource = workflow.resource

        vm.delete = function(){
          workflowEntityService.deleteWorkflow(workflow)
            .then(function(data){
              if(data.data.isValid){
                pager.items.splice(pager.items.indexOf(workflow),1)
                notificationService.success('workflows.deletesuccessfully')
              }else{
                notificationService.error(data.data.message)
              }
              vm.close()
            })
            .catch(function (m) {
              vm.error = m
              notificationService.error('workflows.deleteerror')
              $log(vm.error)
            })
        }
      }
    }

  }
})();

(function () {
  angular.module('gfApp')
    .controller('WorkflowDetailController', controller)

  function controller($stateParams, $state, permissionService, modalService, workflowEntityService, createQuestionsControllerFactory, workflowEntityDeleteValidator, workflowEntityValidator) {
    var vm = this
    
    permissionService.actionRedirect(activate);

    vm.publish = publish
    vm.update = update

    vm.addOrEdit = addOrEdit
    vm.remove = remove

    var templates = {
      attribute: {
        name: '',
        entityType: 'attribute',
        subtype: '',
        extendedData: {},
        children: []
      },
      category: {
        name: '',
        entityType: 'attribute',
        subtype: 'category',
        extendedData: {},
        children: [],
        attributes: []
      }
    }

    ////

    function activate() {
      workflowEntityService.getSet($stateParams.workflowEntityId)
        .then(function (data) {
          vm.data = data
          vm.readonly = data.domainModel.readonly
          vm.sortableOptions.disabled = vm.readonly
          workflowEntityValidator(data.domainModel)
        })
    }

    function publish() {
      return workflowEntityService.publish(vm.data.domainModel)
        .then(function () {
          $state.go($state.current, {}, {reload: true})
          modalService.dismissAll()
        })
    }

    function update(entity, withoutChildren) {
      if (withoutChildren) {
        workflowEntityService.updateSimple(entity)
      } else {
        workflowEntityService.update(entity)
      }
    }

    function addOrEdit(entity) {
      modalService.open(createQuestionsControllerFactory(vm.data.domainModel, angular.isString(entity) ? templates[entity] : entity))
    }

    function remove(entity, arrays) {
      if (workflowEntityDeleteValidator(entity, vm.data.workflows.concat([vm.data.domainModel]))) {
        var allowRemove = true

        if (entity.attributes) {
          angular.forEach(entity.attributes, function (a) {
            if(!remove(a, [vm.data.domainModel.children])){
              allowRemove = false
            }
          })
        }

        if(allowRemove){
          workflowEntityService.remove(entity)
            .then(function () {
                angular.forEach(arrays, function (a) {
                  var i = a.indexOf(entity)
                  if (i !== -1) {
                    a.splice(i, 1)
                  }
                })

                // update linked
                angular.forEach(vm.data.domainModel.children, function (m) {
                  if (m.extendedData.linkedAttribute === entity.name) {
                    m.extendedData.linkedAttribute = ''
                    workflowEntityService.updateSimple(m)
                  }
                })
              }
            )
        }
      }
    }

    ///// sortable
    vm.sortableOptions = {
      cancel: ".unsortable",
      items: "li:not(.unsortable)",
      stop: function stopSortable(e, ui) {
        angular.forEach(ui.item.sortable.sourceModel.filter(function (m) {
          return m.resource
        }), function (a, i) {
          if (a.extendedData.displayOrder !== i) {
            a.extendedData.displayOrder = i
          }
        })
        return workflowEntityService.update(vm.data.domainModel)
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('createQuestionsControllerFactory', factory)
  function factory(workflowEntityService, workflowEntityValidator) {
    return function (domainModel, entity) {
      return {
        size: 'md',
        templateUrl: 'app/modules/siskin/workflow/create.question.modal.html',
        controllerAs: 'm',
        controllerInit: function (vm) {
          vm.categories = domainModel.categories.filter(function (m) {
            return m.resource
          })
          vm.anchorDates = domainModel.children.filter(function (m) {
            return m != entity && (m.subtype === 'date' || m.subtype === 'dateTime')
              && (m.extendedData.isAnchorDate === true || m.extendedData.linkedAttribute)
          })

          vm.categoryTypes = ['storeinfo', 'reportingcontacts', 'string', 'boolean', 'number', 'date', 'dropdown', 'file', 'image', 'user', 'guidelines']
          vm.attributeTypes = [
            {key: 'enum.attribute.string', value: "string"},
            {key: 'enum.attribute.date', value: "date"},
            {key: 'enum.attribute.datetime', value: "dateTime"},
            {key: 'enum.attribute.integer', value: "integer"},
            {key: 'enum.attribute.double', value: "double"},
            {key: 'enum.attribute.boolean', value: "boolean"},
            {key: 'enum.attribute.multiplefile', value: "multipleFile"},
            {key: 'enum.attribute.dropdown', value: "dropdown"},
            {key: 'enum.attribute.confirmation', value: "confirmation"}]

          vm.updateMode = angular.isDefined(entity.resource)
          vm.entity = angular.copy(entity)
          vm.entity.resource = angular.isDefined(entity) ? entity.resource : undefined

          // this line is for cleaning the extendeddata, workflowdesigner will add some unnecessary data that cannot
          // be parsed back into the server
          delete vm.entity.extendedData.linkableAttributes
          delete vm.entity.extendedData.categoryTypes

          vm.initialize = initialize
          vm.initializeAnchorDate = initializeAnchorDate

          vm.addValue = addValue
          vm.addChild = addChild
          vm.removeChild = removeChild
          vm.save = save

          function addValue(property, value) {
            if (isNaN(parseInt(vm.entity.extendedData[property]))) {
              vm.entity.extendedData[property] = 0
            }

            vm.entity.extendedData[property] += value
            if (vm.entity.extendedData[property] <= 0) {
              vm.entity.extendedData[property] = undefined
            }
          }

          function initialize() {
            vm.entity.children.length = 0
            vm.entity.extendedData = {category: vm.entity.extendedData.category}

            if (vm.entity.subtype == 'dropdown') {
              vm.entity.children.push({entityType: 'availableValues', children: []})
            }
            if (vm.entity.subtype == 'dateTime' || vm.entity.subtype == 'date') {
              vm.entity.children.push({entityType: 'timeSpan'})
            }
          }

          function initializeAnchorDate() {
            vm.entity.children[0].extendedData.days = 0
            vm.entity.children[0].extendedData.hours = 0
            vm.entity.children[0].extendedData.minutes = 0
            vm.entity.extendedData.linkedAttribute = undefined
          }

          function addChild(type) {
            vm.entity.children[0].children.push({
              entityType: type
            })
          }

          function removeChild(child) {
            if (angular.isDefined(child.resource)) {
              child.isDeleted = true
            } else {
              vm.entity.children[0].children.splice(vm.entity.children[0].children.indexOf(child), 1)
            }
          }

          function save() {
            (vm.updateMode ? update : create)().then(vm.close)
          }

          ////////////////////

          function create() {
            var arrayToUpdate = vm.entity.subtype === 'category'
              ? domainModel.categories
              : domainModel.categories.find(function (c) {
                return c.name === (vm.entity.extendedData.category || 'Default')
              }).attributes

              vm.entity.extendedData.displayOrder = arrayToUpdate.length === 0 
                ? 0
                : arrayToUpdate[arrayToUpdate.length-1].extendedData.displayOrder + 1

            return workflowEntityService.createChild(domainModel, vm.entity, arrayToUpdate)
              .then(function (data) {
                domainModel.children.push(data)
                arrayToUpdate.push(data)
              })
          }

          function update() {
            var previousArrayToUpdate = vm.entity.subtype === 'category'
              ? domainModel.categories
              : domainModel.categories.find(function (c) {
                return c.name === (entity.extendedData.category || 'Default')
              }).attributes

            var arrayToUpdate = vm.entity.subtype === 'category'
              ? domainModel.categories
              : domainModel.categories.find(function (c) {
                return c.name === (vm.entity.extendedData.category || 'Default')
              }).attributes

            vm.entity.extendedData.displayOrder = arrayToUpdate.indexOf(entity) === -1 ? arrayToUpdate.length : arrayToUpdate.indexOf(entity)

            return workflowEntityService.update(vm.entity, arrayToUpdate)
              .then(function (data) {
                data.validation = vm.entity.validation
                if (entity.attributes) {
                  angular.forEach(entity.attributes, function (a) {
                    a.extendedData.category = vm.entity.name
                    workflowEntityService.updateSimple(a, arrayToUpdate)
                  })
                  data.attributes = entity.attributes
                  data.collapsed = entity.collapsed
                }

                domainModel.children[domainModel.children.indexOf(entity)] = data
                previousArrayToUpdate.splice(previousArrayToUpdate.indexOf(entity), 1)
                arrayToUpdate.splice(vm.entity.extendedData.displayOrder, 0, data)
                workflowEntityValidator(domainModel)
                
              })
          }
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('UserListController', controller)

  function controller() {
    var vm = this;

    vm.search = search

    activate()

    ////

    function activate(){

    }

    function search() {

    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('TaskInstanceAttributesListController', controller)

  function controller($stateParams, requestHelperService, taskInstanceService, filterHelperService) {
    var vm = this;

    vm.header = []

    activate()

    ////

    function activate(){
      vm.query = $stateParams.query
      vm.search = requestHelperService.getFromQuery('projectTasksAttributes',vm.query)
      vm.pager = taskInstanceService.pagerAttributes(vm.search)

      filterHelperService.populateFilter(vm.search).then(function(f){
        if(angular.isDefined(f.store)){
          vm.header.push(f.store.name)
        }
        if(angular.isDefined(f.client)){
          vm.header.push(f.client.name)
        }
        if(angular.isDefined(f.projectTemplate)){
          vm.header.push(f.projectTemplate.name)
        }
      })
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('TaskInstanceListController', function ($state, $stateParams, permissionService, filterHelperService, uriTemplate,
      taskInstanceService, gfSiskinDropdownValues, userService) {
      var vm = this
      var QUERY_TEMPLATE = uriTemplate.create('{?storeGroupId,projectInstanceName,userId,country,region,clientId,templateId,storeId,status,orderBy,taskNames*}')

      vm.search = angular.extend({
        orderBy: gfSiskinDropdownValues.orderBy[0],
        dueDate: {},
        completedDate: {}
      },QUERY_TEMPLATE.fromUri("?" + $stateParams.query))

      vm.reset = reset
      vm.resetDateRangeFilter = resetDateRangeFilter

      permissionService.actionRedirect(activate)

      ///////

      function activate() {
        vm.statusValues = gfSiskinDropdownValues.taskStatuses
        vm.orderByValues = gfSiskinDropdownValues.orderBy
        vm.pager = taskInstanceService.pager()
        vm.userPager = userService.Pager()

        filterHelperService.populateFilter(vm.search).then(function(f){
          vm.search = angular.extend(vm.search, f)
        })

        vm.pager.reset(vm.search)

        taskInstanceService.getFilters()
          .then(function(data){
            vm.filters = data
          })
      }

      function reset() {
        if(vm.search.dueDate.startDate && vm.search.dueDate.endDate){
          vm.search.dueFrom = vm.search.dueDate.startDate.toJSON()
          vm.search.dueTo = vm.search.dueDate.endDate.toJSON()
        }
        if(vm.search.completedDate.startDate && vm.search.completedDate.endDate){
          vm.search.completedFrom = vm.search.completedDate.startDate.toJSON()
          vm.search.completedTo = vm.search.completedDate.endDate.toJSON()
        }

        vm.pager.reset(vm.search)
        $state.go($state.current.name, {query: QUERY_TEMPLATE.toUri(vm.pager.searchCriteria).substring(1)}, {notify: false})
      }

      function resetDateRangeFilter(type){
        vm.search[type + 'From'] = null
        vm.search[type + 'To'] = null

        vm.search[type + 'Date'] = {
          startDate: null,
          endDate : null
        }

        reset()
      }
    })
})();

(function () {
    angular.module('gfApp')
      .directive('taskInfo', function (taskInstanceService) {
        return {
          restrict: 'E',
          templateUrl: 'app/modules/siskin/taskinstance/info.directive.html',
          scope: true,
          bindToController:{
            task:"="
          },
          controllerAs:'vm',
          controller: function(){
            var vm = this;
            
            if(!vm.task.info){
                taskInstanceService.getInfo(vm.task.resource).then(function(data){
                  vm.data = data
                })
              }
          }
        }
      })
  })();
  
(function () {
  angular.module('gfApp')
    .controller('InboxController', function ($rootScope, $scope, $log, $timeout, $filter, debounce, $state, navigateTo, $stateParams, uriTemplate, dateTimeService,
                                             taskService, taskInboxService, taskInboxUnreadService, requestHelperService, permissionService, gfSiskinActions) {
      var vm = this

      var QUERY_TEMPLATE = uriTemplate.create('{?projectTemplateId,groupId,concernId,taskNames*,dueFrom,dueTo,claimState,mode}')
      var doQuery = debounce(searchInbox, 1000, false);
      var mode = $state.current.data.mode || QUERY_TEMPLATE.fromUri("?" + $stateParams.query).mode


      vm.openTask = openTask
      vm.claimTask = claimTask
      vm.unclaimTask = unclaimTask
      vm.markAllTasksRead = markAllTasksRead
      vm.view = view
      vm.viewAttributes = viewAttributes
      vm.toggleViewMode = toggleViewMode

      vm.pager = taskInboxService.pager
      vm.searchLoaded = false
      vm.searchData = taskInboxService.getSearch()
      vm.smartSearch = {
        onChange: smartSearchOnChange,
        refresh: smartSearchApplyFilter
      }
      vm.advancedSearch = {
        isVisible: false,
        onDateChange: onDateChange,
        taskState: {
          choices: ['all', 'new', 'claimed', 'unclaimed'],
          onSelect: taskStateOnChange
        }
      }

      if(angular.isUndefined(mode)){
        permissionService.can(gfSiskinActions.inboxCardModeDefault).then(function(val){
          vm.isListMode = !val
        })
      }else{
        vm.isListMode = mode === 'list'
      }

      permissionService.actionRedirect(activate)


      ///////

      function smartSearchOnChange() {
        taskInboxService.smartSearch.onChange()
        doQuery()
      }

      function smartSearchApplyFilter(s) {
        taskInboxService.smartSearch.applyFilter(s)
      }

      function onDateChange() {
        doQuery()
      }

      function taskStateOnChange() {
        doQuery()
      }

      function searchInbox() {
        var parameters = taskInboxService.search()
        addSearchQueryToUrl(parameters)
      }

      function addSearchQueryToUrl(preset) {
        preset.mode = vm.isListMode ? 'list' : 'tab'
        $state.go($state.current.name, {query: QUERY_TEMPLATE.toUri(preset).substring(1)}, {notify: false})
      }

      function markAllTasksRead() {
        taskInboxUnreadService.markAllTasksRead()
      }

      function toggleViewMode() {
        vm.isListMode = !vm.isListMode

        var parameters = taskInboxService.getSearchParameters()
        parameters.mode = vm.isListMode ? 'list' : 'tab'
        addSearchQueryToUrl(parameters)
      }

      function activate() {
        var preset = QUERY_TEMPLATE.fromUri("?" + $stateParams.query)

        taskInboxService.initialize(preset)
          .then(function (updatedPreset) {
            if (taskInboxService.advancedParametersSet()) {
              vm.advancedSearch.isVisible = true
            }

            addSearchQueryToUrl(updatedPreset)

            vm.searchLoaded = true;
          })

        var unsub = $rootScope.$on('inboxTask:completed', function (event, completedTaskId) {
          $log.debug('InboxController: complete task ' + completedTaskId)
          vm.pager.removeTask(completedTaskId)
        });
        $scope.$on('destroy', unsub)

        var newTask = $rootScope.$on('appNotificationHub:setUnreadTaskIds', setUnreadTaskIds);
        $scope.$on('$destroy', function(){
          newTask();
        })

        searchInbox();
      }

      function setUnreadTaskIds(event, data){
        if(data.refresh){
          taskInboxService.refreshPage()
        }
      }

      function openTask(task) {
        taskInboxService.open(task).catch(function () {
          vm.pager.removeTask(task.id)
        })
      }

      function claimTask(task) {
        taskService.claim(task).then(function () {
          task.claimed = true
          task.claimable = false;
          task.unclaimable = true;
        }).then(function () {
          openTask(task)
        })
      }

      function unclaimTask(task) {

        taskService.unclaim(task).then(function () {
          task.claimed = false
          task.claimable = true;
          task.unclaimable = false;
          if(task.tazk){
            task.tazk.close()
          }
        })
      }

      function view(projectTask) {
        $state.go('siskin.taskinstance', {taskInstanceId: projectTask.id})
      }

      function viewAttributes() {
        vm.pager.query.attributeType = 'MultipleFile'
        $state.go("siskin.taskinstancesattributes", {query: requestHelperService.getQuery('projectTasksAttributes', vm.pager.query)})
      }

    })
})();

(function () {
    angular.module('gfApp')
      .controller('TaskInstanceInteractiveController', controller)

    function controller($stateParams, $timeout, taskInstanceService, taskService,dataValueService, scrollingService) {
      var vm = this;

      vm.search = {}

      vm.complete = complete
      vm.hasError = hasError
      vm.close = close


      activate()

      ////

      function activate() {
        return taskInstanceService.getDetails($stateParams.taskInstanceId)
          .then(function (data) {
            vm.completedByUser = data.isCompleted && data.isAssignedToLoggedUser
            vm.notAccessible = (data.isCompleted && !data.isAssignedToLoggedUser) || ((!data.canUnclaim || !data.isAssignedToLoggedUser) && !data.canClaim)

            vm.loaded = angular.isUndefined($stateParams.action)
            vm.data = data
            vm.data.dataValues.forEach(function (g) {
              g.data.forEach(function (dv) {
                dv.field.readonly = !vm.data.canPerformTaskAction || dv.field.readonly
                dv.readonly = !vm.data.canPerformTaskAction || dv.readonly
              })
            })

            vm.data.note = ''

            // ---- perform interactive task logic

            // if not accessible: cannot perform any action
            if(vm.notAccessible){
              return
            }

            // automatically claim
            if(data.canClaim){
              return claim().then(autoComplete)
            }else{
              return autoComplete()
            }
          })
      }

      function autoComplete(){
        if($stateParams.action && vm.data.canPerformTaskAction){
           return complete(vm.data.actions.filter(function(a){return a.name === $stateParams.action})[0], false)
        }
      }

      function complete(action, scrollToError) {
        var result = taskService.isCompleteWithActionValid(vm.data, action.name)

        vm.noteRequired = result.noteRequired

        if(result.fieldsRequired || result.noteRequired){
          if(scrollToError){
            $timeout(function(){
              scrollingService.scrollToError()
            },1)
          }

          vm.loaded = true
          return
        }

        return taskService.completeWithAction(vm.data, action.name)
          .then(function () {
            vm.loaded = true
            vm.completedByUser = true
        })
      }


      function hasError(dv) {
        return angular.isDefined(dv.highlightRequiredAction) && dv.highlightRequiredAction !== '' && !dataValueService.hasValue(dv)
      }

      //////

      function claim(){
        var task = {
        id: vm.data.id,
        claimable: vm.data.canClaim,
        unclaimable: vm.data.canUnclaim,
        state: vm.data.status,
        resource: vm.data.resource
        }

        return taskService.claim(task).then(activate)
      }
    }
  })();

(function () {
  angular.module('gfApp')
    .controller('TaskInstanceDetailController', controller)

  function controller($stateParams, $log, $timeout, $state, noteControllerFactory, taskInstanceService, taskService, categories,
    modalService, requestHelperService, dataValueService, projectInstanceDetailService,
    reportCreateControllerFactory, errorHelperService, permissionService, gfSiskinActions, configService,scrollingService) {
    var vm = this;

    vm.search = {}

    vm.decimalsLength = configService.appSettings.decimalsLength
    vm.notaspecialgroup = notaspecialgroup
    vm.complete = complete
    vm.noteAdd = noteAdd
    vm.hasError = hasError
    vm.createReport = createReport
    vm.activeTaskViewModel = activeTaskViewModel
    vm.claim = claim
    vm.unclaim = unclaim
    vm.moreInfo = moreInfo

    vm.reportData = {}
    vm.reportData.activeTasks = null
    vm.reportData.dueOn = null

    activate()

    ////

    function activate() {
      return taskInstanceService.getDetails($stateParams.taskInstanceId)
        .then(function (data) {
          vm.data = data
          vm.data.dataValues.forEach(function (g) {
            g.data.forEach(function (dv) {
              dv.field.readonly = !vm.data.canPerformTaskAction || dv.field.readonly
              dv.readonly = !vm.data.canPerformTaskAction || dv.readonly
            })
          })

          vm.query = requestHelperService.getQuery('projectTasks', {
            storeId: data.storeId,
            projectTemplateId: data.projectTemplateId
          })
          $timeout(function(){
            vm.active = vm.data.dataValues.length == 0 ? 0 : 1
          })
        })
        .catch(function(){
          vm.error = true
        })
    }

    function notaspecialgroup(group) {
      if (angular.isUndefined(group.type) || group.data.some(function(a){return !a.readonly})) {
        return true
      }

      return categories.specialcategories.indexOf(group.type) === -1
    }

    function complete(action) {
      var result = taskService.isCompleteWithActionValid(vm.data, action.name)

      if(result.fieldsRequired){
        return
      }

      if (result.noteRequired) {
        noteAdd(action)
        return
      }

      $log.debug('normal complete behaviour')
      vm.isBusy = true;
      taskService.completeWithAction(vm.data, action.name)
        .then(function () {

          permissionService.can(gfSiskinActions.externalView).then(function(can){
            if(can){
              $state.reload()
            }else{
              $state.go('siskin.projectinstancedetail', {projectInstanceId: vm.data.projectId})
            }
          })
        }).finally(function(){
          vm.isBusy = false;
        })
    }

    function noteAdd(action) {
      modalService.open(noteControllerFactory(vm.data, action, function(){complete(action)}))
    }

    function hasError(dv) {
      return angular.isDefined(dv.highlightRequiredAction) && dv.highlightRequiredAction !== '' && !dataValueService.hasValue(dv)
    }

    function activeTaskViewModel(activeTask) {
      var vm = this;
      vm.reportData.dueOn = activeTask.dueOn

      if (activeTask.$has('assignedto')) {
        activeTask.$request().$get('assignedto')
          .then(function (user) {
            vm.reportData.assignedTo = user
          })
          .catch(function (e) {
            throw "Cannot get user the task is assigned to: " + errorHelperService.formatError(e);
          })
      }
    }

    function createReport(){

      $stateParams.projectInstanceId = vm.data.projectId;

      projectInstanceDetailService.get($stateParams.projectInstanceId)
      .then(function (data) {
        vm.reportData.data = data

        dataValueService.getDataValuesByGroup(data.resource, function (dv) {
          return dv.categoryName
        }, function (dv) {
          return dv.categoryListOrder
        }, function (dv) {
          return dv.categoryType
        }, function (dv) {
          return dv.categoryId
        }).then(function(data){
          vm.reportData.data.attributeGroups = data.groups
          vm.reportData.data.dataValues = data.dataValues
        })

        modalService.open(reportCreateControllerFactory(vm.reportData.data))
      })

    }

    function claim(){
      if(vm.data){
        var task = {
          id: vm.data.id,
          claimable: vm.data.canClaim,
          unclaimable: vm.data.canUnclaim,
          state: vm.data.status,
          resource: vm.data.resource
        }

        vm.isBusy = true;
        taskService.claim(task).then(function(){
          return activate();
        }).finally(function(){
          vm.isBusy = false;
        })
      }
    }

    function unclaim(){
      if(vm.data){
        var task = {
          id: vm.data.id,
          claimable: vm.data.canClaim,
          unclaimable: vm.data.canUnclaim,
          state: vm.data.status,
          resource: vm.data.resource
        }

        vm.isBusy = true;
        taskService.unclaim(task).then(function(){
          return activate()
        }).finally(function(){
          vm.isBusy = false;
        })
      }
    }

    function moreInfo(){
      vm.active = 0;
      $timeout(function(){
        scrollingService.scrollTo(angular.element(".note"), 100);
      })
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('ReportsController', controller)

  function controller(reportService, projectTemplateService) {
    var vm = this


    vm.select = select
    vm.reload = reload
    vm.download = download

    vm.search = {}
    vm.projects = []

    activate()

    ////

    function activate(){
      vm.pager = projectTemplateService.getPager(true);
    }

    function select(m){
      m.pvalue = !m.pvalue

      if(angular.isDefined(m.attributes)){
        angular.forEach(m.attributes, function(a){
          a.pvalue = m.pvalue
        })
      }

      if(m.type === 'attribute'){
        angular.forEach(vm.data.categories, function(c){
          if(c.attributes.indexOf(m) >= 0){
            c.pvalue = c.attributes.length === c.attributes.filter(function(m){return m.pvalue}).length
          }
        })
      }
    }

    function reload(){
      if(!vm.projects.length){
        vm.data = undefined
        return
      }

      vm.busy = true
      reportService.get(vm.projects.map(function(m){return m.id}))
        .then(function(data){
          vm.data = data
        })
        .finally(function(){
          vm.busy = false
        })
    }

    function download(){
      reportService.download(vm.data, { dataItems : vm.data.all.filter(function(m){return m.pvalue && m.id})})
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('WorkflowInstanceController', controller)

  function controller($stateParams,$timeout, $state, workflowInstanceService, workflowInstanceGoJsService, notificationService) {
    var vm = this

    vm.select = select
    vm.startWizard = startWizard
    vm.stopWizard = stopWizard
    vm.selectedEntity = selectedEntity
    vm.updateMilestone = updateMilestone
    vm.refresh = refresh

    workflowInstanceGoJsService.init()
    vm.flowchart = workflowInstanceGoJsService.flowchart

    var forbiddenTypes = ['start']

    activate()

    /////

    function activate(selectFirst){
      vm.wizard = new Wizard(vm.flowchart)

      return workflowInstanceService.getByProject($stateParams.projectId)
        .then(function(data){
          if(!data.allWorkflows.length){
            $state.go('siskin.projectinstancedetail', {projectInstanceId: $stateParams.projectId})
          }else{
            vm.data = data
            vm.wizard.milestones = data.milestones
            if(selectFirst !== false) select(vm.data.workflow.instances[0])
          }
        })
    }

    function refresh(){
      vm.isBusy = true
      var previousId =  angular.isUndefined(vm.selected) ? null : vm.selected.id

      return activate(false)
        .then(function(){
          if(!vm.data.allWorkflows.some(function(w){
            if(w.instances[0].id === previousId){
              select(w.instances[0])
              return true
            }
          })){
            select(vm.data.workflow.instances[0])
          }
        })
        .finally(function(){
          vm.isBusy = false
        })
    }

    function select(workflowInstance){
      if(angular.isDefined(vm.selected) && vm.selected != null && vm.selected.workflowInstance == workflowInstance){
        return
      }

      vm.selected = null

      if(angular.isUndefined(workflowInstance.flowData)){
        workflowInstanceService.getDetails(workflowInstance.resource)
          .then(function(data){
            workflowInstance.flowData = data

            data.completedProjectTasks.map(function(m){
              m.selected = workflowInstance.projectId !== m.projectId
            })
            updateCanvas(workflowInstance)
          })
      }else{
        updateCanvas(workflowInstance)
      }
    }

    function updateCanvas(workflowInstance){
      vm.wizard.preview = workflowInstance.flowData
      vm.wizard.completedProjectTasks = workflowInstance.flowData.completedProjectTasks
      vm.wizard.steps[1].display = vm.wizard.milestones.length > 0 || vm.wizard.completedProjectTasks.length > 0


      vm.selected = workflowInstance
      $timeout(function(){
        vm.flowchart.update(workflowInstance.flowData.flowData,
          {
            highlight: workflowInstance.flowData.currentActivityId,
            selectionChanged: selectedEntity
          })
      })
    }

    function selectedEntity(e){

      $timeout(function(){
        var node = e.diagram.selection.first();
        vm.wizard.to = null

        if(node == null || angular.isUndefined(node.data.category) || forbiddenTypes.indexOf(node.data.category) !== -1) return false

        vm.wizard.to = {key: node.data.key,name: node.data.text,category: node.data.category}

        vm.flowchart.diagram.nodes.each(function (n) {
          if (n.data.highlight === true)
            vm.wizard.from = {key: n.data.key,name: n.data.text,category: n.data.category}
        });
      })
    }

    function startWizard(){
      vm.wizard.hasStarted = vm.flowchart.diagram.allowSelect = true
      vm.wizard.init()
    }

    function stopWizard() {
      vm.wizard.hasStarted = vm.flowchart.diagram.allowSelect = false
    }

    function updateState(){
      vm.isBusy = true
      workflowInstanceService.rollback(vm.selected.resource,
        vm.wizard.to.key,
        vm.wizard.completedProjectTasks.filter(function(m){return m.selected}).map(function(m){return m.id}),
        vm.wizard.milestones.filter(function(m){return m.hasChanged}))
        .then(function(){
          $timeout(function(){
            vm.refresh().then(function(){
              notificationService.success('rollback.success');
              vm.isBusy = false
            })
          },2000) // notice this delay is necessary in order to give the API to process the workflow event (usually takes less than a second)
        })
        .catch(function(){
          notificationService.error('rollback.error')
          vm.isBusy = false
        })
    }

    function updateMilestone(m){
      if(m.isCompleted !== m.isCompletedPrevious){
        m.hasChanged = true
      }
    }

    //////////////////////////

    function Wizard(flowchart){
      var vm = this

      vm.from = null
      vm.to = null
      vm.showAll = false
      vm.current = null
      vm.init = function(){ vm.selectedTasks = [], vm.setCurrent(0) },
        vm.setCurrent = function ($index, byUser) {
          if(!byUser || vm.steps[$index].isCompleted){
            for(var i=$index;i<vm.steps.length;i++){
              vm.steps[i].isCompleted = false
            }

            if(!byUser && vm.current){
              vm.current.isCompleted = true
            }

            vm.current = vm.steps[$index]
            vm.current.init()
          }
        }
      vm.steps = [
        new Step('select', 'rollback.wizard.select', 'rollback.wizard.selectanactivity', 'rollback.wizard.next', function () {flowchart.allowSelect(false);
          vm.setCurrent((vm.steps[1].display)?1:2)}, function() { flowchart.allowSelect(true)}, function() { return vm.to }),
        new Step('history', 'rollback.wizard.history', 'rollback.wizard.hintstep', 'rollback.wizard.next', function () {vm.setCurrent(2)}),
        new Step('confirm', 'rollback.wizard.confirm', 'rollback.wizard.confirmation', 'rollback.wizard.rollback', updateState)
      ]
    }

    function Step(id, title, description, btnLabel, complete, init, valid) {
      var vm = this

      vm.id = id
      vm.title= title
      vm.description= description
      vm.btnLabel= btnLabel
      vm.complete= complete
      vm.display = true
      vm.init= init || function(){}
      vm.valid= valid || function(){return true}
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('roleSelectionControllerFactory', factory)

  function factory(projectInstanceRoleMappingService, notificationService) {
    return function (data,callback) {
      return {
        size:'lg',
        templateUrl: 'app/modules/siskin/projectinstance/roleselection.modal.html',
        controllerInit: function (vm) {

          vm.data = data
          vm.roles = []

          vm.init = init
          vm.save = save
          vm.changed = changed
          vm.isValid = isValid

          vm.busy = false

          init()

          ////

          function init() {
            vm.busy = true;
            projectInstanceRoleMappingService.get(vm.data.resource)
              .then(function (roles) {
                vm.roles = roles
                vm.busy = false
              })
          }

          function save() {
            vm.busy = true
            var update = true

            angular.forEach(vm.roles, function (role) {
              if (role.userOrGroup.length === 0) {
                notificationService.error('projectinstance.projectrolemapping.errorempty')
                update = false
              }
            })

            if (update) {
              projectInstanceRoleMappingService.update(vm.data.resource, vm.roles)
                .then(function (roles) {
                  angular.forEach(roles, function (r) {
                    if (r) {
                      vm.roles[vm.roles.findIndex(function (x) {
                        return x.id === r.id
                      })] = r
                    }
                  })
                  notificationService.success('projectinstance.projectrolemapping.updated')
                  vm.close()
                  callback(vm.roles)
                  vm.busy = false
                }).catch(function () {
              })
            }
            else{
              vm.busy = false
            }
          }

          function changed(role) {

            if (role.userOrGroup.findIndex(function (x) {
              return x.id === role.userOrGroup[role.userOrGroup.length - 1].id
            }) === role.userOrGroup.length - 1) {
              role.usersAssigned = []
              role.groups = []
              angular.forEach(role.userOrGroup, function (m) {

                if (m.type === 'user') {
                  role.usersAssigned.push(m)
                } else {
                  role.groups.push(m)
                }

              })
            } else {
              role.userOrGroup.pop()
            }
          }

          function isValid(){
            return !vm.roles.some(function(m) {return m.userOrGroup.length === 0});
          }
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('putonholdControllerFactory', factory)

	function factory(projectInstanceDetailService){
    return function (data,setActive){
      return {
        size: 'lg',
        templateUrl: 'app/modules/siskin/projectinstance/putonhold.modal.html',
        controllerInit: function (vm) {
          vm.message = ""
          vm.data = data

          vm.save = save

          function save() {
            if (data.isActive !== setActive) {
              data.isActive = setActive
              data.message = vm.message
              
              projectInstanceDetailService.update(vm.data.resource, data)
              .then(function(model){
                data.canStart = !model.startedOn && model.startingOn && !model.isActive
              })
            }
            vm.close()
          }
        }
      }
    }
	}
})();

(function () {
  angular.module('gfApp')
    .controller('projectInstanceListController', controller)
  function controller(permissionService, projectInstanceService) {
    var vm = this;

    vm.reset = reset
    vm.search ={}

    permissionService.actionRedirect(activate)

    ////

    function activate() {
      vm.pager = projectInstanceService.getPager({pageSize:10})
      vm.pager.defaultSearchCriteria = {}
      vm.pager.defaultSearchCriteria.showDeactivated = true

      vm.pager.reset(vm.search)

       projectInstanceService.getFilters().then(function(data){
         vm.filters =data

         if(vm.filters.attributes.length){
          vm.search.attributeIds =  vm.filters.attributes[0].id
         }

         reset()
       })
    }

    function reset() {
      vm.pager.reset(vm.search)
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('ProjectInstanceDetailController', controller)

  function controller($q, $scope, $stateParams, $window, $timeout, $state, projectInstanceDetailService, permissionService, errorHelperService, dataValueService, modalService,
                      reportCreateControllerFactory, taskService, noteContainerControllerFactory, concernService, roleSelectionControllerFactory, gfSiskinActions, configService, fileEndpointService, putonholdControllerFactory ) {

    var vm = this;

    vm.decimalsLength = configService.appSettings.decimalsLength
    vm.features = configService.appSettings.features
    vm.projectId = $stateParams.projectInstanceId
    vm.projectName = $stateParams.projectName
    vm.projectInstanceName = $stateParams.projectInstanceName
    vm.previousDv = {}
    vm.tabsLeft = false
    vm.active = null
    vm.showAttributes = false
    vm.showMetadata = false
    vm.showHistory = false
    vm.activeTasks = null
    vm.isEditing = false
    vm.dataModelCopy = null
    vm.concernPager = null
    vm.isDownloading = false

    vm.select = select
    vm.edit = edit
    vm.cancelEdit = cancelEdit
    vm.persist = persist
    vm.back = back
    vm.createReport = createReport
    vm.toggleAttributes = toggleAttributes
    vm.toggleMetadata = toggleMetadata
    vm.toggleHistory = toggleHistory
    vm.claim = claim
    vm.downloadAllImages = downloadAllImages
    vm.showPutOnHoldModal = showPutOnHoldModal
    vm.showNotesModal = showNotesModal
    vm.showRolesModal = showRolesModal
    vm.editProjectInstanceDetails = editProjectInstanceDetails
    vm.update = update
    vm.remove = remove

    permissionService.actionRedirect(activate)

    ////

    function activate() {

      projectInstanceDetailService.get(vm.projectId)
        .then(function (data) {
          vm.data = data
          vm.data.entityType="projectInstance"

          $timeout(function () {
            if ($window.innerWidth < 450) {
              vm.active = null;
            }
            vm.isInit = true;
          }, 1)
        })
        .catch(function (e) {
          vm.error = true;
          throw "Cannot get project: " + errorHelperService.formatError(e);
        });

      $scope.$on('appNotificationHub:setUnreadTaskIds', updateActiveTasks)

      permissionService.canAnd([gfSiskinActions.projectInstanceHistoryView,gfSiskinActions.projectInstanceStagesView, gfSiskinActions.projectInstanceRolesView]).then(
        function(val){
          vm.style = {
            reverse: !val,
            fullwidth: !val
          }
          vm.showAttributes = vm.style.fullwidth
        }
      )

    }

    function updateActiveTasks(){
      projectInstanceDetailService.get(vm.projectId)
        .then(function(data){
          vm.data.activeTasks = data.activeTasks
          vm.data.history = data.history
          vm.nextMilestoneName = data.nextMilestoneName
        })
    }

    function select(group) {
      if (angular.isDefined(vm.previousSelected)) {
        vm.previousSelected.active = false;
      }

      vm.previousSelected = group;
      group.active = true;
    }

    function edit(group, dataValue) {
      dataValue.editError = false;
      dataValue.field.$request().$get('draft')
        .then(function (dv) {
          updateDisplay(group, dataValue, dv);
        })
        .catch(function (e) {
          dataValue.editError = true;
          throw 'cannot get draft ' + errorHelperService.formatError(e);
        })
    }

    function cancelEdit(group, dataValue) {
      var g = vm.data.attributeGroups[vm.data.attributeGroups.indexOf(group)];
      var index = g.data.indexOf(dataValue);
      g.data[index] = dataValue.prev;
    }

    function remove() {
      projectInstanceDetailService.remove(vm.data.resource)
      .then(modalService.dismissAll)
      .then(function(){
        $state.go("siskin.project",{projectId:vm.data.resource.projectId})
      })
    }

    function persist(group, dataValue) {
      if (dataValue.isBusyFn()) {
        return;
      }

      dataValue.persistError = false;
      dataValue.field.$request().$post('self')
        .then(function (data) {
          if (data.$has('dataValue')) {
            return data.$request().$get('dataValue');
          } else {
            return null;
          }
        })
        .then(function (dvs) {
          persistCallback(dataValue, dvs, group)
        })
        .catch(function (e) {
          dataValue.persistError = true;
          throw 'Cannot persist datavalue ' + errorHelperService.formatError(e);
        });
    }

    function persistCallback(dataValue, dvs, group) {
      angular.forEach(dvs, function (dv) {
        if (!dv.$hasLink('current')) {
          // -- if draft is unmodified and has no current, persist
          // -- will not create current link will not exist.
          // -- Cancel editing instead
          cancelEdit(group, dataValue);
        } else {
          dv.$request().$get('current')
            .then(function (current) {
              var uiDv = group.data.filter(function (m) {
                return m.name === dv.name;
              });

              if (uiDv.length === 1) {
                updateDisplay(group, uiDv[0], current);
              }
            })
            .catch(function (e) {
              throw 'Cannot get current from datavalue ' + errorHelperService.formatError(e);
            });
        }
      })
    }

    function updateDisplay(group, uiDv, dv) {
      var promises = [];
      var wrapper = dataValueService.createDataValueWrapper(dv, promises);
      wrapper.prev = uiDv;

      $q.all(promises)
        .then(function () {
          var g = vm.data.attributeGroups[vm.data.attributeGroups.indexOf(group)];
          var index = g.data.indexOf(uiDv);
          g.data[index] = wrapper;
        })
    }

    function back() {
      vm.active = null;
    }

    function createReport(){
      modalService.open(reportCreateControllerFactory(vm.data))
    }

    function downloadAllImages(){
      vm.isDownloading = true;
      fileEndpointService.downloadFromResource(vm.data.resource).finally(function(){
        vm.isDownloading = false;
      });
    }

    function toggleMetadata(){
      vm.showMetadata = !vm.showMetadata;
    }

    function toggleAttributes(){
      vm.showAttributes = !vm.showAttributes;
    }

    function toggleHistory(){
      vm.showHistory = !vm.showHistory;
    }

    function showPutOnHoldModal(status) {
      modalService.open(putonholdControllerFactory(vm.data,(status!=='onHold')))
    }

    function showNotesModal() {
      modalService.open(noteContainerControllerFactory(vm.data, gfSiskinActions.projectInstanceNotesEdit))
    }


    function claim(m){
      if(m){
        var task = {
          id: m.resource.id,
          claimable: m.resource.claimable,
          unclaimable: m.resource.unclaimable,
          state: m.resource.state,
          resource: m.resource
        }

        m.isBusy = true;
        taskService.claim(task).then(function(){
          $state.go('siskin.taskinstance', {taskInstanceId: task.id})
        }).finally(function(){
          m.isBusy = false;
        })
      }
    }

    function showRolesModal() {
      modalService.open(roleSelectionControllerFactory(vm.data, roleAssignmentCallback))
    }

    function editProjectInstanceDetails() {
      vm.isEditing = true
      vm.dataModelCopy = angular.copy(vm.data)
      vm.dataModelCopy.concern = {id: vm.dataModelCopy.concernId, name: vm.dataModelCopy.concernName}
      vm.concernPager = concernService.pager()
    }

    function roleAssignmentCallback(roles){
      vm.data.roleAssignment = roles
    }

    function update() {
      vm.dataModelCopy.concernId = vm.dataModelCopy.concern.id

      projectInstanceDetailService.update(vm.data.resource, vm.dataModelCopy)
        .then(function (data) {
          vm.data.concernId = data.concernId
          vm.data.concernName = data.concernName
          vm.data.concernAddress= data.concernAddress
          vm.data.projectInstanceName = data.name
          vm.data.name = data.name
          vm.isEditing = false
        })
    }

  }
})
();

(function () {
  angular.module('gfApp')
    .factory('reportCreateControllerFactory', factory)

  function factory($document, $stateParams, $timeout, projectInstanceReportService, configService, reportContainerService, projectInstanceDetailService) {
    return function (instance) {
      return {
        size: 'lg',
        templateUrl: 'app/modules/siskin/projectinstance/create.report.modal.html',
        controllerAs: 'vm',
        controllerInit: function (vm) {
          vm.data = instance
          vm.search = {}

          vm.filterApprovedFiles = {}
          vm.displayEmptyCategories = {}
          vm.showDraftValues = {}
          vm.filterApprovedFiles = {pvalue:true}

          vm.presetsAll = []
          vm.all = instance.attributeGroups.concat(instance.dataValues)
          vm.templatesPager = reportContainerService.pager()
          vm.step = 0

          vm.select = select
          vm.presetLoaded = presetLoaded
          vm.create = create
          vm.next = next
          vm.back = back
          vm.print = print
          vm.showDraftValuesChanged = showDraftValuesChanged

          vm.apiFileUrl = configService.api.app + "/file/public?path=reporttemplates%2F"

          activate()

          preselect(vm.all, instance)

          ////////////////

          function activate() {
            vm.isAnyUnapproved = vm.data.attributeGroups.some(function (m) {
              return m.data.some(function(a) {return angular.isDefined(a.content) && a.content.some(function (f) {
                  return !f.isApproved
                })})
            })
          }

          function preselect(items, instance) {
            if (!instance.skipItemPreselect) {
              angular.forEach(items, function (item) {
                if (item.hasOwnProperty('selector')) {
                  return; // skip preselection for report template type
                }
                select(item, true);
              });

              instance.skipItemPreselect = true;
            }
          }

          function select(m, value) {
            var val = angular.isDefined(value) ? value : !m.pvalue

            m.pvalue = val

            if (angular.isDefined(m.data)) {
              angular.forEach(m.data, function (a) {
                select(a, val)
              })
            }

            if (angular.isDefined(m.content)) {
              angular.forEach(m.content, function (a) {
                select(a, val)
              })
            }

            if (angular.isUndefined(m.content) && angular.isUndefined(m.data)) {
              angular.forEach(vm.data.attributeGroups, function (c) {
                if (c.data.indexOf(m) >= 0) {
                  c.pvalue = c.data.length === c.data.filter(function (m) {
                      return m.pvalue
                    }).length
                }
              })
            }
          }

          function create() {
            var model = {
              template: vm.report.name,
              filterApprovedFiles: vm.filterApprovedFiles.pvalue === true,
              displayEmptyCategories: vm.displayEmptyCategories.pvalue === true,
              showDraftValues: vm.showDraftValues.pvalue === true,
              projectId: $stateParams.projectInstanceId,
              versionedDataValues: vm.data.dataValues.filter(function (m) {
                return m.pvalue
              })
                .map(VersionedDataValueDao)
            }

            if(configService.appSettings.features.supportApproveImages){
              model.filterApprovedFiles = vm.filterApprovedFiles.pvalue === true
            }

            projectInstanceReportService.getData(vm.data.resource, model)
              .then(function (data) {
                vm.daoData = data
                next()
              })
          }

          function print() {
            var reportName = vm.report.pvalue+"-"+instance.projectInstanceName

            vm.printing = true
            projectInstanceReportService.getReport({html: $document[0].getElementsByClassName('report-body')[0].innerHTML}, reportName)
              .finally(function(){
                vm.printing = false
              })
          }

          function next() {
            if (vm.step < 1)
              vm.step++
          }

          function back() {
            if (vm.step > 0)
              vm.step--
          }

          // force select all files after preset is loaded: files shouldn't be saved in the preset, since its id change
          // everytime new files are loaded
          function presetLoaded() {
            var selected = vm.data.dataValues.filter(function (m) {
              return m.pvalue
            })
            angular.forEach(selected, function (m) {
              select(m, m.pvalue)
            })
          }

          function VersionedDataValueDao(m) {
            return {
              id: m.versionedDataValueId,
              fileIds: angular.isDefined(m.content) ? m.content.filter(function (f) {
                  return f.pvalue
                }).map(function (f) {
                  return f.id
                }) : []
            }
          }

          function showDraftValuesChanged(){
            var showDraftValues = vm.showDraftValues.pvalue === true

            projectInstanceDetailService.get(vm.data.id, showDraftValues)
            .then(function (data) {
              var oldData = vm.data;
              vm.data = data

              $timeout( function(){

                //reselect old selected fields
                angular.forEach(oldData.attributeGroups, function (group) {
                  var index = findWithAttr(vm.data.attributeGroups,"id",group.id);
                    if(index > -1){
                      vm.data.attributeGroups[index].pvalue = group.pvalue;

                      angular.forEach(group.data, function (field) {
                        var indexField = findWithAttr(vm.data.attributeGroups[index].data,"versionedDataValueId",field.versionedDataValueId);
                        if(indexField > -1){
                          vm.data.attributeGroups[index].data[indexField].pvalue = field.pvalue;
                          select(vm.data.attributeGroups[index].data[indexField], field.pvalue)
                        }
                      })

                    }
                });

            }, 1 );

            })
          }

          function findWithAttr(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('projectInstanceCreateControllerFactory', factory)

  function factory($state, storeService, projectInstanceService, fileEndpointService, gfSiskinActions, notificationService, configService) {
    return function (data) {
      return {
        size: 'lg',
        templateUrl: 'app/modules/siskin/projectinstance/create.modal.html',
        permissionAction: gfSiskinActions.projectTemplateStartInstance,
        controllerInit: function( vm) {
          var projectTemplate = data

          storeService.initialize({defaultSearchCriteria: {clientId : data.clientId}},Store)

          vm.features = configService.appSettings.features
          vm.concernPager = storeService.pager
          vm.file = {}

          //////////////////

          projectInstanceService.getTemplate(data)
            .then(function(data){
              vm.data = data
              vm.data.isActive = true
            })

          vm.save = function () {
            if(vm.data.isActive) {
              vm.data.startingOn = null
            }

            vm.isBusy = true
            projectInstanceService.create(vm.data)
              .then(function (data) {
                if(angular.isDefined(data)){
                  $state.go('siskin.projectinstancedetail', {projectInstanceId: data.id})
                }else{
                  notificationService.success('projectinstances.instance.successnoaccess')
                }
                vm.close()
              })
              .catch(function (m) {
                vm.error = m
              })
              .finally(function(){
                vm.isBusy = false
              })
          }

          vm.changed = function(role){
            role.usersAssigned = []
            role.groups = []

            angular.forEach(role.userOrGroup, function(m){
              if(m.type === 'user'){
                role.usersAssigned.push(m)
              }else{
                role.groups.push(m)
              }
            })
          }

          vm.getStores = function(exportTemplate){
            fileEndpointService.download('projecttemplate-stores-excel', projectTemplate, {exportTemplate: exportTemplate})
          }

          vm.upload = function() {
            if(vm.file.data.length > 0){
              vm.uploadingValidation = null
              vm.uploading = true
              vm.error = false

              fileEndpointService.upload('projecttemplate-stores-excel', projectTemplate, vm.file.data[0])
                .then(function(data){
                  vm.uploadingValidation = data.data
                })
                .catch(function(){
                  vm.error = true
                })
                .finally(function(){
                  vm.uploading = false
                  vm.file = {}
                })
            }
          }

          vm.addMetaData = function () {
            if (vm.data) {
              if (!vm.data.projectMetaData) {
                vm.data.projectMetaData = [];
              }
              vm.data.projectMetaData.push({ name: "", data: "" });
            }
          }

          vm.removeMetaData = function (metaData) {
            if (vm.data) {
              var index = vm.data.projectMetaData.indexOf(metaData);
              vm.data.projectMetaData.splice(index, 1);
            }
          }

          function Store(resource){
            return {
              resource : resource,
              id : resource.id,
              name : resource.name + (resource.address !== "" ? " - " : "") + resource.address
            }
          }
        }

      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('projectUpdateControllerFactory', factory)

  function factory(projectTemplateService) {
    return function (data) {
      return {
        templateUrl: 'app/modules/siskin/project/list.update.html',
        controllerInit: function (vm) {
          vm.original = data
          vm.data = angular.copy(data)
          vm.data.resource = data.resource

          vm.save = function () {
            projectTemplateService.update(vm.data)
              .then(function (data) {
                vm.original.name = data.name
                vm.close()
              })
              .catch(function (m) {
                vm.error = m
              })
          }
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('ProjectListController', controller)

  function controller($state, projectTemplateService, clientService, modalService,
                      projectInstanceCreateControllerFactory,projectCreateControllerFactory, projectUpdateControllerFactory, dateTimeService, configService, pagerService) {
    var vm = this;

    vm.features = configService.appSettings.features
    vm.search = {}

    vm.update = update
    vm.create = create
    vm.createInstance = createInstance
    vm.deactivate = deactivate
    vm.restore = restore
    vm.remove = remove
    vm.reset = reset
    vm.downloadProjectTemplates = downloadProjectTemplates
    vm.resetDates = resetDates

    activate()

    ////

    function activate() {
      if($state.current.data.dateFromThisYear){
        vm.search.dateFrom = dateTimeService.currentYear()
      }
      clientService.initialize()

      vm.pager = projectTemplateService.getPager({append:false})
      vm.pager.defaultSearchCriteria = {}
      vm.pager.reset(vm.search)

      if($state.current.data.showDeactivated){
        vm.pagerDeactivated = projectTemplateService.getPager({append:false})
        vm.pagerDeactivated.defaultSearchCriteria = { isActive: false }
        vm.pagerDeactivated.reset(vm.search)
    }
      

      vm.clientPager = clientService.pager
    }

    function resetDates() {
      vm.search.query = null
      vm.search.dateFrom = null
      vm.search.dateTo = null
      reset();
    }

    function reset() {
      vm.pager.reset(vm.search)

      if(vm.pagerDeactivated){
        vm.pagerDeactivated.reset(vm.search)
      }
    }

    function create($event) {
      $event.stopPropagation()
      modalService.open(projectCreateControllerFactory())
    }

    function createInstance($event, projectTemplate) {
      $event.stopPropagation()
      modalService.open(projectInstanceCreateControllerFactory(projectTemplate))
    }

    function update($event, projectTemplate) {
      $event.stopPropagation()
      modalService.open(projectUpdateControllerFactory(projectTemplate))
    }

    function deactivate(projectTemplate) {
      projectTemplate.isActive = false
      projectTemplateService.update(projectTemplate).then(function(){
        modalService.dismissAll()
        vm.reset()
      })
    }

    function restore(projectTemplate) {
      projectTemplate.isActive = true
      projectTemplateService.update(projectTemplate).then(function(){
        modalService.dismissAll()
        vm.reset()
      })
    }

    function remove(projectTemplate) {
      vm.pagerDeactivated.remove(projectTemplate)
    }

    function downloadProjectTemplates(){
      var filter = angular.extend({},vm.search);
      pagerService.normalizeFilter(filter)

      projectTemplateService.getReport(filter);
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('ProjectDetailController', controller)
  function controller($state, $stateParams,
                      configService, modalService, projectAttributesControllerFactory, projectInstanceCreateControllerFactory,
                      projectAttributesAclsControllerFactory,projectAttributesBatchUpdateControllerFactory, noteContainerControllerFactory,
                      emailSettingsControllerFactory,workflowPreviewControllerFactory,
                      projectTemplateService, permissionService, fileEndpointService, gfSiskinActions,licensingService) {
    var vm = this;
    vm.widgets = configService.appSettings.dashboards.project.controls

    vm.createInstance = createInstance
    vm.attributesAcls = attributesAcls
    vm.attributesExportImport = attributesExportImport
    vm.attributesBatchUpdate = attributesBatchUpdate
    vm.downloadAllImages = downloadAllImages
    vm.deactivate = deactivate
    vm.restore = restore
    vm.deleteProjectTemplate = deleteProjectTemplate
    vm.showNotesModal = showNotesModal
    vm.showEmailSettingsModal = showEmailSettingsModal
    vm.viewWorkflow = viewWorkflow
    vm.isDownloading = false;

    permissionService.actionRedirect(activate)

    ////

    function activate() {
      projectTemplateService.getDetail($stateParams.projectId)
        .then(
          function (data) {
            vm.data =data
            vm.data.entityType="projectTemplate"
            if (!data.totalProjectInstances && !licensingService.license.isExpiredInGracePartialBlock) {
              createInstance()
            }
          }
        )
    }

    function createInstance() {
      modalService.open(projectInstanceCreateControllerFactory(vm.data))
    }

    function attributesExportImport() {
      modalService.open(projectAttributesControllerFactory(vm.data))
    }

    function attributesAcls() {
      modalService.open(projectAttributesAclsControllerFactory(vm.data))
    }

    function attributesBatchUpdate() {
      modalService.open(projectAttributesBatchUpdateControllerFactory(vm.data))
    }

    function downloadAllImages(){
      vm.isDownloading = true;
      fileEndpointService.downloadFromResource(vm.data.resource).finally(function(){
        vm.isDownloading = false;
      });
    }

    function deleteProjectTemplate() {
      projectTemplateService.remove(vm.data.resource)
      .then(modalService.dismissAll)
      .then(function(){
        $state.go("siskin.projectlist")
      })
    }

    function deactivate() {
      vm.data.isActive = false
      return projectTemplateService.update(vm.data)
    }

    function restore() {
      vm.data.isActive = true
      return projectTemplateService.update(vm.data)
    }

    function showNotesModal() {
      modalService.open(noteContainerControllerFactory(vm.data, gfSiskinActions.projectTemplateNotesEdit))
    }

    function showEmailSettingsModal(){
      modalService.open(emailSettingsControllerFactory(vm.data))
    }

    function viewWorkflow(){
      modalService.open(workflowPreviewControllerFactory(vm.data.resource))
    }

  }
})();

(function () {
  angular.module('gfApp')
    .factory('projectCreateControllerFactory', factory)

  function factory($state, clientService, workflowEntityService, metaDataEntityService, projectTemplateService, emailDigestSettingsService, configService) {
    return function () {
      return {
        templateUrl: 'app/modules/siskin/project/list.create.html',
        controllerInit: function (vm) {

          clientService.initialize()
          workflowEntityService.initialize()

          vm.clientPager = clientService.pager
          vm.workflowValues = workflowEntityService.workflows
          vm.projectTypePager = metaDataEntityService.pager("ProjectType")
          vm.brandPager = metaDataEntityService.pager("Brand")
          vm.features = configService.appSettings.features

          vm.data = {}

          // handle no metadata entities yet set
          vm.brandPager.onItemsFetched = function () {
            if(vm.brandPager.searchCount === 1){
              vm.noBrands = vm.brandPager.items.length === 0
            }
          }

          vm.projectTypePager.onItemsFetched = function () {
            if(vm.projectTypePager.searchCount === 1){
              vm.noProjectTypes = vm.projectTypePager.items.length === 0
            }
          }

          vm.save = function () {
            vm.isBusy = true
            vm.error = null
            projectTemplateService.create(vm.data)
              .then(function (data) {
                emailDigestSettingsService.initalizeProjectEmailTemplates(data.id)
                $state.go('siskin.project',{projectId:data.id})
                vm.close()
              })
              .catch(function (m) {
                vm.error = m
              })
              .finally(function(){
                vm.isBusy = false
              })
          }
        }

      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('noteContainerControllerFactory', factory)

  function factory(noteContainerService, permissionService){
    return function (data,editPermission){
      return {
        size: 'lg',
        templateUrl: 'app/modules/siskin/noteContainer/noteContainer.modal.html',
        controllerInit: function (vm) {
          vm.message = ""
          vm.data = data
          vm.notes = []
          vm.files = []

          vm.init = init
          vm.edit = edit
          vm.create = create
          vm.update = update
          vm.remove = remove
          vm.selectNote = selectNote
          vm.showNewNoteForm = showNewNoteForm
          vm.cancelEdit = cancelEdit

          vm.allCompletedCallback = allCompletedCallback
          vm.addOrUpdateFile = addOrUpdateFile
          vm.startProcess = startProcess
          vm.endProcess = endProcess

          vm.canEditNotes =false

          vm.sortableOptions = {
            disabled: false,
            stop: function (e, ui) {
              var array = vm.notes
              if (ui.item.sortable.model.isFileNote) {
                array = vm.files
              }
              angular.forEach(array, function (m, key) {
                var neworder = array.indexOf(m)
                if (m.displayOrder !== neworder) {
                  var copy = angular.copy(m)
                  copy.displayOrder = neworder
                  noteContainerService.update(m.resource, copy)
                    .then(function (updated) {
                      array[key].displayOrder = updated.displayOrder
                    })
                }
              })
            }
          }

          init()

          /////

          function init() {
            noteContainerService.getNotes(vm.data.resource)
              .then(function (notes) {
                vm.notes = notes.filter(function (n) {
                  return !n.isFileNote
                })
                vm.files = notes.filter(function (n) {
                  return n.isFileNote
                })
              })

            permissionService.can(editPermission).then(function(can){
              vm.sortableOptions.disabled = !can
              vm.canEditNotes = can
            })
          }

          function edit(note){
            vm.editNote = note
            vm.noteCopy = angular.copy(note)
          }

          function create(){
            noteContainerService.create(vm.editNote,vm.data).then(function(created){
              vm.notes.push(created)
              vm.noteSelected = created
              cancelEdit()
            })
          }

          function update() {
            noteContainerService.update(vm.editNote.resource, vm.noteCopy)
              .then(function(updated){
                vm.editNote.title = updated.title
                vm.editNote.body = updated.body
                cancelEdit()
              })
          }

          function remove(note) {
            return noteContainerService.remove(note.resource).then(function(){
              cancelEdit()
              if(!note.isFileNote){
                vm.noteSelected = null
                vm.notes.splice(vm.notes.indexOf(note), 1)
              }else{
                vm.fileSelected = null
                vm.files.splice(vm.files.indexOf(note), 1)
              }
            })
          }

          function selectNote(note){
            note.isFileNote? vm.fileSelected = note :  vm.noteSelected = note
            vm.editNote = null
          }

          function showNewNoteForm(){
            var note = {
              title: "",
              body: "",
              isFileNote: false,
              displayOrder: vm.notes.length,
              resource: null
            }
            vm.editNote = note
            vm.noteCopy = note
            vm.activeTab = 0
          }

          function cancelEdit(){
            vm.noteCopy = null
            vm.editNote = null
          }

          // file upload
          function allCompletedCallback() {
            vm.activeTab = 1
            vm.isBusy = false
          }

          function addOrUpdateFile(data) {
            data = data.resource || data.fileResource.resource
            if(data.$hasEmbedded('note')){
              data.$request().$get('note').then(function(n){
                var note = noteContainerService.maps.Note(n)
                vm.fileSelected = note
                vm.files.push(note)
              })
            }else if(data.isUploaded === true){
              for (var i = 0; i < vm.files.length; i++) {
                for(var j = 0;j< vm.files[i].fileList.length;j++){
                  if(vm.files[i].fileList[j].id === data.id){
                    noteContainerService.get(vm.files[i].resource).then(function(m){
                      vm.fileSelected = vm.files[i-1] = m
                    })
                  }
                }
              }
            }
          }

          function startProcess() {
            vm.isBusy = true
          }

          function endProcess() {
            vm.false = true
          }

        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('noteControllerFactory', factory)

  function factory(taskNotesService, pagerService) {
    return function (data, action, callback) {
      return {
        size: 'lg',
        templateUrl: 'app/modules/siskin/note/note.create.html',
        controllerInit: function (vm) {
          var task = data
          vm.note = ''
          vm.action = action

          if(data.resource.$has('projectrolemappings')){
            vm.projectRoleMappingsPager = new pagerService.Pager({
              resource: data.resource,
              initialRel: 'projectrolemappings',
              dataRel: 'projectrolemapping',
              mapper: ProjectRoleMapping,
              nextPageRel: 'next',
              pageSize: 0
            })
          }

          vm.save = function () {
            taskNotesService.sendNoteForTask(task, vm.note, false, vm.projectRoleMappings)
              .then(function (data) {
                task.history.push(data)
                task.lastNote = data
                if (angular.isDefined(action) && angular.isDefined(callback)) {
                  callback()
                }
                vm.close()
              })
              .catch(function (m) {
                vm.error = m
              })
          }

          function ProjectRoleMapping(resource){
            return {
              resource: resource,
              id: resource.id,
              name: resource.name
            }
          }
        }
      }
    }
  }
})();


(function () {
    angular.module('gfApp')
      .controller('SystemMonitoringController', controller)
  
    function controller($rootScope, permissionService, projectTemplateService) {

      var vm = this;

      vm.filter = {};
      vm.projectTemplates = []

      vm.search = search

      permissionService.actionRedirect(activate)
  
      function activate() {
        projectTemplateService.getAll().then(function(data){
          vm.projectTemplates.push.apply(vm.projectTemplates, data);
        })
      }  

      function search() {
        $rootScope.$broadcast('$dashboardSearch');
      }
    }
  })();

(function () {
  angular.module('gfApp')
    .controller('MetaDataEntityListController', controller)

  function controller($state, permissionService, metaDataEntityService, modalService, metaDataEntityCreateControllerFactory,metaDataEntityDeleteControllerFactory) {

    var type = $state.current.data.metaDataEntityType
    var vm = this;

    vm.type = type
    vm.search = {}

    vm.create = create
    vm.edit = edit
    vm.remove = remove
    vm.update = update
    vm.cancel = cancel
    vm.reset = reset

    permissionService.actionRedirect(activate)

    ////

    function activate() {
      vm.pager = metaDataEntityService.pager(type,false)
      vm.pager.reset()
      modalService.dismissAll()
    }

    function create() {
      modalService.open(metaDataEntityCreateControllerFactory({type:type}, onCreateCallback))
    }

    function onCreateCallback(metaDataEntity){
      vm.pager.items.push(metaDataEntity)
    }

    function edit(model) {
      model.edit = angular.copy(model)
      model.edit.resource = model.resource
    }

    function remove(model) {
      modalService.open(metaDataEntityDeleteControllerFactory(model, onDeleteCallback))
    }

    function onDeleteCallback(metaDataEntity){
      vm.pager.items.splice(vm.pager.items.indexOf(metaDataEntity), 1 );
    }

    function update(model) {
      metaDataEntityService.update(model.edit)
      .then(function (metaDataEntity) {
        vm.pager.items[vm.pager.items.indexOf(model)] = metaDataEntity;
      })
    }

    function cancel(model) {
      clearEditting(model)
    }

    function clearEditting(model){
      model.edit = null
    }

    function reset() {
      vm.pager.reset(vm.search)
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('metaDataEntityDeleteControllerFactory', factory)

  function factory(metaDataEntityService, notificationService) {
    return function (data, callback) {
      return {
        templateUrl: 'app/modules/siskin/metaDataEntity/list.delete.html',
        controllerInit: function (vm) {

          vm.data = data

          vm.remove = function () {
            metaDataEntityService.remove(vm.data)
              .then(function () {
                vm.close()
                callback(vm.data)
              })
              .catch(function (m) {
                vm.error = m

                notificationService.error(m.data.split(','));
              })
          }
        }

      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('metaDataEntityCreateControllerFactory', factory)

  function factory($state, metaDataEntityService, notificationService) {
    return function (data, callback) {
      return {
        templateUrl: 'app/modules/siskin/metaDataEntity/list.create.html',
        controllerInit: function (vm) {
          
          vm.data = data

          vm.save = function () {
            metaDataEntityService.create(vm.data)
              .then(function (data) {
                vm.close()
                callback(data);
              })
              .catch(function (m) {
                vm.error = m
                notificationService.error("metadataentity.create.error");
              })
          }
        }

      }
    }
  }
})();

(function () {
  angular.module("gfApp").controller("LicensingController", controller);

  function controller(licensingService, permissionService) {
    var vm = this;

    permissionService.actionRedirect(activate)

    ////////

    function activate(){
      vm.data = licensingService.license
    }
  }
})();

(function(){
  angular.module('gfApp')
    .controller('IntegrationApiController',controller)

  function controller(permissionService, integrationService){
    var vm = this;

    vm.getStatusClass = getStatusClass;
    vm.onRetryTaskClicked = onRetryTaskClicked;
    vm.refreshData = refreshData;
    vm.reset= reset;
    vm.downloadPayload = integrationService.downloadPayload;
    vm.onRequestExpandClicked = onRequestExpandClicked;
    vm.search = search;

    setDefaultValues();
    onRequestExpandClicked(null);

    permissionService.actionRedirect(refreshData)

    function search(){
      vm.searchRequestInput.pageNumber = 1;
      refreshData();
    }

    function reset(){

      setDefaultValues()

      refreshData();
    }


    function refreshData(){

      vm.busy= true;

      if(vm.createdOnInputFilter.startDate &&  vm.createdOnInputFilter.endDate){
        vm.searchRequestInput.createdFrom = vm.createdOnInputFilter.startDate.format();
        vm.searchRequestInput.createdTo = vm.createdOnInputFilter.endDate.format();
      }else{
        vm.searchRequestInput.createdFrom= null;
        vm.searchRequestInput.createdTo=null;
      }

      if(vm.selectedStatusOption != vm.statusOptions[0]){
        vm.searchRequestInput.status = vm.selectedStatusOption
      }else{
        vm.searchRequestInput.status = null;
      }

      integrationService.getAll(vm.searchRequestInput).then(function(data){
        vm.data = data;
        vm.busy= false;
      })
    }

    function onRequestExpandClicked(requestKey){
      vm.expandedRequestKey = vm.expandedRequestKey == requestKey ? null:  requestKey
    }

    function onRetryTaskClicked(task){
      integrationService.retryTask(task.alternateKey).then(function(){
        refreshData();
      })
    }

    function getStatusClass(status){
      switch(status){
        case 'Completed':
          return "primary";
        case 'Failed':
          return "danger";
        case 'Pending':
          return "warning";
          default:
            return "default"
      }
    }

    function setDefaultValues(){
      vm.statusOptions = [
        "All",
        "Pending",
        "Completed",
        "Failed"
      ]

      vm.selectedStatusOption = vm.statusOptions[0]

      vm.createdOnInputFilter = {
        startDate: null,
        endDate: null
      };

      vm.searchRequestInput ={
        pageSize: 10,
        pageNumber: 1,
        status: null,
        createdFrom: null,
        createdTo: null,
        searchTerm:null
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('HomeController', controller)

  function controller() {

    activate()

    ////

    function activate(){

    }

  }
})();

(function () {
  angular.module('gfApp')
    .controller('EmailTemplateListController', controller)

  function controller($timeout, permissionService, emailTemplateService, emailTemplateCreateControllerFactory, notificationService, modalService, userProfileService) {
    var vm = this;

    vm.search = {}
    vm.selectedtask = null
    vm.active = false

    vm.selectProject = selectProject
    vm.selectTask = selectTask
    vm.selectEmailTemplateType = selectEmailTemplateType
    vm.selectEmailTemplate = selectEmailTemplate
    vm.selectLanguage = selectLanguage
    vm.save = save
    vm.change = change
    vm.updateName = updateName
    vm.remove = remove
    vm.send = send
    vm.preview = preview
    vm.addValue = addValue
    vm.canDelete = canDelete
    vm.back = back
    vm.create = create
    vm.removeEmailTemplateType = removeEmailTemplateType

    permissionService.actionRedirect(activate)

    ////

    function activate() {
      emailTemplateService.get()
        .then(function (data) {
          vm.data = data

          $timeout(function () {
            vm.selected = vm.data.global
            vm.selectProject()
          })
        })

      userProfileService.userLoaded
        .then(function (user) {
          vm.userEmail = user.email
        })
    }

    function selectProject(){
      vm.emailTemplateType = undefined
      vm.selectedtask = null

      if(vm.selected){
      emailTemplateService.getProjectTemplates(vm.selected)
        .then(function (m) {
          vm.active = true
          vm.selected.settings = m.settings
          vm.selected.emailTemplateTypes = m.emailTemplateTypes
          emailTemplateService.getTaskTemplates(m).then(function(data){
            vm.selected.taskTemplates = data.taskTemplates
          })
          vm.totalCustomTemplates = vm.selected.emailTemplateTypes.filter(function(t){return t.type==='custom' && t.name!==""}).length
        })}
      else{
        vm.selected = vm.data.global
        selectProject()
      }
    }

    function selectTask() {
      vm.emailTemplateType = undefined
      if (vm.selectedtask) {
        emailTemplateService.getProjectTemplates(vm.selectedtask)
          .then(function (m) {
            vm.selected.settings = m.settings
            vm.selected.emailTemplateTypes = m.emailTemplateTypes
          })
      }else{
        vm.selected.taskTemplates = null
        selectProject()
      }
    }

    function selectEmailTemplate(emailTemplate) {
      vm.emailTemplate = emailTemplate

      $timeout(function(){
        vm.preview(emailTemplate)
      })
    }

    function selectEmailTemplateType(emailTemplateType) {
      vm.emailTemplateType = emailTemplateType
      vm.selectLanguage(vm.emailTemplateType.emailTemplatesByLanguage[0])
    }

    function selectLanguage(language){
      vm.language = language

      vm.selectEmailTemplate(vm.language.value.filter(function(e){return e.channel === 'email'})[0])
    }

    function save(emailTemplate) {
      emailTemplate.saving = true
      emailTemplateService.save(emailTemplate)
        .then(function(data){
          emailTemplate.resource = data.resource
          emailTemplate.id = data.id
          emailTemplate.changed = false
          emailTemplate.saving = false
        })
    }

    function change(emailTemplate) {
      emailTemplate.changed = true
      preview(emailTemplate)
    }

    function updateName(emailTemplateType){
      emailTemplateService.rename(emailTemplateType).then(function(){emailTemplateType.renaming = false})
    }

    function remove(emailTemplate) {
      emailTemplateService.remove(emailTemplate)
        .then(function (data) {
          vm.language.value[vm.language.value.indexOf(emailTemplate)] = data

          var nextAvailableLanguage = vm.emailTemplateType.emailTemplatesByLanguage.find(
            function (l) {
              return l.value.find(
                function (m) {
                  return m.id > 0
                }
              )
            }
          )
          if (nextAvailableLanguage) {
            vm.currentTab = vm.selectLanguage(nextAvailableLanguage)
          } else {
            back()
          }
        })
    }

    function back() {
      vm.emailTemplateType = undefined
      vm.selectedtask ? selectTask() : selectProject()
    }

    function send(emailTemplate) {
      vm.busy = true

      emailTemplateService.send(emailTemplate.sendEmail || vm.userEmail, emailTemplate)
        .then(function () {
          notificationService.success('emailtemplates.sendsuccess')
        })
        .catch(function () {
          notificationService.error('emailtemplates.senderror')
        })
        .finally(function(){
          vm.busy = false
        })
    }

    function preview(emailTemplate) {
      emailTemplateService.getPreview(emailTemplate)
        .then(function(data){
          emailTemplate.preview = data.preview
        })
    }

    function addValue(value) {
      if(angular.isDefined(value)){
        vm.emailTemplate.body = value + ' ' +  (vm.emailTemplate.body || '')
        preview(vm.emailTemplate)
      }
    }

    function canDelete(emailTemplate){
      return emailTemplate.id && !(emailTemplate.isGlobal && (!emailTemplate.language || emailTemplate.language === 'en-GB'))
    }

    function create(){
      var byType = angular.extend({},vm.selected.emailTemplateTypes.find(function(t){return t.type==="custom" && t.name===""}))
      var emptyTemplateCopies = byType.emailTemplates.map(function(m){
          return angular.extend({},m)
        })
      byType.emailTemplates = emptyTemplateCopies
      
      modalService.open(emailTemplateCreateControllerFactory(emptyTemplateCopies, function(data){
        byType.name = data[0].name
        byType.refresh()

        vm.selected.emailTemplateTypes.push(byType)
        selectEmailTemplateType(byType)
      }))
    }

    function removeEmailTemplateType(){
      emailTemplateService.removeEmailTemplateType(vm.emailTemplateType)
      .then(modalService.dismissAll).then(vm.back)
    }
  }
})();

(function () {
  angular.module('gfApp')
    .factory('emailTemplateCreateControllerFactory', factory)

  function factory(emailTemplateService, notificationService) {
    return function (data, callback) {
      return {
        templateUrl: 'app/modules/siskin/emailtemplate/list.create.html',
        controllerInit: function (vm) {
          var templates = data

          vm.save = function () {
            angular.forEach(templates,function(m){m.name = vm.name})
            var defaultTemplate = templates[0]

            emailTemplateService.save(defaultTemplate)
              .then(function (data) {
                templates[0] = data
                vm.close()
                callback(templates);
              })
              .catch(function (m) {
                vm.error = m
                notificationService.error("emailtemplates.create.error");
              })
          }
        }

      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('DownloadExternalController', controller)

  function controller($state, $stateParams, fileService, fileEndpointService) {
    var vm = this
    vm.loaded = false;
    vm.hasError = false;

    activate();

    function activate() {
      var fileId = $stateParams.fileId;
      var url = $state.current.data.url;
      var showFileName = $state.current.data.showFileName;

      if(showFileName){
        fileService.get(fileId).then(function(file) {
          vm.file = file;
        })
      }
      
      fileEndpointService.download(url, undefined, {fileId: fileId}).then(function () {
        vm.loaded = true;
      }).catch(function () {
        vm.hasError = true;
        vm.loaded = true;
      });
    }
  }
})();

(function(){
  angular.module('gfApp')
    .controller('DocumentationController',controller)

  function controller(permissionService, fileContainerService){
    var vm = this

    vm.create = create
    vm.update = update
    vm.remove = remove

    permissionService.actionRedirect(activate)

    ////////

    function activate(){
      fileContainerService.getAll()
        .then(function(data){
          vm.data = data
        })
    }

    function create(){
      fileContainerService.create({name: 'Name',description: 'Description'})
        .then(function(data){
          vm.data.push(data)
        })
    }

    function update(m){
      fileContainerService.update(m)
    }

    function remove(m){
      fileContainerService.remove(m)
        .then(function(){
          vm.data.splice(vm.data.indexOf(m),1)
        })
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('ConcernDetailController', controller)

  function controller($stateParams, concernService, errorHelperService, colors) {
    var vm = this

    vm.concernId = $stateParams.storeId
    vm.filter = {}

    init()

    /////

    function init() {
      concernService.get(vm.concernId)
      .then(function(data) {
        vm.data = data

        if(angular.isDefined(data.coordinates)){
            var coordinates = { lat:isNaN(data.coordinates.latitude) ? 0 : data.coordinates.latitude, lng: isNaN(data.coordinates.longitude) ? 0 : data.coordinates.longitude }
            
            vm.maps = {
              center: angular.extend({},coordinates, {zoom:14}),
              markers: [angular.extend({},coordinates, {markerColor: colors.map.default})]
            }
        }
      })
      .catch(function (e) {
        vm.error = true;
        throw "Cannot get concern: " + errorHelperService.formatError(e);
      });
    }
  }
})();

(function () {
  angular.module('gfApp')
    .controller('ClientDashboardController', controller)

  function controller($stateParams, $translate, $state, colors, configService, clientService, permissionService,
    projectTemplateService, moment, gfSiskinActions) {
    var vm = this;

    vm.active = false;
    vm.data = {};
    vm.clients = [{name: $translate.instant("common.all"), resource: {id: 0, name: $translate.instant("common.all")}}];
    vm.charts = {};
    vm.charts.overview = {};
    vm.charts.milestoneOverview = [];
    vm.charts.projectOverview = {};
    vm.colors = {inProgress: colors.overdue, completed: colors.completed}
    vm.defaultClientId = null;
    vm.projectTemplates = []

    var startOfThisYear = moment().startOf('year');
    var today = moment();

    permissionService.can(gfSiskinActions.clientView).then(function(can){
        if(can){
          vm.widgets = configService.appSettings.dashboards.client.controls
          vm.showProjectTemplateFilter = configService.appSettings.dashboards.client.showProjectTemplateFilter
        }
        else{
          vm.widgets = configService.appSettings.dashboards.default.controls
        }
      })

    vm.isLoading = isLoading

    vm.search = search
    vm.resetDateFilter = resetDateFilter

    vm.dateFilter = null
    vm.filters = {
      selectedClient : null,
      dateRange:{},
      projectTemplateId: null
    }

    permissionService.actionRedirect(activate);

    function activate() {

      vm.defaultClientId = $stateParams.clientId
      vm.defaultStartDate = $stateParams.startDate
      vm.defaultEndDate = $stateParams.endDate
      vm.defaultProjectTemplateId = $stateParams.projectTemplateId

      permissionService.can(gfSiskinActions.dashboardView).then(function (val) {
        if (!val) {
          permissionService.can(gfSiskinActions.inboxCardModeDefault).then(function (v) {
            $state.go(v ? 'siskin.inbox' : 'siskin.taskinstances')
          })
        }
      })

      clientService.initialize()

      projectTemplateService.getAll().then(function(data){
        vm.projectTemplates.push.apply(vm.projectTemplates, data);
      })

      vm.pager = clientService.pager
      vm.pager.reset().then(function (data) {

        vm.clients = vm.clients.concat(data)

        if (data.length > 0) {

          vm.filters.selectedClient = vm.clients[0];

          if (vm.defaultClientId) {
            angular.forEach(vm.clients, function (client) {
              if (client.id === vm.defaultClientId) {
                vm.filters.selectedClient = client
              }
            });
          }
        }
        vm.active = true
      })

      if(vm.defaultStartDate && new Date(vm.defaultStartDate)){
        vm.filters.dateRange.startDate = moment(vm.defaultStartDate)
      }else{
        vm.filters.dateRange.startDate = startOfThisYear
      }

      if(vm.defaultEndDate && new Date(vm.defaultEndDate)){
        vm.filters.dateRange.endDate = moment(vm.defaultEndDate)
      }else{
        vm.filters.dateRange.endDate = today
      }

      vm.filters.projectTemplateId = vm.defaultProjectTemplateId
    }

    function isLoading() {
      return vm.active === false;
    }

    function search() {
      var startDate = (vm.filters.dateRange && vm.filters.dateRange.startDate) ? vm.filters.dateRange.startDate.toJSON() : null;
      var endDate = (vm.filters.dateRange && vm.filters.dateRange.endDate) ? vm.filters.dateRange.endDate.toJSON() : null

      $state.go('siskin.dashboard', {
        clientId: vm.filters.selectedClient !== null ? vm.filters.selectedClient.id : null,
        startDate: startDate,
        endDate: endDate,
        projectTemplateId: vm.filters.projectTemplateId
      })
    }

    function resetDateFilter(){
      vm.dateFilter = null

      vm.filters.dateRange = {
        startDate: null,
        endDate : null
      }
      search()
    }

  }
})();




(function () {
    angular.module("gfApp").controller("AdministrationController", controller);
  
    function controller($timeout, permissionService, projectInstanceService, moment) {
        var vm = this;
  
        vm.createProjectsBatch = createProjectsBatch
        vm.count = 1;
        vm.totalCount = 0;
        vm.repeat = false;
        vm.res = [];
        vm.hoursToAdd = 1;
        vm.intervalSeconds = 0;

        permissionService.actionRedirect(activate)
    
        ////////
    
        function activate(){
            
        }

        function createProjectsBatch() {
            var toCreate = vm.count;
            $timeout(function(){vm.busy = true},1);
            projectInstanceService.createBulk(toCreate, vm.projectTemplateId, (vm.startDate ? vm.startDate.toJSON() : undefined)).then(function(){
                vm.totalCount += toCreate;
                vm.res.push({count: toCreate, date: moment()})
                if(vm.repeat) {
                    if(vm.startDate)
                        vm.startDate = moment(vm.startDate).add(vm.hoursToAdd,'hours')

                    $timeout(createProjectsBatch, vm.intervalSeconds * 1000)
                }
            }).finally(function(){vm.busy = false;});
        }
    }
})();
  
/*global UriTemplate:false*/
(function (u) {
  angular.module('gfApp')
  // Wrapper service around some external thing able to do this
  // Tried using https://github.com/LuvDaSun/rfc6570 which fails (ironically, as we're using the guy's lib for hal)
    .service('uriTemplate', function () {
      this.create = function (p) {
        return new UriTemplate(p)
      }
    })

  function UriTemplate(template) {
    var uriTemplate = new u(template);
    this.toUri = uriTemplate.fill
    this.fromUri = uriTemplate.fromUri
  }

})(UriTemplate);

(function () {
  // https://stackoverflow.com/a/13320016
  angular.module('gfApp')
    .factory('debounce', function ($timeout, $q) {
      // The service is actually this function, which we call with the func
      // that should be debounced and how long to wait in between calls
      return function debounce(func, wait, immediate) {
        var timeout;
        // Create a deferred object that will be resolved when we need to
        // actually call the func
        var deferred = $q.defer();
        return function () {
          var context = this, args = arguments;
          var later = function () {
            timeout = null;
            if (!immediate) {
              deferred.resolve(func.apply(context, args));
              deferred = $q.defer();
            }
          };
          var callNow = immediate && !timeout;
          if (timeout) {
            $timeout.cancel(timeout);
          }
          timeout = $timeout(later, wait);
          if (callNow) {
            deferred.resolve(func.apply(context, args));
            deferred = $q.defer();
          }
          return deferred.promise;
        };
      };
    });
})();

(function () {
  angular.module('gfTranslationModule', ['gfAppCore', 'pascalprecht.translate'])
    .config(translations)
    .run(setFallbackLanguage)

  function translations($translateProvider, gfTranslationUpdaterProvider, gfTranslationMapServiceProvider) {
    //$translateProvider.fallbackLanguage('en-GB') // Moved to run to avoid circular dependency
    $translateProvider.useLoader('gfTranslateLanguageLoader')

    if (angular.isUndefined(gfTranslationMapServiceProvider.translateProviderKeys)
      || angular.isUndefined(gfTranslationMapServiceProvider.translateProviderAliases)) {
      throw "The keys and aliases are required"
    }
    $translateProvider.registerAvailableLanguageKeys(
      gfTranslationMapServiceProvider.translateProviderKeys,
      gfTranslationMapServiceProvider.translateProviderAliases
    )

    gfTranslationUpdaterProvider.translations = $translateProvider.translations();
    $translateProvider.useSanitizeValueStrategy('escape')
  }

  function setFallbackLanguage($translate, gfTranslationMapService) {

    // Avoids a circular dependency. The alternative is to use this in angular.config
    if (angular.isUndefined(gfTranslationMapService.fallbackLanguage)) {
      throw "Fallback language undefined"
    }
    $translate.fallbackLanguage(gfTranslationMapService.fallbackLanguage)
  }
})();

(function () {
  angular.module('gfTranslationModule')
    // Match the existing translate directive, which means we'll share scope
    .directive('translateAttr', gfTranslateDirective)
    .directive('translate', gfTranslateDirective)

  function gfTranslateDirective($parse, $templateRequest, $compile, $rootScope, $timeout) {
    return {
      restrict: 'A',
      link: function ($scope, element, attributes) {

        $scope.gfTranslate = {
          toggle: toggle,
          mask: undefined,
          popover: {
            key: getKey(),
            mask: undefined
          }
        }

        activate();

        ////////////

        var ub_toggle, ub_translationSaved;

        function getKey() {
          var keys = []
          if (angular.isDefined(attributes.translateAttr)) {
            var keyValuePairs = $parse(attributes.translateAttr)()
            angular.forEach(keyValuePairs, function (value) {
              keys.push(value)
            });
          } else {
            keys.push(getEvaluated(element))
          }

          if (keys.length !== 1) {
            // Have a hard time imagining this is required
            throw "Can support exactly one translate directive but found " + keys.length
          }

          return keys[0]
        }

        function getEvaluated(element){
          var possibleExpression = element[0].innerHTML;
          if(!possibleExpression.startsWith('{{')){
            return element[0].innerHTML
          } else {
            return $scope.$eval(possibleExpression.slice(2, -2))
          }
        }

        function calculateMaskPositions() {
          var elementDrawInfo = element[0].getBoundingClientRect();
          var maskPosition = {
            top: elementDrawInfo.top,
            left: elementDrawInfo.left,
            width: elementDrawInfo.width,
            height: elementDrawInfo.height
          }
          $scope.gfTranslate.mask = maskPosition;
          $scope.gfTranslate.popover.mask = maskPosition
        }

        function toggle() {
          $rootScope.$broadcast("event:gfTranslation-elementselected", $scope.gfTranslate.popover)
        }

        function activate() {

          ub_toggle = $rootScope.$on('event:gfTranslation-toggled', function (event, isActive) {
            if (isActive) {

              calculateMaskPositions()

              $templateRequest('app/modules/translationModule/translationMask.html').then(function (html) {
                angular.element('.js-translation-mask-insert').after($compile(html)($scope));
              });

              ub_translationSaved = $rootScope.$on('event:gfTranslation-saved', function (/*event, data*/) {
                $timeout(calculateMaskPositions);
              })

              // TODO: While this satisfies some use-cases, the resizing of the sidebar also has an effect on positioning
              //       which will need to be bound to separately. I think it makes sense to have an post-resize broadcast
              //       that can take care of issues like this, because its own calculations are already bound to the resize
              //       and load window events. It's possible however, that all of that is done in CSS, in which case it will
              //       need a different approach.

              // angular.element(window).bind("resize", function () {
              //   calculatePositions()
              // })
            } else {
              ub_translationSaved()
            }
          });

          $scope.$on('destroy', function () {
            ub_toggle();
            ub_translationSaved();
          })
        }
      }
    }
  }
})();

(function () {
  angular
    .module('gfTranslationModule')
    .provider('gfTranslationUpdater', function () {
      var me = this;
      me.translations = {};

      var apiUpdateTranslation = function (rootResource, locale, key, value) {
        var rel = 'translation';
        var urlParams = {locale: locale}
        var body = {data: {}};
        body.data[key] = value
        return rootResource.$request().$patch(rel, urlParams, body)
      }

      this.$get = function ($translate, $translationApi, $q, gfTranslationMapService) {

        return {
          translations: me.translations,
          update: function (key, value, l) {
            var locale = l || $translate.use()

            value = normalize(locale, value)

            return $translationApi
              .then(function (apiRoot) {
                return apiUpdateTranslation(apiRoot, locale, key, value)
              })
              .then(function () {
                me.translations[locale][key] = value
              })
          },

          loadAll: function () {
            var currentKey = $translate.use()
            return $q.all([$translate.use('en-GB'),
              $translate.use('fr-FR'),
              $translate.use('de-DE'),
              $translate.use('ru-RU'),
              $translate.use('es-ES')]).then(function () {
              return $translate.use(currentKey)
            })
          }
        }

        function normalize(locale, value){
          if(!angular.isString(value) || value.length < 2)
          {
            if (locale === gfTranslationMapService.fallbackLanguage) {
              return '__'
            } else {
              return null
            }
          }

          return value
        }

      };
    })
})();

(function () {
  angular.module('gfTranslationModule')
    .controller('gfTranslationPopoverController', function ($scope, $rootScope, $log, $translate, $document, $window, gfTranslationUpdater) {
        var vm = this;
        vm.save = save
        vm.show = false;

        activate();

        ////////////

        var ACTUALSIZE = {
          WIDTH: 276,
          HEIGHT: 88
        }

        function activate() {

          var unbindSelected = $rootScope.$on("event:gfTranslation-elementselected", selected)
          var unbindToggle = $rootScope.$on('event:gfTranslation-toggled', function () {
            // Always reset on initial switch into or out of translation mode
            vm.show = false;
          })

          $scope.$on('destroy', function () {
            unbindSelected();
            unbindToggle()
          })
        }

        function selected(event, popoverData) {
          calculatePopoverPosition(popoverData)
          vm.key = popoverData.key;
          vm.translation = popoverData.translation;
          $translate(vm.key)
            .then(function (value) {
              vm.value = value
              vm.show = true;
            })
            .catch(function (failed) {
              vm.value = failed
              vm.show = true;
            })
        }

        function calculatePopoverPosition(popoverData) {
          var maskPosition = popoverData.mask

          var space_on_top = maskPosition.top;
          var space_on_bottom = $window.innerHeight - maskPosition.top - maskPosition.height;
          var space_on_left = maskPosition.left;
          var space_on_right = $window.innerWidth - maskPosition.left - maskPosition.width;

          var options = [
            {px: space_on_top, pos: 'top'},
            {px: space_on_bottom, pos: 'bottom'}
          ];

          if (!(space_on_bottom < ACTUALSIZE.HEIGHT / 2 || space_on_top < ACTUALSIZE.HEIGHT / 2)) {
            options.push({px: space_on_left, pos: 'left'})
            options.push({px: space_on_right, pos: 'right'})
          }


          vm.direction = options.sort(function (a, b) {
            return b.px - a.px
          })[0].pos;

          vm.pos = calculateOffset(vm.direction, maskPosition, ACTUALSIZE.WIDTH, ACTUALSIZE.HEIGHT)
        }

        // @formatter:off
        function calculateOffset(placement, pos, actualWidth, actualHeight) {
          var offset = placement === 'bottom' ? {
            top: pos.top + pos.height,
            left: pos.left + pos.width / 2 - actualWidth / 2
          } :
            placement === 'top' ? {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2} :
              placement === 'left' ? {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth} :
                /* placement === 'right' */ {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width}

          if (offset.left < 0) {
            offset.left = 0;
          }
          return offset;
        }

        // @formatter:on

        function save(value) {

          gfTranslationUpdater.update(vm.key, value).then(function () {
            // Causes the translation directive to update data
            $rootScope.$broadcast('$translateChangeSuccess')
            $rootScope.$broadcast('event:gfTranslation-saved')
            vm.show = false;
          });
        }
      }
    )
})();

(function () {
  angular
    .module('gfTranslationModule')
    /**
     * Provides a common way to access language definitions for translation-dependent components
     */
    .provider('gfTranslationMapService', function () {

      var FALLBACK_LANGUAGE = 'en-GB'
      var provider = this;
      provider.knownLanguages = {}
      provider.translateProviderKeys = []
      provider.translateProviderAliases = {}
      provider.$get = factory

      init();
      initTranslateProviderKeys();
      initTranslateProviderAliases();

      ////////////

      function factory() {
        return {
          fallbackLanguage: FALLBACK_LANGUAGE,
          getLanguages: function () {
            return provider.knownLanguages
          }
        }
      }

      function init() {
        provider.knownLanguages['en-GB'] = new Language('en-GB', 'English', 'United-Kingdom.png')
        provider.knownLanguages['fr-FR'] = new Language('fr-FR', 'French', 'France.png')
        provider.knownLanguages['de-DE'] = new Language('de-DE', 'German', 'Germany.png')
        provider.knownLanguages['ru-RU'] = new Language('ru-RU', 'Russian', 'Russia.png')
        provider.knownLanguages['es-ES'] = new Language('es-ES', 'Spanish', 'Spain.png')
      }

      function initTranslateProviderKeys() {
        angular.forEach(provider.knownLanguages, function (value, key) {
          provider.translateProviderKeys.push(key)
        })
      }

      function initTranslateProviderAliases() {
        angular.forEach(provider.knownLanguages, function (value, key) {
          if (key === FALLBACK_LANGUAGE) {
            provider.translateProviderAliases['*'] = FALLBACK_LANGUAGE
          } else {
            provider.translateProviderAliases[key] = key
          }
        })
      }

      function Language(key, name, icon) {
        this.key = key;
        this.name = name;
        this.icon = 'assets/images/flags/16/' + icon;
      }
    })
})();

(function () {
  angular.module('gfTranslationModule')
    .controller('gfTranslationController', function ($rootScope, $log, $document, $scope) {

      var vm = this;
      vm.isActive = false;

      activate();

      ////////////

      function activate() {
        $document.bind('keydown', function (e) {
          // IE likes Alt + T so use Ctrl + Alt + T
          if (e.key.toLowerCase() === "t" && e.altKey && e.ctrlKey) {
            e.stopPropagation();

            $scope.$evalAsync(function () {
              vm.isActive = !vm.isActive
              $rootScope.$broadcast('event:gfTranslation-toggled', vm.isActive);
              $log.debug(vm.isActive ? 'translation mode on' : 'translation mode off')
              if (!vm.isActive) {
                angular.element('.js-translation-target').remove()
              }
            })
          }
        });
      }
    })
})();

(function () {
  angular
    .module('gfTranslationModule')
    .service('gfTranslateLanguageLoaderTracker', function ($q) {
      this.translationsLoaded = $q.defer()
    })
    .factory('gfTranslateLanguageLoader', function ($log, $translationApi, gfTranslateLanguageLoaderTracker) {
      return function (options) {
        return $translationApi
          .then(function (rootResource) {
            return rootResource.$request().$get('translation', {locale: options.key})
          }).then(function (translations) {
            $log.debug("translate: downloaded '" + options.key + "'")
            gfTranslateLanguageLoaderTracker.translationsLoaded.resolve();
            return translations.data;
          }).catch(function (err) {
            gfTranslateLanguageLoaderTracker.translationsLoaded.reject(err)
          })
      };
    })
})();

(function () {
  angular.module('tazkModule', [])
})();

(function () {
  angular.module('tazkModule')
    .service('tazkService', function () {

      this.tryAddNewTazkViewModel = tryAddNewTazkViewModel
      this.on = on    // Used by tazk controller to perform layouts
      this.off = off  // Used by tazk controller to perform layouts

      ///////

      // This service hosts all the task interaction logic
      var eventListeners = [];
      var tazks = [];         // View models

      function tryAddNewTazkViewModel(tazkViewModel) {
        if (angular.isUndefined(tazkViewModel)) {
          throw "The 'tazkViewModel' was undefined";
        } else if (tazkViewModel === null) {
          throw "The 'tazkViewModel' was null";
        }
        if (angular.isUndefined(tazkViewModel.id)) {
          throw "Tried creating a tazkViewModel with 'undefined' id";
        } else if (tazkViewModel.id === null) {
          throw "Tried creating a tazkViewModel with null id";
        }

        // Don't create duplicate tasks
        var t = null;
        angular.forEach(tazks, function (task) {
          if (task.id === tazkViewModel.id) {
            fireCreateEvent(task);
            t = task;
            return;
          }
        });

        if (t == null) {
          fireCreateEvent(tazkViewModel);
          t = tazkViewModel;
        }

        tazks.push(t);
        return t;
      }

      function on(listener, func) {
        if (listener !== 'showTazk') {
          throw "Only the 'showTazk' even is fired by this component";
        }

        eventListeners.push(func);
      }

      function off(listener, func) {
        if (listener !== 'showTazk') {
          return; // "Only the 'showTazk' even is fired by this component";
        }

        for (var i = 0; i < eventListeners.length; i++) {
          if (eventListeners[i] === func) {
            eventListeners.splice(i, 1);
            return;
          }
        }
      }

      function fireCreateEvent(task) {
        angular.forEach(eventListeners, function (eventListener) {
          try {
            eventListener(task);
          } catch (e) {
            // Someone forgot to disconnect an even listener
          }
        });
      }

    })
})();

// TODO: Move all specific functionality out of here. This should be responsible for outline display and mode-switching only

(function () {
  angular.module('tazkModule')
    .directive('gfTazk', gfTazk)

  function gfTazk($rootScope, $log, $timeout, taskService, notificationService, errorHelperService) {
    return {
      templateUrl: 'app/modules/tazkModule/tazk.directive.html',
      restrict: 'E',
      controllerAs: 'vm',
      bindToController: {
        tazk: "="
      },
      controller: controllerFunc
    }

    ////////

    function controllerFunc() {

      var inboxTaskBehaviours = ['fields', 'notes']
      var customerChatBehaviours = ['customerChat']
      var behaviours = []
      var defaultBehaviour = behaviours[0]

      var vm = this;
      // TODO: Once raf merges the code from his refactor of the task services, remove the
      //       "refreshDetails" approach, which will make it possible to block and unblock the data when actually
      //       required
      vm.tazk.isBlocked = false
      // This will be one of the supported types of tasks that can be
      // displayed. Wizards and other complex scenarios should also be
      // supported
      vm.noteOnly = false
      vm.displaySavingSpinner = false;
      vm.switchToBehaviour = switchToBehaviour
      vm.doClaim = doClaim
      vm.isDefaultBehaviour = isDefaultBehaviour
      vm.switchToDefaultBehaviour = function () {
        switchToBehaviour(defaultBehaviour)
      }
      vm.behaviour = ''
      vm.complete = complete
      vm.unclaim = unclaim
      vm.optionalItemsUrl = false

      activate()

      ////////

      function activate() {
        if (vm.tazk.task.tazkViewModelType === 'inboxTask') {
          behaviours = inboxTaskBehaviours
          defaultBehaviour = behaviours[0]
          vm.behaviour = defaultBehaviour
        } else if (vm.tazk.task.tazkViewModelType === 'customerChat') {
          behaviours = customerChatBehaviours
          defaultBehaviour = behaviours[0]
          vm.behaviour = defaultBehaviour
        } else {
          throw "Unknown tazkViewModelType '" + vm.tazk.task.tazkViewModelType + "'"
        }

      }

      /**
       * @param {String} behaviour from the allowed list
       */
      function switchToBehaviour(behaviour) {
        if (-1 === behaviours.indexOf(behaviour)) {
          throw  "Unknown behaviour '" + behaviour + "'"
        }

        vm.behaviour = behaviour
      }

      function doClaim() {
        vm.tazk.isBlocked = true;

        taskService.claim(vm.tazk.task)
          .then(function () {
            vm.tazk.task.claimable = false;
            vm.tazk.task.unclaimable = true;
            vm.tazk.task.claimed = true;

            vm.tazk.isBlocked = false;

            angular.forEach(vm.tazk.task.fields, function (f) {
              f.readonly = f.field.readonly;
            });
          })
          .catch(function () {
            vm.tazk.isBlocked = false;
            // -- todo: tell user issue happened
          });
      }

      function isDefaultBehaviour() {
        return vm.behaviour === defaultBehaviour;
      }

      function complete(action) {
        $log.debug("tazkActions : completing task with '" + action.name + "'")
        var result = taskService.isCompleteWithActionValid(vm.tazk.task, action.name)
        if (result.noteRequired) {
          vm.switchToBehaviour('notes')
          return
        }else if(result.fieldsRequired){
          return
        }

        $log.debug('normal complete behaviour')
        vm.tazk.isBlocked = true;
        taskService.completeWithAction(vm.tazk.task, action.name)
          .then(function () {
            vm.tazk.isBlocked = false;
            showOptionalItempsPopup(action)
            vm.tazk.close()
            $rootScope.$broadcast('inboxTask:completed', vm.tazk.id)
          })
          .catch(function (errMessage) {
            vm.tazk.isBlocked = false;
            //   TODO: The ui should know what it's meant to do, so this is an extreme edge-case
            notificationService.error('notification.error.task.failedtocomplete')
            throw "Failed to complete task :" + errorHelperService.formatError(errMessage)
          })
      }

      function unclaim() {
        doUnclaim()
      }

      function doUnclaim() {
        vm.tazk.isBlocked = true;

        taskService.unclaim(vm.tazk.task)
          .then(function () {
            vm.tazk.task.claimable = true;
            vm.tazk.task.claimed = false;
            vm.tazk.isBlocked = false;

            angular.forEach(vm.tazk.task.fields, function (f) {
              f.readonly = true;
            });
          })
          .catch(function() {
            vm.tazk.isBlocked = false;
            // -- todo: tell user issue happened
          });
      }

      function showOptionalItempsPopup(action) {
        if (angular.isDefined(action.optionalItemsUrl)) {
          $rootScope.$broadcast('showOptionalItems', action.optionalItemsUrl);
          $log.debug("tazkActions : showing optional items popup for '" + vm.optionalItemsUrl + "'")
        } else {
          $log.debug("tazkActions : no optional items for '" + action.name + "'")
        }
      }
    }
  }
})();

(function () {
  angular.module('tazkModule')
    .controller('tazkListController', tazkListController)

  /**
   * Calculates positioning and coordinates behaviour between multiple rendered tazks
   */
  function tazkListController($document, $scope, $timeout, $window, tazkService, vibrator) {
    // constants
    var TAZK_MARGIN = 5,
      WINDOW_PAD = 0,// 20,
      TAZK_MIN_WIDTH = 260 + TAZK_MARGIN,
      TAZK_MIN_OPEN_WIDTH = 550 + TAZK_MARGIN
    // TAZK_SHOULD_FULL_WIDTH = 490 // TODO: Control rendering on window resize

    // functions
    var close, showModal, hideModal, toggleOpen

    // initialize
    var vm = this,
      tazks = [],
      modalOpen = false

    var getBodyWidth = function () {
      return $document.width() - 5
      // This was the correct way to do it cross-browser. What
      //return ($document.body || $document.body[0]).clientWidth
    }

    var locate = function (id) {
      for (var i = 0; i < tazks.length; i++) {
        if (id === tazks[i].id) {
          return i
        }
      }

      return -1
    }

    function TazkViewModel(data) {
      var vm = {
        id: data.id,
        title: data.title,
        right: 0,
        left: 0,
        top: 0,
        isOpen: true,
        isModal: false,
        zindex: 0,
        task: data, // TODO - make it __FAR__ more obvious that this is the view model being passed from the outside
        busyOperations: 0,

        close: function () {
          vibrator.vibrate()
          close(locate(data.id))
        },
        showModal: function () {
          vibrator.vibrate()
          showModal(locate(data.id))
        },
        hideModal: function () {
          vibrator.vibrate()
          hideModal(locate(data.id))
        },
        toggleOpen: function () {
          vibrator.vibrate()
          toggleOpen(locate(data.id))
        },
        setBusyOperation: function(previousState, newState){
          if(!previousState && newState){
            vm.busyOperations++;
          }

          if(previousState && !newState){
            vm.busyOperations--;
          }
        }
      }

      return vm;
    }

    var resetForModal = function (tazk) {
      tazk.right = null
    }

    // We need to manually position each tazk to allow interaction underneath the element,
    // which would otherwise be impossible if it was contained in a wrapping div.
    // There used to be hacks to get around it but they are getting unreliable with modern
    // browsers. In addition, we can do some nice tiling of the elements with overlap.
    var draw = function () {
      // Calculate whether the current set will fit on the screen without tiling.
      var anyOpen = false
      var totalTazkLength = 0
      var i, tazk = undefined;
      for (i = 0; i < tazks.length; i++) {
        tazk = tazks[tazks.length - 1 - i]
        // A modal tazk does not appear in the list
        if (tazk.isModal) {
          continue
        }
        if (tazk.isOpen) {
          anyOpen = true
          totalTazkLength += TAZK_MIN_OPEN_WIDTH
        } else {
          totalTazkLength += TAZK_MIN_WIDTH
        }
      }
      var innerWidth = getBodyWidth() - (WINDOW_PAD * 2)
      var overflow = totalTazkLength - innerWidth

      // Calculate tazk positions
      var right = WINDOW_PAD

      // When there is no overflow, position each tazk directly to the left
      if (overflow <= 0) {
        for (i = tazks.length; i > 0;) {
          tazk = tazks[--i]
          if (tazk.isModal) {
            resetForModal(tazk)
            continue
          }

          tazk.right = right
          right += tazk.isOpen ? TAZK_MIN_OPEN_WIDTH : TAZK_MIN_WIDTH
        }
      } else {
        // If we have a lot of tazks, we expect to use the full
        // available width of the screen, but overlap the tazks
        // with the 'tab' of the next tazk being equally distant throughout.
        var evenSpacingAdjust
        var availableSpace = innerWidth - (anyOpen ? TAZK_MIN_OPEN_WIDTH : TAZK_MIN_WIDTH)
        var numToRender = modalOpen ? tazks.length - 2 : tazks.length - 1
        evenSpacingAdjust = availableSpace / numToRender

        // Check if this adjustment will cause empty gaps due to
        // it being greater than the space between wide and narrow
        // tazk widths. In this case, it feels natural to slide
        // a tazk under the previous one by the same distance
        // throughout.
        if (evenSpacingAdjust > TAZK_MIN_OPEN_WIDTH - TAZK_MIN_WIDTH) {
          var simpleCompensate = overflow / numToRender
          for (i = tazks.length; i > 0;) {
            tazk = tazks[--i]
            if (tazk.isModal) {
              resetForModal(tazk)
              continue
            }
            tazk.right = right
            right += (tazk.isOpen ? TAZK_MIN_OPEN_WIDTH : TAZK_MIN_WIDTH) - simpleCompensate
          }
        } else {
          // This is the most complicated scenario, where a wide-format tazk
          // being slid underneath a previous one that is closed would cause
          // it to 'stick out' of the other side. This causes problems when
          // minimizing the right-most open tazk in scenarios with a lot open.
          // To accommodate this, we position the first open tazk as if all
          // previous ones were also open, leaving the minimized ones further
          // to the right than otherwise expected.
          var openRight = right

          var rightMostTazk = tazks[tazks.length - 1].isModal ? tazks[tazks.length - 2] : tazks[tazks.length - 1]
          var rightmostTazkWidth = rightMostTazk.isOpen ? TAZK_MIN_OPEN_WIDTH : TAZK_MIN_WIDTH

          var left = rightmostTazkWidth + WINDOW_PAD
          var openLeft = TAZK_MIN_OPEN_WIDTH + WINDOW_PAD
          var foundOpenTazk = false
          for (i = tazks.length; i > 0;) {
            tazk = tazks[--i]
            if (tazk.isModal) {
              resetForModal(tazk)
              continue
            }

            var width = 0
            if (tazk.isOpen) {
              width = TAZK_MIN_OPEN_WIDTH
              if (!foundOpenTazk) {
                foundOpenTazk = true
                left = openLeft
              }
            } else {
              width = TAZK_MIN_WIDTH
            }

            right = left - width
            tazk.right = right
            left = right + width + evenSpacingAdjust

            openRight = openLeft - TAZK_MIN_OPEN_WIDTH
            openLeft = openRight + TAZK_MIN_OPEN_WIDTH + evenSpacingAdjust
          }
        }
      }
    }

    // Clicking on a tazk will cause it to jump to the front
    // of the list, cascading the others in both directions.
    var bringToFront = function (index) {
      var i
      var j = 0

      for (i = 0; i < index;) {
        tazks[i++].zindex = i
      }

      for (i = tazks.length - 1; i > index;) {
        tazks[i--].zindex = j++
      }

      tazks[index].zindex = tazks.length
    }

    // Only one tazk can be a modal at a time.
    // It is possible to maximize other tazks on top of the
    // one that is currently being the modal. (Not implemented yet)
    var hideShowModal = function (index, showModal) {
      var i = 0
      for (; i < tazks.length; i++) {
        tazks[i].isModal = false
      }

      modalOpen = showModal
      tazks[index].isModal = showModal

      if (showModal) {
        for (i = 0; i < tazks.length; i++) {
          tazks[i].isOpen = index === i
        }
      }

      draw()

     // $scope.$broadcast("ModelResizeClick",true);
    }

    hideModal = function (index) {
      hideShowModal(index, false)
    }
    showModal = function (index) {
      hideShowModal(index, true)
    }

    toggleOpen = function (index) {
      var tazk = tazks[index]
      if (tazk.isModal) {
        hideModal(index)
        tazk.isOpen = false
      } else {
        tazk.isOpen = !tazk.isOpen
      }

      draw()

      // if(tazk.isOpen)
      // {
      //   $scope.$broadcast("ModelResizeClick",true);
      // }
    }

    close = function (index) {
      if (tazks[index].isModal) {
        hideModal(index)
      }
      tazks.splice(index, 1)
      draw()
    }

    var handleAddTazk = function (task) {
      // Focus tazk if it is already open
      for (var i = 0; i < tazks.length; i++) {
        var tazk = tazks[i]

        if (tazk.id === task.id) {
          if (!tazk.isOpen) {
            toggleOpen(i)
            draw()
          }
          bringToFront(i)
          return
        }
      }

      // Create a new tazk

      var newTazk = new TazkViewModel(task)
      task.tazk = newTazk;
      tazks.push(newTazk)
      bringToFront(tazks.length - 1)
      draw()
    }

    // ----------------------------------- EVENT HANDLING -----------------------------------

    var onResize = function () {
      $timeout(draw)
    }

    // Triggered by sizing window, but not by vertical-overflow
    // shrinking the document body due to scrillbar appearing.
    angular.element($window).on('resize', onResize)

    // Not triggered by window sizing, but is by vertical-overflow
    // scrollbar appearing.
    $scope.$watch(getBodyWidth, function (newVal, oldVal) {
      if (newVal !== oldVal) {
        onResize()
      }
    })

    tazkService.on('showTazk', function (args) {
      handleAddTazk(args)
    })

    $scope.$on('$destroy', function () {
      angular.element($window).off('resize', onResize)
      tazkService.off('showTazk', handleAddTazk)
    })

    // --------------------------------------- SCOPE ----------------------------------------

    vm.tazks = tazks
    vm.bringToFront = bringToFront
    vm.modalOpen = function () {
      return modalOpen
    }
  }
})();

(function () {
  angular.module('gfAppCore', ['gfAppInsights'])
    .run(function ($translate, gfOIDCService, gfLoadingService, dateTimeService, notificationService) {
      // Avoids a circular dependency. The alternative is to use this in angular.config

      gfOIDCService.initialize();
      gfLoadingService.initialize();
      dateTimeService.initialize();
      notificationService.initialize();
    })
})();

(function () {
  angular.module('gfAppCore')
    .service('notificationService', function ($rootScope, toastr, $translate) {

      this.success = success
      this.error = error
      this.info = info
      this.warning = warning
      this.initialize = initialize

      ////////////

      var successText = 'Success';
      var errorText = 'Error';
      var infoText = 'Info';
      var warningText = 'Warning'

      function initialize() {
        // This will probably be best handled as an aggregate of the various APIs that we are using
        // var me = this

        // $rootScope.$on('$destroy', $rootScope.$on('auth:isAuthorized', function (event, data) {
        //   if (data === true) {
        //     me.success('notification.success.auth.reconnected')
        //   } else {
        //     me.error('notification.error.auth.lostconnection')
        //   }
        // }))

        $translate('notification.success', function (s) {
          successText = s;
        })
        $translate('notification.error', function (e) {
          errorText = e;
        })
        $translate('notification.info', function (i) {
          infoText = i;
        })
        $translate('notification.warning', function (w) {
          warningText = w;
        })
      }

      function success(message, options) {
        options = options || {};

        $translate(message).then(function (m) {
          toastr.success(m, successText, options)
        }, function (m) {
          toastr.success(m, successText, options)
        })
      }

      function error(message, options) {
        options = angular.extend(options || {}, {allowHtml:true})

        if(angular.isArray(message)){
          message = message.map($translate.instant).join('</br>')
        }

        $translate(message).then(function (m) {
            toastr.error(m, errorText, options)
          },
          function (m) {
            toastr.error(m, errorText, options)
          })
      }


      function info(message, onClick, options) {
        options = angular.extend(options || {}, {allowHtml:true, onTap: onClick})

        $translate(message).then(function (m) {
          toastr.info(m, infoText, options)
        }, function (m) {
          toastr.info(m, infoText, options)
        })
      }

      function warning(message, options) {
        options = options || {};

        $translate(message).then(function (m) {
          toastr.warning(m, warningText, options)
        }, function (m) {
          toastr.warning(m, warningText, options)
        })
      }
    })
})();

(function () {
  angular
    .module('gfAppCore')
    .service('userProfileService', userProfileService)

  function userProfileService($log, $q, $analytics, $translate, gfTranslationMapService, gfRoles) {
    var deferredUser = $q.defer();
    var isLoaded = false

    this.userProfile = {};
    this.hasAnyRole = hasAnyRole

    this.isAllowedTo = {
      viewAdmin: hasAnyRole(),
      translate: hasAnyRole(),
      sendInternalNotes : hasAnyRole(gfRoles.hk),
      viewImpersonate: viewImpersonate(),
      viewStoreDashboard: hasAnyRole(gfRoles.projectAdministrator, gfRoles.storeUser),
      viewSupportUserChat : hasAnyRole()
    }

    this.setApplicationUserContext = setApplicationUserContext;
    this.userLoaded = deferredUser.promise

    ////////////

    function setApplicationUserContext(userdata) {
      if(isLoaded){
        return
      }
      var u = {
        id: userdata.profile.sub,
        longName: userdata.profile.preferred_username,
        timezone: userdata.profile.zoneinfo,
        locale: userdata.profile.locale || gfTranslationMapService.fallbackLanguage,
        email: userdata.profile.email,
        picture: userdata.profile.picture,
        role: userdata.profile.role,
        isImpersonating : angular.isDefined(userdata.profile['impersonator']),
        impersonator: userdata.profile['impersonator'],
        isAuthBypass : userdata.profile.amr[0] === 'x-auth-bypass-token' || false,
        authBypassPurpose: userdata.profile['auth_bypass_purpose']
      }

      this.userProfile = u;

      setAppInsightsUser(u)
      $translate.use(u.locale)

      deferredUser.resolve(u);


      isLoaded = true
    }

    function hasAnyRole() {
      var roles = Array.prototype.slice.call(arguments)

      if(roles.length && angular.isArray(roles[0])){
        roles = roles[0]
      }

      return deferredUser.promise.then(function (user) {
        var userRoles = user.role;

        if(angular.isString(userRoles) && userRoles !== ""){
          userRoles = [userRoles];
        }
        if(!angular.isArray(userRoles)){
          return false
        }

        if(userRoles.indexOf(gfRoles.systemAdministrator) >= 0){
          return true;
        }

        return roles.some(function (role) {
          return userRoles.indexOf(role) >= 0
        })
      })
    }

    function viewImpersonate() {
      return deferredUser.promise.then(function (u) {
        // Must be true when impersonating a low-level user and when a sysadmin
        return u.isImpersonating || hasAnyRole(gfRoles.systemAdministrator)
      })
    }

    function setAppInsightsUser(user) {
      var username = user.id

      if (angular.isDefined(user.impersonator)) {
        username = user.impersonator + '(' + username + ')'
      }
      $analytics.setUsername(username)
      $log.debug("appinsights : '" + username + "'")
    }
  }
})();

(function () {
  angular.module('gfApp')
    .constant('gfSiskinDropdownValues', {
      taskStatuses:[
        {key: 'enum.status.pending', value: 'Pending'},
        {key: 'enum.status.overdue', value: 'Overdue'},
        {key: 'enum.status.escalated', value: 'Escalated'},
        {key: 'enum.status.completed', value: 'Completed'}
      ],
      taskInboxStatuses: [
        {key: 'enum.status.pending', value: 'Pending'},
        {key: 'enum.status.overdue', value: 'Overdue'},
        {key: 'enum.status.escalated', value: 'Escalated'}
      ],
      orderBy: [
        {key: 'enum.orderby.dueon', value: 'DueOn'},
        {key: 'enum.orderby.completedon', value: 'CompletedOn'}
      ],
      emailDigestRequirement: [
        {key:'enum.emailsettings.optional', value:'optional'},
        {key:'enum.emailsettings.none', value:'none'},
        {key:'enum.emailsettings.mandatory', value:'mandatory'}]
    })

})();

(function () {
  angular.module('gfAppCore')
    .constant('gfSiskinActions', {
      dashboardView: 'DashboardView',
      dashboardFilterByCompany: 'DashboardFilterByCompany',
      inboxView: 'InboxView',
      inboxCardModeDefault: 'InboxCardModeDefault',
      inboxFilterByCompany: 'InboxFilterByCompany',
      createSupportRequest: 'CreateSupportRequest',
      taskView: 'TaskView',
      taskEdit: 'TaskEdit',
      taskAssign: 'TaskAssign',
      taskUsersView: 'TaskUsersView',
      tasksProgress: 'TasksProgress',
      reportView: 'ReportView',
      projectInstanceView: 'ProjectInstanceView',
      projectInstanceEdit: 'ProjectInstanceEdit',
      projectInstanceDelete: 'ProjectInstanceDelete',
      projectInstanceStagesView: 'ProjectInstanceStagesView',
      projectInstanceHistoryView: 'ProjectInstanceHistoryView',
      projectInstanceAttributesView: 'ProjectInstanceAttributesView',
      projectInstanceRolesView: 'ProjectInstanceRolesView',
      projectInstanceList: 'ProjectInstanceList',
      projectInstanceNotesEdit: 'ProjectInstanceNotesEdit',
      projectInstanceNotesView: 'ProjectInstanceNotesView',
      projectInstanceRolesEdit: 'ProjectInstanceRolesEdit',
      projectInstanceRollback: 'ProjectInstanceRollback',
      contactInfoView: 'ContactInfoView',
      supportMessageRequest: 'SupportMessageRequest',
      supportMessageResponse: 'SupportMessageResponse',
      workflowsView: 'WorkflowsView',
      workflowEdit: 'WorkflowEdit',
      workflowDelete: 'WorkflowDelete',
      workflowPublish: 'WorkflowPublish',
      projectTemplateView: 'ProjectTemplateView',
      projectTemplateListView: 'ProjectTemplateListView',
      projectTemplateAdminListView: 'ProjectTemplateAdminListView',
      projectTemplateStartInstance: 'ProjectTemplateStartInstance',
      projectTemplateDeactivate: 'ProjectTemplateDeactivate',
      projectTemplateRestore: 'ProjectTemplateRestore',
      projectTemplateCreate: 'ProjectTemplateCreate',
      projectTemplateDelete: 'ProjectTemplateDelete',
      projectTemplateAttributesExport: 'ProjectTemplateAttributesExport',
      projectTemplateAttributesAcls: 'ProjectTemplateAttributesAcls',
      projectTemplateAttributesBatchUpdate: 'ProjectTemplateAttributesBatchUpdate',
      projectTemplateNotesView: 'ProjectTemplateNotesView',
      projectTemplateNotesEdit: 'ProjectTemplateNotesEdit',
      projectTemplateEmailSettingsView: 'ProjectTemplateEmailSettingsView',
      projectTemplateGeneralEmailSettingsView:'ProjectTemplateGeneralEmailSettingsView',
      projectTemplateWorkflowView:'ProjectTemplateWorkflowView',
      projectTemplateAllFilesDownload:'ProjectTemplateAllFilesDownload',
      adminUserGroupStoreManagement: 'AdminUserGroupStoreManagement',
      adminEmailTemplate: 'AdminEmailTemplate',
      adminTaskEmailTemplateEdit : 'AdminTaskEmailTemplateEdit',
      adminCustomerContact: 'AdminCustomerContact',
      adminWelcomeMessage: 'AdminWelcomeMessage',
      adminTranslate: 'AdminTranslate',
      adminImpersonate: 'AdminImpersonate',
      adminDownloadTools: 'AdminDownloadTools',
      adminPermissionsEdit: 'AdminPermissionsEdit',
      adminGroupsStores: 'AdminGroupsStores',
      documentationView: 'DocumentationView',
      licensesView: 'LicensesView',
      integrationView: 'IntegrationView',
      documentationEdit: 'DocumentationEdit',
      workflowSuperAdminEdit: 'WorkflowSuperAdminEdit',
      metaDataEntitiesEdit: 'MetaDataEntitiesEdit',
      cannotViewMilestones: 'CannotViewMilestones',
      storesView: 'StoresView',
      concernNotesView: 'ConcernNotesView',
      concernNotesEdit: 'ConcernNotesEdit',
      clientView: 'ClientView',
      externalView: 'ExternalView',
      toolsView: 'ToolsView',
      concernDetailView: 'ConcernDetailView',
      monitoringView: 'MonitoringView',
      administrationView: 'AdministrationView'
    })
})();

(function () {
  angular.module('gfAppCore')
    .constant('gfRoles', {
      systemAdministrator: 'SYSTEM_ADMINISTRATOR'
    })
})();

(function () {
  angular.module('gfAppCore')
    .constant('knownErrors', {
      clockSkewMessage : 'It appears the time on your device is incorrect',
      safariPrivateBrowsingMessage : "If you are using Safari please disable private browsing. (The application needs to access your browser's local storage)"
    })
    .constant('httpStatusCodes', {
        success  : 200,
        notFound  : 404,
        internalError : 500,
        conflict : 409,
        preconditionFailed : 412
    });
})();

(function(){
  angular.module('gfApp')
    .service('gfHelper', function(){
      var me = this;

      me.groupBy = groupBy
      me.isNullOrEmpty = isNullOrEmpty
      me.toCamelCase = toCamelCase

      /////

      function groupBy(xs, key, fnKey) {
        var array = []
        var reduced = xs.reduce(function (rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {})

        angular.forEach(reduced, function (value, key) {
          array.push({
            key: angular.isDefined(fnKey) ? fnKey(value[0]) : key,
            value: value
          })
        })
        return array
      }


      function isNullOrEmpty(value) {
        if(angular.isUndefined(value) || value == null){
          return true
        }

        if(!angular.isString(value)){
          throw 'Object must be a string'
        }
        return value === ''
      }

      function toCamelCase(str){
        return str
        .replace(/\s(.)/g, function($1) { return $1.toUpperCase(); })
        .replace(/\s/g, '')
        .replace(/^(.)/, function($1) { return $1.toLowerCase(); });
      }
      
    })
})();

/*global Oidc:false*/
// OpenID Connect service responsible for authenticating the user and maintaining the user session via "silent refresh"
// Uses the OpenID Connect library
(function (Oidc) {
  angular
    .module('gfAppCore')
    .service('gfOIDCService', function (configService, $sessionStorage, $timeout, $log, $window, $location, $http, $rootScope, appInsights, userProfileService, $q, moment, knownErrors, authConfigurations) {

      var isAuthorized = false;
      var completedLogin = $q.defer();

      this.isConnected = isAuthorized;
      this.logout = logout;
      this.completedLogin = completedLogin.promise;
      this.impersonate = impersonate;
      this.initialize = initialize
      this.getToken = getToken

      ////////////

      // Uncomment these to get some information about authentication
      // Do not leave this in production
      //Oidc.Log.level = Oidc.Log.INFO
      //Oidc.Log.logger = console

      var silentRenewTries = 0;
      var deauthorizedOn;

      var settings = initSettings()

      var userManager = new Oidc.UserManager(settings);

      userManager.events.addUserUnloaded(function () {
        $log.debug("auth: user unloaded");
      });
      userManager.events.addAccessTokenExpiring(function () {
        $log.debug("auth: token expiring");
      });
      userManager.events.addUserSignedOut(function () {
        $log.debug("auth: user signed out, trying silent renew");
        trySilentRenew("auth: user signed out")
      });

      userManager.events.addUserLoaded(function (user) {
        setAuthorization(user)
      });

      userManager.events.addAccessTokenExpired(function () {
        $log.info('auth: deauthorized')
        isAuthorized = false;
        $rootScope.$broadcast('auth:isAuthorized', isAuthorized)
        deauthorizedOn = moment()
      });

      userManager.events.addSilentRenewError(trySilentRenew);

      function initialize() {
        $log.debug('auth: starting')
        var path = $location.path()

        var authBypass = path.indexOf('x-auth-bypass')
        var error = path.indexOf('error=');
        var id_token = path.indexOf('id_token')
        if (error !== -1) {
          handleLoginError(path)
        }
        else if (authBypass !== -1) {
          useBypassTokenFromPath(path)
        } else if (id_token !== -1) {
          $log.debug('auth: found login token after hash')
          userManager.signinRedirectCallback(path.substr(id_token))
            .then(navigateToPathSetBeforeRedirect)
            .catch(function (err) {
              $log.debug('auth: ' + err)
              if (isClockSkewError(err)) {
                failLogin({message: knownErrors.clockSkewMessage})
              } else {
                failLogin(err)
              }

              throw err
            })
        } else {
          $log.debug('auth: nothing in path, checking for user information in browser storage')
          clearRedirectPathSetBeforeRedirect()
          userManager.getUser().then(function (user) {
            if (!user || user.expired) {
              $log.debug('auth: nothing in storage, getting a new token')
              getNewToken()
            } else {
              $log.debug('auth: found a user in browser storage')
              setAuthorization(user)
            }
          })
        }
      }

      function initSettings(configuration){

        var authConfiguration;
        if(angular.isUndefined(configuration)) {
          // Load an auth configuration from local storage
          // This is set when using auth bypass tokens, right before a redirect
          authConfiguration =
            authConfigurations[$sessionStorage.authConfiguration] ||
            authConfigurations['default']
        } else {
          delete $sessionStorage.authConfiguration
          authConfiguration = authConfigurations[configuration]
        }

        return {
          authority: configService.auth.authority,
            client_id: authConfiguration.client_id,
          redirect_uri: $window.location.protocol + "//" + $window.location.host,
          post_logout_redirect_uri: configService.auth.post_logout_redirect_uri,

          // these two will be done dynamically from the buttons clicked, but are
          // needed if you want to use the silent_renew
          response_type: "id_token token",
          scope: authConfiguration.scope,

          // silent renew will get a new access_token via an iframe
          // just prior to the old access_token expiring (60 seconds prior)
          silent_redirect_uri: $window.location.protocol + "//" + $window.location.host + "/silent_renew.html",
          automaticSilentRenew: true,

          // will raise events for when user has performed a logout at IdentityServer
          monitorSession: true,

          // this will allow all the OIDC protocol claims to be visible in the window. normally a client app
          // wouldn't care about them or want them taking up space
          filterProtocolClaims: true,

          // this will use the user info endpoint if it's an OIDC request and there's an access_token
          loadUserInfo: true
        };
      }

      function impersonate(userName) {
        userManager.clearStaleState()
          .then(userManager.removeUser())
          .then(function () {
            settings.prompt = 'login'
            if (angular.isDefined(userName)) {
              settings.acr_values = 'Impersonate:' + userName
            }

            userManager = new Oidc.UserManager(settings)
            userManager.signinRedirect()
          })
      }

      function handleLoginError(path) {
        // Handle known errors:
        var e;

        var authBypassPurpose = path.indexOf('login_required')
        if (authBypassPurpose !== -1) {
          settings = initSettings('default')
          settings.prompt='login'
          userManager = new Oidc.UserManager(settings)
          userManager.signinRedirect()
        } else {
          e = "Failed to authenticate '" + path + "'";
          $log.error(e)
        }

        failLogin(e)
      }

      function useBypassTokenFromPath(path) {
        $log.debug('auth: found login bypass token')

        var token = undefined;
        var purpose = undefined;
        var postLoginPath = undefined;

        var authBypassToken = path.indexOf('x-auth-bypass-token')
        var authBypassPurpose = path.indexOf('x-auth-bypass-purpose')
        var authBypassPath = path.indexOf('x-auth-bypass-path')


        if (authBypassToken !== -1) {
          token = path.substring(authBypassToken + 20).split('&')[0]
        }

        if (authBypassPurpose !== -1) {
          purpose = path.substring(authBypassPurpose + 22).split('&')[0]
        }

        if (authBypassPath !== -1) {
          postLoginPath = path.substring(authBypassPath + 19).split('&')[0]
        }

        useBypassToken(purpose, postLoginPath, token)
      }

      /**
       * Gets an authentication bypass token, purpose and path from the URL
       * Stores the token in session storage and uses the alternative auth-bypass strategy to log in in place of
       * a user name and password
       * @param path
       */
      function useBypassToken(purpose, postLoginPath, token) {

        if (angular.isDefined(token)) {
          settings.acr_values = 'BypassToken:' + token
        }

        if (angular.isDefined(purpose)) {

          var cfg = authConfigurations[purpose]
          if (angular.isUndefined(cfg) || cfg === null) {
            var err = "auth: Unknown bypass token client"
            $log.error(err)
            appInsights.trackException(err)
            failLogin(err)
            return
          }

          // Change the client we're using so it can be reset after completing a redirect
          $sessionStorage.authConfiguration = purpose

          settings.client_id = cfg.client_id
          settings.scope = cfg.scope
        }

        if (angular.isDefined(postLoginPath)) {
          $sessionStorage.loginSavedPath = postLoginPath
        }

        userManager = new Oidc.UserManager(settings)
        userManager.clearStaleState();
        userManager.signinRedirect()
          .then(null, function (e) {
            $log.info("auth failed: " + e);
            appInsights.trackException(e)
            failLogin(e);
          });
      }

      function getNewToken() {
        userManager.clearStaleState();
        savePathBeforeRedirect()
        userManager.signinRedirect()
          .then(null, function (e) {
            $log.info("auth failed: " + e);
            appInsights.trackException(e)
            failLogin(e);
          });
      }

      function savePathBeforeRedirect() {
        try {
          $sessionStorage.loginSavedPath = $location.path()
          $sessionStorage.loginSavedSearch = $location.search()
        } catch (e) {
          failLogin(e)
          throw e
        }
      }

      function navigateToPathSetBeforeRedirect() {
        var path = $sessionStorage.loginSavedPath
        var parameters = $sessionStorage.loginSavedSearch
        clearRedirectPathSetBeforeRedirect()

        if (!angular.isString(path)) {
          $log.info("auth: no path provided from before redirect")
        } else {
          $log.info("auth: redirecting to " + path)
          $location.path(path)
          $location.search(parameters)
        }
      }

      function clearRedirectPathSetBeforeRedirect() {
        delete $sessionStorage.loginSavedPath
        delete $sessionStorage.loginSavedSearch
      }

      function getToken(){
        return $http.defaults.headers.common.Authorization
      }

      function setAuthorization(user) {
        var token = user.token_type + " " + user.access_token;
        $http.defaults.headers.common.Authorization = token
        $rootScope.$broadcast('auth:newToken', token)
        $log.debug('auth: completed login')
        userProfileService.setApplicationUserContext(user)
        completedLogin.resolve();
        isAuthorized = true;
        silentRenewTries = 0;
        if (deauthorizedOn) {
          $rootScope.$broadcast('auth:isAuthorized', isAuthorized)
          var duration = (moment() - deauthorizedOn) / 1000
          appInsights.trackEvent('deauthorized', null, {duration: duration})
          $log.info("auth: reauthorized after " + duration + 's')
          deauthorizedOn = undefined;
        }
      }

      function logout() {
        delete $sessionStorage.authConfiguration
        delete $sessionStorage.loginSavedPath
        delete $sessionStorage.loginSavedSearch
        userManager.signoutRedirect();
      }

      function failLogin(e) {
        delete $sessionStorage.authConfiguration
        completedLogin.reject(e)
      }

      function trySilentRenew(e) {
        if(!configService.appSettings.silentRenewEnabled){
            $log.debug('auth: silent renew not performed, appSettings.silentRenewEnabled=false')
            return;
        }

        if (angular.isUndefined(e)) {
          e = {error: '', message: ''}
        }

        $log.debug("auth: silent renew error " + ++silentRenewTries, e.message);
        if (e.error === 'login_required') {
          appInsights.trackEvent('detected login_required response from idsrv, logging the user out')
          logout()
        }

        // Continuously try to sign in again if the token has expired and we have a connection error
        userManager.signinSilent()
          .catch(function (error) {
            var trySilentRenewIn = Math.min(silentRenewTries, 30);
            $log.debug('auth: trying to renew again in ' + trySilentRenewIn + 's')
            $timeout(function () {
              trySilentRenew(error)
            }, trySilentRenewIn * 1000);
          });
      }
    })

  function isClockSkewError(err) {
    return err && angular.isString(err.message) &&
      (err.message.startsWith('exp is in the past') || err.message.startsWith('iat is in the future'))
  }

})(Oidc);

(function () {
  angular.module('gfAppCore')
    .service('gfLoadingService', function ($q, $log, gfOIDCService, gfTranslateLanguageLoaderTracker) {

      var waitForTranslationsLoaded = $q.defer();
      var waitForLogin = $q.defer();

      this.completeLogin = waitForLogin.promise;
      this.translationsLoaded = waitForTranslationsLoaded.promise;
      this.initialize = initialize;

      ////////////

      function initialize() {
        gfOIDCService.completedLogin
          .then(function (result) {
            waitForLogin.resolve(result)
            $log.debug('gfLoadingService : completed login')
          })
          .catch(function (fail) {
            waitForLogin.reject(fail)
            $log.debug('gfLoadingService : failed login ' + fail)
          });

        gfTranslateLanguageLoaderTracker.translationsLoaded.promise
          .then(function(){
            waitForTranslationsLoaded.resolve();
          })
          .catch(function (err) {
            waitForTranslationsLoaded.reject(err);
          })
      }
    });
})();

// Use this service instead of moment, tz or the userProfileService

(function () {
  angular
    .module('gfAppCore')
    .filter('dateTimeFromUtc', function (dateTimeService) {
      return function (input) {
        return dateTimeService.formatFromUtc(input, true);
      }
    })
    .filter('dateFromUtc', function (dateTimeService) {
      return function (input) {
        return dateTimeService.formatFromUtc(input, false);
      }
    })
    .filter('dateFrom', function (dateTimeService) {
      return function (input) {
        return dateTimeService.formatFrom(input, 'day');
      }
    })
    .service('dateTimeService', function ($log, userProfileService, moment) {

      var me = this;
      this.locale = undefined;
      this.initialize = initialize;
      this.formatFromUtc = formatFromUtc;
      this.formatMonthFromUtc = formatMonthFromUtc;
      this.momentFromUtc = momentFromUtc;
      this.fromUserDateInputToUtc = fromUserDateInputToUtc;
      this.fromUserTimeInputToUtc = fromUserTimeInputToUtc;
      this.formatMomentOrNull = formatMomentOrNull
      this.formatFrom = formatFrom
      this.currentYear = currentYear

      this.dateFormat = 'll';
      this.dateTimeFormat = 'lll';
      this.uxTimeZone;

      this.dates = {
        today : moment(),
        next30date : moment().add(30,'days'),
        next90date : moment().add(90,'days'),
        next365date : moment().add(365,'days'),
        last30date : moment().subtract(30,'days'),
        last90date : moment().subtract(90,'days'),
        last365date : moment().subtract(365,'days'),
        startOfThisYear : moment().startOf('year'),
        endOfThisYear : moment().endOf('year'),
        startOfThisMonth : moment().startOf('month'),
        endOfThisMonth : moment().endOf('month'),
        startOfThisQuarter : moment().startOf('quarter'),
        endOfThisQuarter : moment().endOf('quarter'),
        startOfLastYear : moment().subtract(1, 'years').startOf('year'),
        endOfLastYear : moment().subtract(1, 'years').endOf('year')
      }

      ////////////

      function initialize() {
        // All moment objects to be created in UTC by default
        moment.tz.setDefault('UTC')
        userProfileService.userLoaded
          .then(function (u) {
            me.uxTimeZone = u.timezone || 'UTC';
            me.locale = u.locale;
            moment.locale(u.locale)
          })
      }

      /**
       * @param {string} date a UTC date string or moment object
       * @param {bool} includeTime whether to format short or long string
       * @returns {string} the date converted local time
       */
      function formatFromUtc(date, includeTime) {
        if (angular.isDate(date)) {
          throw date + " is a javascript date object"
        }

        if (angular.isUndefined(date) || date === null) {
          return null;
        }
        try {
          return moment(date).tz(me.uxTimeZone).format(includeTime ? this.dateTimeFormat : this.dateFormat)
        } catch (e) {
          $log.debug("date is '" + date + "'")
          $log.debug("uxTimeZone is '" + me.uxTimeZone + "'")
          $log.debug("includeTime is '" + includeTime + "'")
          throw e
        }
      }

      function formatMonthFromUtc(date) {
        if (angular.isDate(date)) {
          throw date + " is a javascript date object"
        }

        if (angular.isUndefined(date) || date === null) {
          return null;
        }
        try {
          return moment(date).tz(me.uxTimeZone).format('MMMM YYYY')
        } catch (e) {
          $log.debug("date is '" + date + "'")
          $log.debug("uxTimeZone is '" + me.uxTimeZone + "'")
          throw e
        }
      }

      /**
       * @param (string) date a UTC date string
       * @returns {object} the date converted to moment object
       */
      function momentFromUtc(date) {
        if (angular.isUndefined(date) || date === null || !angular.isString(date)) {
          return null;
        }
        try {
          return moment(date).tz(me.uxTimeZone)
        } catch (e) {
          $log.debug("date is '" + date + "'")
          $log.debug("uxTimeZone is '" + me.uxTimeZone + "'")
          throw e
        }
      }

      /**
       * @param {Date} date User chosen date
       * @returns {string} the date converted to UTC, formatted as a string
       */
      function fromUserDateInputToUtc(date) {
        if (angular.isUndefined(date)) {
          return null;
        }

        if (!angular.isDate(date)) {
          throw date + " is not a js date object"
        }

        return moment.tz({
          year: date.getFullYear(),
          month: date.getMonth(),
          day: date.getDate(),
          hour: 23,
          minute: 59
        }, me.uxTimeZone).utc().format();
      }

      /**
       * Add a date from a timepicker (in user-time-zone) to an existing model (in utc)
       * @param {string} utcModel
       * @param {string} hour
       * @param {string} minute
       * @returns {string} UTC formatted string of the utcModel parameter, with additional precision added from the
       *                   user input
       */
      function fromUserTimeInputToUtc(utcModel, hour, minute) {
        if (!angular.isString(utcModel) || utcModel.indexOf(' ') !== -1) {
          throw "Invalid model, it should be an ISO format string"
        }

        return moment.tz(utcModel, 'UTC').tz(me.uxTimeZone).hour(hour).minute(minute).format()
      }

      function formatMomentOrNull(val) {
        if (angular.isUndefined(val) || val === null || !angular.isFunction(val.format)) {
          return null
        } else {
          return val.format()
        }
      }

      function formatFrom(date, startOf) {
        var m = moment()
        if(startOf){
          m = m.startOf(startOf)
        }

        if (Math.abs(moment(date).diff(m, 'days')) > 1) {
          return moment(date).from(m)
        }
        return moment(date).calendar().split(' ')[0]
      }

      function currentYear() {
        return moment(new Date(new Date().getFullYear(), 0, 1));
      }
      
    })
})();

(function () {
  angular.module('gfAppCore')
    .constant('knownErrors', {
      clockSkewMessage: 'It appears the time on your device is incorrect',
      safariPrivateBrowsingMessage: "If you are using Safari please disable private browsing. (The site needs to access your browser's local storage)"
    })
    .constant('httpStatusCodes', {
      success: 200,
      badRequest: 400,
      forbidden: 403,
      notFound: 404,
      conflict: 409,
      preconditionFailed: 412,
      internalError: 500
    })
    .constant('categories', {
      guidelines: "guidelines",
      storeinfo: "storeinfo",
      reportingcontacts: "reportingcontacts",
      specialcategories: ["storeinfo","reportingcontacts"]
    })
    .constant('taskstatuses', {
      completed: "completed",
      overdue: "overdue"
    })
    .constant('authConfigurations',{
      'default' : {
        client_id : 'Siskin.UI',
        scope: 'openid Siskin.Api Siskin.TranslationApi Siskin.Web'
      }
    })
    .constant('colors',{
      completed: "#3BC79C",
      overdue: "#f8ac59",
      inProgress: "#5090E6",
      map: {
         completed: "3BC79C",
         overdue: "f8ac59",
         inProgress: "5090E6",
         default: "3BC79C"
      },
       milestones: [
        "#579C87","#A1C181","#84D2E2","#E4963B","#F9CA47","#F17E3A","#3E6477",
        "#EFDAC5","#F8AC59","#A36284","#1AB394","#1C84C6","#D9C99E","#19374F","#666666","#415C70","#F25565"
       ],
       milestonesText: [
        "#FFFFFF","#333333", "#333333", "#333333", "#333333", "#FFFFFF", "#FFFFFF",
        "#333333","#333333","#FFFFFF","#FFFFFF","#FFFFFF","#333333","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF"
       ],
       milestonesMap: [
        "579C87", "A1C181", "84D2E2", "E4963B", "F9CA47", "F17E3A", "3E6477",
        "EFDAC5","F8AC59","A36284","1AB394","1C84C6","D9C99E","19374F","666666","415C70","F25565"
      ],
      picChart:[
        "#5090E6", "#45B8E2", "#3BC79C" ,"#FFD650", "#F89D40", "#F84B5F"
      ]
    })
    .constant('workflowEntityConstants',{
      entityTypes: ["string", "date", "dateTime", "integer", "double", "boolean", "multipleFile", "user", "group", "dropdown", "confirmation", "link"]
    })
})();

(function () {
  angular.module('gfAppCore')
    .service('configService', function ($window) {
      this.api = {
        translations: defined($window.rootVariables.api.translations) + "/api/1/translation",
        app: defined($window.rootVariables.api.app) + "/api/1",
        appV2: defined($window.rootVariables.api.app) + "/api/v2",
        signalR : defined($window.rootVariables.api.app) + "/signalr",
        integration: defined($window.rootVariables.api.integration)
      }
      this.auth = {
        authority: defined($window.rootVariables.auth.authority),
        post_logout_redirect_uri: defined($window.rootVariables.auth.post_logout_redirect_uri)
      }

      
      this.appInsightsKey = defined($window.rootVariables.appInsightsKey)
      this.customer = defined($window.rootVariables.customer)

      this.appSettings = $window.rootVariables.appSettings

      angular.forEach(this.appSettings.navigation.filter(function(m){return m.children && m.children.length}), function(m){
        m.canDo = m.children.map(function(m){return m.canDo}).join(',')
      });
    })

  function defined(v){
    if(angular.isUndefined(v) || v === null){
      throw "Setting not defined"
    }

    return v
  }
})();

(function () {
  angular
    .module('gfAppCore')
    .service('$translationApi', function ($http, $q, $log, configService, gfLoadingService, errorHelperService) {
      return createHalApiService($http, $q, $log, gfLoadingService, errorHelperService, '$translationApi', configService.api.translations)
    })
    .service('$appApi', function ($http, $q, $log, configService, gfLoadingService, errorHelperService) {
      return createHalApiService($http, $q, $log, gfLoadingService, errorHelperService, '$appApi', configService.api.app)
    })
    .service('$integrationApi', function ($http, $q, $log, configService, gfLoadingService, errorHelperService) {
      return createApiService($http, $q, $log, gfLoadingService, errorHelperService, '$integrationApi', configService.api.integration, '/status')
    })
    .service('$appApiV2', function ($http, $q, $log, configService, gfLoadingService, errorHelperService) {
      return createApiService($http, $q, $log, gfLoadingService, errorHelperService, '$appApiV2', configService.api.appV2, '')
    })


    function createApiService($http, $q, $log, gfLoadingService, errorHelperService, apiName, apiRoot, statusPath) {
      var apiRootVersion = $q.defer()

      gfLoadingService.completeLogin
        .then(function () {
          return $http.get(apiRoot + (statusPath ? statusPath : '')).then(function(apiResource){
            var links = apiResource.data ? apiResource.data.links : undefined;

            function resolve(url){
              if(links) {
                var link = links.filter(function(l){return l.rel === url});
                if(link.length){
                  return link[0].href;
                }else{
                  throw 'Cannot find link ' + url + ' in the ApiResource of ' + apiRoot;
                }
              }
              
              return apiRoot + '/' + url;
            }

            return apiRootVersion.resolve({
              get:function(url,config){
                return $http.get(resolve(url), config).then(function(result){
                  return result.data;
                })
              },
              post:function(url,config){
                return $http.post(resolve(url), config).then(function(result){
                  return result.data;
                })
              },
              put:function(url,config){
                return $http.put(resolve(url), config).then(function(result){
                  return result.data;
                })
              }
            })
          })
        })
        .catch(function (err) {
          apiRootVersion.reject({err: err.data || 'apiunavailable'});
          $log.info(apiName + ' : is not available ' + errorHelperService.formatError(err))
        });

      return apiRootVersion.promise;
    }

  function createHalApiService($http, $q, $log, gfLoadingService, errorHelperService, apiName, apiRoot) {
    var apiRootVersion = $q.defer()
    gfLoadingService.completeLogin
      .then(function () {
        return $http({url: apiRoot})
      })
      .then(function (apiRootResource) {
        apiRootVersion.resolve(apiRootResource)
        $log.debug(apiName + ' : available')
      })
      .catch(function (err) {
        apiRootVersion.reject({err: err.data || 'apiunavailable'});
        $log.info(apiName + ' : is not available ' + errorHelperService.formatError(err))
      });
    return apiRootVersion.promise;
  }
})();

(function () {
  angular.module('fileUploadModule', [])
})();

(function () {
  angular.module('fileUploadModule')
    .service('singleFileUploadService', function ($httpParamSerializerJQLike, blockUploadService, configService, $rootScope, $log, $timeout, $window, $http, $q, appInsights) {
      return function (container, localId) {
        var BLOCK_SIZE = 1048576;
        var totalBytesRemaining = 0;
        var totalBytesUploaded = 0;
        var currentFilePointer = 0;
        var currentBlockCounter = 0;
        var totalFileSize = 0;
        var paused = false;
        var cancelled = false;
        var failed = false;
        var completed = false;
        var inProgress = false;
        var uriToUpload = "";
        var fileToUpload = {};
        var file = {};
        var mainPromise = {};
        var id = localId;
        var promises = [];
        var containerResource = container;
        var fileResource = {};

        var addPromise = function (promise) {
          promises.push(promise);
          return promise;
        };
        /**
         * Generates the block's id. They need to be of the same length throughout all blocks and be in base64.
         * @param {Integer} id The integer id of the block
         * @returns {String} The block's id in base64 (000000 -> 999999)
         */
        var calculateBlockId = function (id) {
          return btoa(String("000000" + id).slice(-6));
        };

        /**
         * Gets the SAS token for the file upload
         * @returns {}
         */
        var setUploadUri = function () {
          var deferred = $q.defer();

          var params = new FileAddParams(fileToUpload.name);

          if(angular.isDefined(fileToUpload.extendedProperties)){
            angular.extend(params, fileToUpload.extendedProperties)
          }

          containerResource
            .$request()
            .$post('file-add', {}, params)
            .then(function (result) {
              $log.debug("SAS Token refreshed.");
              angular.extend(fileResource, result);
              fileResource.resource = result
              fileToUpload.resource = result;
              uriToUpload = result.url;
              deferred.resolve(uriToUpload);
              file.containerPromise.resolve(fileResource);
              file.containerCreated = true;
            }, function (data) {
              deferred.notify(data);
            });
          return deferred.promise;
        };

        /**
         * Push the instruction data to Blob storage, so it can re-assemble the files from the blocks
         * @returns {}
         */
        var commitBlockList = function () {
          var uri = uriToUpload + '&comp=blocklist';
          var blocks = '';
          for (var i = 0; i < currentBlockCounter; i++) {
            blocks += calculateBlockId(i) + ','
          }
          blocks = blocks.substring(0, blocks.length - 1);
          var requestParameters = {
            method: "PUT",
            url: uri,
            data: $httpParamSerializerJQLike(blocks),
            ignoreAuthModule: true,
            headers: {
              "x-ms-blob-content-type": fileToUpload.type,
              "Content-Type": "application/x-www-form-urlencoded",
              "Authorization": $http.defaults.headers.common.Authorization
            }
          };

          // 8. step: push the summary for the blocks
          blockUploadService.queueUpload(requestParameters)
            .then(function (data) {
              $log.debug(data);
              mainPromise.notify((totalBytesUploaded / totalFileSize * 100));
              completed = true;
              inProgress = false;
              appInsights.trackEvent("File Upload: Completed", {
                fileId: localId,
                fileName: fileToUpload.name
              }, {fileSize: fileToUpload.size});

              fileResource['isUploaded'] = true;

              var rel = fileToUpload.resource.$hasLink('file') ? 'file' : 'self'

              fileToUpload.resource.$request().$put(rel, {}, fileResource).then(function (newResource) {
                mainPromise.resolve("completed");
                var model = angular.extend({}, newResource);
                model.resource = newResource
                file.completionPromise.resolve({id: id, fileResource: model});
              })
            }
            ,function() {} // -- using notify for failing promises
            ,function (response) {
                appInsights.trackEvent("File Upload: Committing Block list Failed", {
                  fileId: localId,
                  fileName: fileToUpload.name,
                  response: response
                }, {fileSize: fileToUpload.size});
                failed = true;
                file.completionPromise.notify({id: id});
                mainPromise.notify(response);
              });
        };

        /**
         * Takes the next block of the data to upload
         * @returns {}
         */
        var uploadFileInBlocks = function () {

          inProgress = true;

          // 1. step: check if we have more data to upload
          if (totalBytesRemaining > 0) {
            var blockSize = BLOCK_SIZE;
            if (totalBytesRemaining < blockSize) {
              blockSize = totalBytesRemaining;
            }

            // 2. step: set the counters and read the next block
            var fileContent = fileToUpload.slice(currentFilePointer, currentFilePointer + blockSize);
            currentFilePointer += blockSize;

            uploadBlock(fileContent)
          } else {
            $q.all(promises).then(function () {
              if (cancelled) {
                // completeUpload.notify({id: id});
              } else {
                appInsights.trackEvent("File Upload: All Blocks Uploaded Successfully", {
                  fileId: localId,
                  fileName: fileToUpload.name
                }, {fileSize: fileToUpload.size});
                commitBlockList();
              }
            });
          }
        };

        /**
         * Uploads a block of data read from the file
         * @param {Blob} requestData The block of data from the file to upload
         * @returns {}
         */
        var uploadBlock = function (requestData) {
          // 4. step: get the upload URI
          var uri = uriToUpload + '&comp=block&blockid=' + calculateBlockId(currentBlockCounter)
          var requestParameters = {
            localId: localId,
            method: "PUT",
            url: uri,
            data: requestData,
            // don't send the Authorization header with this request, blob storage doesn't accept it
            headers: {
              "x-ms-blob-type": "BlockBlob",
              "Content-Type": "application/octet-stream",
              "Authorization": $http.defaults.headers.common.Authorization
            },
            // don't parse the binary into JSON, Angular.
            transformRequest: []
          };

          var bytesInBlock = totalBytesRemaining > BLOCK_SIZE
            ? BLOCK_SIZE
            : totalBytesRemaining;

          // 5. step: start uploading the file
          addPromise(blockUploadService.queueUpload(requestParameters).then(function () {
              totalBytesUploaded += bytesInBlock;
              mainPromise.notify((totalBytesUploaded / totalFileSize * 100));
            }
            ,function () {} // -- using notify for failing promises
            ,function (response) {
              appInsights.trackEvent("File Upload: Block Failed To Upload", {
                fileId: localId,
                fileName: fileToUpload.name,
                response: response
              }, {fileSize: fileToUpload.size});
              failed = true;
              paused = true;
              mainPromise.notify(response);
              file.completionPromise.notify({id: id});
            }));
          currentBlockCounter++;
          totalBytesRemaining -= bytesInBlock;
          uploadFileInBlocks();
        };

        function FileAddParams(displayName){
          this.displayName = displayName;
        }

        return {
          skipCreateFileContainer: false,
          getLocalFileUploadId: function () {
            return id;
          },
          uploadFileInBlocks: function (f) {
            promises = [];
            var deferred = $q.defer();
            var fileObject = f.file;
            var localId = f.id;

            appInsights.context.operation.id = localId;
            appInsights.trackEvent("File Upload: Started", {
              fileId: localId,
              fileName: fileObject.name
            }, {fileSize: fileObject.size});
            id = localId;
            fileToUpload = fileObject;
            file = f;
            currentBlockCounter = 0;
            currentFilePointer = 0;
            totalBytesRemaining = fileObject.size;
            totalBytesUploaded = 0;
            totalFileSize = fileObject.size;
            mainPromise = deferred;

            if (this.skipCreateFileContainer) {
              uploadFileInBlocks();
            } else {
              setUploadUri().then(function () {
                  uploadFileInBlocks();
                }
                , function () {
                } // -- using notify for failing promises
                , function (response) {
                  file.completionPromise.notify({id: id});
                  mainPromise.notify(response);
                });
            }

            return mainPromise.promise;
          },

          cancelUpload: function () {
            if (this.canCancel()) {
              appInsights.trackEvent("File Upload: Cancelled", {
                fileId: localId,
                fileName: fileToUpload.name
              }, {fileSize: fileToUpload.size});
              cancelled = true;
              blockUploadService.cancel(localId);
            }
          },

          pauseUpload: function () {
            if (this.canPause()) {
              appInsights.trackEvent("File Upload: Paused", {
                fileId: localId,
                fileName: fileToUpload.name
              }, {fileSize: fileToUpload.size});
              paused = true;
              blockUploadService.pause(localId);
            }
          },

          resumeUpload: function () {
            if (this.canResume()) {
              appInsights.trackEvent("File Upload: Resumed", {
                fileId: localId,
                fileName: fileToUpload.name
              }, {fileSize: fileToUpload.size});
              paused = false;
              uploadFileInBlocks();
              blockUploadService.resume(localId);
            }
          },

          canResume: function () {
            return paused && !cancelled && !failed
          },

          canPause: function () {
            return inProgress && !cancelled && !completed && !failed
          },

          canRetry: function () {
            return !cancelled && failed;
          },

          canCancel: function () {
            return inProgress && !cancelled && !completed && !failed
          },

          bytesRemaining: function () {
            return totalBytesRemaining;
          },

          percentUploaded: (totalBytesUploaded / totalFileSize * 100)

        }
      }
    })
})();

(function () {
  angular.module('fileUploadModule')
    .service('fileUploadOrchestrationService', function ($q, $timeout, singleFileUploadService, guidFactory) {
      var fileList = [];

      // TODO localize statuses - lowercase, no spaces
      var performUploads = function () {
        var breakLoop = true;
        if (fileList.length > 0) {
          angular.forEach(fileList, function (file) {
            if (breakLoop) {
              if (file.status === 'Pending') {
                breakLoop = false;
                file.status = 'In Progress';

                file.service.uploadFileInBlocks(file)
                  .then(function () {
                      file.status = 'Complete';
                      performUploads();
                    }
                    , function () {
                    } // -- using notify for failing promises
                    , function (data) {
                      if (angular.isNumber(data)) {
                        file.percentageComplete = Math.round(data);
                      } else {
                        if (data === "cancelled") {
                          file.status = 'Cancelled';
                        } else {
                          file.status = 'Failed';
                        }
                        performUploads();
                      }
                    });
              }
            }
          });
        }
      };

      var retry = function (containerId) {
        angular.forEach(fileList, function (file) {
          if (file.containerId == containerId && file.status === 'Failed') {
            file.percentageComplete = 0;
            file.status = 'Pending';
            file.service.skipCreateFileContainer = file.containerCreated;

            // file.service = singleFileUploadService(container, file.id) -- retry only affects 'failed'
            // status files
          }
        });

        performUploads();
      };

      return {
        queueFileUpload: function (files, container, containerId) {
          var fileUploadObjects = [];
          angular.forEach(files, function (item) {
              var fileObject = null;

              // -- get the existing file object if trying to upload a file that is already on the orchestration service
              if (angular.isDefined(item.fileObject)) {
                angular.forEach(fileList, function (f) {
                  if (fileObject === null && f.file === item.fileObject) {
                    fileObject = f;
                  }
                });
              }

              // -- if file was already on the orchestration service
              if (fileObject) {
                fileObject.completionPromise = item.completionPromise;
                fileObject.containerPromise = item.containerPromise;

                // -- if file is already completed, execute completion promise
                if (fileObject.status === 'Complete') {
                  fileObject.completionPromise.resolve({id: fileObject.id, fileResource: item});
                }
              } else {
                var id = guidFactory();
                var instance = singleFileUploadService(container, id);
                fileObject = {
                  id: id,
                  fileName: item.fileObject.name,
                  file: item.fileObject,
                  containerId: containerId,
                  percentageComplete: 0,
                  status: 'Pending',
                  service: instance,
                  completionPromise: item.completionPromise,
                  containerPromise: item.containerPromise,
                  resume: function () {
                    this.service.resumeUpload();
                  },
                  pause: function () {
                    this.service.pauseUpload();
                  },
                  cancel: function () {
                    fileList.splice(fileList.indexOf(fileObject), 1);
                    this.service.cancelUpload();
                  }
                };

                fileList.push(fileObject);
              }

              fileUploadObjects.push(fileObject);
            }
          );

          if (!fileList.some(function (f) {
              return f.status == 'In Progress'
            })) {
            performUploads();
          }

          return fileUploadObjects;
        },
        retry: retry,
        cancel: function (files) {
          if (angular.isDefined(files)) {
            angular.forEach(files, function (file) {
              file.cancel();
            });
          }
        },
        getContainerFiles: function (containerId) {
          return fileList.filter(function (f) {
            return f.containerId === containerId
          })
        },
        isContainerInProgress: function (containerId) {
          return this.getContainerFiles(containerId).some(function (f) {
            return f.status !== 'Complete' && f.status !== 'Cancelled';
          });
        },
        initOrResumeUpload: function (containerId) {
          // -- check orchestrator for files on queue or uploading
          var files = this.getContainerFiles(containerId);
          var allCompletedOrCancelled = !files.some(function (f) {
            return f.status !== 'Complete' && f.status !== 'Cancelled';
          });

          // -- remove all uploads for the field since they were already completed/cancelled
          if (allCompletedOrCancelled) {
            for (var i = fileList.length - 1; i >= 0; i--) {
              if (fileList[i].containerId === containerId) {
                fileList.splice(i, 1);
              }
            }
            files = [];
          }

          return files;
        },
        files: fileList
      }
    })
})
();

(function () {
  angular.module('fileUploadModule')
    .service('blockUploadService', function ($rootScope, $log, $timeout, $window, $http, $q) {

      var concurrentCount = 0;
      var blockQueue = [];
      var pendingQueue = [];

      var tryQueueBlock = function () {
        var anyPending = pendingQueue.filter(function (request) {
          return request.requestData.paused !== true
        });

        if (anyPending.length > 0) {
          if (concurrentCount < 6) {
            var nextBlock = pendingQueue.shift();
            if (nextBlock.requestData.cancelled) {
              nextBlock.existingDeferral.notify('cancelled');
              tryQueueBlock();
            } else if (nextBlock.requestData.paused) {
              pendingQueue.push(nextBlock);
              tryQueueBlock();
            } else {
              queueBlock(nextBlock.requestData, nextBlock.existingDeferral);
            }
          }
        }
      }

      var incrementCurrentCount = function () {
        concurrentCount++;
      };

      var decrementCurrentCount = function () {
        concurrentCount--;
        tryQueueBlock();
      };

      var performRequest = function (requestParameters, retryCount, existingDeferral) {
        var deferral;
        if (existingDeferral == null) {
          deferral = $q.defer();
        }
        else {
          deferral = existingDeferral;
        }

        

        if (requestParameters.paused) {
          return deferral.promise;
        }

        var retryCounter;
        if (retryCount == null) {
          retryCounter = 0;
        }
        else {
          retryCounter = retryCount;
        }
        $http(requestParameters)
          .then(function () {
            // 6. step /good/: we successfully uploaded the chunk, go to the next bit
            return deferral.resolve();
          }, function (response) {
            retryCounter++;
            // we retry 5 times in increasing time periods.
            // This NEVER MUST BE < 2 even for testing purposes
            // An erroneous upload will start the next one, which means it will immediately create the file container
            // and update the fileCollection, causing bad data to be stored (i.e: 10 consecutive file uploads would mean
            // 10 consecutive file container created and fileCollection updated)
            if (retryCounter < 3) {
              $timeout(function () {
                performRequest(requestParameters, retryCounter, deferral);
              }, Math.pow(3, retryCounter - 1) * 5000); // exponentially wait 5s, 15s, 45s, 2:15, and 6:45
              // all in all 10 minutes and 5 seconds
            } else {
              deferral.notify(response);
            }
          });

        return deferral.promise;
      };

      var queueBlock = function (requestData, existingDeferral) {
        var deferral;
        if (existingDeferral == null) {
          deferral = $q.defer();
        }
        else {
          deferral = existingDeferral;
        }
        if (concurrentCount < 6) {
          blockQueue.push(requestData);
          var next = blockQueue.shift();
          incrementCurrentCount();
          performRequest(next, null, null).then(
            function () {
              decrementCurrentCount();
              deferral.resolve();
            }
            , function () {} // -- using notify for failing promises
            , function (response) {
              decrementCurrentCount();
              pendingQueue = [];
              deferral.notify(response)
            });
        } else {
          pendingQueue.push({requestData: requestData, existingDeferral: deferral});
        }

        return deferral.promise;
      };

      return {

        queueUpload: function (requestParameters) {

          var deferral = $q.defer();

          queueBlock(requestParameters, null).then(
            function () {
              deferral.resolve();
            }
            , function () {} // -- using notify for failing promises
            , function (response) {
              deferral.notify(response)
            }
          );

          return deferral.promise;
        },
        cancel: function (id) {
          angular.forEach(pendingQueue, function (request) {
            if (request.requestData.localId === id) {
              request.requestData.cancelled = true;
            }
          });
        },
        pause: function (id) {
          angular.forEach(pendingQueue, function (request) {
            if (request.requestData.localId === id) {
              request.requestData.paused = true;
            }
          });
        },
        resume: function (id) {
          angular.forEach(pendingQueue, function (request) {
            if (request.requestData.localId === id) {
              request.requestData.paused = false;
            }
          });

          tryQueueBlock();
        }
      }
    });
})();

/*global appInsights:false*/
(function(){
  angular.module('gfAppInsights',
    [
      'angulartics',
      'angulartics.application.insights'
    ])
    .config(function($analyticsProvider){
      $analyticsProvider.trackExceptions(true)
      $analyticsProvider.registerExceptionTrack(function (error/*, cause*/) {
        appInsights.trackException(error)
      });
    })
})();

(function(){
  angular.module('gfAppInsights')
    .run(function ($window, $log) {
      if (Object.keys($window.appInsights.config).length === 1) {
        // Add properties to application insights object to make sure we don't
        // access properties that break our operation
        $window.appInsights.context = $window.appInsights.context || {operation: {id: 'app insights shim'}}
        logBlocked()
      } else {
        $log.debug('App insights is running properly')
      }

      function logBlocked(){
        $log.info(' -------------------------------------   ')
        $log.info('-----------------------------------------')
        $log.info('          APP INSIGHTS BLOCKED           ')
        $log.info('-----------------------------------------')
        $log.info('  -------------------------------------  ')
      }

    })
})();

(function () {
  angular.module('gfAppInsights')
    .service('appInsights', function ($window) {
      return $window.appInsights;
    })
})();

// Allows an editableText directive to automatically open based on the provided expression

(function () {
  angular.module('gfApp')
    .directive('autoEditIf', function ($timeout) {
      return {
        restrict: 'A',
        require:'editableText',
        scope: false,
        link: function ($scope, element, attributes/*, editableText*/) {
          $timeout(function () {
            if ($scope.$eval(attributes.autoEditIf)) {
              $scope.$form.$show()
            }
          })
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('skSpinner', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/directives/utility/spinner.directive.html'
      }
    })
    .directive('skSpinnerCircle', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/directives/utility/spinner.circle.directive.html'
      }
    });
})();

(function () {
  angular.module('gfApp')
    .directive('scroll', function ($window, scrollingService) {
      return {
        restrict: 'A',
        scope: false,
        link: function (scope, element) {
          scrollingService.scrollOnResize(scope, element, function () {
            return element.is(":focus");
          }, 15)
        }
      }
    });
})();

(function () {
  angular.module('gfApp')
    .directive('scrollBottom', function ($timeout) {
      return {
        restrict: 'E',
        scope: {countChange :"=", tazk: "="},
        link: function ($scope,element) {
          $scope.$watch('[countChange, tazk.isOpen, tazk.isModal]', function () {
              doScroll();
            }
          );

          function doScroll() {
            $timeout(function () {
              var popupBody =element.closest('div.tazk__behaviour__body')[0];
              if(popupBody != null) {
                popupBody.scrollTop = popupBody.scrollHeight;
              }
              angular.element(".composer > div > textarea").focus();
            })
          }
        }
      }
    });
})();

(function () {
  angular.module('gfApp')
    .directive('printButton', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/directives/utility/printButton.directive.html',
        scope: true,
        controllerAs:'vm',
        controller: function($window){
          var vm = this;

          vm.print = print

          function print(){
            $window.print()
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('preventDefault', function () {
      return {
        restrict: 'A',
        link: function(scope, elem) {
          elem.on('click', function(e){
            e.preventDefault();
          });
        }
      }
    });
})();

(function () {
  angular.module('gfApp')
    .directive('onoffSwitch', function () {
      return {
        restrict: 'E',
        require: ["^ngModel","^switchId"],
        templateUrl: 'app/directives/utility/onoffSwitch.directive.html',
        controllerAs:'vm',
        bindToController:{
          ngModel: "=",
          switchId:"@",
          ngDisabled:"@",
          ngCallback: "&"
        },
        controller: function(){
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('onError', function ($parse) {
      return {
        restrict: 'A',
        compile: function onErrorCompile(tElem, tAttrs) {
          var callback = $parse(tAttrs.onError);

          return function onErrorPostLink(scope, elem) {
            elem.on('error', onError);

            // Helpers
            function onError(event) {
              scope.$apply(function () {
                callback(scope, {$event: event});
              });
            }
          }
        }
      }
    });
})();

(function () {
  angular.module('gfApp')
  .directive("numeric", function () {
    return {
        restrict: "A", // Only usable as an attribute of another HTML element
        require: "?ngModel",
        scope: {
            decimals: "@",
            decimalPoint: "@"
        },
        link: function (scope, element, attr, ngModel) {
            var decimalCount = parseInt(scope.decimals) || 0;
            var decimalPoint = scope.decimalPoint || ".";
            // Run when the model is first rendered and when the model is changed from code
            ngModel.$render = function() {
                if (ngModel.$modelValue != null) {
                    if (angular.isNumber(decimalCount)) {
                        element.val(parseFloat(ngModel.$modelValue).toFixed(decimalCount).toString().replace(".", ","));
                    } else {
                        element.val(ngModel.$modelValue.toString().replace(".", ","));
                    }
                }
            }
            // Run when the view value changes - after each keypress
            // The returned value is then written to the model
            ngModel.$parsers.unshift(function(newValue) {
                if (angular.isNumber(decimalCount)) {
                    var floatValue = parseFloat(newValue.replace(",", "."));
                    if (decimalCount === 0) {
                        return parseInt(floatValue);
                    }
                    return parseFloat(floatValue.toFixed(decimalCount));
                }

                return parseFloat(newValue.replace(",", "."));
            });
            // Formats the displayed value when the input field loses focus
            element.on("change", function () {
                var floatValue = parseFloat(element.val().replace(",", "."))
                if (!isNaN(floatValue) && angular.isNumber(floatValue) && angular.isNumber(decimalCount)) {
                    if (decimalCount === 0) {
                        element.val(parseInt(floatValue))
                    } else {
                        element.val(floatValue.toFixed(decimalCount).replace(".", decimalPoint))
                    }
                } else {
                    element.val(null)
                }
            });
        }
      }
  });
})();

(function () {
  angular.module('gfApp')
    .directive('ngEscape', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 27) {
            scope.$apply(function () {
              scope.$eval(attrs.ngEscape);
            });

            event.preventDefault();
          }
        });
      };
    });
})();

(function () {
  angular.module('gfApp')
    .directive('ngEnter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.ngEnter);
            });

            event.preventDefault();
            event.stopPropagation();
          }
        });
      };
    });
})();

(function(){
	angular.module('gfApp')
		.directive('focusIf', function($timeout){
			return {
				restrict: 'A',
					link: function(scope, element, attrs) {
						scope.$watch(attrs.focusIf, 
							function (newValue) { 
								$timeout(function() {
									newValue && element.focus();
									});
								},true);
							}
		}

	});
})();
(function () {
  angular.module('gfApp')
    .directive('fileUploadButton', function ($timeout) {
      return {
        restrict: 'E',
        templateUrl: 'app/directives/utility/fileUploadButton.directive.html',
        scope: true,
        require: "^ngModel",
        bindToController: {
          ngModel: '=',
          ngChange: '&?',
          accept: '@?',
          label: '@?',
          btnClass: '@?'
        },
        controllerAs:'vm',
        controller: function($element){
          var vm = this;

          vm.btnClass = vm.btnClass || 'btn btn-default'

          var fileUpload = $element.find('input')

          fileUpload.on('change', function () {
            var files = fileUpload[0].files

            vm.ngModel.data = files

            if(angular.isDefined(vm.ngChange)){
              vm.ngChange(files)
            }

            $timeout(function(){
              fileUpload.prop('value',null)
            })
          });
        }
      }
    })
})();

(function(){
  angular.module('gfApp')
    .directive('dropdownPresets',dropdownPresets)

  function dropdownPresets(presetService){
    return {
      restrict: 'E',
      require: "^ngModel",
      scope: {},
      controllerAs: 'vm',
      bindToController:{
        ngModel: "=",
        presetType: "@",
        presetParams:"=?",
        targetValue: "=",
        placeholder: "@",
        allowClear: "@?",
        ngDisabled: "=?"
      },
      templateUrl: 'app/directives/utility/dropdown.directive.html',
      controller: function(){
        var vm = this

        if(angular.isUndefined(vm.allowClear)){
          vm.allowClear = 'true'
        }

        vm.ngChange = ngChange

        activate()

        /////

        function activate(){
          vm.pager = {
            items: [],
            reset: tagging
          }

          presetService.get(vm.presetType, vm.presetParams)
            .then(function (data) {
              vm.data = data
              vm.pager.items = data.presets
            })
        }

        function ngChange(){

          if(angular.isDefined(vm.ngModel)){
            // create preset
            if(angular.isUndefined(vm.ngModel.id)){
              presetService.save(vm.ngModel.name, vm.targetValue)
                .then(function(data){
                  vm.pager.items.push(data)
                })
            }
            // populate values
            else{
              angular.forEach(vm.targetValue, function(v){
                var pv = vm.ngModel.values.filter(function(m){return m.selector === (v.selector | v.id)})

                if(pv.length > 0){
                  v.selected = pv[0].value
                }
              })
            }
          }
        }

        function tagging(search){
          if(search.searchTerm === ""){
            return
          }

          if(angular.isDefined(vm.addedOption)){
            vm.pager.items.shift()
          }

          if(vm.pager.items.indexOf(search.searchTerm) === -1){
            vm.addedOption = search.searchTerm
            vm.pager.items.unshift(search.searchTerm)
          }else{
            vm.addedOption = undefined
          }
        }
      }
    }
  }
})();

(function(){
  angular.module('gfApp')
    .directive('dropdownMultiple',dropdownMultiple)

  function dropdownMultiple(){
    return {
      restrict: 'E',
      require: "^ngModel",
      scope: {},
      controllerAs: 'vm',
      bindToController:{
        ngModel: "=",
        ngChange: "&",
        pager: "=?",
        ngValues: "=?",
        placeholder: "@",
        allowClear: "@?",
        ngDisabled: "=?",
        groupBy: "@?"
      },
      templateUrl: 'app/directives/utility/dropdown.multiple.directive.html',
      controller: function(){
        var vm = this

        if(angular.isUndefined(vm.allowClear)){
          vm.allowClear = 'true'
        }

        vm.reachInfinity = reachInfinity

        activate()

        /////

        function activate(){
          if(angular.isUndefined(vm.pager)){
            vm.pager = {
              items: vm.ngValues
            }
          }
        }

        function reachInfinity(){
          if(angular.isDefined(vm.pager.nextPage)){
            vm.pager.nextPage()
          }
        }
      }
    }
  }
})();

(function(){
  angular.module('gfApp')
    .directive('dropdown',dropdown)

  function dropdown(){
    return {
      restrict: 'E',
      require: "^ngModel",
      scope: {},
      controllerAs: 'vm',
      bindToController:{
        ngModel: "=",
        ngChange: "&",
        pager: "=?",
        ngValues: "=?",
        placeholder: "@",
        allowClear: "@?",
        ngDisabled: "=?",
        tagging: "@?",
        refreshDelay: "@?",
        prop: "@?",
        filter: "=?",
        clearOnSelect: "@?",
        groupBy: "@?"
      },
      templateUrl: 'app/directives/utility/dropdown.directive.html',
      controller: function(){
        var vm = this

        if(angular.isUndefined(vm.allowClear)){
          vm.allowClear = 'true'
        }

        vm.refreshDelay = vm.refreshDelay | 500

        vm.reachInfinity = reachInfinity
        vm.onSelect = onSelect

        activate()

        /////

        function activate(){
          if(angular.isUndefined(vm.pager)){
            vm.pager = {
              items: vm.ngValues
            }

            if(vm.tagging === 'true'){
              vm.pager.reset = tagging
            }
          }
        }

        function reachInfinity(){
          if(angular.isDefined(vm.pager.nextPage)){
            vm.pager.nextPage()
          }
        }

        function tagging(search){
          if(search.searchTerm === ""){
            return
          }

          if(vm.pager.items.length && vm.pager.items[0] === vm.addedOption){
            vm.pager.items.shift()
          }

          if(vm.pager.items.indexOf(search.searchTerm) === -1){
            vm.addedOption = search.searchTerm
            vm.pager.items.unshift(search.searchTerm)
          }else{
            vm.addedOption = undefined
          }
        }

        function onSelect(){
          if(angular.isDefined(vm.clearOnSelect)){
            vm.ngModel = null
          }

          vm.ngChange()
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .directive('disableInputs', function () {
      return {
        restrict: 'A',
        scope: {makeDisable: "="},
        link: function ($scope, element) {
          $scope.$watch('makeDisable', function (newValue) {
            disableInputs(element, newValue);
          });

          function disableInputs(element) {
            angular.element(element).find(':input').each(function (key, input) {
              var attrVal = angular.element(input).attr("ignore-field");
              if (attrVal == null) {
                if ($scope.makeDisable) {
                  angular.element(input).attr('disabled', 'disabled');
                }
                else {
                  angular.element(input).removeAttr('disabled');
                }
              }
            });
          }
        }
      }
    });
})();

(function () {
    angular.module('gfApp')
      .directive('datepickerRange', function ($translate, dateTimeService) {
        return {
          scope: {},
          restrict: 'E',
          require: "^ngModel",
          controllerAs: 'vm',
          link: link,
          controller: controller,
          bindToController: {
            ngModel: "=",
            ngChange: "&?",
            ngClear: "&?",
            ngOptions: "=?",
            placeholder: "@?",
            showFutureRanges: "@?",
            showPastRanges: "@?"
          },
          templateUrl: 'app/directives/utility/datepickerrange.directive.html'
        }

        function link(scope, element){
          scope.vm.picker = element.find('[date-range-picker]')
        }

        function controller() {
            var vm = this

            vm.ngClear = vm.ngClear || clear

            vm.options = angular.extend({},{
                autoApply: true,
                autoUpdateInput: false,
                linkedCalendars: false,
                alwaysShowCalendars: true,
                ranges: {},
                locale:{
                    fromLabel: $translate.instant('common.from'),
                    format: dateTimeService.dateFormat,
                    toLabel: $translate.instant('common.to'),
                    cancelLabel: $translate.instant('common.clear'),
                    customRangeLabel: $translate.instant('daterangepicker.filter.customrange')
                },
                eventHandlers: {
                    'cancel.daterangepicker': function() {
                        if(angular.isDefined(vm.ngClear)){
                            vm.ngClear();
                        }
                      },
                    'apply.daterangepicker': function() {
                        if(angular.isDefined(vm.ngChange)){
                            vm.ngChange();
                        }},
                    'show.daterangepicker': function() {  } // this is required since the datepickerrange has an issue when initial date is null
                }
            },vm.ngOptions)

            // ranges
            var dates = dateTimeService.dates
            var commonRanges = {}
            commonRanges[translate('daterangepicker.filter.thismonth')] = [dates.startOfThisMonth, dates.endOfThisMonth]
            commonRanges[translate('daterangepicker.filter.thisquarter')] = [dates.startOfThisQuarter, dates.endOfThisQuarter]
            commonRanges[translate('daterangepicker.filter.thisyear')] = [dates.startOfThisYear, dates.endOfThisYear]
            commonRanges[translate('daterangepicker.filter.lastyear')] = [dates.startOfLastYear, dates.endOfLastYear]

            var futureRanges = {}
            if(vm.showFutureRanges === 'true'){
                commonRanges[translate('daterangepicker.filter.next30')] = [dates.today, dates.next30date]
                commonRanges[translate('daterangepicker.filter.next90')] = [dates.today, dates.next90date]
                commonRanges[translate('daterangepicker.filter.next365')] = [dates.today, dates.next365date]
            }
            var pastRanges = {}
            if(vm.showPastRanges === 'true'){
                commonRanges[translate('daterangepicker.filter.last30')] = [dates.last30date, dates.today]
                commonRanges[translate('daterangepicker.filter.last90')] = [dates.last90date, dates.today]
                commonRanges[translate('daterangepicker.filter.last365')] = [dates.last365date, dates.today]
            }

            angular.extend(vm.options.ranges,
                pastRanges,futureRanges,commonRanges)

        }

        function clear(){
          this.ngModel.startDate = null
          this.ngModel.endDate = null
          if(this.ngChange){
            this.ngChange()
          }

          this.picker.val('');
        }

        function translate(str){
            return $translate.instant(str)
        }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('datepicker', function ($timeout, dateTimeService, userService, guidFactory, scrollingService) {
      return {
        scope: {},
        restrict: 'E',
        require: "^ngModel",
        compile: compile,
        controllerAs: 'vm',
        controller: controller,
        bindToController: {
          includeTime: "=?",
          ngModel: "=",
          ngChange: "=?",
          ngChanged: "&?",
          placeholder: "@?",
          datepickerTranslatePlaceholder : "@"
        },
        templateUrl: 'app/directives/utility/datepicker.directive.html'
      }

      function compile(elem) {
        var input = elem.find('input');

        input.attr("id", guidFactory());
        input.attr("timezone", dateTimeService.uxTimeZone);
      }

      function controller($scope, $element) {
        var vm = this;
        var input = $element.find('.js-datepicker-trigger');
        var id = input.attr("id");

        var options = {
          format: dateTimeService.dateFormat,
          minView: 'date',
          view: 'date',
          timezone: 'UTC'
        };

        if (vm.includeTime === true) {
          options.format = dateTimeService.dateTimeFormat;
          options.minView = 'minutes';
        }

        $timeout(function(){
          $scope.$broadcast('pickerUpdate', id, options);
        })

        vm.focus = function(){
          var containerElement = $element.parent().parent()
          scrollingService.scrollToIfCannotSee(containerElement, 200);
          vm.focused = true;
        }

        vm.blur = function() {
          vm.focused = false;
        }

        vm.clear = function(){
          vm.ngModel = null;
          $scope.dateChange();
        }

        vm.show = function(){
          $timeout(function(){
            input.trigger('focus');
          })
        }

        $scope.dateChange = function(){
          if(angular.isDefined(vm.ngChange)){
            vm.ngChange(vm.ngModel);
          }

          if(angular.isDefined(vm.ngChanged)){
            $timeout(vm.ngChanged)
          }
        }

        scrollingService.scrollOnResize($scope, $element, function(){
          return vm.focused;
        }, 200);
      }
    });
})();

(function () {
  angular.module('gfApp')
    .directive('confirmationButtonPanel', function ($compile, $templateCache, $templateRequest) {
      return {
        scope: {},
        restrict: 'A',
        bindToController: {
          confirmCallBack: '&ngClick',
          confirmMessage: '@',
          targetElementId: '@',
          params: '=',
          errorKeys: '=',
          errorMessage: '@'
        },
        controllerAs: 'vm',
        controller: controller
      }

      function controller($scope, $element, $timeout, errorHelperService) {
        var vm = this;

        if (angular.isUndefined(vm.targetElementId)) {
          throw 'targetElementId must be defined'
        }

        vm.targetElement = angular.element('#' + vm.targetElementId);

        $scope.confirm = confirm
        $scope.cancel = cancel
        $scope.confirmMessage = vm.confirmMessage
        $scope.errorMessage = vm.errorMessage
        $scope.params = vm.params

        activate()

        ////

        function activate() {
          $element.on('click', function (e) {
            open();
            e.stopPropagation();
            e.stopImmediatePropagation();

            return false;
          })
        }

        function open() {
          $scope.error = false;

          $templateRequest('app/directives/utility/confirmationButton.panel.template.html')
            .then(function (html) {

              var replacingElement = $element.find('div');
              if(replacingElement.length > 0){
                html = html.replace('<div></div>', replacingElement.html())
              }

              var element = $compile(html)($scope);

              element.css('height',vm.targetElement.css('height'))
              element.css('margin-bottom','-' + vm.targetElement.css('height'))
              element.css('z-index','1000')

              vm.targetElement.prepend(element)
              $timeout(function(){
                element.parent().find('.confirmationPanel').addClass('display')
              });
            });
        }

        function confirm() {
          $scope.error = null;
          $scope.processing = true

          if (angular.isDefined(vm.confirmCallBack)) {
            vm.confirmCallBack()
              .then(function () {
                $scope.processing = false
                cancel();
              },showError)
              .catch(showError);
          }
        }

        function showError(error){
          $scope.processing = false
          if(angular.isDefined(vm.errorKeys))
          {
            errorHelperService.formatHttpError(vm.errorKeys, error.status)
              .then(function(value){
                $scope.error = value;})
          }else if(angular.isDefined($scope.errorMessage)){
            $scope.error = $scope.errorMessage;
          }else{
            $scope.error = error.data.message
          }
        }

        function cancel() {
          var panel = vm.targetElement.parent().find('[name="confirmationPanel"]');

          panel.removeClass('display')
          $timeout(function(){
            panel.remove();
          },200)
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('confirmationModal', function ($document, $timeout, modalService) {
      return {
        restrict: 'A',
        priority: 100,
        controllerAs: 'vmModal',
        bindToController: {
          text: "@?",
          templateUrl: "@?",
          ngClick: "&",
          title: "@?",
          btnStyle: "@?",
          errorMessage: "@?"
        },
        controller: function ($element) {
          var vmBtn = this

          $element.bind('click', function (e) {
            e.stopImmediatePropagation()

            modalService.open({
              templateUrl: vmBtn.templateUrl || 'app/directives/utility/confirmation.modal.directive.html',
              controllerInit: function (vm) {
                vm.title = vmBtn.title || $element.text()
                vm.text = vmBtn.text
                vm.confirmFn = vmBtn.ngClick
                vm.btnStyle = vmBtn.btnStyle || 'btn-primary'
                vm.errorMessage = vmBtn.errorMessage || 'common.error'

                vm.confirm = function () {
                  vm.processing = true
                  vm.error = false

                  var result = vm.confirmFn()

                  if (angular.isDefined(result) && angular.isDefined(result.finally)) {
                    result.then(function(){
                      modalService.dismissAll()
                    })

                    return result.catch(function (err) {
                      vm.error = true
                      throw err
                    })
                      .finally(function () {
                        vm.processing = false
                      })
                  } else {
                    modalService.dismissAll()
                    vm.processing = false
                    return result
                  }
                }
              }
            })
          })

        }
      }

    })
})();

(function () {
  angular.module('gfApp')
    .directive('icheck',
      function ($timeout) {
        return {
          restrict: 'A',
          require: 'ngModel',
          link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
              var value;
              value = $attrs['value'];

              $scope.$watch($attrs['ngModel'], function(){
                angular.element(element).iCheck('update');
              })

              return angular.element(element).iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'

              }).on('ifChanged', function(event) {
                if (angular.element(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                  $scope.$apply(function() {
                    return ngModel.$setViewValue(event.target.checked);
                  });
                }
                if (angular.element(element).attr('type') === 'radio' && $attrs['ngModel']) {
                  return $scope.$apply(function() {
                    return ngModel.$setViewValue(value);
                  });
                }
              });
            });
          }
        };
      }
    )
})();

(function () {
    angular.module('gfApp')
    .directive('autoFocus', function($timeout) {
        return {
            restrict: 'AC',
            link: function(_scope, _element) {
                $timeout(function(){
                    _element[0].focus();
                }, 0);
            }
        };
    });
  })();
  
(function () {
  angular.module('gfApp')
    .directive('tazkNotes', function ($log, $timeout, userProfileService, taskNotesService, errorHelperService) {
      return {
        restrict: 'E',
        templateUrl: 'app/directives/tazkBehaviours/tazkNotes.directive.html',
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          tazk: "=",
          behaviour :"="
        },
        link: linkFunction,
        controller: controllerFunction
      }


      function linkFunction($scope, element) {
        // It is possible for this to sometimes fail, not sure exactly under
        // what circumstances this happens
        $scope.$watch(behaviourIsVisible, focusInputAreaIfVisible)

        function behaviourIsVisible() {
          return element.hasClass('ng-hide')
        }

        function focusInputAreaIfVisible(newValue, oldValue) {
          if (!newValue && oldValue) {
            var focusTarget = element.find('textarea')[0]
            if (angular.isUndefined(focusTarget)) {
              throw "Cannot find textarea to focus when switching to task notes"
            }
            focusTarget.focus()
          }
        }
      }


      function controllerFunction() {
        var vm = this;
        vm.busy =false
        vm.notes = {
          data: [],
          highlightRequiredAction: '',
          noteFromThisTaskWasSent: false
        }
        vm.hasError = hasError
        vm.userId = ''
        vm.compose = {
          message: '',
          state: 'writing'
        }
        vm.startSend = startSend
        vm.isNoteFromSelf = isNoteFromSelf
        vm.sendPublic = function () {
          send(false)
        }
        vm.sendInternal = function () {
          send(true)
        }
        vm.back = function(){
          vm.behaviour = 'fields'
        }
        vm.cancelSend = cancelSend

        activate()

        ///////

        function activate() {
          setUser();
          getNotes();
        }

        function hasError() {

          return vm.notes.highlightRequiredAction !== '' && !vm.notes.noteFromThisTaskWasSent
        }

        function setUser() {
          userProfileService.userLoaded.then(function (user) {
            vm.userId = user.id
          })
        }

        function getNotes() {
          taskNotesService.getNotesFromTask(vm.tazk.task)
            .then(function (notes) {
              vm.notes = notes
            })
            .catch(function (err) {
              vm.error = true
              throw "Failed task notes " + errorHelperService.formatError(err)
            })
        }

        function isNoteFromSelf(note) {
          return note.userId === vm.userId
        }

        function startSend() {
          if (vm.compose.message.length === 0) {
            return
          }

          if (userProfileService.isAllowedTo.sendInternalNotes) {
            vm.compose.state = 'sendingInternal'
          } else {
            send(false);
          }
        }

        function send(isNoteInternal) {
          $log.debug("sending message '" + vm.compose.message + "'")
          vm.busy = true
          taskNotesService.sendNoteForTask(vm.tazk.task, vm.compose.message, isNoteInternal, vm.compose.projectRoleMappings)
            .then(function () {
              vm.compose.state = 'writing'
              vm.compose.message = ''
              vm.busy = false
            })
            .catch(function () {
              vm.compose.state = 'writing'
              vm.busy = false
            })
        }

        function cancelSend() {
          vm.compose.state = 'writing'
        }
      }
    });
})();

(function () {
  angular.module('gfApp')
    .directive('tazkFields', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/directives/tazkBehaviours/tazkFields.directive.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('tazkCustomerChat', function ($timeout, concernService, customerChatService, notificationService, errorHelperService, userProfileService) {
      return {
        restrict: 'E',
        controllerAs: 'vm',
        scope: {},
        bindToController: {
          tazk: "="
        },
        templateUrl: 'app/directives/tazkBehaviours/tazkCustomerChat.directive.html',
        link: function ($scope, element) {

          $scope.$watch(function () {
            return $scope.vm.showStoreDropdown
          }, function (newVal) {
            if (newVal) {

              var dropdownToClick = element.find(".ui-select-toggle")[0];

              var inputToFocus = element.find("input.ui-select-search")[0];
              $timeout(function () {
                dropdownToClick.click();
                inputToFocus.focus();
              });

            }
          });

          $scope.$watch(function () {
            return $scope.vm.showProjectInstanceDropdown
          }, function (newVal) {
            if (newVal) {

              var dropdownToClick = element.find(".ui-select-toggle")[1];

              var inputToFocus = element.find("input.ui-select-search")[1];
              $timeout(function () {
                dropdownToClick.click();
                inputToFocus.focus();
              });

            }
          });
        },
        controller: function($rootScope, $scope, concernService){
          var vm = this;

          vm.busy = false;
          vm.messageUserId = ''
          vm.userId = ''
          vm.compose = {
            message: '',
            projectInstance: {}
          }
          vm.hasShownProjectInstanceBox = false
          vm.isMessageFromSelf = isMessageFromSelf
          vm.chats = []
          vm.storeResults = []
          vm.selectedStore = null
          vm.selectedProjectInstance = null
          vm.getProjects = getProjects
          vm.search = search
          vm.concernPager = concernService.concernPager
          vm.showAttachProjectInstance = showAttachProjectInstance
          vm.hideAttachProjectInstance = hideAttachProjectInstance
          vm.attachProjectInstanceOn = false
          vm.attachProjectInstance = attachProjectInstance
          vm.removeProjectInstance = removeProjectInstance
          vm.canAttachProjectInstance = canAttachProjectInstance
          vm.showStoreDropdown = false
          vm.showProjectInstanceDropdown = false
          vm.showAttachedProjectInstance = showAttachedProjectInstance
          vm.sendMessage = sendMessage
          vm.readMessages = readMessages
          vm.userCanSeeAtLeastOneStore = false;
          activate()

          function activate(){

            vm.messageUserId = vm.tazk.task.userId;

            loadMessages()

            concernService.initialSearch()
              .then(function(data){
                vm.userCanSeeAtLeastOneStore = data && data.length > 0;
                return;
              })
              .catch(function(ex){

                throw "Failed to load support messages " + errorHelperService.formatError(ex)
              })


            setUser();
            if(vm.tazk.task.id !== 'customer-support-chat') {
              // to not nag the user to attach a project instance
              vm.hasShownProjectInstanceBox = true;
            }

            var newSupportMessageHandler = $rootScope.$on("appNotificationHub:newSupportMessage", loadMessages);
            $scope.$on("destroy", newSupportMessageHandler)

            vm.concernPager = concernService.concernPagerWithProjectInstances()
          }

          function setUser() {
            userProfileService.userLoaded.then(function (user) {
              vm.userId = user.id
            })
          }

          function loadMessages() {
            customerChatService.getCustomerSupportMessages(vm.messageUserId)
              .then(function (chats) {
                vm.chats = chats;
                vm.tazk.isBlocked = false
                vm.tazk.task.loaded = true;
              })
              .catch(function(ex){
                vm.tazk.isBlocked = false
                vm.tazk.task.loaded = true;

                throw "Failed to load support messages " + errorHelperService.formatError(ex)
              })

          }

          function isMessageFromSelf(message) {
            return message.writerId === vm.userId
          }

          function sendMessage() {
            if (!vm.hasShownProjectInstanceBox && vm.userCanSeeAtLeastOneStore) {
              showAttachProjectInstance();
            } else {
              vm.busy = true;
              var message = {
                body: vm.compose.message,
                userId: vm.messageUserId
              };
              if (vm.compose.projectInstance && vm.compose.projectInstance.id) {
                message.projectInstanceId = vm.compose.projectInstance.id
              }

              customerChatService.sendMessage(message)
                .then(function () {
                  loadMessages();
                  resetCompose();
                  vm.busy = false;
                  $rootScope.$emit('savedSupportChatMessage', message);
                }).catch(function (error) {
                vm.busy = false;
                notificationService.error('notification.error.supportuser.allmessages');
                throw "Failed to send the support chat message " + errorHelperService.formatError(error);
              });
            }
          }

          function resetCompose() {
            vm.compose = {
              message: '',
              projectInstance: {}
            }
          }

          function getProjects() {
            if (vm.selectedStore.projectInstances
              && vm.selectedStore.projectInstances.length === 1) {
              attachProjectInstance(vm.selectedStore.projectInstances[0])
            } else {
              vm.selectedProjectInstance = null;
              vm.showStoreDropdown = false;
              vm.showProjectInstanceDropdown = true;
            }
          }

          function search(searchText) {
            vm.concernPager.reset();
            return vm.concernPager.nextPage(searchText);

          }

          function showAttachProjectInstance() {

            if (vm.concernPager.items && vm.concernPager.items.length === 1) {
              vm.selectedStore = vm.concernPager.items[0];
              vm.attachProjectInstanceOn = true;
              getProjects();

            } else {
              vm.attachProjectInstanceOn = true;
              vm.showStoreDropdown = true;
              vm.showProjectInstanceDropdown = false;
            }

          }

          function hideAttachProjectInstance() {
            vm.attachProjectInstanceOn = false;
            vm.showStoreDropdown = false;
            vm.showProjectInstanceDropdown = false;
            vm.hasShownProjectInstanceBox = true;
            vm.selectedStore = null;
            vm.selectedProjectInstance = null;
          }

          function attachProjectInstance(item) {

            vm.compose.projectInstance = item;
            vm.selectedStore = null;
            vm.selectedProjectInstance = null;
            hideAttachProjectInstance();
          }

          function removeProjectInstance() {
            vm.compose.projectInstance = {};
          }

          function canAttachProjectInstance() {
            return vm.selectedProjectInstance !== null;
          }

          function showAttachedProjectInstance(){
            return Object.keys(vm.compose.projectInstance).length > 0;
          }

          function readMessages(){
            customerChatService.readMessages(vm.messageUserId).then(function(chats){
              vm.chats = chats;
            })
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('projectInstanceList', function (pagerService, projectInstanceDetailService) {
      return {
        scope: {},
        controllerAs: 'vm',
        templateUrl: 'app/directives/shared/projectinstance.list.html',
        bindToController: {
          ngModel: "=",
          filter: "=?"
        },
        controller: controller
      }

      function controller() {
        var vm = this

        activate()

        /////////

        function activate(){
          vm.pager = new pagerService.Pager({
            resource: vm.ngModel.resource,
            mapper: projectInstanceDetailService.maps.Project,
            initialRel: 'projectsmilestones',
            nextPageRel: 'next',
            dataRel: 'project-detail',
            defaultSearchCriteria: vm.filter,
            pageSize: 10,
            append:false,
            fetchOnInit: true
          })

          vm.ngModel.pager = vm.pager
          
          vm.pager.reset()
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('milestoneList', function () {
      return {
        scope: {},
        required:'A',
        controllerAs: 'vm',
        templateUrl: 'app/directives/shared/milestone.list.html',
        bindToController: {
          milestoneList: "="
        },
        controller: function(){

        }
      }
    })
})();

/*eslint angular/no-services: [2,["q"],["directive"]]*/

(function () {
  angular.module('gfApp')
    .directive('licensed', function ($translate, licensingService) {
      return {
        restrict: 'A',
        link: function (scope, elem) {
          var license = licensingService.license;
          var removeAttrs = ['ui-sref','title'];

          if(license.isExpiredInGracePartialBlock){
            elem.off('click')
            angular.forEach(removeAttrs, function(a) {elem.removeAttr(a)})
            elem.addClass('disabled')
            elem.attr('disabled','disabled')
            elem.attr('title',$translate.instant('licenses.expiredlicense'))
            elem.on('click',function(e){e.stopPropagation()})
          }
        }
      }
    })
})();

/*eslint angular/no-services: [2,["q"],["directive"]]*/

(function () {
  angular.module('gfApp')
    .directive('canDo', function ($q, $timeout, permissionService, configService) {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          var hide = angular.isUndefined(attrs.cannotDoClass) && angular.isUndefined(attrs.cannotDoRemoveAttr)

          if (hide) {
            elem.hide()
          }

          var promises = []

          if(attrs.feature){
            promises.push($q(function(r){return r(configService.appSettings.features[attrs.feature])}))
          }

          if(attrs.canDo){
            promises.push(permissionService.canOr(attrs.canDo))
          }

          $q.all(promises).then(function(values){
            var result = true

            // if feature is disabled then it won't be an 'OR' check
            if(attrs.feature && !values[0]){
              result = false
            }else{
              result = !values.some(function(m){return !m})
            }

            if (angular.isDefined(attrs.negate)) {
              result = !result
            }

            if (hide) {
              if (result) {
                elem.show()
              } else {
                elem.remove()
              }
            } else if (!result) {
              if (attrs.cannotDoClass) {
                elem.addClass(attrs.cannotDoClass)
              }

              if (attrs.cannotDoRemoveAttr) {
                angular.forEach(attrs.cannotDoRemoveAttr.split(','), function (a) {
                  $timeout(function(){
                    elem.removeAttr(a)

                    if (a === 'ui-sref') {
                      elem.unbind('click')
                    }
                  },1);

                })
              }
            }
          })
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('actionRedirect', function (permissionService, $state) {
      return {
        restrict: 'E',
        scope: {callback: '&'},
        link: function (scope) {
          permissionService.canOr($state.current.data.action)
            .then(function (result) {
              if (result) {
                scope.callback()
              } else {
                $state.go("siskin.dashboard")
              }
            })
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('selectable', function () {
      this.touchMode = false;
      var me = this;

      return {
        require: ['?gallery', '?filelist'],
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs, ctrls) {

          function stopEventPropagation(event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
          }

          for (var i = 0; i < ctrls.length; i++) {
            var ctrl = ctrls[i];

            if (ctrl === null) {
              continue;
            } else {
              var ctrlScope = ctrl.scope.vm;
              ctrlScope.isSelectable = true;

              var toggleSelect = function (index) {
                var file = ctrlScope.list[index];

                if (angular.isUndefined(file.deselect)) {
                  file.deselect = function () {
                    file.selected = false;
                  }
                }

                if (file.selected === true) {
                  file.deselect();
                } else {
                  file.selected = true;
                }
              }

              ctrlScope.totalSelected = function () {
                var total = 0;
                angular.forEach(ctrlScope.list, function (item) {
                  if (item.selected) {
                    total++;
                  }
                });
                return total;
              }

              ctrlScope.onLongPress = function (index, event) {
                //vibrator.vibrate();
                stopEventPropagation(event);
                toggleSelect(index);
                ctrlScope.list[index].hover = false;
                me.touchMode = true;
              }

              ctrlScope.onClick = function (index, event) {
                if (ctrlScope.totalSelected() > 0) {
                  toggleSelect(index);
                  stopEventPropagation(event);
                }
              }

              ctrlScope.onClickSelect = function (index, event) {
                if (me.touchMode) return;
                toggleSelect(index);
                stopEventPropagation(event);
              }

              ctrlScope.onMouseOver = function (index) {
                if (me.touchMode) return;
                ctrlScope.list[index].hover = true;
              }

              ctrlScope.onMouseLeave = function (index) {
                if (me.touchMode) return;
                ctrlScope.list[index].hover = false;
              }
            }
          }
        }
      }
    });
})();

/*global blueimp:false*/
(function () {
  angular.module('gfApp')
    .directive('gallery', function (fileTypeService, fileService, imageControlService, configService) {
      return {
        restrict: 'E',
        scope: {},
        bindToController: {
          list: '=',
          autoRefresh: '@',
          class: '@?',
          ngClickItem: '=?',
          canApprove: '=?',
          approve: '=?',
          parent: '=?',
          hideUnapproved: '=?',
          disableOrdering: '=?',
          disableRotating: '=?'
        },
        controllerAs: 'vm',
        controller: controller,
        link: link,
        templateUrl: 'app/directives/fileGallery/gallery.html'
      }

      function controller($scope) {
        var vm = this;

        if(vm.list.length){
          vm.list = vm.list.filter(function(m){ return m.isUploaded; });
        }

        vm.autoRefresh = vm.autoRefresh === 'true'
        vm.disableOrdering = vm.disableOrdering === true;
        vm.disableRotating = vm.disableRotating === true;
        vm.scope = $scope
        vm.canApprove = configService.appSettings.features.supportApproveImages && vm.canApprove === true

        vm.fallbackImage = fallbackImage
        vm.clickItem = clickItem

        vm.sortableOptions = {
          stop: function() {
            vm.list.map(function(f, index){
              if(f.listOrder != index){
                f.listOrder = index;
                if(f.resource){
                  fileService.update(f);
                }
                else{
                  fileService.update({resource: f, listOrder: index});
                }
              }
            });
          },
          disabled: vm.disableOrdering
         };
        ////////////


        function fallbackImage(file){
          return fileTypeService.getFallbackSrcByFileExtension(file.extension)
        }

        function clickItem(m,$event){
          if(angular.isDefined(vm.ngClickItem)){
            vm.ngClickItem(m,$event)
          }
        }

      }

      function link(scope, element) {
        if (angular.isUndefined(blueimp)) {
          throw 'blueimp gallery couldnt be found';
        }




        // blueimp binding
        element.on('click', '.gallery', function (event) {
          // todo: suggested way, removing since it shouldn't be necessary;
          // event = event || $window.event;
          var target = event.target || event.srcElement;
          var link = target.src ? target.parentNode : target;
          if (link.tagName !== 'A') {
            return;
          }

          var disableRotating = target.getAttribute("data-disableRotate");
          var rotateElement = angular.element('.rotate-control');

          if(rotateElement){
            rotateElement.off('click')
            rotateElement.on('click', function() {rotateCurrentImage(scope.vm.list)});

            if(disableRotating == 'true'){
              rotateElement.hide();
            }else{
              rotateElement.show();
            }
          }

          var options = {
            index: link,
            event: event,
            container: angular.element('#blueimp-gallery'),
            onslide: function (index, slide) {
              var id = this.list[index].getAttribute('data-id');
              imageControlService.updateImageSrc(slide.firstChild)

              var rotateElement = angular.element('.rotate-control');
              rotateElement.attr('data-id',id);
              rotateElement.attr('data-index',index);
            }
          };

          // blueimp gallery options for configuration
          // angular.extend(options, scope.options);

          // todo: if this is slow cache results, make sure to add the new images

          if(angular.isDefined(scope.vm.parent) && element.closest(scope.vm.parent).length){
            blueimp.Gallery(element.closest(scope.vm.parent).find('.js-gallery__item'), options)
          }else{
            blueimp.Gallery(this.getElementsByClassName('js-gallery__item'), options)
          }




        });

        function rotateCurrentImage(list){
          var element = angular.element('.rotate-control')[0]
          var id = element.getAttribute("data-id");
          var file = list.filter(function(f){return f.id === id})[0];
          var index = element.getAttribute("data-index");

          fileService.rotate(file)
          .then(function(){
            refreshGalleryDisplayImage(index);
            rotateImageById("thumbnail-"+id);
          });
        }
      }




      function rotateImageById(id){
        var image = angular.element('#'+id);
        imageControlService.updateImageSrc(image[0])
      }

      function refreshGalleryDisplayImage(index){
        var image = angular.element("[data-index='" + index + "']").find("img.slide-content");
        if(image && image.length > 0){
          imageControlService.updateImageSrc(image[0])
        }
      }
    });
})();

(function () {
  angular.module('gfApp')
    .directive('filelist', function ($log, fileTypeService,fileService) {
      return {
        scope: {},
        restrict: 'E',
        bindToController: {
          list: '=',
          autoRefresh: '@',
          canApprove: '=?',
          approve: '=?',
          disableOrdering: '=?'
        },
        controllerAs: 'vm',
        controller: controller,
        templateUrl: 'app/directives/fileGallery/filelist.html'
      }

      function controller($scope) {
        var vm = this;

        if(vm.list.length){
          vm.list = vm.list.filter(function(m){ return m.isUploaded; });
        }
        
        vm.autoRefresh = vm.autoRefresh === 'true';
        vm.disableOrdering = vm.disableOrdering === true;
        vm.scope = $scope

        vm.uploadedList = uploadedList
        vm.fallbackImage = fallbackImage

        vm.sortableOptions = {
          stop: function() {
            vm.list.map(function(f, index){
              if(f.listOrder != index){
                f.listOrder = index;
                fileService.update(f);
              }
            });
          },
          disabled: vm.disableOrdering
         };

        //////////

        function fallbackImage(file) {
          return fileTypeService.getFallbackSrcByFileExtension(file.extension)
        }

        function uploadedList() {
          return vm.list.filter(function (f) {
            return f.isUploaded === true;
          })
        }

      }

    });
})();

(function () {
  angular.module('gfApp')
    .service('fileuploadFactory', fileuploadFactoryService);

  function fileuploadFactoryService($q) {
    function findIndexByKeyValue(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] == value) {
          return i;
        }
      }
      return null;
    }

    function getFileIndex(id, fileUploads) {
      return findIndexByKeyValue(fileUploads, 'id', id);
    }

    var completionPromise = function (updateFileCallback, fileUploads, fileFailures) {
      var complete = $q.defer();

      complete.promise.then(
        // -- completion
        function (data) {
          fileUploads.splice(getFileIndex(data.id, fileUploads), 1);
          updateFileCallback(data);
        }
        ,function () {} // -- using notify for failing promises
        ,function (data) {
          var index = getFileIndex(data.id, fileFailures);
          if(index === null){
            fileFailures.push(fileUploads[getFileIndex(data.id, fileUploads)])
          }

        });

      return complete;
    }

    var containerPromise = function (updateFileCallback) {
      var complete = $q.defer();

      complete.promise.then(function (data) {
        updateFileCallback(data)
      });

      return complete;
    }

    var file = function (fileObject, containerId, updateFileCallback, fileUploads, fileFailures) {
      return {
        fileObject: fileObject,
        containerId: containerId,
        completionPromise: completionPromise(updateFileCallback, fileUploads, fileFailures),
        containerPromise: containerPromise(updateFileCallback),
        percentageComplete: 0
      }
    }

    var waitForAllFilesToUpload = function (promises, allCompletedCallback) {
      $q.all(promises).then(function () {
        if (angular.isDefined(allCompletedCallback)) {
          allCompletedCallback();
        }
      });
    }

    return {
      file: file,
      completionPromise: completionPromise,
      waitForAllFilesToUpload: waitForAllFilesToUpload
    }
  }
})();

(function () {
  angular.module('gfApp')
    .directive('fileupload', fileuploadDirective);

  function fileuploadDirective(fileUploadOrchestrationService, $timeout, fileuploadFactory) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        container: "=",
        containerId: "=",
        allCompletedCallback: "=?",
        updateFileCallback: "=",
        startCallback: "=?",
        constraint: "=?",
        callbackStartProcess: "=",
        callbackEndProcess: "=",
        beforeUpload: "="
      },
      controllerAs: 'fileUploadCtrl',
      link: function (scope, element) {
        if (scope.fileuploadDisabled) {
          return;
        }

        var fileUpload = element.find('input');
        var dragDrop = element.find('.fileuploader__droparea');

        scope.getOverallProgress = function () {
          if (scope.fileHistory.length == 0) {
            return 0;
          }

          var total = 0;
          angular.forEach(scope.fileHistory, function (file) {
            total += file.percentageComplete;
          });

          scope.uploading = total != 0;

          return total / scope.fileHistory.length;
        }

        dragDrop.on('drop', function (e) {
          e.preventDefault();
          scope.uploadFiles(e.originalEvent.dataTransfer.files);
          scope.hovering = false;
        });

        dragDrop.on('dragleave', function (e) {
          e.preventDefault();
          scope.hovering = false;
          scope.$apply();
        });

        dragDrop.on('dragover', function (e) {
          e.preventDefault();
          scope.hovering = true;
          scope.$apply();
        });

        fileUpload.on('change', function () {
          if (fileUpload[0].files.length > 0) {
            scope.uploadFiles(fileUpload[0].files);
            fileUpload.val(null)
          }
        });

        scope.uploadFiles = function (files) {
          initOrResumeUpload();

          if (scope.fileQueue.length > 0) {
            // -- in case there are already files on queue, ignore
            // the user trying to upload more files
            return;
          } else {
            scope.uploadFilesWithOrchestrator(files);
          }
        }

        scope.uploadFilesWithOrchestrator = function (files) {
          if(files.length > 0){
            startProcess();
          }

          if (angular.isDefined(scope.startCallback)) {
            scope.startCallback();
          }

          // this line would execute a filter/constraint on the file uploader this used for preventing
          // uploading more files than allowed (MultipleFile max files constraint)

          if (angular.isDefined(scope.constraint)) {
            files = scope.constraint(files);
          }

          scope.fileHistory = [];
          scope.fileFailures = [];
          scope.fileCount = files.length;
          scope.collapsed = true;
          angular.forEach(files, upload);
          scope.uploadFileInBlocks();
        }

        scope.uploadFileInBlocks = function () {
          $timeout(function () {
            var promises = [];
            var fileUploadObjects = fileUploadOrchestrationService.queueFileUpload(scope.fileQueue, scope.container, scope.containerId);
            angular.forEach(fileUploadObjects, function (fileObject) {
              promises.push(fileObject.completionPromise.promise);

              if (fileObject.status === 'Failed') {
                scope.fileFailures.push(fileObject);
              }

              scope.fileUploads.push(fileObject);
              scope.fileHistory.push(fileObject);
            });
            scope.fileQueue = [];

            fileuploadFactory.waitForAllFilesToUpload(promises, allCompletedCallback)
          })
        };

        scope.retry = function () {
          fileUploadOrchestrationService.retry(scope.containerId)
          scope.fileFailures.length = 0;
          startProcess();
        }

        scope.cancel = function () {
          fileUploadOrchestrationService.cancel(scope.fileUploads);
          scope.fileUploads.length = 0;
          stopProcess();
        }

        function allCompletedCallback(){
          stopProcess()

          if(angular.isDefined(scope.allCompletedCallback)){
            scope.allCompletedCallback()
          }
        }

        function stopProcess() {
          if(angular.isDefined(scope.callbackEndProcess)){
            scope.callbackEndProcess();
          }

          element.removeClass('fileuploader--uploading')
        }

        function startProcess() {
          if(angular.isDefined(scope.callbackStartProcess)){
            scope.callbackStartProcess();
          }

          element.addClass('fileuploader--uploading')
        }

        function initOrResumeUpload() {
          scope.fileQueue = [];
          scope.fileUploads = [];
          scope.fileFailures = [];
          scope.fileHistory = [];

          // -- check orchestrator for files on queue or uploading
          var files = fileUploadOrchestrationService.initOrResumeUpload(scope.containerId);

          if (files.length > 0) {
            scope.uploadFilesWithOrchestrator(files.map(function (f) {
              return f.file;
            }));
          }
        }

        function upload(fileObject) {
          var file = fileuploadFactory.file(
            fileObject,
            scope.container,
            scope.updateFileCallback,
            scope.fileUploads,
            scope.fileFailures
          );

          if(angular.isDefined(scope.beforeUpload)){
            scope.beforeUpload(file)
          }

          scope.fileQueue.push(file);
        }

        // -- init or resume existing upload
        initOrResumeUpload();

      },
      templateUrl: 'app/directives/fileGallery/fileUpload.html'
    }
  }
})();

(function () {
  angular.module('gfApp')
    .directive('fieldUser', function ($log, dataValueService, scrollingService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function () {

          var vm = this;
          vm.hasError = hasError
          var oldSelectedUser;
          if(angular.isDefined(vm.field.value)){
            oldSelectedUser = vm.field.value.selectedUser;
          }
          vm.setValue = setValue

          //////////

          var saveError = false

          function setValue() {
            var loggedUserId = undefined;
            if (angular.isDefined(vm.field.value.selectedUser)) {
              loggedUserId = vm.field.value.selectedUser.userId
            }

            $log.debug("saving user '" + loggedUserId + "'")
            setBusy(true)

            dataValueService.saveDataValue(vm.field.field, vm.field.value)
              .then(function () {
                $log.debug("successfully saved '" + loggedUserId + "'")
                oldSelectedUser = vm.field.value.selectedUser
                saveError = false
                setBusy(false)
              })
              .catch(function () {
                vm.field.value.selectedUser = oldSelectedUser
                saveError  = true
                setBusy(false)
                throw "Failed to save data reset to " + loggedUserId
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },
        link: function (scope, element) {
          scrollingService.scrollOnResize(scope, element, function () {
            return element.find(".ui-select-container.open").length > 0;
          },40);
        },
        templateUrl: 'app/directives/fields/user.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldString', function ($log, $timeout, dataValueService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },

        controller: function () {
          var vm = this
          vm.setValue = setValue
          vm.hasError = hasError

          ///////

          var saveError = false;
          var oldValue = vm.field.value;

          function setValue(val) {
            $log.debug('saving ' + val)
            setBusy(true)

            dataValueService.saveDataValue(vm.field.field, val)
              .then(function () {
                $log.debug('successfully saved "' + val + '"')
                oldValue = val
                saveError = false
                setBusy(false)
              })
              .catch(function () {
                vm.field.value = oldValue
                saveError = true
                setBusy(false)
                throw "Failed to save data reset to '" + vm.field.value + "'"
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },

        templateUrl: 'app/directives/fields/string.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldLink', function ($log, dataValueService, gfHelper) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },

        controller: function () {
          var vm = this
          vm.setValue = setValue
          vm.hasError = hasError

          ///////

          var saveError = false;
          var oldValue = vm.field.value;

          function setValue(val) {
            $log.debug('saving ' + val)
            setBusy(true)

            dataValueService.saveDataValue(vm.field.field, val)
              .then(function () {
                $log.debug('successfully saved "' + val + '"')
                oldValue = val
                saveError = false
                setBusy(false)
              })
              .catch(function () {
                vm.field.value = oldValue
                saveError = true
                setBusy(false)
                throw "Failed to save data reset to '" + vm.field.value + "'"
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = !gfHelper.isNullOrEmpty(vm.field.highlightRequiredAction) && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },

        templateUrl: 'app/directives/fields/link.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldInteger', function ($log, $rootScope, dataValueService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function ($scope) {
          var vm = this;
          vm.setValue = setValue
          vm.hasError = hasError

          var saveError = false
          var oldValue = vm.field.value;

          var d = $rootScope.$on('updateDraftValues['+vm.field.field.dataValueId+']', function (message,value) {
            if(vm.field.value != value){
            vm.field.value = value
            }
          })
          $scope.$on('destroy', d)

          function setValue(val) {
            $log.debug('saving ' + val)
            setBusy(true)

            dataValueService.saveDataValue(vm.field.field, val)
            .then(function (data) {
                $log.debug('successfully saved "' + val + '"')
                oldValue = val
                saveError = false
                angular.forEach(data.updatedDataValues, function (newValue) {
                  $rootScope.$broadcast("updateDraftValues["+newValue.id+"]",newValue.value)
                })
                setBusy(false)
              })
              .catch(function () {
                vm.field.value = oldValue
                saveError = true
                setBusy(false)
                throw "Failed to save data reset to '" + vm.field.value + "'"
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },
        templateUrl: 'app/directives/fields/integer.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldGroup', function ($log, dataValueService, scrollingService, gfHelper, groupService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function () {
          var vm = this;

          vm.hasError = hasError

          groupService.initialize()
          vm.pager = groupService.pager

          var oldSelected;
          if(angular.isDefined(vm.field.value)){
            oldSelected = vm.field.value.selected;
          }
          vm.setValue = setValue

          //////////

          var saveError = false

          function setValue() {
            var groupId = undefined;
            if (angular.isDefined(vm.field.value.selected)) {
              groupId = vm.field.value.selected.id
            }

            $log.debug("saving group '" + groupId + "'")
            setBusy(true)

            dataValueService.saveDataValue(vm.field.field, vm.field.value)
              .then(function () {
                $log.debug("successfully saved '" + groupId + "'")
                oldSelected = vm.field.value.selected
                saveError = false
                setBusy(false)
              })
              .catch(function () {
                vm.field.value.selected = oldSelected
                saveError  = true
                setBusy(false)
                throw "Failed to save data reset to " + groupId
              })
          }

          function hasError() {
            vm.field.hasError = saveError 
            vm.field.hasRequiredError = !gfHelper.isNullOrEmpty(vm.field.highlightRequiredAction) && !dataValueService.hasValue(vm.field)

            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },
        link: function (scope, element) {
          scrollingService.scrollOnResize(scope, element, function () {
            return element.find(".ui-select-container.open").length > 0;
          },40);
        },
        templateUrl: 'app/directives/fields/group.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldSimpleFiles', function ($log, dateTimeService, dataValueService, fileService) {
      return {
        scope: {},
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "=",  // TODO: TS-2101
          parent: "@?"
        },
        controllerAs: 'vm',
        controller: function () {
          var vm = this;

          vm.placeholder = true

          vm.hasError = hasError
          vm.addOrUpdateFile = addOrUpdateFile
          vm.allCompletedCallback = allCompletedCallback
          vm.startUpload = startUpload
          vm.toggleViewMode = toggleViewMode
          vm.constraint = constraint
          vm.anyFileSelected = anyFileSelected
          vm.removeSelected = removeSelected
          vm.totalFiles = totalFiles
          vm.startProcess = startProcess
          vm.endProcess = endProcess
          vm.approve = approve

          activate();

          ///////

          function activate() {
            if (angular.isUndefined(vm.field.content)) {
              vm.field.content = [];
            }
            angular.forEach(vm.field.content, function (file) {
              file.uploadedOnStr = dateTimeService.formatFromUtc(file.uploadedOn);
            });

            init();
            refreshDisplayMode();
          }

          function addOrUpdateFile(data) {
            if (angular.isDefined(data.fileResource)) {
              for (var i = 0; i < vm.field.content.length; i++) {
                var file = data.fileResource;
                if (vm.field.content[i].id === file.id) {
                  data.fileResource.uploadedOnStr = dateTimeService.formatFromUtc(file.uploadedOn);
                  vm.field.content.splice(i, 1);
                  vm.field.content.splice(i, 0, file);
                  vm.totalFilesUploaded++;
                  break;
                }
              }
            } else {
              vm.field.content.splice(0, 0, data);
            }
          }

          function allCompletedCallback() {
            if (vm.wasEmpty) {
              refreshDisplayMode();
            }
          }

          function startUpload() {
            init();
          }

          function toggleViewMode() {
            vm.galleryViewMode = !vm.galleryViewMode;
          }

          function constraint(files) {
            if (vm.field.field.maxFiles) {
              var limit = Math.max(0, vm.field.field.maxFiles - vm.field.content.filter(function(f){return f.isUploaded}).length);
              if (limit < files.length) {
                vm.maxFilesReached = true;
                return Array.from(files).slice(0, limit);
              }
            }

            return files;
          }

          function anyFileSelected() {
            for (var i = 0; i < vm.field.content.length; i++) {
              if (vm.field.content[i].selected) {
                return true;
              }
            }
            return false;
          }

          function removeSelected() {
            $log.debug('deleting selected files')

            removeFiles(vm.field.content.filter(function (f) {
              return f.selected === true;
            }), true);
          }

          function removeFiles(files, firstDelete) {
            if (files.length !== 0) {
              var file = files.pop();

              startProcess()
              $log.debug('deleting file: ' + file.id);
              fileService.remove(file)
                .then(function () {
                  if (firstDelete) init();
                  if (angular.isDefined(file.deselect)) file.deselect();

                  vm.field.content.splice(vm.field.content.indexOf(file), 1);
                  vm.totalFilesDeleted++;

                  if(files.length !== 0){
                    removeFiles(files, false);
                  }else{
                    endProcess()
                  }
                })
            }else{
              endProcess()
            }
          }

          function init() {
            vm.wasEmpty = vm.field.content.length === 0;
            vm.totalFilesUploaded = 0;
            vm.totalFilesDeleted = 0;
            vm.maxFilesReached = false;
          }

          function totalFiles() {
            return vm.field.content.filter(function (f) {
              return f.isUploaded === true;
            }).length;
          }

          function refreshDisplayMode() {
            var uploaded = vm.field.content.filter(function (m) {
              return m.isUploaded;
            })

            vm.galleryViewMode = uploaded.filter(function (m) {
                return m.isImage;
              }).length / uploaded.length >= 0.75;
          }

          function hasError() {
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            vm.field.hasError = vm.field.hasRequiredError

            return vm.field.hasError
          }

          function startProcess() {
            setBusy(true);
          }

          function endProcess() {
            setBusy(false);
          }

          function setBusy(val) {
            if (angular.isDefined(vm.contextEntity)) {
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }

          function approve(file, value){
            if(file.isApproved === value){
              file.isApproved = undefined
            }else{
              file.isApproved = value
            }

            fileService.update(file)
          }
        },
        templateUrl: 'app/directives/fields/files.simple.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldFiles', function ($log, dateTimeService, dataValueService, errorHelperService, fileService, imageControlService) {
      return {
        scope: {},
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "=",  // TODO: TS-2101,
          parent: "@?"
        },
        controllerAs: 'vm',
        controller: function () {
          var vm = this;

          vm.hasError = hasError
          vm.addOrUpdateFile = addOrUpdateFile
          vm.allCompletedCallback = allCompletedCallback
          vm.startUpload = startUpload
          vm.toggleViewMode = toggleViewMode
          vm.constraint = constraint
          vm.anyFileSelected = anyFileSelected
          vm.allSelectedAreImages = allSelectedAreImages
          vm.rotateSelectedImages = rotateSelectedImages
          vm.removeSelected = removeSelected
          vm.totalFiles = totalFiles
          vm.startProcess = startProcess
          vm.endProcess = endProcess
          vm.approve = approve

          activate();

          ///////

          function activate() {
            if (angular.isUndefined(vm.field.content)) {
              vm.field.content = [];
            }
            angular.forEach(vm.field.content, function (file) {
              file.uploadedOnStr = dateTimeService.formatFromUtc(file.uploadedOn);
            });

            init();
            refreshDisplayMode();
          }

          function addOrUpdateFile(data) {
            if (angular.isDefined(data.fileResource)) {
              for (var i = 0; i < vm.field.content.length; i++) {
                var file = data.fileResource;
                if (vm.field.content[i].id === file.id) {
                  data.fileResource.uploadedOnStr = dateTimeService.formatFromUtc(file.uploadedOn);
                  vm.field.content.splice(i, 1);
                  vm.field.content.splice(i, 0, file);
                  vm.totalFilesUploaded++;
                  break;
                }
              }
            } else {
              vm.field.content.splice(0, 0, data);
            }
          }

          function approve(file, value){
            if(file.isApproved === value){
              file.isApproved = undefined
            }else{
              file.isApproved = value
            }

            fileService.update(file)
          }

          function allCompletedCallback() {
            if (vm.wasEmpty) {
              refreshDisplayMode();
            }
          }

          function startUpload() {
            init();
          }

          function toggleViewMode() {
            vm.galleryViewMode = !vm.galleryViewMode;
          }

          function constraint(files) {
            if (vm.field.field.maxFiles) {
              var limit = Math.max(0, vm.field.field.maxFiles - vm.field.content.filter(function(f){return f.isUploaded}).length);
              if (limit < files.length) {
                vm.maxFilesReached = true;
                return Array.from(files).slice(0, limit);
              }
            }

            return files;
          }

          function anyFileSelected() {
            for (var i = 0; i < vm.field.content.length; i++) {
              if (vm.field.content[i].selected) {
                return true;
              }
            }
            return false;
          }

          function allSelectedAreImages(){
            return vm.field.content.every(function (m) {
              return !m.selected || m.isImage
            })
          }

          function removeSelected() {
            $log.debug('deleting selected files')

            removeFiles(vm.field.content.filter(function (f) {
              return f.selected === true;
            }), true);
          }

          function removeFiles(files, firstDelete) {
            if (files.length !== 0) {
              var file = files.pop();

              startProcess()
              $log.debug('deleting file: ' + file.id);
              fileService.remove(file)
                .then(function () {
                  if (firstDelete) init();
                  if (angular.isDefined(file.deselect)) file.deselect();

                  vm.field.content.splice(vm.field.content.indexOf(file), 1);
                  vm.totalFilesDeleted++;

                  if(files.length !== 0){
                    removeFiles(files, false);
                  }else{
                    endProcess()
                  }
                })
            }else{
              endProcess()
            }
          }

          function rotateSelectedImages(){
            rotateImages(vm.field.content.filter(function (f) {
              return f.selected && f.isImage
            },true))
          }

          function rotateImages(files, firstRotate){
            if (files.length !== 0){
             var file = files.pop()
             fileService.rotate(file)
             .then(function(){
               if (firstRotate) vm.init()
               if (angular.isDefined(file.deselect)) file.deselect()
               vm.totalFilesRotated++
               
               rotateImageById("thumbnail-"+file.id)
               if (files.length !== 0) {
                 rotateImages(files, false)
               }
             })
           }
         }

         function rotateImageById(id){
          var image = angular.element('#'+id);

          imageControlService.updateImageSrc(image[0])
        }

          function init() {
            vm.wasEmpty = vm.field.content.length === 0;
            vm.totalFilesUploaded = 0;
            vm.totalFilesDeleted = 0;
            vm.maxFilesReached = false;
          }

          function totalFiles() {
            return vm.field.content.filter(function (f) {
              return f.isUploaded === true;
            }).length;
          }

          function refreshDisplayMode() {
            var uploaded = vm.field.content.filter(function (m) {
              return m.isUploaded;
            })

            vm.galleryViewMode = uploaded.filter(function (m) {
                return m.isImage;
              }).length / uploaded.length >= 0.75;
          }

          function hasError() {
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            vm.field.hasError = vm.field.hasRequiredError

            return vm.field.hasError
          }

          function startProcess() {
            setBusy(true);
          }

          function endProcess() {
            setBusy(false);
          }

          function setBusy(val) {
            if (angular.isDefined(vm.contextEntity)) {
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },
        templateUrl: 'app/directives/fields/files.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldValue', function ($timeout, userService, groupService, configService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          readOnly: "@?"
        },
        templateUrl: 'app/directives/fields/fieldValue.html',
        controller: function(){
          var vm = this
          vm.decimalsLength = configService.appSettings.decimalsLength

          vm.readOnly = vm.readOnly !== 'false'
          $timeout(function(){
            vm.readOnly = vm.readOnly !== 'false'
          })
          vm.setValue = setValue

          activate()

          ///////////////

          function activate(){
            if(vm.field.type === "user"){
              vm.pager = userService.Pager()
            }

            if(vm.field.type === "group"){
              vm.pager = groupService.Pager()
            }
          }

          function setValue(val) {
            if(typeof val === "boolean"){
              vm.field.value = vm.field.value === val ? null : val;
            }else{
              vm.field.value = val
            }
          }

        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldDropdown', function ($log, dataValueService, scrollingService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function () {
          var vm = this;
          vm.hasError = hasError
          vm.setValue = setValue

          //////////

          var saveError = false;

          function setValue() {
            var backup = cloneCurrentValue()
            $log.debug('saving ' + getDisplayString())
            setBusy(true)

            dataValueService.saveDataValue(vm.field.field, vm.field.value)
              .then(function () {
                $log.debug('successfully saved ' + getDisplayString())
                saveError = false
                setBusy(false)
              })
              .catch(function () {
                resetTo(backup)
                saveError = true
                setBusy(false)
                throw 'Failed to save data reset to ' + getDisplayString()
              })
          }

          function resetTo(backup) {
            vm.field.value.selectedValues = backup
          }

          function cloneCurrentValue() {
            return vm.field.value.selectedValues.slice()
          }

          function getDisplayString() {
            return "'" + vm.field.value.selectedValues + "'";
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }

        },
        link: function (scope, element) {
          scrollingService.scrollOnResize(scope, element, function () {
            return element.find(".ui-select-container.open").length > 0;
          },40);
        },
        templateUrl: 'app/directives/fields/dropdown.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldDouble', function ($log, $rootScope, dataValueService, configService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function ($scope) {
          var vm = this;
          vm.setValue = setValue
          vm.hasError = hasError
          vm.decimalsLength = configService.appSettings.decimalsLength

          var saveError = false
          var oldValue = vm.field.value

          var d = $rootScope.$on('updateDraftValues['+vm.field.field.dataValueId+']', function (message,value) {
            if(vm.field.value != value){
              vm.field.value = value
            }
          })
          $scope.$on('destroy', d)

          function setValue(val) {
            $log.debug('saving ' + val)
            setBusy(true)

            dataValueService.saveDataValue(vm.field.field, val)
              .then(function (data) {
                $log.debug('successfully saved "' + val + '"')
                oldValue = val
                saveError = false
                angular.forEach(data.updatedDataValues, function (newValue) {
                  $rootScope.$broadcast("updateDraftValues["+newValue.id+"]",newValue.value)
                })
                setBusy(false)
              })
              .catch(function () {
                vm.field.value = oldValue
                saveError = true
                setBusy(false)
                throw "Failed to save data reset to '" + vm.field.value + "'"
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },
        templateUrl: 'app/directives/fields/double.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldDatetime', function ($log, dataValueService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function () {
          var vm = this
          vm.setValue = setValue
          vm.hasError = hasError

          var saveError = false
          var oldValue = vm.field.value;

          function setValue(val) {
            $log.debug('saving ' + val)
            setBusy(true)

            dataValueService.saveDataValue(vm.field.field, val)
              .then(function () {
                $log.debug('successfully saved "' + formatOrNull(val) + '"')
                oldValue = val
                saveError = false
                setBusy(false)
              })
              .catch(function () {
                vm.field.value = oldValue
                saveError = true
                setBusy(false)
                throw "Failed to save data reset to '" + formatOrNull(vm.field.value) + "'"
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function formatOrNull(val){
            if(angular.isUndefined(val) || val === null){
              return null
            } else {
              return val.format()
            }
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }

        },
        templateUrl: 'app/directives/fields/datetime.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldDate', function ($log, dataValueService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function () {
          var vm = this;
          vm.setValue = setValue
          vm.hasError = hasError

          ///////

          var oldValue = vm.field.value;
          var saveError = false

          function setValue(val) {
            $log.debug('saving ' + val)

            setBusy(true)
            dataValueService.saveDataValue(vm.field.field, val)
              .then(function () {
                $log.debug('successfully saved "' + formatOrNull(val) + '"')
                oldValue = val
                saveError = false
                setBusy(false)
              })
              .catch(function () {
                vm.field.value = oldValue
                saveError = true
                setBusy(false)
                throw "Failed to save data reset to '" + formatOrNull(vm.field.value) + "'"
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function formatOrNull(val){
            if(angular.isUndefined(val) || val === null){
              return null
            } else {
              return val.format()
            }
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },
        templateUrl: 'app/directives/fields/date.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldConfirmation', function ($log, $timeout, dataValueService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function () {
          var vm = this;
          vm.toggle = toggle
          vm.hasError = hasError

          activate();

          ///////

          var saveError = false
          var oldValue = vm.field.value;

          function activate() {
            // This is the only non-nullable field type
            if (angular.isUndefined(vm.field.value) || vm.field.value === null) {
              vm.field.value = false;
            }
          }

          function toggle() {
            vm.field.value = !vm.field.value;
            setBusy(true)
            var val = vm.field.value

            dataValueService.saveDataValue(vm.field.field, val)
              .then(function () {
                $log.debug('successfully saved "' + val + '"')
                oldValue = val
                saveError = false
                setBusy(false)
              })
              .catch(function () {
                // Make it more obvious that the value has been reset
                $timeout(function () {
                  vm.field.value = oldValue
                  saveError = true
                  setBusy(false)
                }, 100)

                throw "Failed to save data reset to '" + vm.field.value + "'"
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val) {
            if (angular.isDefined(vm.contextEntity)) {
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },
        templateUrl: 'app/directives/fields/confirmation.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('fieldBoolean', function ($log, $timeout, dataValueService) {
      return {
        scope: {},
        controllerAs: 'vm',
        bindToController: {
          field: "=",
          context: "@",       // TODO: TS-2101
          contextEntity: "="  // TODO: TS-2101
        },
        controller: function () {
          var vm = this;

          var oldValue = vm.field.value;
          vm.hasError = hasError
          vm.setValue = setValue

          var saveError = false

          function setValue(val) {
            if (vm.field.value === val) {
              val = null;
            }
            vm.field.value = val;
            setBusy(true);

            dataValueService.saveDataValue(vm.field.field, val)
              .then(function () {
                $log.debug('successfully saved "' + val + '"')
                oldValue = val
                saveError = false

                setBusy(false);
              })
              .catch(function () {
                // Make it more obvious that the value has been reset
                $timeout(function () {
                  vm.field.value = oldValue
                  setBusy(false);
                  saveError = true
                }, 100)

                throw "Failed to save data reset to '" + vm.field.value + "'"
              })
          }

          function hasError() {
            vm.field.hasError = saveError
            vm.field.hasRequiredError = vm.field.highlightRequiredAction !== '' && !dataValueService.hasValue(vm.field)
            return saveError || vm.field.hasRequiredError
          }

          function setBusy(val){
            if(angular.isDefined(vm.contextEntity)){
              vm.contextEntity.setBusyOperation(vm.field.isBusy, val);
            }

            vm.field.isBusy = val;
          }
        },
        templateUrl: 'app/directives/fields/boolean.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('authorizeDownload', function (fileEndpointService, configService) {
      return {
        restrict: 'A',
        scope: {},
        link: link
      }

      function link(scope, elem, attrs) {

        elem.on("click", function (event) {
          var url = attrs.href;

          if(url.indexOf(configService.api.app) >= 0){
            event.preventDefault();
            fileEndpointService.downloadFromUrlRedirect(url);
          }
        });
      }

    });
})();

(function () {
  angular.module('gfApp')
    .controller('SupportTeamController', function ($scope, $rootScope, $filter, supportTeamMessageService, tazkService, vibrator, notificationService, errorHelperService ) {
      var vm = this;
      var isRequestInProcess = false;
      var previewMaxLength = 128;

      vm.userMessages =[];
      vm.busy =false;
      vm.detailViewOn = false;
      vm.currentStoreName = '';
      vm.currentProjectInstances = [];
      vm.searchText = '';
      vm.showSearch = showSearch;
      vm.resetSearch = resetSearch;
      vm.loading = false;
      vm.searchOn = false;
      vm.interval = {};
      vm.hiding = false;
      vm.openSupportChatWindow = openSupportChatWindow;
      vm.getAllGeneralApplicationUserMessages = getAllGeneralApplicationUserMessages;
      vm.getGeneralApplicationUserMessagesBySearch = getGeneralApplicationUserMessagesBySearch;

      activate();

      function activate(){
        getAllMessagesOnRefresh().then(function(){
            vm.busy = false;
        })
        .catch(function (ex) {
          vm.busy = false;
          notificationService.error('notification.error.supportuser.allmessages');
          throw "Failed to get All support chat messages " + errorHelperService.formatError(ex);
        })

        var unregister = $rootScope.$on("savedSupportChatMessage",function($event, dataChanged)
        {
          if(dataChanged) {
            getAllMessagesOnRefresh();
          }
        });

        $scope.$on("destroy", unregister)

        var newSupportMessageHandler = $rootScope.$on("appNotificationHub:newSupportMessage", getAllMessagesOnRefresh);
        $scope.$on("destroy", newSupportMessageHandler)
      }

      function getAllMessagesOnRefresh(){
        if(!isRequestInProcess) {
          return supportTeamMessageService.getAllGeneralApplicationUserMessages().then(function (response) {
            setMessages(response);
            return response;
          });
        }
      }

      function showSearch(){
        vm.searchOn = true;
      }

      function resetSearch(){
        vm.hiding = true;
        if(vm.searchText.length > 0){
          vm.searchText = '';
          getGeneralApplicationUserMessagesBySearch();
        }

        vm.searchOn = false;
        vm.hiding = false;
      }

      function getGeneralApplicationUserMessagesBySearch() {
        vm.busy = true;
        supportTeamMessageService.getGeneralApplicationUserMessagesBySearch(vm.searchText).then(setMessages).catch(function (ex) {
          notificationService.error('notification.error.supportuser.messagesearch');
          throw "Failed to search support chat messages" + errorHelperService.formatError(ex);
        }).finally(function() {
          vm.busy = false;
        });
      }

      function getAllGeneralApplicationUserMessages() {
        vm.busy = true;
        supportTeamMessageService.getAllGeneralApplicationUserMessages().then(setMessages).catch(function (ex) {
          notificationService.error('notification.error.supportuser.allmessages');
          throw "Failed to get All support chat messages " + errorHelperService.formatError(ex);
        }).finally(function() {
          vm.busy = false;
        });
      }

      function openSupportChatWindow(userMessage) {
        vibrator.vibrate();
        tazkService.tryAddNewTazkViewModel(new SupportChat(userMessage));
      }

      function SupportChat(userMessage){
        var vm = this;
        vm.id = 'support-chat-' + userMessage.userId
        vm.tazkViewModelType = 'customerChat'
        vm.userId = userMessage.userId
        vm.title= userMessage.userName
      }

      function setMessages(data){
        vm.userMessages = data.data;

        angular.forEach(vm.userMessages, function(m){
          var body = m.messages[m.messages.length-1].body;

          if(body.length > previewMaxLength){
            body = body.substring(0,previewMaxLength) + " ...";
          }
          m.preview = body;
        })
      }
    })
})();

(function(){
  angular.module('gfApp')
    .directive('supportMessagesResult', function(){
      return {
        restrict: 'E',
        templateUrl: 'app/supportmessages/supportmessages.result.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('workflowSetService', function ($log, $appApi, $filter, $q, pagerService) {
      var vm = this

      vm.pager = null

      vm.initialize = initialize

      vm.get = get
      // vm.clone = clone
      // vm.update = update
      // vm.publish = publish
      // vm.edit = edit

      ///////


      function initialize(){
        $log.debug('Service - workflowEntityService - initializeWorkflows')

        vm.pager = new pagerService.Pager({
          resource: $appApi,
          initialRel: 'workflowsets',
          dataRel: 'workflowset',
          mapper: WorkflowSet,
          nextPageRel: 'next',
          pageSize: 10
        })


      }

      function get(id){
        return $appApi
          .then(function (v) {
            return v.$request().$get('workflowset',{workflowSetId:id})
          })
          .then(function (data) {
            return WorkflowSetDetail(data)
          })
      }

      ///////////////////////////

      function WorkflowSet(data){
        var vm ={
          resource :data,
          id: data.id,
          name: data.name
        }

        return vm
      }

      function WorkflowSetDetail(resource) {
        var defer = $q.defer()

        var model = {
          resource: resource,
          id: resource.id,
          name: resource.name
        }

        var promises=[]

        // if(resource.$has('workflowentity')){
        //   promises.push(resource.$request().$get('workflowentity')
        //     .then(function(data){
        //       return $q.all(data.map(WorkflowDetailEntity))
        //         .then(function(m){
        //           model.domainModel = RemapDomainModel(m[0])
        //            model.workflows = m.slice(1).map(RemapWorkflow)
        //         })
        //     }))
        // }

        $q.all(promises)
          .then(function(){
            defer.resolve(model)
          })

        return defer.promise
      }

    })
})();

(function () {
  angular.module('gfApp')
    .service('workflowInstanceService', service)

  function service($q, $appApi, $log, errorHelperService) {
    var vm = this

    vm.getDetails = getDetails
    vm.getByProject = getByProject
    vm.rollback = rollback

    /////

    function getDetails(projectWorkflowInstanceResource){
      return projectWorkflowInstanceResource.$request()
        .$get('workflowinstance')
        .then(WorkflowInstance)
    }

    function getByProject(projectId){
      return $appApi.then(function(version){
        return version.$request()
          .$get('project-workflows',{projectId: projectId})
          .then(ProjectWorkflowsResource)
      })
    }

    function rollback(resource, rollbackToWorkflowEntityId, tasksIdsToPurge, milestonesToUpdate){
      return resource.$request().$put('rollback',null,{
        rollbackToWorkflowEntityId: rollbackToWorkflowEntityId,
        tasksIdsToPurge: tasksIdsToPurge,
        milestonesToUpdate: milestonesToUpdate
      }).catch(function(e){
        var err = errorHelperService.formatError(e)
        $log.error(err)
        throw 'Cannot rollback workflow instance ' + err
      })
    }

    /////

    function WorkflowInstance(resource){
      return {
        resource: resource,
        id: resource.id,
        flowData: resource.flowData,
        projectTasks: resource.projectTasks,
        completedProjectTasks: resource.completedProjectTasks,
        childProjects: resource.childProjects,
        currentActivityId: resource.currentActivityId
      }
    }

    function ProjectWorkflowsResource(resource){
      return $q(function(r){
        var model = {
          resource: resource,
          id: resource.id,
          projectInstanceName: resource.projectInstanceName,
          name: resource.name,
          tasks: resource.tasks,
          milestones: (resource.milestones || []).map(function(m){
            m.isCompletedPrevious = m.isCompleted
            return m
          }),
          allWorkflows:[],
          children: []
        }

        if(resource.$has('project-workflow')){
          resource.$request().$get('project-workflow').then(function(data){
            if(!angular.isArray(data)){
              data = [data]
            }

            $q.all(data.map(ProjectWorkflow)).then(function(m){
              model.allWorkflows = m
              model.workflow = model.allWorkflows[0]
              model.children = data.slice(1)
              r(model)
            })
          })
        }else{
          r(model)
        }
      })
    }

    function ProjectWorkflow(resource){
      return $q(function(r){
        var model = {
          resource: resource,
          name: resource.name,
          isRoot: resource.isRoot,
          version: resource.version,
          hasActiveProjects : resource.hasActiveProjects,
          hasProjects: resource.hasProjects,
          instances: []
        }

        if(resource.$has('project-workflowinstance')){
          resource.$request().$get('project-workflowinstance').then(function(data){
            model.instances = data.map(ProjectWorkflowInstance)
            r(model)
          })
        }else{
          r(model)
        }
      })
    }

    function ProjectWorkflowInstance(resource){
      return {
        resource: resource,
        id: resource.id,
        projectId: resource.projectId,
        workflowEntityName: resource.workflowEntityName,
        isChildProject: resource.isChildProject,
        startedOn: resource.startedOn,
        isCompleted: resource.isCompleted,
        version: resource.version
      }
    }
  }
})();

/*global go*/
(function () {
  angular.module('gfApp')
    .service('workflowInstanceGoJsService', service)

  function service() {
    var vm = this

    vm.init = init

    ///////////

    function init(){
      vm.flowchart = new flowchart()
    }

    function flowchart(){
      this.update = function(data, options){
        this.init({
          flowchart: gojsmapper(data).map(),
          options: angular.extend(options || {}, {
            zoomToFit: true,
            readOnlyModel: true,
            allowSelect: false
          })
        })
      }

      this.init = function(data) {
        var me = this

        if (this.isInit) {
          this.load(data);
          return;
        }

        this.isInit = true;


        me.diagram =
          go.GraphObject.make(go.Diagram, "diagram", // must name or refer to the DIV HTML element
            {
              initialContentAlignment: go.Spot.Center,
              "animationManager.isEnabled": false,
              "undoManager.isEnabled": true,
              allowSelect: false
            });

        // -- events

        // on diagram loaded
        me.diagram.addDiagramListener("LayoutCompleted", function() {
          angular.element(".flowchart-div").addClass("loaded");
        });

        // on selected node
        me.diagram.addDiagramListener("ChangedSelection", function(e) {
          data.options.selectionChanged(e);
        });

        // helper definitions for node templates

        function nodeStyle() {

          return [
            // The Node.location comes from the "loc" property of the node data,
            // converted by the Point.parse static method.
            // If the Node.location is changed, it updates the "loc" property of the node data,
            // converting back using the Point.stringify static method.
            new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
            {
              locationSpot: go.Spot.Center
            }
          ];
        }

        // define the Node templates for regular nodes

        var colors = {
          main: "#6b8cb3",
          highlight: "#5bb75b",
          lightText: 'whitesmoke',
          white: 'white'
        }

        var icons = {
          task: go.Geometry.parse("M16.710899,36.727C20.7409,39.759457 25.747499,41.558827 31.1693,41.558827 36.588501,41.558827 41.596401,39.759457 45.627602,36.727 55.046902,37.911882 62.335999,45.946764 62.335999,55.688923L62.335999,64 0,64 0,55.688923C0,45.946764,7.2904,37.911882,16.710899,36.727z M31.169201,0C40.807137,0 48.622002,7.8164558 48.622002,17.455803 48.622002,27.095258 40.807137,34.909003 31.169201,34.909003 21.528767,34.909003 13.715,27.095258 13.715,17.455803 13.715,7.8164558 21.528767,0 31.169201,0z", true)
          , completeMilestone: go.Geometry.parse("M51.790001,24.177999L44.657009,31.310526 42.412151,33.555641 42.360149,33.608337 40.141289,31.392622 33.010998,24.259096 33.010998,30.443459 39.294868,36.728317 42.38615,39.820999 45.479931,36.728317 45.45393,36.701019 45.505932,36.64822 51.790001,30.363361z M42.398598,16.777C50.804901,16.777 57.619999,23.591635 57.619999,32 57.619999,40.406467 50.804901,47.223 42.398598,47.223 33.9897,47.223 27.174,40.406467 27.174,32 27.174,23.591635 33.9897,16.777 42.398598,16.777z M0,0L31.899,0C40.984901,0.20117199,42.398998,8.6806602,42.398998,8.6806602L42.398998,13.110001 41.91222,13.116181C31.719772,13.375278 23.508001,21.74651 23.508001,31.99995 23.508001,42.252407 31.719772,50.623718 41.91222,50.88282L42.398998,50.889 42.398998,64 25.8801,47.848598 9.2863798,64 9.2863798,8.6806602C8.2785301,1.00879,0,0,0,0z", true)
          , uncompleteMilestone: go.Geometry.parse("M36.927601,22.17L33.002998,26.09379 38.909039,31.999508 33.002998,37.906139 36.924919,41.829998 42.832493,35.922752 48.740063,41.829998 52.662003,37.906139 46.755989,31.999474 52.662003,26.09379 48.73756,22.17 42.83255,28.075603z M42.398598,16.777C50.804901,16.777 57.619999,23.592634 57.619999,32 57.619999,40.408367 50.804901,47.223 42.398598,47.223 33.9897,47.223 27.174,40.408367 27.174,32 27.174,23.592634 33.9897,16.777 42.398598,16.777z M0,0L31.899,0C40.984901,0.20214801,42.398998,8.6816397,42.398998,8.6816397L42.398998,13.111 41.91222,13.11718C31.719772,13.37625 23.508001,21.746609 23.508001,32.00005 23.508001,42.25349 31.719772,50.624722 41.91222,50.88382L42.398998,50.889999 42.398998,64 25.8801,47.849602 9.2863798,64 9.2863798,8.6816397C8.2785301,1.00977,0,0,0,0z", true)
          , contractActivity: go.Geometry.parse("M9.7279997,49.706001L37.841999,49.706001 37.841999,52.210999 9.7279997,52.210999z M9.7279997,37.104L37.841999,37.104 37.841999,39.609001 9.7279997,39.609001z M9.7279997,24.503L24.858999,24.503 24.858999,27.009001 9.7279997,27.009001z M4.5663633,4.8352022L4.5663633,59.166008 44.246944,59.166008 44.246944,17.005873 31.674076,17.005873 31.674076,4.8352022z M0,0L31.674076,0 34.25745,0 45.368034,10.878283 48.812,14.249378 48.812,64 0,64z", true)
          , decision: go.Geometry.parse("M39.202953,0L54.573505,15.369803 58.867149,11.074846 61.436275,20.653774 64,30.232 54.422405,27.667566 44.84491,25.097832 49.138554,20.802876 33.768002,5.432992z M24.798717,0L30.235001,5.432992 14.861252,20.802876 19.154837,25.097832 9.5774183,27.667566 0,30.232 2.5657215,20.653772 5.1327934,11.074847 9.4263592,15.369803z", true)
          , caseActivity: go.Geometry.parse("m100.703491,288.859664c0,0 148,-145 148,-145c0,0 1,-111 1,-112c0,-1 85,1 85,1c0,0 -1,111 -1,111c0,0 148,145 148,145c0,0 31,-31 31,-31c0,0 48,168 48,168c0,0 -169,-47 -169,-47c0,0 32,-29 32,-30c0,-1 -88,-89 -88,-89c0,0 1,121 1,120c0,-1 40,-1 40,-1c0,0 -84,154 -84,154c0,0 -86,-155 -86,-155c0,0 44,-3 44,-3c0,0 -1,-114 -1,-114c0,0 -86,88 -86,88c0,0 29,29 29,29c0,0 -167,48 -167,48c0,0 47,-166 47,-167c0,-1 28,30 28,30z", true)
          , migration: go.Geometry.parse("M2.9405556,36.27997L19.353662,36.27997C19.613712,40.570866 21.184009,44.681723 23.964536,48.082432 24.764687,49.062635 25.654855,49.952822 26.595033,50.762989L2.9405556,50.762989C1.3202496,50.762989,0,49.442715,0,47.822376L0,39.220583C0,37.590244,1.3202496,36.27997,2.9405556,36.27997z M40.07915,26.039505C35.567814,26.037608 31.697568,29.460962 31.228801,34.03541 30.738794,38.924829 34.298976,43.284515 39.189158,43.784468 44.07922,44.27441 48.429468,40.724705 48.929485,35.825276 49.429502,30.945621 45.879332,26.576171 40.989147,26.086228 40.683511,26.054981 40.379906,26.039631 40.07915,26.039505z M40.001466,20.029883C40.506362,20.029675 41.016065,20.054951 41.529205,20.106826 49.749458,20.93658 55.729645,28.275957 54.89966,36.495132 54.609612,39.405008 53.489578,42.024628 51.809589,44.174322L61.82983,56.083324C63.099895,57.583179 62.899937,59.832962 61.399883,61.09285 59.889824,62.362747 57.649757,62.162815 56.379692,60.66296L46.229319,48.584051C43.899282,49.654016 41.249166,50.133951 38.509082,49.863956 30.298838,49.023951 24.308641,41.694582 25.148636,33.475406 25.936131,25.769929 32.428023,20.033003 40.001466,20.029883z M2.9403095,17.98002L28.162965,17.98002C23.482472,21.2416,20.202127,26.404101,19.462048,32.467039L2.9403095,32.467039C1.3201389,32.467039,0,31.146399,0,29.525614L0,20.921445C0,19.290654,1.3201389,17.980019,2.9403095,17.98002z M2.9399338,0L44.119007,0C45.73897,0,47.058941,1.3100014,47.058941,2.9400024L47.058941,11.550008C47.058941,13.170009,45.73897,14.490009,44.119007,14.490009L2.9399338,14.490009C1.3199692,14.490009,0,13.170009,0,11.550008L0,2.9400024C0,1.3100014,1.3199692,0,2.9399338,0z", true)
          , modifyAttribute: go.Geometry.parse("M24.713566,54.414L27.674033,56.798189 30.628,59.181179 27.084799,60.551189 23.552,61.920998 24.127633,58.169399z M39.781575,32.973001L47.908998,39.514576 34.488625,56.185001 26.360999,49.642031z M47.339874,26.792416C48.508808,26.777681 49.689411,27.153134 50.670298,27.94158 52.912325,29.745042 53.269096,33.034154 51.461937,35.27513L49.781168,37.365002 41.657999,30.827079 43.338268,28.735807C44.353333,27.475314,45.83696,26.811362,47.339874,26.792416z M17.229177,0L37.181767,0C41.219584,0,44.476799,3.212183,44.597898,7.2122116L44.6147,7.2122116 44.6147,7.3919029 44.619999,8.1211472 44.6147,18.962336 40.879683,18.962336 40.879683,7.2305222C40.770283,5.2734776,39.168175,3.7148666,37.181767,3.7148666L18.590583,3.7148666 18.590583,14.475304C18.590583,16.73702,16.743475,18.589933,14.473365,18.589933L3.719986,18.589933 3.719986,48.342748C3.719986,50.389662,5.3840542,52.058973,7.4368038,52.058973L21.675897,52.058973 21.099694,55.779001 7.4368038,55.779001C3.3293648,55.779001,0,52.441776,0,48.342748L0,17.290424 0,17.287824C0.0045166016,17.222823 0.01953125,17.160323 0.03125,17.095122 0.063720703,16.955822 0.079345703,16.90892 0.10156441,16.86462 0.16076851,16.709721 0.19006348,16.64332 0.21997261,16.584719 0.29101753,16.454418 0.34375191,16.371218 0.39904976,16.294317 0.50256538,16.149817 0.55469131,16.089916 0.60412788,16.024815 0.74805069,15.859514 0.82934952,15.770912 0.91992569,15.675913L15.67777,0.91919708C15.76827,0.82812881 15.856771,0.74866104 15.945372,0.67578506 16.086572,0.55334854 16.141872,0.50647354 16.203173,0.46484756 16.361973,0.34888077 16.441474,0.30469131 16.503974,0.26293945 16.548174,0.23828125 16.592474,0.21875 16.641874,0.19396973 16.776075,0.13012695 16.822975,0.1105957 16.869876,0.094970703 17.006577,0.046875 17.117276,0.022094727 17.225277,0.01171875z", true)
          , parallel: go.Geometry.parse("M27.270001,0L44.310001,0 44.310001,48.643002 27.270001,48.643002z M0,0L17.040001,0 17.040001,48.643002 0,48.643002z", true)
          , sendEmail: go.Geometry.parse("M1.3298071,7.2189996C0.069377362,19.047994 7.4314376,29.596084 17.920897,30.874561 24.282898,31.652145 30.344097,28.8344 34.495197,23.8722L29.635798,20.074174 50.076,11.822937 47.002998,33.650705 42.372799,30.032276C37.376598,36.205253 29.415598,39.746782 20.952198,38.714305 7.8871871,37.121934 -1.4150026,25.24077 0.17746729,12.17463 0.38840741,10.449265 0.78171724,8.7944074 1.3298071,7.2189996z M5.8582464,2.5479999L20.605509,17.294059C21.092606,17.780954,21.879002,17.780954,22.364698,17.294059L37.057301,2.6040888C37.3568,2.8020868,37.556,3.1406436,37.556,3.52723L37.556,14.406086 25.09638,19.438538 30.350246,23.544 8.2397605,23.544C7.125268,22.45281,6.1094647,21.235521,5.2540002,19.894234L5.2540002,3.52723C5.2540002,3.0988941,5.5014983,2.7304878,5.8582464,2.5479999z M7.5706955,0L35.406998,0C35.391399,0.26562262,35.283295,0.52868223,35.077492,0.73058462L22.214069,13.522098C21.783062,13.941394,21.102051,13.943894,20.693144,13.525998L7.8622609,0.7916193C7.6486374,0.57543421,7.5549455,0.28637409,7.5706955,0z", true)
          , completeWorkflow: go.Geometry.parse("M465.398469957348,2.284039510414E-06C482.459535631177,-7.61341652832925E-07 499.520570787427,-7.61341652832925E-07 516.589754137036,2.284039510414E-06 519.715974840161,4.35931638350303 504.222078355786,9.83137658705527 495.651124986645,15.5573039399605 369.009920152661,100.241870437763 263.848604234692,210.585139785908 169.875505479809,318.99998048415 112.043924364087,266.893931900166 60.7961788501707,210.390620742939 0,160.277934585713 10.2915821399656,149.517451797627 23.4670200672117,140.696284805439 39.5505962696043,133.819682632588 67.6463871326414,148.99883607497 91.5659046497312,162.881587539814 125.526414903637,179.184352432392 130.292497667309,181.463908706806 162.467790636059,196.205531631611 165.214326890942,196.065074478291 171.321382555005,195.740977798603 187.712007555005,176.40232423415 197.793550523755,168.061854873798 270.811983140942,107.610042129658 375.722932847973,39.4010119782906 465.398469957348,2.284039510414E-06z", true)
          , start: go.Geometry.parse("M0,0L496.000005990267,315 0,630z", true)
          , apiIntegration: go.Geometry.parse("M15.484477,36.668C15.981843,36.966096 16.510509,37.152196 17.063771,37.239595 17.420648,39.339875 18.138,42.496041 19.647001,46.539003 16.822988,45.801912 13.824387,44.425622 10.750391,42.127546 10.702293,42.092347 10.647597,42.050748 10.602,42.011647 12.138398,40.239564 13.78019,38.445283 15.484477,36.668z M0.18000031,35.340001C21.109592,62.393193,41.892073,43.704469,41.892073,43.704469L38.382893,36.660299 54.375,42.916673 50.020926,59.935003C50.020926,59.935003 47.61854,55.285222 46.674644,53.374929 36.302204,61.860696 8.9586315,64.188882 0.18000031,35.340001z M38.315056,23.537002C38.605352,24.024011 38.990847,24.465421 39.468641,24.822229 41.07402,26.020154 43.213392,25.947252 44.740772,24.811828 49.955505,29.063119 54.429348,34.026925 58.023003,39.594743L58.091999,39.705346C57.913704,40.202657,57.721004,40.697564,57.523006,41.189775L55.382435,40.355157 39.385342,34.093324 32.723928,31.487769 35.912687,37.884908 38.416555,42.907212C35.64709,44.805753,29.647168,48.044122,22.174665,47.029702L22.148466,46.955499C20.96368,43.665029 20.069192,40.296457 19.452,36.940885 20.148491,36.647981 20.785282,36.184571 21.270977,35.535955 22.198064,34.292428 22.363362,32.719495 21.863369,31.363967 26.953103,27.912194 32.479132,25.281839 38.315056,23.537002z M56.78595,20.473512C57.237782,20.468772,57.689449,20.468827,58.14077,20.473703L58.195469,20.474902C58.700764,21.990466 59.118656,23.549127 59.382954,25.177987 60.024948,29.18959 59.828251,33.141294 58.936459,36.860002 55.372601,31.653028 51.078346,26.996843 46.167002,22.99694 46.385799,22.491754 46.502998,21.957967 46.519798,21.42538L46.525097,21.424079C46.791994,21.369481 47.064091,21.316081 47.336189,21.270482 50.452291,20.774896 53.623135,20.506692 56.78595,20.473512z M22.823098,13.192002C28.156434,14.787101 33.224168,17.055402 37.926001,19.9551 37.791899,20.371801 37.717699,20.798902 37.713799,21.2273 31.630357,23.136001 25.863418,25.9264 20.569183,29.541 20.500082,29.4798 20.446781,29.414701 20.380282,29.3639 19.812577,28.9395 19.171973,28.6907 18.519569,28.574901 18.296967,24.201301 18.536568,19.807901 19.226674,15.502001 20.474081,15.418601 21.67979,14.834001 22.485796,13.754502 22.618596,13.573501 22.720297,13.383601 22.823098,13.192002z M7.102994,10.545001L7.2318954,10.550301 7.6928406,10.568401C9.8022356,10.6675 12.060042,10.912297 14.560071,11.310693 14.618672,12.58798 15.205979,13.828968 16.308793,14.65166 16.514595,14.806758 16.737098,14.929157 16.965,15.043756 16.221591,19.64911 15.991189,24.248063 16.271092,28.73492 15.475482,29.020116 14.746274,29.529212 14.202067,30.258403 13.152455,31.66459 13.080955,33.486272 13.842564,34.943258 12.356946,36.458841 10.679826,38.323323 8.8309145,40.533002 1.0547028,33.199876 0.34241104,30.017606 0,29.090415 0.18750191,22.141284 2.7734737,15.63365 7.102994,10.545001z M20.618001,1.5180007C19.974851,3.1480712 19.379798,4.8914878 18.808243,6.7235915 17.512845,6.7652103 16.247244,7.3563821 15.412709,8.4747183 15.281321,8.6492121 15.187428,8.8394072 15.083336,9.0230009 13.147288,8.7274105 11.118748,8.5216162 9.059,8.4630186 12.268457,5.3524138 16.186149,2.9527072 20.618001,1.5180007z M29.630353,0.0010389588C41.731157,-0.10009919 52.638956,7.1912233 57.324001,18.17901 53.774601,18.18551 50.296701,18.461608 46.9764,18.994102 46.641798,19.047401 46.309698,19.112502 45.9751,19.175 45.682199,18.637305 45.278502,18.14381 44.7498,17.749313 43.029799,16.464126 40.679499,16.629424 39.147001,18.025312 34.1756,14.949939 28.8279,12.552762 23.3384,10.914678 23.2798,9.6425898 22.6873,8.3991014 21.591001,7.5788896 21.4347,7.4629304 21.2654,7.3783314 21.104001,7.2858006 21.815001,4.8991143 22.557199,2.7819445 23.363101,0.89011045L23.424401,0.74155195C23.9867,0.61143507 24.5467,0.47214631 25.127501,0.37961559 26.640234,0.13737133 28.144289,0.01346082 29.630353,0.0010389588z", true)
          , siskinKonnektIntegration: go.Geometry.parse("M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z", true)
        }

        function sharedPanel(type, prop) {
          var color = colors.main;

          if (typeof prop !== "undefined") {
            if(typeof prop.color !== "undefined") {
              color = prop.color;
            }
          }

          return go.GraphObject.make(go.Panel, "Vertical",
            {
              background: color,
              width: 140
            },
            new go.Binding("background", "highlight", function(v) { return v ? colors.highlight : null; }),
            go.GraphObject.make(go.TextBlock,
              {
                font: "normal 8pt 'Helvetica Neue', Helvetica, Arial, sans-serif",
                stroke: colors.white,
                margin: go.Margin.parse("4 0 0 0"),
                maxSize: new go.Size(160, NaN),
                wrap: go.TextBlock.WrapFit,
                stretch: go.GraphObject.Fill,
                textAlign: "center"
              },
              new go.Binding("text").makeTwoWay()),
            go.GraphObject.make(go.Panel, "Vertical",
              {
                background: "white",
                stretch: go.GraphObject.Fill,
                margin: 1
              }, go.GraphObject.make(go.Shape, { geometry: icons[type], fill: color, stroke: null, margin: 4, width: 40, height: 40 },
                new go.Binding("fill", "highlight", function(v) { return v ? colors.highlight : null; })))
          );
        }

        // -- template
        function addTemplate(type, prop) {
          me.diagram.nodeTemplateMap.add(type,
            go.GraphObject.make(go.Node, "Spot", nodeStyle(), sharedPanel(type, prop),
              {
                selectionAdornmentTemplate:
                  go.GraphObject.make(go.Adornment, "Auto",
                    go.GraphObject.make(go.Shape, "Rectangle",
                      { fill: null, stroke: colors.highlight, strokeWidth: 8 }),
                    go.GraphObject.make(go.Placeholder)
                  )
              })
          );
        }

        addTemplate("task");
        addTemplate("completeMilestone");
        addTemplate("uncompleteMilestone");
        addTemplate("contractActivity");
        addTemplate("decision");
        addTemplate("caseActivity");
        addTemplate("migration", {color:'gray'});
        addTemplate("modifyAttribute");
        addTemplate("parallel");
        addTemplate("sendEmail");
        addTemplate("apiIntegration");
        addTemplate("siskinKonnektIntegration");

        me.diagram.nodeTemplateMap.add("placeholder",
          go.GraphObject.make(go.Node, "Spot", nodeStyle(),
            go.GraphObject.make(go.Shape, "RoundedRectangle", { fill: "transparent", stroke: null, maxSize: new go.Size(0, 0) })));

        me.diagram.nodeTemplateMap.add("start",
          go.GraphObject.make(go.Node, "Spot", nodeStyle(),
            go.GraphObject.make(go.Shape, "RoundedRectangle",
              { parameter1: 40, maxSize: new go.Size(110, 40), fill: "#fcd03d", stroke: "#dab00b", strokeWidth: 4 }),
            go.GraphObject.make(go.Panel, "Horizontal",
              go.GraphObject.make(go.TextBlock, "Start", { font: "bold 11pt Helvetica, Arial, sans-serif", stroke: "#00517d" }, new go.Binding("text")),
              go.GraphObject.make(go.Shape, { geometry: icons["start"], width: 15, height: 15, margin: go.Margin.parse("0 0 0 10"), fill: colors.main, stroke: null, alignment: go.Spot.Right }))
          ));

        me.diagram.nodeTemplateMap.add("completeWorkflow",
          go.GraphObject.make(go.Node, "Spot", nodeStyle(),
            go.GraphObject.make(go.Shape, "RoundedRectangle",
              { parameter1: 40, maxSize: new go.Size(110, 40), fill: "#fcd03d", stroke: "#dab00b", strokeWidth: 4 },
              new go.Binding("stroke", "highlight", function (v) { return v ? colors.highlight : null; })),
            go.GraphObject.make(go.Panel, "Horizontal",
              go.GraphObject.make(go.TextBlock, "End", { font: "bold 11pt Helvetica, Arial, sans-serif", stroke: "#00517d" }, new go.Binding("text")),
              go.GraphObject.make(go.Shape, { geometry: icons["completeWorkflow"], width: 15, height: 15, margin: go.Margin.parse("0 0 0 10"), fill: colors.main, stroke: null, alignment: go.Spot.Right }))
          ));

        // link template
        me.diagram.linkTemplate =
          go.GraphObject.make(go.Link, // the whole link panel
            {
              //routing: go.Link.AvoidsNodes,
              curve: go.Link.Bezier,
              adjusting: go.Link.Stretch,
              corner: 5,
              toShortLength: 4,
              relinkableFrom: false,
              relinkableTo: false,
              reshapable: false,
              resegmentable: false,
              // mouse-overs subtly highlight links:
              mouseEnter: function(e, link) { link.findObject("HIGHLIGHT").stroke = "rgba(30,144,255,0.2)"; },
              mouseLeave: function(e, link) { link.findObject("HIGHLIGHT").stroke = "transparent"; }
            },
            new go.Binding("points").makeTwoWay(),

            go.GraphObject.make(go.Shape, // the highlight shape, normally transparent
              { isPanelMain: true, strokeWidth: 8, stroke: "transparent", name: "HIGHLIGHT" }),
            go.GraphObject.make(go.Shape, // the link path shape
              { isPanelMain: true, stroke: "gray", strokeWidth: 2 }),
            go.GraphObject.make(go.Shape, // the arrowhead
              { toArrow: "standard", stroke: null, fill: "gray" }),
            go.GraphObject.make(go.Panel, "Auto",
              go.GraphObject.make(go.Shape,
                {
                  fill: go.GraphObject.make(go.Brush, "Radial",{ 0: "rgb(255, 255, 255)", 0.7: "rgb(255, 255, 255)", 1: "rgba(255, 255, 255, 0)" }),
                  stroke: null
                }),
              go.GraphObject.make(go.TextBlock, "transition",
                {
                  textAlign: "center",
                  font: "10pt helvetica, arial, sans-serif"
                },
                new go.Binding("visible", "text", function (s) { if (s) return true; else return false; }),
                new go.Binding("text").makeTwoWay())
            )
          );

        me.diagram.toolManager.linkingTool.temporaryLink.routing = go.Link.Orthogonal;
        me.diagram.toolManager.relinkingTool.temporaryLink.routing = go.Link.Orthogonal;

        // -- command settings
        me.diagram.commandHandler.zoomFactor = 1.5;

        this.load(data); // load an initial diagram from some JSON text
      }


      this.load = function (data) {
        var me = this
        me.diagram.model = go.Model.fromJson(data.flowchart);

        // -- options options
        if (typeof data.options !== "undefined") {

          // -- highlight
          if (typeof data.options.highlight !== "undefined") {
            var node = me.diagram.model.findNodeDataForKey(data.options.highlight);

            if (node != null) {
              me.diagram.model.setDataProperty(node, "highlight", true);
            }

          }

          // -- zoom to fit
          if (data.options.zoomToFit === true) {
            me.diagram.zoomToFit();
          }

          // -- read only model
          if (data.options.readOnlyModel === true) {
            me.diagram.model.isReadOnly = true;
            me.diagram.isReadOnly = true;
          }

          // -- allow select
          if (typeof data.options.allowSelect !== "undefined") {
            me.diagram.allowSelect = data.options.allowSelect;
          }
        }
      }

      this.allowSelect = function (value) {
        this.diagram.allowSelect = value;
      }

      this.zoomIn = function () {
        this.diagram.commandHandler.increaseZoom();
      }

      this.zoomOut = function () {
        this.diagram.commandHandler.decreaseZoom();
      }
    }


    function gojsmapper(data){
      return {
        // -- gojs base config
        base: function () {
          return {
            "class": "go.GraphLinksModel",
            "linkFromPortIdProperty": "fromPort",
            "linkToPortIdProperty": "toPort"
          }
        },

        // -- json object
        data: angular.fromJson(data),

        // -- parse connector from json object
        mapConnection: function (data) {
          return {
            from: data.FromId,
            to: data.ToId,
            text: data.Option
          }
        },

        mapConnections: function(connections) {
          var nodes = new Array();

          for (var i = 0; i < connections.length; i++) {
            nodes.push(this.mapConnection(connections[i]));
          }

          return nodes;
        },

        // -- parse node (activity) from a json object
        mapDesignerItem: function (item) {
          return {
            'category': item.Type,
            'key': item.ID,
            'text': item.DisplayName,
            'loc': item.Left + " " + item.Top
          };
        },

        mapDesignerItems: function (designerItems) {
          var nodes = new Array();

          for (var i = 0; i < designerItems.length; i++) {
            nodes.push(this.mapDesignerItem(designerItems[i]));
          }

          return nodes;
        },
        // -- map main func
        map: function () {

          // -- init gojs flowchart data
          var flow = this.base();

          // -- designer items
          flow.nodeDataArray = this.mapDesignerItems(this.data.Root.DesignerItems.DesignerItem);

          // -- connections
          flow.linkDataArray = this.mapConnections(this.data.Root.Connections.Connection);

          return angular.toJson(flow);
        }
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('workflowEntityValidator', function (workflowEntityConstants) {
      function isNullOrEmpty(val){
        return angular.isUndefined(val) || val == null || val === ""
      }

      function isAttribute(val){
        return workflowEntityConstants.entityTypes.indexOf(val.subtype) !== -1
      }


      function validator(e, siblings) {
        if(angular.isDefined(e.categories)){
          var isValid = true;
          angular.forEach(e.categories, function(c){
            angular.forEach(c.attributes, function(a){
              validator(a, c.attributes)
              if(a.validation.hasError()){
                isValid = false;
              }
            })
          })
          
          return isValid
        }

        e.validation = {
          errors: [],
          hasError: function (property) {
            if(angular.isDefined(property)){
              return this.errors.some(function(e){return e.id === property})
            }else{
              return this.errors.length
            }
          },
          add: function (id,e) {
            if (this.errors.indexOf(e) === -1) {
              this.errors.push({id:id,message:e})
            }
          }
        }

        // attribute
        if (e.entityType === 'attribute') {
          if (isNullOrEmpty(e.subtype)) {
            e.validation.add('subtype','workflow.errors.subtypecannotbenull')
          }

          if (isNullOrEmpty(e.name)) {
            e.validation.add('name','workflow.errors.namecannotbenull')
          }
        }

        // if (isAttribute(e)){
        //   // not null category
        //   if (isNullOrEmpty(e.extendedData.category)) {
        //     e.validation.add('category','workflow.errors.categorycannotbenull')
        //   }
        // }

        // no repeat names
        if(e.entityType === 'attribute' && angular.isDefined(siblings)){
          for(var i=0;i<siblings.length;i++){
            var c = siblings[i]

            if(c.resource !== e.resource && c.name === e.name && ((isAttribute(e) && isAttribute(c)) || e.subtype === c.subtype)){
              e.validation.add('name','workflow.errors.duplicatedname')
            }
          }
        }

        // dropdown
        if (e.entityType === 'availableValues') {
          if (!e.children.length) {
            e.validation.add('children','workflow.errors.atleastoneoption')
          }
        }

        // check children
        angular.forEach(e.children, function (c) {
          if (!validator(c, e.children)) {
            e.validation.add('children','workflow.errors.innerconfiguration')
          }
        })

        return !e.validation.hasError()
      }

      return validator
    });
})();

(function () {
  angular.module('gfApp')
    .service('workflowEntityService', function ($log, $appApi, $filter, $q, pagerService, permissionService, workflowEntityValidator, workflowEntityConstants, fileEndpointService) {
      var vm = this

      vm.pager = null

      vm.initialize = initialize
      vm.initializeWorkflows = initializeWorkflows

      vm.getDomainModels = getDomainModels
      vm.getWorkflowsPublished = getWorkflowsPublished

      vm.getSet = getSet
      vm.clone = clone
      vm.update = update
      vm.updateSimple = updateSimple
      vm.remove = remove
      vm.deleteWorkflow = deleteWorkflow
      vm.restore = restore
      vm.publish = publish
      vm.edit = edit
      vm.downloadWfDesigner = downloadWfDesigner
      vm.download = download

      vm.createChild = createChild
      vm.createChildLink = createChildLink

      ///////

      function initialize() {
        vm.workflows = []
        vm.domainModels = []

        getWorkflowsPublished()
          .then(function (data) {
            angular.extend(vm.workflows, data)
          })
      }

      function initializeWorkflows() {
        $log.debug('Service - workflowEntityService - initializeWorkflows')

        vm.pager = new pagerService.Pager({
          resource: $appApi,
          initialRel: 'workflow-workflows',
          dataRel: 'workflowentity',
          mapper: WorkflowEntity,
          nextPageRel: 'next',
          pageSize: 10
        })
      }

      function getWorkflowsPublished() {
        return $appApi
          .then(function (v) {
            return v.$request().$get('workflow-workflows-published')
          })
          .then(function (data) {
            return data.data.map(WorkflowEntity)
          })
      }

      function getDomainModels() {
        return $appApi
          .then(function (v) {
            return v.$request().$get('workflow-domainmodels')
          })
          .then(function (data) {
            return data.data.map(WorkflowEntity)
          })
      }

      function clone(w) {
        return w.resource.$request().$post('workflowset-clone')
          .then(function (data) {
            return data.data.id;
          })
      }

      function getSet(workflowEntityId) {
        return $appApi
          .then(function (v) {
            return v.$request().$get('workflowset', {workflowEntityId: workflowEntityId})
          })
          .then(function (data) {
            return WorkflowSetDetail(data)
          })
      }

      function downloadWfDesigner() {
        return fileEndpointService.download('download-wfdesigner', undefined, undefined, 'POST')
      }

      function download(entity) {
        return fileEndpointService.download('download', entity, undefined, 'POST')
      }

      function update(entity, siblings) {
        workflowEntityValidator(entity, siblings)

        return entity.resource.$request().$putSelf(entity)
          .then(function (data) {
            return WorkflowDetailEntity(data)
          })
      }

      function updateSimple(entity, siblings) {
        workflowEntityValidator(entity, siblings)

        var entityNoChildren = angular.extend({}, entity)
        entityNoChildren.children = []

        return entity.resource.$request().$putSelf(entityNoChildren)
          .then(function (data) {
            return WorkflowDetailEntity(data)
          })
      }

      function WorkflowEntity(resource) {
        return {
          resource: resource,
          id: resource.id,
          name: resource.name,
          publishedByFullName: resource.publishedByFullName,
          publishedOn: resource.publishedOn,
          isDeleted: resource.isDeleted,
          status: angular.isDefined(resource.status) && resource.status != null ? resource.status.toLowerCase() : null
        }
      }

      function WorkflowSetDetail(resource) {
        var defer = $q.defer()

        var model = {
          resource: resource
        }

        var promises = []

        if (resource.$has('workflowentity')) {
          promises.push(resource.$request().$get('workflowentity')
            .then(function (data) {
              return $q.all(data.map(WorkflowDetailEntity))
                .then(function (m) {
                  model.domainModel = RemapDomainModel(m[0])
                  model.workflows = m.slice(1).map(RemapWorkflow)
                })
            }))
        }

        $q.all(promises)
          .then(function () {
            defer.resolve(model)
          })

        return defer.promise
      }

      function RemapWorkflow(m) {
        angular.forEach(m.children, function (c) {
          if (c.entityType === 'task') {
            c.roles = $filter('find')(c, 'roles')
            c.user = $filter('find')(c, 'user')
            c.escalatedRoles = $filter('find')(c, 'escalatedRoles')
            c.taskAttributes = $filter('find')(c, 'taskAttributes')
            c.actions = $filter('find')(c, 'actions')
            c.taskDate = $filter('find')(c, 'taskDate')
            c.timeSpan = $filter('find')(c, 'timeSpan')
            c.taskReminders = $filter('find')(c, 'taskReminders')

            angular.forEach(c.actions.children, function (a) {
              if (angular.isDefined(a.extendedData.requireValues)) {
                a.attributes = a.extendedData.requireValues.split(";").filter(function (v) {
                  return v !== ""
                })
                  .map(function (m) {
                    return {linkedId: m}
                  })
              }
            })
          }
        })


        return m
      }

      function RemapDomainModel(m) {
        m.categories = [{name: 'Default', subtype: 'category'}].concat(m.children.filter(function (m) {
          return m.subtype === 'category'
        }).sort(function(a,b){return a.extendedData.displayOrder - b.extendedData.displayOrder}))
          .map(function (c) {
            c.hasError = function(){return angular.isDefined(this.validation) && this.validation.hasError() || this.attributes.some(function(a){return angular.isDefined(a.validation) && a.validation.hasError()})}
            c.collapsed = true
            c.attributes = m.children.filter(function (m) {
              return c.name === (m.extendedData.category || ('Default')) && workflowEntityConstants.entityTypes.indexOf(m.subtype) !== -1
            }).sort(function (a, b) {
              return a.extendedData.displayOrder - b.extendedData.displayOrder
            })
            return c
          })

        return m
      }

      function WorkflowDetailEntity(resource) {
        var defer = $q.defer()

        var model = {
          resource: resource,
          id: resource.id,
          linkedId: resource.linkedId,
          name: resource.name,
          status: resource.status,
          entityType: resource.entityType,
          readonly: resource.status === 'Published',
          isVersioned: resource.isVersioned,
          version: resource.version,
          subtype: resource.subtype,
          extendedData: resource.extendedData,
          children: [],
          isAttribute: resource.entityType === 'attribute' && resource.subtype !== 'milestone' && resource.subtype !== 'role' && resource.subtype !== 'category'
        }

        // Workflow designer creates trash data that cannot be later on parsed back when loaded on the web UI
        delete model.extendedData.categoryTypes
        delete model.extendedData.linkableAttributes

        var promises = []

        if (resource.$has('workflowentity')) {
          promises.push(resource.$request().$get('workflowentity')
            .then(function (data) {
              return $q.all(data.map(function (e) {
                return permissionService.hasGroups(e.extendedData.visibleForGroups)
              }))
                .then(function (res) {
                  return $q.all(data.filter(function (m, i) {
                    return res[i]
                  }).map(WorkflowDetailEntity))
                    .then(function (models) {
                      model.children = models
                    })
                })
            })
          )
        }

        $q.all(promises)
          .then(function () {
            defer.resolve(model)
          })

        return defer.promise
      }

      function createChild(parent, entity, siblings) {
        if(!workflowEntityValidator(entity, siblings)){
          return $q(function(res,rej){rej()})
        }

        return parent.resource.$request()
          .$postSelf(entity)
          .then(WorkflowDetailEntity)
      }

      function createChildLink(parent, modelId) {
        return parent.resource.$request()
          .$post('workflowentity-create-child-link', null, {id: modelId})
          .then(WorkflowDetailEntity)
      }

      function remove(entity) {
        return entity.resource.$request()
          .$deleteSelf()
      }

      function deleteWorkflow(entity) {
        return entity.resource.$request()
          .$delete('delete-workflow')
      }

      function restore(entity) {
        return entity.resource.$request()
          .$put('workflowset-restore', null, {id: entity.Id})
      }

      function publish(entity) {
        if(!workflowEntityValidator(entity, entity.children)){
          return $q(function(res,rej){rej()})
        }

        function updateReadonly(entity, status) {
          entity.status = status
          entity.readonly = status === 'Published'
        }

        updateReadonly(entity, 'Published')

        return updateSimple(entity)
          .catch(function (err) {
            updateReadonly(entity, 'Draft')
            throw err
          })
      }


      function edit(entity) {
        return entity.resource.$request().$post('workflowentity-version')
          .then(function (data) {
            var dto = WorkflowDetailEntity(data)

            if (entity.entityType === 'workflow') {
              return RemapWorkflow(dto)
            } else {
              return RemapDomainModel(dto)
            }
          })
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('workflowEntityFactory', function () {

      var templates = {
        dropdownItem : function(){
          return {
            extendedData: {value: 'New option'}
          }
        }
      }

      return function (type, subtype) {
        return templates[type + (subtype || '')]()
      }
    });
})();

(function () {
  angular.module('gfApp')
    .service('workflowEntityDeleteValidator', function (workflowEntityConstants) {
      function isNullOrEmpty(val){
        return angular.isUndefined(val) || val == null || val === ""
      }

      function isAttribute(val){
        return workflowEntityConstants.entityTypes.indexOf(val.subtype) !== -1
      }

      function hasLink(e, entity, ignoreEntityTypes){
        if(ignoreEntityTypes.indexOf(entity.entityType) !== -1){
          return false
        }

        if(entity.linkedId === e.id){
          return true
        }

        if(angular.isDefined(entity.extendedData) && !isNullOrEmpty(entity.extendedData.linkedAttribute)
          && entity.extendedData.linkedAttribute.split(";").indexOf(e.name) !== -1){
          return true
        }

        return angular.isDefined(entity.children) && entity.children.some(function(c){return hasLink(e,c,ignoreEntityTypes)})
      }

      function validator(e, rootEntities) {
        e.validation = {
          errors: [],
          hasError: function (property) {
            if(angular.isDefined(property)){
              return this.errors.some(function(e){return e.id === property})
            }else{
              return this.errors.length
            }
          },
          add: function (id,e) {
            if (this.errors.indexOf(e) === -1) {
              this.errors.push({id:id,message:e})
            }
          }
        }

        // attribute
        if (isAttribute(e)) {
          if(rootEntities.some(function(re){return hasLink(e, re, ['taskCategories','taskAttributes'])})){
            e.validation.add('delete','workflow.errors.cannotdeleteentitybecauselinks')
          }
        }

        return !e.validation.hasError()
      }

      return validator
    });
})();

(function () {
    angular.module('gfApp')
      .service('workflowService', service)
  
    function service($q) {
      var vm = this
  
      vm.get = get
      vm.getFlowData = getFlowData
  
      /////
  
      function get(resource){
        return resource.$request()
          .$get('workflow')
          .then(Workflow)
      }
  
      function getFlowData(resource){
        return resource.$request().$get('flowdata')
            .then(Workflow)
      }

      /////

      function Workflow(resource){
          var defer = $q.defer()

          var vm = {
              resource: resource,
              id: resource.id,
              name: resource.name,
              version: resource.version,
              flowData: resource.flowData,
              children: []
          }

          if(resource.$has('workflow')){
              resource.$request().$get('workflow').then(function(data){
                  return $q.all(data.map(Workflow))
              })
              .then(function(data){
                vm.children = data
                defer.resolve(vm)
              })
          }else{
            defer.resolve(vm)
          }

          return defer.promise
      }
    }
  })();
  
(function () {
  angular.module('gfApp')
    .service('welcomeMessageService', function ($appApi, $q) {

      var service = {
        create: createMessage,
        update: updateMessage,
        delete: deleteMessage,
        get: getMessages,
        getUserWelcomeMessage: getUserMessage,
        dismissUserWelcomeMessage: dismissUserMessage
      };

      return service;

      function deleteMessage(resource, welcomeMessage) {
        return resource.$request().$delete('self', {}, welcomeMessage);
      }


      function createMessage(welcomeMessage) {
        return $appApi.then(function (version) {
          return version.$request().$post('welcomemessages', {}, welcomeMessage);
        });
      }


      function updateMessage(resource, welcomeMessage) {
        return resource.$request().$put('self', {}, welcomeMessage);
      }

      function getMessages() {
        var groupPromise = $appApi.then(function (version) {
          return version.$request().$get('groups').then(function (groupPager) {
            if(groupPager.$has('group')){
              return groupPager.$request().$get('group').then(function (data) {
                return data;
              });
            }else{
              return []
            }
          });
        });

        var welcomeMessagePromise = $appApi.then(function (version) {
          return version.$request().$get('welcomemessages').then(function (welcomeMessagePager) {
            if (welcomeMessagePager.totalItemsCount > 0) {
              return welcomeMessagePager.$request().$get('welcomemessage').then(function (data) {
                return data;
              });
            }
            else {
              return [];
            }
          });
        });

        return $q.all([welcomeMessagePromise, groupPromise]);
      }

      function getUserMessage(userId) {
        return $appApi
          .then(function (version) {
            return version.$request().$get('userwelcomemessage', {userId: userId});
          })
      }

      function dismissUserMessage(userId) {
        return $appApi.then(function (version) {
          return version.$request().$delete('userwelcomemessage', {userId: userId});
        });
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('userService', function ($appApi, $log, pagerService, appInsights, CacheFactory, $q) {
      var vm = this

      vm.Pager = Pager

      //////////////////

      function Pager(){
        return new pagerService.Pager({
          resource: $appApi,
          mapper: User,
          initialRel: 'user-search',
          dataRel: 'user',
          pageSize: 10
        })
      }

      function userFactory(userResource) {
        return {
          userId: userResource.userId,
          longName: userResource.longName,
          timezone: userResource.timeZone,
          locale: userResource.locale,
          email: userResource.email
        }
      }

      this.searchAll = function (query) {
        if (angular.isUndefined(query) || query.length < 2)
          return $q(function () {
            return []
          })

        return $appApi
          .then(function (versionResource) {
            return versionResource.$request().$get('user-search', {'query': query})
          })
          .then(function (userListResource) {
            return userListResource.$request().$get('user')
          })
          .then(function (embeddedUserList) {
            var users = [];
            angular.forEach(embeddedUserList, function (userResource) {
              users.push(userFactory(userResource))
            })
            return users
          })
          .catch(function (ex) {
            appInsights.trackException(ex)
            $log.debug(ex)
            return []
          })
      }

      // With 4k users this returns about 1.5Mb of data, which really sucks on mobile. While it's a quick solution
      // and it's quite nice for prototyping caching we cannot live with this for release
      CacheFactory('userService', {
        maxAge: 5 * 60 * 1000
      })

      this.getAll = function () {
        var deferred = $q.defer()
        var dataCache = CacheFactory.get('userService')
        if (dataCache.get('all')) {
          deferred.resolve(dataCache.get('all'))
        } else {
          $appApi
            .then(function (apiVersionResource) {
              return apiVersionResource.$request().$get('users')
            }).then(function (userListResource) {
            return userListResource.$request().$get('user')
          }).then(function (embeddedUserList) {
            var users = [];
            angular.forEach(embeddedUserList, function (userResource) {
              users.push(userFactory(userResource))
            })
            dataCache.put('all', users)
            deferred.resolve(users)
          }).catch(function (ex) {
            appInsights.trackException(ex)
            $log.debug(ex)
            dataCache.put('all')
            deferred.resolve([]);
          });
        }

        return deferred.promise
      }

      ///////////////

      function User(resource){
        return {
          resource: resource,
          id: resource.id,
          name: resource.name
        }
      }
    })
})();

(function () {
  angular
    .module('gfApp')
    .service('taskNotesService', function ($q) {
      this.getNotesFromTask = getNotesFromTask
      this.sendNoteForTask = sendNoteForTask

      ///////

      /**
       *
       * @param {object} task the task object, this should have 'resource' property that can be accessed to retrieve
       *                 the notes via the API. If the note is added, it will be pushed into the notes property array
       * @param {string} noteBody
       * @param {bool}   isPrivateNote
       */
      function sendNoteForTask(task, noteBody, isPrivateNote, projectRoleMappings) {
        var del = $q.defer()

        if (!task.resource.$has('notes')) {
          throw "Assumed rel 'notes' is not available on the resource"
        }

        var resource = {
          body: noteBody,
          isInternal: isPrivateNote,
          projectRoleMappings: projectRoleMappings
        }

        task.resource.$request().$post('notes', {}, resource)
          .then(function (note) {
            var n = new Note(note)

            if(angular.isDefined(task.notes) && angular.isDefined(task.notes.data)){
              task.notes.data.push(n)
              task.notes.lastNote = note
            }

            if(angular.isDefined(task.notes) && !angular.isArray(task.notes)){
              task.notes.noteFromThisTaskWasSent = true
            }

            del.resolve(n)
          })
          .catch(function (err) {
            del.reject(err)
          })

        return del.promise
      }

      /**
       * @param {object} task the task object to which the notes will be added. This should have
       *                 a 'resource' property that can be accessed to retrieve the notes via the API
       */
      function getNotesFromTask(task) {
        var del = $q.defer()
        if (task.notes.isLoaded) {
          del.resolve(task.notes)
        }
        else {
          task.resource.$request().$get('notes')
            .then(getNotesIfTaskHasAny)
            .then(addNotesToTask)
            .catch(function (error) {
              del.reject(error)
            })
        }

        function getNotesIfTaskHasAny(notesPager) {
          if (!notesPager.$has('note')) {
            var r = $q.defer()
            r.resolve([])
            return r.promise
          } else {
            return notesPager.$request().$get('note')
          }
        }

        function addNotesToTask(notesArray) {
          task.notes.data = [];
          angular.forEach(notesArray, function (noteResource) {
            var note = new Note(noteResource)
            task.notes.data.push(note);
            task.notes.lastNote = note
            if (task.id === note.taskId) {
              task.notes.noteFromThisTaskWasSent = true
            }
          })
          del.resolve(task.notes)
        }

        return del.promise
      }

      function Note(noteResource) {
        var me = this;
        this.body = noteResource.body
        this.createdOn = noteResource.createdOn
        this.taskName = noteResource.taskActivityName
        this.taskId = noteResource.taskActivityId
        this.isPrivate = noteResource.isPrivate
        this.date = noteResource.createdOn
        this.userName = noteResource.userName
        this.userId = ''
        this.type = 'note'
        this.userLongName = ''
        this.userPicture = ''

        if(noteResource.$has('projectrolemapping')){
          noteResource.$request().$get('projectrolemapping')
            .then(function(data){
              me.projectRoleMappingsNames = data.map(function(m){return m.name})
            })
        }

        noteResource.$request().$get('user')
          .then(function (userResource) {
            me.userId = userResource.userId
            me.userLongName = userResource.longName
            me.userPicture = userResource.picture
          })
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('taskInstanceService', taskInstanceService)

  function taskInstanceService($q, $appApi, $log, pagerService, dataValueService, gfHelper) {
    var vm = this

    vm.pager = pager
    vm.pagerAttributes = pagerAttributes

    vm.get = get
    vm.getDetails = getDetails
    vm.getInfo = getInfo
    vm.getFilters = getFilters

    ////////

    function pager(){
      return new pagerService.Pager({
        resource: $appApi,
        initialRel: 'projecttasks-progress',
        dataRel: 'projecttask',
        mapper: ProjectTask,
        nextPageRel: 'next',
        pageSize: 10,
        append: false
      })
    }

    function pagerAttributes(defaultSearch) {
      return new pagerService.Pager({
        resource: $appApi,
        initialRel: 'attributes',
        dataRel: 'taskactivity',
        mapper: ProjectTaskAttributes,
        nextPageRel: 'next',
        pageSize: 10,
        defaultSearchCriteria: defaultSearch,
        append: false
      })
    }

    function get(projectTaskId) {
      $log.debug('Service - taskInstanceService - get')

      return $appApi
        .then(function (v) {
          return v.$request().$get('taskactivity', {taskId: projectTaskId})
        }).then(function (data) {
          return ProjectTask(data)
        })
    }

    function getDetails(projectTaskId) {
      $log.debug('Service - taskInstanceService - get details')

      return $appApi
        .then(function (v) {
          return v.$request().$get('projecttask', {projectTaskId: projectTaskId})
        }).then(function (data) {
          return ProjectTaskWithDetails(data)
        })
    }

    function getInfo(projectTaskResource){
      $log.debug('Service - taskInstanceService - get info')

      return projectTaskResource.$request().$get('info').then(ProjectTaskInfo)
    }

    function getFilters(){
      return $appApi
        .then(function(v){
          return v.$request().$get('projecttasks-filtersprogress')
        })
        .then(function(data){
          var all = data.data

          return {
            tasks:filterGroupedMap(all, 'taskName'),
            regions: filterGroupedMap(all, 'storeRegion'),
            countries: filterGroupedMap(all, 'storeCountry'),
            clients: filterMap(all, 'templateClient'),
            storeGroups: filterMap(all,'storeGroup'),
            stores: filterMap(all,'store'),
            projectTemplates: filterMap(all, 'template'),
            projects: filterMap(all, 'project')
          }
        })
    }

    function filterMap(array, prop, mapName){
      return gfHelper.groupBy(array.filter(function(m){return m[prop+'Id'] != null}),prop+'Name', function(m){return {id:m[prop+'Id'], name:
        angular.isDefined(mapName) ? mapName(m) : m[prop+'Name']}})
        .map(function(m){
          return m.key
        })
    }

    function filterGroupedMap(array, prop){
      return gfHelper.groupBy(array.filter(function(m){return m[prop] != null}), prop).map(function(m){return {key:m.key, value:m.key}})
    }

    function ProjectTask(resource) {
      return {
        resource: resource,
        id: resource.id,
        name: resource.name,
        storeCode: resource.storeCode,
        clientName: resource.clientName,
        storeName: resource.storeName,
        storeId: resource.storeId,
        projectTemplateName: resource.projectTemplateName,
        projectTypeName: resource.projectTypeName,
        dueDate: resource.dueDate,
        date: resource.dueOn,
        completedOn: resource.completedOn,
        status: resource.status,
        isCompleted: resource.isCompleted,
        type: 'task'
      }
    }

    function ProjectTaskAttributes(resource) {
      var vm = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        clientName: resource.clientName,
        storeName: resource.storeName,
        status: resource.status,
        projectTemplateName: resource.projectTemplateName,
        dataValues: []
      }

      if (resource.$has('dataValue')) {
        resource.$request().$get('dataValue')
          .then(function (data) {
            angular.forEach(data, function (dv) {
              var promises = [];
              vm.dataValues.push(dataValueService.createDataValueWrapper(dv, promises))
            })
          })
      }

      return vm
    }

    function ProjectTaskInfo(resource){
      return {
        resource:resource,
        rolemappingGroups: resource.rolemappingGroups,
        rolemappingUsers: resource.rolemappingUsers,
        assignedVersionedDataValues: resource.assignedVersionedDataValues
      }
    }

    function ProjectTaskWithDetails(resource) {
      var defer = $q.defer()

      var vm = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        projectTemplateId: resource.projectTemplateId,
        projectTemplateName: resource.projectTemplateName,
        storeId: resource.storeId,
        projectId: resource.projectId,
        projectName: resource.projectName,
        storeName: resource.storeName,
        storeAddress: resource.storeAddress,
        assignedTo: resource.assignedTo,
        dueOn: resource.dueOn,
        status: resource.status,
        isCompleted: resource.isCompleted,
        completedOn: resource.completedOn,
        isAssignedToLoggedUser: resource.isAssignedToLoggedUser,
        date: resource.completedOn,
        actions: angular.isDefined(resource.actions) ? resource.actions.map(TaskAction) : undefined,
        history: [],
        notes: {},
        type: 'task',
        canClaim: resource.canClaim,
        canUnclaim: resource.canUnclaim,
        canPerformTaskAction: resource.canPerformTaskAction
      }

      var promises = []

      // datavalues
      promises.push(dataValueService.getDataValuesByGroup(resource, function (m) {
        return m.categoryName
      }, function (m) {
        return m.categoryListOrder
      }, function (m) {
        return m.categoryType
      }, function (m) {
        return m.categoryId
      }).then(function (data) {
        vm.dataValues = data.groups
        vm.fields = data.dataValues
      }))

      // completed tasks
      if(resource.$has('projecttask')){
        promises.push(resource.$request().$get('projecttask')
          .then(function(data){
            var promises = data.map(function(t){return ProjectTaskWithDetails(t,false)})
            return $q.all(promises).then(function(m){
              vm.history = vm.history.concat(m)
            })
          }))
      }

      // milestones
      if(resource.$has('milestone')){
        promises.push(resource.$request().$get('milestone')
          .then(function(data){
            vm.history = vm.history.concat(data.map(Milestone))
          }))
      }

      // notes
      if(resource.$has('note')){
        promises.push(resource.$request().$get('note')
          .then(function(data){
            var notes = data.map(TaskNote)
            vm.history = vm.history.concat(notes)
            vm.lastNote = notes[notes.length-1]
          }))
      }

      //  projectrole mappings
      if(resource.$has('projectrolemappings')){
        vm.projectRoleMappingsPager = new pagerService.Pager({
          resource: resource,
          initialRel: 'projectrolemappings',
          dataRel: 'projectrolemapping',
          mapper: ProjectRoleMapping,
          nextPageRel: 'next',
          pageSize: 0
        })
      }

      $q.all(promises).then(function(){
        var historyTasks = vm.history.filter(function(t){return t.type ==='task'})
        if(angular.isUndefined(vm.lastNote) && historyTasks.length){
          var lastTaskWithNotes = historyTasks.reverse().find(function(t){return angular.isDefined(t.lastNote)})
          if(angular.isDefined(lastTaskWithNotes)){
            vm.lastNote = vm.lastNote || lastTaskWithNotes.lastNote
          }
        }
        defer.resolve(vm)
      })

      return defer.promise
    }

    function Milestone(resource){
      return {
        resource: resource,
        id: resource.id,
        name: resource.name,
        date: resource.date,
        type: 'milestone'
      }
    }

    function TaskNote(resource){
      var vm =  {
        resource: resource,
        body: resource.body,
        date: resource.createdOn,
        userName: resource.userName,
        type: 'note'
      }

      if(resource.$has('projectrolemapping')){
        resource.$request().$get('projectrolemapping').then(function(data){
          vm.projectRoleMappingsNames = data.map(function(m){return m.name})
        })
      }

      return vm
    }

    function TaskAction(resource) {
      return {
        name: resource.name,
        requiresAttributes: resource.requiresAttributes,
        requiresNote: resource.requiresNote,
        optionalItemsUrl: resource.optionalItemsUrl
      }
    }

    function ProjectRoleMapping(resource){
      return {
        resource: resource,
        id: resource.id,
        name: resource.name
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('taskInboxUnreadService', function ($q, $rootScope, $appApi, $log, $translate, $state, errorHelperService, notificationService, permissionService, gfSiskinActions, taskInboxService ) {
      var unreadTaskIds = [];

      var service = this;
      service.getUnreadTaskIds = getUnreadTaskIds
      service.getUnreadTaskCount = getUnreadTaskCount
      service.markAllTasksRead = markAllTasksRead

      function getUnreadTaskIds() {
        return initialize()
          .then(function () {
            return unreadTaskIds.slice(0)
          })
      }


      function getUnreadTaskCount() {
        return initialize()
          .then(function () {
            return unreadTaskIds.length
          })
      }

      function updateUnreadTaskIds(event, data) {
        permissionService.can(gfSiskinActions.inboxCardModeDefault).then(function (can) {
          // notification of new task
          if (angular.isDefined(unreadTaskIds)) {
            var message = $translate.instant('taskinstance.newtasknotification') + "<br/>"
            var tasksToOpen = []

            data.ids.filter(function (item) {
              if (unreadTaskIds.indexOf(item) === -1) {
                tasksToOpen.push(item)

                if(!can){
                  message += "<b><a href='" + $state.href('siskin.taskinstance', {taskInstanceId: item}) + "'>" + $translate.instant('taskinstance.newtasknotificationclickhere') + "</a></b><br/>"
                }else{
                  message += "<b>" + $translate.instant('taskinstance.newtasknotificationclickhere')+"</b><br/>"
                }
              }
            })

            if (tasksToOpen.length) {
              notificationService.info(message,can ? function(){openTasks(tasksToOpen)} : null)
            }
          }

          unreadTaskIds = data.ids
        })
      }

      function openTasks(taskIds){
        angular.forEach(taskIds, function(id){
          taskInboxService.open({id:id})
        })
      }

      function markAllTasksRead() {
        return $appApi
          .then(function (version) {
            if (!version.$has('taskactivities-unread')) {
              initializationDeferral.reject()
              throw "taskInboxUnreadService - No 'taskactivities-unread' found on root resource"
            }

            // Simply send up no data
            return version.$request().$put('taskactivities-unread', {}, {})
          })
          .catch(function (e) {
            throw "taskInboxUnreadService - Unable to mark all tasks read " + errorHelperService.formatError(e)
          })
      }

      var initCalled = false;
      var initializationDeferral = $q.defer();

      function initialize() {
        if (initCalled) {
          return initializationDeferral.promise
        }

        initCalled = true;

        $appApi
          .then(function (version) {
            if (!version.$has('taskactivities-unread')) {
              initializationDeferral.reject()
              throw "taskInboxUnreadService - No 'taskactivities-unread' found on root resource"
            }

            return version.$request().$get('taskactivities-unread')
          })
          .then(function (taskActivitiesUnreadResource) {
            if (angular.isArray(taskActivitiesUnreadResource.unreadTaskIds)) {
              unreadTaskIds = taskActivitiesUnreadResource.unreadTaskIds
            }
            initializationDeferral.resolve()
          })
          .catch(function (e) {
            if (errorHelperService.isApiUnavailable(e)) {
              $log.debug('taskInboxUnreadService - Failed to load unread tasks, API unavailable')
            } else {
              var message = errorHelperService.formatError(e)
              initializationDeferral.reject(e)
              throw "taskInboxUnreadService - Failed to load unread tasks " + message
            }
          })

        $rootScope.$on('$destroy',
          $rootScope.$on('appNotificationHub:setUnreadTaskIds', updateUnreadTaskIds)
        );

        return initializationDeferral.promise
      }
    })
})();

(function () {
  // Will delete once this is confirmed as not being required
  angular
    .module('gfApp')
    .service('taskInboxSearchPresetService', function (errorHelperService, $log, $q, $appApi) {
      var me = this;
      me.getPresets = getPresets;
      me.savePreset = savePreset;
      me.deletePreset = deletePreset;

      function savePreset(model) {
        var del = $q.defer();
        var savePromise;
        if (angular.isDefined(model.resource)) {
          // this is an existing resource, send it up
          savePromise = model.resource.$request().$put('self', {}, model)
        } else {
          savePromise = $appApi.then(function (version) {
            version.$request().post('searchfilterpreset', {}, model)
          })
        }
        savePromise
          .then(function (response) {
            // TODO: replace in model
            del.resolve(new InboxSearchParameters(response));
          })
          .catch(function (err) {
            var m = errorHelperService.formatError(err)
            getPresetsDeferral.reject(m)
            throw "Error saving inbox search preset " + m;
          })

        return del.promise;
      }

      function deletePreset(model) {
        return model.resource.$request().$delete('self')
      }

      var getPresetsDeferral = undefined;

      function getPresets() {
        if (angular.isDefined(getPresetsDeferral)) {
          return getPresetsDeferral.promise
        }

        getPresetsDeferral = $q.defer()
        $appApi.then(function (version) {
            if (!(version.$has('searchfilterpresets'))) {
              getPresetsDeferral.resolve([]);
              throw "'formpresets' rel not found"
            }

            return version.$request().$get('searchfilterpresets')
          })
          .then(function (formPresetsPagerAll) {
            if (!formPresetsPagerAll.$has('searchfilterpreset')) {
              getPresetsDeferral.resolve([])
              $log.debug("No 'searchfilter' defined")
            }

            return formPresetsPagerAll.$request().$get('searchfilterpreset')
          })
          .then(function (formpresets) {
            var presets = []
            angular.forEach(formpresets, function (preset) {
              presets.push(new InboxSearchParameters(preset))
            })
            getPresetsDeferral.resolve(presets)
          })
          .catch(function (err) {
            var m = errorHelperService.formatError(err)
            getPresetsDeferral.reject(m)
            throw "Error getting inbox search presets " + m;
          })

        return getPresetsDeferral.promise;
      }
    })

  function InboxSearchParameters(preset) {
    this.name = ''
    this.claimState = 'all'
    this.projectTemplateId = null
    this.groupId = null
    this.concernId = null
    this.taskNames = []
    this.dueFrom = null
    this.dueTo = null

    if (angular.isDefined(preset)) {
      this.name = preset.name
      this.claimState = preset.claimState
      this.projectTemplateId = preset.projectTemplateId
      this.groupId = preset.groupId
      this.concernId = preset.concernId
      this.taskNames = preset.taskNames
      this.dueFrom = preset.dueFrom
      this.dueTo = preset.dueTo
      this.resource = preset
    }
  }

})();

(function () {
  angular.module('gfApp')
    .service('taskInboxSearchService', function ($log, $rootScope, $q, $appApi, $translate, errorHelperService) {

      var me = this;
      me.getTaskActivityFilters = getTaskActivityFilters
      me.onSearchItemSelected = onSearchItemSelected
      me.applyParameters = applyParameters

      activate()

      ///////

      function activate() {
        var deregister = $rootScope.$on('$translateChangeSuccess', function () {
          angular.forEach(allSearchCriteria, function (criterion) {
            criterion.updateTaskNameTranslated()
          })
          angular.forEach(availableSearchValues, function (searchTerm) {
            searchTerm.updateTypeTranslated()
          })
        })

        $rootScope.$on('$destroy', deregister)
      }

      var SEARCH_VALUE_TYPE = {
        projectTemplate: 'projecttemplate',
        group: 'group',
        concern: 'concern',
        taskName: 'taskname'
      }

      var SEARCH_VALUE_ORDER = [
        SEARCH_VALUE_TYPE.projectTemplate,
        SEARCH_VALUE_TYPE.group,
        SEARCH_VALUE_TYPE.concern,
        SEARCH_VALUE_TYPE.taskName
      ]

      var allSearchCriteria = []
      var availableSearchValues = []

      //  Filters work in an AND fashion, and should re-create the existing behaviour of filters in the legacy inbox
      //  This has implications for what makes sense to be selected together. Most things can only be selected one
      //  at a time, thus they need to have a specific value

      //  Search criteria contains a de-normalized set of tasks, concerns, groups, project templates
      //  This is used to limit the available search values, building up an AND query consisting of
      //  (ProjectTemplateId AND GroupId AND ConcernID AND (TaskId OR TaskId OR TaskId ...)

      var chosenProjectTemplateId = null;
      var chosenGroupId = null;
      var chosenConcernId = null;

      //  Task names can be selected several at a time, and this filter works in an OR fashion in combination with the
      //  other selected filter values
      var chosenTaskNames = [];

      /**
       * Handles the selection and clearing event of the ui-select input box
       * @param selectedValuesArray
       * @returns {{projectTemplateId: *, groupId: *, concernId: *, taskNames: Array}}
       */
      function onSearchItemSelected(selectedValuesArray) {
        // Reset
        chosenProjectTemplateId = null
        chosenGroupId = null
        chosenConcernId = null
        clearArray(chosenTaskNames);

        angular.forEach(selectedValuesArray, function (selectedValue) {
          switch (selectedValue.type) {
            case SEARCH_VALUE_TYPE.projectTemplate:
              chosenProjectTemplateId = selectedValue.id
              break;
            case SEARCH_VALUE_TYPE.group:
              chosenGroupId = selectedValue.id
              break;
            case SEARCH_VALUE_TYPE.concern:
              chosenConcernId = selectedValue.id
              break;
            case SEARCH_VALUE_TYPE.taskName:
              chosenTaskNames.push(selectedValue.searchName)
              break;
          }
        })

        // Since we've made a selection, limit the available search values to a subset of the data available
        // using the parameters already provided as the limiting set of criteria
        refreshAvailableValues()

        return {
          selectedValuesArray: selectedValuesArray,
          projectTemplateId: chosenProjectTemplateId,
          groupId: chosenGroupId,
          concernId: chosenConcernId,
          taskNames: chosenTaskNames
        }
      }

      function applyParameters(preset) {
        var selectedValuesArray = []
        angular.forEach(availableSearchValues, function (value) {
          switch (value.type) {
            case SEARCH_VALUE_TYPE.projectTemplate:
              if (value.id === preset.projectTemplateId || null) {
                chosenProjectTemplateId = preset.projectTemplateId
                selectedValuesArray.push(value)
              }
              break;
            case SEARCH_VALUE_TYPE.group:
              if (value.id === preset.groupId || null) {
                chosenGroupId = preset.groupId
                selectedValuesArray.push(value)
              }
              break;
            case SEARCH_VALUE_TYPE.concern:
              if (value.id === preset.concernId || null) {
                chosenConcernId = value.id
                selectedValuesArray.push(value)
              }
              break;
            case SEARCH_VALUE_TYPE.taskName:
                if (angular.isArray(preset.taskNames) && preset.taskNames.indexOf(value.id) !== -1) {
                  chosenTaskNames.push(value.id)
                  selectedValuesArray.push(value)
                }
              break;
          }
        })

        return onSearchItemSelected(selectedValuesArray)
      }


      function refreshAvailableValues() {

        clearArray(availableSearchValues)
        var projectTemplateIds = new HashMap()
        var concernIds = new HashMap()
        var groupIds = new HashMap()
        var taskIds = new HashMap()

        // Search criteria contains a de-normalized set of tasks, concerns, groups, project templates
        // This is used to limit the available search values, building up an AND query consisting of
        // (ProjectTemplateId AND GroupId AND ConcernID AND (TaskId OR TaskId OR TaskId ...)
        angular.forEach(allSearchCriteria, function (criterion) {
          if (matchesChosen(chosenProjectTemplateId, criterion.projectTemplateId)
            && matchesChosen(chosenGroupId, criterion.groupId)
            && matchesChosen(chosenConcernId, criterion.concernId)) {

            if (projectTemplateIds.tryAdd(criterion.projectTemplateId)) {
              availableSearchValues.push(new SearchTerm(
                SEARCH_VALUE_TYPE.projectTemplate,
                criterion.projectTemplateName,
                criterion.projectTemplateName,
                criterion.projectTemplateId));
            }

            if (concernIds.tryAdd(criterion.concernId)) {
              availableSearchValues.push(new SearchTerm(
                SEARCH_VALUE_TYPE.concern,
                criterion.concernCode + ' - ' + criterion.concernName,
                criterion.concernCode,
                criterion.concernId
              ))
            }

            if (groupIds.tryAdd(criterion.groupId)) {
              availableSearchValues.push(new SearchTerm(
                SEARCH_VALUE_TYPE.group,
                criterion.groupName,
                criterion.groupName,
                criterion.groupId,
                criterion.groupIsCompany
              ))
            }

            if (taskIds.tryAdd(criterion.taskName)) {
              availableSearchValues.push(new SearchTerm(
                SEARCH_VALUE_TYPE.taskName,
                criterion.taskNameTranslated,
                criterion.taskName
              ))
            }
          }
        })

        $log.debug('taskInboxSearchService.refreshAvailableValues() - There are ' + availableSearchValues.length + ' values')

        availableSearchValues.sort(function (a, b) {
          var sortByType = SEARCH_VALUE_ORDER.indexOf(a.type) - SEARCH_VALUE_ORDER.indexOf(b.type)
          if (sortByType !== 0) {
            return sortByType
          }

          return naturalSorter(a.searchName, b.searchName)
        })
      }

      function getTaskActivityFilters() {
        var del = $q.defer();

        requestFiltersFromApi()
          .then(function (criteria) {
            allSearchCriteria = criteria
            refreshAvailableValues()
            del.resolve(availableSearchValues)
          })
          .catch(function (err) {
            del.reject(err)
            throw "taskInboxSearchService: getTaskActivityFilters() - Failed to load task activity filters " + errorHelperService.formatError(err)
          })

        return del.promise;
      }

      function requestFiltersFromApi() {
        var del = $q.defer()

        $appApi
          .then(function (version) {
            return version.$request().$get('taskactivityfilters')
          })
          .then(function (taskActivityFilterResource) {
            var searchCriteria = []
            angular.forEach(taskActivityFilterResource.seacrhCriteria, function (element) {
              searchCriteria.push(new SearchCriterion(element))
            })

            del.resolve(searchCriteria)

          })
          .catch(function (err) {
            del.reject(err)
            throw "taskInboxSearchService: loadFilters() - Unable to get task activity filters " + errorHelperService.formatError(err)
          })

        return del.promise;
      }

      function SearchCriterion(resource) {
        var self = this;
        this.taskNameTranslated = resource.taskName
        this.taskName = resource.taskName
        this.concernId = resource.concernId
        this.concernName = resource.concernName
        this.concernCode = resource.concernCode
        this.projectTemplateId = resource.projectTemplateId
        this.projectTemplateName = resource.projectTemplateName
        this.groupId = resource.groupId
        this.groupName = resource.groupName
        this.groupIsCompany = resource.groupIsCompany
        this.updateTaskNameTranslated = updateTaskNameTranslated

        updateTaskNameTranslated()

        function updateTaskNameTranslated() {
          $translate(function (translated) {
            self.taskNameTranslated = translated
          })
        }
      }

      /**
       * This is an item that can be searched for in the inbox search dropdown. We searh by "searchName" and "typeTranslated" allowing a user
       * to find a specific item type they're looking for or an item
       *
       * @param {string} type Search item type : [projectTemplate, group, concern, taskName]
       * @param {string} searchName The translated display name
       * @param {string} shortName Same as the search name, except for stores, which have a really long name, so we use the code instead
       * @param {string} id Identifier for the search parameter, this is usually an int or in the case of taskName search, the task Name of the "Task Template" domain model
       * @constructor
       */
      function SearchTerm(type, searchName, shortName, id, groupIsCompany) {
        var self = this;
        this.type = type
        this.typeTranslated = type
        this.id = id
        this.searchName = searchName
        this.shortName = shortName
        this.updateTypeTranslated = updateTypeTranslated
        this.groupIsCompany = groupIsCompany

        updateTypeTranslated()

        function updateTypeTranslated() {
          $translate('search.itemtype.' + type).then(function (translation) {
            self.typeTranslated = translation
          })
        }
      }
    })


  function matchesChosen(possiblyNullValue, valueToMatch) {
    return possiblyNullValue === null || valueToMatch === possiblyNullValue
  }

  /**
   * Removes all items in an array without destroying its reference
   */
  function clearArray(array) {
    if (angular.isUndefined(array) || array === null) throw "Cannot clear an undefined / null array"
    array.length = 0 // this isn't actually a hack in ECMA script 5+
  }

  /**
   * We could use a plain old object but then we'd have to write the undefined and null checks every time
   * This looks like a C# HashSet
   * @constructor
   */
  function HashMap() {
    var mapObject = {}

    this.tryAdd = function (val) {
      if (angular.isDefined(val) && val !== null && !(val in mapObject)) {
        mapObject[val] = true
        return true
      } else {
        return false
      }
    }
  }

  // https://stackoverflow.com/questions/2802341/javascript-natural-sort-of-alphanumerical-strings/2802804
  function naturalSorter(as, bs) {
    var a, b, a1, b1, i = 0, n, L,
      rx = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
    if (as === bs) return 0;
    a = as.toLowerCase().match(rx);
    b = bs.toLowerCase().match(rx);
    L = a.length;
    while (i < L) {
      if (!b[i]) return 1;
      a1 = a[i],
        b1 = b[i++];
      if (a1 !== b1) {
        n = a1 - b1;
        if (!isNaN(n)) return n;
        return a1 > b1 ? 1 : -1;
      }
    }
    return b[i] ? -1 : 0;
  }

})();

(function () {
  angular.module('gfApp')
    .service('taskInboxService', function ($q, $log, $appApi, $timeout, $translate, debounce, $filter, taskInboxSearchService, taskService, tazkService, dateTimeService, errorHelperService, vibrator, appInsights, notificationService) {

      var availableValues = [];
      var searchLoaded = false;

      var m = {
        smartSearchModel: [],
        smartSearchfilteredValues: [],
        dueFrom: null,
        dueTo: null,
        taskState: 'all'
      }

      var service = this;

      service.open = open
      service.initialize = initialize
      service.pager = new InboxPager()
      service.advancedParametersSet = advancedParametersSet
      service.getSearchParameters = getSearchParameters
      service.markAllTasksRead = markAllTasksRead
      service.getSearch = function () {
        return m
      }
      service.get = get
      service.refreshPage = refreshPage
      service.search = searchInbox
      service.smartSearch = {
        onChange: smartSearchOnChange,
        applyFilter: smartSearchApplyFilter
      }

      var searchCriteria = {}

      function initialize(preset) {

        if (!angular.isObject(preset) || Object.keys(preset).length === 0) {
          preset = undefined
        } else {
          searchLoaded = searchLoaded && preset.refreshFilters !== "true";
          // -- remove 'refreshFilters' it so it does not get added to the url
          delete preset.refreshFilters;
        }

        var d = $q.defer();
        var updatedPreset = searchInbox(preset)

        if (searchLoaded) {
          setSearchParameters(updatedPreset)
          d.resolve(updatedPreset)
        } else {
          taskInboxSearchService.getTaskActivityFilters()
            .then(function (availableSearchValues) {
              $log.debug('InboxController: loaded search values')
              availableValues = availableSearchValues
              m.smartSearchfilteredValues = availableSearchValues
              setSearchParameters(updatedPreset)
              searchLoaded = true
              d.resolve(updatedPreset)
            })
            .catch(function (err) {
              d.resolve()
              throw "taskInboxService: initialize() - Failed to get search filters " + errorHelperService.formatError(err)
            })
        }

        return d.promise;
      }

      function setSearchParameters(p) {
        searchCriteria = taskInboxSearchService.applyParameters(p)
        m.smartSearchModel = searchCriteria.selectedValuesArray
        m.dueFrom = dateTimeService.momentFromUtc(p.dueFrom)
        m.dueTo = dateTimeService.momentFromUtc(p.dueTo)
        m.taskState = p.claimState || 'all'
      }

      function smartSearchOnChange() {
        searchCriteria = taskInboxSearchService.onSearchItemSelected(m.smartSearchModel)
        smartSearchApplyFilter()
      }

      function smartSearchApplyFilter(s) {
        m.smartSearchfilteredValues = !angular.isString(s)
          ? availableValues
          : $filter('propsFilter')(availableValues, {searchName: s, typeTranslated: s})
      }

      function searchInbox(parameters) {
        parameters = parameters || getSearchParameters()

        service.pager.query = new InboxPagerQuery()
        angular.forEach(parameters, function (value, key) {
          service.pager.query[key] = value
        })

        service.pager.reset()

        return parameters
      }

      function refreshPage() {
        service.pager.goPage()
      }

      function getSearchParameters() {
        return {
          projectTemplateId: searchCriteria.projectTemplateId,
          groupId: searchCriteria.groupId,
          concernId: searchCriteria.concernId,
          taskNames: searchCriteria.taskNames,
          claimState: nullIfDefaultTaskState(m.taskState),
          dueFrom: dateTimeService.formatMomentOrNull(m.dueFrom),
          dueTo: dateTimeService.formatMomentOrNull(m.dueTo)
        }
      }

      function advancedParametersSet() {
        return m.dueFrom || m.dueTo || nullIfDefaultTaskState()
      }

      function markAllTasksRead() {
        if (!angular.isArray(service.pager.items)) {
          return
        }

        angular.forEach(service.pager.items, function (task) {
          if (angular.isDefined(task.isViewed)) {
            task.isViewed = true
          }
        })
      }

      function open(task) {
        var q = $q.defer()

        task.isBusy = true;

        // -- fetch data if its just a task id
        if (angular.isUndefined(task.resource)) {
          get(task.id).then(function (data) {
            return open(data)
          })
          .then(function (data) {
            q.resolve(data)
          })
          .catch(function () {
            q.reject()
          })
          .finally(function(){
            task.isBusy = false;
          })
        }else{
          vibrator.vibrate()
          task.isViewed = true

          $timeout(function () {
            // -- immediate task display
            var t = tazkService.tryAddNewTazkViewModel(task);

            // -- get task details
            taskService.populateFields(t)
              .then(function () {
                return taskService.populateTask(t)
              })
              .then(function (task) {
                task.loaded = true
                q.resolve(task)
              })
              .finally(function(){
                task.isBusy = false;
              })
              .catch(function (ex) {
                if (ex.status === 404) {
                  appInsights.trackEvent("Tried to access removed task", {id: task.id})
                  notificationService.error('inbox.tasknotfound')
                  task.tazk.close()
                  q.reject()
                }
              })
          })
        }


        return q.promise
      }

      // Treat the 'all' value as null for the purposes of passing around search parameters
      function nullIfDefaultTaskState() {
        return m.taskState !== 'all'
          ? m.taskState
          : null
      }

      function InboxPagerQuery() {
        this.pageNumber = 1 
        this.claimState = 'all'
        this.pageSize = 8
        this.projectTemplateId = null
        this.groupId = null
        this.concernId = null
        this.taskNames = []
        this.dueFrom = null
        this.dueTo = null
      }

      function InboxPager() {
        var me = this;
        this.items = []
        this.busy = true
        this.page = 1
        this.pageSize = 8
        this.reset = function () {
          me.items.length = 0
          me.busy = false
          me.page = 1
          me.goPage();
        }
        this.query = new InboxPagerQuery()
        this.getQueryParams = function () {
          this.query.pageNumber = me.page
          this.query.pageSize = me.pageSize
          return this.query
        }
        this.removeTask = function (id) {
          angular.forEach(me.items, function (item, idx) {
            if (item.id === id) {
              me.items.splice(idx, 1)
              if(!me.items.length && me.page > 1) {
                me.page--;
              }
              me.goPage()
              return
            }
          })
        }
        
        this.goPage = function () {
          if (me.busy) {
            return;
          }
          me.busy = true;
          me.getPageOfInboxTasks(me.getQueryParams())
            .then(function (taskList) {
              me.items = taskList.map(function(t) { return new Task(t)})
              me.busy = false;

              $timeout(function(){
                angular.element(window).trigger("scroll")
              })
            })
            .catch(function () {
              me.busy = false;
            });
        }

        this.getPageOfInboxTasks = function(queryParameters) {
          return $appApi
            .then(function (version) {
              return version.$request().$get('taskactivities', queryParameters)
            })
            .then(function (activityPager) {
              me.knownPagesAvailable = activityPager.knownPagesAvailable;
              me.totalItemsCount = activityPager.totalItemsCount;

              if (activityPager.$has('taskactivity'))
                return activityPager.$request().$get('taskactivity')
            })
            .catch(function (err) {
              throw "Cannot get a task page " + errorHelperService.formatError(err)
            });
        }
      }

      

      function get(taskId) {
        return $appApi
          .then(function (version) {
            return version.$request().$get('taskactivity', {taskId: taskId})
          })
          .then(function (data) {
            return new Task(data)
          })
      }

      // TAZK VIEW MODEL - tazk.service.js -> goes into -> tazks = [] array via tryAddNewInboxTask()
      function Task(taskResource) {
        this.tazkViewModelId = taskResource.id + '-inboxTask' // TODO - use this instead of ID in tazk.* components
        this.tazkViewModelType = 'inboxTask'
        this.id = taskResource.id
        this.dueOn = taskResource.dueOn
        this.createdOn = taskResource.createdOn
        this.name = taskResource.name
        this.title = taskResource.concernCode
        this.clientName = taskResource.clientName
        this.concernCode = taskResource.concernCode
        this.concernName = taskResource.concernName
        this.projectInstanceId = taskResource.projectInstanceId
        this.projectInstanceName = taskResource.projectInstanceName
        this.projectTemplateName = taskResource.projectTemplateName
        this.projectTemplateCode = taskResource.projectTemplateCode
        this.state = taskResource.state
        this.stateTranslationKey = taskResource.stateTranslationKey
        this.projectTypeName = taskResource.projectTypeName
        this.claimable = taskResource.claimable
        this.unclaimable = taskResource.unclaimable
        this.claimed = taskResource.claimed
        this.isViewed = taskResource.isViewed
        this.resource = taskResource
        this.fields = []
        this.actions = []
        this.notes = { // This data is populated via the taskNotesService
          isLoaded: false,
          data: false,
          highlightRequiredAction: '',
          noteFromThisTaskWasSent: false
        }
      }
    })

})();

(function () {
  angular.module('gfApp')
    .service('taskService', function ($log, $q, pagerService, errorHelperService, dataValueService) {

      var vm = this

      vm.claim = claim
      vm.unclaim = unclaim
      vm.populateFields = populateFields
      vm.populateTask = populateTask
      vm.completeWithAction = completeWithAction
      vm.isCompleteWithActionValid = isCompleteWithActionValid

      //////////////


      function unclaim(task) {
        return claimUnclaim(task, false);
      }

      function claim(task) {
        return claimUnclaim(task, true);
      }

      /**
       * Indicates what is requried to complete a task with the action
       * @param {object} task
       * @param {string} actionName
       */
      function isCompleteWithActionValid(task, actionName) {

        var result = {
          noteRequired: false,
          fieldsRequired: false
        }

        var action = task.actions.filter(function (action) {
          return action.name === actionName
        })[0];

        if (action.requiresNote && !task.notes.noteFromThisTaskWasSent && (angular.isUndefined(task.note) || task.note === '')) {
          $log.debug(actionName + ' a note is required')
          task.notes.highlightRequiredAction = actionName
          result.noteRequired = true
        }

        angular.forEach(task.fields, function (field) {
          if (action.requiresAttributes.indexOf(field.id) !== -1) {
            if (!dataValueService.hasValue(field)) {
              field.highlightRequiredAction = actionName
              result.fieldsRequired = true
            }
          }
        })

        return result
      }

      /**
       * @param {object} task
       * @param {string} actionName
       */
      function completeWithAction(task, actionName) {
        var del = $q.defer();
        task.resource.$request().$put('self', {}, {
          completedWithAction: actionName,
          claimed: task.claimed,
          state: task.resource.state,
          status: task.status, // is more correct to be 'status' instead of 'state'... hacking this because I don't want to refactor the existing models/code for the inbox complete,
          note: task.note,
          projectRoleMappings: task.projectRoleMappings
        })
          .then(function (data) {
            // Clean up the task from the inbox, etc
            del.resolve(data)
          })
          .catch(function (response) {
            del.reject(response.data.message)
            throw "Failed to complete task " + errorHelperService.formatError(response)
          })

        return del.promise;
      }

      function claimUnclaim(task, claim) {
        var resource = {
          claimed: claim,
          claimable: task.claimable,
          unclaimable: task.unclaimable,
          state: task.state,
          id: task.id
        };

        task.isBusy = true;
        return task.resource.$request()
          .$put('taskactivityedit', resource.id, resource)
          .finally(function(){
            task.isBusy = false;
          });
      }

      // -- initialize task info
      function populateFields(taskInfo) {
        var deferral = $q.defer();

        if (taskInfo.resource.$has('taskactivitydetails')) {
          taskInfo.resource.$request().$get('taskactivitydetails')
            .then(function (taskDetails) {
              taskInfo.actions = []
              angular.forEach(taskDetails.actions, function (action) {
                taskInfo.actions.push(new TaskAction(action))
              })

              if(taskDetails.$has('projectrolemappings')){
                taskInfo.tazk.projectRoleMappingsPager = new pagerService.Pager({
                  resource: taskDetails,
                  mapper: ProjectRoleMapping,
                  initialRel: 'projectrolemappings',
                  dataRel: 'projectrolemapping',
                  pageSize: 0
                })
              }

              if (taskDetails.$has('dataValue')) {
                taskDetails.$request().$get('dataValue').then(function (data) {
                  taskInfo.fields = data;

                  deferral.resolve(taskInfo);
                });
              } else {
                deferral.resolve(taskInfo);
              }
            })
            .catch(function (ex) {
              deferral.reject(ex);
              throw 'Cannot map task fields ' + errorHelperService.formatError(ex);
            });
        } else {
          deferral.resolve(taskInfo);
        }

        return deferral.promise;
      }

      // -- populate the task
      function populateTask(taskResource) {
        var deferral = $q.defer();
        var promises = [];
        var fields = taskResource.fields;
        taskResource.fields = [];
        if (fields.length > 0) {
          $q(function (resolve/*, reject*/) {
              angular.forEach(fields, bindField);
             taskResource.fieldsByCategory = dataValueService.groupByCategory(taskResource.fields)

              $q.all(promises).then(function () {
                resolve()
              });
            }
          ).then(function () {
            deferral.resolve(taskResource)
          });
        }
        else {
          deferral.resolve(taskResource)
        }
        return deferral.promise;

        function bindField(field) {
          var taskItem = new TaskItem(taskResource, field)
          // -- files
          if (field.$hasEmbedded('file')) {
            var promise = field.$request().$get('file')
              .then(function (files) {
                angular.forEach(files, function (file) {
                  taskItem.content.push(file);
                });
              });
            promises.push(promise);
          }

          taskResource.fields.push(taskItem);
        }

      }

      // TODO: Remap everything required by this object from the field resource.
      function TaskItem(taskResource, field) {

        this.id = field.id
        this.type = field.type
        this.name = field.name
        this.readonly = field.readonly || !taskResource.claimed
        this.canEdit = field.canEdit
        this.listOrder = field.listOrder
        this.categoryName = field.categoryName,
        this.categoryListOrder = field.categoryListOrder,
        this.categoryType = field.categoryType
        this.categoryId = field.categoryId

        this.content = []
        this.value = field.value
        this.highlightRequiredAction = '' // The specified action requires this field to be filled
        this.isBusy = false;

        // TODO: Rename to "resource" and use _only_ for the API
        this.field = field
        // TODO: Do not use "taskField", replace its use in the file upload service : There's too much nesting and duplication
        this.containerId = field.id
      }

      function TaskAction(actionResource) {
        this.name = actionResource.name;
        this.requiresAttributes = actionResource.requiresAttributes
        this.requiresNote = actionResource.requiresNote
        this.optionalItemsUrl = actionResource.optionalItemsUrl
      }

      function ProjectRoleMapping(resource) {
        return {
          id: resource.id,
          name: resource.name
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('supportTeamMessageService', function ($log, appInsights, $appApi) {

      var service = {
        getAllGeneralApplicationUserMessages: getAllGeneralApplicationUserMessages,
        getGeneralApplicationUserMessagesBySearch:getGeneralApplicationUserMessagesBySearch
      };

      return service;

      function getAllGeneralApplicationUserMessages (){
        return $appApi.then(function (version){
          return version.$request().$get('supportchatmessages');
        });
      }

      function getGeneralApplicationUserMessagesBySearch(query){
        return $appApi.then(function (version){
          return version.$request().$get('searchmessages', {query : query});
        });
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('storeService', storeService)

  function storeService($appApi, $log, pagerService) {
    var vm = this

    vm.pager = null

    vm.get = get
    vm.initialize = initialize

    ////////

    function initialize(options, mapFn){
      $log.debug('Service - storeService - initialize')

      vm.pager = new pagerService.Pager({
        resource: $appApi,
        initialRel: 'stores',
        dataRel: 'store',
        mapper: mapFn || Store,
        nextPageRel: 'next',
        pageSize: 10,
        defaultSearchCriteria: angular.isDefined(options) ? options.defaultSearchCriteria : null
      })
    }

    function get(id){
      return $appApi
        .then(function (v) {
          return v.$request().$get('store', {concernId: id})
        })
        .then(function(data){
          return Store(data)
        })
    }

    function Store(resource){
      return {
        resource : resource,
        id : resource.id,
        name : resource.name
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('scrollingService', function ($document, $window, $timeout) {
      this.scrollWindowTo = scrollWindowTo
      this.scrollTo = scrollTo
      this.scrollToIfCannotSee = scrollToIfCannotSee
      this.scrollOnResize = scrollOnResize
      this.scrollToError = scrollToError

      /////

      // -- scroll windows to
      function scrollWindowTo(offsetX, offsetY){
        offsetX = angular.isDefined(offsetX) ? offsetX : 0;
        offsetY = angular.isDefined(offsetY) ? offsetY : 0;

        $window.scrollTo(offsetX, offsetY);
      }

      // -- scroll to element and a given an offset
      function scrollTo(elem, offset) {
        $document.scrollToElementAnimated(elem,offset, 500)
        // scroll(getFirstScrollableContainer(elem), elem, offset);
      }

      // -- scroll to element and a given an offset if not visible
      function scrollToIfCannotSee(elem, offset) {
        var container = getFirstScrollableContainer(elem);
        var containerHeight = container.height() - offset;
        var cannotSee = elem.position().top + elem.height() > containerHeight;

        if(cannotSee){
          scroll(getFirstScrollableContainer(elem), elem, offset);
        }
      }

      // -- bind window resize event and scroll to element given a condition
      function scrollOnResize(scope, elem, condition, offset) {
        if (angular.isUndefined(condition)) {
          throw 'Condition is required in order to perform a scroll'
        }

        var resizeFocus = function resizeFocus() {
          scrollOnResizeAndCondition(condition, getFirstScrollableContainer(elem), elem, offset);
        }

        // -- bind resize event
        angular.element($window).on('resize', resizeFocus);

        // -- unbind on scope estroy
        scope.$on('$destroy', function () {
          angular.element($window).off('resize', resizeFocus);
        });
      }

      function scrollToError(){
        var elem = angular.element('.has-error').first()

        if(elem.length > 0){
          this.scrollTo(elem,0)
        }
      }


      // --------

      function scrollOnResizeAndCondition(condition, container, e, offset) {
        if (!condition()) {
          return;
        }

        var containerHeight = container.height() - offset;
        var cannotSee = e.position().top + e.height() > containerHeight;

        if (cannotSee) {
          scroll(container, e, containerHeight)
        }
      }

      function scroll(container, elem, offset) {
        if (angular.isUndefined(container) || angular.isUndefined(elem) || elem.length == 0) {
          return;
        }

        $timeout(function(){
          container.scrollToElementAnimated(elem, offset);
        })
        
      }

      function getFirstScrollableContainer(elem) {
        if (angular.isUndefined(elem)) {
          return undefined;
        }

        if (elem == $document) {
          return elem;
        }

        if (elem.css("overflow-y") === "auto") {
          return elem;
        } else {
          return getFirstScrollableContainer(elem.parent())
        }
      }
    });
})();

(function(){
  angular.module('gfApp')
    .service('requestHelperService',requestHelperService )

  function requestHelperService(uriTemplate){
    var vm = this

    vm.normalize = normalize
    vm.getQuery = getQuery
    vm.getFromQuery = getFromQuery

    var templates = {
      'projectTasks' : '{?projectTemplateId,query,storeId,status,clientId}',
      'projectTasksAttributes' : '{?attributeType,projectTemplateId,clientId,storeId,status}'
    }

    var metaDataEntities = ['brand', 'projectType']

    ////////

    function normalize(params, deleteFoundKeys){
      var normalized = angular.copy(params)

      angular.forEach(params, function(value,key){
        if(angular.isUndefined(value)){
          normalized[key + "Id"] = undefined
          if(deleteFoundKeys){
            delete normalized[key]
          }
        }
        if(angular.isObject(value)){
          if(angular.isDefined(value.id)){
            normalized[key + "Id"] = value.id

            if(metaDataEntities.includes(key)){
              if(!normalized.metaDataEntities){
                normalized.metaDataEntities = []
              }
              normalized.metaDataEntities.push({name: value.name, id:value.id, type: key})
            }

            if(deleteFoundKeys){
              delete normalized[key]
            }
          }else if(angular.isDefined(value.value)){
            normalized[key] = value.value
          }
        }
      })

      return normalized
    }

    function getQuery(template, filter){
      return uriTemplate.create(templates[template]).toUri(vm.normalize(filter,true)).substring(1)
    }

    function getFromQuery(template, query) {
      return uriTemplate.create(templates[template]).fromUri("?" + query)
    }

  }
})();

(function () {
  angular.module('gfApp')
    .service('reportContainerService', service)

    function service($appApi, $log, pagerService) {
      var vm = this
      vm.pager = pager

      /////////////

      function pager(){
        $log.debug('Service - reportContainerService - pager')

        return new pagerService.Pager({
          resource: $appApi,
          initialRel: 'reporttemplates',
          dataRel: 'reporttemplate',
          mapper: ReportTemplate,
          nextPageRel: 'next',
          pageSize: 10
        })
      }

      function ReportTemplate(resource) {
        return {
          resource: resource,
          id: resource.id,
          name: resource.name,
          body: resource.body
        };
      }
  }
})();

(function () {
  angular.module('gfApp')
    .service('reportService', service)

  function service($appApi, fileEndpointService) {
    var vm = this

    vm.download = download
    vm.get = get

    ////////

    function get(projectTemplateIds){
      return $appApi
        .then(function (v) {
          return v.$request().$get('report', {projectTemplateIds: projectTemplateIds})
        })
        .then(function(data){
          return ReportingData(data)
        })
    }

    function download(resource, data){
      fileEndpointService.downloadPost(resource, data)
    }

    function ReportingData(resource){
     var vm = {
        resource : resource,
        all: resource.dataItems,
        attributes : resource.dataItems.filter(function(m){return m.type === 'attribute'}).map(ReportDataDto),
        tasks : resource.dataItems.filter(function(m){return m.type === 'task'}).map(ReportDataDto),
        milestones : resource.dataItems.filter(function(m){return m.type === 'milestone'}).map(ReportDataDto)
      }

      vm.categories = groupByCategory(vm.attributes)
      vm.all = vm.all.concat(vm.categories)

      return vm
    }

    function ReportDataDto(dto){
      dto.selector = dto.idsStr + dto.type

      return dto
    }

    function groupByCategory(data) {
      var categories = []

      angular.forEach(data, function (m) {

        var found = false
        angular.forEach(categories, function (g) {
          if (g.name === m.categoryName) {
            g.attributes.push(m)
            found = true
          }
        })

        if (!found) {
          categories.push({selector: m.categoryId + 'category',
            name: m.categoryName,
            type: m.categoryType,
            listOrder: m.categoryListOrder,
            attributes: [m]})
        }
      })

      return categories
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('projectTemplateService', projectTemplateService)

  function projectTemplateService($appApi, $log, $q, errorHelperService, pagerService, requestHelperService, configService, fileEndpointService, gfHelper) {
    var vm = this

    vm.pager = null

    vm.get = get
    vm.getAll = getAll
    vm.create = create
    vm.update = update
    vm.remove = remove
    vm.getDetail = getDetail
    vm.getDetailAttributes = getDetailAttributes
    vm.getAttributesUpdate = getAttributesUpdate
    vm.updateAttribute = updateAttribute
    vm.features = configService.appSettings.features
    vm.getReport = getReport
    vm.getTasks = getTasks
    vm.getMilestones = getMilestones
    vm.getProjects = getProjects

    vm.getPager = getPager

    vm.getVersionUpdates = getVersionUpdates
    vm.workflowVersionUpdate = workflowVersionUpdate
    vm.domainModelVersionUpdate = domainModelVersionUpdate

    ////////

    function get(id) {
      return $appApi
        .then(function (v) {
          return v.$request().$get('projecttemplate', {projectTemplateId: id})
        })
        .then(function (data) {
          return ProjectTemplate(data)
        })
    }

    function getPager(options){
      return new pagerService.Pager({
        resource: $appApi,
        initialRel: 'projecttemplates',
        dataRel: 'projecttemplate',
        mapper: ProjectTemplate,
        nextPageRel: 'next',
        pageSize: options ? options.pageSize : 10,
        append: options ? options.append : false
      })
    }

    function getAll(){
      return $appApi
        .then(function (v) {
          return v.$request().$get('projecttemplate', {})
        })
        .then(function (data) {
          return data.$request().$get('projecttemplate')
        })
        .then(function(data){
          return data.map(ProjectTemplate)
        })
    }


    function create(model) {
      return $appApi
        .then(function (v) {
          if(vm.features.projectGroup && angular.isUndefined(model.client)) {
            throw '- Client field is required'
          }
          if(vm.features.projectGroup && angular.isUndefined(model.brand)) {
            throw '- Brand field is required'
          }
          else if (vm.features.projectType && angular.isUndefined(model.projectType)) {
            throw '- Project Type field is required'
          }
          return v.$request().$post('projecttemplates', {}, requestHelperService.normalize(model))
        })
        .then(function (data) {
          return ProjectTemplate(data)
        })
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot create project template ' + err
        })
    }

    function update(resource) {
      return resource.resource.$request().$putSelf(resource)
    }

    function remove(resource) {
      return resource.$request().$deleteSelf()
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot delete project template ' + err
        })
    }

    function getDetail(projectTemplateId) {
      return $appApi
        .then(function (v) {
          return v.$request().$get('projecttemplate-detail', {projectTemplateId: projectTemplateId})
        })
        .then(function (data) {
          return ProjectTemplateDetail(data)
        })
    }

    function getDetailAttributes(resource) {
      return resource.$request().$get('attributes')
        .then(function (data) {
          return ProjectTemplateAttributes(data)
        })
    }

    function getAttributesUpdate(resource) {
      return resource.$request().$get('attributes-update')
        .then(function (data) {
          return AttributesUpdate(data)
        })
    }

    function updateAttribute(model){
      return model.resource.$request().$putSelf(model)
    }

    /////////////////

    function AttributesUpdate(resource) {
      var defer = $q.defer()
      var vm = {
        resource: resource,
        attributes: []
      }

      if (resource.$has('attribute')) {
        resource.$request().$get('attribute')
          .then(function (data) {
            vm.attributes = data.map(AttributeUpdate)
            defer.resolve(vm)
          })
      } else {
        defer.resolve(vm)
      }

      return defer.promise
    }

    function getReport(filter){
      fileEndpointService.download('projecttemplate-csv', undefined, filter);
    }

    function getVersionUpdates(){
      return $appApi
        .then(function (v) {
          return v.$request().$get('workflowupdates')
            .then(function(resource){
              return ProjectTemplateUpdates(resource)
            })
        })
    }

    function workflowVersionUpdate(projectTemplateId, workflowId, workflowTarget) {
      var info = {
        projectTemplateId: projectTemplateId,
        projectTemplateTarget: null,
        workflowId: workflowId,
        workflowTarget: workflowTarget
      }

      return $appApi
        .then(function (v) {
          return v.$request().$post('workflowupdate-workflow',info)
            .catch(function (e) {
              var err = errorHelperService.formatError(e)
              $log.error(err)
              throw 'Cannot delete project template ' + err
            })
        })
    }

    function domainModelVersionUpdate(projectTemplateId, projectTemplateTarget) {
      var info = {
        projectTemplateId: projectTemplateId,
        projectTemplateTarget: projectTemplateTarget,
        workflowId: null,
        workflowTarget: null
      }

      return $appApi
        .then(function (v) {
          return v.$request().$post('workflowupdate-projecttemplate',info)
            .catch(function (e) {
              var err = errorHelperService.formatError(e)
              $log.error(err)
              throw 'Cannot delete project template ' + err
            })
        })
    }

    function getTasks(resource){
      return resource.$request().$get('tasks').then(function(res){
        return res.data.map(ProjectTemplateTask);
      });
    }

    function getMilestones(resource){
      return resource.$request().$get('milestones');
    }

    function getProjects(resource){
      return resource.$request().$get('status');
    }

    // ---------------------------

    function ProjectTemplate(resource) {
      var vm = {
        resource: resource,
        id: resource.id,
        rootWorkflowId: resource.rootWorkflowId,
        name: resource.name,
        code: resource.code,
        clientId: resource.clientId,
        clientName: resource.clientName,
        projectTypeId: resource.projectTypeId,
        projectTypeName: resource.projectTypeName,
        brandId: resource.brandId,
        brandName: resource.brandName,
        isActive: resource.isActive,
        pendingProjectInstances: resource.pendingProjectInstances,
        completedProjectInstances: resource.completedProjectInstances,
        overdueProjectInstances: resource.overdueProjectInstances,
        totalProjectInstances: resource.totalProjectInstances,
        createdOn: resource.createdOn
      }

      if(resource.metaDataEntities){
        angular.forEach(resource.metaDataEntities, function(m){
          vm[gfHelper.toCamelCase(m.type)+'Id'] = m.id;
          vm[gfHelper.toCamelCase(m.type)+'Name'] = m.name;
        });
      }

      return vm
    }

    function ProjectTemplateAttributes(resource) {
      var defer = $q.defer()
      var vm = {
        resource: resource,
        attributes: []
      }

      if (resource.$has('attribute')) {
        resource.$request().$get('attribute')
          .then(function (data) {
            vm.attributes = data.map(ProjectTemplateAttribute)
            defer.resolve(vm)
          })
      } else {
        defer.resolve(vm)
      }

      return defer.promise
    }

    function ProjectTemplateDetail(resource) {
      return ProjectTemplate(resource)
    }

    function ProjectTemplateAttribute(resource) {
      return {
        resource: resource,
        id: resource.id,
        name: resource.name,
        attributeType: resource.attributeType.toLowerCase(),
        listOrder: resource.listOrder,
        categoryName: resource.categoryName,
        categoryListOrder: resource.categoryListOrder,
        categoryId: resource.categoryId
      }
    }

    function AttributeUpdate(resource){
      return {
        resource: resource,
        id: resource.id,
        name: resource.name,
        type: resource.attributeType.toLowerCase(),
        listOrder: resource.listOrder,
        categoryName: resource.categoryName,
        categoryListOrder: resource.categoryListOrder,
        categoryId: resource.categoryId,
        availableValues: resource.availableValues,
        isMultiple: resource.isMultiple
      }
    }

    function ProjectTemplateTask(model) {
      var total = model.activeNotOverdue + model.activeOverdue + model.completed

      return {
        completed: model.completed,
        overdue: model.activeOverdue,
        inProgress: model.activeNotOverdue,
        active: model.activeNotOverdue + model.activeOverdue,
        name: model.taskName,
        percents: {
          completed: model.completed / total * 100,
          overdue: model.activeOverdue / total * 100,
          inProgress: model.activeNotOverdue / total * 100
        }
      }
    }

    function ProjectTemplateUpdates(resource) {
     return {
       resource: resource,
       updatesInProgress:resource.updatesInProgress,
       upgradeableWorkflows: resource.upgradeableWorkflows
     }
    }


  }
})();

(function () {
  angular.module('gfApp')
    .service('projectInstanceRoleMappingService', function ($log, $q, pagerService, notificationService) {
      var vm = this

      vm.get = get
      vm.update = update

      //////////

      function get(resource) {
        if (!resource.$has('projectrolemappings')){
          return $q(function(s){s([])})
        } else {
          return resource.$request().$get('projectrolemappings')
            .then(function (dataRoles){
              if (dataRoles.$has('projectrolemapping')) {
                return dataRoles.$request().$get('projectrolemapping')
              }else{
                return []
              }
            })
            .then(function(projectRoles){return projectRoles.map(RoleAssignment)})
        }
      }

      function update(resource, data) {
        return $q(function (resolve, reject) {
          resource.$request().$get('projectrolemappings')
            .then(function (roles) {
              return $q.all(data.map(function (r) {
                if (!angular.equals(r.userOrGroup.map(UserOrGroupSimple), r.userOrGroupOriginal.map(UserOrGroupSimple))) {
                  return updateRole(roles, r)
                }
              }))
            })
            .then(resolve)
            .catch(reject)
        })
      }

      function updateRole(dataRoles, role){
       return dataRoles.$request().$putSelf(role)
          .then(function(r){
            return RoleAssignment(r)})
          .catch(function (e) {
            $log.error(e)
            notificationService.error('projectinstance.projectrolemapping.errorupdate')
          })
      }

      function RoleAssignment(resource) {
        var vm = {
          resource: resource,
          id: resource.id,
          name: resource.name,
          projectId: resource.projectId,
          projectRoleId: resource.id,
          userOrGroup: [],
          userOrGroupOriginal: [],
          groups: [],
          usersAssigned: [],
          usersMappedHtml: angular.isDefined(resource.usersMapped) ? resource.usersMapped.map(function(m){return "<b>"+m+"</b>"}).join('<br/>') : undefined,
          pager: ProjectRolePager(resource)
        }

        if (resource.$has('group')) {
          resource.$request().$get('group')
            .then(function (data) {
              vm.groups = data.map(Group)
              vm.userOrGroup = vm.userOrGroup.concat(data.map(Group))
              vm.userOrGroupOriginal = vm.userOrGroupOriginal.concat(data.map(Group))
            })
        }

        if (resource.$has('user')) {
          resource.$request().$get('user')
            .then(function (data) {
              vm.user = data.map(User)
              vm.usersAssigned = data.map(User)
              vm.users = vm.usersAssigned
              vm.userOrGroup = vm.userOrGroup.concat(data.map(User))
              vm.userOrGroupOriginal = vm.userOrGroupOriginal.concat(data.map(User))
            })
        }
        return vm
      }

      function User(resource) {
        return {
          resource: resource,
          id: resource.id,
          name: resource.longName + ' - '+ resource.shortName,
          type: 'user'
        }
      }

      function Group(resource) {
        return {
          resource: resource,
          id: resource.id,
          name: resource.name,
          type: 'group'
        }
      }

      function UserOrGroup(resource){
        return {
          resource : resource,
          id : resource.id,
          name : resource.name,
          type : resource.type
        }
      }

      function UserOrGroupSimple(resource){
        return {
          id : resource.id,
          name : resource.name,
          type : resource.type
        }
      }

      function ProjectRolePager(resource){
        return new pagerService.Pager({
          resource: resource,
          initialRel: 'projectrole-usersgroups',
          dataRel: 'projectrole-usersgroup',
          mapper: UserOrGroup,
          nextPageRel: 'next',
          pageSize: 10
        })
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('projectInstanceReportService', service)

  function service($appApi, $log, $q, $window, $document, errorHelperService, dataValueService, configService) {
    var vm = this

    vm.getData = getData
    vm.getReport = getReport

    ////////

    function getData(resource, model) {
      return resource.$request().$post('report', null, model)
        .then(function(data){return ReportDaoData(data, model.template)})
        .catch(function(e){
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot get the report data ' + err
        })
    }

    function getReport(model, reportName) {
      return $appApi
        .then(function (v) {
          if(reportName.length){
            model.reportName = reportName
          }
          return v.$request().$post('pdf', null, model, { responseType: 'arraybuffer'})
        })
        .then(download)
        .catch(function(e){
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot post html report data ' + err
        })
    }

    //////

    /// helper method 
    function download(data) {
      var fileName = data.headers('FileName')
      var fileType = data.headers('Content-Type')

      var file = new Blob([data.data], {type: fileType});
      var isChrome = !!$window.chrome && !!$window.chrome.webstore;
      var isIE = !!$document.documentMode;
      var isEdge = !isIE && !!$window.StyleMedia;

      if (isChrome) {
        var url = $window.URL || $window.webkitURL;

        var downloadLink = angular.element('<a></a>');
        downloadLink.attr('href', url.createObjectURL(file));
        downloadLink.attr('target', '_self');
        downloadLink.attr('download', fileName);
        downloadLink[0].click();
      }
      else if (isEdge || isIE) {
        $window.navigator.msSaveOrOpenBlob(file, fileName);
      }
      else {
        var fileURL = URL.createObjectURL(file);
        $window.open(fileURL);
      }
    }

    function mapAttributes(data){
      var mappings = null
      data.mapped = {}

      if(data.reportDaoTemplate === 'sow') {
        mappings = [
          { attributeName: 'Job Description', reportVarName: 'jobDescription' },
          { attributeName: 'Equipment / Tools required', reportVarName: 'equipmentTools' },
          { attributeName: 'Material/Fixtures provided by client', reportVarName: 'materialsFixtures' },
          { attributeName: 'Material provided locally', reportVarName: 'materialsLocal' }
        ]
      }

      if(mappings !== null){
        angular.forEach(mappings, function(m){
          data.dataValues.some(function(dv){
            if( dv.name === m.attributeName){
              data.mapped[m.reportVarName] = dv.value
              return true
            }
          })
        })
      }
    }

    /////////////

    function ReportDaoData(resource, template) {
      var defer = $q.defer()

      var model = {
        resource: resource,
        reportDaoTemplate: resource.reportDaoTemplate,
        projectInstanceId: resource.projectInstanceId,
        projectInstanceName: resource.projectInstanceName,
        templateUrl: "app/modules/siskin/projectinstance/report/templates/"+configService.customer+"/"+ template.toLowerCase() + ".html"
      }

      dataValueService.getDataValuesByGroup(resource, function (m) {
        return m.categoryName
      }, function (m) {
        return m.categoryListOrder
      }, function (m) {
        return m.categoryType
      }, function (m) {
        return m.categoryId
      }).then(function (data) {
        model.categories = data.groups
        model.dataValues = data.dataValues

        mapAttributes(model)

        defer.resolve(model)
      })

      return defer.promise
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('projectInstanceDetailService', function ($log, $appApi, $q, dataValueService, projectInstanceService, notificationService, errorHelperService) {
      var vm = this
      vm.get = get
      vm.update = update
      vm.remove = remove

      vm.maps = {
        Project:Project
      }

      function get(projectId, showDraftValues) {
        return $appApi
          .then(function (version) {
            return version.$request().$get('project-detail', {projectId: projectId, showDraftValues: showDraftValues})
            .then(function(data){
              return Project(data);
            });
          })
      }

      function update(resource, data) {
        return resource.$request()
          .$putSelf(data)
          .then(ProjectBasic)
          .catch(function(e){
            $log.error(e)
            notificationService.error('projectinstance.detail.errorupdate')
          })
      }

      /////

      function Project(resource) {
        var vm = {
          resource: resource,
          id : resource.id,
          projectId : resource.projectId,
          projectName: resource.projectName,
          name: resource.name,
          clientName: resource.clientName,
          clientLogoUrl: resource.clientLogoUrl,
          brandName: resource.brandName,
          projectInstanceName: resource.projectInstanceName,
          projectTemplateName: resource.projectTemplateName,
          projectTemplateCode: resource.projectTemplateCode,
          concernId: resource.concernId,
          concernName: resource.concernName,
          concernAddress: resource.concernAddress,
          nextMilestoneName: resource.nextMilestoneName,
          isActive: resource.isActive,
          startedOn: resource.startedOn,
          startingOn: resource.startingOn,
          completedOn: resource.completedOn,
          canStart: !resource.startedOn && resource.startingOn && !resource.isActive,
          history: [],
          milestones: [],
          taskTemplates: [],
          metadata: resource.projectMetaData != null ? resource.projectMetaData : []
        }

        var defer = $q.defer()
        var promises = []

        // notes
        if (resource.$has('note')) {
          resource.$request().$get('note')
            .then(function (data) {
              vm.history = vm.history.concat(data.map(Note))
            })
        }

        // milestones
        if(resource.$has('milestone')){
          promises.push(resource.$request().$get('milestone')
            .then(function(data){
              data.sort(function(a,b){return a.listOrder - b.listOrder})
              vm.milestones.push.apply(vm.milestones, data.map(Milestone))
              vm.milestones.some(function(m){if(!m.isCompleted) {m.isCurrent = true;return true}})
              vm.history = vm.history.concat(vm.milestones.filter(function(m){return m.isCompleted}))
            }))
        }

        // completed tasks
        if(resource.$has('projecttask')){
          promises.push(resource.$request().$get('projecttask')
            .then(function(data){
              var promises = data.map(function(t){return TaskHistoryModel(t)})
              return $q.all(promises).then(function(m){
                vm.history = vm.history.concat(m)
              })
            }))
        }

        // active tasks
        if (resource.$has('activetasks')) {
          promises.push(resource.$request().$get('activetasks')
            .then(function (data) {
              vm.activeTasks = data.map(ActiveTask)
            }))
        }

        // task templates
        if (resource.$has('task')) {
          promises.push(resource.$request().$get('task')
            .then(function (data) {
              vm.taskTemplates = data.map(TaskTemplate)
            }))
        }

        // roles
        if (resource.$has('projectrolemapping')) {
          promises.push(resource.$request().$get('projectrolemapping')
            .then(function (data) {
              vm.roleAssignment = data.map(projectInstanceService.maps.RoleAssignment)
            }))
        }

        dataValueService.getDataValuesByGroup(resource, function (dv) {
          return dv.categoryName
        }, function (dv) {
          return dv.categoryListOrder
        }, function (dv) {
          return dv.categoryType
        }, function (dv) {
          return dv.categoryId
        }).then(function(data){
          vm.attributeGroups = data.groups
          vm.dataValues = data.dataValues
        })

        $q.all(promises)
          .then(function(){
            defer.resolve(vm)
          })

        return defer.promise
      }

      /////////////


      function ActiveTask(resource) {
        var vm = {
          resource: resource,
          name: resource.name,
          dueOn: resource.dueOn,
          state: resource.state,
          isViewed: resource.isViewed,
          relatedUsersHtml: resource.relatedUsers.map(function(m){return "<b>"+m+"</b>"}).join('<br>'),
          id: resource.id
        }

        if (resource.$has('assignedto')) {
          resource.$request().$get('assignedto')
            .then(function (data) {
              vm.assignedTo = User(data)
            })
        }

        return vm
      }

      function Note(resource) {
        var vm = {
          resource: resource,
          id: resource.id,
          title: resource.title,
          body: resource.body,
          date: resource.createdOn,
          userName: resource.createdByFullName,
          displayOrder: resource.displayOrder,
          noteType: resource.noteType,
          type: 'note'
        }

        if(resource.$has('projectrolemapping')){
          resource.$request().$get('projectrolemapping').then(function(data){
            vm.projectRoleMappingsNames = data.map(function(m){return m.name})
          })
        }

        return vm
      }

      function TaskHistoryModel(resource)
      {
          var vm = {
            resource : resource,
            type : 'task',
            taskNotes : [],
            name : resource.name,
            date : resource.completedOn
          }

        var promises = []
        if(resource.$has('note')){
          promises.push(resource.$request().$get('note')
            .then(function(data){
              var taskNotes = data.map(TaskNoteHistoryModel)
              vm.taskNotes = vm.taskNotes.concat(taskNotes)
              vm.lastNote = taskNotes[taskNotes.length-1]
            }))
        }

        return vm
      }

      function User(resource) {
        var vm = {
          resource: resource,
          id: resource.id,
          name: resource.name,
          type: 'user'
        }

        return vm
      }

      function TaskNoteHistoryModel(resource){
        var vm =  {
                resource: resource,
                body: resource.body,
                date: resource.createdOn,
                userName: resource.userName,
                type: 'note'
              }

        if(resource.$has('projectrolemapping')){
          resource.$request().$get('projectrolemapping').then(function(data){
            vm.projectRoleMappingsNames = data.map(function(m){return m.name})
          })
        }

        return vm;
      }

      function Milestone(resource){
        return {
          resource: resource,
          id: resource.id,
          name: resource.name,
          date: resource.date,
          isCompleted: resource.isCompleted,
          listOrder: resource.listOrder,
          type: 'milestone'
        }
      }

      function TaskTemplate(resource){
        return {
          resource: resource,
          id: resource.id,
          name: resource.name,
          createdOn: resource.createdOn,
          projectTaskStatus: resource.projectTaskStatus,
          projectTaskId: resource.projectTaskId,
          projectTaskAssignedTo: resource.projectTaskAssignedTo,
          projectTaskCompletedBy: resource.projectTaskCompletedBy,
          completed: resource.projectTaskStatus === 'Completed',
          overdue: resource.projectTaskStatus === 'Overdue' || resource.projectTaskStatus === 'Escalated',
          active: resource.projectTaskStatus === 'Pending'
        }
      }

      function ProjectBasic(resource){
        return {
          resource: resource,
          id: resource.projectId,
          name: resource.projectInstanceName,
          projectTemplateName: resource.projectTemplateName,
          canEdit: resource.canEdit,
          canEditNotes: resource.canEditNotes,
          concernId: resource.concernId,
          concernName: resource.concernName,
          concernAddress: resource.concernAddress,
          isActive: resource.isActive,
          message: resource.message,
          startingOn: resource.startingOn,
          startedOn: resource.startedOn,
          canStart: !resource.startedOn && resource.startingOn && !resource.isActive
        }
      }

      function remove(resource) {
        return resource.$request().$deleteSelf()
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot delete project instance ' + err
        })
      }

    })
})();

(function () {
  angular.module('gfApp')
    .service('projectInstanceService', projectInstanceService)

  function projectInstanceService($appApi, $log, $q, pagerService, errorHelperService, requestHelperService, gfHelper, dataValueService) {
    var vm = this

    vm.getTemplate = getTemplate
    vm.create = create
    vm.createBulk = createBulk

    vm.initialize = initialize
    vm.pager = null
    vm.Pager = Pager
    vm.getFilters = getFilters

    vm.maps = {
      Project : Project,
      RoleAssignment : RoleAssignment
    }

    /////////

    function Pager(resource){
      return new pagerService.Pager({
        resource: resource || $appApi,
        mapper: ProjectBasic,
        initialRel: 'projects',
        dataRel: 'project',
        pageSize: 0
      })
    }

    function initialize() {
      $log.debug('Service - projectInstanceService - initialize')

      vm.pager = vm.getPager();
    }

    vm.getPager = function(options){
      options = options || {};

      return new pagerService.Pager({
        resource: $appApi,
        initialRel: 'projects',
        dataRel: 'project',
        mapper: Project,
        nextPageRel: 'next',
        pageSize: options.pageSize || 20,
        append: options.append || false
      })
    }

    function getFilters(){
      return $appApi
        .then(function(v){
          return v.$request().$get('project-filters')
        })
        .then(function(data){
          return {
            stores: filterMap(data.searchCriteria,'store'),
            attributes: filterGroupedMap(data.searchCriteria,'attribute'),
            projectTemplates: filterMap(data.searchCriteria, 'template')
          }
        })
    }

    function filterMap(array, prop){
      return gfHelper.groupBy(array.filter(function(m){return m[prop+'Id'] != null && angular.isDefined(m[prop+'Name'])}),prop+'Name', function(m){return {id:m[prop+'Id'], name:m[prop+'Name']}})
        .map(function(m){
          return m.key
        })
    }

    function filterGroupedMap(array, prop){
      var f =gfHelper.groupBy(array.filter(function(m){ return m[prop+'Id'] != null && angular.isDefined(m[prop+'Name'])}), prop+'Name')
      var list = []

      angular.forEach(f, function(mids){
        var a = {id:[],name:mids.key}
        angular.forEach(mids.value, function(ids){
          if(ids[prop+'Id'] !== '' && a.id.indexOf(ids[prop+'Id'])<0){
            a.id.push(ids[prop+'Id'])
          }
        })
        list.push(a);
      })

      return list
    }

    function getTemplate(projectTemplate) {
      return projectTemplate.resource.$request().$get('project-template')
        .then(function (data) {
          return Project(data)
        })
    }

    function create(model) {
      model.validation = {}
      model.validation.roleAssignmentRequired = {}
      var isValid = true;

      if (model.isActive) {
        model.startingOn = null;
      }

      if(!model.isActive && model.startingOn == null) {
        model.validation.startingOnRequired = true
        model.validation.storeRequired = !model.concern
        isValid = false;
      }
      if(!model.concern){
        model.validation.storeRequired = true
        model.validation.startingOnRequired = !model.isActive && angular.isUndefined(model.startingOn)
        isValid = false;
      }

      angular.forEach(model.roleAssignment, function (role) {
        if(!role.userOrGroup || !role.userOrGroup.length){
          model.validation.roleAssignmentRequired[role.name] = true;
          isValid = false;
        }
      });

      if(!isValid){
        return $q(function(r,rej){rej()})
      }

      return model.resource.$request().$postSelf(requestHelperService.normalize(model))
        .then(function (data) {
          return Project(data)
        })
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot create project instance ' + err
        })
    }

    function createBulk(count, projectTemplateId, startDate){
      return $appApi
        .then(function(v){
          return v.$request().$post('project-createbulk', {count: count, projectTemplateId: projectTemplateId, startDate: startDate});
        });
    }

    // ------------------

    function ProjectBasic(resource){
      return {
        resource: resource,
        id: resource.id,
        name: resource.projectInstanceName
      }
    }

    function Project(resource) {
      if(!resource.id){
        return
      }

      var vm = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        concernId: resource.concernId,
        concernName: resource.concernName,
        concernAddress: resource.concernAddress,
        projectTypeName: resource.projectTypeName,
        projectTemplateId: resource.projectTemplateId,
        projectTemplateName: resource.projectTemplateName,
        projectInstanceName: resource.projectInstanceName,
        projectTemplateCode: resource.projectTemplateCode,
        dataValues : [],
        metadata: resource.projectMetaData != null ? resource.projectMetaData : []
      }

      if (resource.$has('projectrolemapping')) {
        resource.$request().$get('projectrolemapping')
          .then(function (data) {
            vm.roleAssignment = data.map(RoleAssignment)
          })
      }

      if (resource.$has('dataValue')) {
        resource.$request().$get('dataValue')
          .then(function (data) {
            vm.dataValues = data.map(dataValueService.createDataValueWrapper)
          });
      }
      return vm
    }


    function RoleAssignment(resource) {
      var vm = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        listOrder: resource.listOrder,
        usersMappedHtml: angular.isDefined(resource.usersMapped) ? resource.usersMapped.map(function(m){return "<b>"+m+"</b>"}).join('<br/>') : undefined,
        pager: ProjectRolePager(resource)
      }

      if (resource.$has('group')) {
        resource.$request().$get('group')
          .then(function (data) {
            vm.groups = data.map(Group)
          })
      }

      if (resource.$has('user')) {
        resource.$request().$get('user')
          .then(function (data) {
            vm.users = data.map(User)
          })
      }

      return vm
    }

    function User(resource) {
      var vm = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        type: 'user'
      }

      return vm
    }

    function Group(resource) {
      var vm = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        type: 'group'
      }

      return vm
    }

    function UserOrGroup(resource){
      return {
        resource : resource,
        id : resource.id,
        name : resource.name,
        type : resource.type
      }
    }

    function ProjectRolePager(resource){
      return new pagerService.Pager({
        resource: resource,
        initialRel: 'projectrole-usersgroups',
        dataRel: 'projectrole-usersgroup',
        mapper: UserOrGroup,
        nextPageRel: 'next',
        pageSize: 10
      })
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('projectDashboardService', projectDashboardService)

  function projectDashboardService($appApi, pagerService) {
    var vm = this

    vm.getProjectDashboard = getProjectDashboard
    vm.initializeProjectInstancePager = initializeProjectInstancePager

    function getProjectDashboard(filters){
      return $appApi
        .then(function (v) {
          return v.$request().$get('projectdashboardapi', filters)
        })
    }

    function Project(resource){
      return {
        resource : resource,
        name : resource.projectInstanceName,
        workflowDataGuid : resource.workflowDataGuid,
        completedMilestones : resource.completedMilestones,
        id : resource.projectInstanceId
      }
    }

    function initializeProjectInstancePager(defaultSearch) {

      vm.projectPager = new pagerService.Pager({
        resource: $appApi,
        initialRel: 'projectdashboardprojectinstanceapi',
        dataRel: 'projectinstances',
        mapper: Project,
        nextPageRel: 'next',
        pageSize: 10,
        defaultSearchCriteria: defaultSearch
      })
    }

  }

})();

(function () {
  angular.module('gfApp')
    .service('presetService', presetService)

  function presetService($appApi, $q) {
    var vm = this

    vm.get = get
    vm.getForResource = getForResource
    vm.create = create
    vm.update = update
    vm.remove = remove

    ////////

    function get(type, params) {
      return $appApi
        .then(function (v) {
          return v.$request().$get('presets', {type: type}, params)
        })
        .then(function (data) {
          return UserPresets(data)
        })
    }

    function getForResource(resource) {
      if(resource.$has('presets')){
        return resource.$request().$get('presets')
          .then(function (data) {
            return UserPresets(data)
          })
      }else{
        return $q(function(r){r(null)})
      }
    }

    function create(resource, preset) {
      return resource.$request()
        .$postSelf(preset)
        .then(function (data) {
          return Preset(data)
        })
    }

    function update(resource, values) {
      return resource.$request().$putSelf({data: values})
        .then(function (data) {
          return Preset(data)
        })
    }


    function remove(resource) {
      return resource.$request().$deleteSelf()
    }

    //////

    function UserPresets(resource) {
      var defer = $q.defer()

      var vm = {
        resource: resource,
        presets: []
      }

      if (resource.$has('preset')) {
        resource.$request().$get('preset')
          .then(function (data) {
            vm.presets = data.map(Preset)
            defer.resolve(vm)
          })
      } else {
        defer.resolve(vm)
      }

      return defer.promise
    }

    function Preset(resource) {
      return {
        resource: resource,
        id: resource.id,
        name: resource.name,
        values: resource.data.map(function (v) {
          return {
            selector: v.selector,
            value: v.value
          }
        })
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('permissionService', permissionService)

  function permissionService($appApi, $state, $log, pagerService, userProfileService, gfSiskinActions, $q) {
    var vm = this

    vm.initialize = initialize
    vm.get = getPermissionActions
    vm.can = can
    vm.canOr = canOr
    vm.canAnd = canAnd
    vm.hasGroups = hasGroups
    vm.getUser = getUser
    vm.update = update
    vm.actionRedirect = actionRedirect

    vm.isInitialised = false
    vm.isInitializing = false
    vm.user = null
    vm.pager = null

    vm.promises = {canDo: []}

    /////////////

    function initialize() {
      if (vm.pager != null) {
        return
      }

      vm.pager = new pagerService.Pager({
        resource: $appApi,
        initialRel: 'permissionactions',
        dataRel: 'permissionactions',
        mapper: PermissionAction,
        nextPageRel: 'next',
        pageSize: 10
      })

      return userProfileService.userLoaded
        .then(function () {
          return getUser(userProfileService.userProfile.id)
        }).then(function (u) {
          vm.isInitialised = true
          vm.isInitializing = false
          vm.user = u;

          angular.forEach(vm.promises.canDo, function (d) {
            return d.defer.resolve(can(d.action))
          })
        })
    }

    function getPermissionActions() {
      return $appApi
        .then(function (v) {
          return v.$request().$get('permissionactions', {}).then(function (data) {
            return data;
          })
        })
        .then(function (permissionActions) {
          if (permissionActions && permissionActions.length > 0) {
            var models = []
            angular.forEach(permissionActions, function (permissionAction) {
              models.push(PermissionAction(permissionAction))
            });

            return models
          }

          return []
        })
    }

    function PermissionAction(resource) {
      var permissionAction = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        groups: []
      }

      if (resource.$hasEmbedded('group')) {
        resource.$request().$get('group').then(function (groups) {
          angular.forEach(groups, function (group) {
            permissionAction.groups.push(Group(group))
          });
        })

      }

      return permissionAction
    }

    function Group(groupResource) {
      return {
        id: groupResource.id,
        name: groupResource.name,
        companyType: groupResource.companyType,
        resource: groupResource
      }
    }

    function getUser(userId) {
      return $appApi
        .then(function (apiVersionResource) {
          return apiVersionResource
            .$request()
            .$get('user', {userId: userId})
        });
    }

    function canOr(actionsStrOrArray){
      if(angular.isUndefined(actionsStrOrArray) || actionsStrOrArray==='' || !actionsStrOrArray.length){
        return $q(function(resolve){resolve(true)})
      }

      var actions = angular.isArray(actionsStrOrArray)? actionsStrOrArray : actionsStrOrArray.split(',')
      var promises = actions.map(can)

      return $q.all(promises)
        .then(function(results){
          return results.some(function(r){return r})
        })
    }

    function canAnd(actionsStrOrArray){
      if(angular.isUndefined(actionsStrOrArray) || actionsStrOrArray==='' || !actionsStrOrArray.length){
        return $q(function(resolve){resolve(true)})
      }

      var actions = angular.isArray(actionsStrOrArray)? actionsStrOrArray : actionsStrOrArray.split(',')
      var promises = actions.map(can)

      return $q.all(promises)
        .then(function(results){
          return results.every(function(r){return r})
        })
    }

    function can(action) {
      if(angular.isUndefined(action)){
        return $q(function(r){r(true)})
      }

      if (!vm.isInitialised) {
        vm.initialize()

        var defer = $q.defer()
        vm.promises.canDo.push({action:action, defer:defer})
        return defer.promise

      } else {
        var constant = gfSiskinActions[action]
        if (angular.isDefined(constant)) {
          action = constant
        }

        return $q(function (resolve) {
          var notFound = true
          var res = vm.user.cans.some(function (can) {
            if (can.key === action) {
              notFound = false
              return can.value
            }
          })
          if(notFound){
            $log.debug('Missing action:' + action)
          }
          resolve(res)
          return res
        })
      }
    }

    function update(permissionAction) {
      return $appApi
        .then(function (v) {
          return v.$request().$put('permissionactions', {}, permissionAction).then(function (data) {
            return PermissionAction(data)
          })
        })
    }

    function actionRedirect(callback){
      canOr($state.current.data.action)
        .then(function (result) {
          if (result) {
            callback()
          } else {
            if($state.current.data.redirectTo){
              $state.go($state.current.data.redirectTo)
            }else{
              $state.go("siskin.dashboard")
            }
          }
        })
    }

    function hasGroups(str){
      var defer = $q.defer()
      var groups = (str || '').split(',').map(function(s){return s.trim()}).filter(function(s){return s !== ""})

      if(groups.length === 0){
        defer.resolve(true)
      }else{
        userProfileService.hasAnyRole(groups)
          .then(function(val){
            defer.resolve(val)
          })
      }

      return defer.promise
    }
  }
})();

(function() {
  angular
    .module("gfApp")
    .service("pagerService", function($q, $log, $timeout, errorHelperService) {
      this.Pager = Pager;
      this.arrayPager = arrayPager;
      this.normalizeFilter = normalizeFilter;
      ////////////


      function normalizeFilter(criteria){
        angular.forEach(criteria, function(value, key) {
            if (angular.isUndefined(value)) {
              criteria[key + "Id"] = undefined;
            }
            if (angular.isObject(value)) {
              if (angular.isDefined(value.id)) {
                criteria[key + "Id"] = value.id;
              } else if (angular.isDefined(value.value)) {
                criteria[key] = value.value;
              } else if (value.format) {
                criteria[key] = value.format();
              }
            }
          });
      }

      /**
       * Pager for fetching and paginating through data
       * @param {Object} Pager options
       * @param {Object} options.resource resource or promise object
       * @param {String} options.initialRel Main relative name
       * @param {String} options.dataRel {string} Relative name containing item collection
       * @param {Function} options.mapper Constructor function for object mapping
       * @param {String} [options.nextPageRel=''] Next page relative name
       * @param {Number} [options.pageSize=30] Page size
       * @constructor
       */
      function Pager(options) {
        var self = this;
        self.mapper = options.mapper;
        self.api = options.resource;
        self.initialRel = options.initialRel;
        self.name = "Pager " + self.initialRel + ": ";
        self.dataRel = options.dataRel;
        self.nextPageRel = options.nextPageRel || "";
        self.pageSize = angular.isDefined(options.pageSize)
          ? options.pageSize
          : 10;
        self.busy = false;
        self.previousPage = null;
        self.canSearchMore = true;
        self.defaultSearchCriteria = options.defaultSearchCriteria || {};
        self.searchCriteria;
        self.items = [];
        self.onItemsFetched = options.onItemsFetched | function() {};
        self.append = angular.isDefined(options.append) ? options.append : true;
        self.searchCount = 0;

        self.reset = reset;
        self.fetchData = fetchData;
        self.nextPage = nextPage;
        self.goPage = goPage;
        self.mapResources = mapResources;
        self.removeSelected = removeSelected;
        self.remove = remove;
        self.existingRel = false;

        $log.debug(self.name + "Instantiated pager:", options);

        if(options.fetchOnInit){
          self.reset()
        }

        function reset(searchCriteria) {
          searchCriteria = angular.copy(searchCriteria);

          self.busy = true;
          self.searchCriteria = angular.extend(
            searchCriteria || {},
            self.defaultSearchCriteria
          );
          self.canSearchMore = true;
          self.pageNumber = 1;
          self.searchCriteria.pageNumber = self.pageNumber;
          self.searchCriteria.pageSize = self.pageSize;
          self.items.length = 0;


          normalizeFilter(self.searchCriteria)

          self.busyReset = true;

          var defer = angular.isDefined(options.resource.then)
            ? options.resource
            : $q(function(resolve) {
                resolve(options.resource);
              });

          return defer
            .then(function(resource) {
              if (resource.$has(self.initialRel)) {
                return resource
                  .$request()
                  .$get(self.initialRel, self.searchCriteria);
              } else {
                throw self.name +
                  "Nonexistent link relative: " +
                  self.initialRel;
              }
            })
            .then(function(pager) {
              self.busyReset = false;
              return self.fetchData(pager, true);
            })
            .catch(function(err) {
              self.busyReset = false;
              var m = errorHelperService.formatError(err);
              throw self.name +
                "Failed to get items " +
                errorHelperService.formatError(m);
            });
        }

        function resolveItems(resources) {
          if (resources.length && angular.isDefined(resources[0].then)) {
            return $q.all(resources);
          }
          return $q(function(r) {
            return r(resources);
          });
        }

        function fetchData(pager, reset) {
          if (angular.isUndefined(pager.$has)) {
            self.busy = false;
            return $q.when([]);
          }

          var defer = $q.defer();

          self.searchCount++;
          self.knownPagesAvailable = pager.knownPagesAvailable;
          self.pageNumber = pager.pageNumber;
          self.pageSize = pager.pageSize;
          self.totalItemsCount = pager.totalItemsCount;

          if (pager.$has(self.dataRel)) {
            $log.debug(self.name + "Search with criteria", self.searchCriteria);
            self.previousPage = pager;

            pager
              .$request()
              .$get(self.dataRel)
              .then(function(data) {
                if (reset) {
                  self.items.length = 0;
                }
                self.busy = false;
                var mappedItems = self.mapResources(data);
                var fireDefer = $q.defer();
                if (self.append) {
                  resolveItems(mappedItems).then(function(items) {
                    self.items = self.items.concat(items);
                    fireDefer.resolve(items);
                  });
                } else {
                  resolveItems(mappedItems).then(function(items) {
                    self.items.length=0;
                    self.items.push.apply(self.items, items);
                    fireDefer.resolve(self.items);
                  });
                }

                // fire event
                fireDefer.promise.then(function(data) {
                  if (angular.isFunction(self.onItemsFetched)) {
                    self.onItemsFetched();
                  }

                  $log.debug(
                    self.name + " Data returned, count: " + mappedItems.length
                  );

                  if (!self.previousPage.$has(self.nextPageRel)) {
                    self.canSearchMore = false;
                    self.noResults = self.items.length === 0;
                  } else {
                    $timeout(function() {
                      angular.element(window).trigger("scroll");
                    });
                  }

                  defer.resolve(data);
                });
              });
          } else {
            $log.debug(
              self.name +
                "No data relative meaning no data or nonexistent relative name"
            );
            self.canSearchMore = false;
            self.noResults = self.items.length === 0;
            self.disabled = true;
            self.busy = false;

            if (!self.append) {
              self.items = [];
            }

            if (angular.isFunction(self.onItemsFetched)) {
              self.onItemsFetched();
            }

            defer.resolve(self.items);
          }

          return defer.promise;
        }

        function goPage(number) {
          if (self.busy) {
            return $q.when([]);
          }
          self.busy = true;
          self.searchCriteria.pageNumber = number;

          var defer = angular.isDefined(options.resource.then)
            ? options.resource
            : $q(function(resolve) {
                resolve(options.resource);
              });

          return defer
            .then(function(resource) {
              if (resource.$has(self.initialRel)) {
                return resource
                  .$request()
                  .$get(self.initialRel, self.searchCriteria);
              } else {
                throw self.name +
                  "Nonexistent link relative: " +
                  self.initialRel;
              }
            })
            .then(function(pager) {
              return self.fetchData(pager, false);
            })
            .catch(function(err) {
              var m = errorHelperService.formatError(err);
              throw self.name +
                "Failed to get items " +
                errorHelperService.formatError(m);
            });
        }

        function nextPage() {
          if (self.busy) {
            return $q.when([]);
          }
          self.busy = true;
          if (self.previousPage == null) {
            $log.debug(self.name + "Doing initial fetch");
            return self.reset();
          }
          if (self.previousPage.$has(self.nextPageRel)) {
            return self.previousPage
              .$request()
              .$get(self.nextPageRel, self.searchCriteria)
              .then(function(nextPager) {
                $log.debug(
                  self.name +
                    "Fetching data: page: " +
                    nextPager.pageNumber +
                    " available pages: " +
                    nextPager.knownPagesAvailable
                );
                return self.fetchData(nextPager);
              });
          } else {
            $log.debug(
              self.name +
                "Max page size reached or nonexistent next page relative name"
            );
            self.disabled = true;
            self.busy = false;
            return $q.when([]);
          }
        }

        function removeSelected() {
          var promises = [];

          angular.forEach(self.items, function(m) {
            if (m.selected) {
              promises.push(self.remove(m));
            }
          });

          return $q.all(promises);
        }

        function remove(item) {
          if (angular.isUndefined(item.resource)) {
            return $q(function() {
              self.items.splice(self.items.indexOf(item), 1);
            });
          } else {
            item.deleteError = false;
            return item.resource
              .$request()
              .$deleteSelf(item)
              .then(function() {
                self.items.splice(self.items.indexOf(item), 1);
              })
              .catch(function(e) {
                item.deleteError = true;
                var m = errorHelperService.formatError(e);
                $log.error(m);
                throw "pagerService - remove() - Failed to remove item " + m;
              });
          }
        }

        function mapResources(data) {
          var mappedItems = [];
          angular.forEach(data, function(resource) {
            mappedItems.push(new self.mapper(resource));
          });
          return mappedItems;
        }

        return self;
      }

      // service implementation
      function arrayPager(options) {
        var items = options.items;
        var currentPage = options.currentPage || 1;
        var pageSize = options.pageSize || 10;
        var totalItems = options.items.length;
        var totalPages = Math.ceil(totalItems / pageSize);

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // slice items array
        items = items.slice(startIndex, endIndex + 1);

        // return object with all pager properties required by the view
        return {
          items: items,
          totalItems: totalItems,
          currentPage: currentPage,
          pageSize: pageSize,
          totalPages: totalPages,
          startIndex: startIndex,
          endIndex: endIndex
        };
      }
    });
})();

(function () {
  angular.module('gfApp')
    .service('noteContainerService', function ($log, $q, $appApi, notificationService) {
      this.update = update
      this.get = get
      this.getNotes = getNotes
      this.remove = remove
      this.create = create

      this.maps = {
        Note : Note
      }

      function get(resource){
        return resource.$request().$getSelf()
          .then(Note)
      }

      function getNotes(resource){
        if (!resource.$has('notecontainer')){
          return $q(function(s){s([])})
        } else {
          return resource.$request().$get('notecontainer')
            .then(function (dataNotes){
              if (dataNotes.$has('note')) {
                return dataNotes.$request().$get('note')
              }else{
                return []
              }
            })
            .then(function(projectNotes){
              return projectNotes.map(Note)
            })
        }
      }

      function create(note,project){
        return project.resource.$request().$post('notecontainer', {}, note)
          .then(Note)
          .catch(function (err) {
            return err
          })
      }

      function update(resource,data) {
        return resource.$request()
          .$putSelf(data)
          .then(Note)
          .catch(function (e) {
            $log.error(e)
            notificationService.error('notecontainer.errorupdate')
          })
      }

      function remove(resource) {
        return resource.$request().$deleteSelf()
      }

      function Note(resource){
        var note = {
          resource: resource,
          id: resource.id,
          title: resource.title,
          body: resource.body,
          isFileNote: resource.isFileNote,
          displayOrder: resource.displayOrder,
          fileCollectionId: resource.fileCollectionId,
          fileList:[]
        }

        if(note.resource.$has('file')){

          note.resource.$request().$get('file').then(function(files){
            angular.forEach(files,function(file){
              note.fileList.push(File(file))
            })
          })

        }
        return note
      }

      function File(resource){
        return{
          resource:resource,
          id:resource.id,
          displayName: resource.displayName,
          uploadedBy: resource.uploadedBy,
          uploadedOn: resource.uploadedOn,
          type: resource.type,
          url: resource.url
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('navigateTo', function ($state) {
      this.taskInboxWithQuery = taskInboxWithQuery

      ///////

      function taskInboxWithQuery(query){
        $state.go('siskin.inbox', {query: query})
      }
    })
})();
(function () {
  angular.module('gfApp')
    .service('modalService', function ($uibModalStack, $uibModal, permissionService) {
      var vm = this

      vm.open = open
      vm.close = close
      vm.dismissAll = dismissAll

      function open(modalOptions) {

        permissionService.can(modalOptions.permissionAction)
          .then(function(val){
            if(val){
              if(angular.isUndefined(modalOptions.controllerAs)){
                modalOptions.controllerAs = 'vmModal'
              }

              var defaultOptions = {
                animation: 'fadeIn',
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                controllerAs: modalOptions.controllerAs,
                scope: false,
                controller: controller(modalOptions.controllerInit)
              }

              $uibModal.open(angular.extend({},modalOptions, defaultOptions))
                .closed.then(function(){
                  if(vm.current && vm.current.onClosed){
                    vm.current.onClosed();
                  }
                })
            }
          })
      }

      function dismissAll() {
        $uibModalStack.dismissAll()
      }

      function controller(initFn) {
        return ['$uibModalInstance', function ($uibModalInstance) {
          var vmThis = this

          if(angular.isDefined(initFn)){
            initFn(vmThis)
          }

          vmThis.close = function () {
            $uibModalInstance.dismiss('cancel')
          }

          vm.current = vmThis
        }]
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('metaDataEntityService', service)

  function service($appApi, $log, errorHelperService, pagerService) {
    var vm = this

    vm.pager = pager
    vm.create = create
    vm.update = update
    vm.remove = remove

    ////////

    function pager(type,append){
      $log.debug('Service - metaDataEntityService - pager')

      return new pagerService.Pager({
        resource: $appApi,
        initialRel: 'metadataentities',
        dataRel: 'metadataentity',
        mapper: MetaDataEntity,
        nextPageRel: 'next',
        pageSize: 10,
        defaultSearchCriteria: {
          type: type
        },
        append:append
      })
    }

    function create(model) {
      return $appApi
        .then(function (v) {
          if(angular.isUndefined(model.name)) {
            throw '- Name field is required'
          }

          return v.$request().$post('metadataentity', {type: model.type}, model)
        })
        .then(MetaDataEntity)
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot create the entity ' + err
        })
    }

    function update(resource) {
      return resource.resource.$request().$putSelf(resource).then(MetaDataEntity)
    }

    function remove(resource) {
      return resource.resource.$request().$deleteSelf()
    }

    function MetaDataEntity(resource){
      return {
        resource : resource,
        id : resource.id,
        name : resource.name,
        type: resource.type
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('licensingService', service)

  function service($appApi, notificationService, permissionService, gfSiskinActions) {
    var vm = this

    vm.license = null
    vm.init = init

    ////////

    function init() {
      return $appApi
        .then(function (v) {
          return v.$request().$get('license')
        })
        .then(function(data){
          var license = data.data;
          vm.license = license


          permissionService.can(gfSiskinActions.licensesView).then(function (value) {
            if(value){
              var notificationOptions = {timeOut: 0, extendedTimeOut: 0, tapToDismiss: false};

              if (license.isExpiredInGracePartialBlock) {
                notificationService.error('licensing.info.isexpiredingracepartialblock', notificationOptions);
              } else if (license.isExpiredInGrace) {
                notificationService.error('licensing.info.isexpiredingrace', notificationOptions);
              } else if (license.isExpiringUrgent) {
                notificationService.error('licensing.info.isexpiringurgent', notificationOptions);
              } else if (license.isExpiring) {
                notificationService.warning('licensing.info.isexpiring', notificationOptions);
              } 
            }
          });
          

          return data.data
        })
      }
    }
  }
)();

(function () {
  angular.module('gfApp')
    .service('integrationService',integrationService)

  function integrationService($integrationApi, $window, $document) {
    var vm = this
    vm.getAll = getAll;
    vm.downloadPayload = downloadPayload;
    vm.retryTask = retryTask;

    function getAll(requestInputTerm){
      return $integrationApi.then(function(api){
        return api.get("request", {params: requestInputTerm});
      })
    }

    function retryTask(taskAlternateKeyId){
      return $integrationApi.then(function(api){
        return api.put("task/"+taskAlternateKeyId+"/retry");
      })
    }

    function downloadPayload(payload){
      return $integrationApi.then(function(api){
        return api.get("payload/"+payload.blobReference, {responseType:'arraybuffer'})
          .then(function (response) {
              var file = new Blob([response], {type: payload.mimeType});

              var isChrome = !!$window.chrome;
              var isIE = /*@cc_on!@*/false || !!$document.documentMode;
              var isEdge = !isIE && !!$window.StyleMedia;


              if (isChrome){
                  var url = $window.URL || $window.webkitURL;

                  var downloadLink = angular.element('<a></a>');
                  downloadLink.attr('href',url.createObjectURL(file));
                  downloadLink.attr('target','_self');
                  downloadLink.attr('download', payload.blobReference);
                  downloadLink[0].click();
              }
              else if(isEdge || isIE){
                  $window.navigator.msSaveOrOpenBlob(file, payload.blobReference);

              }
              else {
                  var fileURL = URL.createObjectURL(file);
                  $window.open(fileURL);
              }
        })
      })       
    }
  }
})();

(function () {
    angular.module('gfApp')
    .service('imageControlService', service)

    function service() {
      var vm = this

      vm.updateImageSrc = updateImageSrc
      vm.refreshImageUrl = refreshImageUrl

      ////////////

      function updateImageSrc(element){
          if(element){
            var newUrl = refreshImageUrl(element.src);
            element.src = newUrl;
          }
        }
    
      function refreshImageUrl(url){
        var decachString = "t=";
        
        if(url.includes(decachString)){
          url = url.substring( 0, url.indexOf(decachString));
        }
        decachString += new Date().getTime();
        url = addParameterToURL(url, decachString)
        return url;
      }

      function addParameterToURL(url, param){
        url += (url.split('?')[1] ? '&':'?') + param;
        return url;
      }
    }
})();
(function () {
  angular.module('gfApp')
    .service('guidFactory', function () {
      return function () {
        function s4() {
          // WARNING: The 'GUID's generated in javascript cannot be considered globally unique. They are
          // random-ish, but never use these for anything you greatly care about
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
          s4() + '-' + s4() + s4() + s4();
      }
    });
})();

(function () {
  angular.module('gfApp')
    .service('groupStoreService', groupStoreService)

  function groupStoreService($appApi, $log, pagerService) {
    var vm = this
    vm.initialize = initialize
    vm.pager = null
    vm.get = get

    vm.isInitialised = false
    vm.update = update

    function initialize(){
      vm.pager = new pagerService.Pager({
        resource: $appApi,
        initialRel: 'groupstores',
        dataRel: 'groupstores',
        mapper: GroupStore,
        nextPageRel: 'next',
        pageSize: 0
      })
    }

    function get(){
      return $appApi
        .then(function (v) {
          return v.$request().$get('groupstores', {}).then(function(data){
            return data;
          })
        })
        .then(function(groupStores){
          if(groupStores && groupStores.length > 0){
            var models = []
            angular.forEach(groupStores, function(groupStore){
              models.push(GroupStore(groupStore))
            });

            return models
          }

          return []
        })
    }

    function GroupStore(resource){
      var groupStore = {
        resource : resource,
        id : resource.id,
        groupName : resource.groupName,
        stores : []
      }

      if(resource.$hasEmbedded('store')){
          resource.$request().$get('store').then(function(stores){
            angular.forEach(stores, function(store){
            groupStore.stores.push(Store(store))
          });
        })

      }

      return groupStore
    }

    function Store(storeResource){
      return {
        id : storeResource.id,
        name : storeResource.name,
        resource : storeResource
      }
    }

    function update(groupStore){
      return $appApi
        .then(function (v) {
          return v.$request().$put('groupstores', {}, groupStore ).then(function(data){
            return GroupStore(data)
          })
        })
    }

  }
})();

(function () {
  angular.module('gfApp')
    .service('groupService', groupService)

  function groupService($appApi, $log, pagerService) {
    var vm = this

    vm.pager = null

    vm.initialize = initialize
    vm.Pager = Pager

    ////////

    function initialize(){

      vm.pager = this.Pager()
    }

    function Pager(){
      return new pagerService.Pager({
        resource: $appApi,
        mapper: Group,
        initialRel: 'groups',
        dataRel: 'group',
        nextPageRel: 'next',
        pageSize: 0
      })
    }

    ////////

    function Group(resource){
      return {
        resource : resource,
        id : resource.id,
        name : resource.name,
        companyType : resource.companyType
      }
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('gfTools', service)

  function service() {
    var vm = this

    vm.groupBy = groupBy

    ///////


    function groupBy(array, id){
      if(angular.isUndefined(array)){
        throw 'array parameter is required'
      }

      if(!angular.isArray(array)){
        throw 'the passed param is not an array'
      }

      var groups = []

      angular.forEach(array,function(m){
        var keyVal = m[id]
        var g = groups.filter(function(m){return m.key === keyVal}).shift()

        if(angular.isUndefined(g)){
          groups.push({key: keyVal, value: [m]})
        }else{
          g.value.push(m)
        }
      })

      return groups
    }
  }
})();

(function(){
  angular.module('gfApp')
    .service('filterHelperService',filterHelperService )

  function filterHelperService($q, storeService, clientService, projectTemplateService){
    var vm = this

    vm.populateFilter = populateFilter

    ////////

    function populateFilter(filter){
      var defer = $q.defer()
      var promises = [];

      if(angular.isDefined(filter.storeId)){
        promises.push(storeService.get(filter.storeId).then(function(data){filter.store = data}))
      }

      if(angular.isDefined(filter.clientId)){
        promises.push(clientService.get(filter.clientId).then(function(data){filter.client = data}))
      }

      if(angular.isDefined(filter.templateId)){
        promises.push(projectTemplateService.get(filter.templateId).then(function(data){filter.template = data}))
      }

      if(angular.isDefined(filter.projectTemplateId)){
        promises.push(projectTemplateService.get(filter.projectTemplateId).then(function(data){filter.projectTemplate = data}))
      }


      $q.all(promises)
        .then(function(){
          defer.resolve(filter)
        })

      return defer.promise
    }
  }
})();

(function () {
  angular.module('gfApp')
    .service('fileTypeService', function () {
      var me = this;
      me.getTypeByFileExtension = getTypeByFileExtension
      me.getFallbackSrcByFileExtension = getFallbackSrcByFileExtension
      me.isImage = isImage

      var extensions = {
        'xls': 'excel',
        'xlsx': 'excel',

        'doc': 'document',
        'docx': 'document',

        'gif': 'image',
        'jpeg': 'image',
        'jpg': 'image',
        'png': 'image',
        'tiff': 'image',
        'tif': 'image',
        'bmp': 'image',

        'pdf': 'pdf',
        'txt': 'text',

        'mpg': 'video',
        'wmv': 'video',
        'avi': 'video',
        'mp4': 'video',

        'rar': 'compressed',
        '7z': 'compressed',
        'zip': 'compressed'
      }

      function getFallbackSrcByFileExtension(extension) {
        return getPlaceholder(getTypeByFileExtension(extension))
      }


      function getPlaceholder(type) {
        var loc = "../assets/images/placeholders/"
        switch (type) {
          case 'excel':
            return loc + "excel.jpg"
          case 'document':
            return loc + "document.jpg"
          case 'file':
            return loc + "file.jpg"
          case 'image':
            return loc + "image.jpg"
          case 'pdf':
            return loc + "pdf.jpg"
          case 'text':
            return loc + "text.jpg"
          case 'video':
            return loc + "video.jpg"
          case 'compressed':
            return loc + "compressed.jpg"
        }
      }


      function getTypeByFileExtension(extension) {
        var extensionStr = extension.startsWith('.') ? extension.slice(1) : extension;

        if (extensions.hasOwnProperty(extensionStr.toLowerCase())) {
          return extensions[extensionStr.toLowerCase()];
        }
        return 'file';
      }

      function isImage(extension) {
        return getTypeByFileExtension(extension) === 'image';
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('fileEndpointService', fileEndpointService)

  // this service is required for these endpoints returning a file, where simple 'url' get cannot be done (due the authentication process)
  function fileEndpointService($q, $appApi, $window, $http, $log, $httpParamSerializer, $document, errorHelperService, requestHelperService, notificationService) {
    var vm = this

    vm.download = download
    vm.downloadFromResource = downloadFromResource
    vm.downloadPost = downloadPost
    vm.downloadFromUrl = downloadFromUrl
    vm.downloadFromUrlRedirect = downloadFromUrlRedirect
    vm.upload = upload

    //////

    /// if resource is provided, it will get the URL from the resource, if not, it will get the url from the version resource
    /// if filter is provided, it will append to that URL the parameters
    function download(rel, resource, filter, method) {
      $log.debug('Service - fileEndpointService - download (GET)')

      var params = ''

      if (angular.isDefined(filter)) {
        params += '?' + $httpParamSerializer(requestHelperService.normalize(filter, true))
      }

      var defer = $q.defer()

      if (angular.isDefined(resource)) {
        defer.resolve(resource.resource || resource)
      } else {
        $appApi
          .then(function (v) {
            defer.resolve(v)
          })
      }

      var downloadDefer = $q.defer()

      defer.promise.then(function (resource) {
        return $http({
            method: method || 'GET',
            url: resource.$href(rel) + params,
            responseType: 'arraybuffer',
            transformRequest: angular.identity
          }).then(function(d){save(d); downloadDefer.resolve()})
          .catch(function (err) {
            var m = errorHelperService.formatError(err)
            $log.error(m)
            downloadDefer.reject(err);
            throw "Service - fileEndpointService - download (GET) failure " + m
          })
      })

      return downloadDefer.promise
    }

    function downloadPost(resource, data, rel) {
      $log.debug('Service - fileEndpointService - download (POST)')

      rel = rel || 'report'

      var defer = $q.defer()
      if (angular.isDefined(resource)) {
        defer.resolve(resource.resource)
      } else {
        $appApi
          .then(function (v) {
            defer.resolve(v)
          })
      }

      defer.promise.then(function (resource) {
        return $http({
            method: 'POST',
            url: resource.$href(rel),
            responseType: 'arraybuffer',
            transformRequest: angular.identity,
            data: angular.toJson(data)
          }).then(save)
          .catch(function (err) {
            var m = errorHelperService.formatError(err)
            $log.error(m)
            throw "Service - fileEndpointService - download (POST) failure " + m
          })
      })

      return defer.promise
    }

    function save(data) {
      var fileName = data.headers('FileName')
      var fileType = data.headers('Content-Type')

      var file = new Blob([data.data], {
        type: fileType
      });
      var isIE = !!$document.documentMode;
      var isEdge = !isIE && !!$window.StyleMedia;


      if (isEdge || isIE) {
        $window.navigator.msSaveOrOpenBlob(file, fileName);
      } else {
        downloadFromUrl(($window.URL || $window.webkitURL).createObjectURL(file), fileName)
      }
      return $q.all([])
    }

    function upload(rel, resource, file) {
      var defer = $q.defer()

      if (angular.isDefined(resource)) {
        defer.resolve(resource.resource)
      } else {
        $appApi
          .then(function (v) {
            defer.resolve(v)
          })
      }

      return defer.promise.then(function (resource) {
        var fd = new FormData();
        fd.append('file', file);

        return $http({
          url: resource.$href(rel),
          method: 'POST',
          data: fd,
          headers: {
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        });
      })
    }

    function downloadFromResource(resource) {
      return resource.$request().$get('files')
      .then(function (data) {
        if(data.data.downloadUrl){
          $window.open(data.data.downloadUrl);
        }else{
          notificationService.info('notification.info.filetoobig');
        }
      }).catch(function () {
        notificationService.error('project.instance.unexpectederror');
       });
    }

    //////

    function downloadFromUrl(url, fileName) {
      return $http({
        method: 'GET',
        url: url,
        transformRequest: angular.identity,
        responseType: 'arraybuffer'
      }).success(function (data, status, headers) {
        headers = headers();

        var filename = headers['filename'] || fileName;

        var contentType = headers['content-type'];

        var downloadLink = angular.element('<a></a>');
        try {
          var blob = new Blob([data], {
            type: contentType
          });
          var url = $window.URL.createObjectURL(blob);

          downloadLink.attr('href', url);
          downloadLink.attr('target', '_self');
          downloadLink.attr('download', filename);

          downloadLink[0].click();
        } catch (ex) {
          $log.error(ex);
        }
      }).error(function (data) {
        $log.error(data);
      });
    }

    function downloadFromUrlRedirect(url) {
      return $http({method: 'GET', url: url, transformRequest: angular.identity}).success(function(url){
        $window.open(url)
      }).error(function (data) {
        $log.error(data);
      });
    }

    return vm
  }
})();

(function () {
  angular.module('gfApp')
    .service('fileContainerService', service)

  function service($appApi, fileService, imageControlService) {
    var vm = this

    vm.getAll = getAll
    vm.create = create
    vm.update = update
    vm.remove = remove

    vm.maps = {
      FileContainer: FileContainer
    }

    ////////

    function getAll() {
      return $appApi
        .then(function (v) {
          return v.$request().$get('filecontainers')
        })
        .then(function (data) {
          if(data.$has('filecontainer')){
            return data.$request().$get('filecontainer')
          }else{
            return []
          }
        })
        .then(function (data) {
          return data.map(FileContainer)
        })
    }

    function create(m) {
      return $appApi
        .then(function (v) {
          return v.$request().$post('filecontainer', null, m)
        })
        .then(function (data) {
          return FileContainer(data)
        })
    }

    function update(m) {
      return m.resource.$request().$putSelf(m)
        .then(FileContainer)
    }

    function remove(m){
      return m.resource.$request().$deleteSelf()
    }

    ////////////

    function File(resource) {
      var vm = angular.extend({}, resource)

      vm.resource = resource

      return vm
    }

    function FileContainer(resource) {
      var vm = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        description: resource.description,
        files: []
      }

      // -- files
      if (resource.$hasEmbedded('file')) {
        resource.$request().$get('file').then(function (files) {
          angular.forEach(files, function (file) {
            vm.files.push(new File(file))
          })
        })
      }

      angular.extend(vm, {
        addOrUpdateFile: function (data) {
          if (angular.isDefined(data.fileResource)) {
            for (var i = 0; i < vm.files.length; i++) {
              var file = data.fileResource
              if (vm.files[i].id === file.id) {
                vm.files.splice(i, 1)
                vm.files.splice(i, 0, file)
                vm.totalFilesUploaded++
                break
              }
            }
          } else {
            vm.files.splice(0, 0, data);
          }
        },
        init: function () {
          vm.wasEmpty = vm.files.length === 0;
          vm.totalFilesUploaded = 0;
          vm.totalFilesDeleted = 0;
          vm.totalFilesRotated = 0;
          vm.maxFilesReached = false;
        },
        startProcess: function () {
          vm.isBusy = true
        },
        endProcess: function () {
          vm.isBusy = false
        },
        anyFileSelected: function () {
          return vm.files.some(function (m) {
            return m.selected
          })
        },
        allSelectedAreImages:function(){
          return vm.files.every(function (m) {
            return !m.selected || m.isImage
          })
        },
        removeSelected: function () {
          vm.removeFiles(vm.files.filter(function (f) {
            return f.selected
          }), true)
        },
        removeFiles: function (files, firstDelete) {
          if (files.length !== 0) {
            var file = files.pop()
            vm.startProcess()
            fileService.remove(file)
              .then(function () {
                if (firstDelete) vm.init()
                if (angular.isDefined(file.deselect)) file.deselect()
                vm.files.splice(vm.files.indexOf(file), 1)
                vm.totalFilesDeleted++;

                if (files.length !== 0) {
                  vm.removeFiles(files, false)
                } else {
                  vm.endProcess()
                }
              })
          } else {
            vm.endProcess()
          }
        },
        rotateSelectedImages:function(){
          vm.rotateImages(vm.files.filter(function (f) {
            return f.selected && f.isImage
          },true))
        },
        rotateImages: function(files, firstRotate){
           if (files.length !== 0){
            var file = files.pop()
            fileService.rotate(file)
            .then(function(){
              if (firstRotate) vm.init()
              if (angular.isDefined(file.deselect)) file.deselect()
              vm.totalFilesRotated++
              
              vm.rotateImageById("thumbnail-"+file.id)
              if (files.length !== 0) {
                vm.rotateImages(files, false)
              }
            })
          }
        },
        rotateImageById: function(id){
          var image = angular.element('#'+id);

          imageControlService.updateImageSrc(image[0])
        }
      })

      return vm
    }
  }

})();

(function () {
  angular.module('gfApp')
    .service('fileCollectionService', service)

  function service($q, fileService) {
    var vm = this

    vm.remove = remove
    vm.getFileCollection = getFileCollection

    ////////

    function remove(m){
      return m.resource.$request().$deleteSelf()
    }

    function getFileCollection(m){
      return m.resource.$request().$post('filecollection')
        .then(function (data) {
          return FileCollection(data)
        })
    }

    ////////

    function FileCollection(resource) {
      var vm = {
        resource: resource,
        id: resource.id,
        files: []
      }

      // -- files
      if (resource.$hasEmbedded('file')) {
        resource.$request().$get('file').then(function (files) {
          angular.forEach(files, function (file) {
            vm.files.push(new File(file))
          })
        })
      }

      angular.extend(vm, {
        addOrUpdateFile: function (data) {
          if (angular.isDefined(data.fileResource)) {
            for (var i = 0; i < vm.files.length; i++) {
              var file = data.fileResource
              if (vm.files[i].id === file.id) {
                vm.files.splice(i, 1)
                vm.files.splice(i, 0, file)
                vm.totalFilesUploaded++
                break
              }
            }
          } else {
            vm.files.splice(0, 0, data);
          }
        },
        init: function () {
          vm.wasEmpty = vm.files.length === 0;
          vm.totalFilesUploaded = 0;
          vm.totalFilesDeleted = 0;
          vm.maxFilesReached = false;
        },
        startProcess: function () {
          vm.isBusy = true
        },
        endProcess: function () {
          vm.isBusy = false
        },
        anyFileSelected: function () {
          return vm.files.some(function (m) {
            return m.selected
          })
        },
        removeSelected: function () {
          vm.removeFiles(vm.files.filter(function (f) {
            return f.selected
          }), true)
        },
        removeFiles: function (files, firstDelete) {
          if (files.length !== 0) {
            var file = files.pop()
            vm.startProcess()
            fileService.remove(file)
              .then(function () {
                if (firstDelete) vm.init()
                if (angular.isDefined(file.deselect)) file.deselect()
                vm.files.splice(vm.files.indexOf(file), 1)
                vm.totalFilesDeleted++;

                if (files.length !== 0) {
                  vm.removeFiles(files, false)
                } else {
                  vm.endProcess()
                }
              })
          } else {
            vm.endProcess()
          }
        }
      })

      return vm
    }
  }

})();

(function () {
  angular.module('gfApp')
    .service('fileService', function ($log, $appApi, errorHelperService ) {

      var vm = this

      vm.get = get
      vm.remove = remove
      vm.update = update
      vm.rotate = rotate

      //////////

      function get(fileId) {

       return $appApi.then(function(v){
          return v.$request().$get('file', {fileId: fileId});
        });
      }

      function remove(file) {
        $log.debug('removing file (' + file.id + ')')

        var resource = file.resource || file

        return resource
          .$request()
          .$delete('self')
          .catch(function(e){
            throw 'cannot delete file: ' + errorHelperService.formatError(e);
          })
      }

      function update(file) {
        $log.debug('updating file (' + file.id + ')')

        var resource = file.resource || file

        return resource.$request().$putSelf(file)
          .catch(function(e){
            throw 'cannot update file: ' + errorHelperService.formatError(e);
          })
      }

      function rotate(file){
        var resource = file.resource || file

        $log.debug('rotating  file (' + file.id + ')')
        return resource.$request().$put('rotate')
      }
    })
})();

(function(){
  angular.module('gfApp')
    .service('errorHelperService', function($log, $translate){
      var me = this;

      me.formatError = formatError
      me.formatHttpError = formatHttpError
      me.isApiUnavailable = isApiUnavailable

      /////

      function formatError(err){
        if(angular.isDefined(err)  && err !== null && angular.isDefined(err.data) && err.data !== null){
          if(angular.isDefined(err.data.stackTrace)) {
            $log.debug(err.data.stackTrace)
          }

          return err.message;
        } else {
          return err
        }
      }

      function formatHttpError(httpErrors, statusCode){
        if(httpErrors.hasOwnProperty(statusCode)){
          return $translate(httpErrors[statusCode])
        }

        return $translate(httpErrors['default'])
      }

      function isApiUnavailable(e){
        return angular.isDefined(e) && e !== null && e.err === 'apiunavailable';
      }
    })
})();

(function () {
  angular.module('gfApp')
    .service('emailTemplateService', emailTemplateService)

  function emailTemplateService($appApi, $log, $q, gfTools, gfSiskinActions, errorHelperService, gfTranslationMapService, permissionService) {
    var vm = this

    var languages = gfTranslationMapService.getLanguages()

    vm.get = get
    vm.getProjectTemplates = getProjectTemplates
    vm.getTaskTemplates = getTaskTemplates
    vm.save = save
    vm.rename = rename
    vm.remove = remove
    vm.getPreview = getPreview
    vm.send = send
    vm.removeEmailTemplateType = removeEmailTemplateType

    ////////

    function get() {
      $log.debug('Service - emailTemplateService - get email containers')

      return $appApi
        .then(function (v) {
          return v.$request().$get('emailtemplatecontainer')
        })
        .then(function (data) {
          return Containers(data)
        })
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot get email containers ' + err
        })
    }

    function getProjectTemplates(resource) {
      $log.debug('Service - emailTemplateService - get email container templates')

      if(resource!=null){
      return resource.resource.$request().$getSelf()
        .then(function (data) {
          return Container(data)
        })
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot get email container templates ' + err
        })
      }
    }

    function getTaskTemplates(resource) {
      return permissionService.can(gfSiskinActions.adminTaskEmailTemplateEdit).then(function (can) {

        if (can) {
          if (resource.resource.$has('emailtemplate-tasks')) {
            $log.debug('Service - emailTemplateService - get email task container templates')
            return resource.resource.$request().$get('emailtemplate-tasks', {parentId: resource.id})
              .then(function (data) {
                return Containers(data)
              })
              .catch(function (e) {
                var err = errorHelperService.formatError(e)
                $log.error(err)
                throw 'Cannot get email task container templates ' + err
              })
          } else {
            return $q.resolve([])
          }
        } else {
          return $q.resolve([])
        }

      })
    }

    function save(emailTemplate) {
      $log.debug('Service - emailTemplateService - save or update language');

      var promise
      if (emailTemplate.id) {
        promise = emailTemplate.resource.$request().$putSelf(emailTemplate)
      } else {
        promise = emailTemplate.resource.$request().$postSelf(emailTemplate)
      }

      return promise.then(function (data) {
        return EmailTemplate(data)
      })
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot save or update language ' + err
        })
    }

    function rename(emailTemplateType){
      var promises = []

      angular.forEach(emailTemplateType.emailTemplates.filter(function(t){return t.id!=0}), function(t){
        t.name = emailTemplateType.name
        promises.push(t.resource.$request().$putSelf(t))
      })
      
      return $q.all(promises)
    }

    function removeEmailTemplateType(emailTemplateType){
      var promises = []
      angular.forEach(emailTemplateType.emailTemplates.filter(function(t){return t.id!=0}), function(t){
        promises.push(t.resource.$request().$deleteSelf(t))
      })
      
      return $q.all(promises)
    }

    function remove(emailTemplate) {
      $log.debug('Service - emailTemplateService - delete language')

      return emailTemplate.resource.$request().$deleteSelf()
        .then(function (data) {
          return EmailTemplate(data)
        })
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot delete language ' + err
        })
    }

    function getPreview(emailTemplate) {
      $log.debug('Service - emailTemplateService - get preview for language')

      return emailTemplate.resource.$request().$post('emailtemplate-preview', {}, emailTemplate)
        .then(function (data) {
          return EmailTemplate(data)
        })
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot get language preview ' + err
        })
    }

    function send(email, emailTemplate) {
      $log.debug('Service - emailTemplateService - send language')

      var prev = emailTemplate.sendEmail
      emailTemplate.sendEmail = email

      return emailTemplate.resource.$request().$post('emailtemplate-sendtest', {}, emailTemplate)
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot send test email ' + err
        })
        .finally(function(){
          emailTemplate.sendEmail = prev
        })
    }

    //////

    function Containers(resource) {
      var defer = $q.defer()

      var vm = {
        resource: resource,
        projectTemplates: [],
        taskTemplates: []
      }

      resource.$request().$get('emailtemplatecontainer')
        .then(function (data) {
          var promises = data.map(Container)

          $q.all(promises)
            .then(function (data) {
              angular.forEach(data, function (c) {
                if (c.emailTemplateContainerType === 'Global') {
                  vm.global = c
                  c.name = "Global"
                  vm.projectTemplates.push(c)
                } else if (c.emailTemplateContainerType === 'ProjectTemplate') {
                  vm.projectTemplates.push(c)
                }else if (c.emailTemplateContainerType === 'TaskTemplate') {
                  vm.taskTemplates.push(c)
                }
              })
            })


          defer.resolve(vm)
        })


      return defer.promise
    }

    function Container(resource) {
      var defer = $q.defer()
      var vm = {
        resource: resource,
        id: resource.id,
        name: resource.name,
        emailTemplateContainerType: resource.emailTemplateContainerType
      }

      var promises = []
      if (resource.$has('emailtemplatecontainer-setting')) {
        promises.push(resource.$request().$get('emailtemplatecontainer-setting')
          .then(function (data) {
            vm.settings = data.map(EmailContainerSetting)
          }))
      }

      if (resource.$has('emailtemplate-bytype')) {
        promises.push(resource.$request().$get('emailtemplate-bytype')
          .then(function (data) {
            $q.all(data.map(EmailTemplateType))
              .then(function (data) {
                vm.emailTemplateTypes = data
              })
          }))
      }

      $q.all(promises).then(function () {
        defer.resolve(vm)
      })

      return defer.promise
    }

    function EmailTemplateType(resource) {
      var defer = $q.defer()
      var vm = {
        resource: resource,
        type: resource.type.toLowerCase(),
        isLayout: resource.isLayout,
        name: resource.name,
        tools : resource.tools,
        refresh: function(){
          var $this = this
          $this.emailTemplatesByLanguage = gfTools.groupBy($this.emailTemplates, 'languageIcon')
          $this.emailTemplatesCount = $this.emailTemplates.filter(function (m) {return m.id !== 0}).length
        }
      }

      if (resource.$has('emailtemplate')) {
        resource.$request().$get('emailtemplate')
          .then(function (data) {
            vm.emailTemplates = data.map(EmailTemplate)
            vm.refresh()
            defer.resolve(vm)
          })
      } else {
        defer.resolve(vm)
      }

      return defer.promise
    }

    function EmailContainerSetting(resource) {
      return {
        resource: resource,
        emailTemplateType: resource.emailTemplateType,
        name: resource.name,
        interval: resource.interval,
        lastSent: resource.lastSent,
        isGlobal: resource.isGlobal
      }
    }

    function EmailTemplate(resource) {
      var lg = languages[resource.language]

      return {
        resource: resource,
        id: resource.id,
        channel: resource.channel.toLowerCase(),
        language: resource.language,
        languageIcon: angular.isUndefined(lg) ? undefined : lg.icon,
        subject: resource.subject,
        header: resource.header,
        body: resource.body,
        type: resource.type,
        name: resource.name,
        isDefault: resource.isDefault,
        isGlobal: resource.isGlobal,
        isLayout: resource.isLayout,
        isInteractiveEmail: resource.isInteractiveEmail,
        preview: resource.preview
      }
    }


  }
})();

(function () {
  angular.module('gfApp')
    .service('emailDigestSettingsService', emailDigestSettingsService)

  function emailDigestSettingsService($appApi, $log, $q, errorHelperService, notificationService) {
    var vm = this

    vm.get = get
    vm.updateUserSetting = updateUserSetting
    vm.updateGeneralSetting = updateGeneralSetting
    vm.initalizeProjectEmailTemplates = initalizeProjectEmailTemplates

    ////////

    function get(id) {

      return $appApi
        .then(function (v) {
          return v.$request().$get('emailsettings', {projectTemplateId: id})
        }).then(EmailSettings)
        .catch(function (e) {
          var err = errorHelperService.formatError(e)
          $log.error(err)
          throw 'Cannot get email containers ' + err
        })
    }

    function updateUserSetting(setting) {
      if (setting.id > 0) {
        return setting.resource.$request()
          .$putSelf(setting)
          .then(EmailUserSetting)
          .catch(function (e) {
            $log.error(e)
            notificationService.error('emailsettings.user.errorupdate')
          })
      } else {
        return $appApi.then(function (version){
          return version.$request().$post('emailusersetting', {projectTemplateId: setting.projectTemplateId}, setting)
            .then(EmailUserSetting)
            .catch(function (e) {
              $log.error(e)
              notificationService.error('emailsettings.user.errorupdate')
            })
        })
      }
    }

    function updateGeneralSetting(setting){
      return setting.resource.$request()
        .$putSelf(setting)
        .then(EmailGeneralSetting)
        .catch(function (e) {
          $log.error(e)
          notificationService.error('emailsettings.general.errorupdate')
        })
    }

    function initalizeProjectEmailTemplates(projectTemplateId){
      return $appApi.then(function(version){
        return version.$request().$post('emailsettings', {projectTemplateId:projectTemplateId})
        .catch(function (e) {
          $log.error(e)
          notificationService.error('emailsettings.projecttemplate.error')
        })
      })
    }
    
    function EmailSettings(resource) {
      var res = {
        resource: resource,
        generalSettings: [],
        userSettings: []
      }

      var promises = []

      if (resource.$hasEmbedded('emailgeneralsetting')) {
        promises.push(resource.$request().$get('emailgeneralsetting').then(function (setting) {
          angular.forEach(setting, function (s) {
            res.generalSettings.push(EmailGeneralSetting(s))
          })
        }))
      }
      if (resource.$hasEmbedded('emailusersetting')) {
        promises.push(resource.$request().$get('emailusersetting').then(function (setting) {
          angular.forEach(setting, function (s) {
            res.userSettings.push(EmailUserSetting(s))
          })
        }))
      }

      return $q.all(promises).then(function(){ return res})
    }

    function EmailGeneralSetting(resource) {
      return {
        resource: resource,
        id: resource.id,
        projectTemplateId: resource.projectTemplateId,
        emailTemplateType: resource.emailTemplateType,
        requirement: resource.requirement
      }
    }

    function EmailUserSetting(resource) {
      return {
        resource: resource,
        id: resource.id,
        projectTemplateId: resource.projectTemplateId,
        emailTemplateType: resource.emailTemplateType,
        enabled: resource.enabled
      }
    }

  }
})();

(function () {
  angular.module('gfApp')
    .service('dataValueService', function ($q,$timeout, fileUploadOrchestrationService) {
      this.saveDataValue = saveDataValue
      this.hasValue = hasValue
      this.getDataValuesByGroup = getDataValuesByGroup
      this.groupByCategory = groupByCategory
      this.createDataValueWrapper = createDataValueWrapper

      /**
       * Saves a data value in the api
       * @param dataValue the object, containing a self rel that will be used to save the resource
       *                  this can be a task or a project instance relation
       * @param newValue updated full value object
       * @returns {Function} promise to update the data
       */
      function saveDataValue(dataValue, newValue) {
        return dataValue.$request().$put('self', {}, {
          type: dataValue.type,
          value: newValue
        })
      }


      function hasValue(dataValue) {

        if(dataValue.type === 'files'){
          return angular.isDefined(dataValue.content) && dataValue.content.some(function(f){return f.isUploaded})
        }

        if(!defaultHasValue(dataValue)){
          return false
        }

        switch (dataValue.type) {
          case 'confirmation':
            return dataValue.value === true
          case 'dropdown':
            return  dataValue.value.selectedValues.length > 0
          case 'user':
            return angular.isDefined(dataValue.value.selectedUser) && dataValue.value.selectedUser !== null
          case 'group':
            return angular.isDefined(dataValue.value.selected) && dataValue.value.selected !== null
          case 'string':
            return dataValue.value.trim().length > 0
          default:
            return true
        }
      }

      function defaultHasValue(dataValue) {
        return angular.isDefined(dataValue.value) && dataValue.value !== null && dataValue.value !== ''
      }

      function groupByCategory(data) {
        var tabs = {
          groups : [],
          selected: null,
          selectedIndex: null
        }

        tabs.back = function(){
          tabs.selected = null
          tabs.selectedIndex = null
        }

        angular.forEach(data, function (dv) {
          var group = undefined;
          var name = dv.categoryName;
          var listOrder = dv.categoryListOrder;
          var type = dv.categoryType;

          angular.forEach(tabs.groups, function (g) {
            if (g.name === name) {
              group = g;
            }
          });

          if (angular.isUndefined(group)) {
            group = {name: name, type: type, listOrder: listOrder, data: []};
            tabs.groups.push(group);
          }

          group.data.push(dv);
        })

        return tabs;
      }

      function getDataValuesByGroup(data, nameFn, orderFn, typeFn, idFn) {
        var defer = $q.defer()

        var groups = []
        var dvs = []

        if (data.$has('dataValue')) {
          data.$request().$get('dataValue')
            .then(function (data) {
              var dvsPromises = []

              angular.forEach(data, function (dv) {
                var dvPromise = $q.defer()
                dvsPromises.push(dvPromise)
                var promises = []
                var dataValue = createDataValueWrapper(dv, promises);
                dvs.push(dataValue)

                $q.all(promises).then(function () {
                  // -- assign to group
                  var group = undefined;
                  var name = nameFn(dataValue)
                  var id = idFn(dataValue)
                  var listOrder = angular.isDefined(orderFn) ? orderFn(dataValue) : 0
                  var type = angular.isDefined(typeFn) ? typeFn(dataValue) : ''

                  angular.forEach(groups, function (g) {
                    if (g.name === name) {
                      group = g;
                    }
                  });

                  if (angular.isUndefined(group)) {
                    group = {id: id, name: name, type: type, listOrder: listOrder, data: []};
                    groups.push(group);
                  }


                  group.data.push(dataValue)
                  dvPromise.resolve()
                });
              });

              $q.all(dvsPromises)
                .then(function(){
                  defer.resolve({dataValues: dvs, groups: groups})
                })
            });
        }else{
          defer.resolve({dataValues: dvs, groups: groups})
        }

        return defer.promise
      }

      function createDataValueWrapper(dv, promises) {
        var dataValue = {
          type: dv.type,
          name: dv.name,
          readonly: dv.readonly,
          field: dv,
          id: dv.id,
          versionedDataValueId: dv.versionedDataValueId,
          content: [],
          value: dv.value,
          canEdit: dv.$hasLink('draft'),
          isCurrent: dv.isCurrent,
          isBusy: false,
          categoryName: dv.categoryName,
          categoryListOrder: dv.categoryListOrder,
          categoryType: dv.categoryType,
          categoryId: dv.categoryId,
          highlightRequiredAction: '',
          hasValue: dv.hasValue,
          fileApprove: dv.fileApprove,
          fileOnlyApproved: dv.fileOnlyApproved
        };

        dataValue.isBusyFn = function() {
          if(dataValue.type === 'files'){
            return dataValue.isBusy || fileUploadOrchestrationService.isContainerInProgress(dv.id);
          }
          return dataValue.isBusy
        }

        // -- load embedded
        // -- files
        if (dv.$hasEmbedded('file')) {
          var promise = dv.$request().$get('file').then(function (files) {
            angular.forEach(files, function (file) {
              dataValue.content.push(new File(file));
            });
          })
          if(angular.isArray(promises)){
            promises.push(promise)
          }
        }

        return dataValue;
      }


      function File(resource){
        var vm = angular.extend({}, resource)

        vm.resource = resource

        return vm
      }
    })
})();

(function () {
    angular.module('gfApp')
      .service('dashboardV2Service', service)
  
    function service($appApiV2) {
      var vm = this

      vm.getProjectInstancesByCountry = getProjectInstancesByCountry
      vm.getProjectInstancesByStatus = getProjectInstancesByStatus
      vm.getProjectTemplatesOverview = getProjectTemplatesOverview
      vm.getProjectInstancesMap = getProjectInstancesMap
      vm.getProjectInstancesOverview = getProjectInstancesOverview
      vm.getProjectInstancesStatus = getProjectInstancesStatus
      vm.getProjectInstancesProcessTime = getProjectInstancesProcessTime
      vm.getKonnektProcesses = getKonnektProcesses
      vm.getProjectInstances = getProjectInstances
  
      function getProjectInstancesByCountry(filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-projectinstancesbycountry', {params: sanitizeFilter(filters)})
        });
      }
  
      function getProjectInstancesByStatus(filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-projectinstancesbystatus', {params: sanitizeFilter(filters)})
        });
      }
  
      function getProjectTemplatesOverview(filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-projecttemplatesoverview', {params: sanitizeFilter(filters)}).then(function(m){
              return m;
            })
        });
      }
  
      function getProjectInstancesMap(filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-projectinstancesmap', {params: sanitizeFilter(filters)})
        });
      }
  
      function getProjectInstancesOverview (filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-projectinstancesoverview', {params: sanitizeFilter(filters)})
        });
      }

      function getProjectInstancesStatus (filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-projectinstancesstatus', {params: sanitizeFilter(filters)})
        });
      }

      function getProjectInstancesProcessTime (filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-projectinstancesprocesstime', {params: sanitizeFilter(filters)})
        });
      }

      function getKonnektProcesses (filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-konnektprocesses', {params: sanitizeFilter(filters)})
        });
      }

      function getProjectInstances (filters){
        return $appApiV2
        .then(function (v) {
            return v.get('dashboard-projectinstances', {params: sanitizeFilter(filters)})
        });
      }

      // ---------------

      function sanitizeFilter(filters){
        if(!filters) return {}

        var filter = {
          clientId:  filters.selectedClient ? filters.selectedClient.id : null,
          projectTemplateId: filters.projectTemplateId,
          dateFrom: (filters.dateRange && filters.dateRange.startDate) ? filters.dateRange.startDate.toJSON() : null,
          dateTo: (filters.dateRange && filters.dateRange.endDate) ? filters.dateRange.endDate.toJSON() : null,
          pageNumber: filters.pageNumber,
          query: filters.query,
          projectStatus: filters.projectStatus
        }

        if(filters.dateFrom){
          filter.dateFrom = filters.dateFrom.toJSON()
        }

        if(filters.dateTo){
          filter.dateTo = filters.dateTo.toJSON()
        }

        return filter
      }
    }
  })();
  
(function () {
  angular.module('gfApp')
    .service('dashboardService', dashboardService)

  function dashboardService($appApi, $q) {
    var vm = this

    var promises = {}
    var promisesPending = {}


    vm.getAllWidgets = getAllWidgets
    vm.getLineChartWidget = getLineChartWidget
    


    function sanitizeFilter(filters){
      return {
        clientId:  filters.selectedClient!==null ? filters.selectedClient.id : null,
        startDate: (filters.dateRange && filters.dateRange.startDate) ? filters.dateRange.startDate.toJSON() : null,
        endDate: (filters.dateRange && filters.dateRange.endDate) ? filters.dateRange.endDate.toJSON() : null
      }
    }

    function getAllWidgets(filters){
      var filterStr = angular.toJson(filters);
      if(promises[filterStr]){
        var q = $q.defer()
        if(!promisesPending[filterStr]) promisesPending[filterStr] = []
        promisesPending[filterStr].push(q)
        return q.promise
      }



      var defer = $appApi
        .then(function (v) {
          return v.$request().$get('dashboard', sanitizeFilter(filters))
        })
        .then(function(data){
          var dto = allWidgets(data)
          angular.forEach(promisesPending[filterStr], function(p){
            p.resolve(dto);
          })
          delete promisesPending[filterStr]
          delete filterStr[filterStr]

          return dto;
        })

        promises[filterStr] = defer;

        return defer;
    }

    function getLineChartWidget(id){
      return $appApi
        .then(function (v) {
          return v.$request().$get('dashboard-monthlyoverview', {clientId: id})
        })
    }

    function allWidgets(resource){
      return {
        resource : resource,
        id : resource.id,
        name : resource.name,
        projectOverview : resource.projectOverview,
        projectByClient: resource.projectByClient,
        projectByCountry: resource.projectByCountry,
        projectByProjectType: resource.projectByProjectType,
        projectByBrand: resource.projectByBrand,
        projects : resource.projects,
        stores : resource.stores
      }
    }


  }

})();

(function () {
  angular.module('gfApp')
    .service('customerContactService', function ($log, appInsights,$appApi, $q) {

      var service = {
        create : createCustomerContact,
        update : updateCustomerContact,
        delete : deleteCustomerContact ,
        get: getCustomerContacts,
        getUserCustomerContact: getUserCustomerContact
      };

      return service;

      function deleteCustomerContact(resource, customerContact){
        return resource.$request().$delete('self', {}, customerContact);
      }

      function createCustomerContact(customerContact){
        return $appApi.then(function (version){
          return version.$request().$post('customercontacts', {}, customerContact);
        });
      }

      function updateCustomerContact(resource, customerContact){
        return resource.$request().$put('self', {}, customerContact);
      }

      function getCustomerContacts(){

        var groupPromise = $appApi.then(function (version){
          return version.$request().$get('groups').then(function(groupPager){
            if(groupPager.$has('group')){
              return groupPager.$request().$get('group').then(function(data){
                return data;
              });
            }else{
              return []
            }
          });
        });

        var customerContactPromise = $appApi.then(function (version){
          return version.$request().$get('customercontacts').then(function(customerContactPager){
            if(customerContactPager.totalItemsCount >0) {
              return customerContactPager.$request().$get('customercontact').then(function (data) {
                return data;
              });
            }
            else
            {
              return [];
            }
          });
        });

        return $q.all([customerContactPromise, groupPromise]);
      }

      function getUserCustomerContact(userId){
        return $appApi.then(function (version){
          return version.$request().$get('usercustomercontact', {userId : userId});
        });
      }
    })
})();

(function () {
  angular
    .module('gfApp')
    .service('customerChatService', function ($appApi) {

      this.getCustomerSupportMessages = getCustomerSupportMessages
      this.sendMessage = sendMessage
      this.readMessages = readMessages

      function getCustomerSupportMessages(userId){

        return $appApi.then(function (version) {
          return version.$request().$get('usersupportchatmessages', {userId: userId});
        })
       .then(function(customerChatMessagesPager){
          if(customerChatMessagesPager.$hasLink('supportchatmessages')){
            return customerChatMessagesPager.$request().$get('supportchatmessages').then(function(data){
              return data;
            });
          }

          return;
       });
      }

      function sendMessage(message){
        return $appApi.then(function (version) {
          return version.$request().$post('createsupportchatmessage', {}, message);
        })
      }

      function readMessages(userId){
        return $appApi.then(function (version) {
          return version.$request().$put('readsupportchatmessages', {userId: userId});
        })
       .then(function(customerChatMessagesPager){
          return customerChatMessagesPager.$request().$get('supportchatmessages').then(function(data){
            return data;
          });

       });
      }
    })
})();

(function() {
  angular.module('gfApp')
    .service('concernService',
      function ($appApi, pagerService) {

        var vm = this
        vm.get = get
        vm.pager = pager
        vm.concernPagerWithProjectInstances = concernPagerWithProjectInstances
        vm.initialSearch = initialSearch
        ////////////

        function initialSearch() {
          return getConcernsWithProjectInstances('', 1, 1)
        }

        function pager() {
          return new pagerService.Pager({
            resource: $appApi,
            initialRel: 'concerns',
            dataRel: 'concern',
            mapper: Concern,
            nextPageRel: 'next',
            pageSize: 10
          })
        }

        function get(id){
          return $appApi
            .then(function (v) {
              return v.$request().$get('concern', {concernId: id})
            })
            .then(function(data){
              return Store(data)
            })
        }

        function concernPagerWithProjectInstances() {
          return new pagerService.Pager({
            resource: $appApi,
            initialRel: 'concerns-with-projectinstances',
            dataRel: 'concern',
            mapper: ConcernWithProjectInstances,
            nextPageRel: 'next',
            pageSize: 10,
            append:false
          })
        }

        function getConcernsWithProjectInstances(searchString, pageNumber, pageSize) {
          return $appApi.then(function (version) {
            return version.$request().$get('concerns-with-projectinstances', {
              query: angular.isUndefined(searchString) ? '' : searchString,
              pageNumber: pageNumber,
              pageSize: pageSize
            })
              .then(function (concernPager) {
                if (concernPager.$has('concern')) {
                  return concernPager.$request().$get('concern');
                }
                return;
              })
              .then(function (data) {
                return data;
              });
          });

        }

        function Concern(resource) {
          this.id = resource.id
          this.name = resource.name
          this.code = resource.code
          this.siteCode = resource.siteCode
          this.address = resource.address,
          this.country = resource.country,
          this.nationalStoreNumber = resource.nationalStoreNumber
          this.postCode = resource.postCode
          this.state = resource.state
          this.region = resource.region
          this.coordinates = resource.coordinates
          this.concernType = resource.concernType
        }

        function ConcernWithProjectInstances(concern) {
          this.id = concern.id
          this.code = concern.code
          this.name = concern.name
          this.siteCode = concern.siteCode
          this.address = concern.address,
          this.country = concern.country,
          this.nationalStoreNumber = concern.nationalStoreNumber
          this.postCode = concern.postCode
          this.state = concern.state
          this.region = concern.region
          this.coordinates = concern.coordinates
          this.concernType = concern.concernType

          this.projectTemplateName = concern.projectTemplateName
          this.projectInstances = concern.projectInstances
          this.projectInstancesCount = concern.projectInstancesCount
        }

        function Store(resource){
          return {
            resource: resource,
            id: resource.id,
            name: resource.name,
            code: resource.code,
            siteCode: resource.siteCode,
            address: resource.address,
            country: resource.country,
            nationalStoreNumber: resource.nationalStoreNumber,
            postCode: resource.postCode,
            state: resource.state,
            region: resource.region,
            coordinates: resource.coordinates,
            concernType: resource.concernType
          }
        }
      })
})();

(function () {
  angular.module('gfApp')
    .service('clientService', clientService)

  function clientService($appApi, $log, pagerService) {
    var vm = this

    vm.pager = null

    vm.initialize = initialize
    vm.get = get
    vm.getDetail = getDetail

    ////////

    function initialize(){
      $log.debug('Service - clientService - initialize')

      vm.pager = new pagerService.Pager({
        resource: $appApi,
        initialRel: 'clients',
        dataRel: 'client',
        mapper: Client,
        nextPageRel: 'next',
        pageSize: 0
      })
    }

    function get(id){
      return $appApi
        .then(function (v) {
          return v.$request().$get('client', {clientId: id})
        })
        .then(function(data){
          return Client(data)
        })
    }

    function getDetail(id){
      return $appApi
        .then(function (v) {
          return v.$request().$get('client-detail', {clientId: id})
        })
        .then(function(data){
          return ClientDetail(data)
        })
    }

    function Client(resource){
      return {
        resource : resource,
        id : resource.id,
        name : resource.name
      }
    }

    function ClientDetail(resource){
      return {
        resource : resource,
        id : resource.id,
        name : resource.name,
        projectOverview : resource.projectOverview,
        projects : resource.projects,
        stores : resource.stores
      }
    }

  }
})();

(function () {
  angular.module('gfApp')
    .service('aclService', service)

  function service($log, $q, errorHelperService) {
    var vm = this

    vm.pager = null

    vm.get = get
    vm.create = create
    vm.update = update

    ////////

    function get(resource){
      return resource.$request().$get('attributeacls')
        .then(Acls)
        .catch(handleError)
    }

    function create(model){
      return model.resource.$request().$postSelf(model)
        .then(Acl)
        .catch(handleError)
    }

    function update(model){
      return model.resource.$request().$putSelf(model)
        .then(Acl)
        .catch(handleError)
    }

    function handleError(e){
      var err = errorHelperService.formatError(e)
      $log.error(err)
      throw e
    }

    ////////


    function Acls(resource){
      var defer = $q.defer()
      var promises = []

      var vm =  {
        resource : resource,
        id : resource.id
      }

      if(resource.$has('attributeacl')){
        promises.push(resource.$request().$get('attributeacl')
          .then(function(data){
            vm.all = data.map(Acl)
          }))
      }

      $q.all(promises)
        .then(function(){
          defer.resolve(vm)
      })

      return defer.promise
    }

    function Acl(resource){
      return {
        resource:resource,
        id: resource.id,
        attributeId: resource.attributeId,
        attributeName: resource.attributeName,
        attributeListOrder: resource.attributeListOrder,
        projectRoleId: resource.projectRoleId,
        projectRoleName: resource.projectRoleName || 'project.acls.storelevel',
        projectRoleListOrder: resource.projectRoleListOrder,
        accessLevel: resource.accessLevel,
        fileApprove: resource.fileApprove,
        fileOnlyApproved: resource.fileOnlyApproved,
        isFileOrMultiFile: resource.isFileOrMultiFile
      }
    }
  }
})();

(function () {
  angular.module('gfSignalrModule', ['SignalR'])
    .run(function(appNotificationHub){
      appNotificationHub.initialize()
    });
})();

// shouldn't really have these, we only need to receive updates _from_ the server,
// the API should be used to send data up, but if you do want to do this, use the following:
//
// Register the available methods in the configuration object by adding this:
// methods: ['send'],
//
// Call the methods by doing hub.send(arguments)
//
(function () {
  angular.module('gfSignalrModule')
    .service('appNotificationHub', function ($rootScope, Hub, $log, configService, $timeout, signalRConnectionState, appInsights) {
      var me = this;
      me.initialize = initialize
      ///////

      var hub = undefined;
      var state = signalRConnectionState.connecting;

      ///////

      // Server-called functions
      // TODO: Move these out as there's a lot of signalr-specific logic in here, mixed with a little domain logic

      function setUnreadTaskIds(newTaskIds, refresh) {
        $log.debug('appNotificationHub: received new task ids ' + newTaskIds.length)
        $rootScope.$broadcast('appNotificationHub:setUnreadTaskIds', {ids: newTaskIds, refresh: refresh})
      }

      function newSupportMessage(){
        $rootScope.$broadcast('appNotificationHub:newSupportMessage')
      }

      ///////

      function initialize() {
        var deregister = $rootScope.$on('auth:newToken', function (e, accessToken) {
          var qs = {'access_token': accessToken}

          if (angular.isUndefined(hub)) {
            $log.debug('appNotificationHub: creating hub with new token')
            hub = createHub(qs)
          } else {
            $log.debug('appNotificationHub: received new access token, setting in existing hub')
            hub.connection.qs = qs
          }
        })

        $rootScope.$on('$destroy', deregister);
      }

      function createHub(qs) {
        return new Hub('notificationHub', {
          rootPath: configService.api.signalR,
          pingInterval: null,
          queryParams: qs,
          // Mandatory for multiple hubs
          useSharedConnection: true,

          //handle connection error
          errorHandler: onError,
          stateChanged: onStateChanged,

          listeners: {
            'setUnreadTaskIds': setUnreadTaskIds,
            'newSupportMessage' : newSupportMessage
          }
        });
      }

      function onStateChanged(s) {
        state = s.newState;
        switch (state) {
          case signalRConnectionState.connecting:
            $log.debug('appNotificationHub:connecting')
            break;
          case signalRConnectionState.connected:
            $log.debug('appNotificationHub:connected')
            break;
          case signalRConnectionState.reconnecting:
            $log.debug('appNotificationHub:reconnecting')
            break;
          case signalRConnectionState.disconnected:
            $log.debug('appNotificationHub:disconnected')
            tryReconnect();
            state = signalRConnectionState.disconnected
            break;
        }
      }

      function onError(error) {
        $log.debug(error)
        appInsights.trackException(error, 'tryReconnect', {location: 'appNotificationHub'})
        tryReconnect();
      }

      function tryReconnect() {
        $timeout(function () {
          if (state !== signalRConnectionState.disconnected) {
            return
          }
          $log.debug('appNotificationHub: trying to long-term reconnect')

          // The state is changed to "signalRConnectionState.connecting" by the connection attempt
          // which will trigger the onStateChanged handler if it fails, making this continuously
          // try to re-connect to the server
          hub.connect()

        }, 10000)
      }

    });
})();

/*global jQuery:false*/
(function ($) {
  angular.module('gfSignalrModule')
    .constant('signalRConnectionState', {
      connecting:   $.signalR.connectionState.connecting,
      connected:    $.signalR.connectionState.connected,
      reconnecting: $.signalR.connectionState.reconnecting,
      disconnected: $.signalR.connectionState.disconnected
    })
})(jQuery);

(function () {
  angular.module('gfApp')
    .controller('NavigationUnreadCountersController', function ($scope, $rootScope, $timeout, taskInboxUnreadService, userProfileService, errorHelperService, customerChatService, supportTeamMessageService) {
      var vm = this;
      vm.newTaskCount = 0

      activate()
      ///////

      function updateUnreadTaskIds(event, data){
        $timeout(function(){
          vm.newTaskCount = data.ids.length
        })
      }

      function activate() {
        taskInboxUnreadService.getUnreadTaskCount()
          .then(function (count) {
            vm.newTaskCount = count
          })

        userProfileService.isAllowedTo.viewSupportUserChat.then(function (visible) {

          if(visible){
            getSupportMessageCountForSupportUser()
          } else {
            getSupportMessageCountForGeneralApplicationUser()
          }

        })

        $scope.$on('destroy', $scope.$on('appNotificationHub:setUnreadTaskIds', updateUnreadTaskIds))

        var supportMessageCounterHandler = $rootScope.$on("appNotificationHub:newSupportMessage", getSupportMessageCount)

        $scope.$on('destroy', supportMessageCounterHandler)


      }

      function getSupportMessageCount(){
        userProfileService.isAllowedTo.viewSupportUserChat
        .then(function (visible) {
          if(visible){
            getSupportMessageCountForSupportUser()
          } else {
            getSupportMessageCountForGeneralApplicationUser()
          }
        })
        .catch(function(ex){
          throw "NavigationUnreadCountersController - Failed to load support message count for support user" + errorHelperService.formatError(ex)
        })
      }

      function getSupportMessageCountForGeneralApplicationUser(){
        userProfileService.userLoaded
        .then(function (user) {
          return customerChatService.getCustomerSupportMessages(user.id)
        })
        .then(function(chats){
          var messageCount = 0;
          angular.forEach(chats, function (chat) {
            if(!chat.viewed){
              messageCount ++;
            }
          });

          vm.supportMessageCountForGeneralApplicationUser = messageCount;
        })
        .catch(function(ex){
          if(ex.err === 'unavailable')
          throw "NavigationUnreadCountersController - Failed to load support message count for general application user" + errorHelperService.formatError(ex)
        })
      }

      function getSupportMessageCountForSupportUser(){
        supportTeamMessageService.getAllGeneralApplicationUserMessages().then(function (response) {
          var messageCount = 0;
          angular.forEach(response.data, function (userMessage) {
            if(!userMessage.responded){
              messageCount ++;
            }
          });

          vm.supportMessageCountForSupportUser = messageCount;
        });
      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('NavigationController', function ($appApi, userProfileService, configService, gfSiskinActions,modalService,
                                                  projectCreateControllerFactory, tazkService, customerChatService) {
      var vm = this;
      vm.user = {}
      vm.storeDashboardVisible = false
      vm.supportUserChatVisible = false
      vm.appApi = false
      vm.gfSiskinActions = gfSiskinActions
      vm.supportMessages = false

      vm.createProjectTemplate = createProjectTemplate
      vm.openSupportMessagePopup = openSupportMessagePopup
      vm.navigation = configService.appSettings.navigation
      vm.doAction = doAction

      activate()

      ///////

      function activate() {
        userProfileService.userLoaded
          .then(function (u) {
            if (!u.isAuthBypass) {
              enableNavigation()
            }
          })
      }

      function doAction(action, $event){
        if(action){
        $event.stopPropagation()
        $event.preventDefault()
        }

        if(angular.isDefined(vm[action])){
          vm[action]()
        }
      }

      function enableNavigation() {
        $appApi
          .then(function () {
            vm.appApi = true;

            userProfileService.isAllowedTo.viewStoreDashboard.then(function (visible) {
              vm.storeDashboardVisible = visible;
            })

            if (configService.appSettings.features.supportMessages === true) {
              vm.supportMessages = true
            }

            userProfileService.isAllowedTo.viewSupportUserChat.then(function (visible) {
              vm.supportUserChatVisible = visible;
            })

          });
      }

      function createProjectTemplate(){
        modalService.open(projectCreateControllerFactory())
      }

      function CustomerChat(user) {
        var vm = this;
        vm.id = 'customer-support-chat'
        vm.tazkViewModelType = 'customerChat'
        vm.userId = user.id
        vm.title = user.longName
      }

      function openSupportMessagePopup() {
        userProfileService.userLoaded.then(function (user) {
          tazkService.tryAddNewTazkViewModel(new CustomerChat(user));
          customerChatService.readMessages(user.id).then(function(){
            vm.supportMessageCountForGeneralApplicationUser = 0;
          });
        });
      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('PortalRedirectController', function ($window, $state, $timeout, userProfileService) {

      activate();

      ///////

      function activate() {
        userProfileService.userLoaded
          .then(function () {
            // Without applying this timeout the ui-router throws an error :
            //     Controller 'uiSelect', required by directive 'uiSelectMatch', can't be found!
            // It appears there is some ui component that is still initializing when we switch state, so wait until
            // the DOM is ready through the standard $timeout approach
            $timeout(redirect)
          })
      }

      function redirect(){
        $state.go('app.landing')
      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('MainController', function ($scope, $state, $appApi, $timeout, $window, $interval, $localStorage, $log, CacheFactory, welcomeMessageService,
                                            gfLoadingService, gfOIDCService, userProfileService, knownErrors, notificationService, errorHelperService,
                                            configService, taskstatuses, permissionService, gfSiskinActions, licensingService) {

      var appInsightsWarningHandled = false

      var vm = this;
      vm.isLoggedIn = false;
      vm.isExternalUser = false
      vm.initalizeError = null
      vm.reloadWindow = reloadWindow;
      vm.logout = logout;
      vm.dismissWelcomeMessage = dismissWelcomeMessage;
      vm.renderWelcomeMessage = renderWelcomeMessage;

      vm.newTaskCount = 0

      vm.welcomeMessage = '';
      vm.user = {}

      vm.app = 'app' // TODO: this would change depending on the config (right now you can set, 'default', 'job', 'app'
      vm.logoUrl = $window.rootVariables.logoUrl;

      // TODO: Move elsewhere
      vm.previewWelcomeMessage = previewWelcomeMessage;
      vm.themeBaseClass = "theme-" + configService.customer

      permissionService.can(gfSiskinActions.externalView).then(function(can){vm.isExternalUser = can})

      activate();

      ///

      function activate() {

        gfLoadingService.completeLogin
          .catch(function (err) {
            vm.isLoginError = true
            $state.current.data = {pageTitle: "Error"}
            vm.initalizeError = "Cannot sign in"
            if (isQuotaExceededError(err)) {
              vm.initalizeError += ' - ' + knownErrors.safariPrivateBrowsingMessage
            } else if (isGenericError(err)) {
              vm.initalizeError += ' - ' + err.message
            }
          })

        gfLoadingService.translationsLoaded.then(function () {
          return $appApi
        })
        .then(function(){
          return licensingService.init()
        })
        .then(function(){
          vm.isLoggedIn = true
        })
        .catch(function (err) {
          vm.isLoginError = true;
          if(angular.isString(err.err)){
            vm.initalizeError = err.err;
          }
          $log.error(err)
          $state.current.data = {pageTitle: "Error"}
        })



        userProfileService.userLoaded.then(function (user) {
          vm.user = user;
          vm.access_token = gfOIDCService.getToken();

          welcomeMessageService.getUserWelcomeMessage(user.id)
            .then(function (message) {
              if (message.value) {
                vm.welcomeMessage = vm.renderWelcomeMessage(message.value);
                vm.showWelcomeMessage = true;
                vm.welcomeMessagePreview = false;
              } else {
                handleAppInsightsBlocking()
              }
            })
            .catch(function (e) {
              if (errorHelperService.isApiUnavailable(e)) {
                $log.debug('MainController - Cannot get welcome message, api not available')
              } else {
                var err = errorHelperService.formatError(e)
                throw "MainController - Cannot get welcome message " + err
              }
            });
        })

        // add constants for ease of use on views
        vm.constants = {
          'taskstatuses': taskstatuses
        }
      }

      function reloadWindow() {
        vm.isLoginError = false;
        $timeout($window.location.reload(true), 500);
      }

      function logout() {
        CacheFactory.destroyAll()
        gfOIDCService.logout()
      }

      function dismissWelcomeMessage() {
        handleAppInsightsBlocking()
        vm.showWelcomeMessage = false;

        // Do not steal welcome messages from a user if you are impersonating the user
        // this does mean that you will see the welcome message every single time
        if (!vm.welcomeMessagePreview && !vm.user.isImpersonating) {
          welcomeMessageService.dismissUserWelcomeMessage(vm.user.id);
        }
      }

      function previewWelcomeMessage(message) {
        vm.welcomeMessagePreview = true;
        vm.showWelcomeMessage = true;
        vm.welcomeMessage = vm.renderWelcomeMessage(message);
      }

      function renderWelcomeMessage(message) {
        if (message === null) {
          return null;
        }
        return message.split('$username').join(vm.user.longName);
      }

      function handleAppInsightsBlocking() {
        if (appInsightsWarningHandled) {
          return
        }

        appInsightsWarningHandled = true

        if (Object.keys($window.appInsights.config).length === 1) {
          if (configService.appSettings.features.forceAppInsightsPrompt) {
            $localStorage.appInsightsAlertDismissed = false
          }

          if ($localStorage.appInsightsAlertDismissed !== true) {
            $log.debug("App insights alert dismissed")
            $timeout(function () {
              notificationService.warning('notification.info.appinsightsblocked')
            }, 5000)
            $localStorage.appInsightsAlertDismissed = true
          } else {
            $log.debug("App insights alert showing")
          }
        }
      }
    })

  function isQuotaExceededError(err) {
    return err && err.code === 22
  }

  function isGenericError(err) {
    return err && angular.isString(err.message)
  }

})();

(function () {
  angular.module('gfApp')
    .controller('LandingController', function ($state, $appApi, $timeout, userProfileService) {

      activate();

      ///////

      function activate() {
        userProfileService.userLoaded
          .then(function () {
            // Without applying this timeout the ui-router throws an error :
            //     Controller 'uiSelect', required by directive 'uiSelectMatch', can't be found!
            // It appears there is some ui component that is still initializing when we switch state, so wait until
            // the DOM is ready through the standard $timeout approach
            $timeout(switchToUserDefaultState)
          })
      }

      function switchToUserDefaultState(){
        userProfileService.isAllowedTo.viewStoreDashboard
          .then(function(canSee) {
          if (canSee) {
            $state.go('siskin.stores')

          } else {
            $state.go('siskin.inbox')
          }
        })
      }
    })
})();

(function () {
  angular.module('gfApp')
    .filter('trusted', function ($sce) {
      return function (url) {
        return $sce.trustAsResourceUrl(url);
      }
    })
    .filter('trustedHtml', function ($sce) {
      return function (input) {
        return $sce.trustAsHtml(input);
      }
    })
    // UI-select filter by multiple properties
    .filter('propsFilter', function () {
      return function (items, props) {
        var out = [];

        if (angular.isArray(items)) {
          items.forEach(function (item) {
            var itemMatches = false;

            var keys = Object.keys(props);
            for (var i = 0; i < keys.length; i++) {
              var prop = keys[i];
              var text = props[prop].toLowerCase();
              if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                itemMatches = true;
                break;
              }
            }

            if (itemMatches) {
              out.push(item);
            }
          });
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      }
    })
    .filter('enum', function ($translate) {
      filter.$stateful = true
      var value = null

      function filter(input, prefix) {
        if(!input){
          return ''
        }

        var result = ''
        if (value) {
          result = value
        } else {
          $translate('hkt.enum.' + prefix + '.' + input)
            .then(function (data) {
              value = data
            })
        }
        return result
      }

      return filter
    })
    // displays a translated key like 'None' if no value is provided
    .filter('ornone', function ($translate) {
      filter.$stateful = true
      var value = null

      function filter(input) {
        if(input){
          return input
        }

        var result = ''
        if (value) {
          result = value
        } else {
          $translate('common.notspecified')
            .then(function (data) {
              value = data
            })
        }
        return result
      }

      return filter
    })
    // displays a translated key like 'None' if no value is provided
    .filter('ornotset', function ($translate) {
      filter.$stateful = true
      var value = null

      function filter(input) {
        if(input){
          return input
        }
        
        var result = ''
        if (value) {
          result = value
        } else {
          $translate('common.notset')
            .then(function (data) {
              value = data
            })
        }
        return result
      }

      return filter
    })
    // displays a translated key like 'Default' if no value is provided
    .filter('ordefault', function ($translate) {
      filter.$stateful = true
      var value = null

      function filter(input) {
        if(input){
          return input
        }

        var result = ''
        if (value) {
          result = value
        } else {
          $translate('common.default')
            .then(function (data) {
              value = data
            })
        }
        return result
      }

      return filter
    })

    // returns asset absolute path
    .filter('asset', function(){
      return function (input) {
        return "/assets/images/" + input
      }
    })
    .filter('notTransient', function(){
      return function (items) {
        var out = [];

        if (angular.isArray(items)) {
          out = items.filter(function(m){return m.id !== 0})
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      }
    })
    .filter('hasValue', function(dataValueService){
      return function (items) {
        var out = [];

        if (angular.isArray(items)) {
          out = items.filter(function(m){return dataValueService.hasValue(m)})
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      }})

    .filter('find', function(){
      function recursiveFind(item, param){
        if(item.entityType === param){
          return item
        }else{
          if(angular.isUndefined(item.children)){
            return null
          }

          var items = item.children.map(function (c) {return recursiveFind(c, param)}).filter(function (c) {return c != null})

          if(items.length > 1){
            throw 'more than one ' + param + ' entity found'
          }else if(items.length === 1){
            return items[0]
          }else{
            return null
          }
        }
      }

      return function(item, param, property){
        if(angular.isUndefined(item.children)){
          throw 'find is used for entities with "children" property'
        }

        var ret =  recursiveFind(item, param)

        if(angular.isDefined(property)){
          return ret[property]
        }

        return ret
      }
    })

    .filter('attributeOrCategory',function(){
      return function (items) {
        var out = [];

        if (angular.isArray(items)) {
          out = items.filter(function(m){
            return m.entityType === 'attribute' && m.subtype !== 'role' && m.subtype !== 'milestone' && (angular.isUndefined(m.extendedData.category) || m.extendedData.category === '')
          })
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      }
    })

    .filter('attribute',function(){
      return function (items) {
        var out = [];

        if (angular.isArray(items)) {
          out = items.filter(function(m){
            return m.entityType === 'attribute' && m.subtype !== 'role' && m.subtype !== 'milestone' && m.subtype !== 'category'
          })
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      }
    })

    .filter('dateAttribute',function(){
      return function (items) {
        var out = [];

        if (angular.isArray(items)) {
          out = items.filter(function(m){
            return m.subtype === 'date' || m.subtype === 'dateTime'
          })
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      }
    })

    .filter('categoryAttributes',function(){
      return function (items, parent) {
        var out = [];

        if (angular.isArray(items)) {
          out = items.filter(function(m){
            return parent.name === m.extendedData.category && m.entityType === 'attribute' && m.subtype !== 'role' && m.subtype !== 'milestone' && m.subtype !== 'category'
          })
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      }
    })

    .filter('wfEntityLink',function(){
      return function(link, items, prop){

        for(var i=0;i<items.length;i++){
          var item = items[i]
          if(item.id === link.linkedId){
            if(angular.isDefined(prop)){
              return item[prop]
            }else{
              return item
            }
          }
        }

        return ''
      }
    })

  .filter("proxyFilter", function($filter) {
      return function(value, filterName) {
        if(angular.isString(filterName)){
          return $filter(filterName)(value)
        }else{
          return $filter('filter')(value,filterName)
        }
      };
    })

  .filter("filterByProperty", function($filter) {
    return function(value, propertyName, propertyValue) {
      var filter = {}
      filter[propertyName] = propertyValue
      return $filter('filter')(value,filter)
    };
  });

})();

(function () {
  angular.module('gfApp')
    .controller('fileUploadController', function ($log, $scope, fileUploadOrchestrationService) {
      var vm = this;
      vm.files = fileUploadOrchestrationService.files;
    })
})();

(function () {
  angular.module('gfApp')
    //   sample usage:
    //   <property-switcher ng-if="vm.canApprove" ng-model="item" property="isApproved" ng-change="vm.update(item)"
    //      options="{undefined:{key:'file.pending'},true:{class:'label-primary',key:'file.approved'},false:{class:'label-danger fa fa-times fa-2x',key:'file.unapproved'}}"></property-switcher>
    .directive('propertySwitcher', function ($timeout) {
      return {
        scope: {},
        restrict: 'E',
        bindToController:{
          ngModel:'=',
          property: '@',
          options:'=',
          ngChange:'&'
        },
        controllerAs: 'vm',
        controller: function () {
          var vm = this

          vm.current = get(vm.ngModel)

          vm.next = next

          //////////

          function next(){
            var breakOnNext = false, set = false
            for(var l in vm.options){
              if(vm.options.hasOwnProperty(l) && vm.options[l] === vm.current){
                breakOnNext = true
              }else if(breakOnNext){
                set = true
                vm.current = vm.options[l]
                vm.ngModel[vm.property] = l
                break
              }
            }

            if(!set){
              for(var o in vm.options){
                if(vm.options.hasOwnProperty(o)){
                  vm.current = vm.options[o]
                  setValue(o)
                  break
                }
              }
            }

            $timeout(function(){
              vm.ngChange()
            })
          }

          function get(){
            for(var l in vm.options){
              if(vm.options.hasOwnProperty(l) && (""+vm.ngModel[vm.property]) === l){
               return vm.options[l]
              }
            }
          }

          function setValue(value){
            if(value === 'false'){
              vm.ngModel[vm.property] = false
            }else if (value === 'true'){
              vm.ngModel[vm.property] = true
            }else if (value === 'undefined'){
              vm.ngModel[vm.property] = undefined
            }else{
              vm.ngModel[vm.property] = value
            }

          }
        },
        templateUrl: 'app/directives/propertySwitcher.directive.html'
    }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('presets', function () {
      return {
        scope: {},
        restrict: 'E',
        bindToController: {
          values: "=",
          resource: "=",
          onSelect: '&?'
        },
        templateUrl: 'app/directives/presets.directive.html',
        controllerAs: 'vm',
        controller: function (presetService) {
          var vm = this

          vm.remove = remove
          vm.update = update
          vm.select = select

          activate()

          ///

          function activate() {
            function get() {
              return angular.isDefined(vm.resource)
                ? presetService.getForResource(vm.resource)
                : presetService.get()
            }

            get()
              .then(function (data) {
                vm.data = data
              })
          }

          function update(selected) {
            var values = vm.values.map(function (m) {
              return {selector: m.selector || (m.id+m.name), value: m.pvalue}
            })

            presetService.update(selected.resource, values)
              .then(function(data){
                selected.values = data.values
              })
          }

          function remove(selected) {
            presetService.remove(selected.resource)
              .then(function(){
                vm.data.presets.splice(vm.data.presets.indexOf(selected),1)
                vm.selected = undefined
              })
          }

          function select(selected) {
            if (!selected) {
              return
            }

            if (angular.isString(selected)) {
              create(selected)
            } else {
              angular.forEach(vm.values, function (m) {
                var v = selected.values.find(function (v) {
                  return v.selector == (m.selector || (m.id+m.name))
                })

                if (v) {
                  m.pvalue = angular.fromJson(v.value)
                }
              })
            }

            if(angular.isDefined(vm.onSelect)){
              vm.onSelect()
            }
          }

          function create(selected) {
            var values = vm.values.map(function (m) {
              return {selector: m.selector || (m.id+m.name), value: angular.toJson(m.pvalue)}
            })

            presetService.create(vm.data.resource, {name: selected, data: values})
              .then(function(data){
                vm.selected = data
                vm.data.presets.splice(0,1)
                vm.data.presets.push(data)
              })
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('pager', function () {
      return {
        scope: {},
        restrict:'E',
        controllerAs: 'vm',
        templateUrl: 'app/directives/pager.directive.html',
        bindToController: {
          ngModel: "="
        },
        controller: function(){
          var vm = this;
          vm.pager = vm.ngModel;
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('optionalItems', function ($rootScope, $document, $uibModal) {
      return {
        scope:{},
        restrict: 'E',
        controller: function($scope){
          // bind
          var d = $rootScope.$on('showOptionalItems', display);

          $scope.$on('destroy', d)

          function display(event, url) {
            $scope.url = url;

            $uibModal.open({
              animation: 'fadeIn',
              component: 'optional-items',
              templateUrl: 'app/directives/optionalItems.directive.html',
              windowClass: 'modal-fullscreen optional-items-modal',
              backdropClass: 'optional-items-backdrop',
              ariaLabelledBy: 'modal-title',
              ariaDescribedBy: 'modal-body',
              scope: $scope,
              controllerAs: '$ctrl',
              controller: function ($scope, $uibModalInstance) {
                $scope.close = function () {
                  $uibModalInstance.dismiss('cancel');
                };
              }
            });
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('maps', function ($timeout, $compile, NgMap) {
      return {
        scope:{},
        restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
          data:'=',
          height:"@?",
          width:"@?"
        },
        controller: function(){
          var vm = this

          vm.height = vm.height || '380px'
          vm.width = vm.width || '100%'

          vm.googleMapsUrl="//maps.googleapis.com/maps/api/js?key=AIzaSyBLocBtToldYu0qsQ_p5py-GP6_T8MU7PA"
          vm.markerUrl="//chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2"

          $timeout(function(){
            NgMap.getMap().then(function(map) {

              vm.map = map

              map.setCenter(vm.data.center)
              map.setZoom(isNaN(vm.data.center.zoom) ? 1 : vm.data.center.zoom)
            })
          })

         vm.select = function(mk, m){
            vm.selected = vm.data.markers[m]
            vm.map.showInfoWindow('infowindow', this)
          }
        },
        templateUrl: 'app/directives/maps.directive.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('imgRefresher', function (fileTypeService) {
      return {
        scope: {},
        restrict: 'E',
        controller: controller,
        controllerAs: 'vm',
        bindToController: {
          url: '=src',
          extension: '=',
          class: '@'
        },
        templateUrl: 'app/directives/imgRefresher.directive.html'
      }


      function controller($timeout) {
        var vm = this;
        var retry = 5000; // -- retry every 5s
        var fallbackSrc = fileTypeService.getFallbackSrcByFileExtension(vm.extension)

        vm.src = fallbackSrc
        vm.onError = onError

        init();

        ///

        function init(){
          if (angular.isDefined(vm.url) && vm.url !== null) {
            vm.src = vm.url;
          }
        }

        function onError(){
          if (angular.isDefined(vm.url) && vm.url !== null) {
            vm.src = fallbackSrc

            $timeout(function(){
              vm.src = vm.url;
            },retry);
          }
        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('collapsible', function () {
      return {
        restrict: 'E',
        transclude: {
          'title': "?collapsibleTitle",
          'optionsRight': "?collapsibleOptionsRight",
          'optionsLeft': "?collapsibleOptionsLeft"
        },
        scope: {
          'visibleBody': "=?",
          'expanded':"@"
        },
        controller: function ($scope, $timeout) {
          $scope.collapsed = true;
          if (angular.isUndefined($scope.visibleBody)) {
            $scope.visibleBody = true;
          }

          $scope.toggle = function () {
            $scope.collapsed = !$scope.collapsed;
          }

          if($scope.expanded === 'true'){
            $timeout(function(){
              $scope.collapsed = false;
            })
          }
        },
        controllerAs: 'collapsibleCtrl',
        link: function (scope, element, attrs) {
          attrs.$observe('expand', function () {
            if (attrs['expand'] === "true") {
              if (scope.collapsed) {
                scope.collapsed = false;
              }
            }
          })
        },
        templateUrl: 'app/directives/collapsible.html'
      }
    });
})();

(function () {
  angular.module('gfApp')
    .controller('ContactInfoController', function ($state,customerContactService ,userProfileService) {
      var vm = this;
      vm.customerContact = '';
      vm.showCustomerContactPreview = false;
      vm.show = true
      vm.showDismiss = false
      activate();

      ////////////

      function activate() {
        vm.showCustomerContactPreview = true;
        userProfileService.userLoaded.then(function (user) {
          vm.user = user;
          customerContactService.getUserCustomerContact(user.id)
            .then(function (customerContact) {
              if (customerContact.value) {
                vm.customerContact = renderCustomerContact(customerContact.value);
                vm.showCustomerContactPreview = true;
              }
            });
        })

        function renderCustomerContact(customerContact) {
          if (customerContact == null) {
            return null;
          }
          return customerContact.split('$username').join(vm.user.longName);
        }

      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('CustomerContactController', function ($log, $scope, customerContactService, gfTranslationMapService, notificationService, errorHelperService) {
      var vm = this;
      vm.languages = gfTranslationMapService.getLanguages()
      vm.search = '';
      vm.messageResources = [];
      vm.customerContacts = [];
      vm.customerContact = '';
      vm.customerContactsLoaded = false;
      vm.activeCustomerContact = null;
      vm.defaultMessageResource = {group: '', language: 'en-GB', value: ''};
      vm.isSavingCustomerContact = false;
      vm.isDeletingCustomerContact = false;
      vm.showCustomerContactPreview = false;
      vm.getCustomerContactsCallBack = getCustomerContactsCallBack
      vm.loadCustomerContacts = loadCustomerContacts
      vm.setActiveCustomerContact = setActiveCustomerContact
      vm.loadEdit = loadEdit
      vm.saveCustomerContact = saveCustomerContact
      vm.deleteCustomerContact = deleteCustomerContact
      vm.getLanguageName = getLanguageName
      vm.getLanguageKey = getLanguageKey
      vm.getResourceById = getResourceById
      vm.isCustomerContactActive = isCustomerContactActive
      vm.hasCustomerContactInLanguage = hasCustomerContactLanguage
      vm.showCustomerContact = showCustomerContact
      vm.canDeleteCustomerContact = canDeleteCustomerContact
      vm.canSaveCustomerContact = canSaveCustomerContact
      vm.previewCustomerContact = previewCustomerContact;

      vm.isPreviewMode = true;
      vm.show = false
      vm.dismissCustomerContactPreview = dismissCustomerContactPreview;
      activate();

      ////////////

      function activate() {
        vm.loadCustomerContacts();
      }

      function getCustomerContactsCallBack(messages, groups, activeCustomerContact) {
        vm.messageResources = messages;
        vm.customerContacts = [];
        groups.unshift({name: ''});
        angular.forEach(groups, function (group) {
          var customerContact = {};
          customerContact.group = group.name;

          angular.forEach(vm.languages, function (language) {
            customerContact[language.name] = null;
          });

          vm.customerContacts.push(customerContact);
        });

        angular.forEach(messages, function (message) {
          angular.forEach(vm.customerContacts, function (customerContact) {
            var languageName = vm.getLanguageName(message.language);

            if (customerContact.group === message.group ||
              (customerContact.group === '' && message.group === null)) {
              customerContact[languageName] = message.value;
            }
          });

          if (message.group === '' && message.language === 'en-GB') {
            vm.defaultMessageResource = message;
          }
        });

        vm.setActiveCustomerContact(activeCustomerContact);
        $scope.customercontacteditform.$setPristine();
        vm.customerContactsLoaded = true;
      }

      function loadCustomerContacts(activeCustomerContact) {
        customerContactService.get().then(function (data) {
          vm.getCustomerContactsCallBack(data[0], data[1], activeCustomerContact);
        });
      }

      function setActiveCustomerContact(customerContact) {
        if (!customerContact) {
          customerContact = vm.defaultMessageResource;
        }

        vm.activeCustomerContact = {
          id: customerContact.id == null ? null : customerContact.id,
          group: customerContact.group,
          language: customerContact.language,
          value: customerContact.value
        };
      }

      function loadEdit(group, lang) {
        vm.activeCustomerContact = null;
        for (var i in vm.messageResources) {
          var languageName = vm.getLanguageName(vm.messageResources[i].language);

          if (vm.messageResources[i].group == group && languageName == lang) {
            vm.setActiveCustomerContact(vm.messageResources[i]);
            break;
          }
        }

        if (vm.activeCustomerContact === null) {
          vm.activeCustomerContact = {group: group, language: vm.getLanguageKey(lang), value: ''}
        }

        $scope.customercontacteditform.$setPristine();
      }

      function saveCustomerContact() {
        vm.isSavingCustomerContact = true;
        if (vm.activeCustomerContact != null && vm.activeCustomerContact.id) {
          var messageResource = vm.getResourceById(vm.activeCustomerContact.id);

          customerContactService.update(messageResource, vm.activeCustomerContact)
            .then(function (messageResource) {
              vm.isSavingCustomerContact = false;
              vm.loadCustomerContacts(messageResource);
            }).catch(function (ex) {
            notificationService.error('notification.error.savecustomerinfo');
            throw "Failed to save customer contact info " + errorHelperService.formatError(ex)
          });
        }
        else {
          customerContactService.create(vm.activeCustomerContact).then(function (messageResource) {
            vm.isSavingCustomerContact = false;
            vm.loadCustomerContacts(messageResource);
          }).catch(function (ex) {
            notificationService.error('notification.error.customercontactsave');
            throw "Failed save customer contact " + errorHelperService.formatError(ex)
          });
        }
      }

      function deleteCustomerContact() {
        vm.isDeletingCustomerContact = true;

        var messageResource = vm.getResourceById(vm.activeCustomerContact.id);
        customerContactService.delete(messageResource, vm.activeCustomerContact).then(function () {
          vm.isDeletingCustomerContact = false;
          vm.activeCustomerContact.id = null;
          vm.activeCustomerContact.value = '';
          vm.loadCustomerContacts(vm.activeCustomerContact);
        }).catch(function (ex) {
          notificationService.error('notification.error.customercontactdelete');
          throw "Failed to delete customer contact " + errorHelperService.formatError(ex)
        });
      }

      function getLanguageName(key) {

        if (key != null && key.length > 0) {
          return vm.languages[key].name;
        }
        return '';
      }

      function getLanguageKey(name) {
        for (var i in vm.languages) {
          if (vm.languages[i].name === name) {
            return vm.languages[i].key;
          }
        }

        return '';
      }

      function getResourceById(id) {
        var messageResource = null;

        if (vm.activeCustomerContact != null && vm.activeCustomerContact.id) {
          for (var i in vm.messageResources) {
            if (vm.messageResources[i].id === id) {
              messageResource = vm.messageResources[i];
              break;
            }
          }
        }

        return messageResource;
      }

      function isCustomerContactActive(group, lang) {
        if (vm.activeCustomerContact != null) {
          var languageName = vm.getLanguageName(vm.activeCustomerContact.language);
          return group === vm.activeCustomerContact.group && lang === languageName;
        }

        return false;
      }

      function hasCustomerContactLanguage(customerContact, lang) {
        return customerContact[lang] !== null;
      }

      function showCustomerContact(customerContact) {
        if (vm.search !== '') {
          return true;
        }

        for (var i in vm.languages) {
          var languageName = vm.languages[i].name;
          if (customerContact[languageName] !== null && customerContact[languageName] !== '') {
            return true;
          }
        }

        return false;
      }

      function canDeleteCustomerContact(customerContact) {
        return (vm.isDeletingCustomerContact
        || !isSaved(customerContact)
        || isDefault(customerContact));
      }

      function isSaved(customerContact) {
        return customerContact != null
          && customerContact.id != null
      }

      function isDefault(customerContact) {
        return customerContact.language == 'en-GB' &&
          (customerContact.group == null || customerContact.group === '')
      }

      function canSaveCustomerContact(customerContact) {
        return !(customerContact == null);
      }

      function dismissCustomerContactPreview() {
        vm.show = false;
      }

      function previewCustomerContact(customerContact) {
        vm.show = true;
        vm.customerContact = customerContact;
      }
    })
})();

(function(){
	angular.module('gfApp')
		.controller('ConcernController', function (concernService, permissionService) {
			var vm = this;
			
			vm.getConcernTaskCount= getConcernTaskCount;
			vm.loading = false;
			vm.hiding = false;

			vm.search = {query:''}

			permissionService.actionRedirect(activate)

			function activate(){
				vm.pager = concernService.concernPagerWithProjectInstances()
				vm.pager.reset(vm.search)
			}

			function getConcernTaskCount(concern){
				var count = 0;
				angular.forEach(concern.projectInstances, function(project) {
					count = count + project.taskCount;
				});

				return count;
			}
    })
})();


(function () {
  angular.module('gfApp')
    .directive('welcomeMessage', function () {
      return {
        restrict: 'A',
        scope: {},
        controllerAs:'vm',
        // THIS IS NOT THE CORRECT APPROACH TO RE-USING A VIEW
        // See how this is done in "contactInfo" instead
        bindToController: {
          controller : "=welcomeMessage"
        },
        controller: function ($scope) {
          var vm =this;
          vm.welcomeMessage = vm.controller.welcomeMessage;
          vm.dismiss = dismiss;

          function dismiss(){
            vm.controller.dismissWelcomeMessage();
          }

          $scope.$watch("vm.controller.welcomeMessage", function(newValue){
            vm.welcomeMessage =newValue;
          });
        },
        templateUrl: 'app/admin.welcomemessage/welcomemessage.html'
      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('WelcomeMessageController', function ($log, $scope, $timeout, permissionService, welcomeMessageService, gfTranslationMapService, notificationService, errorHelperService) {
      var vm = this;

      vm.languages = gfTranslationMapService.getLanguages()

      vm.search = '';
      vm.messageResources = []
      vm.welcomeMessages = []
      vm.welcomeMessagesLoaded = false;
      vm.activeMessage = null;
      vm.defaultMessageResource = {group: '', language: 'en-GB', value: ''};
      vm.isSavingMessage = false;
      vm.isDeletingMessage = false;
      vm.getWelcomeMessagesCallBack = getWelcomeMessagesCallBack
      vm.loadMessages = loadMessages
      vm.setActiveMessage = setActiveMessage
      vm.loadEdit = loadEdit
      vm.saveMessage = saveMessage
      vm.deleteMessage = deleteMessage
      vm.getLanguageName = getLanguageName
      vm.getLanguageKey = getLanguageKey
      vm.getResourceById = getResourceById
      vm.isMessageActive = isMessageActive
      vm.hasMessageInLanguage = hasMessageLanguage
      vm.showMessage = showMessage
      vm.canDeleteMessage = canDeleteMessage
      vm.canSaveMessage = canSaveMessage

      permissionService.actionRedirect(activate)

      ////////////

      function activate() {
        vm.loadMessages();
      }

      function getWelcomeMessagesCallBack(messages, groups, activeMessage) {
        vm.messageResources = messages;
        vm.welcomeMessages = [];
        groups.unshift({name: ''});
        angular.forEach(groups, function (group) {
          var message = {};
          message.group = group.name;

          angular.forEach(vm.languages, function (language) {
            message[language.name] = null;
          });

          vm.welcomeMessages.push(message);
        });

        angular.forEach(messages, function (message) {
          angular.forEach(vm.welcomeMessages, function (welcomeMessage) {
            var languageName = vm.getLanguageName(message.language);

            if (welcomeMessage.group === message.group ||
              (welcomeMessage.group === '' && message.group === null)) {
              welcomeMessage[languageName] = message.value;
            }
          });

          if (message.group === '' && message.language === 'en-GB') {
            vm.defaultMessageResource = message;
          }
        });

        vm.setActiveMessage(activeMessage);
        $scope.welcomemessageeditform.$setPristine();
        vm.welcomeMessagesLoaded = true;
      }

      function loadMessages(activeMessage) {
        welcomeMessageService.get().then(function (data) {
          vm.getWelcomeMessagesCallBack(data[0], data[1], activeMessage);
        }).catch(function (ex) {
          notificationService.error('notification.error.welcomemessageload');
          throw "Failed to load messages " + errorHelperService.formatError(ex)
        });
      }

      function setActiveMessage(message) {
        if (!message) {
          message = vm.defaultMessageResource;
        }

        vm.activeMessage = {
          id: message.id === null ? null : message.id,
          group: message.group,
          language: message.language,
          value: message.value
        };
      }

      function loadEdit(group, lang) {
        vm.activeMessage = null;
        for (var i in vm.messageResources) {
          var languageName = vm.getLanguageName(vm.messageResources[i].language);

          if (vm.messageResources[i].group === group && languageName === lang) {
            vm.setActiveMessage(vm.messageResources[i]);
            break;
          }
        }

        if (vm.activeMessage === null) {
          vm.activeMessage = {group: group, language: vm.getLanguageKey(lang), value: ''}
        }

        $scope.welcomemessageeditform.$setPristine();
      }


      function saveMessage() {
        vm.isSavingMessage = true;
        if (vm.activeMessage.id) {
          var messageResource = vm.getResourceById(vm.activeMessage.id);

          welcomeMessageService.update(messageResource, vm.activeMessage).then(function (messageResource) {
            vm.isSavingMessage = false;
            vm.loadMessages(messageResource);
          }).catch(function (ex) {
            notificationService.error('notification.error.welcomemessagesave');
            throw "Failed to save welcome message " + errorHelperService.formatError(ex)
          });
        }
        else {
          welcomeMessageService.create(vm.activeMessage).then(function (messageResource) {
            vm.isSavingMessage = false;
            vm.loadMessages(messageResource);
          }).catch(function (ex) {
            notificationService.error('notification.error.welcomemessagesave');
            throw "Failed to save welcome message " + errorHelperService.formatError(ex)
          });
        }
      }


      function deleteMessage() {
        vm.isDeletingMessage = true;

        var messageResource = vm.getResourceById(vm.activeMessage.id);

        welcomeMessageService.delete(messageResource, vm.activeMessage).then(function () {
          vm.isDeletingMessage = false;
          vm.activeMessage.id = null;
          vm.activeMessage.value = '';
          vm.loadMessages(vm.activeMessage);
        }).catch(function (ex) {
          notificationService.error('notification.error.welcomemessagedelete');
          throw "Failed to delete welcomemessage " + errorHelperService.formatError(ex)
        });
      }


      function getLanguageName(key) {
          if (key !== null && key.length >0 ) {
            return vm.languages[key].name;
          }
        return '';
      }

      function getLanguageKey(name) {
        for (var i in vm.languages) {
          if (vm.languages[i].name === name) {
            return vm.languages[i].key;
          }
        }

        return '';
      }


      function getResourceById(id) {
        var messageResource = null;

        if (vm.activeMessage.id) {
          for (var i in vm.messageResources) {
            if (vm.messageResources[i].id === id) {
              messageResource = vm.messageResources[i];
              break;
            }
          }
        }

        return messageResource;
      }


      function isMessageActive(group, lang) {
        if (vm.activeMessage !== null) {
          var languageName = vm.getLanguageName(vm.activeMessage.language);
          return group === vm.activeMessage.group && lang === languageName;
        }

        return false;
      }


      function hasMessageLanguage(msg, lang) {
        return msg[lang] !== null;
      }


      function showMessage(msg) {
        if (vm.search !== '') {
          return true;
        }

        for (var i in vm.languages) {
          var languageName = vm.languages[i].name;
          if (msg[languageName] !== null && msg[languageName] !== '') {
            return true;
          }
        }

        return false;
      }


      function canDeleteMessage(msg) {
        return (vm.isDeletingMessage
        || !isSaved(msg)
        || isDefault(msg));
      }

      function isSaved(msg){
        return msg !== null
          && msg.id !== null
      }

      function isDefault(msg){
        return msg.language === 'en-GB' &&
          (msg.group === null || msg.group === '')
      }

      function canSaveMessage(msg) {
        return !( msg === null );
      }
    })
})();

(function () {
  angular.module('gfApp')
    .directive('adminTranslate', function ($rootScope, gfTranslationUpdater, $timeout) {
      return {
        restrict: 'A',
        scope: {
          key: "=adminTranslate",
          lang: "@"
        },
        templateUrl: 'app/admin.translate/admin.translate.directive.html',
        link: function (scope, element) {
          scope.value = gfTranslationUpdater.translations[scope.lang][scope.key]
          scope.edit = false
          scope.showInput = showInput
          scope.doTranslate = doTranslate
          scope.doCancel = doCancel

          var d = $rootScope.$on('event:gfTranslation-saved', function () {
            $timeout(scope.value = gfTranslationUpdater.translations[scope.lang][scope.key])
          })

          scope.$on('destroy', d)

          function doTranslate() {
            gfTranslationUpdater.update(scope.key, scope.value, scope.lang).then(function () {
              $rootScope.$broadcast('$translateChangeSuccess')
              $rootScope.$broadcast('event:gfTranslation-saved')
              scope.edit = false
            })
          }

          function doCancel(){
            scope.edit = false;
            scope.value = gfTranslationUpdater.translations[scope.lang][scope.key]
          }

          function showInput() {
            scope.edit = true
            $timeout(function(){element.find('input')[0].focus()})
          }

        }
      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('TranslateController', function ($translate, $timeout, $log, permissionService, gfTranslationUpdater, gfTranslationMapService, pagerService, gfHelper) {
      var vm = this;
      vm.activeKey = $translate.use();
      vm.filter = '';
      vm.pager = {};
      vm.pageNumber = 1;
      vm.isCollapsed = false;
      vm.loadTranslations = loadTranslations;
      vm.languages = gfTranslationMapService.getLanguages();
      vm.translations = [];
      vm.all = [];
      vm.translationsLoaded = false;
      vm.reset = reset;
      vm.getPage = getPage;
      vm.filterTranslations = filterTranslations;
      vm.languageSelected = vm.languages[vm.activeKey]

      permissionService.actionRedirect(activate);

      function activate() {
        vm.loadTranslations();
      }

      vm.switch = function (key) {
        $translate.use(key);
        vm.activeKey = key;
      }

      function loadTranslations() {
        vm.translations = [];
        vm.all = [];
        gfTranslationUpdater.loadAll().then(function () {
          var keys = gfTranslationUpdater.translations['en-GB'];
          for (var key in keys) {
            if (keys.hasOwnProperty(key)) {
              vm.all.push(key)
            }
          }
          vm.translations = vm.all;
          vm.getPage(1);
          vm.translationsLoaded = true;
          $timeout(function(){
            $log.debug('TranslateController: Finished binding translations')
          },1000)
        })
      }

      function getPage(page) {
        vm.pager = pagerService.arrayPager({
          items: vm.translations,
          currentPage: page,
          pageSize: 10
        });
      }

      function filterTranslations() {
        vm.pageNumber = 1;
        filterData();
        vm.getPage(1);
      }

      function reset() {
        vm.filter = '';
        vm.pageNumber = 1;
        vm.translations = vm.all;
        vm.getPage(1);
      }

      function filterData() {
        vm.filter = vm.filter.trim()
        if (!gfHelper.isNullOrEmpty(vm.filter)) {

          vm.translations = [];
          angular.forEach(vm.all, function (translation) {
            if (translation.includes(vm.filter)) {
                vm.translations.push(translation);
            }
          })
        } else {
          vm.translations = vm.all;
        }
      }

  })
})();

(function () {
  angular.module('gfApp')
    .controller('PermissionController', function ($state,customerContactService ,userProfileService, permissionService, modalService, groupService) {
      var vm = this;
      vm.permissions = []
      vm.createPermissionAction = createPermissionAction
      vm.editPermissionAction = editPermissionAction
      vm.editStore = editStore

      permissionService.actionRedirect(activate)

      ////////////

      function activate() {


        permissionService.initialize();
        groupService.initialize();

        vm.pager = permissionService.pager
        vm.pager.reset().then(function(permissions){
          vm.permissions = permissions
        });
      }

      function refresh(){
        vm.pager.reset().then(function(permissions){
          vm.permissions = permissions
        });
      }

      function createPermissionAction($event){
        $event.stopPropagation()
        modalService.open({
          templateUrl: 'app/admin.permissions/permissions.action.create.html',
          controllerInit: createPermissionActionController()
        })
      }

      function editPermissionAction($event, permission){
        $event.stopPropagation()
        modalService.open({
          templateUrl: 'app/admin.permissions/permissions.action.update.html',
          controllerInit: updatePermissionActionController(permission)
        })
      }

      function editStore($event, permission){
        $event.stopPropagation()
        modalService.open({
          templateUrl: 'app/admin.permissions/permissions.store.update.html',
          controllerInit: updateStorePermissionActionController(permission)
        })
      }

      function createPermissionActionController(){

      }

      function updatePermissionActionController(permissionAction){
        return function (vm) {
          vm.original = permissionAction
          vm.data = angular.copy(permissionAction)
          vm.data.resource = permissionAction.resource
          vm.groupPager = groupService.pager

          vm.save = function () {
            permissionService.update(vm.data)
              .then(function (data) {

                vm.original.name = data.name
                vm.close()

                refresh();
              })
              .catch(function (m) {
                vm.error = m
              })
          }

        }



      }

      function updateStorePermissionActionController(){

      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('ImpersonateController', function (gfOIDCService, userService, permissionService) {

      var vm = this;

      permissionService.actionRedirect(activate);

      function activate() { }

      vm.impersonate = function (user) {
        gfOIDCService.impersonate(user.userId)
      }


      vm.search = function (query) {
        userService.searchAll(query).then(function (users) {
          vm.users = users
        })
      }

      vm.stopImpersonate = function () {
        gfOIDCService.impersonate()
      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('GroupStoreController', function (permissionService, groupStoreService, modalService, storeService) {
      var vm = this;
      vm.groups = []
      vm.editGroupStore = editGroupStore

      permissionService.actionRedirect(activate);

      ////////////

      function activate() {


        groupStoreService.initialize();
        storeService.initialize();

        vm.pager = groupStoreService.pager
        vm.pager.reset().then(function(groups){
          vm.groups = groups
        });
      }

      function refresh(){
        vm.pager.reset().then(function(groups){
          vm.groups = groups
        });
      }

      function editGroupStore($event, groupStore){
        $event.stopPropagation()
        modalService.open({
          size: 'lg',
          templateUrl: 'app/admin.groupstore/groupstore.action.update.html',
          controllerInit: updateGroupStoreController(groupStore)
        })
      }

      function updateGroupStoreController(groupStore){
        return function (vm) {
          vm.original = groupStore
          vm.data = angular.copy(groupStore)
          vm.data.resource = groupStore.resource
          vm.storePager = storeService.pager

          vm.save = function () {
            groupStoreService.update(vm.data)
              .then(function (data) {

                vm.original.name = data.name
                vm.close()

                refresh();
              })
              .catch(function (m) {
                vm.error = m
              })
          }

        }



      }
    })
})();

(function () {
  angular.module('gfApp')
    .controller('WorkflowsController', function (workflowEntityService) {

      var vm = this

       activate()

      ///////////

      function activate(){
        workflowEntityService.getOverview()
          .then(function(data){
            vm.data = data
          })
      }


    })
})();

(function () {
  angular
    .module('gfApp')
    .run(function ($timeout) {
      // Full height of sidebar
      function fix_height() {
        var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
        angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

        var navbarHeight = angular.element('nav.navbar-default').height();
        var wrapperHeight = angular.element('#page-wrapper').height();

        if (navbarHeight > wrapperHeight) {
          angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
        }

        if (navbarHeight < wrapperHeight) {
          angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
        }

        if (angular.element('body').hasClass('fixed-nav')) {
          if (navbarHeight > wrapperHeight) {
            angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
          } else {
            angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
          }
        }

      }

      angular.element(window).bind("load resize scroll", function () {
        fix_height();
      });

      // Move right sidebar top after scroll
      angular.element(window).scroll(function () {
        if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
          angular.element('#right-sidebar').addClass('sidebar-top');
        } else {
          angular.element('#right-sidebar').removeClass('sidebar-top');
        }
      });

      $timeout(function () {
        fix_height();
      });

      // Minimalize menu when screen is less than 768px
      angular.element(window).bind("load resize orientationchange", addSmallWindowClass)


      function addSmallWindowClass(){
        if (angular.element(document).width() < 769) {
          angular.element('body').addClass('body-small')
        } else {
          angular.element('body').removeClass('body-small')
        }
      }

      addSmallWindowClass()
    });
})();

(function () {
  angular
    .module('gfApp')
    .run(function ($rootScope, $state, $stateParams, $window, editableOptions) {
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;
      editableOptions.theme = 'bs3';
      
      var d = $rootScope.$on("$locationChangeStart", function() { $window.scrollTo(0, 0) });
      $rootScope.$on('$destroy', d);
    });
})();

/*global rootVariables:false*/
(function () {
  'use strict';

  angular
    .module('gfApp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    var routes = rootVariables.appSettings.routes

    $stateProvider
      .state('siskin', {
        abstract: true,
        url: "",
        templateUrl: "app/components/common/content.html"
      })
      .state('siskin.admintranslate', {
        url: "/translate",
        templateUrl: "app/admin.translate/admin.translate.html",
        data: {pageTitle: 'nav.admin.translate', action:'adminTranslate'}
      })

      .state('siskin.adminimpersonate', {
        url: "/impersonate",
        templateUrl: "app/admin.impersonate/admin.impersonate.html",
        data: {pageTitle: 'nav.admin.impersonate', action:'adminImpersonate'}
      })

      .state('siskin.adminwelcomemessage', {
        url: "/welcomemessage",
        templateUrl: "app/admin.welcomemessage/admin.welcomemessage.html",
        data: {pageTitle: 'nav.admin.welcomemessage', action:'adminWelcomeMessage'}
      })

      .state('siskin.projectinstancedetail', {
        url: routes["siskin.projectinstancedetail"],
        templateUrl: "app/modules/siskin/projectinstance/detail.html",
        data: {pageTitle: 'nav.projectdetail', action:'projectInstanceView', redirectTo:'siskin.inbox'}
      })

      .state('siskin.store', {
        url: routes["siskin.store"],
        templateUrl: "app/modules/siskin/concern/detail.html",
        data: {pageTitle: 'nav.storedetail', action:'concernDetailView', redirectTo:'siskin.dashboard'}
      })

      .state('siskin.projectInstances', {
        url: routes["siskin.projectInstances"],
        templateUrl: "app/modules/siskin/projectinstance/list.html",
        data: {pageTitle: 'nav.projectinstances',action: 'projectInstanceList'}
      })

      .state('siskin.admincustomercontact', {
        url: "/customercontact",
        templateUrl: "app/contactInfo/admin.customercontact.html",
        data: {pageTitle: 'nav.admin.customercontact'}
      })

      .state('siskin.contactinfo', {
        url: "/contactinfo",
        templateUrl: "app/contactInfo/contactinfo.html",
        data: {pageTitle: 'nav.contactinfo'}
      })

      .state('siskin.stores', {
        url: routes["siskin.stores"],
        templateUrl: "app/concern/concern.html",
        data: {pageTitle: 'nav.stores', action:'storesView', redirectTo:'siskin.dashboard'}
      })

      .state('siskin.supportusermessage', {
        url: "/supportusermessage",
        templateUrl: "app/supportmessages/supportteam.message.html",
        data: {pageTitle: 'Support Team - View Messages'}
      })

      .state('siskin.landing', {
        url: "/landing",
        templateUrl: "app/landing/landing.html",
        data: {pageTitle: 'Siskin'}
      })

      .state('portalredirect', {
        url: "/portalredirect",
        templateUrl: "app/portalRedirect/portalRedirect.html",
        data: {pageTitle: 'Siskin'}
      })

      .state('siskin.signout', {
        url: "/signout",
        templateUrl: "app/main/main.signout.html",
        data: {pageTitle: 'nav.signout'}
      })

      .state('siskin.clients', {
        url: "/clients",
        templateUrl: "app/modules/siskin/client/list.html",
        data: {pageTitle: 'nav.clients'}
      })

      .state('siskin.emailtemplates', {
        url: "/emailtemplates",
        templateUrl: "app/modules/siskin/emailtemplate/list.html",
        data: {pageTitle: 'nav.emailtemplates', action:'adminEmailTemplate'}
      })

      .state('siskin.groups', {
        url: "/groups",
        templateUrl: "app/modules/siskin/group/list.html",
        data: {pageTitle: 'nav.groups'}
      })

      .state('siskin.projects', {
        url: routes["siskin.projects"],
        templateUrl: "app/modules/siskin/project/list.html",
        data: {
          pageTitle: 'nav.projects',
          dateFromThisYear: true,
          showDeactivated: false
        }
      })

      .state('siskin.home', {
        url: "/home",
        templateUrl: "app/modules/siskin/home/view.html",
        data: {pageTitle: 'nav.home'}
      })

      .state('siskin.projectlist', {
        url: routes["siskin.projectlist"],
        templateUrl: "app/modules/siskin/project/list.admin.html",
        data: {
          pageTitle: 'nav.projectslist',
          dateFromThisYear: true,
          showDeactivated: true
        }
      })

      .state('siskin.projecttypelist', {
        url: routes["siskin.projecttypelist"],
        templateUrl: "app/modules/siskin/metaDataEntity/list.html",
        data: {
          pageTitle: 'nav.projecttypelist',
          metaDataEntityType: 'ProjectType',
          action: 'metaDataEntitiesEdit'
        }
      })

      .state('siskin.brandlist', {
        url: "/brands",
        templateUrl: "app/modules/siskin/metaDataEntity/list.html",
        data: {
          pageTitle: 'nav.brandlist',
          metaDataEntityType: 'Brand',
          action: 'metaDataEntitiesEdit'
        }
      })

      .state('siskin.reports', {
        url: "/reports",
        templateUrl: "app/modules/siskin/reports/reports.html",
        data: {pageTitle: 'nav.reports'}
      })

      .state('siskin.taskinstance', {
        url: routes["siskin.taskinstance"],
        templateUrl: "app/modules/siskin/taskinstance/detail.html",
        data: {pageTitle: 'nav.task'}
      })

      .state('siskin.taskinstanceinteractive', {
        url: routes["siskin.taskinstanceinteractive"],
        templateUrl: "app/modules/siskin/taskinstance/detail.interactive.html",
        data: {pageTitle: 'nav.task', navbar: false}
      })

      .state('siskin.inbox', {
        url: "/inbox/:query",
        templateUrl: "app/modules/siskin/taskinstance/inbox.html",
        data: {pageTitle: 'nav.inbox', redirectTo: 'siskin.home'}
      })

      .state('siskin.taskinstancesattributes', {
        url: routes["siskin.taskinstancesattributes"],
        templateUrl: "app/modules/siskin/taskinstance/listattributes.html",
        data: {pageTitle: 'nav.taskinstancesattributes'}
      })

      .state('siskin.project', {
        url: routes["siskin.project"],
        templateUrl: "app/modules/siskin/project/detail.html",
        data: {pageTitle: 'nav.project', action:'projectTemplateView'}
      })

      .state('siskin.workflows', {
        url: "/workflows",
        templateUrl: "app/modules/siskin/workflow/list.html",
        data: {pageTitle: 'nav.workflows', action:'workflowsView'}
      })

      .state('siskin.workflowset', {
        url: "/workflow/:workflowEntityId",
        templateUrl: "app/modules/siskin/workflow/detail.html",
        data: {pageTitle: 'nav.workflows', action:'workflowsView'}
      })

      .state('siskin.dashboard', {
        url: "/dashboard?clientId&startDate&endDate&projectTemplateId",
        templateUrl: "app/modules/siskin/clientdashboard/detail.html",
        data: {pageTitle: 'nav.clientdashboard', action:'dashboardView', redirectTo:'siskin.inbox'}
      })

      .state('siskin.projecttasks', {
        url: routes["siskin.projecttasks"],
        templateUrl: "app/modules/siskin/taskinstance/list.html",
        data: {pageTitle: 'nav.taskinstances', action:'tasksProgress'}
      })

      .state('siskin.adminpermissions', {
        url: "/permissions",
        templateUrl: "app/admin.permissions/permissions.html",
        data: {pageTitle: 'nav.admin.permissions', action:'adminPermissionsEdit'}
      })

      .state('siskin.admingroupstore', {
        url: routes["siskin.admingroupstore"],
        templateUrl: "app/admin.groupstore/groupstore.html",
        data: {pageTitle: 'nav.admin.groupstore', action:'adminGroupsStores'}
      })

      .state('siskin.integration', {
        url: "/integration",
        templateUrl: "app/modules/siskin/integration/list.html",
        data: {pageTitle: 'nav.integration', action: 'integrationView'}
      })

      .state('siskin.monitoring', {
        url: "/monitoring",
        templateUrl: "app/modules/siskin/monitoring/home.html",
        data: {pageTitle: 'nav.monitoring', action: 'monitoringView'}
      })

      .state('siskin.documentation', {
        url: "/documentation",
        templateUrl: "app/modules/siskin/documentation/list.html",
        data: {pageTitle: 'nav.documentation', action: 'documentationView'}
      })

      .state('siskin.rollback', {
        url: routes["siskin.rollback"],
        templateUrl: "app/modules/siskin/projectinstance/rollback.html",
        data: { pageTitle: 'nav.rollback', action: 'projectInstanceRollback'}
      })

      .state('siskin.file', {
        url: "/file/:fileId",
        templateUrl: "app/modules/siskin/downloadexternal/downloadexternal.html",
        data: { pageTitle: 'nav.downloading', navbar: false, url: 'file-download'}
      })

      .state('siskin.projectfiles', {
        url: "/projectfiles/:fileId",
        templateUrl: "app/modules/siskin/downloadexternal/downloadexternal.html",
        data: { pageTitle: 'nav.downloading', navbar: false, url: 'file-project-download', showFileName: true }
      })

      .state('siskin.licensing', {
        url: "/licensing",
        templateUrl: "app/modules/siskin/licensing/list.html",
        data: {pageTitle: 'nav.licensing', action: 'licensesView'}
      })

      .state('siskin.administration', {
        url: "/administration",
        templateUrl: "app/modules/siskin/administration/detail.html",
        data: {pageTitle: 'Administration', action: 'administrationView'}
      })
      


    $urlRouterProvider.otherwise('dashboard')
  }
})();


(function () {
angular
    .module('gfApp')
    .config(toastr)
    .config(http)
    .config(debugging)
    .config(vibrate)
    .config(cache)
    .config(other)
    .config(sanitizationWhitelist)
    .config(chartjs)

  function http($httpProvider) {
    $httpProvider.defaults.headers.patch['Content-Type'] = 'application/hal+json'
    $httpProvider.defaults.headers.put['Content-Type'] = 'application/hal+json'
    $httpProvider.defaults.headers.post['Content-Type'] = 'application/hal+json'

    $httpProvider.interceptors.push(function($q,$injector) {
      return {
          'responseError': function(err) {
            if(err.data === 'licenses.expiredlicense'){
              var configService = $injector.get('configService')
              if(err.config.url !== configService.api.app){
                $injector.get('notificationService').error('notification.errorgeneric')
              }
            }
            return $q.reject(err);
          }
      };
    });
  }

  function debugging($compileProvider, $logProvider) {
    if (localStorage.getItem("debug") !== "true") {
      $compileProvider.debugInfoEnabled(false);
      $logProvider.debugEnabled(false)
    }
  }

  function vibrate(vibratorProvider) {
    var sequences = {
      default: 10,
      twice: [15, 75, 10],
      long: 400
    };

    vibratorProvider.setSequences(sequences)
  }

  function cache(CacheFactoryProvider) {
    // Changing this shouldn't be necessary
    angular.extend(CacheFactoryProvider.defaults,
      {
        storageMode: 'sessionStorage',       // Provides a max of ~10MB of storage combined between local and session
        maxAge: 30 * 1000,                   // Items added to this cache expire after 30 seconds minutes
        cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour
        deleteOnExpire: 'aggressive'         // Items will be deleted from this cache when they expire
      });
  }

  function toastr(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      debug: false,
      progressBar: true,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      positionClass: "toast-top-right",
      onclick: null,
      showDuration: "400",
      hideDuration: "1000",
      timeOut: "30000",
      extendedTimeOut: "5000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut"
    });
  }

  function other($ariaProvider) {
    $ariaProvider['config']({
      bindRoleForClick: false
    })
    // Nicer paths, but possibly difficult to work with
    //$locationProvider.html5Mode({
    //    enabled: true
    //})
  }

  function sanitizationWhitelist($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https|http):/);
  }

  function chartjs(ChartJsProvider){
      // Configure all charts
      ChartJsProvider.setOptions({
        chartColors: ['#FF5252', '#FF8A80'],
        responsive: true
      })
  }

})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('gfApp')
  .directive('sideNavigation', function ($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        // Call metsi to build when user signup
        scope.$watch('authentication.user', function () {
          $timeout(function () {
            element.metisMenu();
          });
        });

        // Colapse menu in mobile mode after click on element
        var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
        menuElement.click(function () {
          if (angular.element(window).width() < 769) {
            angular.element("body").toggleClass("mini-navbar");
          }
        });

        // Enable initial fixed sidebar
        if (angular.element("body").hasClass('fixed-sidebar')) {
          var sidebar = element.parent();
          sidebar.slimScroll({
            height: '100%',
            railOpacity: 0.9
          });
        }

      }
    };
  })
  .directive('minimalizaSidebar', function ($timeout) {
    return {
      restrict: 'A',
      template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
      controller: function ($scope) {
        $scope.minimalize = function () {
          angular.element('body').toggleClass('mini-navbar');
          if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
            // Hide menu in order to smoothly turn on when maximize menu
            angular.element('#side-menu').hide();
            // For smoothly turn on menu
            $timeout(function () {
              angular.element('#side-menu').fadeIn(400);
            }, 200);
          } else {
            // Remove all inline style from jquery fadeIn function to reset menu state
            angular.element('#side-menu').removeAttr('style');
          }
        };
      }
    };
  })
  .directive('stopEvent', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        element.bind(attr.stopEvent, function (e) {
          e.stopPropagation();
        });
      }
    }
  })
  .directive('bindHtmlCompile', function ($compile) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch(function () {
          return scope.$eval(attrs.bindHtmlCompile);
        }, function (value) {
          element.html(value);
          $compile(element.contents())(scope);
        });
      }
    };
  });

(function () {
  angular.module('gfApp')
    .directive('onLongPress', function ($parse, $timeout) {
      var me = this;

      return {
        restrict: 'A',
        link: function ($scope, $elm, $attrs) {
          var timer;
          var timerDuration = (!isNaN($attrs.longPressDuration) && parseInt($attrs.longPressDuration)) || 600;
          // By default we prevent long press when user scrolls
          var preventLongPressOnScroll = ($attrs.preventOnscrolling ? $attrs.preventOnscrolling === 'true' : true)
          // Variable used to prevent long press while scrolling
          var touchStartY;
          var touchStartX;
          var MAX_DELTA = 15;
          var DEBOUNCE_MS = 200;
          var debounce = false;
          // Bind touch, mouse and click event
          $elm.bind('touchstart', onEnter);
          $elm.bind('touchend', onExit);

          // If these are enabled, they produce a rouble "onEnter" event, which causes the click handler to
          // trigger in turn. If re-enabling these, you should prevent the "onEnter" handler from firing very
          // quickly following an "onExit" event.
          // $elm.bind('mousedown', onEnter);
          // $elm.bind('mouseup', onExit);

          $elm.bind('click', onClick);

          // For windows mobile browser
          // We're not going to deal with this use case
          // $elm.bind('pointerdown', onEnter);
          // $elm.bind('pointerup', onExit);

          if (preventLongPressOnScroll) {
            // Bind touchmove so that we prevent long press when user is scrolling
            $elm.bind('touchmove', onMove);
          }

          // Prevent context menu (right click and long tap) (Chrome)
          $elm.bind('contextmenu', function () {
            return angular.isUndefined(me.touchMode) || !me.touchMode;
          });

          function onEnter(evt) {
            if (debounce) return;
            var functionHandler = $parse($attrs.onLongPress);
            // For tracking scrolling
            if ((evt.originalEvent || evt).touches) {
              touchStartY = (evt.originalEvent || evt).touches[0].screenY;
              touchStartX = (evt.originalEvent || evt).touches[0].screenX;
            }
            //Cancel existing timer
            $timeout.cancel(timer);
            //To handle click event properly
            $scope.longPressSent = false;
            // We'll set a timeout for 600 ms for a long press
            timer = $timeout(function () {
              $scope.longPressSent = true;
              // If the touchend event hasn't fired,
              // apply the function given in on the element's on-long-press attribute
              debounce = true;
              $timeout(function () {
                debounce = false;
              }, DEBOUNCE_MS)
              $scope.$apply(function () {
                functionHandler($scope, {
                  $event: evt
                });
              });
            }, timerDuration);

          }

          function onExit(evt) {
            var functionHandler = $parse($attrs.onTouchEnd);
            // Prevent the onLongPress event from firing
            $timeout.cancel(timer);
            // If there is an on-touch-end function attached to this element, apply it
            if ($attrs.onTouchEnd) {
              $scope.$apply(function () {
                functionHandler($scope, {
                  $event: evt
                });
              });
            }

          }

          function onClick(evt) {
            //If long press is handled then prevent click
            if ($scope.longPressSent && (!$attrs.preventClick || $attrs.preventClick === "true")) {
              evt.preventDefault();
              evt.stopPropagation();
              evt.stopImmediatePropagation();
            }

          }

          function onMove(evt) {
            var yPosition = (evt.originalEvent || evt).touches[0].screenY;
            var xPosition = (evt.originalEvent || evt).touches[0].screenX;

            // If we scrolled, prevent long presses
            if (angular.isDefined(angular.touchStartY) && angular.isDefined(touchStartX) &&
              (Math.abs(yPosition - touchStartY) > MAX_DELTA) || Math.abs(xPosition - touchStartX) > MAX_DELTA) {
              $timeout.cancel(timer);
            }

          }
        }
      };
    });
})();

angular.module("gfApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/workflows.html","<div ng-controller=\"WorkflowsController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div ng-if=\"!vm.data\">\r\n        <sk-spinner></sk-spinner>\r\n      </div>\r\n\r\n      <div ng-if=\"vm.data\">\r\n        <div class=\"well\">\r\n          <h4>Total : {{ vm.data.total}}</h4>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/admin.groupstore/groupstore.action.update.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>admin.groupuser.updategroupstore</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-2 control-label\" translate>admin.groupuser.group</label>\r\n        <div class=\"col-lg-10 control-text\">{{vmModal.data.groupName}}</div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-2 control-label\" translate>admin.groupuser.stores</label>\r\n        <div class=\"col-lg-10\">\r\n          <dropdown-multiple ng-model=\"vmModal.data.stores\" pager=\"vmModal.storePager\" placeholder=\"admin.permissions.storesplaceholder\"></dropdown-multiple>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.save\r\n    </button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel\r\n    </button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/admin.groupstore/groupstore.html","<div ng-controller=\"GroupStoreController as vm\">\r\n\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content permissionaction\">\r\n    <div class=\"table-responsive\">\r\n    	<table class=\"table table-striped\">\r\n    		<thead>\r\n    			<tr>\r\n    				<th class=\"permission\" translate>admin.groupuser.group</th>\r\n    				<th class=\"groups\" translate>admin.groupuser.stores</th>\r\n    				<th class=\"actions\" translate>admin.groupuser.actions</th>\r\n    			</tr>\r\n    		</thead>\r\n    		<tbody>\r\n    			<tr ng-repeat=\"group in vm.groups\" style=\"min-width: auto; height:auto;\">\r\n    				<td class=\"permission\">{{group.groupName}}</td>\r\n    				<td class=\"groups\">\r\n                        <span ng-repeat=\"store in group.stores\" class=\"label label-primary\">{{store.name}}</span>\r\n                    </td>\r\n    				<td class=\"action\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.editGroupStore($event, group)\" translate>admin.groupuser.edit</button></td>\r\n    			</tr>\r\n    		</tbody>\r\n    	</table>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/admin.impersonate/admin.impersonate.html","<div ng-controller=\"ImpersonateController as impCtrl\" class=\"impersonate\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"ibox float-e-margins\">\r\n      <div class=\"ibox-title flexeverything\" ng-show=\"main.user.impersonator\">\r\n        <h4 translate>nav.admin.impersonate</h4>\r\n      \r\n        <div class=\"flexeverything--spacer\"></div>\r\n        <div class=\"ibox-tools\" ng-if=\"main.user.impersonator\">\r\n          <button class=\"btn btn-outline btn-danger\" ng-click=\"impCtrl.stopImpersonate()\"><i class=\"fa fa-times\"></i>&nbsp;&nbsp;<span class=\"bold\">{{main.user.longName}}\r\n                </span>\r\n          </button>\r\n        </div>\r\n      </div>\r\n\r\n      <!--table-->\r\n      <div class=\"ibox-title flexeverything\">\r\n        <h4 class=\"flex\" translate>nav.admin.impersonate</h4>\r\n        <form role=\"search\" class=\"pull-right\">\r\n          <input type=\"text\" id=\"top-search\" class=\"form-control\" translate-attr=\"{placeholder : \'impersonate.search.placeholder\'}\" ng-change=\"impCtrl.search(searchTerm)\" ng-model=\"searchTerm\" ng-model-options=\"{debounce : 500}\">\r\n        </form>\r\n      </div>\r\n      <div class=\"ibox-content\">\r\n        <table class=\"table table-hover table-clickable table-header-ms-up\">\r\n          <thead>\r\n          <tr>\r\n            <th translate>user.name</th>\r\n            <th class=\"visible-sm-up\" translate>user.email</th>\r\n            <th translate>user.timezone</th>\r\n            <th translate>user.locale</th>\r\n            <th></th>\r\n          </tr>\r\n          </thead>\r\n          <tbody>\r\n          <tr ng-repeat=\"user in impCtrl.users\" ng-click=\"impCtrl.impersonate(user)\">\r\n            <td>\r\n                <span class=\"visible-xs-block\">\r\n                  <p><strong>{{user.longName}}</strong></p>\r\n                  <p>{{user.email}}</p>\r\n                </span>\r\n              <span class=\"visible-sm-up\">\r\n                        {{user.longName}}\r\n                </span>\r\n            </td>\r\n            <td class=\"visible-sm-up\">{{user.email}}</td>\r\n            <td class=\"visible-ms-up\">{{user.timezone}}</td>\r\n            <td class=\"visible-ms-up\">{{user.locale}}</td>\r\n            <td class=\"visible-ms-up table-clickable-hint\">\r\n              <i class=\"fa fa-arrow-circle-right\"></i>\r\n            </td>\r\n          </tr>\r\n          </tbody>\r\n        </table>\r\n\r\n        <div ng-if=\"cCtrl.userMessages == null || cCtrl.userMessages.length <=0\">\r\n          <div class=\"text-center\" translate>impersonate.pleasesearch</div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/admin.permissions/permissions.action.update.html","<div class=\"modal-header\">\r\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n    <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n  </button>\r\n  <h4 class=\"modal-title\" translate>admin.permissions.updatepermission</h4>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n  <form class=\"form-horizontal\">\r\n    <div class=\"form-group\">\r\n      <label class=\"col-lg-4 control-label\" translate>admin.permissions.permission</label>\r\n      <div class=\"col-lg-8\">\r\n        {{vmModal.data.name}}\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label class=\"col-lg-4 control-label\" translate>admin.permissions.groups</label>\r\n      <div class=\"col-lg-8\">\r\n        <dropdown-multiple ng-model=\"vmModal.data.groups\" pager=\"vmModal.groupPager\" placeholder=\"admin.permissions.groupsplaceholder\"></dropdown-multiple>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.save\r\n  </button>\r\n  <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel\r\n  </button>\r\n</div>\r\n\r\n");
$templateCache.put("app/admin.permissions/permissions.html","<div ng-controller=\"PermissionController as vm\">\r\n\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content permissionaction\">\r\n    <div class=\"table-responsive\">\r\n    	<table class=\"table table-striped\">\r\n    		<thead>\r\n    			<tr>\r\n    				<th class=\"permission\" translate>admin.permissions.permissions</th>\r\n    				<th class=\"groups\" translate>admin.permissions.groups</th>\r\n    				<th class=\"actions\" translate>admin.permissions.actions</th>\r\n    			</tr>\r\n    		</thead>\r\n    		<tbody>\r\n        <tr>\r\n          <td>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"vm.search\" translate-attr=\"{\'placeholder\':\'common.searchplaceholder\'}\">\r\n          </td>\r\n          <td colspan=\"2\"></td>\r\n        </tr>\r\n    			<tr ng-repeat=\"permission in vm.permissions | orderBy:\'name\' | filter:{name:vm.search}\" style=\"min-width: auto; height:auto;\">\r\n    				<td class=\"permission\">{{permission.name}}</td>\r\n    				<td class=\"groups\">\r\n                        <span ng-repeat=\"group in permission.groups\" class=\"label label-primary\">{{group.name}}</span>\r\n                    </td>\r\n    				<td class=\"action\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.editPermissionAction($event, permission)\" translate>admin.permissions.edit</button></td>\r\n    			</tr>\r\n    		</tbody>\r\n    	</table>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/admin.translate/admin.translate.directive.html","<div>\r\n  <span class=\"translateadmin__all--highlight\" ng-hide=\"edit\" ng-click=\"showInput()\">\r\n  {{value || \'__\'}}\r\n  </span>\r\n\r\n  <div class=\"input-group\" ng-show=\"edit\">\r\n    <input class=\"form-control\" type=\"text\" ng-model=\"value\" ng-enter=\"doTranslate()\" ng-escape=\"doCancel()\">\r\n        <span class=\"input-group-btn\">\r\n        <button class=\"btn\" ng-click=\"doTranslate()\">Save\r\n        </button>\r\n      </span>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/admin.translate/admin.translate.html","<div ng-controller=\"TranslateController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n        <div class=\"col-lg-12\">\r\n          <div class=\"ibox float-e-margins\" ng-class=\"{ collapsed : vm.isCollapsed}\">\r\n            <div class=\"ibox-title\">\r\n              <h4>In-Context Translations</h4>\r\n              <div class=\"ibox-tools\">\r\n                <a class=\"collapse-link\" ng-click=\"vm.isCollapsed = !vm.isCollapsed\">\r\n                  <i class=\"fa fa-chevron-up\"></i>\r\n                </a>\r\n              </div>\r\n            </div>\r\n            <div class=\"ibox-content\">\r\n              <p>\r\n                You can switch the application to an in-context translation mode at any time by pressing the <strong>Ctrl +\r\n                Alt +\r\n                T</strong>.\r\n                Any translatable\r\n                text will be highlighted.\r\n              </p>\r\n              <p>\r\n                Translations are immediately saved and visible to users when they reload the page. Translations are separate\r\n                between\r\n                environments.\r\n              </p>\r\n              <p>\r\n                To translate another language in-context, first switch the application to that language.\r\n              </p>\r\n\r\n              <div style=\"text-align: center;\">\r\n                <span ng-repeat=\"lang in vm.languages\">\r\n                  <a class=\"btn btn-white\" ng-class=\"{\'active\' : lang.key === vm.activeKey }\" ng-click=\"vm.switch(lang.key)\">\r\n                    <img src=\"{{lang.icon}}\" alt=\"flag\"> {{lang.name}}\r\n                  </a>\r\n                 </span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n\r\n          <div class=\"ibox-title\">\r\n            <h4>All translations</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n\r\n            <div class=\"row m-b-sm filter-panel-xs\">\r\n                <div class=\"col-lg-9\">\r\n                  <input class=\"form-control\" type=\"text\" ng-model=\"vm.filter\" placeholder=\"{{\'common.filterbykeyplaceholder\' | translate}}\" ng-enter=\"vm.filterTranslations()\">\r\n                </div>\r\n\r\n                <div class=\"col-lg-2\">\r\n                  <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.filterTranslations()\" translate>common.filter</button>\r\n                  <button type=\"button\" class=\"btn\" ng-click=\"vm.reset()\" translate>common.reset</button>\r\n                </div>\r\n            </div>\r\n\r\n            <div ng-show=\"vm.translationsLoaded\">\r\n\r\n              <table class=\"table table-striped translateadmin__all ng-cloak\">\r\n                <colgroup><col style=\"width:20%\">\r\n                <col style=\"width:16%\">\r\n                <col style=\"width:16%\">\r\n                <col style=\"width:16%\">\r\n                <col style=\"width:16%\">\r\n                <col style=\"width:16%\">\r\n                <thead>\r\n                <tr>\r\n                  <th>Key</th>\r\n                  <th>English</th>\r\n                  <th>French</th>\r\n                  <th>German</th>\r\n                  <th>Russian</th>\r\n                  <th>Spanish</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                <tr data-ng-repeat=\"key in vm.pager.items\">\r\n                  <td>{{key}}</td>\r\n                  <td admin-translate=\"key\" lang=\"en-GB\"></td>\r\n                  <td admin-translate=\"key\" lang=\"fr-FR\"></td>\r\n                  <td admin-translate=\"key\" lang=\"de-DE\"></td>\r\n                  <td admin-translate=\"key\" lang=\"ru-RU\"></td>\r\n                  <td admin-translate=\"key\" lang=\"es-ES\"></td>\r\n                </tr>\r\n                </tbody>\r\n              </colgroup></table>\r\n            </div>\r\n\r\n            <ul ng-if=\"vm.pager.totalPages > 1\" uib-pagination total-items=\"vm.pager.totalItems\" ng-model=\"vm.pageNumber\" max-size=\"vm.pager.pageSize\" class=\"pagination-sm\" boundary-links=\"true\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"vm.getPage(vm.pageNumber)\">\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/admin.welcomemessage/admin.welcomemessage.html","<div ng-controller=\"WelcomeMessageController as tCtrl\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title\">\r\n            <h4 translate>nav.admin.editwelcomemessage.groups</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n              <input type=\"text\" placeholder=\"{{\'common.searchplaceholder\'|translate}}\" ng-model=\"tCtrl.search\" ng-model-options=\"{ debounce: 1000 }\" class=\"form-control searchbox\">\r\n\r\n              <table class=\"table\" ng-show=\"tCtrl.welcomeMessagesLoaded\">\r\n                <colgroup><col class=\"table--col__40percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <thead>\r\n                <tr>\r\n                  <th>Group</th>\r\n                  <th>English</th>\r\n                  <th>French</th>\r\n                  <th>German</th>\r\n                  <th>Russian</th>\r\n                  <th>Spanish</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                <tr data-ng-repeat=\"msg in tCtrl.welcomeMessages | filter: tCtrl.showMessage | filter: { group:tCtrl.search }\">\r\n                  <td>{{msg.group}}</td>\r\n                  <td ng-repeat=\"lang in tCtrl.languages\">\r\n                    <span>\r\n                      <a class=\"btn btn-white\" ng-class=\"{\'active\' : tCtrl.isMessageActive(msg.group, lang.name) === true }\" ng-click=\"tCtrl.loadEdit(msg.group, lang.name)\">\r\n                        <img ng-src=\"{{lang.icon}}\" alt=\"flag\" ng-class=\"{ greyscale : !tCtrl.hasMessageInLanguage(msg, lang.name)}\">\r\n                      </a>\r\n                    </span>\r\n                  </td>\r\n                </tr>\r\n                </tbody>\r\n              </colgroup></table>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title\">\r\n            <h4 translate>nav.admin.editwelcomemessage</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n              <form name=\"welcomemessageeditform\">\r\n                <div class=\"flexeverything\">\r\n                  <div class=\"flexeverything--spacer\"></div>\r\n                  <button class=\"btn btn-white btn-w-m\" ng-disabled=\"tCtrl.activeMessage.value == null || tCtrl.activeMessage.value == \'\'\" ng-click=\"main.previewWelcomeMessage(tCtrl.activeMessage.value)\" translate>generic.action.preview</button>\r\n                </div>\r\n                <textarea placeholder=\"edit welcome message here\" class=\"htmleditor\" rows=\"20\" ng-disabled=\"tCtrl.activeMessage === null\" ng-model=\"tCtrl.activeMessage.value\"></textarea>\r\n                <div class=\"flexeverything\">\r\n                  <div class=\"flexeverything--spacer\"></div>\r\n                  <div class=\"checkbox\">\r\n                    <label><input type=\"checkbox\" ng-model=\"tCtrl.activeMessage.forced\"><span translate>generic.action.force</span></label>\r\n                  </div>\r\n\r\n                </div>\r\n                <div class=\"flexeverything\">\r\n                  <button class=\"btn btn-w-m btn-danger ladda-button\" ng-disabled=\"tCtrl.canDeleteMessage(tCtrl.activeMessage)\" ng-click=\"tCtrl.deleteMessage()\" title=\"Delete\" data-style=\"expand-right\" ladda=\"tCtrl.isDeletingMessage\" translate>generic.action.delete</button>\r\n                  <div class=\"flexeverything--spacer\"></div>\r\n                  <button class=\"ladda-button btn btn-w-m btn-primary\" ng-click=\"tCtrl.saveMessage()\" ng-disabled=\"!tCtrl.canSaveMessage(tCtrl.activeMessage)|| welcomemessageeditform.$pristine\" title=\"Save\" data-style=\"expand-left\" ladda=\"tCtrl.isSavingMessage\" translate>generic.action.save\r\n                  </button>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/admin.welcomemessage/welcomemessage.html","<!--\r\n     THIS IS NOT THE CORRECT APPROACH TO RE-USING A VIEW\r\n     See how this is done in \"contactInfo\" instead\r\n-->\r\n\r\n<div class=\"welcome-splash\">\r\n	<div class=\"text-center inner\">\r\n    <p ng-bind-html=\"vm.welcomeMessage | trustedHtml\"></p>\r\n		<button class=\"btn btn-w-m btn-primary\" ng-click=\"vm.dismiss()\" translate>generic.action.continuetoapp</button>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/concern/concern.html","<div ng-controller=\"ConcernController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n\r\n  <!-- End Top Nav Bar -->\r\n\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"ibox concern\" id=\"concern-wrapper\">\r\n      <!-- search result -->\r\n      <div class=\"ibox-title flexeverything\">\r\n        <h4 class=\"flex\" translate>concern.concernplural</h4>\r\n        <form role=\"search\" class=\"pull-right\">\r\n              <input type=\"text\" id=\"top-search\" ng-model=\"vm.search.query\" ng-change=\"vm.pager.reset(vm.search)\" ng-model-options=\"{ debounce: 500 }\" class=\"form-control\" translate-attr=\"{placeholder : \'common.searchplaceholder\'}\">\r\n        </form>\r\n      </div>\r\n      <div class=\"ibox-content\">\r\n        <table class=\"table\">\r\n          <thead>\r\n          <tr>\r\n            <th class=\"hidden-xs\" translate>concern.code</th>\r\n            <th translate>concern.name</th>\r\n            <th translate>concern.projects</th>\r\n            <th can-do feature=\"concernType\" translate>concern.concerntype</th>\r\n            <th></th>\r\n          </tr>\r\n          </thead>\r\n          <tbody>\r\n          <tr ng-repeat=\"concern in vm.pager.items\">\r\n            <td class=\"hidden-xs\">\r\n              <span>{{concern.code}}</span>\r\n            </td>\r\n            <td>\r\n              <span class=\"visible-xs\">{{concern.code}}</span>\r\n              <span>{{concern.name}}</span>\r\n            </td>\r\n            <td>\r\n              {{concern.projectInstancesCount}}\r\n              <span translate>common.projectplural</span>\r\n            </td>\r\n            <td can-do feature=\"concernType\">\r\n              {{concern.concernType | ornotset}}\r\n            </td>\r\n            <td class=\"visible-ms-up table-clickable-hint\">\r\n              <div ui-sref=\"siskin.store({storeId:concern.id})\" class=\"btn btn-default btn-small\" translate>common.view\r\n            </div></td>\r\n          </tr>\r\n          </tbody>\r\n        </table>\r\n        <div ng-if=\"!vm.pager.busy && vm.pager.items.length === 0\">\r\n          <div class=\"text-center\" translate>concern.norecord</div>\r\n        </div>\r\n        <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n        <pager ng-model=\"vm.pager\"></pager>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/contactInfo/admin.customercontact.html","\r\n<div ng-controller=\"CustomerContactController as tCtrl\">\r\n\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div ng-include=\"\'app/contactInfo/customercontact.html\'\"></div>\r\n    <div ng-show=\"!tCtrl.show\" class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title\">\r\n            <h4 translate>nav.admin.customercontacts</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n              <input type=\"text\" placeholder=\"Seach here\" ng-model=\"tCtrl.search\" ng-model-options=\"{ debounce: 1000 }\" class=\"form-control searchbox\">\r\n              <table class=\"table\" ng-show=\"tCtrl.customerContactsLoaded\">\r\n                <colgroup><col class=\"table--col__40percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <col class=\"table--col__12percent\">\r\n                <thead>\r\n                <tr>\r\n                  <th>Group</th>\r\n                  <th>English</th>\r\n                  <th>French</th>\r\n                  <th>German</th>\r\n                  <th>Russian</th>\r\n                  <th>Spanish</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                <tr data-ng-repeat=\"cc in tCtrl.customerContacts  | filter: tCtrl.showCustomerContact | filter: { group:tCtrl.search }\">\r\n                  <td>{{cc.group}}</td>\r\n                  <td ng-repeat=\"lang in tCtrl.languages\">\r\n                    <span>\r\n                      <a class=\"btn btn-white\" ng-class=\"{\'active\' : tCtrl.isCustomerContactActive(cc.group, lang.name) === true }\" ng-click=\"tCtrl.loadEdit(cc.group, lang.name)\">\r\n                        <img ng-src=\"{{lang.icon}}\" alt=\"flag\" ng-class=\"{ greyscale : !tCtrl.hasCustomerContactInLanguage(cc, lang.name)}\">\r\n                      </a>\r\n                    </span>\r\n                  </td>\r\n                </tr>\r\n                </tbody>\r\n              </colgroup></table>\r\n            </div>\r\n          </div>\r\n      </div>\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title\">\r\n            <h4 translate>nav.admin.editcustomercontact</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n              <form name=\"customercontacteditform\">\r\n                <div class=\"flexeverything m-b-xs\">\r\n                  <div class=\"flexeverything--spacer\"></div>\r\n                  <button class=\"btn btn-white btn-w-m\" ng-disabled=\"tCtrl.activeCustomerContact.value == null || tCtrl.activeCustomerContact.value == \'\'\" ng-click=\"tCtrl.previewCustomerContact(tCtrl.activeCustomerContact.value)\" translate>generic.action.preview</button>\r\n                </div>\r\n                  <textarea placeholder=\"edit customer contact here\" class=\"htmleditor\" rows=\"20\" ng-disabled=\"tCtrl.activeCustomerContact === null\" ng-model=\"tCtrl.activeCustomerContact.value\"></textarea>\r\n                <div class=\"flexeverything\">\r\n                  <button class=\"btn btn-w-m btn-danger ladda-button\" ng-disabled=\"tCtrl.canDeleteCustomerContact(tCtrl.activeCustomerContact)\" ng-click=\"tCtrl.deleteCustomerContact()\" data-style=\"expand-right\" ladda=\"tCtrl.isDeletingCustomerContact\" translate>generic.action.delete</button>\r\n                  <div class=\"flexeverything--spacer\"></div>\r\n                  <button class=\"ladda-button btn btn-w-m btn-primary\" ng-click=\"tCtrl.saveCustomerContact()\" ng-disabled=\"!tCtrl.canSaveCustomerContact(tCtrl.activeCustomerContact)|| customercontacteditform.$pristine\" data-style=\"expand-left\" ladda=\"tCtrl.isSavingCustomerContact\" translate>generic.action.save\r\n                  </button>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/contactInfo/contactinfo.html","<div ng-controller=\"ContactInfoController as tCtrl\">\r\n\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div ng-include=\"\'app/contactInfo/customercontact.html\'\"></div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/contactInfo/customercontact.html","<div ng-if=\"tCtrl.show\" class=\"ccpreview\">\r\n  <a class=\"btn btn-default pull-right\" ng-if=\"tCtrl.isPreviewMode\" ng-click=\"tCtrl.dismissCustomerContactPreview()\"><i class=\"fa fa-times\"></i>\r\n  </a>\r\n  <div class=\"inner inner__wordbreak\">\r\n    <p ng-bind-html=\"tCtrl.customerContact  | trustedHtml\"></p>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/collapsible.html","<div class=\"collapsible collapsible--collapsed\" ng-class=\"{\'collapsible--collapsed\' : collapsed}\">\r\n  <div class=\"collapsible__heading\">\r\n    <span class=\"collapsible__heading__options--left\">\r\n      <span ng-transclude=\"optionsLeft\"></span>\r\n    </span>\r\n    <span class=\"collapsible__heading__title\" ng-click=\"toggle()\">\r\n      <a>\r\n        <span ng-transclude=\"title\"></span>\r\n      </a>\r\n    </span>\r\n    <span class=\"collapsible__heading__options--right\">\r\n      <span ng-transclude=\"optionsRight\"></span>\r\n    </span>\r\n  </div>\r\n  <div class=\"collapsible__content\">\r\n    <div class=\"collapsible__content__body\" ng-show=\"visibleBody\">\r\n      <ng-transclude></ng-transclude>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/directives/imgRefresher.directive.html","<img ng-src=\"{{vm.src}}\" on-error=\"vm.onError($event)\" class=\"{{vm.class}}\">\r\n");
$templateCache.put("app/directives/maps.directive.html","<div ng-if=\"!vm.data\" style=\"max-height:{{vm.height}}\" class=\"content-center\">\r\n  <strong translate>clientdashboard.nodatatoshow</strong>\r\n</div>\r\n<div id=\"innerMapWidgetDiv\" ng-if=\"vm.data\" map-lazy-load=\"{{vm.googleMapsUrl}}\">\r\n  <map style=\"height:380px;min-height:380px;\" street-view-control=\"false\" map-type-control=\"false\" zoom-control=\"true\" zoom-control-options=\'{position:\"top_left\"}\'>\r\n    <marker title=\"{{m.title}}\" position=\"[{{m.lat}},{{m.lng}}]\" ng-repeat=\"m in vm.data.markers\" on-click=\"vm.select($index)\" icon=\"{{vm.markerUrl}}|{{m.markerColor}}\"></marker>\r\n    <info-window id=\"infowindow\">\r\n        <div bind-html-compile=\"vm.selected.message\"></div>\r\n    </info-window>\r\n  </map>\r\n</div>\r\n");
$templateCache.put("app/directives/optionalItems.directive.html","<div class=\"modal-header\">\r\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"close()\"><span aria-hidden=\"true\">×</span><span class=\"sr-only\">Close</span></button>\r\n  <h4 class=\"modal-title\" translate>optionalitems.optionalitems</h4>\r\n</div>\r\n<div class=\"modal-body optional-items-modal__body\">\r\n  <p><a href=\"{{ url }}\" target=\"_blank\" translate>optionalitems.pleaseclickhere</a></p>\r\n  <iframe src=\"{{ url | trusted}}\"></iframe>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"close()\" translate>generic.action.close</button>\r\n</div>\r\n");
$templateCache.put("app/directives/pager.directive.html","<ul ng-if=\"vm.pager.knownPagesAvailable > 1\" uib-pagination total-items=\"vm.pager.totalItemsCount\" ng-model=\"vm.pager.page\" items-per-page=\"vm.pager.pageSize\" max-size=\"8\" class=\"pagination-sm\" boundary-links=\"true\" boundary-link-numbers=\"true\" rotate=\"false\" first-text=\"&lt;&lt;\" previous-text=\"&lt;\" next-text=\"&gt;\" last-text=\"&gt;&gt;\" ng-change=\"vm.pager.goPage(vm.pager.page)\">\r\n</ul>\r\n");
$templateCache.put("app/directives/presets.directive.html","<div class=\"flexeverything\">\r\n  <dropdown ng-if=\"vm.data\" ng-model=\"vm.selected\" ng-change=\"vm.select(vm.selected)\" allow-clear=\"true\" placeholder=\"common.preset.placeholder\" ng-values=\"vm.data.presets\" tagging=\"true\" refresh-delay=\"0\"></dropdown>\r\n  <button class=\"btn btn-danger btn-sm m-l-xs\" ng-if=\"vm.selected\" ng-click=\"vm.remove(vm.selected)\"><i class=\"fa fa-trash\"></i></button>\r\n  <button class=\"btn btn-primary btn-sm m-l-xs\" ng-if=\"vm.selected\" ng-click=\"vm.update(vm.selected)\"><i class=\"fa fa-floppy-o\"></i></button>\r\n</div>\r\n");
$templateCache.put("app/directives/propertySwitcher.directive.html","<span ng-click=\"vm.next()\" class=\"p-sm\">\r\n  <label class=\"label {{vm.current.class}}\" translate>{{vm.current.key}}</label>\r\n</span>\r\n");
$templateCache.put("app/fileUpload/fileUpload.html","<div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n<div ng-controller=\"fileUploadController as main\">\r\n  <div class=\"row\">\r\n    <div class=\"col-lg-12\">\r\n      Pending Files:\r\n      <ul style=\"list-style-type: none;\">\r\n        <li ng-repeat=\"file in main.files\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"progress progress-mini\">\r\n              <div id=\"progress-{{file.id}}\" class=\"progress-bar\" style=\"width:{{file.percentageComplete}}%\"></div>\r\n            </div>\r\n            <div style=\"margin-top:3px;\">\r\n              <div class=\"col-md-8\">\r\n                <label>{{file.fileName}}</label>\r\n                <label>{{file.percentageComplete}}%</label>\r\n              </div>\r\n              <div class=\"col-md-4\">\r\n                <button class=\"btn btn-primary btn-xs m-r-20\" ng-show=\"file.service.canPause()\" ng-click=\"file.service.pauseUpload()\" ng-touch=\"file.pause()\">Pause\r\n                </button>\r\n                <button class=\"btn btn-primary btn-xs m-r-20\" ng-show=\"file.service.canResume()\" ng-click=\"file.service.resumeUpload()\" ng-touch=\"file.resume()\">Resume\r\n                </button>\r\n                <button class=\"btn btn-primary btn-xs m-r-20\" ng-show=\"file.service.canCancel()\" ng-click=\"file.service.cancelUpload()\" ng-touch=\"file.cancel()\">Cancel\r\n                </button>\r\n                <button class=\"btn btn-primary btn-xs m-r-20\" ng-show=\"file.service.canRetry()\" ng-click=\"file.retry()\" ng-touch=\"file.retry()\">Retry\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/landing/landing.html","<div ng-controller=\"LandingController as landing\">\r\n  <div ng-include=\"\'app/inbox/inboxSearchBar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <!-- This should never be visible -->\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/main/main.signout.html","<div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n\r\n<div class=\"signout\">\r\n  <div class=\"text-center inner inner__wordbreak\">\r\n    <p translate>signout.hintmessage</p>\r\n    <button class=\"btn btn-primary\" ng-click=\"main.logout()\"><i class=\"fa fa-sign-out\"></i> <span class=\"nav-label\" translate>nav.signout</span></button>\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n");
$templateCache.put("app/navigation/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\">\r\n  <div class=\"sidebar-collapse\" ng-controller=\"NavigationController as navCtrl\">\r\n    <div id=\"side-menu\" ng-controller=\"NavigationUnreadCountersController as countersCtrl\">\r\n      <ul ng-if=\"navCtrl.appApi\" side-navigation class=\"nav metismenu\">\r\n\r\n        <li class=\"nav-header\">\r\n          <div class=\"profile-element\" uib-dropdown>\r\n            <a style=\"cursor: default\">\r\n              <span class=\"clear\">\r\n                <i class=\"fa fa-user-circle\" aria-hidden=\"true\" ng-if=\"main.user.impersonator\"></i>\r\n                <strong class=\"font-bold navbar--text\">{{main.user.email}}</strong>\r\n                <!-- <span class=\"text-muted text-xs block navbar--text\" title=\"{{main.user.email}}\">{{main.user.email}}</span> -->\r\n              </span>\r\n            </a>\r\n            <div class=\"logo-element\">\r\n              Siskin\r\n            </div>\r\n          </div>\r\n        </li>\r\n\r\n        <li ng-repeat=\"i in navCtrl.navigation | filter: { id: \'!signout\' }\" can-do=\"{{i.canDo}}\" ng-click=\"navCtrl.doAction(i.action,$event)\" ng-class=\"{active: i.path === $state.current.name}\" title=\"{{i.translationKey | translate}}\">\r\n          <!-- action -->\r\n          <a ng-switch=\"i.id\" ng-if=\"!i.path\">\r\n            <i class=\"{{i.icon}}\"></i>\r\n            <span class=\"nav-label\" translate>{{i.translationKey}}</span>\r\n            <div ng-switch-when=\"supportchat.new\">\r\n                <span class=\"badge badge-danger bubble__count\" ng-if=\"countersCtrl.supportMessageCountForGeneralApplicationUser > 0 && countersCtrl.supportMessageCountForGeneralApplicationUser < 100\">{{countersCtrl.supportMessageCountForGeneralApplicationUser}}</span>\r\n                <span class=\"badge badge-danger bubble__count\" ng-if=\"countersCtrl.supportMessageCountForGeneralApplicationUser > 99\"><i class=\"fa fa-exclamation\"></i></span>\r\n                <span class=\"label label-danger pull-right message__count\" ng-if=\"countersCtrl.supportMessageCountForGeneralApplicationUser > 0 \">{{countersCtrl.supportMessageCountForGeneralApplicationUser}}</span>\r\n            </div>\r\n            <span ng-if=\"i.children.length\" class=\"fa arrow\"></span>\r\n          </a>\r\n          <!-- link/menu -->\r\n          <a ui-sref=\"{{i.path}}\" ng-switch=\"i.id\" ng-if=\"i.path\">\r\n            <i class=\"{{i.icon}}\"></i>\r\n            <span class=\"nav-label\" translate>{{i.translationKey}}</span>\r\n            <div ng-switch-when=\"inbox\" ng-if=\"countersCtrl.newTaskCount\">\r\n              <span class=\"label label-danger pull-right\" ui-sref=\"siskin.inbox({\'query\': \'claimState=new\'})\">{{countersCtrl.newTaskCount}}</span>\r\n            </div>\r\n            <div ng-switch-when=\"supportchat.messages\">\r\n              <span class=\"badge badge-danger bubble__count\" ng-if=\"countersCtrl.supportMessageCountForSupportUser > 0 && countersCtrl.supportMessageCountForSupportUser < 100\">{{countersCtrl.supportMessageCountForSupportUser}}</span>\r\n              <span class=\"badge badge-danger bubble__count\" ng-if=\"countersCtrl.supportMessageCountForSupportUser > 99\"><i class=\"fa fa-exclamation\"></i></span>\r\n              <span class=\"label label-danger pull-right\" ng-if=\"countersCtrl.supportMessageCountForSupportUser > 0\">{{countersCtrl.supportMessageCountForSupportUser}}</span>\r\n            </div>\r\n            <span ng-if=\"i.children.length\" class=\"fa arrow\"></span>\r\n          </a>\r\n\r\n          <ul class=\"nav nav-second-level collapse\" ng-if=\"i.children.length\">\r\n            <li ng-repeat=\"c in i.children\" ui-sref-active=\"active\" title=\"{{c.translationKey | translate}}\" can-do=\"{{c.canDo}}\">\r\n              <a ui-sref=\"{{c.path}}\" ng-if=\"c.path\">\r\n                <i class=\"{{c.icon}}\"></i>\r\n                <span translate>{{c.translationKey}}</span>\r\n              </a>\r\n              <a ng-href=\"{{c.url}}\" target=\"_blank\" ng-if=\"c.url\">\r\n                  <i class=\"{{c.icon}}\"></i>\r\n                  <span translate>{{c.translationKey}}</span>\r\n                </a>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n\r\n        <li class=\"flexeverything--spacer\"></li>\r\n        <li ng-repeat=\"i in navCtrl.navigation | filter: { id: \'signout\' }\" ng-class=\"{active: i.path === $state.current.name}\" title=\"{{i.translationKey | translate}}\">\r\n          <a ui-sref=\"{{i.path}}\">\r\n            <i class=\"{{i.icon}}\"></i>\r\n            <span class=\"nav-label\" translate>{{i.translationKey}}</span>\r\n          </a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</nav>\r\n");
$templateCache.put("app/portalRedirect/portalRedirect.html","<div class=\"login\" ng-controller=\"PortalRedirectController as PortalRedirect\">\r\n    <div>\r\n      <sk-spinner></sk-spinner>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/supportmessages/supportmessages.result.html","<table class=\"table table-hover table-clickable table-header-ms-up\">\r\n  <thead>\r\n  <tr>\r\n    <th translate>supportuser.requestedby</th>\r\n    <th class=\"visible-sm-up\" translate>supportuser.lastmessagedetails</th>\r\n    <th translate>supportuser.senton</th>\r\n    <th></th>\r\n  </tr>\r\n  </thead>\r\n  <tbody>\r\n  <tr ng-repeat=\"userMessage in cCtrl.userMessages | orderBy:[\'responded\',\'-lastMessageSentOn\']\" ng-click=\"cCtrl.openSupportChatWindow(userMessage)\">\r\n    <td class=\"visible-xs-block\">\r\n      <p>{{userMessage.userName}}</p>\r\n      <p class=\"usermessage__body\">{{userMessage.preview}}</p>\r\n    </td>\r\n    <td class=\"visible-sm-up\">{{userMessage.userName}}</td>\r\n    <td class=\"visible-sm-up\">\r\n      <span class=\"usermessage__body\">{{userMessage.preview}}</span>\r\n    </td>\r\n    <td class=\"visible-ms-up\">{{ userMessage.lastMessageSentOn | dateTimeFromUtc}}</td>\r\n    <td>\r\n      <label class=\"label label-danger\" ng-if=\"!userMessage.responded\">\r\n        <i class=\"fa fa-warning\"></i>\r\n        {{\'supportuser.pendingresponse\'|translate}}\r\n      </label>\r\n    </td>\r\n  </tr>\r\n  </tbody>\r\n</table>\r\n\r\n<div ng-if=\"cCtrl.userMessages == null || cCtrl.userMessages.length <=0\">\r\n  <div class=\"text-center\" translate>supportuser.norecord</div>\r\n</div>\r\n\r\n\r\n\r\n");
$templateCache.put("app/supportmessages/supportteam.message.html","<div ng-controller=\"SupportTeamController as cCtrl\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"ibox supportmessages\">\r\n      <div class=\"ibox-title flexeverything\" ng-show=\"!cCtrl.detailViewOn\">\r\n        <h4 class=\"supportmessages__search__header flex\">\r\n          <span translate>supportuser.messages</span>\r\n          ({{cCtrl.userMessages.length}})</h4>\r\n          <form role=\"search\" class=\"pull-right\">\r\n              <input type=\"text\" id=\"top-search\" ng-model=\"cCtrl.searchText\" ng-change=\"cCtrl.getGeneralApplicationUserMessagesBySearch()\" ng-model-options=\"{ debounce: 500 }\" class=\"form-control\" focus-if=\"cCtrl.searchOn\" reset-field translate-attr=\"{placeholder : \'supportuser.searchplaceholder\'}\">\r\n          </form>\r\n      </div>\r\n      <div class=\"ibox-content\" ng-hide=\"cCtrl.detailViewOn\">\r\n        <support-messages-result></support-messages-result>\r\n        <sk-spinner ng-show=\"cCtrl.busy\"></sk-spinner>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/components/common/content.html","<div id=\"login-splash\" ng-hide=\"main.isLoggedIn\" ng-include=\"\'app/components/common/login.html\'\"></div>\r\n<div id=\"welcome-message\" ng-hide=\"!main.showWelcomeMessage\" welcome-message=\"main\"> </div>\r\n<!-- Wrapper-->\r\n<div ng-hide=\"main.showWelcomeMessage\" ng-if=\"main.isLoggedIn\" vid=\"wrapper\">\r\n\r\n  <!-- Navigation -->\r\n  <div ng-include=\"\'app/navigation/navigation.html\'\"></div>\r\n\r\n  <!-- Page wraper -->\r\n  <!-- ng-class with current state name give you the ability to extended customization your view -->\r\n  <div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\" ng-class=\"{\'external-view\':main.isExternalUser}\">\r\n\r\n    <!-- Page wrapper -->\r\n    <!-- <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div> -->\r\n\r\n    <!-- Main view  -->\r\n    <div ui-view></div>\r\n\r\n  </div>\r\n  <!-- End page wrapper-->\r\n</div>\r\n<!-- End wrapper-->\r\n\r\n<div id=\"blueimp-gallery\" class=\"blueimp-gallery blueimp-gallery-controls\">\r\n  <div class=\"slides\"></div>\r\n  <h3 class=\"title\"></h3>\r\n  <a class=\"prev\">‹</a>\r\n  <a class=\"next\">›</a>\r\n  <a class=\"rotate-control\"></a>\r\n  <a class=\"close\">×</a>\r\n  <a class=\"play-pause\"></a>\r\n  <ol class=\"indicator\"></ol>\r\n</div>\r\n");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown>\r\n  <a ng-click=\"showhide()\"> <i class=\"fa fa-chevron-up\"></i></a>\r\n  <a uib-dropdown-toggle=\"\" href>\r\n    <i class=\"fa fa-wrench\"></i>\r\n  </a>\r\n  <ul uib-dropdown-menu>\r\n    <li><a href>Config option 1</a>\r\n    </li>\r\n    <li><a href>Config option 2</a>\r\n    </li>\r\n  </ul>\r\n  <a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a>\r\n</div>\r\n");
$templateCache.put("app/components/common/login.html","<div class=\"login\">\r\n\r\n  <div class=\"btn\" ng-if=\"main.isLoginError\">\r\n    <h1>\r\n      <a ng-click=\"main.reloadWindow()\">\r\n        <i class=\"fa fa-ban\"></i>\r\n      </a>\r\n    </h1>\r\n    <br>\r\n    <p class=\"text-danger\" ng-if=\"main.initalizeError\">\r\n      {{main.initalizeError | translate}}\r\n    </p>\r\n  </div>\r\n  <div ng-if=\"!main.isLoginError\">\r\n    <sk-spinner></sk-spinner>\r\n  </div>\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\">\r\n  <nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\">\r\n    <div class=\"navbar-header\">\r\n      <span minimaliza-sidebar></span>\r\n      <div class=\"autosearch\" ng-if=\"vm.autosearch\">\r\n        <div class=\"form-group\">\r\n          <input ng-model=\"vm.search.query\" translate-attr=\"{placeholder: \'common.searchplaceholder\'}\" ng-change=\"vm.reset()\">\r\n        </div>\r\n      </div>\r\n      <div class=\"logo flexeverything\">\r\n        <div class=\"flexeverything--spacer\"></div>\r\n        <img ng-src=\"{{main.logoUrl}}\" ng-if=\"!vm.autosearch\">\r\n      </div>\r\n    </div>\r\n  </nav>\r\n</div>\r\n");
$templateCache.put("app/components/common/topnavbarbasic.html","<div class=\"row border-bottom\">\r\n  <nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\">\r\n    <div class=\"navbar-header\">\r\n      <span minimaliza-sidebar></span>\r\n      <div class=\"logo\">\r\n        <img src=\"{{main.logoUrl}}\">  \r\n      </div>\r\n    </div>\r\n  </nav>\r\n</div>\r\n");
$templateCache.put("app/directives/fields/boolean.html","<div class=\"fieldBoolean form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- readonly -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <div class=\"btn-group btn-group\" role=\"group\">\r\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-success\' : vm.field.value === false, \'btn-default\' : vm.field.value !== false}\" translate disabled=\"disabled\">common.no</button>\r\n      <button type=\"button\" class=\"btn\" ng-class=\"{\'btn-success\' : vm.field.value === true, \'btn-default\' : vm.field.value !== true}\" translate disabled=\"disabled\">common.yes</button>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <div class=\"btn-group btn-group\" role=\"group\">\r\n      <button type=\"button\" class=\"btn\" ng-click=\"vm.setValue(false)\" ng-class=\"{\'btn-success\' : vm.field.value === false, \'btn-default\' : vm.field.value !== false}\" translate>common.no</button>\r\n      <button type=\"button\" class=\"btn\" ng-click=\"vm.setValue(true)\" ng-class=\"{\'btn-success\' : vm.field.value === true, \'btn-default\' : vm.field.value !== true}\" translate>common.yes</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/fields/confirmation.html","<div class=\"fieldConfirmation form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- readonly -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <button type=\"button\" class=\"btn btn-default\" disabled=\"disabled\">\r\n      <i class=\"fa\" ng-class=\"{\'fa-check-square-o\' : vm.field.value === true, \'fa-square-o\' : vm.field.value === false}\"></i>\r\n    </button>\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <button type=\"button\" class=\"btn\" ng-click=\"vm.toggle()\" ng-class=\"{\'btn-success\' : vm.field.value === true, \'btn-default\' : vm.field.value === false}\">\r\n      <i class=\"fa\" ng-class=\"{\'fa-check-square-o\' : vm.field.value === true, \'fa-square-o\' : vm.field.value === false}\"></i>\r\n    </button>\r\n  </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/directives/fields/date.html","<div class=\"fieldDate form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- read -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <input type=\"text\" class=\"form-control\" value=\"{{ vm.field.value | dateFromUtc }}\" readonly=\"readonly\">\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <datepicker ng-model=\"vm.field.value\" ng-change=\"vm.setValue\"></datepicker>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/fields/datetime.html","<div class=\"fieldDateTime form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- read -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <input type=\"text\" class=\"form-control\" value=\"{{ vm.field.value | dateTimeFromUtc }}\" readonly=\"readonly\">\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <datepicker ng-model=\"vm.field.value\" include-time=\"true\" ng-change=\"vm.setValue\"></datepicker>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/fields/double.html","<div class=\"fieldDouble form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- readonly -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <span class=\"form-control\">{{vm.field.value| number:vm.decimalsLength}}</span>\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <input class=\"form-control\" ng-model=\"vm.field.value\" numeric decimals=\"{{vm.decimalsLength}}\" placeholder=\"Type number here ...\" ng-change=\"vm.setValue(vm.field.value)\" ng-model-options=\"{updateOn: \'blur\'}\" scroll>\r\n  </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/directives/fields/dropdown.html","<div class=\"fieldDropdown form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!--single dropdown-->\r\n  <ui-select translate-attr=\"{placeholder : \'attribute.dropdown.placeholder\'}\" ng-model=\"vm.field.value.selectedValues[0]\" ng-if=\"!vm.field.value.multiple\" ng-disabled=\"vm.field.readonly\" on-select=\"vm.setValue($item, $model)\" uis-open-close=\"vm.onOpenClose(isOpen)\">\r\n   	<ui-select-match allow-clear=\"true\" placeholder=\"{{\'attribute.dropdown.placeholder\'|translate}}\">{{$select.selected}}</ui-select-match>\r\n  	<ui-select-choices repeat=\"value in vm.field.value.availableValues | filter: $select.search\">\r\n      {{value}}\r\n    </ui-select-choices>\r\n  </ui-select>\r\n\r\n  <!--multiple dropdown-->\r\n  <ui-select translate-attr=\"{placeholder : \'attribute.dropdown.multiple.placeholder\'}\" ng-if=\"vm.field.value.multiple\" ng-model=\"vm.field.value.selectedValues\" ng-disabled=\"vm.field.readonly\" on-select=\"vm.setValue($item, $model)\" on-remove=\"vm.setValue($item, $model)\" multiple=\"multiple\" uis-open-close=\"vm.onOpenClose(isOpen)\">\r\n   	<ui-select-match allow-clear=\"true\" placeholder=\"{{\'attribute.dropdown.multiple.placeholder\'|translate}}\">{{$item}}</ui-select-match>\r\n  	<ui-select-choices repeat=\"value in vm.field.value.availableValues | filter: $select.search\">\r\n      {{value}}\r\n    </ui-select-choices>\r\n  </ui-select>\r\n</div>\r\n");
$templateCache.put("app/directives/fields/fieldValue.html","<div ng-switch=\"vm.field.type\">\r\n  <!--user-->\r\n  <div ng-switch-when=\"user\">\r\n    <p ng-if=\"vm.readOnly\">{{vm.field.value.selectedUser.longName}}</p>\r\n    <dropdown ng-if=\"!vm.readOnly\" pager=\"vm.pager\" ng-model=\"vm.field.value\" prop=\"id\"></dropdown>\r\n  </div>\r\n\r\n  <!--group-->\r\n  <div ng-switch-when=\"group\">\r\n    <p ng-if=\"vm.readOnly\">{{vm.field.value.selected.name | ornotset}}</p>\r\n    <dropdown ng-if=\"!vm.readOnly\" pager=\"vm.pager\" ng-model=\"vm.field.value\" prop=\"id\"></dropdown>\r\n  </div>\r\n\r\n  <!--dropdown-->\r\n  <div ng-switch-when=\"dropdown\">\r\n    <p ng-if=\"vm.readOnly && vm.field.value.selectedValues.length\">\r\n      <span ng-repeat=\"o in vm.field.value.selectedValues\"> {{o}} {{ !$last ? \', \' : \'\' }}</span>\r\n    </p>\r\n    <p ng-if=\"vm.readOnly && !vm.field.value.selectedValues.length\" translate>common.notset</p>\r\n    <div ng-if=\"!vm.readOnly\">\r\n      <dropdown ng-if=\"!vm.field.isMultiple\" ng-values=\"vm.field.availableValues\" ng-model=\"vm.field.value\"></dropdown>\r\n      <dropdown-multiple ng-if=\"vm.field.isMultiple\" ng-values=\"vm.field.availableValues\" ng-model=\"vm.field.value\"></dropdown-multiple>\r\n    </div>\r\n  </div>\r\n\r\n  <!--files-->\r\n  <div ng-switch-when=\"files\">\r\n    <div ng-if=\"vm.readOnly\">\r\n      <img ng-repeat=\"f in vm.field.content | filter:{isUploaded:true}\" src=\"{{f.url}}\" style=\"max-width: 300px; max-height: 300px\">\r\n    </div>\r\n    <input ng-if=\"!vm.readOnly\" type=\"text\" ng-model=\"vm.field.value\">\r\n  </div>\r\n\r\n  <!--date-->\r\n  <div ng-switch-when=\"date\">\r\n    <p ng-if=\"vm.readOnly\">{{(vm.field.value  | dateFromUtc) | ornotset }}</p>\r\n    <div ng-if=\"!vm.readOnly\">\r\n      <datepicker ng-model=\"vm.field.dateValue\"></datepicker>\r\n    </div>\r\n  </div>\r\n\r\n  <!--datetime-->\r\n  <div ng-switch-when=\"datetime\">\r\n    <p ng-if=\"vm.readOnly\">{{(vm.field.value | dateTimeFromUtc) | ornotset}}</p>\r\n    <div ng-if=\"!vm.readOnly\">\r\n      <datepicker ng-model=\"vm.field.dateValue\" include-time=\"true\"></datepicker>\r\n    </div>\r\n  </div>\r\n\r\n  <!--boolean-->\r\n  <div ng-switch-when=\"boolean\">\r\n    <div ng-if=\"vm.readOnly\">\r\n      <p ng-if=\"vm.field.value == true\" translate>common.yes</p>\r\n      <p ng-if=\"vm.field.value == false\" translate>common.no</p>\r\n      <p ng-if=\"vm.field.value == null\" translate>common.notset</p>\r\n    </div>\r\n    <div ng-if=\"!vm.readOnly\">\r\n        <div class=\"btn-group btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn\" ng-click=\"vm.setValue(false)\" ng-class=\"{\'btn-success\' : vm.field.value === false, \'btn-default\' : vm.field.value !== false}\" translate>common.no</button>\r\n            <button type=\"button\" class=\"btn\" ng-click=\"vm.setValue(true)\" ng-class=\"{\'btn-success\' : vm.field.value === true, \'btn-default\' : vm.field.value !== true}\" translate>common.yes</button>\r\n        </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!--confirmation-->\r\n  <div ng-switch-when=\"confirmation\">\r\n    <div ng-if=\"vm.readOnly\">\r\n      <p ng-if=\"vm.field.value == true\" translate>common.yes</p>\r\n      <p ng-if=\"vm.field.value == false\" translate>common.no</p>\r\n      <p ng-if=\"vm.field.value == null\" translate>common.notset</p>\r\n    </div>\r\n    <div ng-if=\"!vm.readOnly\">\r\n        <button type=\"button\" class=\"btn\" ng-click=\"vm.field.value = !vm.field.value\" ng-class=\"{\'btn-success\' : vm.field.value === true, \'btn-default\' : !vm.field.value}\">\r\n          <i class=\"fa\" ng-class=\"{\'fa-check-square-o\' : vm.field.value === true, \'fa-square-o\' : !vm.field.value}\"></i>\r\n        </button>\r\n      </div>\r\n  </div>\r\n\r\n  <!--string-->\r\n  <div ng-switch-when=\"string\">\r\n    <div ng-if=\"vm.readOnly\">\r\n      <p>{{vm.field.value | ornotset}}</p>\r\n    </div>\r\n    <div ng-if=\"!vm.readOnly\">\r\n        <input ng-if=\"!vm.field.field.isMultiLine\" type=\"text\" class=\"form-control\" ng-model=\"vm.field.value\">\r\n        <textarea ng-if=\"vm.field.field.isMultiLine\" class=\"form-control\" ng-model=\"vm.field.value\" rows=\"5\"></textarea>\r\n    </div>\r\n  </div>\r\n\r\n  <!--integer-->\r\n  <div ng-switch-when=\"integer\">\r\n    <p ng-if=\"vm.readOnly\">{{vm.field.value | ornotset}}</p>\r\n    <input ng-if=\"!vm.readOnly\" class=\"form-control\" ng-model=\"vm.field.value\" numeric decimals=\"0\">\r\n  </div>\r\n\r\n  <!-- double -->\r\n  <div ng-switch-when=\"double\">\r\n    <p ng-if=\"vm.readOnly\">{{(vm.field.value | number: vm.decimalsLength) | ornotset}}</p>\r\n    <input ng-if=\"!vm.readOnly\" class=\"form-control\" ng-model=\"vm.field.value\" numeric>\r\n  </div>\r\n\r\n  <!-- multiple file -->\r\n  <div ng-switch-when=\"multiplefile\" ng-if=\"vm.field.fileCollection\">\r\n      <fileupload container=\"vm.field.fileCollection.resource\" container-id=\"vm.field.fileCollection.id\" update-file-callback=\"vm.field.fileCollection.addOrUpdateFile\" start-callback=\"vm.field.fileCollection.init\" callback-start-process=\"vm.field.fileCollection.startProcess\" callback-end-process=\"vm.field.fileCollection.endProcess\">\r\n        <div class=\"panel panel-default\">\r\n          <div class=\"panel-heading p-n text-right\">\r\n              <label class=\"label-fileupload m-b-none m-l-xs\" for=\"{{ vm.field.fileCollection.id }}\" ng-show=\"!vm.field.fileCollection.anyFileSelected()\">\r\n                  <div class=\"btn btn-info btn-fileupload btn-fileupload--start\"><i class=\"fa fa-cloud-upload\"></i></div>\r\n              </label>\r\n              <a class=\"btn btn-danger m-l-xs\" ng-click=\"vm.field.fileCollection.removeSelected()\" ng-show=\"vm.field.fileCollection.anyFileSelected()\"><i class=\"fa fa-trash\"></i></a>\r\n          </div>\r\n          <div class=\"panel-body\" ng-if=\"!vm.field.fileCollection.isBusy\">\r\n              <filelist selectable list=\"vm.field.fileCollection.files\"></filelist>\r\n              <span class=\"text-center\" ng-if=\"!vm.field.fileCollection.files.length\" translate>common.nofiles</span>\r\n          </div>\r\n        </div>\r\n      </fileupload>\r\n  </div>\r\n\r\n  <!-- generic -->\r\n  <div ng-switch-default>\r\n    <p ng-if=\"vm.readOnly\">{{vm.field.value | ornotset}}</p>\r\n    <input ng-if=\"!vm.readOnly\" type=\"text\" class=\"form-control\" ng-model=\"vm.field.value\">\r\n  </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/directives/fields/files.html","<div class=\"fieldFiles\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!--readonly-->\r\n  <collapsible visible-body=\"vm.totalFiles() > 0\" ng-if=\"vm.field.readonly\" expanded=\"true\">\r\n    <collapsible-title name=\"title\">\r\n        {{ vm.totalFiles() }} <span translate>datavalues.files.files</span>\r\n    </collapsible-title>\r\n    <collapsible-options-right>\r\n      <a class=\"btn btn-success collapsible__options__viewMode\" ng-click=\"vm.toggleViewMode()\" ng-show=\"vm.totalFiles() > 0\">\r\n        <i class=\"fa\" ng-class=\"{\'fa-th-large\': !vm.galleryViewMode, \'fa-th-list\' : vm.galleryViewMode}\"></i>\r\n      </a>\r\n    </collapsible-options-right>\r\n    <filelist disable-ordering=\"true\" list=\"vm.field.content\" ng-if=\"!vm.galleryViewMode\" can-approve=\"vm.field.fileApprove\"></filelist>\r\n    <gallery disable-ordering=\"true\" disable-rotating=\"true\" list=\"vm.field.content\" can-approve=\"vm.field.fileApprove\" ng-if=\"vm.galleryViewMode\" parent=\"vm.parent\"></gallery>\r\n  </collapsible>\r\n\r\n  <!--write-->\r\n  <fileupload container=\"vm.field.field\" container-id=\"vm.field.id\" all-completed-callback=\"vm.allCompletedCallback\" update-file-callback=\"vm.addOrUpdateFile\" start-callback=\"vm.startUpload\" constraint=\"vm.constraint\" ng-if=\"!vm.field.readonly\" callback-start-process=\"vm.startProcess\" callback-end-process=\"vm.endProcess\">\r\n    <collapsible visible-body=\"vm.totalFiles() > 0\" expand=\"{{ vm.totalFilesUploaded > 0 || vm.totalFilesDeleted > 0 || vm.maxFilesReached}}\" expanded=\"true\">\r\n      <collapsible-options-left>\r\n        <a class=\"btn btn-fileupload btn-fileupload-danger btn-danger\" ng-click=\"vm.removeSelected()\" ng-show=\"vm.anyFileSelected()\">\r\n          <i class=\"fa fa-trash\"></i>\r\n        </a>\r\n        <a class=\"btn btn-primary m-l-xs\" ng-click=\"vm.rotateSelectedImages()\" ng-show=\"vm.anyFileSelected() && vm.allSelectedAreImages()\">\r\n          <i class=\"fa fa-repeat\"></i>\r\n        </a>\r\n      </collapsible-options-left>\r\n      <collapsible-title name=\"title\">\r\n        <span ng-if=\"vm.totalFilesUploaded > 0\">\r\n          {{ vm.totalFilesUploaded }} <span translate>datavalues.files.filesuploaded</span>\r\n        </span>\r\n        <span ng-if=\"vm.totalFilesDeleted > 0\">\r\n          {{ vm.totalFilesDeleted }} <span translate>datavalues.files.filesdeleted</span>\r\n        </span>\r\n        <span class=\"label label-danger fileuploader__maxfiles\" ng-if=\"vm.maxFilesReached\">\r\n          <strong translate>datavalues.files.maxfiles</strong> ({{vm.field.field.maxFiles}})\r\n        </span>\r\n        <span ng-if=\"!vm.totalFilesUploaded && !vm.totalFilesDeleted && !vm.maxFilesReached\">\r\n          {{ vm.totalFiles() }} <span translate>datavalues.files.files</span>\r\n        </span>\r\n      </collapsible-title>\r\n      <collapsible-options-right>\r\n        <label for=\"{{ vm.field.field.id }}\">\r\n          <button class=\"btn btn-fileupload btn-success\">\r\n            <i class=\"fa fa-cloud-upload\"></i>\r\n          </button>\r\n        </label>\r\n        <button class=\"btn btn-fileupload btn-success collapsible__options__viewMode\" ng-click=\"vm.toggleViewMode()\" ng-show=\"vm.totalFiles() > 0\">\r\n          <i class=\"fa\" ng-class=\"{\'fa-th-large\': !vm.galleryViewMode, \'fa-th-list\' : vm.galleryViewMode}\"></i>\r\n        </button>\r\n      </collapsible-options-right>\r\n      <filelist selectable list=\"vm.field.content\" ng-if=\"!vm.galleryViewMode\" can-approve=\"vm.field.fileApprove\" approve=\"vm.approve\"></filelist>\r\n      <gallery selectable list=\"vm.field.content\" ng-if=\"vm.galleryViewMode\" can-approve=\"vm.field.fileApprove\" approve=\"vm.approve\" parent=\"vm.parent\"></gallery>\r\n    </collapsible>\r\n  </fileupload>\r\n</div>\r\n\r\n");
$templateCache.put("app/directives/fields/files.simple.html","<div class=\"fieldFiles fieldFiles--simple\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!--readonly-->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <!--placeholder-->\r\n    <div class=\"gallery simple\" ng-if=\"vm.placeholder\">\r\n      <div class=\"gallery__repeat\" ng-if=\"vm.placeholder && !vm.field.content.length\">\r\n        <div class=\"gallery__item\">\r\n          <div class=\"gallery__item__link\">\r\n            <img ng-src=\"{{ \'placeholders/image.jpg\' | asset}}\" ng-if=\"!vm.autoRefresh && !item.thumbnail\" class=\"gallery__item__image--image\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <gallery disable-ordering=\"true\" disable-rotating=\"true\" list=\"vm.field.content\" can-approve=\"vm.field.fileApprove\" parent=\"vm.parent\"></gallery>\r\n  </div>\r\n  <!--write-->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <fileupload container=\"vm.field.field\" container-id=\"vm.field.id\" all-completed-callback=\"vm.allCompletedCallback\" update-file-callback=\"vm.addOrUpdateFile\" start-callback=\"vm.startUpload\" constraint=\"vm.constraint\" callback-start-process=\"vm.startProcess\" callback-end-process=\"vm.endProcess\">\r\n\r\n      <span class=\"label label-danger fileuploader__maxfiles\" ng-if=\"vm.maxFilesReached\">\r\n          <strong translate>datavalues.files.maxfiles</strong> ({{vm.field.field.maxFiles}})\r\n    </span>\r\n\r\n      <gallery selectable list=\"vm.field.content\" parent=\"vm.parent\" can-approve=\"vm.field.fileApprove\" approve=\"vm.approve\" class=\"simple\"></gallery>\r\n      <label class=\"label-fileupload\" for=\"{{vm.field.id}}\" ng-show=\"!vm.anyFileSelected()\">\r\n        <!--placeholder-->\r\n        <div class=\"gallery simple\" ng-if=\"vm.placeholder\">\r\n          <div class=\"gallery__repeat\" ng-if=\"vm.placeholder && !(vm.field.content | filter:{isUploaded:true}).length\">\r\n            <div class=\"gallery__item\">\r\n              <div class=\"gallery__item__link\">\r\n                <img ng-src=\"{{ \'placeholders/image.jpg\' | asset}}\" ng-if=\"!vm.autoRefresh && !item.thumbnail\" class=\"gallery__item__image--image\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"btn btn-info btn-fileupload btn-fileupload--start\">\r\n          <i class=\"fa fa-cloud-upload\"></i>\r\n        </div>\r\n      </label>\r\n      <a class=\"btn btn-fileupload btn-fileupload-danger btn-danger btn-fileupload--delete\" ng-click=\"vm.removeSelected()\" ng-show=\"vm.anyFileSelected()\">\r\n        <i class=\"fa fa-trash\"></i>\r\n      </a>\r\n    </fileupload>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/directives/fields/group.html","<div class=\"fieldGroup form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.hasError()\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n\r\n  <!-- readonly -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.field.value.selected.name\" disabled=\"disabled\">\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <dropdown ng-if=\"!vm.field.readonly\" ng-disabled=\"vm.field.readonly\" ng-model=\"vm.field.value.selected\" pager=\"vm.pager\" ng-change=\"vm.setValue()\" placeholder=\"attribute.group.placeholder\"></dropdown>\r\n  </div>\r\n");
$templateCache.put("app/directives/fields/integer.html","<div class=\"fieldInteger form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- readonly -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <input class=\"form-control\" ng-model=\"vm.field.value\" disabled=\"disabled\">\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <input class=\"form-control\" ng-model=\"vm.field.value\" numeric decimals=\"0\" placeholder=\"Type number here ...\" ng-change=\"vm.setValue(vm.field.value)\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" scroll>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/fields/link.html","<div class=\"fieldLink form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.hasError()\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- readonly -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <div class=\"form-control\">\r\n        <a href=\"{{vm.field.value}}\" class=\"fake-link\" title=\"{{vm.field.field.description}}\" target=\"{{vm.field.field.openInNewTab ? \'_blank\' : \'\'}}\">{{vm.field.field.displayText || vm.field.value}}</a>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <input type=\"text\" class=\"form-control\" ng-change=\"vm.setValue(vm.field.value)\" ng-model=\"vm.field.value\" title=\"{{vm.field.field.description}}\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" scroll>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/fields/string.html","<div class=\"fieldString form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- readonly -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <p ng-if=\"!vm.field.field.isMultiLine\" type=\"text\" class=\"form-control\">{{vm.field.value}}</p>\r\n    <pre ng-if=\"vm.field.field.isMultiLine\" class=\"form-control string-attribute-multiline\">{{ vm.field.value }}</pre>\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <!--<input type=\"text\" class=\"form-control\" ng-model=\"field.value\" placeholder=\"Type here ...\" scroll />-->\r\n    <input ng-if=\"!vm.field.field.isMultiLine\" type=\"text\" class=\"form-control\" ng-change=\"vm.setValue(vm.field.value)\" ng-model=\"vm.field.value\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" scroll>\r\n    <textarea ng-if=\"vm.field.field.isMultiLine\" class=\"form-control\" ng-change=\"vm.setValue(vm.field.value)\" ng-model=\"vm.field.value\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" rows=\"5\">\r\n    </textarea>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/fields/user.html","<div class=\"fieldUser form-group\" ng-class=\"{\'has-error\' : vm.hasError() }\">\r\n  <div ng-if=\"vm.context == \'inbox\'\">\r\n    <label translate>{{vm.field.name}}</label>\r\n    <span ng-if=\"vm.field.hasRequiredError\" class=\"label label-danger pull-right\" translate>task.fields.required</span>\r\n  </div>\r\n  <!-- readonly -->\r\n  <div ng-if=\"vm.field.readonly\">\r\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.field.value.selectedUser.longName\" disabled=\"disabled\">\r\n  </div>\r\n\r\n  <!-- write -->\r\n  <div ng-if=\"!vm.field.readonly\">\r\n    <ui-select translate-attr=\"{placeholder : \'attribute.user.placeholder\'}\" ng-model=\"vm.field.value.selectedUser\" ng-disabled=\"vm.field.readonly\" on-select=\"vm.setValue($item, $model)\" uis-open-close=\"onOpenClose(isOpen)\" reset-search-input=\"true\">\r\n      <ui-select-match allow-clear=\"true\" placeholder=\"{{\'attribute.user.placeholder\'|translate}}\">\r\n        {{$select.selected.longName}}\r\n      </ui-select-match>\r\n      <ui-select-choices repeat=\"value in vm.field.value.availableValues | filter: $select.search\">\r\n        {{value.longName}}\r\n      </ui-select-choices>\r\n    </ui-select>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/directives/fileGallery/fileUpload.html","<div class=\"fileuploader\" ng-class=\"{\'fileuploader--uploading\' : fileUploads.length > 0}\">\r\n  <input class=\"fileuploader__fileinput\" type=\"file\" name=\"file\" id=\"{{containerId}}\" ng-disabled=\"disabled\" accept=\"*\" multiple=\"multiple\">\r\n  <div class=\"fileuploader__uploading\">\r\n    <button class=\"btn btn-fileupload btn-fileupload-danger btn-danger fileuploader__uploading__cancel\" ng-click=\"cancel()\" ng-if=\"fileUploads.length > 0\">\r\n      <i class=\"fa fa-times\"></i>\r\n    </button>\r\n    <div class=\"fileuploader__uploading__progress\">\r\n      <div class=\"fileuploader__uploading__progress--starting progress progress-striped active\" ng-show=\"!uploading\">\r\n        <div role=\"progressbar\" class=\"progress-bar\" style=\"width:100%\"></div>\r\n      </div>\r\n      <div class=\"progress progress-striped active\" ng-show=\"uploading\">\r\n        <div role=\"progressbar\" class=\"progress-bar\" style=\"width:{{getOverallProgress()}}%\"></div>\r\n      </div>\r\n      <div class=\"fileuploader__uploading__progress__text\">\r\n        <div ng-if=\"fileUploads.length - fileFailures.length != 0\">\r\n          <h4>{{ fileHistory.length - fileUploads.length}} <span translate>fileupload.of</span> {{fileHistory.length}} <span translate>fileupload.uploaded</span></h4>\r\n        </div>\r\n        <div ng-if=\"fileUploads.length - fileFailures.length == 0\">\r\n          <h4>\r\n            {{ fileFailures.length}} <span translate>fileupload.of</span> {{ fileHistory.length }} <span translate>fileupload.notupdated</span>\r\n          </h4>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <button class=\"btn btn btn-success fileuploader__uploading__retry\" ng-click=\"retry()\" ng-if=\"fileUploads.length - fileFailures.length == 0\">\r\n      <i class=\"fa fa-undo\"></i>\r\n    </button>\r\n  </div>\r\n  <div class=\"fileuploader__droparea\" ng-class=\"{\'fileuploader__droparea--hovering\': hovering}\">\r\n    <ng-transclude>\r\n      <label for=\"{{containerId}}\" class=\"fileuploader__defaultblock\">\r\n        <h4>Drop files here</h4>\r\n      </label>\r\n    </ng-transclude>\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n");
$templateCache.put("app/directives/fileGallery/filelist.html","<div class=\"container-fluid filelist\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.list\">\r\n  <div ng-repeat=\"item in vm.list track by item.id\" ng-if=\"item.isUploaded\">\r\n    <!-- approve -->\r\n    <div ng-if=\"vm.update\">\r\n      <input ng-if=\"vm.canApprove\" class=\"form-control\" type=\"checkbox\" ng-model=\"item.isApproved\" ng-change=\"vm.update(item)\">\r\n    </div>\r\n\r\n    <!-- Non selectable item -->\r\n    <div class=\"filelist__item row\" ng-if=\"vm.isSelectable !== true\">\r\n      <!-- authorize-download directive will be used if we revert back to authorized download (get request will have the token bearer )-->\r\n      <a class=\"filelist__item__download__wrapper flexeverything\" href=\"{{item.url}}\" target=\"_blank\" authorize-download>\r\n        <div class=\"filelist__item__image__wrapper\">\r\n          <!--no autorefreshing image-->\r\n          <img ng-if=\"!vm.autoRefresh\" class=\"filelist__item__image\" id=\"thumbnail-{{item.id}}\" ng-src=\"{{item.thumbnail || vm.fallbackImage(item)}}\" fallback-src=\"{{vm.fallbackImage(item)}}\">\r\n          <!--img autorefreshing-->\r\n          <img-refresher ng-if=\"vm.autoRefresh\" class=\"filelist__item__image\" src=\"item.thumbnail\" extension=\"item.extension\"></img-refresher>\r\n        </div>\r\n        <div class=\"filelist__item__details flex m-r-xs\">\r\n          <h4 class=\"filelist__item__details--filename no-margins\" title=\"{{item.displayName}}\">\r\n            {{item.displayName}}</h4>\r\n          <div>\r\n            <div class=\"filelist__item__details--useranddate\">\r\n              <small>{{item.uploadedBy}},</small>\r\n              <small>{{item.uploadedOn | dateTimeFromUtc}}</small>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"gallery__repeat__options\">\r\n          <div title=\"{{\'file.approved\' | translate}}\" ng-if=\"item.isApproved\" class=\"gallery__item__indicator--approved pull-right label label-primary\"><i class=\"fa fa-check fa-2x\"></i></div>\r\n        </div>\r\n      </a>\r\n    </div>\r\n\r\n    <!-- Selectable item -->\r\n    <div class=\"filelist__options\" ng-if=\"vm.delete\">\r\n      <a class=\"btn btn-danger\" ng-click=\"vm.delete()\"></a>\r\n    </div>\r\n    <div class=\"filelist__item row\" ng-if=\"vm.isSelectable\" ng-mouseover=\"vm.onMouseOver($index)\" ng-mouseleave=\"vm.onMouseLeave($index)\" on-long-press=\"vm.onLongPress($index, $event)\" ng-click=\"vm.onClick($index, $event)\" long-press-duration=\"480\" ng-class=\"{\r\n            \'filelist__item--selected\' : item.selected,\r\n            \'filelist__item--active\' : item.hover,\r\n            \'filelist__item--highlight\' : vm.totalSelected() > 0}\">\r\n\r\n      <div class=\"filelist__item__download__wrapper\">\r\n        <!-- authorize-download directive will be used if we revert back to authorized download (get request will have the token bearer )-->\r\n        <a href=\"{{item.url}}\" target=\"_blank\" authorize-download>\r\n          <div class=\"filelist__item__image__wrapper\">\r\n            <!--no autorefreshing image-->\r\n            <img ng-if=\"!vm.autoRefresh\" class=\"filelist__item__image\" id=\"thumbnail-{{item.id}}\" ng-src=\"{{item.thumbnail || vm.fallbackImage(item)}}\" fallback-src=\"{{vm.fallbackImage(item)}}\">\r\n            <!--img autorefreshing-->\r\n            <img-refresher ng-if=\"vm.autoRefresh\" class=\"filelist__item__image\" src=\"item.thumbnail\" extension=\"item.extension\"></img-refresher>\r\n\r\n            <div class=\"filelist__item__image__overlay\"></div>\r\n            <div class=\"filelist__item__indicator\" ng-click=\"vm.onClickSelect($index, $event)\">\r\n              <div class=\"filelist__item__indicator__icon\">\r\n                <svg class=\"filelist__item__indicator__icon__checkmark\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\">\r\n                  <circle cx=\"12.5\" cy=\"12.2\" r=\"8.292\"></circle>\r\n                </svg>\r\n                <svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\">\r\n                  <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"></path>\r\n                  <svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\">\r\n                    <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"></path>\r\n                  </svg>\r\n                </svg>\r\n              </div>\r\n              <div class=\"filelist__item__indicator__placeholder\">\r\n                <svg width=\"24px\" height=\"24px\" class=\"JUQOtc rqet2b\" viewBox=\"0 0 24 24\">\r\n                  <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"></path>\r\n                </svg>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"filelist__item__details\">\r\n            <h4 class=\"filelist__item__details--filename no-margins\" title=\"{{item.displayName}}\">\r\n              {{item.displayName}}</h4>\r\n            <div>\r\n              <div class=\"filelist__item__details--useranddate\">\r\n                <small>{{item.uploadedBy}},</small>\r\n                <small>{{item.uploadedOn | dateTimeFromUtc }}</small>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </a>\r\n        <div class=\"filelist__item__options\" stop-event=\"click\">\r\n          <div class=\"btn-group btn-group\" ng-if=\"vm.canApprove\" role=\"group\">\r\n            <!--<button type=\"button\" class=\"btn btn-xs\" ng-click=\"vm.approve(item, false)\"-->\r\n                    <!--ng-class=\"{\'btn-danger\' : item.isApproved === false, \'btn-default\' : item.isApproved !== false}\" translate><i class=\"fa fa-times fa-2x\"></i></button>-->\r\n            <button type=\"button\" class=\"btn btn-xs\" ng-click=\"vm.approve(item, true)\" ng-class=\"{\'btn-primary\' : item.isApproved === true, \'btn-default\' : item.isApproved !== true}\" translate><i class=\"fa fa-check fa-2x\"></i></button>\r\n          </div>\r\n        </div>\r\n      \r\n    </div>\r\n  </div>\r\n</div>\r\n</div>");
$templateCache.put("app/directives/fileGallery/gallery.html","<div ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.list\" class=\"gallery {{vm.class}} links blueimp-gallery-inner\" ng-class=\"{\'hide-unapproved\' : vm.hideUnapproved}\">\r\n  <div class=\"gallery__repeat\" ng-repeat=\"item in vm.list track by item.id\" ng-if=\"item.isUploaded\" ng-class=\"{\'approved\': item.isApproved}\">\r\n    <!-- Non selectable item -->\r\n    <div class=\"gallery__item\" ng-if=\"vm.isSelectable !== true\" ng-class=\"{\'gallery__item--selected-simple\' : item.pvalue}\">\r\n      <div class=\"fa fa-check-circle fa-2x gallery__item__indicator__simple\" ng-if=\"vm.ngClickItem\" ng-click=\"vm.clickItem(item)\" stop-event=\"click\"></div>\r\n      <a class=\"gallery__item__link\" href=\"{{item.url}}\" title=\"{{item.displayName}}\" data-id=\"{{item.id}}\" data-rotateurl=\"{{item.rotateUrl}}\" ng-class=\"{\'js-gallery__item\' : item.thumbnail}\" authorize-download>\r\n        <!--no autorefreshing image-->\r\n        <img ng-if=\"!vm.autoRefresh\" id=\"thumbnail-{{item.id}}\" data-disablerotate=\"{{vm.disableRotating}}\" class=\"gallery__item__image--{{vm.fileType(item)}}\" ng-src=\"{{item.thumbnail  || vm.fallbackImage(item)}}\">\r\n\r\n        <!--img autorefreshing-->\r\n        <img-refresher ng-if=\"vm.autoRefresh\" id=\"thumbnail-{{item.id}}\" class=\"gallery__item__image--{{vm.fileType(item)}}\" src=\"item.thumbnail\" extension=\"item.extension\"></img-refresher>\r\n      </a>\r\n    </div>\r\n\r\n    <!-- Selectable item -->\r\n    <div ng-if=\"vm.isSelectable\" class=\"gallery__item\" ng-mouseover=\"vm.onMouseOver($index)\" ng-mouseleave=\"vm.onMouseLeave($index)\" on-long-press=\"vm.onLongPress($index, $event)\" ng-click=\"vm.onClick($index, $event);vm.clickItem(item)\" long-press-duration=\"480\" ng-class=\"{\r\n            \'gallery__item--selected\' : item.selected,\r\n            \'gallery__item--active\' : item.hover,\r\n            \'gallery__item--highlight\' : vm.totalSelected() > 0}\">\r\n      <div class=\"gallery__item__image__overlay\"></div>\r\n      <div class=\"gallery__item__indicator\" ng-click=\"vm.onClickSelect($index, $event)\">\r\n        <div class=\"gallery__item__indicator__icon\">\r\n          <svg class=\"gallery__item__indicator__icon__checkmark\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\">\r\n            <circle cx=\"12.5\" cy=\"12.2\" r=\"8.292\"></circle>\r\n          </svg>\r\n          <svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\">\r\n            <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"></path>\r\n            <svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\">\r\n              <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"></path>\r\n            </svg>\r\n          </svg>\r\n        </div>\r\n        <div class=\"gallery__item__indicator__placeholder\">\r\n          <svg width=\"24px\" height=\"24px\" class=\"JUQOtc rqet2b\" viewBox=\"0 0 24 24\">\r\n            <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"></path>\r\n          </svg>\r\n        </div>\r\n      </div>\r\n\r\n      <a class=\"gallery__item__link\" href=\"{{item.url}}\" title=\"{{item.displayName}}\" data-id=\"{{item.id}}\" data-rotateurl=\"{{item.rotateUrl}}\" ng-class=\"{\'js-gallery__item\' : item.thumbnail}\" authorize-download>\r\n\r\n        <!--no autorefreshing image-->\r\n        <img ng-if=\"!vm.autoRefresh\" id=\"thumbnail-{{item.id}}\" ng-src=\"{{item.thumbnail || vm.fallbackImage(item)}}\" fallback-src=\"{{vm.fallbackImage(item)}}\">\r\n\r\n        <!--img autorefreshing-->\r\n        <img-refresher ng-if=\"vm.autoRefresh\" id=\"thumbnail-{{item.id}}\" src=\"item.thumbnail\" extension=\"item.extension\"></img-refresher>\r\n      </a>\r\n\r\n    </div>\r\n\r\n\r\n    <!-- approve -->\r\n    <div class=\"gallery__repeat__options\">\r\n      <div class=\"btn-group btn-group\" ng-if=\"vm.canApprove\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-sm\" ng-click=\"vm.approve(item, true)\" ng-class=\"{\'btn-primary\' : item.isApproved, \'btn-default\' : !item.isApproved}\">\r\n          <i class=\"fa\" ng-class=\"{\'fa-check-square-o\': item.isApproved, \' fa-square-o\': !item.isApproved}\"></i>\r\n          {{ (item.isApproved === true ? \'file.approved\' : \'file.unapproved\') | translate}}\r\n        </button>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/shared/milestone.list.html","<div class=\"milestonelist\">\r\n  <span ng-repeat=\"m in vm.milestoneList\" class=\"btn btn-arrow-right milestonelist__milestone\" ng-class=\"{\'btn-primary completed\': m.isCompleted, \'btn-default\' : !m.isCompleted, \'current\':m.isCurrent, \'btn-arrow-right-no-tail\':$first,\r\n                     \'btn-arrow-right-no-head\': $last}\">\r\n    <span>{{m.name}}</span>\r\n  </span>\r\n  <span ng-if=\"!vm.milestoneList.length\" translate>milestones.norecord</span>\r\n</div>\r\n\r\n");
$templateCache.put("app/directives/shared/projectinstance.list.html","<div class=\"projecttemplateprojectinstancelist\">\r\n  <table class=\"table\">\r\n    <thead>\r\n    <tr>\r\n      <th>\r\n        <a can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" ui-sref=\"siskin.project({projectId:vm.projectTemplate.id})\" cannot-do-remove-attr=\"href,ui-sref\">\r\n          {{vm.projectTemplate.name}}\r\n        </a>\r\n      </th>\r\n      <th translate can-do feature=\"displayStores\">concern.concern</th>\r\n      <th translate>projectinstances.milestones</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-if=\"vm.pager.noResults && !vm.pager.busy\">\r\n      <td colspan=\"3\" class=\"text-center\" translate>common.norecords</td>\r\n    </tr>\r\n    <tr ng-repeat=\"m in vm.pager.items\">\r\n      <td>\r\n        <a can-do=\"projectInstanceView\" cannot-do-class=\"disabled\" ui-sref=\"siskin.projectinstancedetail({projectInstanceId:m.id})\" cannot-do-remove-attr=\"href,ui-sref\">\r\n          {{m.name}}\r\n        </a>\r\n        <span class=\"label label-default m-l-sm\" ng-if=\"!m.isActive\"><i class=\"fa fa-pause m-r-sm\"></i>\r\n          {{\'projectinstances.deactivated\'|translate}}\r\n          <span ng-if=\"m.canStart\">, {{\'projectinstances.startingon\'|translate}} : {{ m.startingOn | date}}</span>\r\n        </span>\r\n      </td>\r\n      <td can-do feature=\"displayStores\">\r\n        {{m.storeName}}\r\n      </td>\r\n      <td milestone-list=\"m.milestones\"></td>\r\n    </tr>\r\n    </tbody>\r\n  </table>\r\n  <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n  <pager ng-model=\"vm.pager\"></pager>\r\n</div>\r\n");
$templateCache.put("app/directives/tazkBehaviours/tazkCustomerChat.directive.html","<div class=\"tazk__behaviour__body supportchat__body\">\r\n  <scroll-bottom ng-if=\"vm.chats.length>0\" count-change=\"vm.chats.length\" tazk=\"vm.tazk\">\r\n   <ul class=\"chats\">\r\n      <li ng-class=\"{\'right\' : vm.isMessageFromSelf(chat) }\" ng-repeat=\"chat in vm.chats\">\r\n        <span class=\"date-time\">{{chat.sentOn | dateTimeFromUtc }}</span>\r\n        <a class=\"name\">{{chat.writerName}}</a>\r\n        <a class=\"image\">\r\n          <img alt=\"{{chat.writerName}}\" ng-src=\"{{chat.writerProfilePictureUrl}}&s=80\">\r\n        </a>\r\n        <div class=\"message\">\r\n          <p class=\"message__content\">{{chat.body}}</p>\r\n          <div ng-if=\"chat.projectInstanceId\"><a ui-sref=\"siskin.projectinstancedetail({projectInstanceId: chat.projectInstanceId})\">{{chat.projectInstanceName}}</a></div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n  </scroll-bottom>\r\n</div>\r\n<div class=\"tazk__behaviour__footer supportchat__footer\" disable-inputs make-disable=\"vm.busy\">\r\n  <div ng-show=\"vm.showAttachedProjectInstance()\">\r\n      <div class=\"alert alert-info alert-dismissible\" role=\"alert\" type=\"info\" close=\"vm.removeProjectInstance()\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"vm.removeProjectInstance()\">\r\n            <span aria-hidden=\"true\">×</span>\r\n            <span class=\"sr-only\" translate>generic.action.close</span>\r\n        </button>\r\n        <div>\r\n          <span>\r\n            <strong>\r\n              <a ui-sref=\"siskin.projectinstancedetail({projectInstanceId:vm.compose.projectInstance.id})\">\r\n                {{vm.compose.projectInstance.projectTemplateName}} / {{vm.compose.projectInstance.name}}\r\n              </a>\r\n            </strong>\r\n          </span>\r\n        </div>\r\n      </div>\r\n  </div>\r\n	<div ng-show=\"!vm.attachProjectInstanceOn\" class=\"flexeverything supportchat__composer__wrapper\">\r\n    <!-- Use this when you need to add a link to a project instance -->\r\n\r\n  	<div class=\"btn-group dropup btn__showattachprojectinstance\" ng-show=\"vm.userCanSeeAtLeastOneStore\">\r\n  		<button type=\"button\" class=\"btn\" ng-disabled=\"disabled\" ng-click=\"vm.showAttachProjectInstance()\">\r\n      <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n      </button>\r\n    </div>\r\n    <div class=\"composer\">\r\n      <div class=\"flexeverything\" tooltip-trigger=\"click\" tooltip-enable=\"vm.hasError()\" tooltip-is-open=\"vm.hasError()\" ng-class=\"{\'has-error\' : vm.hasError()}\">\r\n      <textarea msd-elastic ng-model=\"vm.compose.message\" translate-attr=\"{placeholder : \'supportchat.composeplaceholder\'}\" placeholder=\"supportchat.composeplaceholder\" class=\"form-control\" rows=\"1\" auto-focus></textarea>\r\n        <button class=\"btn btn-small btn-info\" ng-show=\"vm.compose.message.length !== 0\" ng-click=\"vm.sendMessage()\">\r\n          <i class=\"fa fa-paper-plane\"></i>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div ng-show=\"vm.attachProjectInstanceOn && vm.userCanSeeAtLeastOneStore\" class=\"flexeverything supportchat__footer__attachprojectinstance\">\r\n    <div class=\"btn-group dropup attachprojectinstance__goback\">\r\n      <button type=\"button\" class=\"btn supportchat__footer__backbutton\" ng-click=\"vm.hideAttachProjectInstance()\">\r\n        <i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i>\r\n      </button>\r\n    </div>\r\n    <div class=\"attachprojectinstance__searchwrapper\">\r\n      <dropdown ng-model=\"vm.selectedStore\" pager=\"vm.concernPager\" placeholder=\"{{\'supportchat.storesearch.placeholder\'|translate}}\" ng-if=\"vm.concernPager\" ng-show=\"vm.showStoreDropdown\" ng-change=\"vm.getProjects(vm.selectedStore)\" class=\"\">\r\n      </dropdown>\r\n\r\n\r\n      <dropdown ng-model=\"vm.selectedProjectInstance\" ng-values=\"vm.selectedStore.projectInstances\" placeholder=\"{{\'supportchat.projectinstancesearch.placeholder\'|translate}}\" ng-if=\"vm.selectedStore\" ng-show=\"vm.showProjectInstanceDropdown\" ng-change=\"vm.attachProjectInstance(vm.selectedProjectInstance)\" class=\"\">\r\n      </dropdown>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/tazkBehaviours/tazkFields.directive.html","<div class=\"tazk__behaviour__body\">\r\n  <div class=\"attributetabs attributetabs--vertical tabs-container\">\r\n    <!--attribues-->\r\n    <div ng-repeat=\"tab in vm.tazk.task.fieldsByCategory.groups\" class=\"ibox float-e-margins m-b-xs\" ng-class=\"{ collapsed : !tab.show}\">\r\n      <div class=\"ibox-title p-xs\" ng-click=\"tab.show = !tab.show\">\r\n        <span class=\"flexeverything flexeverything--aligncenter\">\r\n          <i class=\"fa fa-2x datavalue-icon datavalue-icon-{{tab.type}} m-l-sm\"></i>\r\n          <span class=\"m-l-sm\" translate>{{tab.name || \'common.attributes\'}}</span>\r\n          <span>({{(tab.data | hasValue).length}}/{{tab.data.length}})</span>\r\n          <span ng-if=\"(tab.data | filter: {hasRequiredError:true}).length\" class=\"label label-danger\" translate>task.fields.required</span>\r\n        </span>\r\n        <div class=\"ibox-tools ibox-tools-sm dropdown\">\r\n          <a><i class=\"fa fa-chevron-up\"></i></a>\r\n        </div>\r\n      </div>\r\n      <div class=\"ibox-content\">\r\n        <div class=\"attributetabs__group__datavalue form-group\" ng-repeat=\"field in tab.data | orderBy:\'listOrder\' \" ng-switch=\"field.type\">\r\n          <field-files class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"files\" context=\"inbox\" context-entity=\"vm.tazk\" parent=\".ibox-content\"></field-files>\r\n          <field-boolean class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"boolean\" context=\"inbox\" context-entity=\"vm.tazk\"></field-boolean>\r\n          <field-confirmation class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"confirmation\" context=\"inbox\" context-entity=\"vm.tazk\"></field-confirmation>\r\n          <field-date class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"date\" context=\"inbox\" context-entity=\"vm.tazk\"></field-date>\r\n          <field-datetime class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"datetime\" context=\"inbox\" context-entity=\"vm.tazk\"></field-datetime>\r\n          <field-double class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"double\" context=\"inbox\" context-entity=\"vm.tazk\"></field-double>\r\n          <field-dropdown class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"dropdown\" context=\"inbox\" context-entity=\"vm.tazk\"></field-dropdown>\r\n          <field-integer class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"integer\" context=\"inbox\" context-entity=\"vm.tazk\"></field-integer>\r\n          <field-string class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"string\" context=\"inbox\" context-entity=\"vm.tazk\"></field-string>\r\n          <field-user class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"user\" context=\"inbox\" context-entity=\"vm.tazk\"></field-user>\r\n          <field-group class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"group\" context=\"inbox\" context-entity=\"vm.tazk\"></field-group>\r\n          <field-link class=\"attributetabs__group__datavalue--data\" field=\"field\" ng-switch-when=\"link\" context=\"inbox\" context-entity=\"vm.tazk\"></field-link>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n      <!--notes-->\r\n      <div class=\"attributetabs__group\" ng-click=\"vm.switchToBehaviour(\'notes\')\" ng-if=\"vm.tazk.task.notes.lastNote\">\r\n        <div class=\"ibox-title p-xs\" ng-click=\"tab.show = !tab.show\">\r\n          <span class=\"flexeverything flexeverything--aligncenter\">\r\n            <i class=\"fa fa-2x fa-sticky-note m-l-sm\"></i>\r\n             <div class=\"attributetabs__group--title-text m-l-xs\">{{vm.tazk.task.notes.lastNote.userName}} : {{vm.tazk.task.notes.lastNote.body}} <i class=\"fa fa-eye m-l-xs\" ng-if=\"vm.tazk.task.notes.lastNote.projectRoleMappingsNames.length\" title=\"{{ \'notes.notefor\' | translate }} : {{ vm.tazk.task.notes.lastNote.projectRoleMappingsNames.join(\', \')}}\"></i></div>\r\n          </span>\r\n        </div>\r\n      </div>\r\n  </div>\r\n</div>\r\n<div class=\"tazk__behaviour__footer\">\r\n  <button class=\"btn btn-primary\" ng-if=\"!vm.tazk.task.claimed\" ng-click=\"vm.doClaim()\" translate>task.btn.claim</button>\r\n  <div ng-if=\"vm.tazk.task.claimed\" class=\"flex\">\r\n    <button class=\"btn btn-default\" ng-if=\"vm.tazk.task.unclaimable\" ng-click=\"vm.unclaim()\" translate>task.btn.unclaim\r\n    </button>\r\n    <button class=\"tazk--iconbutton\" type=\"button\" ng-click=\"vm.switchToBehaviour(\'notes\')\">\r\n      <i class=\"ion-chatbox fa-lg\"></i>\r\n    </button>\r\n\r\n    <div ng-if=\"vm.tazk.task.actions.length < 3\" class=\"pull-right\">\r\n      <button class=\"btn btn-primary m-l-xs\" ng-click=\"vm.complete(action)\" ng-repeat=\"action in vm.tazk.task.actions\" translate>{{action.name}}</button>\r\n    </div>\r\n    <div ng-if=\"vm.tazk.task.actions.length > 2\" class=\"btn-group dropup m-l-sm pull-right\">\r\n      <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n        <i class=\"fa fa-caret-up fa-x2 m-r-xs\"></i> Actions\r\n      </button>\r\n      <ul class=\"dropdown-menu dropdown-menu-right\">\r\n        <li><a class=\"dropdown-item\" ng-click=\"vm.complete(action)\" ng-repeat=\"action in vm.tazk.task.actions\" translate>{{action.name}}</a></li>\r\n      </ul>\r\n    </div>\r\n\r\n    <button ng-show=\"vm.tazk.busyOperations > 0\" class=\"btn btn-primary pull-right flexeverything\" disabled=\"disabled\">\r\n      <span translate>task.behavior.saving</span>\r\n      <sk-spinner-circle></sk-spinner-circle>\r\n    </button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/tazkBehaviours/tazkNotes.directive.html","<div class=\"tazk__behaviour__body\">\r\n    <scroll-bottom ng-if=\"vm.notes.data.length>0 && vm.behaviour === \'notes\'\" count-change=\"vm.notes.data.length\" tazk=\"vm.tazk\">\r\n    <ul class=\"chats\">\r\n      <li ng-class=\"{\'right\' : vm.isNoteFromSelf(note) }\" ng-repeat=\"note in vm.notes.data\">\r\n        <span class=\"date-time\">{{note.createdOn | dateTimeFromUtc }}</span>\r\n        <a class=\"name\">\r\n          {{note.userLongName}}\r\n          <i class=\"fa fa-eye m-l-xs\" ng-if=\"note.projectRoleMappingsNames.length\" title=\"{{ \'notes.notefor\' | translate }} : {{ note.projectRoleMappingsNames.join(\', \')}}\"></i>\r\n        </a>\r\n        <a class=\"image\">\r\n          <!-- Assuming that the user profile pic comes from gravatar, &s=80 will get an 80px size image -->\r\n          <img alt=\"{{note.userLongName}}\" src=\"{{note.userPicture}}&s=80\">\r\n        </a>\r\n        <div class=\"message\">\r\n          <p class=\"message__content\">{{note.body}}</p>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    </scroll-bottom>\r\n</div>\r\n\r\n<div class=\"tazk__behaviour__footer\" disable-inputs make-disable=\"vm.busy\">\r\n  <div class=\"flexeverything\">\r\n    <button class=\"btn btn-default\" ng-click=\"vm.back()\" translate>common.back</button>\r\n    <div class=\"flex m-l-sm\" ng-switch=\"vm.compose.state\">\r\n      <div ng-switch-when=\"writing\" class=\"flexeverything\" uib-tooltip-html=\"\'{{\'task.notes.composerequired\'|translate}}\'\" tooltip-trigger=\"click\" tooltip-enable=\"vm.hasError()\" tooltip-is-open=\"vm.hasError()\" ng-class=\"{\'has-error\' : vm.hasError()}\">\r\n      <textarea msd-elastic ng-model=\"vm.compose.message\" translate-attr=\"{placeholder : \'task.notes.composeplaceholder\'}\" placeholder=\"task.notes.composeplaceholder\" class=\"form-control\" rows=\"1\"></textarea>\r\n        <dropdown-multiple ng-if=\"vm.tazk.projectRoleMappingsPager\" ng-show=\"vm.compose.message.length\" pager=\"vm.tazk.projectRoleMappingsPager\" ng-model=\"vm.compose.projectRoleMappings\" placeholder=\"common.selectroles\"></dropdown-multiple>\r\n        <button class=\"btn btn-small btn-info task__notes__footer__send\" ng-show=\"vm.compose.message.length\" ng-click=\"vm.sendPublic()\">\r\n          <i class=\"fa fa-paper-plane\"></i>\r\n        </button>\r\n      </div>\r\n      <!--<div ng-switch-when=\"sendingInternal\" class=\"flexeverything\">-->\r\n        <!--<button class=\"btn flex\" ng-click=\"vm.cancelSend()\"><i class=\"fa fa-times\"></i></button>-->\r\n        <!--<button class=\"btn btn-warning flex\" ng-click=\"vm.sendPublic()\" translate>task.notes.btn.sendpublic</button>-->\r\n        <!--<button class=\"btn btn-primary flex\" ng-click=\"vm.sendInternal()\" translate>task.notes.btn.sendinternal</button>-->\r\n      <!--</div>-->\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/utility/confirmation.modal.directive.html","<div stop-event=\"click\">\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\"><span aria-hidden=\"true\">×</span><span class=\"sr-only\" translate>generic.action.close</span></button>\r\n    <h4 class=\"modal-title\" translate>{{vmModal.title}}</h4>\r\n  </div>\r\n  <div class=\"modal-body modal__body\">\r\n    <p translate>{{vmModal.text || \'common.confirmationmessage\'}}</p>\r\n    <div class=\"alert alert-danger flexeverything flexeverything--aligncenter\" ng-if=\"vmModal.error\">\r\n      <i class=\"fa fa-exclamation-circle fa-2x m-r-sm\"></i>\r\n      {{ vmModal.errorMessage | translate}}</div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button ng-if=\"vmModal.confirm\" type=\"button\" class=\"btn {{vmModal.btnStyle}}\" ng-click=\"vmModal.confirm()\" ng-class=\"{\'has-error\': vmModal.error}\" ng-disabled=\"vmModal.processing\">\r\n      <sk-spinner-circle class=\"pull-left m-r-xs\" ng-if=\"vmModal.processing\"></sk-spinner-circle>\r\n       {{(vmModal.title || \'generic.action.confirm\') | translate}}\r\n    </button>\r\n    <button type=\"button\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\" ng-disabled=\"vmModal.processing\" translate>generic.action.close</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/utility/confirmationButton.panel.template.html","<div class=\"confirmationPanel\" name=\"confirmationPanel\">\r\n  <div class=\"confirmationPanel__block\" ng-hide=\"!processing\">\r\n    <div class=\"confirmationPanel__block__backdrop\"></div>\r\n    <div class=\"confirmationPanel__block__spinner\">\r\n      <sk-spinner></sk-spinner>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"confirmationPanel__body\">\r\n\r\n    <h4 translate>{{ confirmMessage }}</h4>\r\n    <div class=\"confirmationPanel__body--content\">\r\n      <div></div>\r\n    </div>\r\n\r\n    <div class=\"confirmationPanel__body--options\">\r\n      <button ng-click=\"confirm()\" ng-disabled=\"processing\" class=\"btn btn-primary\" translate>app.confirmation.panel.confirm</button>\r\n      <button ng-click=\"cancel()\" ng-disabled=\"processing\" class=\"btn btn-default\" translate>app.confirmation.panel.cancel</button>\r\n    </div>\r\n    <div class=\"confirmationPanel__body--error\" ng-if=\"error\">\r\n      <label class=\"label label-danger\" translate>{{ error }}</label>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/directives/utility/datepicker.directive.html","<div>\r\n  <input type=\"button\" date-time ng-model=\"vm.ngModel\" ng-focus=\"vm.focus()\" ng-blur=\"vm.blur()\" auto-close=\"true\" date-change=\"dateChange\" class=\"form-control js-datepicker-trigger datepicker__hidden\" type=\"text\">\r\n\r\n  <div class=\"input-group date\">\r\n    <span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>\r\n    <input type=\"text\" class=\"form-control\" ng-if=\"!vm.includeTime\" placeholder=\"{{vm.placeholder}}\" value=\"{{ vm.ngModel | dateFromUtc }}\">\r\n    <input type=\"text\" class=\"form-control\" ng-if=\"vm.includeTime\" placeholder=\"{{vm.placeholder}}\" value=\"{{ vm.ngModel | dateTimeFromUtc }}\">\r\n    <i class=\"datepicker--clear fa fa-times\" ng-click=\"vm.clear()\" ng-show=\"vm.ngModel\"></i>\r\n  </div>\r\n\r\n  <div ng-click=\"vm.show()\" class=\"datepicker-trigger-overlay\"></div>\r\n</div>\r\n\r\n");
$templateCache.put("app/directives/utility/datepickerrange.directive.html","<div class=\"date-range-picker\">\r\n    <!-- clear button since datepickerrange clear only displays when autoApply is false -->\r\n    <i class=\"fa fa-times\" ng-show=\"vm.ngModel.startDate || vm.ngModel.endDate\" ng-click=\"vm.ngClear()\"></i>\r\n\r\n    <input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.ngModel\" options=\"vm.options\" placeholder=\"{{vm.placeholder | translate}}\">\r\n  </div>\r\n");
$templateCache.put("app/directives/utility/dropdown.directive.html","<ui-select reset-search-input=\"true\" ng-model=\"vm.ngModel\" ng-disabled=\"vm.ngDisabled\" theme=\"bootstrap\" reset-search-input=\"false\" on-select=\"vm.onSelect()\" on-remove=\"vm.ngChange()\" reach-infinity=\"vm.reachInfinity()\" translate-attr=\"{placeholder : vm.placeholder}\">\r\n  <ui-select-match allow-clear=\"{{vm.allowClear}}\" placeholder=\"{{vm.placeholder|translate}}\">\r\n    {{$select.selected.name || ($select.selected.key | translate) || $select.selected}}\r\n  </ui-select-match>\r\n  <ui-select-choices repeat=\"(item.value || item[vm.prop] || item) as item in vm.pager.items | proxyFilter:vm.filter | filter:(vm.ngValues ? $select.search : \'\') track by $index\" refresh=\"vm.pager.reset({query: $select.search,searchTerm:$select.search})\" refresh-delay=\"vm.refreshDelay\" group-by=\"vm.groupBy\">\r\n    <div ng-bind-html=\"(item.name || (item.key | translate) || item ) | highlight: $select.search\"></div>\r\n  </ui-select-choices>\r\n</ui-select>\r\n");
$templateCache.put("app/directives/utility/dropdown.multiple.directive.html","<ui-select reset-search-input=\"true\" ng-model=\"vm.ngModel\" ng-disabled=\"vm.ngDisabled\" theme=\"bootstrap\" reset-search-input=\"false\" on-select=\"vm.ngChange()\" on-remove=\"vm.ngChange()\" reach-infinity=\"vm.reachInfinity()\" translate-attr=\"{placeholder : vm.placeholder}\" multiple=\"multiple\">\r\n  <ui-select-match allow-clear=\"{{vm.allowClear}}\" placeholder=\"{{vm.placeholder|translate}}\">\r\n    {{$item.name || ($item.key | translate) || $item}}\r\n  </ui-select-match>\r\n  <ui-select-choices repeat=\"(item.value || item) as item in vm.pager.items | filter:(vm.ngValues ? $select.search : \'\') track by $index\" refresh=\"vm.pager.reset({query: $select.search,searchTerm:$select.search})\" refresh-delay=\"500\" group-by=\"vm.groupBy\">\r\n    <div ng-bind-html=\"(item.name || (item.key | translate) || item ) | highlight: $select.search\"></div>\r\n  </ui-select-choices>\r\n</ui-select>\r\n");
$templateCache.put("app/directives/utility/fileUploadButton.directive.html","<input type=\"file\" name=\"file\" id=\"upload\" accept=\"{{vm.accept}}\" style=\"display: none;\">\r\n<label class=\"{{vm.btnClass}}\" for=\"upload\" translate>{{vm.label}}</label>\r\n");
$templateCache.put("app/directives/utility/onoffSwitch.directive.html","<div class=\"onoffswitch\">\r\n  <input type=\"checkbox\" checked=\"\" class=\"onoffswitch-checkbox\" ng-disabled=\"vm.ngDisabled\" id=\"{{vm.switchId}}\" ng-checked=\"vm.ngModel\" ng-click=\"vm.ngCallback()\">\r\n  <label class=\"onoffswitch-label\" for=\"{{vm.switchId}}\">\r\n    <span class=\"onoffswitch-inner\"></span>\r\n    <span class=\"onoffswitch-switch\"></span>\r\n  </label>\r\n</div>\r\n");
$templateCache.put("app/directives/utility/printButton.directive.html","<button ng-click=\"vm.print()\" class=\"btn btn-primary ignore-print\">\r\n  <i class=\"fa fa-print\"></i>\r\n  <span translate>common.print</span>\r\n</button>\r\n");
$templateCache.put("app/directives/utility/spinner.circle.directive.html","<div class=\"sk-spinner sk-spinner-fading-circle\">\r\n  <div class=\"sk-circle1 sk-circle\"></div>\r\n  <div class=\"sk-circle2 sk-circle\"></div>\r\n  <div class=\"sk-circle3 sk-circle\"></div>\r\n  <div class=\"sk-circle4 sk-circle\"></div>\r\n  <div class=\"sk-circle5 sk-circle\"></div>\r\n  <div class=\"sk-circle6 sk-circle\"></div>\r\n  <div class=\"sk-circle7 sk-circle\"></div>\r\n  <div class=\"sk-circle8 sk-circle\"></div>\r\n  <div class=\"sk-circle9 sk-circle\"></div>\r\n  <div class=\"sk-circle10 sk-circle\"></div>\r\n  <div class=\"sk-circle11 sk-circle\"></div>\r\n  <div class=\"sk-circle12 sk-circle\"></div>\r\n</div>\r\n");
$templateCache.put("app/directives/utility/spinner.directive.html","<div class=\"sk-spinner sk-spinner-wave\">\r\n  <div class=\"sk-rect1\"></div>\r\n  <div class=\"sk-rect2\"></div>\r\n  <div class=\"sk-rect3\"></div>\r\n  <div class=\"sk-rect4\"></div>\r\n  <div class=\"sk-rect5\"></div>\r\n</div>\r\n");
$templateCache.put("app/modules/tazkModule/tazk.directive.html","<!-- header -->\r\n<div class=\"tazk__header flexeverything\">\r\n\r\n\r\n  <!--<label ng-hide=\"vm.isDefaultBehaviour()\" class=\"tazk__header__controls tazk__header_backtodefault\">-->\r\n    <!--<button class=\"tazk&#45;&#45;iconbutton\" ng-click=\"vm.switchToDefaultBehaviour()\">-->\r\n      <!--<i class=\"ion-arrow-left-c\"></i>-->\r\n    <!--</button>-->\r\n  <!--</label>-->\r\n\r\n  <!-- TODO: There\'s a bunch of spacing things that need to happen here to correctly shrink this div using flexbox when the task name gets long but still keep everything centered -->\r\n  <div class=\"tazk__header_backtodefault\" ng-hide=\"!vm.isDefaultBehaviour()\" style=\"width: 41px;\"></div>\r\n  <!-- /TODO -->\r\n\r\n  <label class=\"tazk__name\" ng-bind-html=\"vm.tazk.title\"></label>\r\n\r\n  <div class=\"tazk__header__controls\">\r\n    <button class=\"tazk__header__minimize\" ng-click=\"vm.tazk.toggleOpen()\">\r\n      <i class=\"ion-minus\"></i>\r\n    </button>\r\n    <button class=\"tazk__header__modal\" ng-if=\"!vm.tazk.isModal\" ng-click=\"vm.tazk.showModal()\">\r\n      <i class=\"ion-arrow-expand\" style=\"font-size: 15px;\"></i>\r\n    </button>\r\n    <button class=\"tazk__header__modal\" ng-if=\"vm.tazk.isModal\" ng-click=\"vm.tazk.hideModal()\">\r\n      <i class=\"ion-arrow-shrink\" style=\"font-size: 15px;\"></i>\r\n    </button>\r\n    <button class=\"tazk__header__close\" ng-click=\"vm.tazk.close()\">\r\n      <i class=\"ion-close\"></i>\r\n    </button>\r\n  </div>\r\n\r\n\r\n</div>\r\n\r\n<div class=\"tazk__behaviour\" ng-if=\"vm.tazk.task.tazkViewModelType === \'customerChat\'\">\r\n  <tazk-customer-chat tazk=\"vm.tazk\"></tazk-customer-chat>\r\n</div>\r\n\r\n<div class=\"tazk__behaviour\" ng-if=\"vm.tazk.task.tazkViewModelType === \'inboxTask\'\">\r\n  <tazk-fields ng-show=\"vm.behaviour === \'fields\'\"></tazk-fields>\r\n  <tazk-notes ng-show=\"vm.behaviour === \'notes\'\" behaviour=\"vm.behaviour\" tazk=\"tazk\"></tazk-notes>\r\n</div>\r\n\r\n<!-- blocking overlay -->\r\n<div class=\"tazk__blocker\" ng-hide=\"!vm.tazk.isBlocked && vm.tazk.task.loaded\">\r\n  <div class=\"tazk__block__backdrop\"></div>\r\n  <div class=\"tazk__block__spinner\">\r\n    <sk-spinner></sk-spinner>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/tazkModule/tazk.html","<div class=\"tazkContainer\" ng-controller=\"tazkListController as tlCtrl\">\r\n\r\n  <div class=\"tazkContainer__backdrop\" ng-if=\"tlCtrl.modalOpen()\"></div>\r\n\r\n  <gf-tazk tazk=\"tazk\" class=\"tazk\" role=\"\" ng-click=\"tlCtrl.bringToFront($index)\" ng-repeat=\"tazk in tlCtrl.tazks\" ng-style=\"{ right: tazk.right, \'z-index\': tazk.zindex }\" ng-class=\"{ \'tazk--minimized\' : !tazk.isOpen, \'tazk--modal\' : tazk.isModal }\" id=\"tazk-container-{{tazk.id}}\">\r\n  </gf-tazk>\r\n\r\n  <!-- Optional items URL popup -->\r\n  <optional-items></optional-items>\r\n</div>\r\n");
$templateCache.put("app/modules/translationModule/translation.html","<div class=\"gfTranslation\" ng-controller=\"gfTranslationController as translationCtrl\">\r\n\r\n  <div ng-controller=\"gfTranslationPopoverController as popoverCtrl\">\r\n    <div ng-include=\"\'app/modules/translationModule/translationPopover.html\'\"></div>\r\n    <div class=\"gfTranslation__backdrop\" ng-if=\"translationCtrl.isActive == true\" ng-click=\"popoverCtrl.show = false\"></div>\r\n  </div>\r\n\r\n  <div class=\"js-translation-mask-insert\"></div>\r\n  <!-- All popover mask elements are added here -->\r\n</div>\r\n");
$templateCache.put("app/modules/translationModule/translationMask.html","<div class=\"js-translation-target\" ng-style=\"{\'width\' : gfTranslate.mask.width, \'height\' : gfTranslate.mask.height, \'left\' : gfTranslate.mask.left, \'top\' : gfTranslate.mask.top}\" style=\"position:fixed; background-color: black; opacity: 0.3\" ng-click=\"gfTranslate.toggle()\">\r\n</div>\r\n");
$templateCache.put("app/modules/translationModule/translationPopover.html","<div ng-show=\"popoverCtrl.show\" class=\"popover {{popoverCtrl.direction}} in\" role=\"tooltip\" ng-style=\"{\'left\' : popoverCtrl.pos.left, \'top\' : popoverCtrl.pos.top}\" style=\"display: block; position: fixed;\">\r\n  <div class=\"arrow\"></div>\r\n  <h3 class=\"popover-title\">{{popoverCtrl.key}}</h3>\r\n  <div class=\"popover-content\">\r\n\r\n      <div class=\"input-group\">\r\n        <input class=\"form-control\" type=\"text\" ng-model=\"popoverCtrl.value\" ng-enter=\"popoverCtrl.save(popoverCtrl.value)\">\r\n        <span class=\"input-group-btn\">\r\n        <button class=\"btn\" ng-click=\"popoverCtrl.save(popoverCtrl.value)\">Save\r\n        </button>\r\n      </span>\r\n      </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/administration/detail.html","<div class=\"licensing\" ng-controller=\"AdministrationController as vm\">\r\n    <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n    <div class=\"wrapper wrapper-content\">\r\n      <div class=\"row\">\r\n        <div class=\"col-lg-12\">\r\n          <div class=\"ibox float-e-margins\">\r\n            <div class=\"ibox-title\">\r\n              <h4>Create Projects (batch)</h4>\r\n            </div>\r\n            <div class=\"ibox-content\">\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-2\">\r\n                  <input type=\"number\" class=\"form-control\" placeholder=\"Projects to create\" ng-model=\"vm.count\">\r\n                </div>\r\n                <div class=\"col-lg-2\">\r\n                  <input type=\"number\" class=\"form-control\" placeholder=\"Project template id\" ng-model=\"vm.projectTemplateId\">\r\n                </div>\r\n                <div class=\"col-lg-2\">\r\n                  <datepicker ng-model=\"vm.startDate\" placeholder=\"Start Date\"></datepicker>\r\n                </div>\r\n                <label>\r\n                  <input icheck type=\"checkbox\" class=\"checkbox\" ng-model=\"vm.repeat\">Repeat\r\n                </label>\r\n                <div class=\"col-lg-2\" ng-if=\"vm.repeat && vm.startDate\">\r\n                  <input type=\"number\" class=\"form-control\" placeholder=\"Hours to add after iteration\" ng-model=\"vm.hoursToAdd\">\r\n                </div>\r\n                <div class=\"col-lg-2\" ng-if=\"vm.repeat\">\r\n                  <input type=\"number\" class=\"form-control\" placeholder=\"Interval (seconds)\" ng-model=\"vm.intervalSeconds\">\r\n                </div>\r\n\r\n                <button class=\"btn btn-primary\" ng-click=\"vm.createProjectsBatch()\">\r\n                  Create\r\n                  <sk-spinner-circle ng-if=\"vm.busy\" ng-disabled=\"vm.busy\"></sk-spinner-circle>\r\n                </button>\r\n                <span ng-if=\"vm.totalCount\"><label class=\"label label-success\">{{vm.totalCount}}</label> projects were created in total</span>\r\n              </div>\r\n              <div class=\"alert alert-success\" ng-repeat=\"r in vm.res track by $index\">{{r.count}} projects were created ({{r.date | dateTimeFromUtc}})</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/modules/siskin/clientdashboard/detail.html","<div class=\"clientdashboard\" ng-controller=\"ClientDashboardController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n    <sk-spinner ng-if=\"vm.isLoading()\"></sk-spinner>\r\n    <div ng-if=\"!vm.isLoading()\" class=\"wrapper wrapper-content\">\r\n      <div class=\"row content-end-wrapper\">\r\n        <div class=\"col-lg-12 dashboard-filter\">\r\n          <div class=\"ibox float-e-margins flexeverything\">\r\n              <div class=\"col-lg-3 col-xs-12 m-b-xs\">\r\n                <datepicker-range ng-model=\"vm.filters.dateRange\" ng-change=\"vm.search()\" options=\"vm.dateRangeOptions\" ng-clear=\"vm.resetDateFilter()\" placeholder=\"projectdashboard.filter.daterangeplaceholder\">\r\n              </datepicker-range></div>\r\n            <span class=\"flexeverything--spacer\"></span>\r\n            <a class=\"btn btn-primary m-b-z\" ui-sref=\"siskin.inbox\">\r\n              <i class=\"fa fa-inbox\"></i> {{\'clientdashboard.viewinbox\' | translate}}\r\n            </a>\r\n              <dropdown ng-if=\"vm.projectTemplates.length\" ng-model=\"vm.filters.projectTemplateId\" ng-values=\"vm.projectTemplates\" class=\"m-l-sm\" placeholder=\"{{\'projectdashboard.filter.projecttemplateplaceholder\'| translate}}\" prop=\"id\" ng-change=\"vm.search()\">\r\n\r\n              <ui-select ng-if=\"vm.clients.length > 2\" class=\"m-l-sm\" ng-model=\"vm.filters.selectedClient\" on-select=\"vm.search($item.resource)\">\r\n                <ui-select-match allow-clear=\"false\" placeholder=\"{{\'attribute.dropdown.placeholder\'|translate}}\">{{$select.selected.name}}</ui-select-match>\r\n                <ui-select-choices repeat=\"client in vm.clients | filter: $select.search\">\r\n                  {{client.name}}\r\n                </ui-select-choices>\r\n              </ui-select>\r\n          </dropdown></div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row widget-section-xs\" ng-if=\"vm.widgets\">\r\n        <div ng-repeat=\"widget in vm.widgets as w\" ng-switch=\"widget.type\">\r\n          <widget-piechart-projectinstances-overview ng-switch-when=\"piechart-projectinstances\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-piechart-projectinstances-overview>\r\n          <widget-piechart-projectinstances-client ng-switch-when=\"piechart-projectinstances-client\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-piechart-projectinstances-client>\r\n          <widget-piechart-projectinstances-projecttype ng-switch-when=\"piechart-projectinstances-projecttype\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-piechart-projectinstances-projecttype>\r\n          <widget-barchart-projectinstances-country ng-switch-when=\"barchart-projectinstances-country\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-barchart-projectinstances-country>\r\n          <widget-barchart-projectinstances-brand ng-switch-when=\"barchart-projectinstances-brand\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-barchart-projectinstances-brand>\r\n          <widget-map-projectinstances ng-switch-when=\"map-projectinstances\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header || \'widget.mapprojects.title\'}}\"></widget-map-projectinstances>\r\n          <widget-list-projectinstancemilestones ng-switch-when=\"list-projectinstancemilestones\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-list-projectinstancemilestones>\r\n          <widget-list-projecttemplatoverview ng-switch-when=\"list-projecttemplateoverview\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header || \'widget.mapprojects.title\'}}\"></widget-list-projecttemplatoverview>\r\n          <widget-linechart-projectinstances ng-switch-when=\"linechart-projectinstances\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-linechart-projectinstances>\r\n\r\n          <widget-v2-piechart-projectinstances-overview ng-switch-when=\"v2-piechart-projectinstances\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-v2-piechart-projectinstances-overview>\r\n          <widget-v2-barchart-projectinstances-country ng-switch-when=\"v2-barchart-projectinstances-country\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-v2-barchart-projectinstances-country>\r\n          <widget-v2-map-projectinstances ng-switch-when=\"v2-map-projectinstances\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header || \'widget.mapprojects.title\'}}\"></widget-v2-map-projectinstances>\r\n          <widget-v2-list-projectinstancemilestones ng-switch-when=\"v2-list-projectinstancemilestones\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-v2-list-projectinstancemilestones>\r\n          <widget-v2-list-projecttemplatoverview ng-switch-when=\"v2-list-projecttemplateoverview\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header || \'widget.projecttemplatelist.title\'}}\"></widget-v2-list-projecttemplatoverview>\r\n          <widget-v2-linechart-projectinstances ng-switch-when=\"v2-linechart-projectinstances\" filters=\"vm.filters\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-v2-linechart-projectinstances>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n");
$templateCache.put("app/modules/siskin/concern/detail.html","<div class=\"concernDetail\" ng-controller=\"ConcernDetailController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <sk-spinner ng-show=\"!vm.data\"></sk-spinner>\r\n\r\n  <div class=\"wrapper wrapper-content\" ng-if=\"vm.data\">\r\n  <!-- not found -->\r\n    <div class=\"not-found-panel\" ng-show=\"vm.error\">\r\n      <div class=\"ibox float-e-margins\">\r\n        <div class=\"ibox-content\">\r\n          <i class=\"fa fa-exclamation-circle fa-3x\"></i>\r\n          <h3 translate>concern.detail.notfound</h3>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"ibox float-e-margins\">\r\n      <div class=\"ibox-title concernDetail__progress__header flexeverything\">\r\n        <h4 class=\"concernDetail__progress__header--title\" ng-show=\"vm.data\">\r\n          <div class=\"row\">\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.name</span>:\r\n              <strong>{{vm.data.name | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.code</span>:\r\n              <strong>{{vm.data.code | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.sitecode</span>:\r\n              <strong>{{vm.data.siteCode | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.address</span>:\r\n              <strong>{{vm.data.address | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.postcode</span>:\r\n              <strong>{{vm.data.postCode | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.state</span>:\r\n              <strong>{{vm.data.state | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.region</span>:\r\n              <strong>{{vm.data.region | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.country</span>:\r\n              <strong>{{vm.data.country | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.nationalstorenumber</span>:\r\n              <strong>{{vm.data.nationalStoreNumber | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.latitude</span>:\r\n              <strong>{{vm.data.coordinates.latitude | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.longitude</span>:\r\n              <strong>{{vm.data.coordinates.longitude | ornotset}}</strong>\r\n            </p>\r\n            <p class=\"col-xs-12 col-sm-6\">\r\n              <span translate>concern.concerntype</span>:\r\n              <strong>{{vm.data.concernType | ornotset}}</strong>\r\n            </p>\r\n          </div>\r\n        </h4>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"ibox float-e-margins\" ng-if=\"vm.maps\">\r\n      <div class=\"ibox-content\">\r\n        <maps width=\"100%\" height=\"380px\" data=\"vm.maps\"></maps>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"ibox float-e-margins\">\r\n      <div class=\"ibox-title flexeverything\">\r\n        <h4 class=\"flexeverything--spacer\" translate>concern.projectinstances</h4>\r\n        <label can-do=\"projectInstanceEdit\"><input icheck type=\"checkbox\" ng-model=\"vm.filter.showInactive\" ng-change=\"vm.data.pager.reset()\">\r\n          {{\'widget.projectlistmilestones.showdeactivated\'|translate}}\r\n        </label>\r\n      </div>\r\n      <div class=\"ibox-content\" ng-if=\"vm.data\">\r\n        <project-instance-list ng-model=\"vm.data\" filter=\"vm.filter\"></project-instance-list>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/documentation/list.html","<div class=\"documentation\" ng-controller=\"DocumentationController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <sk-spinner ng-show=\"!vm.data\"></sk-spinner>\r\n    <div class=\"row\" ng-if=\"vm.data\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"float-e-margins\">\r\n          <div class=\"jobadminlist__title\">\r\n            <span class=\"flexeverything--spacer\"></span>\r\n            <button class=\"btn btn-primary\" ng-click=\"vm.create()\" can-do=\"documentationEdit\">\r\n              <i class=\"fa fa-plus-circle\"></i>\r\n              <span translate>filecontainers.add</span>\r\n            </button>\r\n          </div>\r\n          <div>\r\n            <div ng-repeat=\"m in vm.data\" class=\"ibox\">\r\n              <div can-do=\"documentationEdit\" negate>\r\n                <div class=\"ibox-title\">\r\n                  <h4><i class=\"fa fa-book m-r-xs\"></i>{{m.name}}</h4>\r\n                </div>\r\n                <div class=\"ibox-content\">\r\n                  <h5>{{m.description}}</h5>\r\n                  <filelist list=\"m.files\"></filelist>\r\n                  <div class=\"alert alert-info m-b-none\" ng-if=\"!m.files.length\" translate>common.nodatatoshow</div>\r\n                </div>\r\n              </div>\r\n\r\n              <div can-do=\"documentationEdit\">\r\n                <fileupload container=\"m.resource\" container-id=\"m.id\" update-file-callback=\"m.addOrUpdateFile\" start-callback=\"m.init\" callback-start-process=\"m.startProcess\" callback-end-process=\"m.endProcess\">\r\n                  <div class=\"ibox-title flexeverything\">\r\n                    <input class=\"form-control m-b-xs documentation__name\" type=\"text\" ng-model=\"m.name\" translate-attr=\"{\'placeholder\':\'filecontainers.nameplaceholder\'}\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" ng-change=\"vm.update(m)\" ng-if=\"!m.busy\">\r\n                    <div class=\"flexeverything--spacer\"></div>\r\n                    <div class=\"btn-group m-l-sm\">\r\n                      <button confirmation-modal btn-style=\"btn-danger\" class=\"btn btn-danger btn-outline\" ng-click=\"vm.remove(m)\" translate>common.delete</button>\r\n                  </div>\r\n                </div>\r\n                  <div class=\"ibox-content\" ng-show=\"!m.isBusy\">\r\n                    <div class=\"flexeverything\">\r\n                      <input class=\"form-control m-b-xs\" type=\"text\" ng-model=\"m.description\" translate-attr=\"{\'placeholder\':\'filecontainers.descriptionplaceholder\'}\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" ng-change=\"vm.update(m)\" ng-if=\"!m.isBusy\">\r\n                      <div class=\"flexeverything--spacer\"></div>\r\n                      <label class=\"label-fileupload m-b-none m-l-xs\" for=\"{{ m.id }}\" ng-show=\"!m.anyFileSelected()\">\r\n                        <div class=\"btn btn-info btn-fileupload btn-fileupload--start\">\r\n                          <i class=\"fa fa-cloud-upload\"></i>\r\n                        </div>\r\n                      </label>\r\n\r\n                      <a class=\"btn btn-danger m-l-xs\" ng-click=\"m.removeSelected()\" ng-show=\"m.anyFileSelected()\">\r\n                        <i class=\"fa fa-trash\"></i>\r\n                      </a>\r\n                      <a class=\"btn btn-primary m-l-xs\" ng-click=\"m.rotateSelectedImages()\" ng-show=\"m.anyFileSelected() && m.allSelectedAreImages()\">\r\n                        <i class=\"fa fa-repeat\"></i>\r\n                      </a>\r\n                    </div>\r\n                    <filelist selectable list=\"m.files\"></filelist>\r\n                  </div>\r\n                </fileupload>\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/modules/siskin/downloadexternal/downloadexternal.html","<div class=\"downloadexternal taskinstancedetail interactive\" ng-controller=\"DownloadExternalController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n\r\n  <div ng-if=\"vm.file\" style=\"max-width: 600px;margin:auto;\" class=\"row alert alert-success text-center\">\r\n    <h2 class=\"m-n\"><b><i class=\"fa fa-file m-r-lg\"></i>{{vm.file.displayName}}</b></h2>\r\n  </div>\r\n\r\n  <div class=\"wrapper wrapper-content text-center\" ng-if=\"!vm.loaded\">\r\n    <h1 translate>download.downloadingmessage</h1>\r\n  </div>\r\n\r\n  <sk-spinner ng-if=\"!vm.loaded\"></sk-spinner>\r\n\r\n\r\n  <div class=\"wrapper wrapper-content text-center\" ng-if=\"vm.loaded\">\r\n    <h1 ng-hide=\"vm.hasError\" translate>download.downloadsuccessfully</h1>\r\n    <h1 ng-hide=\"!vm.hasError\" translate>download.downloadnotfound</h1>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/emailtemplate/list.create.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>emailtemplates.create.title</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>emailtemplates.name</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"vmModal.name\">\r\n        </div>\r\n    </div></form>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" ng-disabled=\"!vmModal.name.length\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.create</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/emailtemplate/list.edit.html","<div ng-if=\"vm.emailTemplateType\">\r\n    <button ng-click=\"vm.back()\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-chevron-left m-r-xs\"></i>{{\'common.back\' | translate}}</button>\r\n    <div class=\"mail-box-header\">\r\n      <div>\r\n          <h4 class=\"flexeverything\">{{ (vm.selected.name || \'emailtemplates.global\') | translate}}\r\n            <span ng-if=\"vm.selectedtask\" class=\"m-l-xs\">{{\"/ \"+ vm.selectedtask.name}}</span>\r\n            <span class=\"m-l-xs\">/</span>\r\n            <span ng-if=\"vm.emailTemplateType.type != \'custom\'\" class=\"m-l-xs\">{{(\'enum.emailtemplatetype.\' + vm.emailTemplateType.type) | translate}}</span>\r\n            <span ng-if=\"vm.emailTemplateType.type == \'custom\' && !vm.emailTemplateType.renaming\" class=\"m-l-xs\">{{vm.emailTemplateType.name}}</span>\r\n            <input ng-if=\"vm.emailTemplateType.renaming\" type=\"text\" class=\"flex input input-sm form-control m-l-xs\" ng-model=\"vm.emailTemplateType.name\">\r\n            <div class=\"pull-right\" ng-if=\"vm.emailTemplateType.type == \'custom\' && !vm.emailTemplateType.renaming\">\r\n              <button class=\"btn btn-default btn-sm m-l-sm m-t-xs\" ng-click=\"vm.emailTemplateType.renaming = true\">\r\n                <i class=\"fa fa-edit\"></i>\r\n                {{\'common.edit\'|translate}}\r\n              </button>\r\n            </div>\r\n\r\n            <div class=\"pull-right\" ng-if=\"vm.emailTemplateType.renaming\">\r\n              <button class=\"btn btn-primary btn-sm m-l-xs m-t-xs\" ng-click=\"vm.updateName(vm.emailTemplateType)\">\r\n                <i class=\"fa fa-check\"></i>\r\n              </button>\r\n              <button class=\"btn btn-danger btn-sm m-t-xs\" ng-click=\"vm.emailTemplateType.renaming = false\">\r\n                <i class=\"fa fa-times\"></i>\r\n              </button>\r\n            </div>\r\n\r\n            <span class=\"flexeverything--spacer hidden-xs hidden-md\"></span>\r\n\r\n          </h4>\r\n      </div>\r\n      <div>\r\n        <div class=\"mail-tools tooltip-demo m-t-md\">\r\n          <div class=\"btn-group\">\r\n            <button type=\"button\" ng-if=\"lang.key\" ng-repeat=\"lang in vm.emailTemplateType.emailTemplatesByLanguage\" class=\"btn\" ng-class=\"{\'active\' : lang === vm.language , \'btn-primary\' : ((lang.value | notTransient).length), \'btn-white\' : !((lang.value | notTransient).length) }\" ng-click=\"vm.selectLanguage(lang)\">\r\n              <img src=\"{{lang.key}}\">\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n  </div>\r\n    <div class=\"mail-box-header emailtemplatelist__emailtemplate\" ng-if=\"vm.language\">\r\n      <div class=\"flexeverything\">\r\n        <dropdown ng-repeat=\"t in vm.emailTemplateType.tools\" ng-values=\"t.values\" ng-model=\"vm.selectedValue\" ng-change=\"vm.addValue(vm.selectedValue)\" placeholder=\"{{t.displayText}}\" clear-on-select=\"true\" class=\"m-r-sm\"></dropdown>\r\n\r\n        <div class=\"flexeverything--spacer\"></div>\r\n        <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.emailTemplate.changed\" ng-click=\"vm.save(vm.emailTemplate)\" ng-disabled=\"vm.emailTemplate.saving\">\r\n          <i class=\"fa fa-floppy-o\"></i>\r\n          {{\'emailtemplates.save\' | translate}}\r\n        </button>\r\n        <button class=\"btn btn-danger btn-sm m-l-sm\" ng-if=\"vm.canDelete(vm.emailTemplate)\" ng-click=\"vm.remove(vm.emailTemplate)\">\r\n          <i class=\"fa fa-trash\"></i>\r\n          {{\'emailtemplates.delete\' | translate}}\r\n        </button>\r\n      </div>\r\n\r\n      <uib-tabset class=\"tabs-container m-t-sm\" active=\"vm.currentTab\">\r\n        <uib-tab ng-repeat=\"t in vm.language.value | orderBy: \'channel\'\" ng-click=\"vm.selectEmailTemplate(t)\">\r\n          <uib-tab-heading>\r\n            <div ng-switch=\"t.channel\">\r\n              <i ng-switch-when=\"email\" class=\"fa fa-envelope\" ng-class=\"{\'has-value\': t.id}\"></i>\r\n              <i ng-switch-when=\"sms\" class=\"fa fa-mobile\" ng-class=\"{\'has-value\': t.id}\"></i>\r\n            </div>\r\n          </uib-tab-heading>\r\n          <div class=\"panel-body\" ng-switch=\"t.channel\">\r\n            <!--email-->\r\n            <div ng-switch-when=\"email\">\r\n              <div class=\"col-lg-4\">\r\n                <h6 class=\"m-b-none\" ng-if=\"!t.isLayout\" translate>emailtemplates.subject</h6>\r\n                <input class=\"form-control m-b-md\" ng-model=\"t.subject\" ng-if=\"!t.isLayout\" ng-change=\"vm.change(t)\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 1000, \'blur\': 0 }}\">\r\n                <h6 class=\"m-b-none\" ng-if=\"!t.isLayout\" translate>emailtemplates.header</h6>\r\n                <input class=\"form-control m-b-md\" ng-model=\"t.header\" ng-if=\"!t.isLayout\" ng-change=\"vm.change(t)\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 1000, \'blur\': 0 }}\">\r\n                <h6 class=\"m-b-none\" translate>emailtemplates.body</h6>\r\n                <textarea class=\"form-control m-b-md\" ng-model=\"t.body\" ng-change=\"vm.change(t)\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 1000, \'blur\': 0 }}\"></textarea>\r\n              </div>\r\n              <div class=\"col-lg-8 emailtemplatelist__emailtemplate__preview--email\" ng-if=\"t.preview\">\r\n                <div class=\"panel panel-default\">\r\n                  <div class=\"panel-heading\">\r\n                    <b translate>emailtemplates.preview</b>\r\n                    <div ng-if=\"t.preview.subject\">\r\n                      {{ \'emailtemplates.subject\' | translate }} : <span>{{t.preview.subject}}</span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"panel-body\">\r\n                    <div ng-bind-html=\"t.preview.body | trustedHtml\"></div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div ng-if=\"vm.emailTemplate\" class=\"pull-right mail-search m-l-xl col-xs-12 col-md-6\">\r\n                <div class=\"input-group\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" ng-model=\"vm.emailTemplate.sendEmail\" ng-disabled=\"vm.busy\" translate-attr=\"{placeholder: vm.userEmail}\">\r\n                  <div class=\"input-group-btn\">\r\n                    <button class=\"btn btn-sm btn-primary\" ng-disabled=\"vm.busy\" ng-click=\"vm.send(vm.emailTemplate)\" translate>emailtemplates.send</button>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--sms-->\r\n            <div ng-switch-when=\"sms\">\r\n              <div class=\"col-lg-4\">\r\n                <h6 class=\"m-b-none\" translate>emailtemplates.body</h6>\r\n                <textarea class=\"form-control m-b-md\" ng-model=\"t.body\" ng-change=\"vm.change(t)\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 1000, \'blur\': 0 }}\"></textarea>\r\n              </div>\r\n              <div class=\"col-lg-8 emailtemplatelist__emailtemplate__preview\">\r\n                <div class=\"panel panel-default\">\r\n                  <div class=\"panel-heading\">\r\n                    <b translate>emailtemplates.preview</b>\r\n                  </div>\r\n                  <div class=\"panel-body\">\r\n                    <div class=\"panel\">{{t.preview.body}}</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            \r\n          </div>\r\n        </uib-tab>\r\n      </uib-tabset>\r\n    </div>\r\n  </div>\r\n\r\n    \r\n  \r\n\r\n");
$templateCache.put("app/modules/siskin/emailtemplate/list.html","<div class=\"emailtemplatelist\" ng-controller=\"EmailTemplateListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <sk-spinner ng-if=\"!vm.data\"></sk-spinner>\r\n    <div class=\"row\" ng-if=\"vm.data\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title taskinstancelist__title breadcrumb\">\r\n            <h4 translate>nav.emailtemplates</h4>\r\n          </div>\r\n      <div class=\"ibox-content\">\r\n\r\n        <div class=\"row m-b-lg\">\r\n          <!--project templates-->\r\n          <div class=\"col-sm-4\">\r\n            <label class=\"control-label\" translate>search.itemtype.projecttemplate</label>\r\n          <dropdown ng-if=\"vm.data.projectTemplates\" ng-values=\"vm.data.projectTemplates\" ng-model=\"vm.selected\" ng-change=\"vm.selectProject()\"></dropdown>\r\n          </div>\r\n          <!--task templates-->\r\n          <div class=\"col-sm-4\" ng-if=\"vm.selected.taskTemplates\" can-do=\"adminTaskEmailTemplateEdit\">\r\n            <label class=\"control-label\" translate>search.itemtype.taskname</label>\r\n                  <dropdown ng-values=\"vm.selected.taskTemplates\" ng-model=\"vm.selectedtask\" ng-change=\"vm.selectTask()\"></dropdown>\r\n          </div>\r\n          <button class=\"pull-right btn btn-primary m-r-sm\" ng-click=\"vm.create()\" ng-if=\"vm.selected && !vm.emailTemplateType\" translate>common.create</button>\r\n          <button ng-if=\"vm.emailTemplateType && vm.emailTemplateType.type == \'custom\'\" confirmation-modal btn-style=\"btn-danger\" class=\"pull-right btn btn-danger m-r-sm\" text=\"emailtemplates.delete.description\" title=\"{{\'emailtemplates.delete.title\' | translate}}\" ng-click=\"vm.removeEmailTemplateType()\">\r\n                <i class=\"fa fa-times m-r-xs\"></i><span translate>common.delete</span>\r\n          </button>\r\n      </div>\r\n\r\n      <div ng-if=\"vm.selected && !vm.emailTemplateType\">\r\n        <sk-spinner ng-if=\"!vm.data\"></sk-spinner>\r\n        <div ng-if=\"vm.data\">\r\n\r\n          <!-- custom emails -->\r\n          <table class=\"table table-hover table-mail table-bordered table-clickable\" ng-if=\"vm.totalCustomTemplates\">\r\n            <thead>\r\n              <tr><th colspan=\"3\" translate>emailtemplates.customtypes</th></tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"t in vm.selected.emailTemplateTypes | filter:{isLayout:false,type:\'Custom\'}\" ng-if=\"t.name !== \'\'\" ng-click=\"vm.selectEmailTemplateType(t)\">\r\n              <td><b>{{ t.name }}</b></td>\r\n              <td>{{\'emailtemplates.description.\' + t.type | translate}}</td>\r\n              <td>\r\n                <span class=\"label pull-right\" ng-class=\"{\'label-info\': t.emailTemplatesCount}\">{{ t.emailTemplatesCount }}</span>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n\r\n          <!-- predefined email template types -->\r\n          <table class=\"table table-hover table-mail table-bordered table-clickable\">\r\n            <thead>\r\n              <tr><th colspan=\"3\" translate>emailtemplates.types</th></tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"t in vm.selected.emailTemplateTypes | filter:{isLayout:false,type:\'!Custom\'}\" ng-click=\"vm.selectEmailTemplateType(t)\">\r\n              <td><b>{{(\'enum.emailtemplatetype.\' + t.type) | translate}}</b></td>\r\n              <td>{{\'emailtemplates.description.\' + t.type | translate}}</td>\r\n              <td>\r\n                <span class=\"label pull-right\" ng-class=\"{\'label-info\': t.emailTemplatesCount}\">{{ t.emailTemplatesCount }}</span>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n\r\n          <!-- layouts -->\r\n          <table class=\"table table-hover table-mail table-bordered table-clickable m-t-lg\">\r\n            <thead>\r\n              <tr><th colspan=\"3\" translate>emailtemplates.layouts</th></tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat=\"t in vm.selected.emailTemplateTypes | filter:{isLayout:true}\" ng-click=\"vm.selectEmailTemplateType(t)\">\r\n              <td><b>{{(\'enum.emailtemplatetype.\' + t.type) | translate}}</b></td>\r\n              <td>{{\'emailtemplates.description.\' + t.type | translate}}</td>\r\n              <td>\r\n                <span class=\"label pull-right\" ng-class=\"{\'label-info\': t.emailTemplatesCount}\">{{ t.emailTemplatesCount }}</span>\r\n              </td>\r\n            </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n      <div ng-include=\"\'app/modules/siskin/emailtemplate/list.edit.html\'\"></div>\r\n  </div>\r\n  </div>\r\n</div>\r\n</div></div></div>");
$templateCache.put("app/modules/siskin/home/view.html","<div ng-controller=\"HomeController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/integration/list.html","<div ng-controller=\"IntegrationApiController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <sk-spinner ng-show=\"!vm.data\"></sk-spinner>\r\n    <div class=\"row\" ng-if=\"vm.data\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title\">\r\n            <h4 translate>integration.list.title</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"row m-b-sm filter-panel-xs\">\r\n              <div class=\"col-lg-4\">\r\n                <input class=\"form-control\" type=\"text\" ng-model=\"vm.searchRequestInput.searchTerm\" ng-change=\"vm.search()\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" placeholder=\"{{\'integration.list.search.placeholder\' | translate}}\">\r\n              </div>\r\n\r\n              <div class=\"col-lg-3 date-range-picker\">\r\n                <datepicker-range ng-change=\"vm.search()\" ng-model=\"vm.createdOnInputFilter\" placeholder=\"{{\'integration.list.createdon.placeholder\' | translate}}\">\r\n              </div>\r\n\r\n              <ui-select class=\"col-lg-2\" ng-model=\"vm.selectedStatusOption\" ng-change=\"vm.search()\">\r\n                <ui-select-match>\r\n                    <span ng-bind=\"vm.selectedStatusOption\"></span>\r\n                </ui-select-match>\r\n                <ui-select-choices repeat=\"option in vm.statusOptions\">\r\n                    <span ng-bind=\"option\"></span>\r\n                </ui-select-choices>\r\n            </ui-select>\r\n\r\n              <div class=\"col-lg-3\">\r\n                <button type=\"button\" class=\"btn\" ng-click=\"vm.reset()\" translate>common.reset</button>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"well text-center\" ng-if=\"vm.data.items.length == 0\">\r\n              <span translate>integration.list.empty</span>\r\n            </div>\r\n\r\n            <table ng-if=\"vm.data.items.length != 0\" class=\"table table-clickable\">\r\n              <tr>\r\n                <th translate>integration.list.alternatekey</th>\r\n                <th translate>integration.list.name</th>\r\n                <th translate>integration.list.uniquereference</th>\r\n                <th translate>integration.list.status</th>\r\n                <th translate>integration.list.createdon</th>\r\n              <tbody>\r\n                <tr ng-repeat-start=\"request in vm.data.items\" ng-click=\"vm.onRequestExpandClicked(request.alternateKey)\">\r\n                  <td>\r\n                    {{request.alternateKey}}\r\n                  </td>\r\n                  <td>{{request.name}}</td>\r\n                  <td>{{request.uniqueReference}}</td>\r\n                  <td>\r\n                    <span class=\"label label-{{vm.getStatusClass(request.statusName)}}\">{{request.statusName}}</span>\r\n                    </td>\r\n                  <td>{{request.createdOn | date: \'dd-MM-yyyy HH:mm:ss\'}}</td>\r\n                </tr>\r\n                  <tr ng-if=\"vm.expandedRequestKey == request.alternateKey\" ng-repeat-end=\"\">\r\n                    <td colspan=\"5\">\r\n\r\n                      <div class=\"col-md-12\">\r\n                        <div ng-repeat=\"task in request.tasks\">\r\n                          <div class=\"col-md-4\">\r\n                            <div class=\"panel panel-{{vm.getStatusClass(task.status)}}\">\r\n                              <div class=\"panel-heading\">\r\n                                <div class=\"btn-group pull-right\">\r\n                                  <button class=\"btn btn-primary\" ng-if=\"task.status !=\'Completed\'\" ng-click=\"vm.onRetryTaskClicked(task)\">\r\n                                    <i class=\"fa fa-repeat\"></i>\r\n                                    <span translate>common.retry</span>\r\n                                  </button>\r\n                                </div>\r\n                                <h3>{{task.taskType}}</h3>\r\n                              </div>\r\n                              <div class=\"panel-body\">\r\n                                <div>\r\n                                  <span><strong>{{task.name}}</strong></span>\r\n                                </div>\r\n                                <span>{{task.completedOn | date: \'dd-MM-yyyy HH:mm:ss \'}}</span>\r\n                                <span>{{task.failedOn | date: \'dd-MM-yyyy HH:mm:ss \'}}</span>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n\r\n                      <div class=\"col-md-12\">\r\n                          <div ng-repeat=\"payload in request.payloads\">\r\n                            <div class=\"col-md-4\">\r\n                              <div class=\"panel panel-success\">\r\n                                <div class=\"panel-heading\">\r\n                                  <div class=\"btn-group pull-right\">\r\n                                    <button class=\"btn btn-primary\" ng-click=\"vm.downloadPayload(payload)\">\r\n                                      <i class=\"fa fa-download\"></i>\r\n                                      <span translate>common.download</span>\r\n                                    </button>\r\n                                  </div>\r\n                                  <h3>{{payload.payloadType}}</h3>\r\n                                </div>\r\n                                <div class=\"panel-body\">\r\n                                  <span>{{payload.createdOn | date: \'dd-MM-yyyy HH:mm:ss\'}}</span>\r\n                                </div>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n\r\n                        </div>\r\n                      </td></tr></tbody></tr></table></div>\r\n                    \r\n                  \r\n              \r\n            \r\n\r\n            <div class=\"flexeverything\">\r\n              <span class=\"flexeverything--spacer\"></span>\r\n              <ul class=\"text-right\" ng-if=\"vm.data.totalPages > 1\" uib-pagination total-items=\"vm.data.totalCount\" ng-model=\"vm.searchRequestInput.pageNumber\" max-size=\"vm.searchRequestInput.pageSize\" class=\"pagination-sm\" boundary-links=\"true\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"vm.refreshData()\"></ul>\r\n            </div>\r\n            <sk-spinner ng-show=\"vm.busy\"></sk-spinner>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n\r\n");
$templateCache.put("app/modules/siskin/licensing/list.html","<div class=\"licensing\" ng-controller=\"LicensingController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <sk-spinner ng-if=\"!vm.data && !vm.error\"></sk-spinner>\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title\">\r\n            <h4 translate>licenses.title</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <table ng-if=\"vm.data || vm.error\" class=\"table table-striped\">\r\n              <thead>\r\n                <tr>\r\n                  <th translate>licenses.clientname</th>\r\n                  <th translate>licenses.validfrom</th>\r\n                  <th translate>licenses.validto</th>\r\n                  <th translate></th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-if=\"!vm.error\">\r\n                  <td><b>{{vm.data.clientName}}</b></td>\r\n                  <td>{{vm.data.validFrom | dateFromUtc}}</td>\r\n                  <td>\r\n                    {{vm.data.validTo | dateFromUtc}}\r\n                    <i ng-if=\"vm.data.isExpiringUrgent\" title=\"{{\'licensing.info.isexpiringurgent\'| translate}}\" class=\"fa fa-warning text-danger\"></i>\r\n                    <i ng-if=\"vm.data.isExpiring && !vm.data.isExpiringUrgent\" title=\"{{\'licensing.info.isexpiring\'| translate}}\" class=\"fa fa-warning text-warning\"></i>\r\n                  </td>\r\n                  <td>\r\n                      <label ng-if=\"!vm.data.isExpiredInGrace\" class=\"label label-success\"><i class=\"fa fa-check-circle-o m-r-sm\"></i>{{\'licenses.validlicense\' | translate}}</label>\r\n                      <label ng-if=\"vm.data.isExpiredInGrace\" class=\"label label-danger\"><i class=\"fa fa-warning m-r-sm\"></i>{{\'licenses.expiredlicense\' | translate}}</label>\r\n                  </td>\r\n                </tr>\r\n                <tr ng-if=\"vm.error\">\r\n                  <td colspan=\"4\" class=\"text-center text-danger\"> <i class=\"fa fa-ban\"></i> {{ \'licenses.invalidlicense\' | translate}} </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/metaDataEntity/list.create.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>{{\'metadataentity.create.title.\' + vmModal.data.type | lowercase}}</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>metadataentity.property.name</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"vmModal.data.name\" ng-enter=\"vmModal.save()\" auto-focus>\r\n        </div>\r\n    </div></form>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" translate ng-disabled=\"vmModal.data.name == null || vmModal.data.name == \'\'\">common.create</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/metaDataEntity/list.delete.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>{{\'metadataentity.delete.title.\' + vmModal.data.type | lowercase}}</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <div>\r\n        <label translate>{{\'metadataentity.delete.message.\' + vmModal.data.type | lowercase }}</label>\r\n    </div>\r\n    <div>\r\n        <label type=\"text\">{{vmModal.data.name}}</label>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary btn-danger\" ng-click=\"vmModal.remove()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.delete</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/metaDataEntity/list.html","<div class=\"jobadminlist\" ng-controller=\"MetaDataEntityListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title jobadminlist__title\">\r\n            <h4 translate>{{\'metadataentity.list.title.\' + vm.type | lowercase}}</h4>\r\n            <button class=\"btn btn-primary\" ng-click=\"vm.create()\">\r\n              <i class=\"fa fa-plus-circle\"></i>\r\n              <span class=\"hidden-xs\" translate>{{\'metadataentity.list.create.\' + vm.type | lowercase}}</span>\r\n            </button>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n\r\n            <div class=\"autosearch m-b-sm\">\r\n                <input class=\"form-control\" ng-model=\"vm.search.query\" translate-attr=\"{placeholder: \'common.searchplaceholder\'}\" ng-change=\"vm.reset()\">\r\n            </div>\r\n            <div class=\"well text-center\" ng-if=\"vm.pager.items.length == 0\">\r\n              <span translate>metadataentity.list.empty</span>\r\n            </div>\r\n            <table class=\"table\">\r\n\r\n              <tbody>\r\n                <tr ng-repeat=\"m in vm.pager.items | orderBy: \'name\'\">\r\n                  <td class=\"center\" ng-if=\"!m.edit\">{{m.name}}</td>\r\n                  <td ng-if=\"m.edit\">\r\n                    <form ng-submit=\"vm.update(m)\">\r\n                        <input type=\"text\" class=\"form-control\" ng-model=\"m.edit.name\">\r\n                        <input type=\"submit\" class=\"hidden form-control\">\r\n                    </form>\r\n                  </td>\r\n                  <td class=\"text-right\">\r\n                    <!-- Desktop actions column -->\r\n                    <div class=\"hidden-xs\">\r\n                      <button class=\"btn btn-default\" ng-if=\"!m.edit\" ng-click=\"vm.edit(m)\" translate>\r\n                        common.edit\r\n                    </button>\r\n                    <button class=\"btn btn-danger btn-outline\" ng-if=\"!m.edit\" ng-click=\"vm.remove(m)\" translate>\r\n                        common.delete\r\n                    </button>\r\n                    <button class=\"btn btn-primary\" ng-if=\"m.edit\" ng-click=\"vm.update(m)\" translate ng-disabled=\"m.edit.name == null || m.edit.name == \'\'\">\r\n                        common.save\r\n                    </button>\r\n                    <button class=\"btn btn-default\" ng-if=\"m.edit\" ng-click=\"vm.cancel(m)\" translate>\r\n                        common.cancel\r\n                    </button>\r\n                    </div>\r\n                    <!-- Mobile actions column -->\r\n                    <div class=\"visible-xs dropdown\">\r\n                      <button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" translate>workflow.wfentity.actions</button>\r\n                      <div class=\"dropdown-menu dropdown-menu-right\">\r\n                        <button class=\"btn btn-default\" ng-if=\"!m.edit\" ng-click=\"vm.edit(m)\">\r\n                          <i class=\"fa fa-pencil\"></i> <span translate>common.edit</span>\r\n                      </button>\r\n                      <button class=\"btn btn-danger btn-outline\" ng-if=\"!m.edit\" ng-click=\"vm.remove(m)\">\r\n                          <i class=\"fa fa-trash-o\"></i> <span translate>common.delete</span>\r\n                      </button>\r\n                      <button class=\"btn btn-primary\" ng-if=\"m.edit\" ng-click=\"vm.update(m)\">\r\n                          <i class=\"fa fa-check\"></i> <span translate>common.save</span>\r\n                      </button>\r\n                      <button class=\"btn btn-default\" ng-if=\"m.edit\" ng-click=\"vm.cancel(m)\">\r\n                          <i class=\"fa fa-times\"></i> <span translate>common.cancel</span>\r\n                      </button>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n            <pager ng-model=\"vm.pager\"></pager>\r\n          </div>\r\n        </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n");
$templateCache.put("app/modules/siskin/monitoring/home.html","<div class=\"systemmonitoring\" ng-controller=\"SystemMonitoringController as vm\">\r\n    <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n    <div class=\"row widget-section-xs\">\r\n\r\n        <div class=\"row m-t-lg col-lg-12\">\r\n              <dropdown ng-if=\"vm.projectTemplates.length\" ng-model=\"vm.filter.projectTemplateId\" ng-values=\"vm.projectTemplates\" class=\"pull-right m-b-sm\" placeholder=\"{{\'projectdashboard.filter.projecttemplateplaceholder\'| translate}}\" prop=\"id\" ng-change=\"vm.search()\"></dropdown>\r\n        </div>\r\n\r\n        <widget-projectinstances-status class=\"col-lg-12\" filter=\"vm.filter\"></widget-projectinstances-status>\r\n        <widget-projectinstances-processtime class=\"col-lg-12\" filter=\"vm.filter\"></widget-projectinstances-processtime>\r\n        <widget-konnekt-requests class=\"col-lg-12\" filter=\"vm.filter\"></widget-konnekt-requests>\r\n    </div>\r\n</div>\r\n  ");
$templateCache.put("app/modules/siskin/note/note.create.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\">\r\n      {{\'taskinstance.note.addnote\' | translate}}\r\n      <label class=\"label label-info\" ng-if=\"vmModal.action\" translate>{{vmModal.action.name}}</label>\r\n    </h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <div class=\"col-lg-12\">\r\n          <textarea type=\"text\" class=\"form-control\" ng-model=\"vmModal.note\" style=\"resize:vertical\" placeholder=\"{{\'taskinstance.note.writeanote\'|translate}}\" rows=\"6\" auto-focus></textarea>\r\n        </div>\r\n        <div class=\"col-lg-offset-7 col-lg-5 m-t-sm\">\r\n          <dropdown-multiple ng-if=\"vmModal.projectRoleMappingsPager\" pager=\"vmModal.projectRoleMappingsPager\" ng-model=\"vmModal.projectRoleMappings\" placeholder=\"common.selectroles\"></dropdown-multiple>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" ng-disabled=\"!vmModal.note\" translate>common.save</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/noteContainer/noteContainer.modal.html","<div class=\"notesmodal\">\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>generic.action.close</span>\r\n    </button>\r\n    <h4 translate>projectinstance.detail.notes</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <uib-tabset class=\"tabs-container\" active=\"vmModal.activeTab\">\r\n      <uib-tab index=\"0\">\r\n        <uib-tab-heading ng-click=\"vmModal.cancelEdit()\" translate>notecontainer.notes</uib-tab-heading>\r\n        <div class=\"panel-body\">\r\n          <div class=\"col-sm-4\">\r\n            <ul class=\"agile-list sortable-list ui-sortable\" ui-sortable=\"vmModal.sortableOptions\" ng-model=\"vmModal.notes\" ng-if=\"vmModal.notes\">\r\n              <li class=\"success-element ui-sortable-handle\" ng-repeat=\"note in vmModal.notes\" ng-click=\"vmModal.selectNote(note)\" ng-class=\"vmModal.noteSelected.id == note.id ? \'note-selected\' : \'\'\">\r\n                <span class=\"text-truncate\">{{note.title}}</span>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <div class=\"col-sm-8 p-xs\">\r\n\r\n            <div ng-if=\"vmModal.editNote && !vmModal.editNote.isFileNote\">\r\n              <input type=\"text\" class=\"form-control m-b-xs\" ng-model=\"vmModal.noteCopy.title\" auto-focus>\r\n              <textarea class=\"form-control m-b-sm\" ng-model=\"vmModal.noteCopy.body\"></textarea>\r\n              <div class=\"pull-right\">\r\n                <button class=\"btn btn-default btn-outline\" ng-click=\"vmModal.cancelEdit()\"><i class=\"fa fa-times m-r-xs\"></i><span translate>common.cancel</span></button>\r\n                <button class=\"btn btn-primary\" ng-click=\"vmModal.update()\" ng-if=\"vmModal.noteCopy.resource\"><i class=\"fa fa-check m-r-xs\"></i><span translate>common.save</span></button>\r\n                <button class=\"btn btn-primary\" ng-click=\"vmModal.create()\" ng-if=\"!vmModal.noteCopy.resource\"><i class=\"fa fa-plus m-r-xs\"></i><span translate>generic.action.add</span></button>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"vmModal.noteSelected && !vmModal.editNote\" id=\"editNotePanel\">\r\n              <div class=\"m-l-xs m-b-md p-xs bg-muted editNotePanel__body\">{{vmModal.noteSelected.body}}</div>\r\n              <div class=\"pull-right\" ng-if=\"vmModal.canEditNotes\">\r\n                <button confirmation-button-panel target-element-id=\"editNotePanel\" class=\"btn btn-danger btn-outline\" h-auto=\"false\" confirm-message=\"notecontainer.deleteconfirmation\" error-message=\"notecontainer.deleteerror\" ng-click=\"vmModal.remove(vmModal.noteSelected)\"><i class=\"fa fa-times m-r-xs\"></i><span translate>generic.action.delete</span></button>\r\n\r\n                <button class=\"btn btn-primary\" ng-click=\"vmModal.edit(vmModal.noteSelected)\"><i class=\"fa fa-pencil m-r-xs\"></i><span translate>generic.action.edit</span></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n      <uib-tab index=\"1\">\r\n        <uib-tab-heading ng-click=\"vmModal.cancelEdit()\" translate>notecontainer.files</uib-tab-heading>\r\n        <div class=\"panel-body\">\r\n          <div class=\"col-sm-4\">\r\n            <ul class=\"agile-list sortable-list ui-sortable text-truncate\" ui-sortable=\"vmModal.sortableOptions\" ng-model=\"vmModal.files\" ng-if=\"vmModal.files\">\r\n              <li class=\"success-element ui-sortable-handle\" ng-repeat=\"fileNote in vmModal.files\" ng-click=\"vmModal.selectNote(fileNote)\" ng-class=\"vmModal.fileSelected.id == fileNote.id ? \'note-selected\' : \'\'\">\r\n                <span class=\"text-truncate\">{{fileNote.title}}</span>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n\r\n          <div class=\"col-sm-8\" id=\"editFilePanel\">\r\n            <div ng-if=\"vmModal.editNote && vmModal.editNote.isFileNote\">\r\n              <input type=\"text\" class=\"form-control m-b-xs\" ng-model=\"vmModal.noteCopy.title\" auto-focus>\r\n              <div class=\"pull-right\">\r\n                <button class=\"btn btn-default btn-outline\" ng-click=\"vmModal.cancelEdit()\"><i class=\"fa fa-times m-r-xs\"></i><span translate>common.cancel</span></button>\r\n                <button class=\"btn btn-primary\" ng-click=\"vmModal.update()\" ng-if=\"vmModal.noteCopy.resource\"><i class=\"fa fa-check m-r-xs\"></i><span translate>common.save</span></button>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"vmModal.fileSelected && !vmModal.editNote && !vmModal.isBusy\">\r\n              <div class=\"m-t-sm m-b-sm\">\r\n                <span class=\"label\">{{vmModal.fileSelected.title}}</span>\r\n              </div>\r\n              <div class=\"row p-h-xs m-b-xs border-bottom\">\r\n                <div class=\"col-sm-6 font-bold\" translate>notecontainer.name</div>\r\n                <div class=\"col-sm-2 hidden-xs hidden-sm font-bold\" translate>notecontainer.details</div>\r\n                <div class=\"col-sm-3 hidden-xs hidden-sm font-bold\" translate>notecontainer.modified</div>\r\n              </div>\r\n              <div class=\"row m-b-sm\" ng-repeat=\"file in vmModal.fileSelected.fileList\">\r\n                <div class=\"col-xs-1\"><i class=\"fa fa-lg m-t-xs pull-right\" ng-class=\"\'file_icon--\' + file.type\"></i></div>\r\n                <div class=\"col-md-5 col-xs-9\"><span class=\"text-truncate\" title=\"{{file.displayName}}\">{{file.displayName}}</span></div>\r\n                <div class=\"col-md-2 hidden-xs hidden-sm\">{{file.uploadedBy}}</div>\r\n                <div class=\"col-md-3 hidden-xs hidden-sm\">{{file.uploadedOn| dateTimeFromUtc}}</div>\r\n                <div><a class=\"btn btn-default btn-xs\" href=\"{{file.url}}\"><i class=\"fa fa-download\"></i></a></div>\r\n              </div>\r\n              <div class=\"pull-right m-t-xs\" ng-if=\"vmModal.canEditNotes\">\r\n                <button confirmation-button-panel target-element-id=\"editFilePanel\" class=\"btn btn-danger btn-outline\" h-auto=\"false\" confirm-message=\"notecontainer.deleteconfirmation\" error-message=\"notecontainer.deleteerror\" ng-click=\"vmModal.remove(vmModal.fileSelected)\"><i class=\"fa fa-times m-r-xs\"></i><span translate>generic.action.delete</span></button>\r\n                <button class=\"btn btn-primary\" ng-click=\"vmModal.edit(vmModal.fileSelected)\"><i class=\"fa fa-pencil m-r-xs\"></i><span translate>generic.action.edit</span></button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </uib-tab>\r\n    </uib-tabset>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <fileupload container=\"vmModal.data.resource\" container-id=\"vmModal.data.id\" ng-if=\"vmModal.canEditNotes\" all-completed-callback=\"vmModal.allCompletedCallback\" update-file-callback=\"vmModal.addOrUpdateFile\" callback-start-process=\"vmModal.startProcess\" callback-end-process=\"vmModal.endProcess\">\r\n      <label for=\"{{vmModal.data.id}}\">\r\n        <span class=\"btn btn-primary\" ng-class=\"{\'has-error\': vmModal.error}\"><i class=\"fa fa-plus m-r-xs\"></i><span translate>notecontainer.addfile</span></span>\r\n      </label>\r\n    </fileupload>\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.showNewNoteForm()\" ng-class=\"{\'has-error\': vmModal.error}\" ng-if=\"vmModal.canEditNotes\"><i class=\"fa fa-plus m-r-xs\"></i><span translate>notecontainer.addnote</span></button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>generic.action.close</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/detail.html","<div class=\"jobdetail\" ng-controller=\"ProjectDetailController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <sk-spinner ng-if=\"!vm.data || vm.isDownloading\"></sk-spinner>\r\n\r\n    <div class=\"row\" ng-if=\"vm.data\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title\">\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-6 m-b-xs flexeverything\">\r\n                <span><a ui-sref=\"siskin.dashboard\" translate>nav.clientdashboard</a> / <span>{{vm.data.name}}</span></span>\r\n                <label class=\"label label-default m-l-sm\" ng-if=\"!vm.data.isActive\"><i class=\"fa fa-pause m-r-xs\"></i>{{\'project.deactivated\'|translate}}</label>\r\n              </div>\r\n              <div class=\"col-sm-6 text-right\">\r\n              <button class=\"btn btn-default m-l-sm\" ui-sref=\"siskin.inbox({query:\'projectTemplateId=\' + vm.data.id})\" translate>\r\n                project.viewprojecttasks\r\n              </button>\r\n\r\n              <button class=\"btn btn-primary m-l-sm\" ng-if=\"vm.data.isActive\" can-do=\"projectTemplateStartInstance\" ng-click=\"vm.createInstance()\" licensed>\r\n                <i class=\"fa fa-plus-circle\"></i>\r\n                <span translate>project.createinstance</span>\r\n              </button>\r\n\r\n              <div class=\"btn-group m-l-sm\" can-do=\"projectTemplateAttributesExport,projectTemplateAttributesAcls,projectTemplateEmailSettingsView,projectTemplateAttributesBatchUpdate,projectTemplateAllFilesDownload,projectTemplateWorkflowView,projectTemplateAllFilesDownload,projectTemplateDelete\">\r\n                <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n                  <i class=\"fa fa-cog fa-x2\"></i>\r\n                </button>\r\n                <ul class=\"dropdown-menu dropdown-menu-right\">\r\n                  <li><a class=\"dropdown-item\" ng-click=\"vm.showNotesModal()\" can-do=\"ProjectTemplateNotesView\">\r\n                    <i class=\"fa fa-sticky-note m-l-n-sm m-r-xs\"></i>\r\n                    {{\'project.notes\' | translate}}\r\n                  </a>\r\n                  </li>\r\n                  <li can-do=\"projectTemplateAttributesExport\"><a class=\"dropdown-item\" ng-click=\"vm.attributesExportImport()\">\r\n                    <i class=\"fa fa-list m-l-n-sm m-r-xs\"></i>\r\n                    {{\'project.attributesexportimport\'|translate}}\r\n                  </a></li>\r\n                  <li can-do=\"projectTemplateAttributesAcls\"><a class=\"dropdown-item\" ng-click=\"vm.attributesAcls()\">\r\n                    <i class=\"fa fa-eye m-l-n-sm m-r-xs\"></i>\r\n                    {{\'project.attributesacls\'|translate}}\r\n                  </a>\r\n                  </li>\r\n                  <li can-do=\"projectTemplateEmailSettingsView\"><a class=\"dropdown-item\" ng-click=\"vm.showEmailSettingsModal()\">\r\n                    <i class=\"fa fa-envelope m-l-n-sm m-r-xs\"></i>\r\n                    {{\'project.emailsettings\'|translate}}\r\n                  </a>\r\n                  </li>\r\n                  <li can-do=\"projectTemplateAttributesBatchUpdate\" feature=\"projectTemplateAttributesBatchUpdate\">\r\n                    <a class=\"dropdown-item\" ng-click=\"vm.attributesBatchUpdate()\">\r\n                      <i class=\"fa fa-pencil-square-o m-l-n-sm m-r-xs\"></i>\r\n                      {{\'project.attributesbatchupdate\' | translate}}\r\n                    </a>\r\n                  </li>\r\n                  <li can-do=\"projectTemplateAllFilesDownload,projectTemplateWorkflowView\" role=\"separator\" class=\"divider\"></li>\r\n                  <li>\r\n                    <a class=\"dropdown-item\" ng-click=\"vm.viewWorkflow()\" can-do=\"projectTemplateWorkflowView\">\r\n                      <i class=\"fa fa-sitemap m-l-n-sm m-r-xs\"></i>\r\n                      {{\'project.workflowview\' | translate}}\r\n                    </a>\r\n                  </li>\r\n                  <li>\r\n                    <a class=\"dropdown-item\" ng-click=\"vm.downloadAllImages()\" can-do=\"projectTemplateAllFilesDownload\">\r\n                      <i class=\"fa fa-download m-l-n-sm m-r-xs\"></i>\r\n                      {{\'project.downloadallimages\' | translate}}\r\n                    </a>\r\n                  </li>\r\n                  <li can-do=\"projectTemplateDelete\" role=\"separator\" class=\"divider\"></li>\r\n                  <li can-do=\"projectTemplateDelete\">\r\n                    <a ng-if=\"vm.data.isActive\" confirmation-modal btn-style=\"btn-danger\" class=\"dropdown-item\" ng-click=\"vm.deactivate()\" text=\"project.deactivate.description\">\r\n                      <i class=\"fa fa-pause m-l-n-sm m-r-xs\"></i>\r\n                      {{\'project.deactivate\' | translate}}\r\n                    </a>\r\n                    <a ng-if=\"!vm.data.isActive\" confirmation-modal btn-style=\"btn-danger\" class=\"dropdown-item\" ng-click=\"vm.restore()\" text=\"project.restore.description\">\r\n                      <i class=\"fa fa-play m-l-n-sm m-r-xs\"></i>\r\n                      {{\'project.restore\' | translate}}\r\n                    </a>\r\n                    <a ng-if=\"!vm.data.isActive\" confirmation-modal btn-style=\"btn-danger\" class=\"dropdown-item\" ng-click=\"vm.deleteProjectTemplate()\" text=\"project.delete.description\">\r\n                      <i class=\"fa fa-trash m-l-n-sm m-r-xs\"></i>\r\n                      {{\'project.delete\' | translate}}\r\n                    </a>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"ibox-content\" ng-if=\"vm.data && !vm.data.totalProjectInstances\">\r\n            <div class=\"content-center\">\r\n              <strong class=\"m-t-lg m-b-lg\" translate>project.nodatatoshow</strong>\r\n            </div>\r\n          </div>\r\n      </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-if=\"vm.data\">\r\n      <div ng-repeat=\"widget in vm.widgets as w\" ng-switch=\"widget.type\">\r\n        <widget-piechart-projectoverview project=\"vm.data\" ng-switch-when=\"piechart-projectoverview\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-piechart-projectoverview>\r\n        <widget-list-milestonehit project=\"vm.data\" ng-switch-when=\"list-milestonehit\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-list-milestonehit>\r\n        \r\n        <widget-piechart-projectmilestones project=\"vm.data\" ng-switch-when=\"piechart-projectmilestones\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-piechart-projectmilestones>\r\n        <widget-map-project project=\"vm.data\" ng-switch-when=\"map-project\" client-id=\"vm.selectedClient.id\" class=\"{{widget.class}}\" header=\"{{widget.header || \'widget.mapprojects.title\'}}\"></widget-map-project>\r\n        <widget-list-projectmilestones data=\"vm.data\" ng-switch-when=\"list-projectmilestones\" client-id=\"vm.selectedClient.id\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-list-projectmilestones>\r\n        <widget-v2-project-instances project=\"vm.data\" ng-switch-when=\"v2-projectinstances\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-v2-project-instances>\r\n        <widget-list-taskoverview project=\"vm.data\" ng-switch-when=\"list-taskoverview\" class=\"{{widget.class}}\" header=\"{{widget.header}}\"></widget-list-taskoverview>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/list.admin.html","<div class=\"jobadminlist\" ng-controller=\"ProjectListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title jobadminlist__title\">\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-6 m-b-sm\">\r\n                  <h4 translate>projects.projects</h4>\r\n              </div>\r\n              <div class=\"col-sm-6 text-right\">\r\n                <button class=\"btn btn-primary m-l-sm\" ng-click=\"vm.create($event)\" can-do=\"projectTemplateCreate\" licensed>\r\n                  <i class=\"fa fa-plus-circle\"></i>\r\n                  <span class=\"hidden-sm hidden-xs\" translate>projects.newproject</span>\r\n                </button>\r\n                <button class=\"btn btn-primary m-l-sm\" ng-click=\"vm.downloadProjectTemplates()\">\r\n                    <i class=\"fa fa-download\"></i>\r\n                    <span class=\"hidden-sm hidden-xs\" translate>common.download</span>\r\n                  </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"autosearch m-b-sm\">\r\n              <input class=\"form-control\" ng-model=\"vm.search.query\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" translate-attr=\"{placeholder: \'common.searchplaceholder\'}\" ng-change=\"vm.reset()\">\r\n            </div>\r\n            <div class=\"row m-b-sm filter-panel-xs\">\r\n              <span class=\"col-sm-4\">\r\n                <datepicker class=\"m-b-xs\" ng-model=\"vm.search.dateFrom\" placeholder=\"{{\'common.from\' | translate}}\" ng-changed=\"vm.reset()\"></datepicker>\r\n              </span>\r\n              <span class=\"col-sm-4\">\r\n                <datepicker class=\"m-b-xs\" ng-model=\"vm.search.dateTo\" placeholder=\"{{\'common.to\' | translate}}\" ng-changed=\"vm.reset()\"></datepicker>\r\n              </span>\r\n              <span class=\"col-sm-4 col-xs-12\">\r\n                <button type=\"button\" class=\"btn btn-primary reset-button\" ng-click=\"vm.resetDates()\" translate>common.reset</button>\r\n              </span>\r\n            </div>\r\n            <table class=\"table\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"visible-sm visible-xs\" translate>projects.projectname</th>\r\n                  <th class=\"hidden-sm hidden-xs\" translate>projects.projectcode</th>\r\n                  <th class=\"hidden-sm hidden-xs\" translate can-do feature=\"projectGroup\">projects.client</th>\r\n                  <th class=\"hidden-sm hidden-xs\" translate can-do feature=\"projectBrand\">projects.brand</th>\r\n                  <th class=\"hidden-sm hidden-xs\" translate>projects.projectname</th>\r\n                  <th class=\"hidden-sm hidden-xs\" translate can-do feature=\"projectType\">projects.projecttype</th>\r\n                  <th translate></th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-if=\"!(vm.pager.items).length && !vm.pager.busy\">\r\n                  <td colspan=\"7\" class=\"text-center\" translate>common.norecords</td>\r\n                </tr>\r\n                <tr ng-repeat=\"m in vm.pager.items | orderBy : \'-date\'\">\r\n                  <td class=\"visible-sm visible-xs\">{{m.code}} - {{m.name}}</td>\r\n                  <td class=\"hidden-sm hidden-xs\">{{m.code}}</td>\r\n                  <td class=\"hidden-sm hidden-xs\" can-do feature=\"projectGroup\">{{m.clientName}}</td>\r\n                  <td class=\"hidden-sm hidden-xs\" can-do feature=\"projectBrand\">{{m.brandName}}</td>\r\n                  <td class=\"hidden-sm hidden-xs\">{{m.name}}</td>\r\n                  <td class=\"hidden-sm hidden-xs\" can-do feature=\"projectType\">{{m.projectTypeName}}</td>\r\n                  <td class=\"text-right\">\r\n                    <!-- Desktop actions column -->\r\n                    <div class=\"hidden-sm hidden-xs\">\r\n                      <a class=\"btn btn-default\" ui-sref=\"siskin.project({projectId: m.id})\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\" translate>\r\n                        workflows.edit\r\n                      </a>\r\n                      <button class=\"btn btn-default\" ng-click=\"vm.update($event, m)\" can-do=\"projectTemplateCreate\" translate>\r\n                        projects.renameproject\r\n                      </button>\r\n                      <button class=\"btn btn-default\" can-do=\"projectTemplateStartInstance\" ng-click=\"vm.createInstance($event, m)\" licensed translate>\r\n                        projects.createinstance\r\n                      </button>\r\n                      <button confirmation-modal class=\"btn btn-danger btn-outline\" ng-if=\"m.isActive\" text=\"templates.deactivate.description\" ng-click=\"vm.deactivate(m)\" error-message=\"templates.deactivate.error\" can-do=\"ProjectTemplateDeactivate\" translate>\r\n                        templates.deactivate\r\n                      </button>\r\n                    </div>\r\n                    <!-- Mobile actions column -->\r\n                    <div class=\"visible-sm visible-xs dropdown\">\r\n                      <button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\r\n                        <i class=\"fa fa-cog fa-x2\"></i> {{\'workflow.wfentity.actions\'|translate}}\r\n                      </button>\r\n                      <div class=\"dropdown-menu dropdown-menu-right\">\r\n                        <button class=\"btn btn-default\" ui-sref=\"siskin.project({projectId: m.id})\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\">\r\n                          <i class=\"fa fa-eye\"></i> <span translate>workflows.edit</span>\r\n                        </button>\r\n                        <button class=\"btn btn-default\" ng-click=\"vm.update($event, m)\">\r\n                          <i class=\"fa fa-pencil-square-o\"></i> <span translate>projects.renameproject</span>\r\n                        </button>\r\n                        <button class=\"btn btn-default\" can-do=\"projectTemplateStartInstance\" ng-click=\"vm.createInstance($event, m)\" licensed>\r\n                          <i class=\"fa fa-plus-circle\"></i> <span translate>projects.createinstance</span>\r\n                        </button>\r\n                        <button confirmation-modal class=\"btn btn-danger btn-outline\" ng-if=\"m.isActive\" text=\"templates.deactivate.description\" ng-click=\"vm.deactivate(m)\" error-message=\"templates.deactivate.error\" can-do=\"ProjectTemplateDeactivate\">\r\n                          <i class=\"fa fa-ban\"></i> <span translate>templates.deactivate</span>\r\n                        </button>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n            <pager ng-model=\"vm.pager\"></pager>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"ibox float-e-margins\" ng-class=\"{ collapsed : !vm.showDeleted}\" can-do=\"ProjectTemplateRestore\">\r\n          <div class=\"ibox-title breadcrumb\" ng-click=\"vm.showDeleted = !vm.showDeleted\">\r\n            <i class=\"pull-right fa fa-chevron-up\"></i>\r\n            <h4 translate>nav.deactivatedtemplates</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <table class=\"table\">\r\n              <thead>\r\n              <tr>\r\n                <th class=\"visible-sm visible-xs\" translate>projects.projectname</th>\r\n                <th class=\"hidden-sm hidden-xs\" translate>projects.projectcode</th>\r\n                <th class=\"hidden-sm hidden-xs\" translate can-do feature=\"projectGroup\">projects.client</th>\r\n                <th class=\"hidden-sm hidden-xs\" translate can-do feature=\"projectBrand\">projects.brand</th>\r\n                <th class=\"hidden-sm hidden-xs\" translate>projects.projectname</th>\r\n                <th class=\"hidden-sm hidden-xs\" translate can-do feature=\"projectType\">projects.projecttype</th>\r\n                <th translate></th>\r\n              </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-if=\"!(vm.pagerDeactivated.items).length && !vm.pagerDeactivated.busy\">\r\n                  <td colspan=\"7\" class=\"text-center\" translate>common.norecords</td>\r\n                </tr>\r\n              <tr ng-repeat=\"m in vm.pagerDeactivated.items | orderBy : \'-date\'\">\r\n                <td class=\"visible-sm visible-xs\">{{m.code}} - {{m.name}}</td>\r\n                <td class=\"hidden-sm hidden-xs\">{{m.code}}</td>\r\n                <td class=\"hidden-sm hidden-xs\" can-do feature=\"projectGroup\">{{m.clientName}}</td>\r\n                <td class=\"hidden-sm hidden-xs\" can-do feature=\"projectBrand\">{{m.brandName}}</td>\r\n                <td class=\"hidden-sm hidden-xs\">{{m.name}}</td>\r\n                <td class=\"hidden-sm hidden-xs\" can-do feature=\"projectType\">{{m.projectTypeName}}</td>\r\n                <td class=\"text-right\">\r\n                  <!-- Desktop actions column -->\r\n                  <div class=\"hidden-sm hidden-xs\">\r\n                    <button confirmation-modal class=\"btn btn-danger btn-outline\" ng-if=\"!m.isActive\" can-do=\"projectTemplateDelete\" text=\"templates.remove.description\" ng-click=\"vm.remove(m)\" error-message=\"templates.remove.error\">\r\n                        <i class=\"fa fa-trash visible-sm visible-xs\"></i> <span translate>templates.remove</span>\r\n                    </button>\r\n                    <button confirmation-modal class=\"btn btn-default btn-outline\" ng-if=\"!m.isActive\" text=\"templates.restore.description\" ng-click=\"vm.restore(m)\" error-message=\"templates.restore.error\">\r\n                      <i class=\"fa fa-undo visible-sm visible-xs\"></i> <span translate>templates.restore</span>\r\n                    </button>\r\n                  </div>\r\n                  <!-- Mobile actions column -->\r\n                  <div class=\"visible-sm visible-xs dropdown\">\r\n                    <button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\r\n                      <i class=\"fa fa-cog fa-x2\"></i> {{\'workflow.wfentity.actions\'|translate}}\r\n                    </button>\r\n                    <div class=\"dropdown-menu dropdown-menu-right\">\r\n                      <button class=\"btn btn-default\" ui-sref=\"siskin.project({projectId: m.id})\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\">\r\n                        <i class=\"fa fa-eye\"></i> <span translate>workflows.edit</span>\r\n                      </button>\r\n                      <button class=\"btn btn-default\" ng-click=\"vm.update($event, m)\">\r\n                        <i class=\"fa fa-pencil-square-o\"></i> <span translate>projects.renameproject</span>\r\n                      </button>\r\n                      <button confirmation-modal class=\"btn btn-danger btn-outline\" ng-if=\"!m.isActive\" can-do=\"projectTemplateDelete\" text=\"templates.remove.description\" ng-click=\"vm.remove(m)\" error-message=\"templates.remove.error\">\r\n                        <i class=\"fa fa-trash\"></i> <span translate>templates.remove</span>\r\n                      </button>\r\n                      <button confirmation-modal class=\"btn btn-default btn-outline\" ng-if=\"!m.isActive\" text=\"templates.restore.description\" ng-click=\"vm.restore(m)\" error-message=\"templates.restore.error\">\r\n                        <i class=\"fa fa-undo\"></i> <span translate>templates.restore</span>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </td>\r\n              </tr>\r\n              </tbody>\r\n            </table>\r\n            <sk-spinner ng-show=\"vm.pagerDeactivated.busy\"></sk-spinner>\r\n            <pager ng-model=\"vm.pagerDeactivated\"></pager>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/list.create.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>projects.create.newproject</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.create.name</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"vmModal.data.name\" ng-disabled=\"vmModal.isBusy\" auto-focus>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.create.code</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"vmModal.data.code\" ng-disabled=\"vmModal.isBusy\">\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"vmModal.features.projectGroup\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.create.client</label>\r\n        <div class=\"col-lg-8\">\r\n          <dropdown ng-model=\"vmModal.data.client\" pager=\"vmModal.clientPager\" ng-disabled=\"vmModal.isBusy\"></dropdown>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"vmModal.features.projectBrand\">\r\n          <label class=\"col-lg-4 control-label\" translate>projects.create.brand</label>\r\n          <div class=\"col-lg-8\">\r\n            <div class=\"alert alert-danger\" ng-if=\"vmModal.noBrands\">{{\'projects.create.nobrands\' | translate}}\r\n              <a ui-sref=\"siskin.brandlist\" can-do=\"metaDataEntitiesEdit\" ng-click=\"vmModal.close()\" translate>projects.create.brandslink</a>\r\n            </div>\r\n            <dropdown ng-model=\"vmModal.data.brand\" ng-if=\"!vmModal.noBrands\" pager=\"vmModal.brandPager\" ng-disabled=\"vmModal.isBusy\"></dropdown>\r\n          </div>\r\n        </div>\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.create.workflow</label>\r\n        <div class=\"col-lg-8\">\r\n          <dropdown ng-model=\"vmModal.data.rootWorkflow\" ng-values=\"vmModal.workflowValues\" ng-disabled=\"!vmModal.workflowValues.length || vmModal.isBusy\"></dropdown>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\" ng-if=\"vmModal.features.projectType\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.create.projecttype</label>\r\n\r\n        <div class=\"col-lg-8\">\r\n          <div class=\"alert alert-danger\" ng-if=\"vmModal.noProjectTypes\">{{\'projects.create.noprojecttypes\' | translate}}\r\n            <a ui-sref=\"siskin.projecttypelist\" can-do=\"metaDataEntitiesEdit\" translate>projects.create.projecttypeslink</a>\r\n          </div>\r\n          <dropdown ng-model=\"vmModal.data.projectType\" pager=\"vmModal.projectTypePager\" ng-disabled=\"vmModal.isBusy\"></dropdown>\r\n        </div>\r\n      </div>\r\n      <div class=\"alert alert-danger m-b-n flexeverything flexeverything--aligncenter\" ng-if=\"vmModal.error\">\r\n        <i class=\"fa fa-exclamation-circle fa-2x m-r-sm\"></i>\r\n        {{ \'projects.create.error\' | translate}}</div>\r\n\r\n        <sk-spinner ng-show=\"vmModal.isBusy\"></sk-spinner>\r\n      </form></div>\r\n    \r\n\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" ng-disabled=\"vmModal.isBusy\" translate>common.next</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n\r\n");
$templateCache.put("app/modules/siskin/project/list.html","<div class=\"joblist\" ng-controller=\"ProjectListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title breadcrumb\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-6 m-b-xs\">\r\n                <h4 translate>nav.projectslist</h4>\r\n              </div>\r\n              <div class=\"col-xs-6 text-right\">\r\n                <button can-do=\"projectTemplateCreate\" class=\"btn btn-primary m-l-sm\" ng-click=\"vm.create($event)\" licensed>\r\n                  <i class=\"fa fa-plus-circle\"></i>\r\n                  <span class=\"hidden-xs\" translate>projects.newproject</span>\r\n                </button>\r\n                <button class=\"btn btn-primary m-l-sm\" ng-click=\"vm.downloadProjectTemplates()\">\r\n                  <i class=\"fa fa-download\"></i>\r\n                  <span class=\"hidden-xs\" translate>common.download</span>\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"autosearch m-b-sm\">\r\n              <input class=\"form-control\" ng-model=\"vm.search.query\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\" translate-attr=\"{placeholder: \'common.searchplaceholder\'}\" ng-change=\"vm.reset()\">\r\n            </div>\r\n            <div class=\"row m-b-sm filter-panel-xs\">\r\n              <span class=\"col-sm-4\">\r\n                <datepicker class=\"m-b-xs\" ng-model=\"vm.search.dateFrom\" placeholder=\"{{\'common.from\' | translate}}\" ng-changed=\"vm.reset()\"></datepicker>\r\n              </span>\r\n              <span class=\"col-sm-4\">\r\n                <datepicker class=\"m-b-xs\" ng-model=\"vm.search.dateTo\" placeholder=\"{{\'common.to\' | translate}}\" ng-changed=\"vm.reset()\"></datepicker>\r\n              </span>\r\n              <span class=\"col-sm-4 col-xs-12\">\r\n                <button type=\"button\" class=\"btn btn-primary reset-button\" ng-click=\"vm.resetDates()\" translate>common.reset</button>\r\n              </span>\r\n            </div>\r\n            <table class=\"table\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"visible-sm visible-xs\" translate>projectinstance.detail.project</th>\r\n                  <th class=\"hidden-sm hidden-xs\" translate>projects.projectcode</th>\r\n                  <th ng-if=\"vm.features.projectGroup\" can-do=\"clientView\" negate translate>projects.client</th>\r\n                  <th class=\"hidden-sm hidden-xs\" ng-if=\"vm.features.projectBrand\" translate>projects.brand</th>\r\n                  <th class=\"hidden-sm hidden-xs\" translate>projects.projectname</th>\r\n                  <th class=\"hidden-sm hidden-xs\" ng-if=\"vm.features.projectType\" translate>projects.projecttype</th>\r\n                  <th class=\"hidden-sm hidden-xs\" translate>projects.createdon</th>\r\n                  <th class=\"col-sm-2 col-xs-3\" translate>projects.progress</th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-if=\"vm.pager.noResults && !vm.pager.busy\">\r\n                  <td colspan=\"7\" class=\"text-center\" translate>common.norecords</td>\r\n                </tr>\r\n                <tr ng-repeat=\"m in vm.pager.items\">\r\n                  <td class=\"visible-sm visible-xs\">{{m.code}} - <a ui-sref=\"siskin.project({projectId: m.id})\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\">{{m.name}}</a></td>\r\n\r\n                  <td class=\"hidden-sm hidden-xs\">{{m.code}}</td>\r\n                  <td ng-if=\"vm.features.projectGroup\" can-do=\"clientView\" negate>{{m.clientName}}</td>\r\n                  <td class=\"hidden-sm hidden-xs\" ng-if=\"vm.features.projectBrand\">{{m.brandName}}</td>\r\n\r\n                  <td class=\"hidden-sm hidden-xs\"><a ui-sref=\"siskin.project({projectId: m.id})\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\">{{m.name}}</a></td>\r\n                  <td class=\"hidden-sm hidden-xs\" ng-if=\"vm.features.projectType\">{{m.projectTypeName}}</td>\r\n                  <td class=\"hidden-sm hidden-xs\">{{m.createdOn | dateTimeFromUtc}}</td>\r\n                  <td>\r\n                    <div class=\"progress\">\r\n                      <div ng-if=\"m.completedProjectInstances\" class=\"progress-bar progress-bar-primary\" role=\"progressbar\" style=\"width: {{m.completedProjectInstances / m.totalProjectInstances * 100}}%\" aria-valuenow=\"{{m.completedProjectInstances}}\" aria-valuemin=\"0\" aria-valuemax=\"{{m.totalProjectInstances}}\" uib-tooltip-html=\"\'{{\'project.complete\' | translate}} : {{m.completedProjectInstances}}\'\" tooltip-trigger=\"mouseenter\">\r\n                        <span>{{m.completedProjectInstances}}</span>\r\n                      </div>\r\n                      <div ng-if=\"m.overdueProjectInstances\" class=\"progress-bar progress-bar-warning\" role=\"progressbar\" style=\"width: {{m.overdueProjectInstances / m.totalProjectInstances * 100}}%\" aria-valuenow=\"{{m.overdueProjectInstances}}\" aria-valuemin=\"0\" aria-valuemax=\"{{m.totalProjectInstances}}\" uib-tooltip-html=\"\'{{\'project.overdue\' | translate}} : {{m.overdueProjectInstances}}\'\" tooltip-trigger=\"mouseenter\">\r\n                        <span>{{m.overdueProjectInstances}}</span>\r\n                      </div>\r\n\r\n                      <div ng-if=\"(m.totalProjectInstances - m.completedProjectInstances - m.overdueProjectInstances)\" class=\"progress-bar progress-bar-success\" role=\"progressbar\" style=\"width: {{(m.totalProjectInstances - m.completedProjectInstances - m.overdueProjectInstances) / m.totalProjectInstances * 100}}%\" aria-valuenow=\"{{m.overdueProjectInstances}}\" aria-valuemin=\"0\" aria-valuemax=\"{{m.totalProjectInstances}}\" uib-tooltip-html=\"\'{{\'project.inprogress\' | translate}} : {{m.totalProjectInstances - m.completedProjectInstances - m.overdueProjectInstances}}\'\" tooltip-trigger=\"mouseenter\">\r\n                        <span>{{m.totalProjectInstances - m.completedProjectInstances - m.overdueProjectInstances}}</span>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <pager ng-model=\"vm.pager\"></pager>\r\n            <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/list.update.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>projects.update.update</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.update.name</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"vmModal.data.name\" auto-focus>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.save</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/create.modal.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>projects.instance.createprojectinstance</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <div ng-if=\"!vmModal.data\">\r\n      <sk-spinner-circle ng-if=\"!vm.data\"></sk-spinner-circle>\r\n    </div>\r\n    <div ng-if=\"vmModal.data\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.instance.name</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"vmModal.data.projectInstanceName\" disabled=\"disabled\" can-do feature=\"projectInstanceCanEditName\" negate>\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"vmModal.data.projectInstanceName\" can-do feature=\"projectInstanceCanEditName\" ng-disabled=\"vmModal.isBusy\" auto-focus>\r\n      </div>\r\n      </div>\r\n      <div ng-if=\"vmModal.features.projectType\" class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.instance.projecttype</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"vmModal.data.projectTypeName\" disabled=\"disabled\">\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label class=\"col-lg-4 control-label\" translate>projects.create.startasactive</label>\r\n        <div class=\"col-lg-2\">\r\n          <div class=\"m-t-xs\">\r\n              <input icheck class=\"form-check-input\" type=\"checkbox\" ng-model=\"vmModal.data.isActive\" ng-disabled=\"vmModal.isBusy\">\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-6\">\r\n          <datepicker ng-if=\"!vmModal.data.isActive\" ng-class=\"{\'has-error\': vmModal.data.validation.startingOnRequired}\" class=\"m-b-xs\" ng-model=\"vmModal.data.startingOn\" placeholder=\"{{\'projects.create.startingon\' | translate}}\" ng-disabled=\"vmModal.isBusy\"></datepicker>\r\n        </div>\r\n      </div>\r\n    </form>\r\n\r\n    <uib-tabset class=\"tabs-container\">\r\n      <uib-tab>\r\n        <uib-tab-heading translate>projects.instance.createtab</uib-tab-heading>\r\n        <div class=\"panel-body\">\r\n          <form class=\"form-horizontal\">\r\n            <!--<div class=\"form-group\">-->\r\n            <!--<label class=\"col-lg-4 control-label\" translate>projects.instance.projectinstancename</label>-->\r\n            <!--<div class=\"col-lg-8\">-->\r\n            <!--<input type=\"text\" class=\"form-control\"  ng-model=\"vmModal.data.name\" translate-attr=\"{placeholder:\'projects.instance.projectinstancenameplaceholder\'}\">-->\r\n            <!--</div>-->\r\n            <!--</div>-->\r\n            <div class=\"form-group\" ng-class=\"{\'has-error\': vmModal.data.validation.storeRequired}\">\r\n              <label class=\"col-lg-4 control-label\" translate>projects.instance.storename</label>\r\n              <div class=\"col-lg-8\">\r\n                <dropdown ng-model=\"vmModal.data.concern\" pager=\"vmModal.concernPager\" placeholder=\"{{\'projects.instance.storenameplaceholder\'| translate}}\" ng-disabled=\"vmModal.isBusy\"></dropdown>\r\n                <span class=\"help-block m-b-none\" translate>projects.instance.hint</span>\r\n              </div>\r\n            </div>\r\n            <hr>\r\n            <div class=\"form-group\">\r\n              <label class=\"col-lg-4 control-label\" translate>project.create.metadata</label>\r\n              <div class=\"col-lg-8\">\r\n                <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.addMetaData()\">\r\n                  <i class=\"fa fa-plus\"></i>\r\n                </button>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\" ng-repeat=\"metaData in vmModal.data.projectMetaData\">\r\n              <div class=\"col-lg-4\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"metaData.name\" translate-attr=\"{placeholder:\'project.create.metadatakey\'}\">\r\n              </div>\r\n              <div class=\"col-lg-7\">\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"metaData.data\" translate-attr=\"{placeholder:\'project.create.metadatavalue\'}\">\r\n              </div>\r\n              <div class=\"col-lg-1\">\r\n                <button class=\"btn btn-default btn-circle\" type=\"button\" ng-click=\"vmModal.removeMetaData(metaData)\">\r\n                  <i class=\"fa fa-times\"></i>\r\n                </button>\r\n              </div>\r\n            </div>\r\n            <hr>\r\n            <div class=\"form-group\" ng-repeat=\"role in vmModal.data.roleAssignment | orderBy:\'listOrder\'\" ng-class=\"{\'has-error\': vmModal.data.validation.roleAssignmentRequired[role.name]}\">\r\n              <label class=\"col-lg-4 control-label\">{{role.name}}</label>\r\n              <div class=\"col-lg-8\">\r\n                <dropdown-multiple ng-model=\"role.userOrGroup\" pager=\"role.pager\" placeholder=\"projects.instance.userorgroup\" ng-change=\"vmModal.changed(role)\" group-by=\"type\" ng-disabled=\"vmModal.isBusy\"></dropdown-multiple>\r\n              </div>\r\n            </div>\r\n          </form>\r\n          <sk-spinner ng-show=\"vmModal.isBusy\"></sk-spinner>\r\n        </div>\r\n      </uib-tab>\r\n      <uib-tab>\r\n        <uib-tab-heading translate>projects.instance.importtab</uib-tab-heading>\r\n        <div class=\"panel-body\">\r\n          <form class=\"form-horizontal\">\r\n            <div class=\"form-group\">\r\n              <label class=\"col-lg-4 control-label\" translate>projects.instance.getstorestemplate</label>\r\n              <div class=\"col-lg-8\">\r\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.getStores(true)\" translate>projects.instance.getstorestemplatebtn</button>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"col-lg-4 control-label\" translate>projects.instance.getstores</label>\r\n              <div class=\"col-lg-8\">\r\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.getStores(false)\" translate>projects.instance.getstoresbtn</button>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"col-lg-4 control-label\" translate>projects.instance.uploadexcel</label>\r\n              <div class=\"col-lg-8\">\r\n                <div>\r\n                  <file-upload-button ng-model=\"vmModal.file\" ng-change=\"vmModal.upload()\" accept=\"application/vnd.ms-excel\" label=\"projects.instance.uploadexcelbtn\"></file-upload-button>\r\n                </div>\r\n                <sk-spinner ng-if=\"vmModal.uploading\"></sk-spinner>\r\n                <label class=\"alert alert-success m-t-md\" ng-if=\"vmModal.uploadingValidation.isValid\" translate>projects.instance.success</label>\r\n                <label class=\"alert alert-danger m-t-md\" ng-if=\"vmModal.error\" translate>project.instance.unexpectederror</label>\r\n                <div class=\"alert alert-danger m-t-md\" ng-if=\"vmModal.uploadingValidation && !vmModal.uploadingValidation.isValid\">\r\n                  <label translate>projects.import.error</label>\r\n                  <label ng-if=\"vmModal.uploadingValidation.message\" translate>{{vmModal.uploadingValidation.message}}</label>\r\n                    <div class=\"m-t-xs m-b-md\" ng-repeat=\"r in vmModal.uploadingValidation.errors\">\r\n                      <strong>{{ \'validation.import.rownumber\'  | translate}} {{r.rowOrdinal +1}}</strong><span class=\"m-l-xs\">({{r.projectName}}):</span>\r\n                        <div class=\"m-xs m-l-sm\" ng-repeat=\"e in r.errors\"><strong>{{e.columnName}}</strong><i class=\"fa fa-arrow-right m-l-xs m-r-xs\"></i> <span class=\"m-r-xs\" ng-repeat=\"m in e.messages\" translate>{{m}}</span>: {{e.value}}</div>\r\n                        <div ng-if=\"r.message && !r.errors.length\" class=\"m-xs m-l-sm\">{{r.message}}</div>\r\n                    </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </uib-tab>\r\n    </uib-tabset>\r\n  </div>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"(!vmModal.data.isActive && !vmModal.data.startingOn) || vmModal.isBusy\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.create</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/create.report.modal.html","<div class=\"report-instance\">\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vm.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>projectinstance.detail.createreport.title</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\" ng-switch=\"vm.step\" ng-class=\"{\'preview\' : vm.step==1}\">\r\n    <!--step 1-->\r\n    <div ng-switch-when=\"0\">\r\n      <div class=\"m-b-sm flexeverything\">\r\n        <div class=\"flexeverything--spacer\"></div>\r\n        <presets values=\"vm.all\" resource=\"vm.data.resource\" on-select=\"vm.presetLoaded()\"></presets>\r\n      </div>\r\n\r\n      <dropdown class=\"report-instance__reporttemplates\" pager=\"vm.templatesPager\" ng-model=\"vm.report\" placeholder=\"projectinstance.detail.createreport.selectreportplaceholder\"></dropdown>\r\n\r\n      <div class=\"m-t-sm form-horizontal\">\r\n        <div class=\"form-group\" ng-if=\"vm.isAnyUnapproved\" can-do feature=\"supportApproveImages\">\r\n          <div class=\"col-md-4\">\r\n            <label translate>projectinstance.detail.createreport.displayonlyapprovedfiles</label>\r\n          </div>\r\n          <div class=\"col-lg-8\">\r\n            <input icheck type=\"checkbox\" ng-model=\"vm.filterApprovedFiles.pvalue\">\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <div class=\"col-md-4\">\r\n            <label translate>projectinstance.detail.createreport.showdraftvalues</label>\r\n          </div>\r\n          <div class=\"col-lg-8\">\r\n            <input icheck type=\"checkbox\" ng-model=\"vm.showDraftValues.pvalue\" ng-change=\"vm.showDraftValuesChanged()\">\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <div class=\"col-md-4\">\r\n            <label translate>projectinstance.detail.createreport.displayemptycategories</label>\r\n          </div>\r\n          <div class=\"col-lg-8\">\r\n            <input icheck type=\"checkbox\" ng-model=\"vm.displayEmptyCategories.pvalue\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row m-t-sm\">\r\n        <div class=\"col-lg-12\">\r\n          <h3 translate>projectinstance.detail.createreport.selectattributes</h3>\r\n          <input type=\"text\" class=\"input input-sm form-control m-b-sm\" placeholder=\"{{\'common.searchplaceholder\' | translate}}\" ng-model=\"vm.search.attribute\">\r\n\r\n          <ul class=\"agile-list p-l-none\">\r\n            <li ng-repeat=\"m in vm.data.attributeGroups | orderBy:\'listOrder\'\" ng-class=\"{\'success-element\': m.pvalue}\" ng-click=\"vm.select(m, !m.pvalue)\">\r\n              {{m.name | ordefault}}\r\n              <ul class=\"agile-list\">\r\n                <li ng-repeat=\"a in m.data | filter: {name: vm.search.attribute} | orderBy:\'field.listOrder\'\" ng-class=\"{\'success-element\': a.pvalue}\" ng-click=\"vm.select(a, !a.pvalue)\" stop-event=\"click\">\r\n                  {{a.name}}\r\n                  <i ng-if=\"a.type === \'files\'\" class=\"pull-right fa {{a.expanded ? \'fa-chevron-up\' : \'fa-chevron-down\'}}\" ng-click=\"a.expanded = !a.expanded\" stop-event=\"click\"></i>\r\n                  <div ng-if=\"a.expanded\">\r\n                    <gallery class=\"gallery-sm\" list=\"a.content\" can-approve=\"a.fileApprove\" hide-unapproved=\"vm.filterApprovedFiles.pvalue\" ng-click-item=\"vm.select\" stop-event=\"click\"></gallery>\r\n                  </div>\r\n                </li>\r\n              </ul>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!--step 2-->\r\n    <div ng-switch-when=\"1\">\r\n      <div ng-if=\"vm.daoData\" bind-html-compile=\"vm.report.body\"></div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\" ng-switch=\"vm.step\">\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.close()\" ng-class=\"{\'has-error\': vm.error}\" translate>common.close</button>\r\n    <span ng-switch-when=\"0\">\r\n      <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.create()\" ng-disabled=\"!vm.report\" translate>common.next</button>\r\n    </span>\r\n    <span ng-switch-when=\"1\">\r\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.back()\" translate>common.back</button>\r\n      <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.print()\" ng-disabled=\"vm.printing\">\r\n        <sk-spinner-circle class=\"pull-left m-r-xs\" ng-if=\"vm.printing\"></sk-spinner-circle>\r\n        {{ (vm.printing ? \'common.downloading\' : \'common.download\') | translate }}\r\n      </button>\r\n    </span>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.actions.html","<!-- edit -->\r\n<div ng-if=\"!vm.isEditing\">\r\n  <button class=\"btn btn-default m-r-xs\" ng-click=\"vm.editProjectInstanceDetails()\" can-do=\"projectInstanceEdit\">\r\n    <i class=\"fa fa-edit\"></i>\r\n    {{\'common.edit\'|translate}}\r\n  </button>\r\n</div>\r\n\r\n<div ng-if=\"vm.isEditing\">\r\n  <button class=\"btn btn-primary\" ng-click=\"vm.update()\" ng-disabled=\"!vm.dataModelCopy.concern || !vm.dataModelCopy.projectInstanceName\">\r\n    <i class=\"fa fa-check\"></i>\r\n  </button>\r\n  <button class=\"btn btn-danger m-r-xs\" ng-click=\"vm.isEditing = false\">\r\n    <i class=\"fa fa-times\"></i>\r\n  </button>\r\n</div>\r\n\r\n<!-- actions -->\r\n<div class=\"btn-group m-r-md\" can-do=\"projectTemplateAttributesExport,projectTemplateAttributesAcls\">\r\n  <button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n    <i class=\"fa fa-cog fa-x2\"></i>\r\n  </button>\r\n  <ul class=\"dropdown-menu dropdown-menu-right\">\r\n    <li><a class=\"dropdown-item\" ng-click=\"vm.showNotesModal()\" can-do=\"projectInstanceNotesView\">\r\n      <i class=\"fa fa-sticky-note m-l-n-sm m-r-xs\"></i>\r\n      {{\'projectinstance.detail.notes\' | translate}}\r\n    </a>\r\n    </li>\r\n\r\n    <li can-do=\"projectInstanceRolesEdit\"><a class=\"dropdown-item\" ng-click=\"vm.showRolesModal()\">\r\n      <i class=\"fa fa-users m-l-n-sm m-r-xs\"></i>\r\n      {{\'projectinstance.detail.editroles\'|translate}}\r\n    </a>\r\n    </li>\r\n\r\n    <li ng-if=\"!vm.data.completedOn && vm.data.startedOn\" can-do=\"projectInstanceRollback\"><a class=\"dropdown-item\" ui-sref=\"siskin.rollback({projectId: vm.data.id})\">\r\n      <i class=\"fa fa-sitemap m-l-n-sm m-r-xs\"></i>\r\n      {{\'projectinstance.detail.rollback\'|translate}}\r\n    </a>\r\n    </li>\r\n\r\n    <li can-do=\"projectInstanceRolesEdit,projectInstanceEdit,ProjectInstanceDelete,projectInstanceNotesEdit\" role=\"separator\" class=\"divider\"></li>\r\n\r\n    <li can-do=\"reportView\"><a class=\"dropdown-item\" ng-click=\"vm.createReport()\">\r\n      <i class=\"fa fa-list m-l-n-sm m-r-xs\"></i>\r\n      {{\'projectinstance.detail.createreport\'|translate}}\r\n    </a>\r\n    </li>\r\n    <li can-do=\"projectTemplateAllFilesDownload\"><a class=\"dropdown-item\" ng-click=\"vm.downloadAllImages()\">\r\n      <i class=\"fa fa-download m-l-n-sm m-r-xs\"></i>\r\n      {{\'project.downloadallimages\'|translate}}\r\n    </a>\r\n    </li>\r\n\r\n    <li can-do=\"projectInstanceDelete,projectInstanceEdit\" role=\"separator\" class=\"divider\"></li>\r\n    <li can-do=\"projectInstanceEdit\"><a class=\"dropdown-item\" ng-if=\"vm.data.isActive\" ng-click=\"vm.showPutOnHoldModal(\'onHold\')\">\r\n      <i class=\"fa fa-pause m-l-n-sm m-r-xs\"></i>\r\n      {{\'projectinstance.detail.resumeonhold.putonhold\' | translate}}\r\n    </a>\r\n      <a class=\"dropdown-item\" ng-if=\"!vm.data.isActive\" ng-click=\"vm.showPutOnHoldModal(\'resume\')\">\r\n        <i class=\"fa fa-play m-l-n-sm m-r-xs\"></i>\r\n        {{\'projectinstance.detail.resumeonhold.resumeproject\' | translate}}\r\n      </a>\r\n    </li>\r\n    <li can-do=\"projectInstanceDelete\">\r\n        <a confirmation-modal btn-style=\"btn-danger\" class=\"dropdown-item\" ng-click=\"vm.remove()\" text=\"projectinstance.delete.description\">\r\n          <i class=\"fa fa-trash m-l-n-sm m-r-xs\"></i>\r\n          {{\'projectinstance.delete\' | translate}}\r\n        </a>\r\n    </li>\r\n  </ul>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.attributes.html","<div class=\"ibox float-e-margins\" can-do=\"projectInstanceAttributesView\" ng-class=\"{ collapsed : !vm.showAttributes}\">\r\n  <div class=\"ibox-title\" ng-click=\"vm.toggleAttributes()\">\r\n    <h3 translate>projectinstance.detail.attributes</h3>\r\n    <div class=\"ibox-tools dropdown\">\r\n      <a>\r\n        <i class=\"fa fa-chevron-up\"></i>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <div class=\"projectInstanceDetail__attributes tabs-container\" ng-show=\"vm.isInit\">\r\n      <uib-tabset active=\"vm.active\" ng-class=\"{\'tabs-inactive\' : vm.active == null}\" class=\"clearfix\">\r\n\r\n        <uib-tab ng-repeat=\"tab in vm.data.attributeGroups | orderBy:\'listOrder\'\" class=\"projectInstanceDetail__group\">\r\n          <uib-tab-heading class=\"projectInstanceDetail__group--title\" ng-class=\"{\'projectInstanceDetail__group--empty\': (tab.data | hasValue).length === 0 }\">\r\n            <i class=\"fa fa-2x projectInstanceDetail__group--title-icon icon-{{tab.type}}\"></i>\r\n            <span class=\"projectInstanceDetail__group--title-type\">\r\n                <span>{{tab.name | ordefault}}</span>\r\n              </span>\r\n            <span class=\"projectInstanceDetail__group--title-arrow visible-ms-block\">\r\n                <i class=\"ion-arrow-right-c\"></i>\r\n              </span>\r\n          </uib-tab-heading>\r\n          <div class=\"panel-body\">\r\n            <div class=\"panel-body--title visible-ms-block\">\r\n              <a class=\"btn btn-sm btn-default\" ng-click=\"vm.back()\">\r\n                <span class=\"ion-arrow-left-c\"></span>\r\n              </a>\r\n              <span class=\"panel-body--title-type\">\r\n                  <span>{{tab.name | ordefault}}</span>\r\n                  <i class=\"fa fa-2x panel-body--title-icon icon-{{tab.type}}\"></i>\r\n                </span>\r\n            </div>\r\n\r\n            <div ng-repeat=\"dv in tab.data | filter:vm.searchText | orderBy:\'field.listOrder\'\" ng-switch=\"dv.type\" class=\"datavalue projectInstanceDetail__datavalue\" ng-class=\"{\'col-sm-2 image\': dv.type === \'files\' && tab.type === \'image\',\'col-lg-12\': dv.type !== \'files\' || tab.type !== \'image\', \'has-error\': vm.hasError(dv)}\">\r\n              <div class=\"datavalue__title\">\r\n                  <span class=\"projectInstanceDetail__datavalue__title\" ng-class=\"{\'editing\' : !dv.isCurrent}\">\r\n                    <button ng-if=\"!dv.isCurrent\" ng-click=\"vm.cancelEdit(tab, dv)\" class=\"btn btn-default btn-sm projectInstanceDetail__datavalue__options--option\">\r\n                      <i class=\"fa fa-times\"></i>\r\n                    </button>\r\n                    <label class=\"projectInstanceDetail__datavalue__name\" translate>\r\n                      {{dv.name}}\r\n                    </label>\r\n                      <span class=\"projectInstanceDetail__datavalue__options\">\r\n                      <button ng-if=\"dv.canEdit\" ng-click=\"vm.edit(tab, dv)\" ng-class=\"{\'has-error\': dv.editError}\" class=\"btn btn-primary btn-xs projectInstanceDetail__datavalue__options--option\">\r\n                        <i class=\"fa fa-pencil\"></i>\r\n                      </button>\r\n                      <button ng-if=\"!dv.isCurrent\" ng-click=\"vm.persist(tab, dv)\" ng-class=\"{\'has-error\': dv.persistError}\" class=\"btn btn-primary btn-sm projectInstanceDetail__datavalue__options--option\">\r\n                        <i class=\"fa fa-check\"></i>\r\n                      </button>\r\n                    </span>\r\n                  </span>\r\n              </div>\r\n\r\n                <field-files class=\"datavalue__data\" field=\"dv\" ng-if=\"tab.type !== \'image\'\" ng-switch-when=\"files\" parent=\".panel-body\"></field-files>\r\n                <field-simple-files class=\"datavalue__data\" field=\"dv\" ng-if=\"tab.type === \'image\'\" ng-switch-when=\"files\" parent=\".panel-body\"></field-simple-files>\r\n                <field-boolean class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"boolean\"></field-boolean>\r\n                <field-confirmation class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"confirmation\"></field-confirmation>\r\n                <field-date class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"date\"></field-date>\r\n                <field-datetime class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"datetime\"></field-datetime>\r\n                <field-double class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"double\"></field-double>\r\n                <field-dropdown class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"dropdown\"></field-dropdown>\r\n                <field-integer class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"integer\"></field-integer>\r\n                <field-string class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"string\"></field-string>\r\n                <field-user class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"user\"></field-user>\r\n                <field-group class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"group\"></field-group>\r\n                <field-link class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"link\"></field-link>\r\n              </div>\r\n            </div>\r\n        </uib-tab>\r\n      </uib-tabset>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.history.html","<div class=\"ibox float-e-margins\" ng-class=\"{ collapsed : !vm.showHistory}\" can-do=\"projectInstanceHistoryView\">\r\n  <div class=\"ibox-title\" ng-click=\"vm.toggleHistory()\">\r\n    <h3 translate>projectinstance.detail.history</h3>\r\n    <div class=\"ibox-tools dropdown\">\r\n      <a>\r\n        <i class=\"fa fa-chevron-up\"></i>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <div class=\"panel-body\">\r\n      <p translate>projectinstance.detail.historyhint</p>\r\n      <div id=\"vertical-timeline\" class=\"dark-timeline\">\r\n        <div class=\"vertical-timeline-block\" ng-repeat=\"m in vm.data.history | orderBy:\'-date\'\" ng-switch=\"m.type\">\r\n          <!--note-->\r\n          <div ng-switch-when=\"note\">\r\n            <div class=\"vertical-timeline-icon yellow-bg\">\r\n              <i class=\"fa fa-sticky-note\"></i>\r\n            </div>\r\n\r\n            <div class=\"vertical-timeline-content\">\r\n              <h2 translate>taskinstance.note</h2>\r\n              <p>{{m.body}}</p>\r\n              <span class=\"vertical-date\">\r\n                  {{m.date | dateFrom}}\r\n                  <br>\r\n                  <small>{{m.date | dateTimeFromUtc}}</small>\r\n                  <small><b>, {{m.userName}}</b></small>\r\n                </span>\r\n            </div>\r\n          </div>\r\n\r\n          <!--milestone-->\r\n          <div ng-switch-when=\"milestone\">\r\n            <div class=\"vertical-timeline-icon blue-bg\">\r\n              <i class=\"fa fa-flag\"></i>\r\n            </div>\r\n\r\n            <div class=\"vertical-timeline-content\">\r\n              <h2 translate>taskinstance.milestone</h2>\r\n              <p>{{m.name}}</p>\r\n              <span class=\"vertical-date\">\r\n                  {{m.date | dateFrom}}\r\n                  <br>\r\n                  <small>{{m.date | dateTimeFromUtc}}</small>\r\n                </span>\r\n            </div>\r\n          </div>\r\n\r\n          <!--task-->\r\n          <div ng-switch-when=\"task\">\r\n            <div class=\"vertical-timeline-icon navy-bg\">\r\n              <i class=\"fa fa-user\"></i>\r\n            </div>\r\n\r\n            <div class=\"vertical-timeline-content\">\r\n              <div>\r\n\r\n                <h2 translate>taskinstance.task</h2>\r\n                <p>{{m.name}}</p>\r\n                <div class=\"vertical-date\" style=\"float:none;\">\r\n                  {{m.date | dateFrom}}\r\n                  <br>\r\n                  <small>{{m.date | dateTimeFromUtc}}</small>\r\n\r\n                </div>\r\n              </div>\r\n              <!--notes of task-->\r\n              <div class=\"inspinia-timeline m-t-sm\">\r\n                <div class=\"timeline-item\" ng-repeat=\"n in m.taskNotes\">\r\n                  <div class=\"row note m-t-xs\">\r\n                    <i class=\"fa fa-sticky-note\"></i>\r\n                    <div class=\"col-xs-8 content no-top-border\" style=\"padding-top:0px;min-height:0px;\">\r\n                      <div>{{n.body}}</div>\r\n                      <span class=\"vertical-date\" style=\"float:none\">\r\n                            <small>{{n.date | dateTimeFromUtc}}</small>\r\n                            <small><b>, {{n.userName}}</b></small>\r\n                            <small class=\"fa fa-eye m-l-xs\" ng-if=\"n.projectRoleMappingsNames.length\" title=\"{{ \'notes.notefor\' | translate }} : {{ n.projectRoleMappingsNames.join(\', \')}}\"></small>\r\n                          </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.html","<div class=\"projectInstanceDetail\" ng-controller=\"ProjectInstanceDetailController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <sk-spinner ng-show=\"!vm.isInit || vm.isDownloading\"></sk-spinner>\r\n\r\n  <div class=\"wrapper wrapper-content\" ng-if=\"vm.isInit\">\r\n  <!--not found-->\r\n    <div class=\"not-found-panel\" ng-show=\"vm.error\">\r\n      <div class=\"ibox float-e-margins\">\r\n        <div class=\"ibox-content\">\r\n          <i class=\"fa fa-exclamation-circle fa-3x\"></i>\r\n          <h3 translate>projectinstance.detail.notfound</h3>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  <!--progress-->\r\n    <div class=\"projectInstanceDetail__progress m-b-sm\">\r\n      <div class=\"ibox float-e-margins\">\r\n        <div class=\"ibox-title projectInstanceDetail__progress__header flexeverything\">\r\n          <div class=\"projectInstanceDetail__progress__header--title\">\r\n              <div class=\"pull-right\" ng-include=\"\'app/modules/siskin/projectinstance/detail.actions.html\'\"></div>\r\n              <div ng-include=\"\'app/modules/siskin/projectinstance/detail.info.html\'\"></div>\r\n          </div>\r\n        </div>\r\n        <div class=\"ibox-content projectInstanceDetail__progress__content\">\r\n          <div ng-include=\"\'app/modules/siskin/projectinstance/detail.progress.html\'\"></div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\" ng-class=\"{ \'flex-reverse\' : vm.style.reverse}\">\r\n      <div ng-class=\"{ \'col-lg-12\' :vm.style.fullwidth, \'col-lg-5\' : !vm.style.fullwidth}\">\r\n        <div ng-include=\"\'app/modules/siskin/projectinstance/detail.metadata.html\'\"></div>\r\n        <div ng-include=\"\'app/modules/siskin/projectinstance/detail.tasks.html\'\"></div>\r\n        <div ng-include=\"\'app/modules/siskin/projectinstance/detail.history.html\'\"></div>\r\n      </div>\r\n      <div ng-class=\"{ \'col-lg-12\' : vm.style.fullwidth, \'col-lg-7\' : !vm.style.fullwidth}\">\r\n        <div ng-include=\"\'app/modules/siskin/projectinstance/detail.attributes.html\'\"></div>\r\n        <div ng-include=\"\'app/modules/siskin/projectinstance/detail.roles.html\'\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.info.html","<!-- info -->\r\n<p class=\"col-sm-6\">\r\n  <span translate>projectinstance.detail.projectinstancename</span>:\r\n  <strong ng-if=\"!vm.isEditing || !vm.features.projectInstanceCanEditName\">{{ vm.data.projectInstanceName }}</strong>\r\n  <input ng-if=\"vm.isEditing && vm.features.projectInstanceCanEditName\" type=\"text\" class=\"projectInstanceDetail__name flex form-control inline-block\" ng-model=\"vm.dataModelCopy.projectInstanceName\" auto-focus>\r\n  <label class=\"label label-default m-l-sm\" ng-if=\"!vm.data.isActive\"><i class=\"fa fa-pause m-r-xs\"></i>{{\'projectinstance.detail.deactivated\'|translate}}</label>\r\n</p>\r\n<p class=\"col-sm-12\">\r\n  <span translate>projectinstance.detail.project</span>:\r\n  <strong><a ui-sref=\"siskin.project({projectId: vm.data.projectId})\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\">{{ vm.data.projectTemplateName }}</a></strong>\r\n</p>\r\n<p class=\"col-sm-12\">\r\n  <span translate>projectinstance.detail.projecttemplatecode</span>:\r\n  <strong>{{vm.data.projectTemplateCode}}</strong>\r\n</p>\r\n\r\n<div class=\"row-fluid\">\r\n  <p class=\"col-sm-6\" ng-if=\"vm.features.projectGroup\">\r\n    <span translate>projectinstance.detail.client</span>:\r\n    <strong>{{ vm.data.clientName }}</strong>\r\n  </p>\r\n  <p class=\"col-sm-6\" ng-if=\"vm.features.projectBrand\">\r\n    <span translate>projectinstance.detail.brand</span>:\r\n    <strong>{{vm.data.brandName}}</strong>\r\n  </p>\r\n  <p class=\"col-sm-6\" ng-if=\"vm.data.canStart\">\r\n    <span translate>projectinstance.detail.startingon</span> :\r\n    <strong>{{vm.data.startingOn | dateFromUtc}}</strong>\r\n    <button class=\"btn btn-info btn-xs m-l-xs\" ng-click=\"vm.showPutOnHoldModal(true)\" can-do=\"projectInstanceEdit\">\r\n        {{\'projectinstance.detail.start\'|translate}}\r\n        <i class=\"fa fa-play m-l-xs\"></i>\r\n    </button>\r\n  </p>\r\n  <p class=\"col-sm-6\" ng-if=\"vm.data.completedOn\">\r\n    <span translate>projectinstance.detail.completedon</span>:\r\n    <span class=\"label label-primary float-none\">{{vm.data.completedOn | dateTimeFromUtc}}</span>\r\n  </p>\r\n</div>\r\n<div class=\"row-fluid\">\r\n  <p class=\"col-sm-12 flexeverything\">\r\n    <span translate>projectinstance.detail.concern</span>:\r\n    <a class=\"m-l-sm\" ui-sref=\"siskin.store({storeId:vm.data.concernId})\" ng-if=\"!vm.isEditing\">\r\n      <strong>{{ vm.data.concernName }}</strong>\r\n    </a>\r\n    <dropdown ng-if=\"vm.concernPager && vm.isEditing\" ng-model=\"vm.dataModelCopy.concern\" pager=\"vm.concernPager\" placeholder=\"{{\'projectinstance.detail.selectconcern\'|translate}}\" ng-if=\"vm.concernPager\" class=\"m-l-sm inline-block\"></dropdown>\r\n  </p>\r\n  <p class=\"col-sm-12\" ng-if=\"!vm.isEditing\">\r\n    <span translate>projectinstance.detail.storeaddress</span>:\r\n    <strong>{{vm.data.concernAddress}}</strong>\r\n  </p>\r\n\r\n  <div class=\"col-sm-12\" ng-repeat=\"storeInfo in vm.data.attributeGroups | filter:{type:\'storeinfo\'}\">\r\n    <span class=\"storeinfo m-r-xs\" ng-repeat=\"field in storeInfo.data\" ng-switch=\"field.type\" ng-if=\"field.value\">\r\n      <span ng-switch-when=\"datetime\" class=\"label m-b-xs\">\r\n        {{ field.name }} : {{ field.value | dateTimeFromUtc}}\r\n      </span>\r\n      <span ng-switch-when=\"date\" class=\"label m-b-xs\">\r\n        {{ field.name }} : {{ field.value | dateFromUtc}}\r\n      </span>\r\n      <span ng-switch-when=\"double\" class=\"label m-b-xs\">\r\n        {{ field.name }} : {{ field.value | number: vm.decimalsLength}}\r\n      </span>\r\n      <span ng-switch-when=\"user\" class=\"label m-b-xs\">\r\n        {{ field.name }} : {{ field.value.selectedUser.longName }}\r\n      </span>\r\n      <span ng-switch-default class=\"label m-b-xs\">\r\n        {{ field.name }} : {{ field.value }}\r\n      </span>\r\n    </span>\r\n  </div>\r\n\r\n  \r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.metadata.html","<div class=\"ibox float-e-margins\" ng-class=\"{ collapsed : !vm.showMetadata}\">\r\n  <div class=\"ibox-title\" ng-click=\"vm.toggleMetadata()\">\r\n    <h3 translate>projectinstance.detail.metadata</h3>\r\n    <div class=\"ibox-tools dropdown\">\r\n      <a>\r\n        <i class=\"fa fa-chevron-up\"></i>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n        <div class=\"panel-body\">\r\n\r\n          <div ng-if=\"!vm.data.metadata.length\">\r\n            <span colspan=\"3\" class=\"text-center\" translate>common.norecords</span>\r\n          </div>\r\n\r\n          <div class=\"table-responsive\" ng-if=\"vm.data.metadata.length\">\r\n            <table class=\"table table-striped\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"name\" translate>projectinstance.detail.metadata.key</th>\r\n                  <th class=\"data\" translate>projectinstance.detail.metadata.value</th>\r\n                  <!--\r\n                  <th class=\"action\"></th>\r\n                  -->\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-repeat=\"meta in vm.data.metadata | orderBy:\'name\'\" style=\"min-width: auto; height:auto;\">\r\n                  <td class=\"name\">{{meta.name}}</td>\r\n                  <td class=\"data\">{{meta.data}}</td>\r\n                  <!--\r\n                  <td class=\"action\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\'vm.editMetadata(meta)\' translate>common.edit</button></td>\r\n                  -->\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n\r\n        </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.progress.html","<div class=\"feed-activity-list\" ng-show=\"vm.isInit\">\r\n  <div class=\"feed-element projectInstanceDetail__tasks\" ng-if=\"vm.data.activeTasks.length\">\r\n    <div class=\"media-body\">\r\n      <h3 translate>projectinstance.detail.tasks</h3>\r\n    </div>\r\n    <ul class=\"agile-list\">\r\n      <li class=\"flexeverything col-md-9\" ng-repeat=\"m in vm.data.activeTasks\" ng-class=\"{\'success-element\' :  m.state != \'overdue\', \'warning-element\' : m.state == \'overdue\', \'projectInstanceDetail__activetask--new\' : !m.isViewed }\">\r\n        <div class=\"flex\">\r\n          <div class=\"row\">\r\n            <span class=\"task-name\">{{m.name}}</span>\r\n            <span class=\"label\" ng-class=\"{\'label-primary\' :  m.state != \'overdue\', \'label-warning\' : m.state == \'overdue\' }\">Due On : {{m.dueOn | dateTimeFromUtc}}</span>\r\n          </div>\r\n          <div class=\"row\">\r\n            {{\'projectinstance.detail.assignedto\' | translate}} {{ (m.assignedTo ? m.assignedTo.name :\r\n            \'projectinstance.detail.assignedtonone\') | translate}}\r\n          </div>\r\n        </div>\r\n        <div class=\"projectInstanceDetail__progress__actions m-l-md\">\r\n          <button ui-sref=\"siskin.taskinstance({taskInstanceId: m.id})\" class=\"btn btn-info\" translate>projectinstance.detail.view</button>\r\n          <button class=\"btn btn-primary\" ng-if=\"m.resource.claimable\" ng-disabled=\"m.isBusy\" ng-click=\"vm.claim(m)\" translate>projectinstance.detail.start</button>\r\n          <button can-do=\"taskUsersView\" uib-popover-html=\"m.relatedUsersHtml\" popover-placement=\"bottom\" type=\"button\" class=\"btn btn-info\">\r\n            <i class=\"fa fa-user\"></i>\r\n            {{\'task.relatedto\' | translate}}\r\n          </button>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n  <div can-do=\"cannotViewMilestones\" negate>\r\n    <div class=\"feed-element projectInstanceDetail__milestones\">\r\n      <div class=\"media-body\">\r\n        <h3 translate>projectinstance.detail.milestones</h3>\r\n      </div>\r\n    </div>\r\n    <div class=\"feed-element milestones\">\r\n        <div class=\"media-body\" milestone-list=\"vm.data.milestones\"></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"clearfix\"></div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.roles.html","<div class=\"ibox float-e-margins\" can-do=\"projectInstanceRolesView\" ng-class=\"{ collapsed : !vm.showRoles}\">\r\n  <div class=\"ibox-title\" ng-click=\"vm.showRoles = !vm.showRoles\">\r\n    <h3 translate>projectinstance.detail.roles</h3>\r\n    <div class=\"ibox-tools dropdown\"><a><i class=\"fa fa-chevron-up\"></i></a></div>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <div class=\"tabs-container projectInstanceDetail__roleAssignment\" ng-show=\"vm.isInit\">\r\n        <div class=\"row roleAssignment m-b-md\" ng-repeat=\"m in vm.data.roleAssignment | orderBy:\'name\'\">\r\n          <div class=\"col-sm-3\"><strong>{{m.name}}</strong></div>\r\n          <div class=\"col-sm-6 m-b-xs\">\r\n            <div class=\"label label-primary\" ng-repeat=\"u in m.users\">{{u.name}}</div>\r\n            <div class=\"label label-success\" ng-repeat=\"u in m.groups\">{{u.name}}</div>\r\n          </div>\r\n          <div class=\"col-sm-3\">\r\n            <button can-do=\"taskUsersView\" uib-popover-html=\"m.usersMappedHtml\" popover-placement=\"bottom\" type=\"button\" class=\"btn btn-info btn-xs\">\r\n              <i class=\"fa fa-user\"></i>\r\n              {{\'task.relatedto\' | translate}}\r\n            </button>\r\n          </div>\r\n        </div>\r\n        \r\n      \r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/detail.tasks.html","<div class=\"ibox float-e-margins\" ng-class=\"{ collapsed : !vm.showTasks}\" can-do=\"projectInstanceStagesView\">\r\n  <div class=\"ibox-title\" ng-click=\"vm.showTasks = !vm.showTasks\">\r\n    <h3 translate>projectinstance.detail.tasks</h3>\r\n    <div class=\"ibox-tools dropdown\">\r\n      <a><i class=\"fa fa-chevron-up\"></i></a>\r\n    </div>\r\n  </div>\r\n  <div class=\"ibox-content\" ng-show=\"vm.isInit\">\r\n    <table class=\"table jobdetail__tasks\">\r\n      <thead>\r\n      <tr>\r\n        <th colspan=\"3\" translate>projectinstance.detail.tasksname</th>\r\n      </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr ng-if=\"!vm.data.taskTemplates.length\">\r\n          <td colspan=\"3\" class=\"text-center\" translate>common.norecords</td>\r\n        </tr>\r\n      <tr ng-repeat=\"t in vm.data.taskTemplates | orderBy:\'createdOn\'\">\r\n        <td>\r\n          <a ui-sref=\"siskin.taskinstance({taskInstanceId: t.projectTaskId})\">{{t.name}}</a>\r\n        </td>\r\n        <td>\r\n          <span ng-if=\"!t.projectTaskCompletedBy && t.projectTaskAssignedTo\">{{\'projectinstance.detail.overview.assignedto\' | translate}} <b>{{t.projectTaskAssignedTo}}</b></span>\r\n          <span ng-if=\"t.projectTaskCompletedBy\">{{\'projectinstance.detail.overview.completedby\' | translate}} <b>{{t.projectTaskCompletedBy}}</b></span>\r\n          <span ng-if=\"!t.completed && !t.projectTaskAssignedTo\" translate>common.task.unassigned</span>\r\n        </td>\r\n        <td>\r\n          <i class=\"fa fa-check-circle fa-2x projectInstanceDetail__overview__task--completed\" ng-if=\"t.completed\" translate-attr=\"{title:\'enum.status.completed\'}\"></i>\r\n          <i class=\"fa fa-exclamation-circle fa-2x projectInstanceDetail__overview__task--overdue\" ng-if=\"t.overdue\" translate-attr=\"{title:\'enum.status.overdue\'}\"></i>\r\n          <i class=\"fa fa-user-circle fa-2x projectInstanceDetail__overview__task--active\" ng-if=\"t.active\" translate-attr=\"{title:\'enum.status.pending\'}\"></i>\r\n        </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/list.html","<div class=\"projectinstancelist\" ng-controller=\"projectInstanceListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title flexeverything\">\r\n            <h4 class=\"flex\" translate>nav.projectinstancelist  </h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"joblist__filter\">\r\n              <div class=\"row m-t-sm m-b-sm\">\r\n\r\n                <div class=\"col-sm-4 col-md-3 m-b-sm\">\r\n                  <span class=\"input-header\" translate>common.searchplaceholder</span>\r\n                  <input type=\"text\" id=\"top-search\" ng-model=\"vm.search.query\" ng-change=\"vm.reset()\" ng-model-options=\"{ debounce: 500 }\" class=\"form-control\" translate-attr=\"{placeholder : \'common.searchplaceholder\'}\">\r\n                  \r\n                </div>\r\n\r\n                <div class=\"col-sm-4 col-md-3 m-b-sm\">\r\n                  <span class=\"input-header\" translate>projects.projectname</span>\r\n                  <dropdown ng-if=\"vm.filters\" ng-values=\"vm.filters.projectTemplates\" ng-model=\"vm.search.template\" ng-change=\"vm.reset()\" placeholder=\"projects.filterbyprojectnameplaceholder\">\r\n                  </dropdown>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4 col-md-3 m-b-sm\">\r\n                  <span class=\"input-header\" translate>projects.filterbystore</span>\r\n                  <dropdown ng-if=\"vm.filters\" ng-values=\"vm.filters.stores\" ng-model=\"vm.search.store\" ng-change=\"vm.reset()\" placeholder=\"projects.filterbystoreplaceholder\">\r\n                  </dropdown>\r\n                </div>\r\n\r\n                <div class=\"col-sm-4 col-md-3 m-b-sm\">\r\n                  <span class=\"input-header\" translate>projects.orderbyattribute</span>\r\n                  <dropdown ng-if=\"vm.filters\" ng-values=\"vm.filters.attributes\" ng-model=\"vm.search.attributeIds\" prop=\"id\" ng-change=\"vm.reset()\">\r\n                </dropdown>\r\n                </div>\r\n\r\n              </div>\r\n            </div>\r\n\r\n            <table class=\"table\">\r\n              <thead>\r\n              <tr>\r\n                <th class=\"col-xs hidden-xs\" translate>projects.projecttemplatename</th>\r\n                <th class=\"col-xs hidden-xs\" translate>projects.projecttemplatecode</th>\r\n                <th class=\"col-xs\" translate>projects.projectinstancename</th>\r\n                <th class=\"col-xs\" translate>projects.storename</th>\r\n                <th class=\"col-xs hidden-xs\" translate>projects.storeaddress</th>\r\n                <th class=\"col-xs\" translate ng-if=\"vm.filters.attributes.length\">projects.projectinfo</th>\r\n              </tr>\r\n              </thead>\r\n              <tbody>\r\n              <tr ng-if=\"vm.pager.noResults\">\r\n                <td colspan=\"7\" class=\"text-center\" translate>common.norecords</td>\r\n              </tr>\r\n              <tr ng-repeat=\"m in vm.pager.items\">\r\n                <td class=\"col-xs hidden-xs\">\r\n                  <a ui-sref=\"siskin.project({\'projectId\': m.projectTemplateId})\" can-do=\"projectTemplateView\">{{m.projectTemplateName}}</a>\r\n                  <span can-do=\"projectTemplateView\" negate>{{m.projectTemplateName}}</span>\r\n                </td>\r\n                <td class=\"col-xs hidden-xs\">{{m.projectTemplateCode}}</td>\r\n                <td class=\"col-xs\">\r\n                  <a ui-sref=\"siskin.projectinstancedetail({projectInstanceId:m.id})\">{{m.projectInstanceName}}</a>\r\n                </td>\r\n                <td class=\"col-xs\">\r\n                  <a ui-sref=\"siskin.store({storeId:m.concernId})\">{{m.concernName}}</a>\r\n                </td>\r\n                <td class=\"col-xs hidden-xs\">{{m.concernAddress}}</td>\r\n                <td class=\"col-xs\" ng-if=\"vm.filters.attributes.length\">\r\n                  <div ng-repeat=\"i in m.dataValues\" class=\"flexeverything attributeValueList\">\r\n                    <strong class=\"attribute\">{{i.name}}</strong>\r\n                    <field-value field=\"i\"></field-value>\r\n                  </div>\r\n                </td>\r\n              </tr>\r\n              </tbody>\r\n            </table>\r\n            <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n            <pager ng-model=\"vm.pager\"></pager>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/putonhold.modal.html","<div>\r\n	<div class=\"modal-header\">\r\n		<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n			<span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>generic.action.close</span>\r\n		</button>\r\n	<h4 class=\"modal-title\" ng-if=\"vmModal.data.isActive\" translate>projectinstance.detail.resumeonhold.putonhold</h4>\r\n	<!-- when actually developing the \'hold\' we gotta display \'start\' or \'resume\'  -->\r\n    <!-- <h4 class=\"modal-title\" ng-if=\"!vmModal.data.isActive\" translate>projectinstance.detail.resumeonhold.resumeproject</h4> -->\r\n    <h4 class=\"modal-title\" ng-if=\"!vmModal.data.isActive\" translate>projectinstance.detail.resumeonhold.start</h4>\r\n	</div>\r\n\r\n	<div class=\"modal-body\">\r\n		<form class=\"form-horizontal\">\r\n			<div class=\"form-group\">\r\n				<div class=\"col-lg-12\">\r\n					<textarea type=\"text\" class=\"form-control\" ng-model=\"vmModal.message\" style=\"resize:vertical\" rows=\"4\" placeholder=\"{{\'projectinstance.detail.resumeonhold.writecomment\'|translate}}\" auto-focus ng-enter=\"vmModal.save()\"></textarea>\r\n				</div>\r\n			</div>\r\n		</form>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<button type=\"button\" class=\"btn btn-danger\" ng-disabled=\"!vmModal.message\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>generic.action.confirm</button>\r\n		<button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>generic.action.close</button>\r\n	</div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/roleselection.modal.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>projectinstance.projectrolemapping.modaltitle</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\" ng-repeat=\"role in vmModal.roles | orderBy:\'listOrder\'\" ng-if=\"vmModal.roles\">\r\n        <label class=\"col-lg-4 control-label\">{{role.name}}</label>\r\n        <div class=\"col-lg-8\">\r\n          <dropdown-multiple ng-model=\"role.userOrGroup\" pager=\"role.pager\" placeholder=\"projects.instance.userorgroup\" ng-change=\"vmModal.changed(role)\" group-by=\"type\"></dropdown-multiple>\r\n        </div>\r\n      </div>\r\n    </form>\r\n\r\n    <sk-spinner ng-show=\"vmModal.busy\"></sk-spinner>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" ng-disabled=\"vmModal.busy || !vmModal.isValid()\" translate>common.save</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/projectinstance/rollback.html","<div id=\"rollback-panel\" class=\"rollback\" ng-controller=\"WorkflowInstanceController as vm\">\r\n  <div class=\"blocking-overlay\" ng-class=\"{\'busy\':vm.isBusy}\">\r\n    <sk-spinner></sk-spinner>\r\n  </div>\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n\r\n    <sk-spinner ng-if=\"!vm.data\"></sk-spinner>\r\n    <div class=\"row\" ng-class=\"{\'busy\':vm.isBusy}\" ng-if=\"vm.data\">\r\n      <div class=\"col-lg-9\">\r\n        <div class=\"flowchart\">\r\n          <div class=\"ibox float-e-margins\">\r\n            <div class=\"ibox-title flexeverything\">\r\n              <h3 class=\"flexeverything--spacer\">\r\n                <a ui-sref=\"siskin.projectinstancedetail({projectInstanceId:vm.data.id})\">{{vm.data.projectInstanceName}}</a> /\r\n                {{ vm.selected.workflowEntityName }} {{ vm.selected.version }}\r\n              </h3>\r\n              <div class=\"actions\">\r\n                <div class=\"btn-group zoom\">\r\n                  <button class=\"btn\" ng-click=\"vm.flowchart.zoomOut()\"><i class=\"fa fa-minus\"></i></button>\r\n                  <button class=\"btn\" ng-click=\"vm.flowchart.zoomIn()\"><i class=\"fa fa-plus\"></i></button>\r\n                </div>\r\n                <button class=\"btn btn-primary\" ng-click=\"vm.startWizard()\" ng-if=\"vm.selected && !vm.wizard.hasStarted\" ng-disabled=\"vm.selected.isCompleted\" translate>rollback.rollbackthis</button>\r\n                <button class=\"btn btn-default\" ng-click=\"vm.stopWizard()\" ng-if=\"vm.selected && vm.wizard.hasStarted\" translate>common.cancel</button>\r\n              </div>\r\n            </div>\r\n            <div class=\"ibox-content\">\r\n              <div class=\"flowchart-panel\">\r\n                <div class=\"flowchart-div loading\">\r\n                  <i class=\"loader element\"></i>\r\n                  <span class=\"content\">\r\n                                                <span id=\"diagram-container\">\r\n                                                    <sk-spinnner-circle ng-show=\"!vm.selected\"></sk-spinnner-circle>\r\n                                                    <div ng-class=\"{\'rollback__diagram--loaded\':vm.selected}\" id=\"diagram\"></div>\r\n                                                </span>\r\n                                            </span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-3\">\r\n        <div class=\"ibox\">\r\n          <div class=\"ibox-title\">\r\n            <div ng-if=\"!vm.wizard.hasStarted\" class=\"flexeverything\">\r\n              <h3 class=\"flexeverything--spacer\" translate>rollback.projectinstances</h3>\r\n              <i class=\"fa fa-refresh fa-2x\" title=\"{{\'rollback.refresh\'|translate}}\" ng-click=\"vm.refresh()\"></i>\r\n            </div>\r\n\r\n            <div class=\"flexeverything\" ng-if=\"vm.wizard.hasStarted\">\r\n                                <span ng-class=\"{\'btn-default\' : !s.isCompleted && vm.wizard.current != s, \'btn-primary\': s.isCompleted || vm.wizard.current == s, \'btn-arrow-right-no-tail\':$first,\'btn-arrow-right-no-head\': $last}\" ng-click=\"vm.wizard.setCurrent($index,true)\" class=\"btn btn-small btn-arrow-right flexeverything--spacer\" ng-repeat=\"s in vm.wizard.steps | filter:{display:true}\">\r\n                                    {{ s.title | translate}}\r\n                                </span>\r\n            </div>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div ng-if=\"!vm.wizard.hasStarted\">\r\n              <div ng-repeat=\"w in vm.data.allWorkflows\">\r\n                <div class=\"rollback__workflow alert\" ng-click=\"vm.select(m)\" ng-repeat=\"m in w.instances\" ng-class=\"{\'rollback__workflow--ischild\' : !w.isRoot, \'alert-muted\':m.isCompleted,\r\n                                        \'alert-success\':!m.isCompleted, \'rollback__workflow--selected\':m == vm.selected}\">\r\n                  <i class=\"fa fa-sitemap m-r-xs\"></i>\r\n                  <b>{{w.name}}</b>\r\n                  <small>{{w.version}}</small>\r\n                </div>\r\n              </div>\r\n\r\n\r\n\r\n            </div>\r\n\r\n            <div ng-if=\"vm.wizard.hasStarted\" class=\"rollback__wizard\">\r\n              <h4 ng-if=\"vm.wizard.current.description\">{{ vm.selected.wizard.current.description }}</h4>\r\n\r\n              <div class=\"rollback__wizard__body\">\r\n                <div ng-switch=\"vm.wizard.current.id\">\r\n                  <!-- Step 1 : select  -->\r\n                  <div ng-switch-when=\"select\">\r\n                    <div class=\"alert alert-info flexeverything\">\r\n                      <i class=\"fa fa-info-circle fa-2x\"></i>\r\n                      <b class=\"m-l-xs\" translate>rollback.wizard.selectanactivity</b>\r\n                    </div>\r\n                    <p ng-if=\"vm.wizard.to\">{{\'rollback.wizard.selected\'|translate}} <b>{{ vm.wizard.to.name }}</b></p>\r\n                  </div>\r\n                  <!-- --Step 2 : tasks  -->\r\n                  <div ng-switch-when=\"history\">\r\n                    <div class=\"alert alert-info flexeverything\">\r\n                      <i class=\"fa fa-info-circle fa-2x\"></i>\r\n                      <b class=\"m-l-xs\" translate>rollback.wizard.hintstep</b>\r\n                    </div>\r\n\r\n                    <div class=\"project-tasks\" ng-if=\"vm.wizard.completedProjectTasks.length\">\r\n                      <h5 translate>rollback.wizard.tasks\r\n                        <div ng-repeat=\"t in vm.wizard.completedProjectTasks\" class=\"m-b-xs\">\r\n                          <label>\r\n                            <input icheck type=\"checkbox\" class=\"checkbox\" ng-model=\"t.selected\" ng-disabled=\"vm.selected.projectId !== t.projectId\">\r\n                            <span class=\"label label-info m-l-xs\"><i class=\"icon-ok icon-white\"></i>{{ t.name }}</span>\r\n                          </label>\r\n                        </div>\r\n                    </h5></div>\r\n\r\n                    <div class=\"milestones\" ng-if=\"vm.wizard.milestones.length\">\r\n                      <h5 translate>rollback.wizard.milestones</h5>\r\n                      <div ng-repeat=\"m in vm.wizard.milestones\" class=\"flexeverything m-b-xs\">\r\n                        <label>\r\n                          <input icheck type=\"checkbox\" class=\"checkbox\" ng-change=\"vm.updateMilestone(m)\" ng-model=\"m.isCompleted\">\r\n                          <span class=\"label label-success m-l-xs\">\r\n                                                                <i class=\"icon-ok icon-white\"></i>\r\n                                                                {{ m.name }}\r\n                                                            </span>\r\n                        </label>\r\n                      </div>\r\n                    </div>\r\n\r\n                  </div>\r\n                  <!-- --Step 3 : confirm -- -->\r\n                  <div ng-switch-when=\"confirm\">\r\n                    <!-- -- Summary -- -->\r\n                    <div class=\"alert alert-info flexeverything\">\r\n                      <i class=\"fa fa-info-circle fa-2x\"></i>\r\n                      <b class=\"m-l-xs\" translate>rollback.wizard.confirmationhint</b>\r\n                    </div>\r\n                    <b translate>rollback.wizard.hint</b>\r\n                    <ul>\r\n                      <li><b>{{\'rollback.wizard.from\'|translate}} <label class=\"label label-success\">{{vm.wizard.from.name}}</label></b></li>\r\n                      <li><b>{{\'rollback.wizard.to\'|translate}} <label class=\"label label-success\">{{vm.wizard.to.name}}</label></b></li>\r\n                    </ul>\r\n                    <!-- Active and parallel tasks  -->\r\n                    <div>\r\n                      <div ng-if=\"vm.wizard.preview.projectTasks.length\" class=\"m-b-md\">\r\n                        <b>{{ vm.wizard.preview.projectTasks.length }} {{\'rollback.wizard.activetasks\' | translate}}</b>\r\n                        <div ng-repeat=\"t in vm.wizard.preview.projectTasks\" class=\"m-b-xs\">\r\n                          <div class=\"label label-success m-r-xs\">\r\n                            {{t.name}}\r\n                          </div>\r\n                          <small class=\"muted\">-- {{\'rollback.wizard.historytaskdueon\' | translate}} {{ t.dueOn | dateTimeFromUtc }}</small>\r\n                        </div>\r\n                      </div>\r\n\r\n                      <div ng-if=\"vm.wizard.preview.childProjects.length\" class=\"m-b-md\">\r\n                        <b>{{ vm.wizard.preview.childProjects.length }} {{\'rollback.wizard.childprojectswillbedeleted\' | translate}}</b>\r\n                        <div ng-repeat=\"t in vm.wizard.preview.childProjects\">\r\n                          <div class=\"m-b-xs\">\r\n                                                                <span class=\"label label-success m-r-xs\">\r\n                                                                        <i class=\"icon-ok icon-white\"></i>{{ t.name }}\r\n                                                                </span>\r\n                            <small class=\"muted\">-- {{ t.startedOn | dateTimeFromUtc }}</small>\r\n                          </div>\r\n\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <!-- History -->\r\n                    <div ng-if=\"(vm.wizard.completedProjectTasks|filter:{selected:true}).length\">\r\n                      <b>{{(vm.wizard.completedProjectTasks|filter:{selected:true}).length}} {{\'rollback.wizard.historytaskupdated\'|translate}}</b>\r\n\r\n                      <div ng-repeat=\"t in vm.wizard.completedProjectTasks | filter : {selected : true}\" class=\"m-b-xs\">\r\n                        <span class=\"label m-r-xs\" ng-class=\"{\'label-success\': t.isCurrent, \'label-default\': !t.isCurrent}\">{{ t.name }}</span>\r\n                        <small class=\"muted\">-- {{\'rollback.wizard.historytaskcompletedon\' | translate}} {{ t.completedOn | dateTimeFromUtc }}</small>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <!-- Milestones -->\r\n                    <div ng-if=\"(vm.wizard.milestones|filter:{hasChanged:true}).length\">\r\n                      <b>{{(vm.wizard.milestones|filter:{hasChanged:true}).length}} {{\'rollback.wizard.historymilestoneupdated\'|translate}}</b>\r\n\r\n                      <div ng-repeat=\"m in vm.wizard.milestones | filter : {hasChanged : true}\" class=\"m-b-md\">\r\n                                                        <span class=\"label label-success m-r-xs\">\r\n                                                            <i class=\"icon-ok icon-white\"></i>{{ m.name }}\r\n                                                        </span>\r\n                        <i class=\"fa fa-arrow-right m-r-xs\"></i>\r\n                        <span class=\"label label-danger\" ng-if=\"!m.isCompleted\"><i class=\"fa fa-times m-r-xs\"></i>{{\'rollback.wizard.milestoneuncompleted\'| translate}}</span>\r\n                        <span class=\"label label-primary\" ng-if=\"m.isCompleted\"><i class=\"fa fa-check m-r-xs\"></i>{{\'rollback.wizard.milestonecompleted\'| translate}}</span>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div ng-switch-default></div>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"step-actions flexeverything\">\r\n                <button class=\"btn btn-primary btn-step flexeverything--spacer m-t-md\" ng-click=\"vm.wizard.current.complete()\" ng-disabled=\"!vm.wizard.current.valid()\" translate>\r\n                  {{ vm.wizard.current.btnLabel }}\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/reports/reports.html","<div class=\"reports\" ng-controller=\"ReportsController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title\">\r\n            <h4 translate>reports.title</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"flexeverything wrap\">\r\n              <dropdown-multiple ng-model=\"vm.projects\" pager=\"vm.pager\" ng-change=\"vm.reload()\" placeholder=\"reports.projects\" ng-disabled=\"vm.busy\"></dropdown-multiple>\r\n              <span class=\"flexeverything--spacer\"></span>\r\n              <presets class=\"m-r-sm\" ng-if=\"vm.data\" values=\"vm.data.all\" resource=\"vm.data.resource\" ng-disabled=\"vm.busy\"></presets>\r\n              <button class=\"btn btn-primary\" ng-disabled=\"!vm.data || vm.busy\" ng-click=\"vm.download()\" translate>reports.download</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"row\">\r\n      <sk-spinner ng-show=\"vm.busy\"></sk-spinner>\r\n      <div ng-show=\"!vm.busy && vm.data\">\r\n        <div class=\"col-md-4\">\r\n          <div class=\"ibox float-e-margins\">\r\n            <div class=\"ibox-content\">\r\n              <h3 translate>reports.attributes</h3>\r\n              <input type=\"text\" class=\"input input-sm form-control\" placeholder=\"{{\'common.searchplaceholder\' | translate}}\" ng-model=\"vm.search.attribute\">\r\n\r\n              <ul class=\"agile-list\">\r\n                <li ng-repeat=\"m in vm.data.categories\" ng-class=\"{\'success-element\': m.pvalue}\" ng-click=\"vm.select(m)\">\r\n                  {{m.name}}\r\n\r\n                  <ul class=\"agile-list\">\r\n                    <li ng-repeat=\"a in m.attributes | filter: {name: vm.search.attribute}\" ng-class=\"{\'success-element\': a.pvalue}\" ng-click=\"vm.select(a, $event)\" stop-event=\"click\">\r\n                      {{a.name}}\r\n                    </li>\r\n                  </ul>\r\n                </li>\r\n              </ul>\r\n\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-4\">\r\n          <div class=\"ibox float-e-margins\">\r\n            <div class=\"ibox-content\">\r\n              <h3 translate>reports.tasks</h3>\r\n              <input type=\"text\" class=\"input input-sm form-control\" placeholder=\"{{\'common.searchplaceholder\' | translate}}\" ng-model=\"vm.search.task\">\r\n\r\n              <ul class=\"agile-list\">\r\n                <li ng-repeat=\"m in vm.data.tasks  | filter: {name: vm.search.task}\" ng-class=\"{\'success-element\': m.pvalue}\" ng-click=\"vm.select(m)\">\r\n                  {{m.name}}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-4\">\r\n          <div class=\"ibox float-e-margins\">\r\n            <div class=\"ibox-content\">\r\n              <h3 translate>reports.milestones</h3>\r\n              <input type=\"text\" class=\"input input-sm form-control\" placeholder=\"{{\'common.searchplaceholder\' | translate}}\" ng-model=\"vm.search.milestone\">\r\n\r\n              <ul class=\"agile-list\">\r\n                <li ng-repeat=\"m in vm.data.milestones  | filter: {name: vm.search.milestone}\" ng-class=\"{\'success-element\': m.pvalue}\" ng-click=\"vm.select(m)\">\r\n                  {{m.name}}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/taskinstance/detail.html","<div class=\"taskinstancedetail\" ng-controller=\"TaskInstanceDetailController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <sk-spinner ng-if=\"!vm.data && !vm.error\"></sk-spinner>\r\n  <div class=\"alert alert-danger text-center\" ng-if=\"vm.error\">\r\n    <i class=\"fa fa-exclamation-circle fa-5x m-b-lg m-t-lg\"></i>\r\n    <div>\r\n        <h3 translate>task.interactive.cannotaccess</h3>\r\n        <h3 translate ng-if=\"vm.data.isCompleted\">task.interactive.completedbyotheruser</h3>\r\n    </div>\r\n</div>\r\n  <div class=\"wrapper wrapper-content\" ng-if=\"vm.data\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins m-b-sm\">\r\n          <div class=\"ibox-title flexeverything\">\r\n            <h4>\r\n              <a ui-sref=\"siskin.inbox({\'query\': vm.query})\" translate>nav.inbox</a> /\r\n              <a can-do=\"projectTemplateView\" ui-sref=\"siskin.project({\'projectId\': vm.data.projectTemplateId})\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\">{{ vm.data.projectTemplateName  }}</a> /\r\n              <a can-do=\"projectInstanceView\" ui-sref=\"siskin.projectinstancedetail({\'projectInstanceId\': vm.data.projectId})\">{{ vm.data.projectName }}</a>\r\n              <span can-do=\"projectInstanceView\" negate>{{ vm.data.projectName }}</span>\r\n            </h4>\r\n            <span class=\"flexeverything--spacer\"></span>\r\n            <span>\r\n                  <button can-do=\"reportView\" class=\"btn btn-primary\" ng-click=\"vm.createReport()\" translate>projectinstance.detail.createreport</button>\r\n              </span>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <h2><b>{{ \'taskinstance.name\' | translate }}</b> : {{vm.data.name}}</h2>\r\n            <h3><b>{{ \'taskinstance.projectinstancename\' | translate }}</b> : {{vm.data.projectName}}</h3>\r\n            <h3><b>{{ \'taskinstance.store\' | translate }}</b> : {{vm.data.storeName}}</h3>\r\n            <div class=\"row m-b-md\">\r\n              <div class=\"col-lg-12 m-b-xs\">\r\n                <b>{{ \'taskinstance.storeaddress\' | translate }} </b>: {{ vm.data.storeAddress}}\r\n              </div>\r\n\r\n              <div class=\"col-sm-12\" ng-repeat=\"storeInfo in vm.data.dataValues | filter:{type:\'storeinfo\'}\">\r\n                <span class=\"storeinfo m-r-xs\" ng-repeat=\"field in storeInfo.data\" ng-switch=\"field.type\" ng-if=\"field.value\">\r\n                  <span ng-switch-when=\"datetime\" class=\"label m-b-xs\">\r\n                    {{ field.name }} : {{ field.value | dateTimeFromUtc}}\r\n                  </span>\r\n                  <span ng-switch-when=\"date\" class=\"label m-b-xs\">\r\n                    {{ field.name }} : {{ field.value | dateFromUtc}}\r\n                  </span>\r\n                  <span ng-switch-when=\"double\" class=\"label m-b-xs\">\r\n                    {{ field.name }} : {{ field.value | number: vm.decimalsLength}}\r\n                  </span>\r\n                  <span ng-switch-when=\"user\" class=\"label m-b-xs\">\r\n                    {{ field.name }} : {{ field.value.selectedUser.longName }}\r\n                  </span>\r\n                  <span ng-switch-default class=\"label m-b-xs\">\r\n                    {{ field.name }} : {{ field.value }}\r\n                  </span>\r\n                </span>\r\n              </div>\r\n            </div>\r\n\r\n            <table class=\"table\">\r\n              <thead>\r\n              <tr>\r\n                <th translate>taskinstance.status</th>\r\n                <th translate>taskinstance.dueon</th>\r\n                <th translate>taskinstance.assigned</th>\r\n                <th ng-if=\"vm.data.status !== main.constants.taskstatuses.completed && vm.data.canPerformTaskAction\" translate>taskinstance.actions\r\n                </th>\r\n                <th ng-if=\"vm.data.status === main.constants.taskstatuses.completed\" translate>\r\n                  taskinstance.completedon\r\n                </th>\r\n              </tr>\r\n              </thead>\r\n              <tbody>\r\n              <tr>\r\n                <td>\r\n                  <label class=\"label label-status-{{vm.data.status}}\">{{\'enum.status.\' + vm.data.status |\r\n                    translate}}</label>\r\n                </td>\r\n                <td>{{vm.data.dueOn | dateTimeFromUtc}}</td>\r\n                <td>{{vm.data.assignedTo | ornone}}</td>\r\n                <td ng-if=\"vm.data.status !== main.constants.taskstatuses.completed\">\r\n                  <button class=\"btn btn-primary m-l-xs\" ng-if=\"vm.data.canClaim\" ng-disabled=\"vm.isBusy\" ng-click=\"vm.claim()\" translate>\r\n                    taskinstance.claim\r\n                  </button>\r\n                  <!-- <div class=\"btn-group\" > -->\r\n                  <span ng-if=\"vm.data.canPerformTaskAction\">\r\n                    <button class=\"btn btn-primary m-l-xs\" ng-disabled=\"vm.isBusy\" ng-repeat=\"action in vm.data.actions\" ng-click=\"vm.complete(action)\">\r\n                      {{action.name | translate}}\r\n                    </button>\r\n                    <button class=\"btn btn-info m-l-xs\" ng-click=\"vm.noteAdd()\" translate>taskinstance.addnote</button>\r\n                  </span>\r\n                  <button class=\"btn btn-default m-l-xs\" ng-if=\"vm.data.canUnclaim\" ng-disabled=\"vm.isBusy\" ng-click=\"vm.unclaim()\" translate>\r\n                    taskinstance.unclaim\r\n                  </button>\r\n                </td>\r\n                <td ng-if=\"vm.data.status === main.constants.taskstatuses.completed\">{{vm.data.completedOn |\r\n                  dateTimeFromUtc }}\r\n                </td>\r\n              </tr>\r\n              </tbody>\r\n            </table>\r\n\r\n          </div>\r\n        </div>\r\n        <div class=\"ibox float-e-margins m-b-sm\" ng-if=\"vm.data.lastNote\">\r\n          <div class=\"ibox-title\" translate>taskinstance.notes</div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"message flexeverything\">\r\n              <i class=\"fa fa-sticky-note m-r-sm\"></i>\r\n              <div class=\"flex\">\r\n                <div>\r\n                  {{vm.data.lastNote.date | dateFromUtc}}\r\n                  <i class=\"fa fa-eye m-l-xs\" ng-if=\"vm.data.lastNote.projectRoleMappingsNames.length\" title=\"{{ \'notes.notefor\' | translate }} : {{ vm.data.lastNote.projectRoleMappingsNames.join(\', \')}}\"></i>\r\n                </div>\r\n                <b>{{vm.data.lastNote.userName}} : </b> {{vm.data.lastNote.body}}\r\n              </div>\r\n              <button class=\"btn btn-info\" can-do=\"projectInstanceHistoryView\" ng-click=\"vm.moreInfo()\" translate>taskinstance.moreinfo</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"tabs-container\">\r\n          <uib-tabset active=\"vm.active\" ng-class=\"{\'tabs-inactive\' : vm.active == null}\" class=\"clearfix\">\r\n            <uib-tab ng-repeat=\"tab in vm.data.dataValues | filter:vm.notaspecialgroup | orderBy : \'listOrder\'\">\r\n              <uib-tab-heading ng-class=\"{\'taskinstancedetail__category--empty\': (tab.data | hasValue).length === 0 }\">\r\n                <i class=\"fa fa-2x datavalue-icon datavalue-icon-{{tab.type}}\"></i>\r\n                <span>{{tab.name | ordefault}}</span>\r\n                <span ng-if=\"(tab.data | filter:{hasRequiredError:true}).length\" class=\"label label-danger\" translate>task.fields.required</span>\r\n              </uib-tab-heading>\r\n              <div class=\"panel-body datavalue-group--{{tab.type}}\">\r\n                <h3>{{tab.name}}</h3>\r\n                <div class=\"datavalue\" ng-repeat=\"dv in tab.data | filter:vm.searchText | orderBy:\'field.listOrder\'\" ng-switch=\"dv.type\" ng-class=\"{\'col-sm-2\': dv.type === \'files\' && tab.type === \'image\',\'col-lg-12\': dv.type !== \'files\', \'has-error\': vm.hasError(dv)}\">\r\n                  <div class=\"datavalue__title\">\r\n                        <span class=\"projectInstanceDetail__datavalue__title\">\r\n                          <label class=\"projectInstanceDetail__datavalue__name\" translate>\r\n                            {{dv.name}}\r\n                          </label>\r\n                          <span ng-if=\"dv.hasRequiredError\" class=\"label label-danger\" translate>task.fields.required</span>\r\n                        </span>\r\n                  </div>\r\n\r\n                  <div ng-switch-when=\"files\" class=\"datavalue__data\">\r\n                    <field-files field=\"dv\" ng-if=\"tab.type !== \'image\'\" parent=\".panel-body\"></field-files>\r\n                    <field-simple-files field=\"dv\" ng-if=\"tab.type === \'image\'\" parent=\".panel-body\"></field-simple-files>\r\n                  </div>\r\n                  <field-boolean class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"boolean\"></field-boolean>\r\n                  <field-confirmation class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"confirmation\"></field-confirmation>\r\n                  <field-date class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"date\"></field-date>\r\n                  <field-datetime class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"datetime\"></field-datetime>\r\n                  <field-double class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"double\"></field-double>\r\n                  <field-dropdown class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"dropdown\"></field-dropdown>\r\n                  <field-integer class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"integer\"></field-integer>\r\n                  <field-string class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"string\"></field-string>\r\n                  <field-user class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"user\"></field-user>\r\n                  <field-group class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"group\"></field-group>\r\n                  <field-link class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"link\"></field-link>\r\n                </div>\r\n              </div>\r\n            </uib-tab>\r\n\r\n            <!--history-->\r\n            <uib-tab can-do=\"projectInstanceHistoryView\">\r\n              <uib-tab-heading>\r\n                <i class=\"fa fa-2x fa-calendar\"></i>\r\n                <span translate>taskinstance.history</span>\r\n                <i class=\"visible-ms-block ion-arrow-right-c\"></i>\r\n              </uib-tab-heading>\r\n              <div class=\"panel-body\">\r\n                <h3 translate>taskinstance.projectinstancehistory</h3>\r\n                <p translate>taskinstance.projectinstancehistoryhint</p>\r\n\r\n\r\n                <div id=\"vertical-timeline\" class=\"dark-timeline\">\r\n                  <div class=\"vertical-timeline-block\" ng-repeat=\"m in vm.data.history | orderBy:\'-date\'\" ng-switch=\"m.type\">\r\n                       <div ng-switch-default>{{m.type}}</div>\r\n                    <!--note-->\r\n                    <div ng-switch-when=\"note\" class=\"note\">\r\n                      <div class=\"vertical-timeline-icon yellow-bg\">\r\n                        <i class=\"fa fa-sticky-note\"></i>\r\n                      </div>\r\n\r\n                      <div class=\"vertical-timeline-content\">\r\n                        <h2>\r\n                          {{\'taskinstance.note\'|translate}}\r\n                          <i class=\"fa fa-eye m-l-xs\" ng-if=\"m.projectRoleMappingsNames.length\" title=\"{{ \'notes.notefor\' | translate }} : {{ m.projectRoleMappingsNames.join(\', \')}}\"></i>\r\n                        </h2>\r\n                        <p>{{m.body}}</p>\r\n                        <span class=\"vertical-date\">\r\n                          {{m.date | dateFrom}}\r\n                          <br>\r\n                          <small>{{m.date | dateTimeFromUtc}}</small>\r\n                          <small><b>, {{m.userName}}</b></small>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <!--milestone-->\r\n                    <div ng-switch-when=\"milestone\">\r\n                      <div class=\"vertical-timeline-icon blue-bg\">\r\n                        <i class=\"fa fa-flag\"></i>\r\n                      </div>\r\n\r\n                      <div class=\"vertical-timeline-content\">\r\n                        <h2 translate>taskinstance.milestone</h2>\r\n                        <p>{{m.name}}</p>\r\n                        <span class=\"vertical-date\">\r\n                          {{m.date | dateFrom}}\r\n                          <br>\r\n                          <small>{{m.date | dateTimeFromUtc}}</small>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <!--task-->\r\n                    <div ng-switch-when=\"task\">\r\n                      <div class=\"vertical-timeline-icon navy-bg\">\r\n                        <i class=\"fa fa-user\"></i>\r\n                      </div>\r\n\r\n                      <div class=\"vertical-timeline-content\">\r\n                        <div>\r\n\r\n                          <h2 translate>taskinstance.task</h2>\r\n                          <p>{{m.name}}</p>\r\n                          <!--<a class=\"btn btn-sm btn-primary\" ng-if=\"m.history.length\"-->\r\n                          <!--ng-click=\"m.more = !m.more\">{{m.more ? \'taskinstance.lessinfo\' : \'taskinstance.moreinfo\' | translate }}</a>-->\r\n                          <div class=\"vertical-date\" style=\"float:none;\">\r\n                            {{m.date | dateFrom}}\r\n                            <br>\r\n                            <small>{{m.date | dateTimeFromUtc}}</small>\r\n\r\n                          </div>\r\n                        </div>\r\n                        <!--notes of task-->\r\n                        <div class=\"inspinia-timeline m-t-sm\">\r\n                          <div class=\"timeline-item\" ng-repeat=\"n in m.history\">\r\n                            <div class=\"row\">\r\n                              <div class=\"col-xs-3 date\">\r\n                                <i class=\"fa fa-sticky-note\"></i>\r\n                              </div>\r\n                              <div class=\"col-xs-7 content no-top-border\" style=\"padding-top:0px;min-height:0px;\">\r\n                                <div>{{n.body}}</div>\r\n                                <span class=\"vertical-date\" style=\"float:none\">\r\n                                    <small>{{n.date | dateTimeFromUtc}}</small>\r\n                                    <small><b>, {{n.userName}}</b>\r\n                                      <i class=\"fa fa-eye m-l-xs\" ng-if=\"n.projectRoleMappingsNames.length\" title=\"{{ \'notes.notefor\' | translate }} : {{ n.projectRoleMappingsNames.join(\', \')}}\"></i>\r\n                                    </small>\r\n                                  </span>\r\n                              </div>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n\r\n                      </div>\r\n                    </div>\r\n\r\n                  </div>\r\n                </div>\r\n\r\n\r\n              </div>\r\n            </uib-tab>\r\n\r\n            <!--reporting contracts-->\r\n            <uib-tab ng-repeat=\"dvs in vm.data.dataValues | filter:{type:\'reportingcontacts\'}\">\r\n              <uib-tab-heading>\r\n                <i class=\"fa fa-2x fa-user\"></i>\r\n                <span>{{dvs.name}}</span>\r\n                <i class=\"visible-ms-block ion-arrow-right-c\"></i>\r\n              </uib-tab-heading>\r\n              <div class=\"panel-body taskinstancedetail__reportingcontacts\">\r\n                <h3 translate>taskinstance.resourceandclientcontacts</h3>\r\n                <div class=\"form-horizontal\">\r\n                  <div class=\"form-group\" ng-repeat=\"dv in dvs.data | filter:vm.search.query\">\r\n                    <div class=\"col-md-2\">\r\n                      <label>{{dv.name}}</label>\r\n                    </div>\r\n                    <div class=\"col-md-10\">\r\n                      <span class=\"form-control\">{{dv.value | ornone}}</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </uib-tab>\r\n          </uib-tabset>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/taskinstance/detail.interactive.html","<div class=\"taskinstancedetail interactive\" ng-controller=\"TaskInstanceInteractiveController as vm\">\r\n    <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n    <sk-spinner ng-if=\"!vm.data || !vm.loaded\"></sk-spinner>\r\n    <div class=\"wrapper wrapper-content\" ng-if=\"vm.data\">\r\n    <!-- task already assigned to another user -->\r\n    <div class=\"alert alert-danger text-center\" ng-if=\"vm.notAccessible\">\r\n        <i class=\"fa fa-exclamation-circle fa-5x m-b-lg m-t-lg\"></i>\r\n        <div>\r\n            <h3 translate>task.interactive.cannotaccess</h3>\r\n            <h3 translate ng-if=\"vm.data.isCompleted\">task.interactive.completedbyotheruser</h3>\r\n        </div>\r\n    </div>\r\n<div class=\"alert alert-success text-center\" ng-if=\"vm.completedByUser\">\r\n        <i class=\"fa fa-check-circle fa-5x m-b-lg m-t-lg\"></i>\r\n        <div>\r\n            <h3>{{\'task.interactive.taskwascompletedsuccessfullyon\'| translate}} <b ng-if=\"vm.data.completedOn\">{{vm.data.completedOn | dateTimeFromUtc}}</b></h3>\r\n            <h3>{{\'task.interactive.closepage\' | translate }} {{\'task.interactive.or\' | translate }} <a ui-sref=\"siskin.dashboard\" translate>task.interactive.navigatetosiskin</a></h3>\r\n        </div>\r\n        <a ng-click=\"vm.close()\" translate></a>\r\n</div>\r\n<div ng-if=\"!vm.completedByUser && !vm.notAccessible && vm.loaded\">\r\n      <div class=\"ibox float-e-margins\">\r\n        <div class=\"ibox-title\">\r\n          <h3 translate>common.attributes</h3>\r\n        </div>\r\n\r\n        <div class=\"ibox-content\">\r\n            <div class=\"well\" ng-repeat=\"tab in vm.data.dataValues | filter:vm.notaspecialgroup | orderBy : \'listOrder\'\">\r\n                <div class=\"datavalue-group--{{tab.type}} flexeverything\">\r\n                    <i class=\"fa fa-2x datavalue-icon datavalue-icon-{{tab.type}} m-r-sm\"></i>\r\n                    <h2>{{tab.name}}\r\n                </h2></div>\r\n\r\n                  <div class=\"datavalue\" ng-repeat=\"dv in tab.data | filter:vm.searchText | orderBy:\'field.listOrder\'\" ng-switch=\"dv.type\" ng-class=\"{\'has-error\': vm.hasError(dv)}\">\r\n                    <div class=\"datavalue__title\">\r\n                          <span class=\"projectInstanceDetail__datavalue__title\">\r\n                            <label class=\"projectInstanceDetail__datavalue__name\" translate>\r\n                              {{dv.name}}\r\n                            </label>\r\n                            <span ng-if=\"dv.hasRequiredError\" class=\"label label-danger\" translate>task.fields.required</span>\r\n                          </span>\r\n                    </div>\r\n\r\n                    <div ng-switch-when=\"files\" class=\"datavalue__data\">\r\n                      <field-files field=\"dv\" ng-if=\"tab.type !== \'image\'\" parent=\".panel-body\"></field-files>\r\n                      <field-simple-files field=\"dv\" ng-if=\"tab.type === \'image\'\" parent=\".panel-body\"></field-simple-files>\r\n                    </div>\r\n                    <field-boolean class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"boolean\"></field-boolean>\r\n                    <field-confirmation class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"confirmation\"></field-confirmation>\r\n                    <field-date class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"date\"></field-date>\r\n                    <field-datetime class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"datetime\"></field-datetime>\r\n                    <field-double class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"double\"></field-double>\r\n                    <field-dropdown class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"dropdown\"></field-dropdown>\r\n                    <field-integer class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"integer\"></field-integer>\r\n                    <field-string class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"string\"></field-string>\r\n                    <field-user class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"user\"></field-user>\r\n                    <field-group class=\"datavalue__data\" field=\"dv\" ng-switch-when=\"group\"></field-group>\r\n                  </div>\r\n              </div>\r\n          </div>\r\n      </div>\r\n\r\n\r\n\r\n              <div class=\"ibox\">\r\n                <div class=\"ibox-content\">\r\n                   <!-- note -->\r\n                   <div class=\"pull-right m-b-sm\" style=\"min-width: 250px;\">\r\n                      <dropdown-multiple ng-if=\"vm.data.projectRoleMappingsPager\" pager=\"vm.data.projectRoleMappingsPager\" ng-model=\"vm.data.projectRoleMappings\" placeholder=\"common.selectroles\"></dropdown-multiple>\r\n                   </div>\r\n                   <div ng-class=\"{\'has-error\':vm.noteRequired && !vm.data.note}\">\r\n                      <textarea type=\"text\" class=\"form-control\" ng-model=\"vm.data.note\" rows=\"6\" style=\"resize:vertical\" placeholder=\"{{\'taskinstance.note.addnote\'|translate}}\"></textarea>\r\n                   </div>\r\n\r\n                   <!-- actions -->\r\n                   <div class=\"row m-t-sm\">\r\n                     <div class=\"col-sm-3 actions\">\r\n                        <button class=\"btn btn-primary full-width m-b-sm\" ng-repeat=\"action in vm.data.actions | filter:{\'name\': $stateParams.action}\" ng-click=\"vm.complete(action, true)\">{{action.name | translate}}</button>\r\n                     </div>\r\n                     </div>\r\n                   </div>\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n\r\n      </div>\r\n    \r\n  \r\n  \r\n");
$templateCache.put("app/modules/siskin/taskinstance/detail.note.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\">\r\n      {{\'taskinstance.note.addnote\' | translate}}\r\n      <label class=\"label label-info\" ng-if=\"vmModal.action\">: {{vmModal.action.name | translate}}</label>\r\n    </h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <div class=\"col-lg-12\">\r\n          <textarea type=\"text\" class=\"form-control\" ng-model=\"vmModal.note\" style=\"resize:vertical\"></textarea>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <dropdown-multiple ng-if=\"vmModal.projectRoleMappingsPager\" ng-disabled=\"!vmModal.note\" pager=\"vmModal.projectRoleMappingsPager\" ng-model=\"vmModal.projectRoleMappings\" placeholder=\"common.selectroles\"></dropdown-multiple>\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.save()\" ng-class=\"{\'has-error\': vmModal.error}\" ng-disabled=\"!vmModal.note\" translate>common.save</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/taskinstance/detail.reportingcontacts.html","");
$templateCache.put("app/modules/siskin/taskinstance/inbox.html","<div class=\"taskinstancelist\" ng-controller=\"InboxController as vm\">\r\n  <div ng-include=\"\'app/modules/siskin/taskinstance/inbox.searchbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div ng-if=\"vm.isListMode\" ng-include=\"\'app/modules/siskin/taskinstance/inbox.list.html\'\"></div>\r\n    <div ng-if=\"!vm.isListMode\" ng-include=\"\'app/modules/siskin/taskinstance/inbox.tab.html\'\"></div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/taskinstance/inbox.list.html","<div class=\"row\">\r\n  <div class=\"col-lg-12\">\r\n    <div class=\"ibox float-e-margins\">\r\n      <div class=\"ibox-title taskinstancelist__title breadcrumb\">\r\n        <span can-do=\"dashboardView\"><a ui-sref=\"siskin.dashboard\" translate>nav.clientdashboard</a> / </span><span translate>nav.inbox</span>\r\n        <span class=\"flexeverything--spacer\"></span>\r\n        <!--<button class=\"btn btn-default\" ng-click=\"vm.viewAttributes()\" translate>taskinstances.exportfiles</button>-->\r\n      </div>\r\n      <div class=\"ibox-content\">\r\n          <table class=\"table\">\r\n          <thead>\r\n          <tr>\r\n            <th class=\"visible-xs\" translate>taskinstances.project</th>\r\n            <th class=\"hidden-xs\" translate>taskinstances.name</th>\r\n            <th class=\"hidden-xs\" translate>taskinstances.code</th>\r\n            <th class=\"hidden-xs\" translate can-do feature=\"projectGroup\">taskinstances.client</th>\r\n            <th class=\"hidden-xs\" translate>taskinstances.storename</th>\r\n            <th class=\"hidden-xs\" translate>taskinstances.project</th>\r\n            <th class=\"hidden-xs\" translate can-do feature=\"projectType\">taskinstances.projecttype</th>\r\n            <th translate>taskinstances.taskstatus</th>\r\n            <th translate>taskinstances.action</th>\r\n            <th class=\"hidden-xs\" translate>taskinstances.date</th>\r\n          </tr>\r\n          </thead>\r\n          <tbody>\r\n          <tr ng-repeat=\"m in vm.pager.items | orderBy : \'-date\'\">\r\n            <td class=\"visible-xs\">{{m.name}} - {{m.projectTemplateName}}</td>\r\n            <td class=\"hidden-xs\">{{m.name}}</td>\r\n            <td class=\"hidden-xs\">{{m.concernCode}}</td>\r\n            <td class=\"hidden-xs\" can-do feature=\"projectGroup\">{{m.clientName}}</td>\r\n            <td class=\"hidden-xs\">{{m.concernName}}</td>\r\n            <td class=\"hidden-xs\">{{m.projectTemplateName}}</td>\r\n            <td class=\"hidden-xs\" can-do feature=\"projectType\">{{m.projectTypeName}}</td>\r\n            <td>{{\'enum.status.\' + m.state | translate}}</td>\r\n            <td>\r\n              <button class=\"btn btn-default btn-sm\" ng-click=\"vm.view(m)\" translate>taskinstances.view</button>\r\n            </td>\r\n            <td class=\"hidden-xs\">{{m.dueOn | dateTimeFromUtc}}</td>\r\n          </tr>\r\n          <tr ng-if=\"!vm.pager.busy && (vm.pager.items == null || vm.pager.items.length <=0)\">\r\n            <td colspan=\"8\">\r\n              <div class=\"text-center\" translate>common.norecords</div>\r\n            </td>\r\n          </tr>\r\n          </tbody>\r\n        </table>\r\n        <pager ng-model=\"vm.pager\"></pager>\r\n        \r\n        <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/taskinstance/inbox.searchbar.html","<div class=\"row border-bottom\">\r\n  <nav class=\"inbox__search navbar navbar-static-top white-bg\" role=\"navigation\">\r\n    <div class=\"navbar-header\">\r\n      <span minimaliza-sidebar></span>\r\n      <div class=\"form-group\">\r\n        <ui-select style=\"padding-top: 16px\" ng-disabled=\"!vm.searchLoaded\" translate-attr=\"{placeholder : \'inbox.search.placeholder\'}\" multiple=\"multiple\" ng-model=\"vm.searchData.smartSearchModel\" on-select=\"vm.smartSearch.onChange($item, $model)\" on-remove=\"vm.smartSearch.onChange($item, $model)\" uis-open-close=\"vm.smartSearch.onOpenClose(isOpen)\" translate-attr=\"{placeholder : \'inbox.search.placeholder\'}\">\r\n          <ui-select-match ng-click=\"vm.log()\" allow-clear=\"true\" placeholder=\"{{\'inbox.search.placeholder\'|translate}}\">\r\n            <span class=\"inbox__search__result\">\r\n            <i class=\"fa fa-code-fork\" ng-if=\"$item.type === \'projecttemplate\'\"></i>\r\n            <i class=\"fa fa-inbox\" ng-if=\"$item.type === \'taskname\'\"></i>\r\n            <i class=\"fa fa-users\" ng-if=\"$item.type === \'group\'\"></i>\r\n            <i class=\"fa fa-map-marker\" ng-if=\"$item.type === \'concern\'\"></i>\r\n\r\n            <span translate>{{$item.shortName}}</span>\r\n            </span>\r\n            \r\n          </ui-select-match>\r\n          <ui-select-choices position=\"down\" repeat=\"value in vm.searchData.smartSearchfilteredValues track by $index\" refresh=\"vm.smartSearch.refresh($select.search)\" refresh-delay=\"100\">\r\n            <div style=\"display: flex;\">\r\n              <div style=\"display: flex;align-items: center; font-size: x-large; margin-right: 15px; margin-left: -10px;\">\r\n                <i class=\"fa fa-code-fork\" ng-if=\"value.type === \'projecttemplate\'\"></i>\r\n                <i class=\"fa fa-inbox\" ng-if=\"value.type === \'taskname\'\"></i>\r\n                <i class=\"fa fa-users\" ng-if=\"value.type === \'group\'\"></i>\r\n                <i class=\"fa fa-map-marker\" ng-if=\"value.type === \'concern\'\"></i>\r\n              </div>\r\n              <div style=\"flex: 1; padding-top: 5px; margin-bottom: -5px;\">\r\n                <span><strong>{{value.searchName}}</strong></span>\r\n                <p ng-if=\"value.type === \'projecttemplate\'\" translate>search.itemtype.projecttemplate</p>\r\n                <p ng-if=\"value.type === \'taskname\'\" translate>search.itemtype.taskname</p>\r\n                <p ng-if=\"value.type === \'group\'\" translate>search.itemtype.group</p>\r\n                <p ng-if=\"value.type === \'concern\'\" translate>search.itemtype.concern</p>\r\n              </div>\r\n\r\n            </div>\r\n\r\n          </ui-select-choices>\r\n        </ui-select>\r\n      </div>\r\n      <i class=\"fa fa-refresh fa-2x m-r-sm\" ng-click=\"vm.pager.reset()\"></i>\r\n      <button class=\"btn btn-default\" ng-disabled=\"!vm.searchLoaded\" ng-click=\"vm.advancedSearch.isVisible = !vm.advancedSearch.isVisible\">\r\n        <!--<span class=\"inbox__search--advancedlabel\">Advanced Search Options</span>-->\r\n        <i class=\"fa fa-cog\"></i>\r\n      </button>\r\n      <button class=\"btn btn-default\" ng-click=\"vm.toggleViewMode()\">\r\n        <i class=\"fa\" ng-class=\"{\'fa-list\':!vm.isListMode, \'fa-id-card-o\':vm.isListMode}\"></i>\r\n      </button>\r\n    </div>\r\n  </nav>\r\n</div>\r\n\r\n<div class=\"inbox__search__advanced\" ng-class=\"{\'inbox__search__advanced--show\' : vm.advancedSearch.isVisible}\">\r\n  <div class=\"row form inbox__search__advanced__controlwrap\" role=\"form\">\r\n    <div class=\"form-group col-md-3\">\r\n      <label translate>inbox.search.duefrom</label>\r\n      <datepicker ng-model=\"vm.searchData.dueFrom\" datepicker-translate-placeholder=\"inbox.search.advanced.dueFrom.placeholder\" autocomplete=\"off\" ng-change=\"vm.advancedSearch.onDateChange\">\r\n      </datepicker>\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <label translate>inbox.search.dueto</label>\r\n      <datepicker ng-model=\"vm.searchData.dueTo\" datepicker-translate-placeholder=\"inbox.search.advanced.dueTo.placeholder\" autocomplete=\"off\" ng-change=\"vm.advancedSearch.onDateChange\">\r\n      </datepicker>\r\n    </div>\r\n\r\n    <div class=\"fieldDropdown form-group col-md-3\">\r\n      <label translate>inbox.search.claimstate</label>\r\n      <ui-select ng-model=\"vm.searchData.taskState\" on-select=\"vm.advancedSearch.taskState.onSelect($item, $model)\">\r\n        <ui-select-match><span translate>{{\'task.claim.state.\' + $select.selected}}</span></ui-select-match>\r\n        <ui-select-choices repeat=\"value in vm.advancedSearch.taskState.choices\">\r\n          <span translate>{{\'task.claim.state.\' + value}}</span>\r\n        </ui-select-choices>\r\n      </ui-select>\r\n    </div>\r\n\r\n    <div class=\"form-group col-md-2 inbox__search__advanced--nolabelcontrol\">\r\n      <button class=\"btn btn-default\" ng-click=\"vm.markAllTasksRead()\" translate>inbox.markalltasksread</button>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/taskinstance/inbox.tab.html","<div class=\"row\" ng-if=\"vm.pager.items != null || vm.pager.items.length >0\">\r\n  <div ng-repeat=\"task in vm.pager.items\">\r\n    <div ng-if=\"$even\" class=\"row\"><!-- Put a row in here to make tasks with mismatched heights align --></div>\r\n    <div ng-include=\"\'app/modules/siskin/taskinstance/inbox.tab.task.html\'\"></div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\" ng-if=\"!vm.pager.busy && (vm.pager.items == null || vm.pager.items.length <=0)\">\r\n  <h3 class=\"col-xs-12 inbox__task__norecord\">\r\n    <div translate>inbox.task.norecord</div>\r\n  </h3>\r\n</div>\r\n\r\n\r\n<pager ng-model=\"vm.pager\"></pager>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-xs-12\">\r\n    <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/taskinstance/inbox.tab.task.html","<div class=\"col-lg-6 inbox__task\" ng-class=\"{\'claimed\' : task.claimed, \'viewed\' : task.isViewed || task.claimed }\">\r\n  <div class=\"ibox float-e-margins\">\r\n    <!--<div class=\"inbox__task__status\">\r\n      <i class=\"fa fa-bookmark inbox__task__status--claimed\"></i>\r\n    </div>-->\r\n    <div class=\"ibox-title inbox__task__title\">\r\n      <!-- Header left -->\r\n      <div class=\"flex inbox__task__title__icon\">\r\n        <h3>\r\n          <i class=\"fa fa-map-marker\"></i>\r\n          &nbsp;\r\n        </h3>\r\n      </div>\r\n      <div class=\"inbox__task__title__name\">\r\n        <span>\r\n          <h4>{{task.concernCode}} - {{task.concernName}}</h4>\r\n          <a can-do=\"projectInstanceView\" ui-sref=\"siskin.projectinstancedetail({projectInstanceId:task.projectInstanceId})\">\r\n            {{task.projectInstanceName}}\r\n            <i class=\"fa fa-long-arrow-right m-l-sm\"></i>\r\n          </a>\r\n          <span can-do=\"projectInstanceView\" negate>{{task.projectInstanceName}}</span>\r\n        </span>\r\n      </div>\r\n      <!-- / Header left -->\r\n\r\n      <div class=\"flexeverything--spacer\"></div>\r\n\r\n      <!-- Header right -->\r\n      <div class=\"inbox__task__title__status\">\r\n        <p>\r\n          <label ng-if=\"!task.isViewed && !task.claimed\" class=\"label\" translate>task.claim.state.new</label>\r\n          <label ng-if=\"task.claimed\" class=\"label label-success\" translate>task.claim.state.claimed</label>\r\n        </p>\r\n        <p>\r\n          <label class=\"label inbox__task__label--state {{task.state}}\" title=\"{{task.dueOn | dateTimeFromUtc}}\">\r\n            <span class=\"visible-ms-up\">{{(\'enum.status.\' + task.state) | translate}}</span>\r\n            <span class=\"block\">{{task.dueOn | dateTimeFromUtc}}</span>\r\n          </label>\r\n        </p>\r\n\r\n      </div>\r\n      <!-- / Header right-->\r\n\r\n\r\n    </div>\r\n    <div class=\"ibox-content inbox__task__content\">\r\n      <div class=\"flexeverything\">\r\n        <h1 class=\"flex\">\r\n        <!-- Inner span here to prevent translate overlay being very wide -->\r\n        <span translate>{{task.name}}</span>\r\n        </h1>\r\n        <div>\r\n          <button class=\"btn btn-info\" ng-class=\"{\'active\': !task.isBusy}\" ng-disabled=\"task.isBusy\" ng-click=\"vm.openTask(task)\">\r\n            <sk-spinner-circle></sk-spinner-circle>{{\'task.btn.view\'|translate}}</button>\r\n          <button class=\"btn btn-primary\" ng-class=\"{\'active\': !task.isBusy}\" ng-disabled=\"task.isBusy\" ng-if=\"!task.claimed\" ng-click=\"vm.claimTask(task)\">\r\n            <sk-spinner-circle></sk-spinner-circle>{{\'task.btn.claim\'|translate}}\r\n          </button>\r\n          <button class=\"btn btn-primary\" ng-class=\"{\'active\': !task.isBusy}\" ng-disabled=\"task.isBusy\" ng-if=\"task.claimed\" ng-click=\"vm.unclaimTask(task)\">\r\n            <sk-spinner-circle></sk-spinner-circle>{{\'task.btn.unclaim\'|translate}}\r\n          </button>\r\n        </div>\r\n      </div>\r\n      <h4 class=\"pull-right inbox__task--bottomright\">\r\n        <i class=\"fa fa-code-fork\"></i> {{task.projectTemplateName}} <strong class=\"m-l-sm\">{{task.projectTemplateCode}}</strong>\r\n      </h4>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/taskinstance/info.directive.html","<div>\r\n    <sk-spinner ng-if=\"!vm.data\"></sk-spinner>\r\n    <span ng-if=\"vm.data.rolemappingGroups.length\">\r\n        <b translate>taskinstances.groups</b>\r\n        <ul><li ng-repeat=\"m in vm.data.rolemappingGroups\">{{m}}</li></ul>\r\n    </span>\r\n    <span ng-if=\"vm.data.rolemappingUsers.length\">\r\n        <b translate>taskinstances.users</b>\r\n        <ul><li ng-repeat=\"m in vm.data.rolemappingUsers track by $index\">{{m}}</li></ul>\r\n    </span>\r\n    <span ng-if=\"vm.data.assignedVersionedDataValues.length\">\r\n        <b translate>taskinstances.assignedgroups</b>\r\n        <ul><li ng-repeat=\"m in vm.data.assignedVersionedDataValues track by $index\">{{m}}</li></ul>\r\n    </span>\r\n    <b ng-if=\"vm.data.assignedVersionedDataValues.length == 0 && vm.data.rolemappingUsers.length == 0 && vm.data.rolemappingGroups.length == 0\" translate>taskinstances.noassignments</b>\r\n</div>");
$templateCache.put("app/modules/siskin/taskinstance/list.html","<div class=\"taskinstancelist\" ng-controller=\"TaskInstanceListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title taskinstancelist__title breadcrumb\">\r\n            <span can-do=\"dashboardView\"><a ui-sref=\"siskin.dashboard\" translate>nav.clientdashboard</a> / </span><span translate>nav.taskinstances</span>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div ng-if=\"vm.filters\">\r\n              <div class=\"taskinstancelist__filter\">\r\n                <div class=\"row filter-panel-xs\">\r\n                  <dropdown class=\"col-sm-2\" ng-model=\"vm.search.storeGroup\" ng-values=\"vm.filters.storeGroups\" placeholder=\"{{\'taskinstances.storegroupfilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\">\r\n                  </dropdown>\r\n                  <span class=\"col-sm-2\">\r\n                    <input class=\"form-control\" ng-model=\"vm.search.projectInstanceName\" placeholder=\"{{\'taskinstances.projectinstancenamefilterplaceholder\'|translate}}\" ng-change=\"vm.reset()\" ng-model-options=\"{updateOn: \'default blur\', debounce : { \'default\': 500, \'blur\': 0 }}\">\r\n                  </span>\r\n\r\n                  <dropdown-multiple class=\"col-sm-2\" ng-model=\"vm.search.taskNames\" ng-values=\"vm.filters.tasks\" placeholder=\"{{\'taskinstances.tasksfilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\">\r\n                  </dropdown-multiple>\r\n\r\n                  <dropdown class=\"col-sm-2\" pager=\"vm.userPager\" ng-model=\"vm.search.userId\" prop=\"id\" placeholder=\"{{\'taskinstances.usersfilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\">\r\n                  </dropdown>\r\n\r\n                  <dropdown class=\"col-sm-2\" ng-model=\"vm.search.country\" ng-values=\"vm.filters.countries\" placeholder=\"{{\'taskinstances.countryfilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\">\r\n                  </dropdown>\r\n\r\n                  <dropdown class=\"col-sm-2\" ng-model=\"vm.search.region\" ng-values=\"vm.filters.regions\" placeholder=\"{{\'taskinstances.regionfilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\">\r\n                  </dropdown>\r\n                </div>\r\n\r\n                <div class=\"row m-t-sm filter-panel-xs\">\r\n                  <dropdown class=\"col-sm-2\" ng-model=\"vm.search.client\" ng-values=\"vm.filters.clients\" placeholder=\"{{\'taskinstances.clientfilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\" ng-if=\"vm.features.projectGroup\"></dropdown>\r\n                  <dropdown class=\"col-sm-2\" ng-model=\"vm.search.store\" ng-values=\"vm.filters.stores\" placeholder=\"{{\'taskinstances.storefilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\">\r\n                  </dropdown>\r\n                  <dropdown class=\"col-sm-2\" ng-model=\"vm.search.template\" ng-values=\"vm.filters.projectTemplates\" placeholder=\"{{\'taskinstances.projectfilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\">\r\n                  </dropdown>\r\n                  <dropdown class=\"col-sm-2\" ng-model=\"vm.search.status\" ng-values=\"vm.statusValues\" placeholder=\"{{\'taskinstances.statusfilterplaceholder\'| translate}}\" ng-change=\"vm.reset()\">\r\n                  </dropdown>\r\n                </div>\r\n\r\n\r\n\r\n                <div class=\"row m-t-sm m-b-sm\">\r\n                  <div class=\"col-sm-4 col-md-3 m-b-sm\">\r\n                    <span class=\"input-header\" translate>taskinstances.duedate</span>\r\n                    <datepicker-range ng-model=\"vm.search.dueDate\" ng-change=\"vm.reset()\" ng-clear=\"vm.resetDateRangeFilter(\'due\')\" placeholder=\"taskinstances.duedate\" show-future-ranges=\"true\">\r\n                  </datepicker-range></div>\r\n                  <div class=\"col-sm-4 col-md-3 m-b-sm\">\r\n                    <span class=\"input-header\" translate>taskinstances.completedon</span>\r\n                    <datepicker-range ng-model=\"vm.search.completedDate\" ng-change=\"vm.reset()\" ng-clear=\"vm.resetDateRangeFilter(\'completed\')\" placeholder=\"taskinstances.completedon\" show-past-ranges=\"true\">\r\n                  </datepicker-range></div>\r\n                  <div class=\"col-sm-4 col-md-6\">\r\n                    <span class=\"pull-right\">\r\n                      <span class=\"input-header\" translate>common.sortby</span>\r\n                      <dropdown ng-model=\"vm.search.orderBy\" ng-values=\"vm.orderByValues\" ng-change=\"vm.reset()\" allow-clear=\"false\"></dropdown>\r\n                    </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n\r\n            <table class=\"table\">\r\n              <thead>\r\n                <tr>\r\n                  <th translate>taskinstances.name</th>\r\n                  <th class=\"hidden-xs\" translate>taskinstances.code</th>\r\n                  <th class=\"hidden-xs\" translate>taskinstances.storename</th>\r\n                  <th translate>taskinstances.project</th>\r\n                  <th translate>taskinstances.taskstatus</th>\r\n                  <th class=\"hidden-xs hidden-sm\" translate>taskinstances.duedate</th>\r\n                  <th class=\"hidden-xs hidden-sm\" translate>taskinstances.completedon</th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-repeat=\"m in vm.pager.items | orderBy : \'-date\'\">\r\n                  <td>{{m.name}}</td>\r\n                  <td class=\"hidden-xs\">{{m.storeCode}}</td>\r\n                  <td class=\"hidden-xs\">\r\n                    <a ui-sref=\"siskin.store({storeId:m.storeId})\">{{m.storeName}}</a></td>\r\n                  <td>{{m.projectTemplateName}}</td>\r\n                  <td><label class=\"label label-status-{{m.status}}\">{{\'enum.status.\' + m.status | translate}}</label>\r\n                  </td>\r\n                  <td class=\"hidden-xs hidden-sm\">{{m.dueDate | dateTimeFromUtc}}</td>\r\n                  <td class=\"hidden-xs hidden-sm\">{{m.completedOn | dateTimeFromUtc}}</td>\r\n                  <td>\r\n                    <button class=\"btn btn-default btn-sm\" ui-sref=\"siskin.taskinstance({taskInstanceId: m.id})\">\r\n                      <i class=\"fa fa-arrow-right visible-xs\"></i> <span class=\"hidden-xs\" translate>common.view</span>\r\n                    </button>\r\n                  </td>\r\n                </tr>\r\n                <tr ng-if=\"!vm.pager.busy && (vm.pager.items == null || vm.pager.items.length <=0)\">\r\n                  <td colspan=\"8\">\r\n                    <div class=\"text-center\" translate>common.norecords</div>\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n            <pager ng-model=\"vm.pager\"></pager>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/taskinstance/listattributes.html","<div class=\"taskinstanceattributeslist\" ng-controller=\"TaskInstanceAttributesListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title taskinstanceattributeslist__title breadcrumb\">\r\n            <a ui-sref=\"siskin.inbox({\'query\': vm.query})\" translate>nav.inbox</a> / <span translate>nav.attributes</span>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"table\">\r\n              <h3 class=\"m-b-md\">\r\n                <span ng-repeat=\"a in vm.header\">{{a}} {{$last ? \'\' : \'/ \'}}</span>\r\n              </h3>\r\n              <div ng-repeat=\"task in vm.pager.items | orderBy : \'-date\' | filter : vm.search.query\" ng-if=\"task.dataValues.length\">\r\n                <h4>\r\n                  <span ng-if=\"!vm.search.projectTemplateId\">{{task.projectTemplateName}} /</span>\r\n                  <span ng-if=\"!vm.search.clientId\">{{task.clientName}} /</span>\r\n                  <span ng-if=\"!vm.search.storeId\">{{task.storeName}} /</span>\r\n                  <a ui-sref=\"siskin.taskinstance({taskInstanceId: task.id})\">{{task.name}}</a>\r\n                  <label class=\"label label-info m-l-sm\">{{\'enum.status.\' + task.status | translate}}</label>\r\n                </h4>\r\n\r\n                <div ng-repeat=\"field in task.dataValues\" ng-switch=\"field.type\">\r\n                  <field-files field=\"field\" ng-switch-when=\"files\" context=\"tasksattributes\" context-entity=\"task\" ng-if=\"field.content.length\"></field-files>\r\n                  <field-boolean field=\"field\" ng-switch-when=\"boolean\" context=\"tasksattributes\" context-entity=\"task\"></field-boolean>\r\n                  <field-confirmation field=\"field\" ng-switch-when=\"confirmation\" context=\"tasksattributes\" context-entity=\"task\"></field-confirmation>\r\n                  <field-date field=\"field\" ng-switch-when=\"date\" context=\"tasksattributes\" context-entity=\"task\"></field-date>\r\n                  <field-datetime field=\"field\" ng-switch-when=\"datetime\" context=\"tasksattributes\" context-entity=\"task\"></field-datetime>\r\n                  <field-double field=\"field\" ng-switch-when=\"double\" context=\"tasksattributes\" context-entity=\"task\"></field-double>\r\n                  <field-dropdown field=\"field\" ng-switch-when=\"dropdown\" context=\"tasksattributes\" context-entity=\"task\"></field-dropdown>\r\n                  <field-integer field=\"field\" ng-switch-when=\"integer\" context=\"tasksattributes\" context-entity=\"task\"></field-integer>\r\n                  <field-string field=\"field\" ng-switch-when=\"string\" context=\"tasksattributes\" context-entity=\"task\"></field-string>\r\n                  <field-user field=\"field\" ng-switch-when=\"user\" context=\"tasksattributes\" context-entity=\"task\"></field-user>\r\n                </div>\r\n                <div class=\"text-center\" ng-if=\"!vm.pager.busy && (vm.pager.items == null || vm.pager.items.length <=0)\" translate>common.norecords\r\n                </div>\r\n              </div>\r\n              <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n              <pager ng-model=\"vm.pager\"></pager>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>");
$templateCache.put("app/modules/siskin/user/list.html","<div class=\"clientslist\" ng-controller=\"UserListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    In progress\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/workflow/create.question.modal.html","<div class=\"workflowsetdetail__attribute\">\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"m.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\">\r\n      {{(m.updateMode ? \'workflow.edit\' : \'workflow.add\') | translate }} {{(m.entity.subtype === \'category\' ? \'workflow.category\' : \'workflow.attribute\') | translate }}\r\n    </h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <form class=\"form-horizontal\">\r\n      <div class=\"form-group\" ng-if=\"m.entity.subtype !== \'category\' && m.categories.length\" ng-class=\"{\'has-error\': m.entity.validation.hasError(\'category\')}\">\r\n        <label class=\"col-lg-4 control-label\" translate>workflowset.create.categoryname</label>\r\n        <div class=\"col-lg-8\">\r\n          <dropdown allow-clear=\"false\" ng-values=\"m.categories\" ng-model=\"m.entity.extendedData.category\" prop=\"name\"></dropdown>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" ng-class=\"{\'has-error\': m.entity.validation.hasError(\'name\')}\">\r\n        <label class=\"col-lg-4 control-label\" translate>workflowset.create.name</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"m.entity.name\">\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"m.entity.subtype !== \'category\' && !m.updateMode\" ng-class=\"{\'has-error\': m.entity.validation.hasError(\'subtype\')}\">\r\n        <label class=\"col-lg-4 control-label\" translate>workflowset.create.attributetype</label>\r\n        <div class=\"col-lg-8\">\r\n          <dropdown ng-values=\"m.attributeTypes\" ng-model=\"m.entity.subtype\" ng-change=\"m.initialize()\" placeholder=\"workflowset.create.attributetype\"></dropdown>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" ng-if=\"m.entity.subtype !== \'category\'\" can-do=\"workflowSuperAdminEdit\">\r\n        <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.ishidden</label>\r\n        <div class=\"col-lg-8\">\r\n          <input icheck type=\"checkbox\" ng-model=\"m.entity.extendedData.isHidden\">\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\" can-do=\"workflowSuperAdminEdit\">\r\n        <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.visibleforgroups</label>\r\n        <div class=\"col-lg-8\">\r\n          <input type=\"text\" class=\"form-control\" ng-model=\"m.entity.extendedData.visibleForGroups\">\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!------------------------------------>\r\n      <div ng-switch=\"m.entity.subtype\">\r\n        <div ng-if=\"m.entity.subtype===\'string\'\">\r\n          <div class=\"form-group\">\r\n            <label class=\"col-lg-4 control-label\" translate=\"\">workflow.dmentity.ismultiline</label>\r\n            <div class=\"col-lg-8\">\r\n              <input icheck type=\"checkbox\" ng-model=\"m.entity.extendedData.isMultiLine\" ng-disabled=\"m.readonly\">\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <!--category-->\r\n        <div ng-switch-when=\"category\" can-do=\"WorkflowSuperAdminEdit\">\r\n          <div class=\"form-group\">\r\n            <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.categorytype</label>\r\n            <div class=\"col-lg-8\">\r\n              <dropdown ng-values=\"m.categoryTypes\" ng-model=\"m.entity.extendedData.categoryType\"></dropdown>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <!--date and datetime-->\r\n        <div ng-if=\"m.entity.subtype===\'date\' || m.entity.subtype=== \'dateTime\'\" can-do=\"WorkflowSuperAdminEdit\">\r\n          <div class=\"form-group\">\r\n            <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.isanchordate</label>\r\n            <div class=\"col-lg-8\">\r\n              <input icheck type=\"checkbox\" ng-model=\"m.entity.extendedData.isAnchorDate\" ng-disabled=\"m.readonly\" ng-change=\"m.initializeAnchorDate()\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-if=\"!m.entity.extendedData.isAnchorDate\">\r\n            <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.linkeddate</label>\r\n            <div class=\"col-lg-8\">\r\n              <p class=\"form-control\" ng-if=\"m.readonly\">{{m.entity.extendedData.linkedAttribute}}</p>\r\n              <dropdown ng-values=\"m.anchorDates\" prop=\"name\" ng-model=\"m.entity.extendedData.linkedAttribute\" ng-if=\"!m.readonly\"></dropdown>\r\n            </div>\r\n          </div>\r\n\r\n          <div ng-repeat=\"timeSpan in m.entity.children\" ng-if=\"!m.entity.extendedData.isAnchorDate\">\r\n            <div class=\"form-group\" ng-if=\"m.entity.extendedData.linkedAttribute\">\r\n              <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.days</label>\r\n              <div class=\"col-lg-8\">\r\n                <p class=\"form-control\" ng-if=\"m.readonly\">{{timeSpan.extendedData.days}}</p>\r\n                <div class=\"input-group\" ng-if=\"!m.readonly\">\r\n                  <div class=\"input-group-prepend\">\r\n                    <span class=\"btn btn-default\" ng-click=\"m.addValue(\'days\',-1)\">-</span>\r\n                  </div>\r\n                  <input type=\"text\" ng-pattern=\"/^\\d+$/\" class=\"form-control\" ng-model=\"m.entity.extendedData.days\" ng-model-options=\"{updateOn:\'blur\'}\">\r\n                  <div class=\"input-group-append\">\r\n                    <span class=\"btn btn-default\" ng-click=\"m.addValue(\'days\',1)\">+</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\" ng-if=\"m.entity.extendedData.linkedAttribute\">\r\n              <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.hours</label>\r\n              <div class=\"col-lg-8\">\r\n                <p class=\"form-control\" ng-if=\"m.readonly\">{{timeSpan.extendedData.hours}}</p>\r\n                <div class=\"input-group\" ng-if=\"!m.readonly\">\r\n                  <div class=\"input-group-prepend\">\r\n                    <span class=\"btn btn-default\" ng-click=\"m.addValue(\'hours\',-1)\">-</span>\r\n                  </div>\r\n                  <input type=\"text\" ng-pattern=\"/^\\d+$/\" class=\"form-control\" ng-model=\"m.entity.extendedData.hours\" ng-model-options=\"{updateOn:\'blur\'}\">\r\n                  <div class=\"input-group-append\">\r\n                    <span class=\"btn btn-default\" ng-click=\"m.addValue(\'hours\',1)\">+</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\" ng-if=\"m.entity.extendedData.linkedAttribute\">\r\n              <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.minutes</label>\r\n              <div class=\"col-lg-8\">\r\n                <p class=\"form-control\" ng-if=\"m.readonly\">{{timeSpan.extendedData.minutes}}</p>\r\n                <div class=\"input-group\" ng-if=\"!m.readonly\">\r\n                  <div class=\"input-group-prepend\">\r\n                    <span class=\"btn btn-default\" ng-click=\"m.addValue(\'minutes\',-1)\">-</span>\r\n                  </div>\r\n                  <input type=\"text\" ng-pattern=\"/^\\d+$/\" class=\"form-control\" ng-model=\"m.entity.extendedData.minutes\" ng-model-options=\"{updateOn:\'blur\'}\">\r\n                  <div class=\"input-group-append\">\r\n                    <span class=\"btn btn-default\" ng-click=\"m.addValue(\'minutes\',1)\">+</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!--multiple file-->\r\n        <div ng-switch-when=\"multipleFile\">\r\n          <div class=\"form-group\">\r\n            <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.maxfiles</label>\r\n            <div class=\"col-lg-8\">\r\n              <p class=\"form-control\" ng-if=\"m.readonly\">{{m.entity.extendedData.maxFiles}}</p>\r\n              <div class=\"input-group input-number m-b\">\r\n                <div class=\"input-group-prepend\">\r\n                  <span class=\"btn btn-default\" ng-click=\"m.addValue(\'maxFiles\',-1)\">-</span>\r\n                </div>\r\n                <input type=\"number\" class=\"form-control\" autocomplete=\"off\" translate-attr=\"{placeholder:\'workflow.dmentity.maxfilesunlimited\'}\" ng-model=\"m.entity.extendedData.maxFiles\" ng-model-options=\"{updateOn:\'blur\'}\" ng-if=\"!m.readonly\">\r\n                <div class=\"input-group-append\">\r\n                  <span class=\"btn btn-default\" ng-click=\"m.addValue(\'maxFiles\',1)\">+</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!--user-->\r\n        <div ng-switch-when=\"user\">\r\n          <div class=\"form-group\">\r\n            <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.linkedrole</label>\r\n            <div class=\"col-lg-8\">\r\n              <p class=\"form-control\" ng-if=\"m.readonly\">{{m.entity.extendedData.linkedAttribute}}</p>\r\n              <dropdown ng-values=\"m.domainModel.children\" filter=\"{subtype:\'role\'}\" prop=\"name\" ng-model=\"m.entity.extendedData.linkedAttribute\" ng-if=\"!m.readonly\"></dropdown>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!--dropdown-->\r\n        <div ng-switch-when=\"dropdown\">\r\n          <div class=\"form-group\">\r\n            <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.dropdownmultiple</label>\r\n            <div class=\"col-lg-8\">\r\n              <input icheck type=\"checkbox\" ng-model=\"m.entity.extendedData.isMultiple\" ng-disabled=\"m.readonly\">\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" ng-class=\"{\'has-error\': m.entity.children[0].validation.hasError(\'children\')}\">\r\n            <label class=\"col-lg-4 control-label\" translate>workflow.dmentity.values</label>\r\n            <div class=\"col-lg-8\">\r\n              <i class=\"fa fa-plus-circle fa-2x m-b-sm\" ng-click=\"m.addChild(\'dropdownItem\')\"></i>\r\n              <div class=\"dropdown__options flexeverything m-b-sm\" ng-repeat=\"value in m.entity.children[0].children | filter:{isDeleted:\'!true\'}\">\r\n                {{value.isDeleted}}\r\n                <input type=\"text\" class=\"form-control\" ng-model=\"value.extendedData.value\" placeholder=\"{{\'workflow.dmentity.dropdownchoice\' | translate}}\">\r\n                <i class=\"fa fa-times-circle fa-2x m-l-sm\" ng-click=\"m.removeChild(value)\"></i>\r\n                </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"alert alert-danger workflowsetdetail__domainmodel__errors row\" ng-if=\"m.entity.validation.hasError()\">\r\n        <ul>\r\n        <li ng-repeat=\"e in m.entity.validation.errors\" translate>{{e.message}}</li>\r\n      </ul>\r\n      </div>\r\n    </form>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"m.save()\" ng-class=\"{\'has-error\': m.error}\" ng-disabled=\"!m.entity.subtype\" translate>\r\n      {{m.updateMode ? \'common.save\' : \'workflow.add\' }}\r\n    </button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"m.close()\" ng-class=\"{\'has-error\': m.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/workflow/deactivate.workflow.modal.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>workflow.deactivateworkflow</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\" translate>\r\n    workflow.deactivate.message\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vmModal.delete()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>generic.action.deactivate</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/workflow/delete.workflow.modal.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>workflow.deleteworkflow</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\" translate>\r\n    workflow.disable.message\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vmModal.delete()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>generic.action.delete</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/workflow/detail.domainmodel.html","<div class=\"workflowsetdetail__domainmodel\">\r\n  <div class=\"panel panel-default\">\r\n    <div class=\"panel-body\" ng-if=\"vm.data\">\r\n      <div class=\"m-b-md\">\r\n        <span class=\"pull-right\" ng-if=\"!vm.readonly\">\r\n          <button class=\"btn-primary btn btn-outline\" ng-click=\"vm.addOrEdit(\'attribute\')\">\r\n            <i class=\"fa fa-plus m-r-sm\"></i><span translate>workflowset.addattribute</span>\r\n          </button>\r\n          <!--<button class=\"btn-primary btn btn-outline\" ng-click=\"vm.addOrEdit(\'category\')\">-->\r\n            <!--<i class=\"fa fa-plus m-r-sm\"></i><span translate>workflowset.addcategory</span>-->\r\n          <!--</button>-->\r\n        </span>\r\n        <h2 class=\"workflowsetdetail__heading\"><b translate>workflowset.attributes</b></h2>\r\n      </div>\r\n\r\n      <div class=\"agile-list\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.data.domainModel.categories\">\r\n        <li ng-repeat=\"m in vm.data.domainModel.categories\" ng-show=\"m.attributes.length || m.id\" ng-class=\"{\'unsortable\': !m.resource, \'has-error\': m.hasError()}\">\r\n          <div class=\"flexeverything\">\r\n            <h3 class=\"flex m-r-sm\">\r\n              <i class=\"fa m-r-sm datavalue-icon datavalue-icon-{{m.subtype}}\"></i>{{m.name}}\r\n            </h3>\r\n            <span ng-if=\"!vm.readonly && m.resource\">\r\n              <button confirmation-modal btn-style=\"btn-danger\" class=\"btn btn-outline btn-danger\" text=\"workflow.delete.description\" title=\"workflow.delete.title\" ng-click=\"vm.remove(m, [vm.data.domainModel.categories])\" ng-if=\"m.attributes.length\">\r\n                <i class=\"fa fa-times\"></i>\r\n              </button>\r\n              <button class=\"btn btn-outline btn-danger\" ng-if=\"!m.attributes.length\" ng-click=\"vm.remove(m, [vm.data.domainModel.categories])\"><i class=\"fa fa-times\"></i></button>\r\n              <button class=\"btn btn-outline btn-primary\" ng-click=\"vm.addOrEdit(m)\"><i class=\"fa fa-pencil\"></i></button>\r\n            </span>\r\n            <button class=\"btn btn-outline btn-default btn-collapse\" ng-click=\"m.collapsed = !m.collapsed\"><i class=\"fa {{!m.collapsed?\'fa-chevron-up\':\'fa-chevron-down\'}}\"></i></button>\r\n          </div>\r\n\r\n          <ul class=\"agile-list\" ui-sortable=\"vm.sortableOptions\" ng-model=\"m.attributes\" ng-show=\"!m.collapsed\">\r\n            <li ng-repeat=\"a in m.attributes\" class=\"flexeverything\" ng-class=\"{\'has-error\': a.validation.hasError()}\">\r\n              <span class=\"flex m-r-sm\"><i class=\"fa m-r-sm datavalue-icon datavalue-icon-{{a.subtype}}\"></i>{{a.name}}</span>\r\n              <span class=\"alert alert-danger workflowsetdetail__domainmodel__errors\" ng-if=\"a.validation.hasError()\">\r\n                <strong ng-repeat=\"e in a.validation.errors\" translate>{{e.message}}</strong>\r\n              </span>\r\n              <span class=\"m-l-xs\" ng-if=\"!vm.readonly\">\r\n                <button class=\"btn btn-outline btn-danger\" ng-click=\"vm.remove(a, [m.attributes, vm.data.domainModel.children])\"><i class=\"fa fa-times\"></i></button>\r\n                <button class=\"btn btn-outline btn-primary m-r-xs\" ng-click=\"vm.addOrEdit(a)\"><i class=\"fa fa-pencil\"></i></button>\r\n              </span>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/workflow/detail.html","<div class=\"workflowsetdetail\" ng-controller=\"WorkflowDetailController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <sk-spinner ng-if=\"!vm.data\"></sk-spinner>\r\n  <div class=\"wrapper wrapper-content\" ng-if=\"vm.data\">\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title workflowsetdetail__heading\">\r\n            <a ui-sref=\"siskin.workflows\" translate>nav.workflows</a> /\r\n            <span ng-if=\"vm.data.workflows[0].readonly\">{{vm.data.workflows[0].name}}</span>\r\n            <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.workflows[0].name\" ng-change=\"vm.update(vm.data.workflows[0],true)\" ng-if=\"!vm.data.workflows[0].readonly\" ng-model-options=\"{debounce : 500}\">\r\n            <label class=\"label label-info\">v{{vm.data.workflows[0].version}}</label>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"flexeverything\">\r\n              <span class=\"flexeverything--spacer\"></span>\r\n              <button confirmation-modal class=\"btn btn-primary btn-lg m-r-xs\" ng-if=\"!vm.readonly\" text=\"workflowset.applychanges.description\" ng-click=\"vm.publish()\" error-message=\"workflow.publish.error\">\r\n                <i class=\"fa fa-cloud-upload\"></i>\r\n                <b translate>workflowset.publish</b>\r\n              </button>\r\n            </div>\r\n            <div ng-include=\"\'app/modules/siskin/workflow/detail.domainmodel.html\'\" class=\"m-b-lg\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/workflow/detail.workflows.html","<div class=\"workflowsetdetail__workflows\">\r\n  <div class=\"workflowsetdetail__domainmodel\">\r\n    <div class=\"flexeverything\">\r\n      <h4 class=\"m-b-md\" translate>workflowset.workflows</h4>\r\n      <div class=\"flexeverything--spacer\"></div>\r\n      <!--<button class=\"btn btn-default\" ng-click=\"vm.edit(vm.selectedworkflow,\'workflows\')\" ng-if=\"vm.selectedworkflow.readonly\" translate>-->\r\n        <!--workflowset.edit-->\r\n      <!--</button>-->\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <uib-tabset class=\"tabs-container\" ng-class=\"{\'col-lg-7\':vm.wfselected.length}\">\r\n        <uib-tab ng-repeat=\"wf in vm.data.workflows\" ng-click=\"vm.selectWorkflow(wf)\">\r\n          <uib-tab-heading>\r\n            <span ng-if=\"!wf.editing\">{{wf.name}}</span>\r\n            <input class=\"form-control\" ng-model=\"wf.name\" ng-show=\"wf.editing\" ng-blur=\"wf.editing = false\" ng-change=\"vm.update(wf)\" ng-model-options=\"{updateOn: \'blur\'}\">\r\n            <i class=\"fa fa-pencil-square-o\" ng-if=\"!wf.readonly && !wf.editing\" ng-click=\"wf.editing = true\"></i>\r\n\r\n          </uib-tab-heading>\r\n          <div class=\"panel-body\">\r\n            <ul class=\"agile-list\">\r\n              <li ng-repeat=\"m in wf.children | filter:{\'entityType\':\'task\'}\" ng-class=\"{\'success-element\': m.selected}\" ng-click=\"vm.select(m)\">\r\n                {{m.name}}\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </uib-tab>\r\n      </uib-tabset>\r\n\r\n      <uib-tabset class=\"tabs-container col-lg-5\" ng-if=\"vm.wfselected.length\" active=\"vm.wfactivetab\">\r\n        <uib-tab index=\"$index+1\" ng-repeat=\"m in vm.wfselected\">\r\n          <uib-tab-heading>\r\n            {{m.name}}\r\n            <a class=\"fa fa-times m-l-sm\" ng-click=\"vm.deselect(m)\" stop-event=\"click\"></a>\r\n          </uib-tab-heading>\r\n          <div class=\"panel-body\">\r\n            <form class=\"form-horizontal\" ng-switch=\"m.entityType\">\r\n              <div class=\"form-group\">\r\n                <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.name</label>\r\n                <div class=\"col-lg-8\">\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"m.name\" disabled=\"disabled\">\r\n                </div>\r\n              </div>\r\n\r\n              <!--task activity-->\r\n              <div ng-switch-when=\"task\">\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.roles</label>\r\n                  <div class=\"col-lg-8\">\r\n                    <div class=\"form-control\">\r\n                      <p ng-repeat=\"r in m.roles.children\" ng-if=\"m.readonly\" class=\"workflowentity__link\">{{r.name}}</p>\r\n                      <div ng-if=\"!m.readonly\">\r\n                        <dropdown ng-values=\"vm.data.domainModel.children\" filter=\"{subtype:\'role\'}\" ng-model=\"vm.selectedEntity\" ng-change=\"vm.createChildLink(m.roles, vm.selectedEntity)\" clear-on-select=\"true\"></dropdown>\r\n\r\n                        <div ng-repeat=\"r in m.roles.children\" class=\"workflowentity__link\">\r\n                          {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                          <i class=\"fa fa-times\" ng-click=\"vm.remove(m.roles, r)\"></i>\r\n                        </div>\r\n                      </div>\r\n\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.user</label>\r\n                  <div class=\"col-lg-8\">\r\n                    <div class=\"form-control\">\r\n                      <p ng-repeat=\"r in m.user.children\" ng-if=\"m.readonly\" class=\"workflowentity__link\">{{r.name}}</p>\r\n                      <div ng-if=\"!m.readonly\">\r\n                        <dropdown ng-values=\"vm.data.domainModel.children\" filter=\"{subtype:\'user\'}\" ng-model=\"vm.selectedEntity\" ng-change=\"vm.createChildLink(m.user, vm.selectedEntity)\" clear-on-select=\"true\" ng-if=\"!m.user.children.length\"></dropdown>\r\n\r\n                        <div ng-repeat=\"r in m.user.children\" class=\"workflowentity__link\">\r\n                          {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                          <i class=\"fa fa-times\" ng-click=\"vm.remove(m.user, r)\"></i>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.escalatedroles</label>\r\n                  <div class=\"col-lg-8\">\r\n                    <div class=\"form-control\">\r\n                      <p ng-repeat=\"r in m.escalatedRoles.children\" ng-if=\"m.readonly\" class=\"workflowentity__link\">\r\n                        {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                      </p>\r\n                      <div ng-if=\"!m.readonly\">\r\n                        <dropdown ng-values=\"vm.data.domainModel.children\" filter=\"{subtype:\'role\'}\" ng-model=\"vm.selectedEntity\" ng-change=\"vm.createChildLink(m.escalatedRoles, vm.selectedEntity)\" clear-on-select=\"true\"></dropdown>\r\n\r\n                        <div ng-repeat=\"r in m.escalatedRoles.children\" class=\"workflowentity__link\">\r\n                          {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                          <i class=\"fa fa-times\" ng-click=\"vm.remove(m.escalatedRoles, r)\"></i>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.attributes</label>\r\n                  <div class=\"col-lg-8\">\r\n                    <div class=\"form-control\">\r\n                      <p ng-repeat=\"r in m.taskAttributes.children\" ng-if=\"m.readonly\" class=\"workflowentity__link\">\r\n                        {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                      </p>\r\n\r\n                      <div ng-if=\"m.taskAttributes.selected\">\r\n                        <i class=\"fa fa-chevron-circle-left\" ng-click=\"m.taskAttributes.selected = null\"></i>\r\n                        <span class=\"pull-right\">{{m.taskAttributes.selected | wfEntityLink:vm.data.domainModel.children:\'name\'}}</span>\r\n                        <div>\r\n                          <span translate>workflow.wfentity.action.displayorder</span>\r\n                          <input type=\"number\" class=\"form-control\" ng-model=\"m.taskAttributes.selected.extendedData.displayOrder\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m.taskAttributes.selected)\">\r\n                        </div>\r\n                        <div class=\"m-t-sm\">\r\n                          <span translate>workflow.wfentity.attribute.readonly</span>\r\n                          <input icheck type=\"checkbox\" ng-model=\"m.taskAttributes.selected.extendedData.readOnly\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m.taskAttributes.selected)\">\r\n                        </div>\r\n                      </div>\r\n\r\n                      <div ng-if=\"!m.readonly && !m.taskAttributes.selected\">\r\n                        <dropdown ng-values=\"vm.data.domainModel.children\" filter=\"\'attribute\'\" ng-model=\"vm.selectedEntity\" ng-change=\"vm.createChildLink(m.taskAttributes, vm.selectedEntity)\" clear-on-select=\"true\"></dropdown>\r\n\r\n                        <div ng-repeat=\"r in m.taskAttributes.children | orderBy:\'extendedData.displayOrder\'\" class=\"workflowentity__link\">\r\n                          <i class=\"fa fa-bars m-r-sm\" ng-click=\"m.taskAttributes.selected = r\"></i>\r\n                          {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                          <i class=\"fa fa-times\" ng-click=\"vm.remove(m.taskAttributes, r)\"></i>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.actions</label>\r\n                  <div class=\"col-lg-8\">\r\n                    <div class=\"form-control\">\r\n                      <p ng-repeat=\"r in m.actions.children\" ng-if=\"m.readonly\" class=\"workflowentity__link\">\r\n                        {{r.name}}\r\n                      </p>\r\n                      <div ng-if=\"m.actions.selected\">\r\n                        <i class=\"fa fa-chevron-circle-left\" ng-click=\"m.actions.selected = null\"></i>\r\n                        <span class=\"pull-right\">{{m.actions.selected.name}}</span>\r\n                        <div>\r\n                          <span translate>workflow.wfentity.action.requirevalues</span>\r\n                          <dropdown ng-values=\"vm.data.domainModel.children\" filter=\"\'attribute\'\" ng-model=\"vm.selectedEntity\" ng-change=\"vm.addId(m.actions.selected,\'attributes\',\'requireValues\',vm.selectedEntity)\" clear-on-select=\"true\"></dropdown>\r\n                          <div ng-repeat=\"r in m.actions.selected.attributes\" class=\"workflowentity__link\">\r\n                            {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                            <i class=\"fa fa-times\" ng-click=\"vm.removeId(m.actions.selected,\'attributes\',\'requireValues\',r)\"></i>\r\n                          </div>\r\n                        </div>\r\n                        <div>\r\n                          <span translate>workflow.wfentity.action.displayorder</span>\r\n                          <input type=\"number\" class=\"form-control\" ng-model=\"m.actions.selected.extendedData.displayOrder\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m.actions.selected)\">\r\n                        </div>\r\n                        <div>\r\n                          <span translate>workflow.wfentity.action.noterequired</span>\r\n                          <input icheck type=\"checkbox\" ng-model=\"m.actions.selected.extendedData.noteRequired\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m.actions.selected)\">\r\n                        </div>\r\n                      </div>\r\n                      <div ng-if=\"!m.readonly && !m.actions.selected\">\r\n                        <!--<div class=\"add-panel m-b-sm\" ng-click=\"vm.addChild(m.actions,\'action\')\">-->\r\n                        <!--<div class=\"add-panel m-b-sm\">-->\r\n                          <!--<span translate>workflow.wfentity.addaction</span>-->\r\n                          <!--<i class=\"fa fa-plus m-l-md\"></i>-->\r\n                        <!--</div>-->\r\n\r\n                        <div ng-repeat=\"r in m.actions.children\" class=\"flexeverything\">\r\n                          <i class=\"fa fa-bars m-r-sm\" ng-click=\"m.actions.selected = r\"></i>\r\n                          <input class=\"form-control\" type=\"text\" ng-model=\"r.name\" ng-change=\"vm.update(r)\" ng-model-options=\"{updateOn: \'blur\'}\">\r\n                          <!--<i class=\"fa fa-times m-l-sm\" ng-click=\"vm.remove(m.actions, r)\"></i>-->\r\n                        </div>\r\n                      </div>\r\n\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.due</label>\r\n                  <div class=\"col-lg-8\">\r\n                    <div class=\"form-control m-b-sm\">\r\n                      <p ng-repeat=\"r in m.taskDate.children\" ng-if=\"m.readonly\" class=\"workflowentity__link\">\r\n                        {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                      </p>\r\n                      <div ng-if=\"!m.readonly\">\r\n                        <dropdown ng-values=\"vm.data.domainModel.children\" filter=\"\'dateAttribute\'\" ng-model=\"vm.selectedEntity\" ng-change=\"vm.createChildLink(m.taskDate, vm.selectedEntity)\" clear-on-select=\"true\" ng-if=\"!m.taskDate.children.length\"></dropdown>\r\n\r\n                        <div ng-repeat=\"r in m.taskDate.children\" class=\"workflowentity__link\">\r\n                          {{r | wfEntityLink:vm.data.domainModel.children:\'name\'}}\r\n                          <i class=\"fa fa-times\" ng-click=\"vm.remove(m.taskDate, r)\"></i>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"flexeverything\">\r\n                      <input type=\"number\" class=\"form-control\" ng-model=\"m.timeSpan.extendedData.days\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m.timeSpan)\" ng-model-options=\"{updateOn: \'blur\'}\">\r\n                      <span class=\"m-l-xs m-r-xs\" translate>workflow.wfentity.days</span>\r\n                    </div>\r\n                    <div class=\"flexeverything\">\r\n                      <input type=\"number\" class=\"form-control\" ng-model=\"m.timeSpan.extendedData.hours\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m.timeSpan)\" ng-model-options=\"{updateOn: \'blur\'}\">\r\n                      <span class=\"m-l-xs m-r-xs\" translate>workflow.wfentity.hours</span>\r\n                    </div>\r\n                    <div class=\"flexeverything\">\r\n                      <input type=\"number\" class=\"form-control\" ng-model=\"m.timeSpan.extendedData.minutes\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m.timeSpan)\" ng-model-options=\"{updateOn: \'blur\'}\">\r\n                      <span class=\"m-l-xs m-r-xs\" translate>workflow.wfentity.minutes</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.reminders</label>\r\n                  <div class=\"col-lg-8\">\r\n                    <div class=\"form-control\">\r\n\r\n                      <div ng-repeat=\"r in m.taskReminders.children\" ng-if=\"m.readonly\" class=\"flexeverything\">\r\n                        <span class=\"workflowentity__link\"> {{r.extendedData.channel}}</span>\r\n                        <span class=\"workflowentity__link\"> {{r.extendedData.offset}}</span>\r\n                        <span class=\"workflowentity__link\"> {{r.extendedData.offsetScale}}</span>\r\n                      </div>\r\n\r\n                      <div ng-if=\"!m.readonly\">\r\n                        <div class=\"add-panel m-b-sm\" ng-click=\"vm.addChild(m.taskReminders,\'taskReminder\')\">\r\n                          <span translate>workflow.wfentity.addreminder</span>\r\n                          <i class=\"fa fa-plus m-l-md\"></i>\r\n                        </div>\r\n\r\n                        <div ng-repeat=\"r in m.taskReminders.children\">\r\n                          <div class=\"flexeverything\" ng-if=\"!r.readonly\">\r\n                            <dropdown ng-values=\"vm.notificationChannels\" ng-model=\"r.extendedData.channel\" ng-change=\"vm.update(r)\" allow-clear=\"false\"></dropdown>\r\n                            <input type=\"number\" class=\"form-control m-l-sm m-r-sm\" ng-model=\"r.extendedData.offset\" ng-change=\"vm.update(r)\" ng-model-options=\"{updateOn: \'blur\'}\">\r\n                            <dropdown ng-values=\"vm.offsetScale\" ng-model=\"r.extendedData.offsetScale\" ng-change=\"vm.update(r)\" allow-clear=\"false\"></dropdown>\r\n                            <i class=\"fa fa-times m-l-sm\" ng-click=\"vm.remove(m.taskReminders, r)\"></i>\r\n                          </div>\r\n                          <div class=\"flexeverything\" ng-if=\"r.readonly\">\r\n                            <p class=\"form-control\">{{r.extendedData.channel}}</p>\r\n                            <p class=\"form-control\">{{r.extendedData.offset}}</p>\r\n                            <p class=\"form-control\">{{r.extendedData.offsetScale}}</p>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-lg-4 control-label\" translate>workflow.wfentity.taskbehaviour</label>\r\n                  <div class=\"col-lg-8 flexeverything\">\r\n                    <span translate>workflow.wfentity.skipdue</span>\r\n\r\n                    <dropdown class=\"m-l-md\" ng-values=\"m.actions.children\" prop=\"name\" ng-model=\"m.extendedData.skipDueAction\" ng-change=\"vm.update(m)\" ng-if=\"!m.readonly\" translate-attr=\"{placeholder:\'workflow.wfentity.actionplaceholder\'}\"></dropdown>\r\n\r\n                    <input class=\"form-control\" type=\"text\" ng-model=\"m.extendedData.skipDueAction\" ng-if=\"m.readonly\" disabled=\"disabled\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <div class=\"col-lg-offset-4 col-lg-8 flexeverything\">\r\n                    <span translate>workflow.wfentity.skipattributes</span>\r\n\r\n                    <dropdown class=\"m-l-md\" ng-values=\"m.actions.children\" prop=\"name\" ng-model=\"m.extendedData.skipIfAttributesNotNullAction\" ng-change=\"vm.update(m)\" ng-if=\"!m.readonly\" translate-attr=\"{placeholder:\'workflow.wfentity.actionplaceholder\'}\"></dropdown>\r\n\r\n                    <input class=\"form-control\" type=\"text\" ng-model=\"m.extendedData.skipIfAttributesNotNullAction\" ng-if=\"m.readonly\" disabled=\"disabled\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <div class=\"col-lg-offset-4 col-lg-8\">\r\n                    <label>\r\n                      <input icheck type=\"checkbox\" ng-model=\"m.extendedData.ignoredByWorkflow\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m)\">\r\n                      <span class=\"m-l-sm\" translate>workflow.wfentity.ignoredbyworkflow</span> </label>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <div class=\"col-lg-offset-4 col-lg-8\">\r\n                    <label>\r\n                      <input icheck type=\"checkbox\" ng-model=\"m.extendedData.sendInteractiveEmail\" ng-disabled=\"m.readonly\" ng-change=\"vm.update(m)\">\r\n                      <span class=\"m-l-sm\" translate>workflow.wfentity.sendinteractiveemail</span> </label>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </uib-tab>\r\n      </uib-tabset>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/workflow/list.html","<div class=\"workflowslist\" ng-controller=\"WorkflowListController as vm\">\r\n  <div ng-include=\"\'app/components/common/topnavbar.html\'\"></div>\r\n  <div class=\"wrapper wrapper-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"ibox float-e-margins\">\r\n          <div class=\"ibox-title breadcrumb\">\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-6 m-b-xs\">\r\n                  <h4 translate>nav.workflows</h4>\r\n              </div>\r\n              <div class=\"col-sm-6 text-right hidden-xs\" can-do=\"toolsView\">\r\n                <button class=\"btn btn-primary m-l-sm\" ng-click=\"vm.checkWfUpdates()\" ng-if=\"vm.pager.items.length\">\r\n                <i class=\"fa fa-refresh m-r-xs\"></i>\r\n                <span translate>workflows.checkforupdates</span>\r\n              </button>\r\n                <button class=\"btn btn-primary m-l-sm\" ng-click=\"vm.downloadWfDesigner()\" ng-disabled=\"vm.downloadingWorkflowDesigner\">\r\n                  <i class=\"fa fa-download\" ng-if=\"!vm.downloadingWorkflowDesigner\"></i>\r\n                  <sk-spinner-circle ng-if=\"vm.downloadingWorkflowDesigner\"></sk-spinner-circle>\r\n                  <span translate>workflows.downloaddesigner</span>\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"ibox-content\" ng-if=\"vm.pager.busy\"><sk-spinner></sk-spinner></div>\r\n          <div class=\"ibox-content\" ng-if=\"!vm.pager.items.length && !vm.pager.busy\" translate>workflows.noworkflows</div>\r\n          <div class=\"ibox-content\" ng-show=\"(vm.pager.items | filter:{isDeleted:false}).length\">\r\n            <input type=\"text\" class=\"input input-sm form-control m-b-sm\" placeholder=\"{{\'common.searchplaceholder\' | translate}}\" ng-model=\"vm.search\">\r\n            <table class=\"table\">\r\n              <thead>\r\n              <tr>\r\n                <th class=\"col-sm-6\" translate>workflows.name</th>\r\n                <th translate>workflows.status</th>\r\n                <th translate></th>\r\n              </tr>\r\n              </thead>\r\n              <tbody>\r\n              <tr ng-repeat=\"m in vm.pager.items | filter:vm.search\" ng-if=\"!m.isDeleted\">\r\n                <td>{{m.name}}</td>\r\n                <td>\r\n                  <label class=\"label\" ng-class=\"{\'label-warning\':m.status === \'draft\',\'label-success\':m.status === \'published\'}\" translate>\r\n                    {{\'enum.workflowentitystatus.\' + m.status}}\r\n                  </label>\r\n                </td>\r\n                <td>\r\n                  <!-- Desktop actions column -->\r\n                  <div class=\"hidden-xs\">\r\n                    <a class=\"btn btn-default\" ui-sref=\"siskin.workflowset({workflowEntityId: m.id})\" translate>workflows.edit</a>\r\n                    <button class=\"btn btn-default\" ng-click=\"vm.clone(m)\" ng-if=\"!m.isDeleted\" ng-disabled=\"m.cloning\">\r\n                      <sk-spinner-circle class=\"pull-left m-r-xs\" ng-if=\"m.cloning\"></sk-spinner-circle>\r\n                      {{(m.cloning ? \'workflows.cloning\' : \'workflows.clone\') | translate}}\r\n                    </button>\r\n                    <button class=\"btn btn-default\" ng-disabled=\"m.downloading\" ng-click=\"vm.download(m)\">\r\n                      <sk-spinner-circle class=\"pull-left m-r-xs\" ng-if=\"m.downloading\"></sk-spinner-circle>\r\n                      {{(m.downloading ? \'workflows.downloading\' : \'workflows.download\') | translate}}\r\n                    </button>\r\n                    <button class=\"btn btn-danger btn-outline\" ng-click=\"vm.disable(m)\" ng-if=\"!m.isDeleted\" translate>workflows.deactivate</button>\r\n                  </div>\r\n                  <!-- Mobile actions column -->\r\n                  <div class=\"visible-xs dropdown\">\r\n                    <button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" translate>workflow.wfentity.actions</button>\r\n                    <div class=\"dropdown-menu dropdown-menu-right\">\r\n                      <a class=\"btn btn-default\" ui-sref=\"siskin.workflowset({workflowEntityId: m.id})\">\r\n                        <i class=\"fa fa-eye\"></i> <span translate>workflows.edit</span>\r\n                      </a>\r\n                      <button class=\"btn btn-default\" ng-click=\"vm.clone(m)\" ng-if=\"!m.isDeleted\" ng-disabled=\"m.cloning\">\r\n                        <sk-spinner-circle class=\"pull-left m-r-xs\" ng-if=\"m.cloning\"></sk-spinner-circle>\r\n                        <i class=\"fa fa-copy\" ng-if=\"!m.cloning\"></i> {{(m.cloning ? \'workflows.cloning\' : \'workflows.clone\') | translate}}\r\n                      </button>\r\n                      <button class=\"btn btn-default\" ng-click=\"vm.download(m)\">\r\n                        <i class=\"fa fa-download\"></i> <span translate>workflows.download</span>\r\n                      </button>\r\n                      <button class=\"btn btn-danger btn-outline\" ng-click=\"vm.disable(m)\" ng-if=\"!m.isDeleted\">\r\n                        <i class=\"fa fa-ban\"></i> <span translate>workflows.deactivate</span>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </td>\r\n              </tr>\r\n              </tbody>\r\n            </table>\r\n            <sk-spinner ng-show=\"vm.pager.busy\"></sk-spinner>\r\n          </div>\r\n        </div>\r\n        <div class=\"ibox float-e-margins\" ng-class=\"{ collapsed : !vm.showDeleted}\" can-do=\"WorkflowRecover\" ng-show=\"(vm.pager.items | filter:{isDeleted:true}).length\">\r\n          <div class=\"ibox-title breadcrumb\" ng-click=\"vm.showDeleted = !vm.showDeleted\">\r\n            <i class=\"pull-right fa fa-chevron-up\"></i>\r\n            <h4 translate>nav.deletedworkflows</h4>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <input type=\"text\" class=\"input input-sm form-control m-b-sm\" placeholder=\"{{\'common.searchplaceholder\' | translate}}\" ng-model=\"vm.searchdeleted\">\r\n            <table class=\"table\">\r\n              <thead>\r\n              <tr>\r\n                <th class=\"col-sm-6\" translate>workflows.name</th>\r\n                <th translate>workflows.status</th>\r\n                <th translate></th>\r\n              </tr>\r\n              </thead>\r\n              <tbody>\r\n              <tr ng-repeat=\"m in vm.pager.items | filter:vm.searchdeleted\" ng-if=\"m.isDeleted\">\r\n                <td>{{m.name}} <b ng-if=\"m.version\">{{m.version}}</b></td>\r\n                <td>\r\n                  <label class=\"label\" ng-class=\"{\'label-warning\':m.status === \'draft\',\'label-success\':m.status === \'published\'}\" translate>\r\n                    {{\'enum.workflowentitystatus.\' + m.status}}\r\n                  </label>\r\n                </td>\r\n                <td>\r\n                  <!-- Desktop actions column -->\r\n                  <div class=\"hidden-xs\">\r\n                    <a class=\"btn btn-default\" ui-sref=\"siskin.workflowset({workflowEntityId: m.id})\" translate>\r\n                      workflows.edit\r\n                    </a>\r\n                    <button class=\"btn btn-default\" ng-click=\"vm.restore(m)\" ng-if=\"m.isDeleted\" translate>\r\n                      workflows.restore\r\n                    </button>\r\n                    <button class=\"btn btn-default\" ng-click=\"vm.download(m)\" translate>\r\n                      workflows.download\r\n                    </button>\r\n                    <button class=\"btn btn-danger btn-outline\" ng-click=\"vm.delete(m)\" translate>\r\n                      workflows.delete\r\n                    </button>\r\n                  </div>\r\n                  <!-- Mobile actions column -->\r\n                  <div class=\"visible-xs dropdown\">\r\n                    <button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" translate>workflow.wfentity.actions</button>\r\n                    <div class=\"dropdown-menu dropdown-menu-right\">\r\n                      <a class=\"btn btn-default\" ui-sref=\"siskin.workflowset({workflowEntityId: m.id})\">\r\n                        <i class=\"fa fa-eye\"></i> <span translate>workflows.edit</span>\r\n                      </a>\r\n                      <button class=\"btn btn-default\" ng-click=\"vm.restore(m)\" ng-if=\"m.isDeleted\">\r\n                        <i class=\"fa fa-undo\"></i> <span translate>workflows.restore</span>\r\n                      </button>\r\n                      <button class=\"btn btn-default\" ng-click=\"vm.download(m)\">\r\n                        <i class=\"fa fa-download\"></i> <span translate>workflows.download</span>\r\n                      </button>\r\n                      <button class=\"btn btn-danger btn-outline\" ng-click=\"vm.delete(m)\">\r\n                        <i class=\"fa fa-trash-o\"></i> <span translate>workflows.delete</span>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </td>\r\n              </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/modules/siskin/workflow/list.update.html","<div class=\"workflowsupdate\">\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>workflow.update.workflowupdates</h4>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <div ng-if=\"vmModal.updatesInProgress>0\" class=\"m-t-md m-b-xl\">\r\n        <div class=\"col-xs-3 text-right\"><i class=\"fa fa-lg fa-info-circle\"></i></div>\r\n        <div class=\"col-xs-8 m-b-md flexeverything\">\r\n         {{vmModal.updatesInProgress}} {{\'workflows.update.updatesinprogress\'|translate}}<sk-spinner-circle class=\"m-l-xs\"></sk-spinner-circle>\r\n        </div>\r\n    </div>\r\n    <div ng-if=\"vmModal.isLoading() && !vmModal.updatesInProgress\" class=\"m-t-xl\"><sk-spinner></sk-spinner></div>\r\n    <div ng-if=\"!vmModal.isLoading() && !vmModal.data.templates.length\" class=\"alert alert-success flexeverything flexeverything--aligncenter\">\r\n      <i class=\"fa fa-check-circle fa-2x m-r-md\"></i>\r\n      {{\'workflows.update.alluptodate\'|translate}}\r\n    </div>\r\n    <div ng-if=\"!vmModal.isLoading() && vmModal.updatesInProgress===0 && vmModal.data.templates.length\">\r\n      <form class=\"form-horizontal\">\r\n        <div class=\"form-group\">\r\n          <label class=\"col-lg-4 control-label\" translate>workflows.update.project</label>\r\n          <div class=\"col-lg-8\">\r\n            <dropdown ng-if=\"vmModal.data.templates\" ng-model=\"vmModal.projectTemplate\" ng-values=\"vmModal.data.templates\" ng-change=\"vmModal.getNextVersion()\" placeholder=\"{{\'workflows.update.selectproject\'| translate}}\"></dropdown>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\" ng-if=\"vmModal.data.workflows\">\r\n            <label class=\"col-lg-4 control-label\" translate>workflows.update.childworkflow</label>\r\n            <div class=\"col-lg-8\">\r\n              <dropdown ng-if=\"vmModal.data.workflows\" ng-model=\"vmModal.childWorkflow\" ng-values=\"vmModal.data.workflows\" ng-change=\"vmModal.getChildWorkflowNextVersion()\" placeholder=\"{{\'workflows.update.selectworkflow\'| translate}}\"></dropdown>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"form-group\" ng-if=\"vmModal.updateInfo\">\r\n          <label class=\"col-lg-4 control-label\" translate>workflows.update.updateto</label>\r\n          <div class=\"col-lg-8\">\r\n            <div class=\"update-info\" ng-if=\"vmModal.updateInfo\">{{vmModal.updateInfo.toDisplayText}}</div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"alert alert-danger m-b-n flexeverything flexeverything--aligncenter\" ng-if=\"vmModal.error\">\r\n          <i class=\"fa fa-exclamation-circle fa-2x m-r-sm\"></i>\r\n          {{ \'workflow.update.error\' | translate}}</div>\r\n\r\n      </form>\r\n    </div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vmModal.update()\" ng-class=\"{\'has-error\': vmModal.error}\" ng-disabled=\"!vmModal.updateInfo\" ng-if=\"vmModal.updatesInProgress===0  && vmModal.data.templates.length\" translate>common.update</button>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.cancel</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/workflow/preview.modal.html","<div class=\"workflowpreview\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vm.close()\">\r\n            <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>generic.action.close</span>\r\n        </button>\r\n        <h4 class=\"modal-title\" translate>workflowpreview.workflows</h4>\r\n    </div>\r\n\r\n    <div class=\"modal-body\">\r\n        <form class=\"form-horizontal\">\r\n            <div class=\"form-group\">\r\n                <div class=\"col-lg-12\">\r\n                    <div class=\"col-lg-7\">\r\n                        <div class=\"flowchart\">\r\n                            <div class=\"ibox float-e-margins\">\r\n                                <div class=\"ibox-title flexeverything\">\r\n                                    <h3>{{ vm.selected.name }}</h3>\r\n                                    <label class=\"label label-default\">v{{ vm.selected.version }}</label>\r\n                                </div>\r\n                                <div class=\"ibox-content\">\r\n                                    <sk-spinner ng-if=\"!vm.isLoaded\"></sk-spinner>\r\n                                    <div class=\"flowchart-panel\" ng-if=\"vm.isLoaded\">\r\n                                        <div class=\"flowchart-div loading\">\r\n                                            <i class=\"loader element\"></i>\r\n                                            <span class=\"content\">\r\n                                                <span id=\"diagram-container\">\r\n                                                    <sk-spinnner-circle ng-show=\"!vm.selected\"></sk-spinnner-circle>\r\n                                                    <div ng-class=\"{\'workflowpreview__diagram--loaded\':vm.selected}\" id=\"diagram\"></div>\r\n                                                </span>\r\n                                            </span>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-5\">\r\n                        <div class=\"ibox\">\r\n                            <div class=\"ibox-title\">\r\n                                <h3 translate>workflowpreview.childworkflows</h3>\r\n                            </div>\r\n                            <div class=\"ibox-content workflowpreview__workflows\">\r\n                                <div class=\"alert m-b-xs {{vm.selected == vm.data ? \'alert-info\':\'alert-secondary\'}}\" ng-click=\"vm.select(vm.data)\">\r\n                                    <b>{{vm.data.name}}</b> <small>{{vm.data.version}}</small>\r\n                                </div>\r\n                                <div ng-repeat=\"w in vm.data.children\" class=\"alert m-b-xs {{vm.selected == w ? \'alert-info\':\'alert-secondary\'}} workflowpreview__workflows__child\" ng-click=\"vm.select(w)\">\r\n                                    <b>{{w.name}}</b> <small>{{w.version}}</small>\r\n                                </div>\r\n                            </div>\r\n\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n    </form></div>\r\n    <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.close()\" ng-class=\"{\'has-error\': vm.error}\" translate>generic.action.close</button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/attribute/acls/list.modal.html","<div class=\"projecttemplateattributeacls\">\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vm.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>project.acls.modaltitle</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <sk-spinner ng-if=\"!vm.acls\"></sk-spinner>\r\n    <div ng-if=\"vm.acls\" class=\"row\">\r\n      <div class=\"col-lg-4\">\r\n        <div class=\"ibox\">\r\n          <div class=\"ibox-title flexeverything\">\r\n            <span>{{ vm.acls.groups.title | translate}}</span>\r\n            <span class=\"flexeverything--spacer\"></span>\r\n            <span>\r\n              <i class=\"fa fa-arrows-h fa-2x projecttemplateattributeacls__swap\" ng-click=\"vm.swap()\"></i>\r\n              <input class=\"form-control\" ng-model=\"vm.filterleft\" ng-model-options=\"{debounce : 500}\">\r\n            </span>\r\n          </div>\r\n\r\n          <div class=\"ibox-content\">\r\n            <div class=\"bg-muted p-xs b-r-sm m-xs selectable\" ng-repeat=\"m in vm.acls.groups.data | filter: {name:vm.filterleft} | orderBy:\'listOrder\'\" ng-click=\"vm.select(m)\" ng-class=\"{\'bg-primary\':vm.selected == m}\">\r\n              {{m.name | translate}}\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-8\">\r\n        <div class=\"ibox\">\r\n          <div class=\"ibox-title flexeverything\">\r\n            <span>{{ vm.acls.groups.titleright | translate}}</span>\r\n            <span class=\"flexeverything--spacer\"></span>\r\n            <span>\r\n              <input class=\"form-control\" ng-model=\"vm.filterright\" ng-model-options=\"{debounce : 500}\">\r\n            </span>\r\n          </div>\r\n          <div class=\"ibox-content\">\r\n            <div class=\"row m-xs\">\r\n              <span class=\"col-xs-4\"></span>\r\n              <span class=\"col-xs-8\">\r\n                <div class=\"btn-group btn-group\" role=\"group\">\r\n                  <button ng-repeat=\"a in vm.accesslevels\" type=\"button\" class=\"btn\" ng-click=\"vm.updateAll(a)\" translate>{{a.translationKey}}</button>\r\n                </div>\r\n                <span class=\"projecttemplateattributeacls__acls--files m-l-md\">\r\n                    <label>{{\'project.acls.fileapprove\' | translate}}<input icheck class=\"form-control\" type=\"checkbox\" ng-model=\"vm.fileApprove\" class=\"m-t-sm\" ng-change=\"vm.toggle(\'fileApprove\',vm.fileApprove)\"></label>\r\n                    <label>{{\'project.acls.fileonlyapproved\' | translate}}<input icheck class=\"form-control\" type=\"checkbox\" ng-model=\"vm.fileOnlyApproved\" class=\"m-t-sm\" ng-change=\"vm.toggle(\'fileOnlyApproved\',vm.fileOnlyApproved)\"></label>\r\n                  </span>\r\n              </span>\r\n            </div>\r\n\r\n            <div class=\"row m-xs\" ng-repeat=\"m in vm.selected.data | filterByProperty:vm.acls.groups.type + \'Name\':vm.filterright | orderBy:[vm.acls.groups.type+\'ListOrder\']\" ng-class=\"{\'m-b-md\': !m[vm.acls.groups.type + \'Name\']}\">\r\n              <span class=\"bg-muted p-xs b-r-sm col-xs-4\" translate>\r\n                {{ m[vm.acls.groups.type + \'Name\']}}\r\n              </span>\r\n              <span class=\"col-xs-8\">\r\n                <div class=\"btn-group btn-group\" role=\"group\">\r\n                  <button ng-repeat=\"a in vm.accesslevels\" type=\"button\" class=\"btn\" ng-click=\"m.accessLevel = a.value;vm.update(m)\" ng-class=\"{\'btn-success\' : m.accessLevel === a.value, \'btn-default\' : m.accessLevel !== a.value}\" translate>{{a.translationKey}}</button>\r\n\r\n                  <span ng-if=\"m.isFileOrMultiFile\" class=\"projecttemplateattributeacls__acls--files m-l-md\">\r\n                    <label><input icheck class=\"form-control\" type=\"checkbox\" ng-model=\"m.fileApprove\" class=\"m-t-sm\" ng-change=\"vm.update(m)\"></label>\r\n                    <label><input icheck class=\"form-control\" type=\"checkbox\" ng-model=\"m.fileOnlyApproved\" class=\"m-t-sm\" ng-change=\"vm.update(m)\"></label>\r\n                  </span>\r\n                </div>\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.close()\" translate>common.close\r\n    </button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/attribute/batchupdate/list.modal.html","<div class=\"attributesbatchupdate\">\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vm.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>attributes.update.title</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <sk-spinner-circle ng-if=\"!vm.attributes\"></sk-spinner-circle>\r\n\r\n    <div class=\"form-horizontal\">\r\n      <div class=\"form-group\">\r\n        <div class=\"col-md-4\">\r\n          <label translate>attributes.update.projects</label>\r\n        </div>\r\n        <div class=\"col-lg-8\">\r\n          <dropdown-multiple placeholder=\"common.all\" ng-if=\"vm.projects\" ng-model=\"vm.projectselected\" ng-values=\"vm.projects\"></dropdown-multiple>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row m-t-sm\" ng-if=\"vm.attributes\">\r\n      <div class=\"col-lg-12\">\r\n        <div class=\"panel panel-default\" ng-repeat=\"m in vm.attributeGroups.groups | orderBy:\'listOrder\'\">\r\n          <div class=\"panel-heading\" ng-click=\"m.expanded = !m.expanded\">\r\n            <div class=\"flexeverything\">\r\n              <strong>{{m.name | ordefault}}</strong>\r\n              <span class=\"flexeverything--spacer\"></span>\r\n              <i class=\"fa {{m.expanded ? \'fa-chevron-up\' : \'fa-chevron-down\'}}\"></i>\r\n            </div>\r\n          </div>\r\n          <div class=\"panel-body\" ng-show=\"m.expanded\">\r\n            <ul class=\"agile-list p-l-none\">\r\n              <li class=\"m-b-md\" ng-repeat=\"a in m.data | filter: {name: m.search} | orderBy:\'listOrder\'\">\r\n                <div class=\"flexeverything\">\r\n                  <span class=\"fa datavalue-icon datavalue-icon-{{a.type}}\"></span>\r\n                  <strong class=\"m-l-sm\">{{a.name}}</strong>\r\n                  <span class=\"label label-success m-l-md\" ng-if=\"a.success\">\r\n                    <i class=\"fa fa-check m-r-xs\"></i>\r\n                    {{ \'attributes.update.success\' | translate }}\r\n                  </span>\r\n                  <span class=\"flexeverything--spacer\"></span>\r\n                  <button class=\"btn btn-primary btn-xs\" ng-if=\"!a.edit\" ng-click=\"vm.edit(a)\">\r\n                    <i class=\"fa fa-pencil\"></i>\r\n                  </button>\r\n                  <span ng-if=\"a.edit\">\r\n                    <button class=\"btn btn-default btn-xs m-r-xs\" ng-click=\"vm.cancel(a)\" ng-disabled=\"a.saving\">\r\n                      <i class=\"m-l-sm fa fa-times\"></i> {{ \'common.cancel\' | translate }}\r\n                    </button>\r\n                    <button class=\"btn btn-primary btn-xs\" ng-click=\"vm.apply(a)\" ng-disabled=\"a.saving\">\r\n                      <i class=\"m-l-sm fa fa-floppy-o\"></i> {{ \'common.apply\' | translate}}\r\n                    </button>\r\n                  </span>\r\n                </div>\r\n\r\n                <div ng-if=\"a.edit\" class=\"m-t-sm\">\r\n                  <sk-spinner ng-show=\"a.saving\"></sk-spinner>\r\n                  <div class=\"form-group\" ng-show=\"!a.saving\">\r\n                    <div ng-if=\"a.type === \'multiplefile\'\">\r\n                      <div class=\"form-horizontal\">\r\n                        <div class=\"form-group\">\r\n                          <div class=\"col-md-2\">\r\n                            <span translate>attributes.update.overridefiles</span>\r\n                          </div>\r\n                          <div class=\"col-lg-10\">\r\n                            <input icheck type=\"checkbox\" ng-model=\"a.overrideFiles\">\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <field-value read-only=\"false\" field=\"a\"></field-value>\r\n                  </div>\r\n                </div>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.close()\" ng-class=\"{\'has-error\': vm.error}\" translate>common.close</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/attribute/exportimport/list.modal.html","<div class=\"projecttemplateattributes\">\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vm.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\">{{\"projecttemplateattributes.exportimportattributes\" | translate}} - {{vm.data.name}}</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n    <sk-spinner ng-if=\"vm.uploading\"></sk-spinner>\r\n    <sk-spinner-circle ng-if=\"!vm.attributes\"></sk-spinner-circle>\r\n\r\n    <div class=\"row m-t-sm\" ng-if=\"vm.attributes\">\r\n      <div class=\"col-lg-12\" ng-show=\"!vm.uploading\">\r\n        <div class=\"alert alert-success\" ng-if=\"vm.uploadingValidation.isValid\" translate>projecttemplateattributes.success</div>\r\n        <div class=\"alert alert-danger m-t-md\" ng-if=\"vm.uploadingValidation && !vm.uploadingValidation.isValid\">\r\n            <label translate>projecttemplateattributes.error</label>\r\n            <div ng-if=\"vm.uploadingValidation.message\" translate>{{vm.uploadingValidation.message}}</div>\r\n            <div class=\"m-t-xs m-b-md\" ng-repeat=\"r in vm.uploadingValidation.errors\">\r\n              <strong>{{ \'validation.import.rownumber\'  | translate}} {{r.rowOrdinal +1}}</strong><span class=\"m-l-xs\">({{r.projectName}}):</span>\r\n                <div class=\"m-xs m-l-sm\" ng-repeat=\"e in r.errors\"><strong>{{e.columnName}}</strong><i class=\"fa fa-arrow-right m-l-xs m-r-xs\"></i> <span class=\"m-r-xs\" ng-repeat=\"m in e.messages\" translate>{{m}}</span> : {{e.value}}</div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-lg-12 flexeverything m-b-md\">\r\n            <presets ng-if=\"vm.attributes.attributes\" values=\"vm.attributes.attributes\" resource=\"vm.attributes.resource\"></presets>\r\n            <div class=\"flexeverything--spacer\"></div>\r\n            <label><input icheck type=\"checkbox\" ng-model=\"vm.toggleVal\" ng-change=\"vm.toggle()\"> {{\'common.selectall\' | translate}}</label>\r\n          </div>\r\n        </div>\r\n\r\n        <h3 translate>projecttemplateattributes.attributes</h3>\r\n        <input type=\"text\" class=\"input input-sm form-control m-b-sm\" placeholder=\"{{\'common.searchplaceholder\' | translate}}\" ng-model=\"vm.search.attribute\">\r\n\r\n        <ul class=\"agile-list p-l-none projecttemplateattributes__list\">\r\n          <div ng-repeat=\"m in vm.attributeGroups.groups | orderBy:\'listOrder\'\">\r\n          <li ng-class=\"{\'success-element\': m.pvalue}\" ng-click=\"vm.select(m, !m.pvalue)\">\r\n            <strong>{{m.name}}</strong>\r\n            <ul class=\"agile-list p-l-none\">\r\n              <li ng-repeat=\"a in m.data | filter: {name: vm.search.attribute} | orderBy:\'listOrder\'\" ng-class=\"{\'success-element\': a.pvalue}\" ng-click=\"vm.select(a, !a.pvalue)\" stop-event=\"click\">\r\n                {{a.name}}\r\n                <i ng-if=\"a.type === \'files\'\" class=\"pull-right fa {{a.expanded ? \'fa-chevron-up\' : \'fa-chevron-down\'}}\" ng-click=\"a.expanded = !a.expanded\" stop-event=\"click\"></i>\r\n                <div ng-if=\"a.expanded\">\r\n                  <gallery class=\"gallery-sm\" list=\"a.content\" ng-click-item=\"vm.select\" stop-event=\"click\" can-approve=\"a.fileApprove\"></gallery>\r\n                </div>\r\n              </li>\r\n            </ul>\r\n          </li>\r\n          </div>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <file-upload-button ng-model=\"vm.file\" ng-change=\"vm.upload()\" accept=\"application/vnd.ms-excel\" btn-class=\"btn btn-primary\" label=\"common.import\"></file-upload-button>\r\n    <span ng-if=\"vm.attributes\">\r\n      <button type=\"button\" ng-disabled=\"(vm.attributes.attributes | filter:{pvalue:true}).length === 0\" class=\"btn btn-primary\" ng-click=\"vm.download(false)\" translate>common.download\r\n      </button>\r\n      <button type=\"button\" ng-disabled=\"(vm.attributes.attributes | filter:{pvalue:true}).length === 0\" class=\"btn btn-primary\" ng-click=\"vm.download(true)\" translate>common.downloadtemplate\r\n      </button>\r\n    </span>\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.close()\" ng-class=\"{\'has-error\': vm.error}\" translate>common.cancel\r\n    </button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetBarchartProjectinstanceByBrand.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n        <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n          <h4 translate>{{vm.header}}</h4>\r\n        </div>\r\n        <div ng-if=\"!vm.hasData()\" class=\"ibox-content content-center-wrapper dashboard-widget\">\r\n          <div class=\"content-center center-block\" ng-if=\"vm.active\" style=\"max-height: 360px; max-width: 720px;\">\r\n            <strong translate>clientdashboard.nodatatoshow</strong>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"vm.hasData()\" class=\"ibox-content dashboard-widget\">\r\n          <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\">\r\n            <canvas id=\"stacked-bar-projectByBrand-chart\" class=\"chart chart-bar\" chart-data=\"vm.charts.projectByBrand.data\" chart-labels=\"vm.charts.projectByBrand.labels\" chart-options=\"vm.charts.projectByBrand.options\" chart-series=\"vm.charts.projectByBrand.series\" chart-colors=\"vm.charts.projectByBrand.colors\">\r\n        </canvas></div>\r\n      </div>\r\n      </div>");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetBarchartProjectinstanceByCountry.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n    <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n      <h4 translate>{{vm.header}}</h4>\r\n    </div>\r\n    <div ng-if=\"!vm.hasData()\" class=\"ibox-content content-center-wrapper dashboard-widget\">\r\n      <div class=\"content-center center-block\" ng-if=\"vm.active\" style=\"max-height: 360px; max-width: 720px;\">\r\n        <strong translate>clientdashboard.nodatatoshow</strong>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"vm.hasData()\" class=\"ibox-content dashboard-widget\">\r\n      <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\">\r\n          <canvas id=\"stacked-bar-projectByCountry-chart\" class=\"chart chart-bar\" chart-data=\"vm.charts.projectByCountry.data\" chart-labels=\"vm.charts.projectByCountry.labels\" chart-options=\"vm.charts.projectByCountry.options\" chart-series=\"vm.charts.projectByCountry.series\" chart-colors=\"vm.charts.projectByCountry.colors\">\r\n      </canvas></div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetLinechart.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n      <canvas class=\"chart chart-line\" chart-data=\"vm.chart.data\" chart-options=\"vm.chart.options\" chart-labels=\"vm.chart.labels\" chart-colors=\"vm.chart.colors\" chart-series=\"vm.chart.series\"></canvas>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetListProjectinstancemilestones.detail.html","<div>\r\n  <project-instance-list ng-repeat=\"m in vm.jobspager.items\" ng-model=\"m\"></project-instance-list>\r\n</div>\r\n<div ng-if=\"vm.pager.noResults\" class=\"content-center\">\r\n  <strong translate>common.norecords</strong>\r\n</div>\r\n<sk-spinner ng-show=\"vm.jobspager.busy\"></sk-spinner>\r\n<pager ng-model=\"vm.jobspager\"></pager>\r\n\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetListProjectinstancemilestones.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <ng-include src=\"\'app/modules/siskin/clientdashboard/widgets/widgetListProjectinstancemilestones.detail.html\'\"></ng-include>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetListProjecttemplatoverview.directive.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <table class=\"table table-striped\">\r\n      <thead>\r\n      <tr>\r\n        <th class=\"col-lg-1\" translate>projects.projectcode</th>\r\n        <th class=\"col-lg-1 hidden-xs\" ng-if=\"vm.features.projectGroup\" can-do=\"clientView\" negate translate>projects.client</th>\r\n        <th class=\"col-lg-1 hidden-xs\" ng-if=\"vm.features.projectBrand\" can-do=\"clientView\" negate translate>projects.brand</th>\r\n        <th class=\"col-lg-2 hidden-xs\" ng-if=\"vm.features.projectType\" can-do=\"clientView\" translate>projects.projecttype</th>\r\n        <th class=\"col-lg-3\" translate>project.projects</th>\r\n        <th class=\"col-lg-1\" translate>projects.totalprojectinstances</th>\r\n        <th class=\"col-lg-3\" translate>project.progressoverview</th>\r\n      </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr ng-repeat=\"p in vm.projects\">\r\n          <td>{{p.projectTemplateCode}}</td>\r\n          <td class=\"hidden-xs\" can-do=\"clientView\" ng-if=\"vm.features.projectGroup\" negate>{{p.group}}</td>\r\n          <td class=\"hidden-xs\" can-do=\"clientView\" ng-if=\"vm.features.projectBrand\" negate>{{p.brand}}</td>\r\n          <td class=\"hidden-xs\" can-do=\"clientView\" ng-if=\"vm.features.projectType\">{{p.projectType}}</td>\r\n          <td><a ui-sref=\"siskin.project({projectId:p.id})\" href=\"{{p.href}}\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\">{{p.name}}</a></td>\r\n          <td>{{p.inProgress + p.completed}}</td>\r\n          <td class=\"col-lg-5\">\r\n            <div class=\"progress m-b-n\">\r\n              <div style=\"width:{{p.percentageInProgress}}%\" uib-tooltip-html=\"\'{{\'project.active\' | translate}} : {{p.inProgress}}\'\" tooltip-trigger=\"mouseenter\" class=\"progress-bar progress-bar-success\">\r\n                <span>{{p.inProgress}}</span>\r\n              </div>\r\n              <div style=\"width:{{p.percentageCompleted}}%\" uib-tooltip-html=\"\'{{\'project.complete\' | translate}} : {{p.completed}}\'\" tooltip-trigger=\"mouseenter\" class=\"progress-bar progress-bar-primary\">\r\n                <span>\r\n                {{p.completed}}</span>\r\n              </div>\r\n            </div>\r\n          </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n    <div class=\"form-group\">\r\n        <div class=\"pull-right m-r-sm\">\r\n            <a class=\"btn btn-default\" ui-sref=\"siskin.projects\">\r\n              {{\'projects.viewmore\' | translate}}\r\n            </a>\r\n        </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetMap.directive.html","<div class=\"ibox float-e-margins widget-map\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\" id=\"outerMapWidgetDiv\">\r\n    <maps min-height=\"324px\" data=\"vm.maps\"></maps>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetPiechartProjectinstanceByClient.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n    <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n      <h4 translate>{{vm.header}}</h4>\r\n    </div>\r\n    <div ng-if=\"!vm.hasData()\" class=\"ibox-content content-center-wrapper dashboard-widget\">\r\n      <div class=\"content-center center-block\" ng-if=\"vm.active\" style=\"max-height: 360px; max-width: 720px;\">\r\n        <strong translate>clientdashboard.nodatatoshow</strong>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"vm.hasData()\" class=\"ibox-content dashboard-widget\">\r\n      <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\">\r\n        <canvas class=\"chart chart-doughnut\" chart-data=\"vm.charts.projectByClient.data\" chart-labels=\"vm.charts.projectByClient.labels\" chart-options=\"vm.charts.projectByClient.options\" chart-colors=\"vm.charts.projectByClient.colors\"></canvas>\r\n      </div>\r\n    </div>\r\n  </div>");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetPiechartProjectinstanceByProjectType.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n        <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n          <h4 translate>{{vm.header}}</h4>\r\n        </div>\r\n        <div ng-if=\"!vm.hasData()\" class=\"ibox-content content-center-wrapper dashboard-widget\">\r\n          <div class=\"content-center center-block\" ng-if=\"vm.active\" style=\"max-height: 360px; max-width: 720px;\">\r\n            <strong translate>clientdashboard.nodatatoshow</strong>\r\n          </div>\r\n        </div>\r\n        <div ng-if=\"vm.hasData()\" class=\"ibox-content dashboard-widget\">\r\n          <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\">\r\n            <canvas class=\"chart chart-pie\" chart-data=\"vm.charts.projectByProjectType.data\" chart-labels=\"vm.charts.projectByProjectType.labels\" chart-options=\"vm.charts.projectByProjectType.options\" chart-colors=\"vm.charts.projectByProjectType.colors\"></canvas>\r\n          </div>\r\n        </div>\r\n      </div>");
$templateCache.put("app/modules/siskin/clientdashboard/widgets/widgetPiechartProjectinstanceOverview.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div ng-if=\"!vm.hasOverviewData()\" class=\"ibox-content content-center-wrapper dashboard-widget\">\r\n    <div class=\"content-center center-block\" ng-if=\"vm.active\" style=\"max-height: 360px; max-width: 720px;\">\r\n      <strong translate>clientdashboard.nodatatoshow</strong>\r\n    </div>\r\n  </div>\r\n  <div ng-if=\"vm.hasOverviewData()\" class=\"ibox-content dashboard-widget\">\r\n    <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\">\r\n      <canvas class=\"chart chart-doughnut\" chart-data=\"vm.charts.overview.data\" chart-labels=\"vm.charts.overview.labels\" chart-options=\"vm.charts.overview.options\" chart-colors=\"vm.charts.overview.colors\"></canvas>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets-v2/widgetV2BarchartProjectinstanceByCountry.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n    <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n      <sk-spinner-circle class=\"pull-right\" ng-if=\"!vm.data\"></sk-spinner-circle>\r\n      <h4 translate>{{vm.header}}</h4>\r\n    </div>\r\n    <div ng-if=\"!vm.hasData()\" class=\"ibox-content content-center-wrapper dashboard-widget\">\r\n      <div class=\"content-center center-block\" ng-if=\"vm.data\" style=\"max-height: 360px; max-width: 720px;\">\r\n        <strong translate>clientdashboard.nodatatoshow</strong>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"vm.hasData()\" class=\"ibox-content dashboard-widget\">\r\n      <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\">\r\n          <canvas id=\"stacked-bar-projectByCountry-chart\" class=\"chart chart-bar\" chart-data=\"vm.charts.projectByCountry.data\" chart-labels=\"vm.charts.projectByCountry.labels\" chart-options=\"vm.charts.projectByCountry.options\" chart-series=\"vm.charts.projectByCountry.series\" chart-colors=\"vm.charts.projectByCountry.colors\">\r\n      </canvas></div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/modules/siskin/clientdashboard/widgets-v2/widgetV2Linechart.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n      <sk-spinner-circle class=\"pull-right\" ng-if=\"!vm.data\"></sk-spinner-circle>\r\n      <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n      <canvas class=\"chart chart-line\" chart-data=\"vm.chart.data\" chart-options=\"vm.chart.options\" chart-labels=\"vm.chart.labels\" chart-colors=\"vm.chart.colors\" chart-series=\"vm.chart.series\"></canvas>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets-v2/widgetV2ListProjectinstancemilestones.directive.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <project-instance-list ng-if=\"vm.projectTemplate\" ng-model=\"vm.projectTemplate\"></project-instance-list>\r\n    <div ng-if=\"vm.jobspager\">\r\n      <div>\r\n        <project-instance-list ng-repeat=\"m in vm.jobspager.items\" ng-model=\"m\"></project-instance-list>\r\n      </div>\r\n      <div ng-if=\"vm.pager.noResults\" class=\"content-center\">\r\n        <strong translate>common.norecords</strong>\r\n      </div>\r\n      <sk-spinner ng-show=\"vm.jobspager.busy\"></sk-spinner>\r\n      <pager ng-model=\"vm.jobspager\"></pager>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets-v2/widgetV2ListProjecttemplatoverview.directive.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n      <sk-spinner-circle class=\"pull-right\" ng-if=\"!vm.data\"></sk-spinner-circle>\r\n      <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <table class=\"table table-striped\">\r\n      <thead>\r\n      <tr>\r\n        <th class=\"col-lg-1\" translate>projects.projectcode</th>\r\n        <th class=\"col-lg-3\" translate>project.projects</th>\r\n        <th class=\"col-lg-1\" translate>projects.totalprojectinstances</th>\r\n        <th class=\"col-lg-3\" translate>project.progressoverview</th>\r\n      </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr ng-repeat=\"p in vm.data\">\r\n          <td>{{p.code}}</td>\r\n          <td><a ui-sref=\"siskin.project({projectId:p.id})\" href=\"{{p.href}}\" can-do=\"projectTemplateView\" cannot-do-class=\"disabled\" cannot-do-remove-attr=\"href,ui-sref\">{{p.name}}</a></td>\r\n          <td>{{p.inProgressCount + p.completedCount}}</td>\r\n          <td class=\"col-lg-5\">\r\n            <div class=\"progress m-b-n\">\r\n              <div style=\"width:{{p.percentageInProgress}}%\" uib-tooltip-html=\"\'{{\'project.active\' | translate}} : {{p.inProgressCount}}\'\" tooltip-trigger=\"mouseenter\" class=\"progress-bar progress-bar-success\">\r\n                <span>{{p.inProgressCount}}</span>\r\n              </div>\r\n              <div style=\"width:{{p.percentageCompleted}}%\" uib-tooltip-html=\"\'{{\'project.complete\' | translate}} : {{p.completedCount}}\'\" tooltip-trigger=\"mouseenter\" class=\"progress-bar progress-bar-primary\">\r\n                <span>\r\n                {{p.completedCount}}\r\n              </span>\r\n              </div>\r\n            </div>\r\n          </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n    <div class=\"form-group text-right\">\r\n          <a class=\"btn btn-default\" ui-sref=\"siskin.projects\">\r\n            {{\'projects.viewmore\' | translate}}\r\n          </a>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets-v2/widgetV2Map.directive.html","<div class=\"ibox float-e-margins widget-map\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n      <sk-spinner-circle class=\"pull-right\" ng-if=\"!vm.data\"></sk-spinner-circle>\r\n      <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\" id=\"outerMapWidgetDiv\" ng-if=\"vm.maps\">\r\n    <maps min-height=\"324px\" data=\"vm.maps\"></maps>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets-v2/widgetV2PiechartProjectinstanceOverview.directive.html","<div class=\"ibox float-e-margins widget-chart\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n      <sk-spinner-circle class=\"pull-right\" ng-if=\"!vm.data\"></sk-spinner-circle>\r\n      <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div ng-if=\"!vm.hasOverviewData()\" class=\"ibox-content content-center-wrapper dashboard-widget\">\r\n    <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\">\r\n      <strong translate>clientdashboard.nodatatoshow</strong>\r\n    </div>\r\n  </div>\r\n  <div ng-if=\"vm.hasOverviewData()\" class=\"ibox-content dashboard-widget\">\r\n    <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\">\r\n      <canvas class=\"chart chart-doughnut\" chart-data=\"vm.charts.overview.data\" chart-labels=\"vm.charts.overview.labels\" chart-options=\"vm.charts.overview.options\" chart-colors=\"vm.charts.overview.colors\"></canvas>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/clientdashboard/widgets-v2/widgetV2ProjectInstances.directive.html","<div class=\"ibox\">\r\n    <div class=\"ibox-title\">\r\n        <span class=\"pull-right flexeverything\">\r\n            <dropdown ng-values=\"vm.projectStatuses\" prop=\"key\" ng-model=\"vm.filters.projectStatus\" allow-clear=\"false\" class=\"m-r-sm\" ng-change=\"vm.search(true)\"></dropdown>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ \'common.searchplaceholder\' |translate}}\" ng-model=\"vm.filters.query\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.search(true)\">\r\n        </span>\r\n        <sk-spinner-circle class=\"pull-right\" ng-if=\"vm.isBusy\"></sk-spinner-circle>\r\n        <h4>{{vm.header | translate}} {{vm.pager.totalItemsCount ? \'(\'+vm.pager.totalItemsCount+\')\': \'\'}}</h4>\r\n    </div>\r\n    <div class=\"ibox-content\">\r\n        <div ng-if=\"vm.pager\">\r\n            <table class=\"table\">\r\n                <thead>\r\n                <tr>\r\n                  <th></th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                <tr ng-if=\"!vm.pager.data.length\">\r\n                  <td colspan=\"2\" class=\"text-center\" translate>common.norecords</td>\r\n                </tr>\r\n                <tr ng-repeat=\"m in vm.pager.data\">\r\n                  <td>\r\n                    <a can-do=\"projectInstanceView\" cannot-do-class=\"disabled\" ui-sref=\"siskin.projectinstancedetail({projectInstanceId:m.id})\" cannot-do-remove-attr=\"href,ui-sref\">\r\n                      {{m.name}}\r\n                    </a>\r\n                    <span class=\"label label-default m-l-sm\" ng-if=\"!m.isActive\"><i class=\"fa fa-pause m-r-sm\"></i>\r\n                      {{\'projectinstances.deactivated\'|translate}}\r\n                    </span>\r\n\r\n                    <span class=\"label label-default m-l-sm\" ng-if=\"!m.startedOn\">\r\n                        Not started\r\n\r\n                        <span class=\"label label-default m-l-sm\" ng-if=\"m.startingOn\">\r\n                            {{\'projectinstances.startingon\'|translate}} : {{ m.startingOn | date}}\r\n                        </span>\r\n                    </span>\r\n\r\n\r\n\r\n                    <span class=\"label label-success m-l-sm\" ng-if=\"m.isCompleted\">{{\'enum.status.completed\'|translate}}</span>\r\n                  </td>\r\n                </tr>\r\n                </tbody>\r\n              </table>\r\n              <sk-spinner ng-show=\"vm.isBusy\"></sk-spinner>\r\n              <pager ng-if=\"!vm.isBusy\" ng-model=\"vm.pager\"></pager>\r\n        </div>\r\n    </div>\r\n  </div>\r\n  ");
$templateCache.put("app/modules/siskin/monitoring/widgets/widget-konnekt-requests.directive.html","\r\n<div class=\"row m-t-lg\">\r\n  <div class=\"col-lg-12\">\r\n    <dropdown ng-values=\"vm.dateRangeOptions\" ng-model=\"vm.dateRangeSelected\" ng-change=\"vm.search()\" class=\"pull-right m-b-sm\" allow-clear=\"false\"></dropdown>\r\n\r\n    <h2 class=\"inline-block\" translate>monitoring.fullfilmentserviceintegrations</h2>\r\n    <sk-spinner-circle class=\"inline-block\" ng-if=\"vm.loading\"></sk-spinner-circle>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-lg-12\">\r\n    <div class=\"ibox float-e-margins widget-chart\">\r\n      <div class=\"ibox-content dashboard-widget\">\r\n        <div ng-if=\"!vm.data.length && !vm.loading\" class=\"content-center center-block\" style=\"height: 360px;\">\r\n          <strong translate>clientdashboard.nodatatoshow</strong>\r\n        </div>\r\n        <div class=\"content-center center-block\" style=\"max-height: 360px; max-width: 720px;\" ng-if=\"vm.chart && vm.data.length\">\r\n          <canvas class=\"chart chart-bar\" chart-data=\"vm.chart.data\" chart-labels=\"vm.chart.labels\" chart-options=\"vm.chart.options\" chart-series=\"vm.chart.series\" chart-colors=\"vm.chart.colors\">\r\n        </canvas></div>\r\n        \r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/monitoring/widgets/widget-projectinstances-processtime.directive.html","<div class=\"row m-t-lg\">\r\n  <div class=\"col-lg-12\">\r\n    <dropdown ng-values=\"vm.metrics\" ng-model=\"vm.metricSelected\" ng-change=\"vm.refresh()\" class=\"pull-right m-b-xs m-l-sm\" allow-clear=\"false\"></dropdown>\r\n    <dropdown ng-values=\"vm.dateRangeOptions\" ng-model=\"vm.dateRangeSelected\" ng-change=\"vm.search()\" class=\"pull-right m-b-xs\" allow-clear=\"false\"></dropdown>\r\n\r\n    <h2 class=\"inline-block\" translate>monitoring.workflowprocesstime</h2>\r\n    <sk-spinner-circle class=\"inline-block\" ng-if=\"vm.loading\"></sk-spinner-circle>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-lg-12\">\r\n    <div class=\"ibox float-e-margins widget-chart\">\r\n      <div class=\"ibox-content dashboard-widget\">\r\n        <div ng-if=\"!vm.data.length && !vm.loading\" class=\"content-center center-block\" style=\"height: 360px; max-width: 720px;\">\r\n          <strong translate>clientdashboard.nodatatoshow</strong>\r\n        </div>\r\n        <canvas ng-if=\"vm.chart && vm.data.length\" class=\"chart chart-line\" chart-data=\"vm.chart.data\" chart-options=\"vm.chart.options\" chart-labels=\"vm.chart.labels\" chart-colors=\"vm.chart.colors\" chart-series=\"vm.chart.series\"></canvas>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/monitoring/widgets/widget-projectinstances-status.directive.html","<div class=\"row\">\r\n  <div class=\"col-lg-12\">\r\n    <h2 translate class=\"inline-block\">monitoring.projectinstances</h2>\r\n    <sk-spinner-circle class=\"inline-block\" ng-if=\"!vm.data\"></sk-spinner-circle>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-lg-4\">\r\n    <div class=\"ibox\">\r\n      <div class=\"ibox-content text-center\">\r\n        <h2>{{vm.data ? vm.data.waitingToStart :  \'--\' }}</h2>\r\n        <h3 translate>monitoring.projectinstances.waitingtostart</h3>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-lg-4\">\r\n    <div class=\"ibox\">\r\n      <div class=\"ibox-content text-center\">\r\n        <h2>{{vm.data ? vm.data.inProgressCount :  \'--\' }}</h2>\r\n        <h3 translate>monitoring.projectinstances.inprogress</h3>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n  <div class=\"col-lg-4\">\r\n    <div class=\"ibox\">\r\n      <div class=\"ibox-content text-center\">\r\n        <h2>{{vm.data ? vm.data.completedCount :  \'--\' }}</h2>\r\n        <h3 translate>monitoring.projectinstances.completed</h3>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/project/emailsettings/list.html","<div>\r\n  <div class=\"modal-header\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"vmModal.close()\">\r\n      <span aria-hidden=\"true\"><i class=\"fa fa-times\"></i></span><span class=\"sr-only\" translate>common.close</span>\r\n    </button>\r\n    <h4 class=\"modal-title\" translate>project.emailsettings</h4>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n\r\n      <table can-do=\"projectTemplateGeneralEmailSettingsView\">\r\n        <thead>\r\n          <tr>\r\n            <th class=\"col-xs-5\" translate>emailsettings.templates</th>\r\n            <th class=\"col-xs-3\" translate>emailsettings.enabled</th>\r\n            <th class=\"col-xs-4 p-xxs\" translate>emailsettings.requirement</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr ng-repeat=\"setting in vmModal.settings | orderBy: \'general.emailTemplateType\'\">\r\n            <td class=\"col-xs-5\" translate>{{\'enum.emailtemplatetype.\'+setting.general.emailTemplateType | lowercase}}</td>\r\n            <td class=\"col-xs-3\"><onoff-switch ng-model=\"setting.user.enabled\" switch-id=\"{{setting.general.emailTemplateType}}\" ng-callback=\"vmModal.updateUserSetting(setting)\" ng-disabled=\"{{setting.general.requirement !== \'Optional\' ? \'disabled\' : \'\'}}\"></onoff-switch></td>\r\n            <td class=\"col-xs-4 p-xxs\"><dropdown ng-model=\"setting.general.requirement\" ng-values=\"vmModal.emailDigestRequirementValues\" allow-clear=\"false\" ng-change=\"vmModal.updateGeneralSetting(setting)\"></dropdown>\r\n          </td></tr>\r\n        </tbody>\r\n      </table>\r\n\r\n      <table can-do=\"projectTemplateGeneralEmailSettingsView\" negate>\r\n        <thead>\r\n        <tr>\r\n          <th class=\"col-xs-5\" translate>emailsettings.templates</th>\r\n          <th class=\"col-xs-3 p-xxs\" translate>emailsettings.enabled</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr ng-repeat=\"setting in vmModal.settings | orderBy: \'general.emailTemplateType\'\" ng-if=\"setting.general.requirement===\'Optional\'\">\r\n          <td class=\"col-xs-5\" translate>{{\'enum.emailtemplatetype.\'+setting.general.emailTemplateType | lowercase}}</td>\r\n          <td class=\"col-xs-3 p-xxs\"><onoff-switch ng-model=\"setting.user.enabled\" switch-id=\"{{setting.general.emailTemplateType}}\" ng-callback=\"vmModal.updateUserSetting(setting)\" ng-disabled=\"{{setting.general.requirement !== \'Optional\' ? \'disabled\' : \'\'}}\"></onoff-switch></td>\r\n        </tr>\r\n        </tbody>\r\n        <tbody>\r\n        <tr ng-if=\"vmModal.hasDisabledSettings\"><th class=\"col-xs-12\" colspan=\"2\"><div class=\"m-b-xs m-t-md\" translate>emailsettings.templates.setbyadmin</div></th></tr>\r\n        <tr ng-repeat=\"setting in vmModal.settings | orderBy: \'general.emailTemplateType\'\" ng-if=\"setting.general.requirement!==\'Optional\'\">\r\n          <td class=\"col-xs-5\" translate>{{\'enum.emailtemplatetype.\'+setting.general.emailTemplateType | lowercase}}</td>\r\n          <td class=\"col-xs-3 p-xxs\"><onoff-switch ng-model=\"setting.user.enabled\" switch-id=\"{{setting.general.emailTemplateType}}\" ng-callback=\"vmModal.updateUserSetting(setting)\" ng-disabled=\"{{setting.general.requirement !== \'Optional\' ? \'disabled\' : \'\'}}\"></onoff-switch></td>\r\n        </tr>\r\n        </tbody>\r\n      </table>\r\n\r\n    </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vmModal.close()\" ng-class=\"{\'has-error\': vmModal.error}\" translate>common.close</button>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/widgets/widgetListMilestonehit.directive.html","<div class=\"ibox float-e-margins widget-list-milestonehit\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12\" ng-if=\"!vm.data.summary.milestoneSummary.length\" translate>milestones.norecord</div>\r\n      <div class=\"col-lg-12 float-e-margins\" ng-if=\"vm.data.summary.milestoneSummary.length\">\r\n        <table class=\"table table-striped\">\r\n          <thead>\r\n          <tr>\r\n            <th class=\"col-lg-4\" translate>projectdashboard.widget.milestonename</th>\r\n            <th class=\"text-center\" translate>projectdashboard.widget.milestonehittitle</th>\r\n          </tr>\r\n          </thead>\r\n          <tbody>\r\n          <tr ng-repeat=\"milestone in vm.data.summary.milestoneSummary\">\r\n            <td>{{milestone.name}}</td>\r\n            <td>\r\n              <div class=\"progress m-b-n\">\r\n                <div uib-tooltip-html=\"\'{{milestone.completed}}\'\" tooltip-trigger=\"mouseenter\" class=\"progress-bar progress-bar-success\" role=\"progressbar\" style=\"width:{{milestone.completedPercentage}}%;\">\r\n                  <span ng-if=\"milestone.completedPercentage > 10\">{{milestone.completed}}</span>\r\n                </div>\r\n                <div uib-tooltip-html=\"\'{{milestone.incomplete}}\'\" tooltip-trigger=\"mouseenter\" class=\"progress-bar bg-info\" role=\"progressbar\" style=\"width:{{milestone.incompletePercentage}}%;\">\r\n                  <span ng-if=\"milestone.incompletePercentage > 10\">{{milestone.incomplete}}</span>\r\n                </div>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          </tbody>\r\n        </table>\r\n        <div class=\"widget-list-milestonehit__legend text-center\">\r\n          <span class=\"widget-list-milestonehit__legend--hit\" translate>projectdashboard.widget.milestonehit</span>\r\n          <span class=\"widget-list-milestonehit__legend--nothit\" translate>projectdashboard.widget.milestonenothit</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/widgets/widgetListProjectmilestones.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title flexeverything\" ng-if=\"vm.header\">\r\n    <h4 class=\"flexeverything--spacer\" translate>{{vm.header}}</h4>\r\n    <label can-do=\"projectInstanceEdit\"><input icheck type=\"checkbox\" ng-model=\"vm.filter.showInactive\" ng-change=\"vm.data.pager.reset()\">\r\n      {{\'widget.projectlistmilestones.showdeactivated\'|translate}}\r\n    </label>\r\n  </div>\r\n  <div class=\"ibox-content\" ng-if=\"vm.data\">\r\n    <project-instance-list ng-model=\"vm.data\" filter=\"vm.filter\"></project-instance-list>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/widgets/widgetListTaskoverview.directive.html","<div class=\"row\">\r\n  <div class=\"col-lg-12\">\r\n    <div class=\"ibox float-e-margins\">\r\n      <div class=\"ibox-title\">\r\n        <h4 translate>{{vm.header}}</h4>\r\n        <sk-spinner-circle class=\"pull-right\" ng-if=\"!vm.data\"></sk-spinner-circle>\r\n      </div>\r\n      <div class=\"ibox-content\">\r\n        <table class=\"table jobdetail__tasks\">\r\n          <thead>\r\n          <tr>\r\n            <th></th>\r\n            <th class=\"col-xs-1 text-center visible-sm-up\" translate>project.active</th>\r\n            <th class=\"col-xs-1 text-center visible-sm-up\" translate>project.complete</th>\r\n            <th class=\"col-xs-1 text-center\" translate>project.totalinstances</th>\r\n            <th class=\"col-xs-3\" class=\"jobdetail__tasks__progress\" translate>project.progressoverview</th>\r\n          </tr>\r\n          </thead>\r\n          <tbody>\r\n          <tr ng-repeat=\"t in vm.data\" ng-if=\"vm.data\">\r\n            <td>{{t.name}}</td>\r\n            <td class=\"visible-sm-up text-center\">{{t.inProgress}}</td>\r\n            <td class=\"visible-sm-up text-center\">{{t.completed}}</td>\r\n            <td class=\"text-center\">{{t.inProgress + t.overdue + t.completed}}</td>\r\n            <td>\r\n              <div class=\"progress m-b-n\">\r\n                <div style=\"width:{{t.percents.inProgress}}%\" class=\"progress-bar progress-bar-success\" title=\"{{\'project.active\' | translate}}\">\r\n                  <span>{{t.inProgress}}</span>\r\n                </div>\r\n                <div style=\"width:{{t.percents.overdue}}%\" class=\"progress-bar progress-bar-warning\" title=\"{{\'task.state.overdue\' | translate}}\">\r\n                  <span>{{t.overdue}}</span>\r\n                </div>\r\n                <div style=\"width:{{t.percents.completed}}%\" class=\"progress-bar progress-bar-primary\" title=\"{{\'project.complete\' | translate}}\">\r\n                  <span>{{t.completed}}</span>\r\n                </div>\r\n              </div>\r\n            </td>\r\n          </tr>\r\n          </tbody>\r\n        </table>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/widgets/widgetMap.directive.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <maps ng-if=\"vm.maps\" min-height=\"324px\" data=\"vm.maps\"></maps>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/widgets/widgetMatrixProjectinstancemilestones.detail.html","<div class=\"col-lg-12 float-e-margins\">\r\n  <sk-spinner ng-if=\"vm.projectInstancesLoading\"></sk-spinner>\r\n  <table class=\"table\" ng-if=\"!vm.projectInstancesLoading\">\r\n    <thead>\r\n    <tr>\r\n      <th class=\"col-lg-3\" translate>projectinstance.detail.startdate</th>\r\n      <th ng-repeat=\"milestone in vm.data.summary.milestoneSummary\" class=\"text-center\">\r\n        {{milestone.name}}\r\n      </th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    <tr ng-repeat=\"projectInstance in vm.projectInstances\">\r\n      <td>\r\n        <a ui-sref=\"siskin.projectinstancedetail({projectInstanceId: projectInstance.id})\">{{projectInstance.name}}</a>\r\n      </td>\r\n      <td ng-repeat=\"milestone in vm.data.summary.milestoneSummary\">\r\n        <div class=\"progress m-b-n workflowstatus\">\r\n          <div ng-class=\"vm.isMilestoneCompleted(projectInstance.completedMilestones, milestone.name) ? \'progress-bar-full\' : \'progress-bar-empty\'\" class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div>\r\n        </div>\r\n      </td>\r\n    </tr>\r\n    </tbody>\r\n  </table>\r\n  <div class=\"row\" style=\"display: flex; justify-content: flex-end;\">\r\n    <ul uib-pagination total-items=\"vm.projectPager.totalItemsCount\" ng-model=\"vm.projectPager.pageNumber\" max-size=\"vm.projectPager.pageSize\" class=\"pagination-sm\" boundary-links=\"true\" boundary-link-numbers=\"true\" rotate=\"false\" ng-change=\"vm.changePage()\"></ul>\r\n  </div>\r\n\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/project/widgets/widgetMatrixProjectinstancemilestones.directive.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <div class=\"row\">\r\n      <ng-include src=\"\'app/modules/siskin/project/widgets/widgetMatrixProjectinstancemilestones.detail.html\'\"></ng-include>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/modules/siskin/project/widgets/widgetPiechartProjectmilestones.directive.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <sk-spinner-circle class=\"pull-right\" ng-if=\"!vm.data\"></sk-spinner-circle>\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div ng-if=\"vm.data && !vm.data.length\" class=\"ibox-content content-center-wrapper dashboard-widget\">\r\n    <div class=\"content-center\">\r\n      <strong translate>clientdashboard.nodatatoshow</strong>\r\n    </div>\r\n  </div>\r\n  <div ng-if=\"vm.data && vm.data.length\" class=\"ibox-content dashboard-widget\">\r\n    <div class=\"content-center\">\r\n      <canvas class=\"chart chart-doughnut\" chart-data=\"vm.milestoneOverviewChart.data\" chart-labels=\"vm.milestoneOverviewChart.labels\" chart-options=\"vm.milestoneOverviewChart.options\" chart-colors=\"vm.milestoneOverviewChart.colors\"></canvas>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/modules/siskin/project/widgets/widgetPiechartProjectoverview.directive.html","<div class=\"ibox float-e-margins\">\r\n  <div class=\"ibox-title\" ng-if=\"vm.header\">\r\n    <h4 translate>{{vm.header}}</h4>\r\n  </div>\r\n  <div class=\"ibox-content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-lg-4 scorecard\">\r\n        <div class=\"scorecard__value\">\r\n          {{vm.project.totalProjectInstances}}\r\n        </div>\r\n        <div translate>\r\n          projectinstance.detail.totalcount\r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-4 col-xs-6 scorecard\">\r\n        <div class=\"scorecard__value\">\r\n          {{vm.project.pendingProjectInstances}}\r\n        </div>\r\n        <div translate>\r\n          enum.projectstatus.inprogress\r\n        </div>\r\n      </div>\r\n      <div class=\"col-lg-4 col-xs-6 scorecard\">\r\n        <div class=\"scorecard__value\">\r\n          {{vm.project.completedProjectInstances}}\r\n        </div>\r\n        <div translate>\r\n          enum.status.completed\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row dashboard-widget m-t-md\">\r\n      <canvas class=\"chart chart-doughnut\" chart-data=\"vm.projectPieChart.data\" chart-labels=\"vm.projectPieChart.labels\" chart-options=\"vm.projectPieChart.options\" chart-colors=\"vm.projectPieChart.colors\"></canvas>\r\n    </div>\r\n  </div>\r\n</div>\r\n");}]);